
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire8661"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire8661"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("1SXIy", function(module, exports) {
/* eslint-env browser */ /**
 * This is the web browser implementation of `debug()`.
 */ exports.formatArgs = formatArgs;
exports.save = save;
exports.load = load;
exports.useColors = useColors;
exports.storage = localstorage();
exports.destroy = (()=>{
    let warned = false;
    return ()=>{
        if (!warned) {
            warned = true;
            console.warn('Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`.');
        }
    };
})();
/**
 * Colors.
 */ exports.colors = [
    '#0000CC',
    '#0000FF',
    '#0033CC',
    '#0033FF',
    '#0066CC',
    '#0066FF',
    '#0099CC',
    '#0099FF',
    '#00CC00',
    '#00CC33',
    '#00CC66',
    '#00CC99',
    '#00CCCC',
    '#00CCFF',
    '#3300CC',
    '#3300FF',
    '#3333CC',
    '#3333FF',
    '#3366CC',
    '#3366FF',
    '#3399CC',
    '#3399FF',
    '#33CC00',
    '#33CC33',
    '#33CC66',
    '#33CC99',
    '#33CCCC',
    '#33CCFF',
    '#6600CC',
    '#6600FF',
    '#6633CC',
    '#6633FF',
    '#66CC00',
    '#66CC33',
    '#9900CC',
    '#9900FF',
    '#9933CC',
    '#9933FF',
    '#99CC00',
    '#99CC33',
    '#CC0000',
    '#CC0033',
    '#CC0066',
    '#CC0099',
    '#CC00CC',
    '#CC00FF',
    '#CC3300',
    '#CC3333',
    '#CC3366',
    '#CC3399',
    '#CC33CC',
    '#CC33FF',
    '#CC6600',
    '#CC6633',
    '#CC9900',
    '#CC9933',
    '#CCCC00',
    '#CCCC33',
    '#FF0000',
    '#FF0033',
    '#FF0066',
    '#FF0099',
    '#FF00CC',
    '#FF00FF',
    '#FF3300',
    '#FF3333',
    '#FF3366',
    '#FF3399',
    '#FF33CC',
    '#FF33FF',
    '#FF6600',
    '#FF6633',
    '#FF9900',
    '#FF9933',
    '#FFCC00',
    '#FFCC33'
];
/**
 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
 * and the Firebug extension (any Firefox version) are known
 * to support "%c" CSS customizations.
 *
 * TODO: add a `localStorage` variable to explicitly enable/disable colors
 */ // eslint-disable-next-line complexity
function useColors() {
    // NB: In an Electron preload script, document will be defined but not fully
    // initialized. Since we know we're in Chrome, we'll just detect this case
    // explicitly
    if (typeof window !== 'undefined' && window.process && (window.process.type === 'renderer' || window.process.__nwjs)) return true;
    // Internet Explorer and Edge do not support colors.
    if (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/(edge|trident)\/(\d+)/)) return false;
    let m;
    // Is webkit? http://stackoverflow.com/a/16459606/376773
    // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632
    // eslint-disable-next-line no-return-assign
    return typeof document !== 'undefined' && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance || // Is firebug? http://stackoverflow.com/a/398120/376773
    typeof window !== 'undefined' && window.console && (window.console.firebug || window.console.exception && window.console.table) || // Is firefox >= v31?
    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
    typeof navigator !== 'undefined' && navigator.userAgent && (m = navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/)) && parseInt(m[1], 10) >= 31 || // Double check webkit in userAgent just in case we are in a worker
    typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/);
}
/**
 * Colorize log arguments if enabled.
 *
 * @api public
 */ function formatArgs(args) {
    args[0] = (this.useColors ? '%c' : '') + this.namespace + (this.useColors ? ' %c' : ' ') + args[0] + (this.useColors ? '%c ' : ' ') + '+' + module.exports.humanize(this.diff);
    if (!this.useColors) return;
    const c = 'color: ' + this.color;
    args.splice(1, 0, c, 'color: inherit');
    // The final "%c" is somewhat tricky, because there could be other
    // arguments passed either before or after the %c, so we need to
    // figure out the correct index to insert the CSS into
    let index = 0;
    let lastC = 0;
    args[0].replace(/%[a-zA-Z%]/g, (match)=>{
        if (match === '%%') return;
        index++;
        if (match === '%c') // We only are interested in the *last* %c
        // (the user may have provided their own)
        lastC = index;
    });
    args.splice(lastC, 0, c);
}
/**
 * Invokes `console.debug()` when available.
 * No-op when `console.debug` is not a "function".
 * If `console.debug` is not available, falls back
 * to `console.log`.
 *
 * @api public
 */ exports.log = console.debug || console.log || (()=>{});
/**
 * Save `namespaces`.
 *
 * @param {String} namespaces
 * @api private
 */ function save(namespaces) {
    try {
        if (namespaces) exports.storage.setItem('debug', namespaces);
        else exports.storage.removeItem('debug');
    } catch (error) {
    // Swallow
    // XXX (@Qix-) should we be logging these?
    }
}
/**
 * Load `namespaces`.
 *
 * @return {String} returns the previously persisted debug modes
 * @api private
 */ function load() {
    let r;
    try {
        r = exports.storage.getItem('debug') || exports.storage.getItem('DEBUG');
    } catch (error) {
    // Swallow
    // XXX (@Qix-) should we be logging these?
    }
    // If debug isn't set in LS, and we're in Electron, try to load $DEBUG
    r;
    return r;
}
/**
 * Localstorage attempts to return the localstorage.
 *
 * This is necessary because safari throws
 * when a user disables cookies/localstorage
 * and you attempt to access it.
 *
 * @return {LocalStorage}
 * @api private
 */ function localstorage() {
    try {
        // TVMLKit (Apple TV JS Runtime) does not have a window object, just localStorage in the global context
        // The Browser also has localStorage in the global context.
        return localStorage;
    } catch (error) {
    // Swallow
    // XXX (@Qix-) should we be logging these?
    }
}

module.exports = (parcelRequire("7kBR8"))(exports);
const { formatters } = module.exports;
/**
 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
 */ formatters.j = function(v) {
    try {
        return JSON.stringify(v);
    } catch (error) {
        return '[UnexpectedJSONParseError]: ' + error.message;
    }
};

});
parcelRegister("7kBR8", function(module, exports) {
/**
 * This is the common logic for both the Node.js and web browser
 * implementations of `debug()`.
 */ 
function $5567c417bf6247fd$var$setup(env) {
    createDebug.debug = createDebug;
    createDebug.default = createDebug;
    createDebug.coerce = coerce;
    createDebug.disable = disable;
    createDebug.enable = enable;
    createDebug.enabled = enabled;
    createDebug.humanize = (parcelRequire("3pRq5"));
    createDebug.destroy = destroy;
    Object.keys(env).forEach((key)=>{
        createDebug[key] = env[key];
    });
    /**
	* The currently active debug mode names, and names to skip.
	*/ createDebug.names = [];
    createDebug.skips = [];
    /**
	* Map of special "%n" handling functions, for the debug "format" argument.
	*
	* Valid key names are a single, lower or upper-case letter, i.e. "n" and "N".
	*/ createDebug.formatters = {};
    /**
	* Selects a color for a debug namespace
	* @param {String} namespace The namespace string for the debug instance to be colored
	* @return {Number|String} An ANSI color code for the given namespace
	* @api private
	*/ function selectColor(namespace) {
        let hash = 0;
        for(let i = 0; i < namespace.length; i++){
            hash = (hash << 5) - hash + namespace.charCodeAt(i);
            hash |= 0; // Convert to 32bit integer
        }
        return createDebug.colors[Math.abs(hash) % createDebug.colors.length];
    }
    createDebug.selectColor = selectColor;
    /**
	* Create a debugger with the given `namespace`.
	*
	* @param {String} namespace
	* @return {Function}
	* @api public
	*/ function createDebug(namespace) {
        let prevTime;
        let enableOverride = null;
        let namespacesCache;
        let enabledCache;
        function debug(...args) {
            // Disabled?
            if (!debug.enabled) return;
            const self = debug;
            // Set `diff` timestamp
            const curr = Number(new Date());
            const ms = curr - (prevTime || curr);
            self.diff = ms;
            self.prev = prevTime;
            self.curr = curr;
            prevTime = curr;
            args[0] = createDebug.coerce(args[0]);
            if (typeof args[0] !== 'string') // Anything else let's inspect with %O
            args.unshift('%O');
            // Apply any `formatters` transformations
            let index = 0;
            args[0] = args[0].replace(/%([a-zA-Z%])/g, (match, format)=>{
                // If we encounter an escaped % then don't increase the array index
                if (match === '%%') return '%';
                index++;
                const formatter = createDebug.formatters[format];
                if (typeof formatter === 'function') {
                    const val = args[index];
                    match = formatter.call(self, val);
                    // Now we need to remove `args[index]` since it's inlined in the `format`
                    args.splice(index, 1);
                    index--;
                }
                return match;
            });
            // Apply env-specific formatting (colors, etc.)
            createDebug.formatArgs.call(self, args);
            const logFn = self.log || createDebug.log;
            logFn.apply(self, args);
        }
        debug.namespace = namespace;
        debug.useColors = createDebug.useColors();
        debug.color = createDebug.selectColor(namespace);
        debug.extend = extend;
        debug.destroy = createDebug.destroy; // XXX Temporary. Will be removed in the next major release.
        Object.defineProperty(debug, 'enabled', {
            enumerable: true,
            configurable: false,
            get: ()=>{
                if (enableOverride !== null) return enableOverride;
                if (namespacesCache !== createDebug.namespaces) {
                    namespacesCache = createDebug.namespaces;
                    enabledCache = createDebug.enabled(namespace);
                }
                return enabledCache;
            },
            set: (v)=>{
                enableOverride = v;
            }
        });
        // Env-specific initialization logic for debug instances
        if (typeof createDebug.init === 'function') createDebug.init(debug);
        return debug;
    }
    function extend(namespace, delimiter) {
        const newDebug = createDebug(this.namespace + (typeof delimiter === 'undefined' ? ':' : delimiter) + namespace);
        newDebug.log = this.log;
        return newDebug;
    }
    /**
	* Enables a debug mode by namespaces. This can include modes
	* separated by a colon and wildcards.
	*
	* @param {String} namespaces
	* @api public
	*/ function enable(namespaces) {
        createDebug.save(namespaces);
        createDebug.namespaces = namespaces;
        createDebug.names = [];
        createDebug.skips = [];
        const split = (typeof namespaces === 'string' ? namespaces : '').trim().replace(/\s+/g, ',').split(',').filter(Boolean);
        for (const ns of split)if (ns[0] === '-') createDebug.skips.push(ns.slice(1));
        else createDebug.names.push(ns);
    }
    /**
	 * Checks if the given string matches a namespace template, honoring
	 * asterisks as wildcards.
	 *
	 * @param {String} search
	 * @param {String} template
	 * @return {Boolean}
	 */ function matchesTemplate(search, template) {
        let searchIndex = 0;
        let templateIndex = 0;
        let starIndex = -1;
        let matchIndex = 0;
        while(searchIndex < search.length){
            if (templateIndex < template.length && (template[templateIndex] === search[searchIndex] || template[templateIndex] === '*')) {
                // Match character or proceed with wildcard
                if (template[templateIndex] === '*') {
                    starIndex = templateIndex;
                    matchIndex = searchIndex;
                    templateIndex++; // Skip the '*'
                } else {
                    searchIndex++;
                    templateIndex++;
                }
            } else if (starIndex !== -1) {
                // Backtrack to the last '*' and try to match more characters
                templateIndex = starIndex + 1;
                matchIndex++;
                searchIndex = matchIndex;
            } else return false; // No match
        }
        // Handle trailing '*' in template
        while(templateIndex < template.length && template[templateIndex] === '*')templateIndex++;
        return templateIndex === template.length;
    }
    /**
	* Disable debug output.
	*
	* @return {String} namespaces
	* @api public
	*/ function disable() {
        const namespaces = [
            ...createDebug.names,
            ...createDebug.skips.map((namespace)=>'-' + namespace)
        ].join(',');
        createDebug.enable('');
        return namespaces;
    }
    /**
	* Returns true if the given mode name is enabled, false otherwise.
	*
	* @param {String} name
	* @return {Boolean}
	* @api public
	*/ function enabled(name) {
        for (const skip of createDebug.skips){
            if (matchesTemplate(name, skip)) return false;
        }
        for (const ns of createDebug.names){
            if (matchesTemplate(name, ns)) return true;
        }
        return false;
    }
    /**
	* Coerce `val`.
	*
	* @param {Mixed} val
	* @return {Mixed}
	* @api private
	*/ function coerce(val) {
        if (val instanceof Error) return val.stack || val.message;
        return val;
    }
    /**
	* XXX DO NOT USE. This is a temporary stub function.
	* XXX It WILL be removed in the next major release.
	*/ function destroy() {
        console.warn('Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`.');
    }
    createDebug.enable(createDebug.load());
    return createDebug;
}
module.exports = $5567c417bf6247fd$var$setup;

});
parcelRegister("3pRq5", function(module, exports) {
/**
 * Helpers.
 */ var $27cd24efd2f930b8$var$s = 1000;
var $27cd24efd2f930b8$var$m = $27cd24efd2f930b8$var$s * 60;
var $27cd24efd2f930b8$var$h = $27cd24efd2f930b8$var$m * 60;
var $27cd24efd2f930b8$var$d = $27cd24efd2f930b8$var$h * 24;
var $27cd24efd2f930b8$var$w = $27cd24efd2f930b8$var$d * 7;
var $27cd24efd2f930b8$var$y = $27cd24efd2f930b8$var$d * 365.25;
/**
 * Parse or format the given `val`.
 *
 * Options:
 *
 *  - `long` verbose formatting [false]
 *
 * @param {String|Number} val
 * @param {Object} [options]
 * @throws {Error} throw an error if val is not a non-empty string or a number
 * @return {String|Number}
 * @api public
 */ module.exports = function(val, options) {
    options = options || {};
    var type = typeof val;
    if (type === 'string' && val.length > 0) return $27cd24efd2f930b8$var$parse(val);
    else if (type === 'number' && isFinite(val)) return options.long ? $27cd24efd2f930b8$var$fmtLong(val) : $27cd24efd2f930b8$var$fmtShort(val);
    throw new Error('val is not a non-empty string or a valid number. val=' + JSON.stringify(val));
};
/**
 * Parse the given `str` and return milliseconds.
 *
 * @param {String} str
 * @return {Number}
 * @api private
 */ function $27cd24efd2f930b8$var$parse(str) {
    str = String(str);
    if (str.length > 100) return;
    var match = /^(-?(?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|weeks?|w|years?|yrs?|y)?$/i.exec(str);
    if (!match) return;
    var n = parseFloat(match[1]);
    var type = (match[2] || 'ms').toLowerCase();
    switch(type){
        case 'years':
        case 'year':
        case 'yrs':
        case 'yr':
        case 'y':
            return n * $27cd24efd2f930b8$var$y;
        case 'weeks':
        case 'week':
        case 'w':
            return n * $27cd24efd2f930b8$var$w;
        case 'days':
        case 'day':
        case 'd':
            return n * $27cd24efd2f930b8$var$d;
        case 'hours':
        case 'hour':
        case 'hrs':
        case 'hr':
        case 'h':
            return n * $27cd24efd2f930b8$var$h;
        case 'minutes':
        case 'minute':
        case 'mins':
        case 'min':
        case 'm':
            return n * $27cd24efd2f930b8$var$m;
        case 'seconds':
        case 'second':
        case 'secs':
        case 'sec':
        case 's':
            return n * $27cd24efd2f930b8$var$s;
        case 'milliseconds':
        case 'millisecond':
        case 'msecs':
        case 'msec':
        case 'ms':
            return n;
        default:
            return undefined;
    }
}
/**
 * Short format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */ function $27cd24efd2f930b8$var$fmtShort(ms) {
    var msAbs = Math.abs(ms);
    if (msAbs >= $27cd24efd2f930b8$var$d) return Math.round(ms / $27cd24efd2f930b8$var$d) + 'd';
    if (msAbs >= $27cd24efd2f930b8$var$h) return Math.round(ms / $27cd24efd2f930b8$var$h) + 'h';
    if (msAbs >= $27cd24efd2f930b8$var$m) return Math.round(ms / $27cd24efd2f930b8$var$m) + 'm';
    if (msAbs >= $27cd24efd2f930b8$var$s) return Math.round(ms / $27cd24efd2f930b8$var$s) + 's';
    return ms + 'ms';
}
/**
 * Long format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */ function $27cd24efd2f930b8$var$fmtLong(ms) {
    var msAbs = Math.abs(ms);
    if (msAbs >= $27cd24efd2f930b8$var$d) return $27cd24efd2f930b8$var$plural(ms, msAbs, $27cd24efd2f930b8$var$d, 'day');
    if (msAbs >= $27cd24efd2f930b8$var$h) return $27cd24efd2f930b8$var$plural(ms, msAbs, $27cd24efd2f930b8$var$h, 'hour');
    if (msAbs >= $27cd24efd2f930b8$var$m) return $27cd24efd2f930b8$var$plural(ms, msAbs, $27cd24efd2f930b8$var$m, 'minute');
    if (msAbs >= $27cd24efd2f930b8$var$s) return $27cd24efd2f930b8$var$plural(ms, msAbs, $27cd24efd2f930b8$var$s, 'second');
    return ms + ' ms';
}
/**
 * Pluralization helper.
 */ function $27cd24efd2f930b8$var$plural(ms, msAbs, n, name) {
    var isPlural = msAbs >= n * 1.5;
    return Math.round(ms / n) + ' ' + name + (isPlural ? 's' : '');
}

});



// import wasmUrl from "@automerge/automerge/automerge.wasm?url";
// import * as Automerge from "@automerge/automerge/slim";
/**
 * # Automerge
 *
 * This library provides the core automerge data structure and sync algorithms.
 * Other libraries can be built on top of this one which provide IO and
 * persistence.
 *
 * An automerge document can be thought of an immutable POJO (plain old javascript
 * object) which `automerge` tracks the history of, allowing it to be merged with
 * any other automerge document.
 *
 * ## Creating and modifying a document
 *
 * You can create a document with {@link init} or {@link from} and then make
 * changes to it with {@link change}, you can merge two documents with {@link
 * merge}.
 *
 * ```ts
 * import * as automerge from "@automerge/automerge"
 *
 * type DocType = {ideas: Array<automerge.Text>}
 *
 * let doc1 = automerge.init<DocType>()
 * doc1 = automerge.change(doc1, d => {
 *     d.ideas = [new automerge.Text("an immutable document")]
 * })
 *
 * let doc2 = automerge.init<DocType>()
 * doc2 = automerge.merge(doc2, automerge.clone(doc1))
 * doc2 = automerge.change<DocType>(doc2, d => {
 *     d.ideas.push(new automerge.Text("which records its history"))
 * })
 *
 * // Note the `automerge.clone` call, see the "cloning" section of this readme for
 * // more detail
 * doc1 = automerge.merge(doc1, automerge.clone(doc2))
 * doc1 = automerge.change(doc1, d => {
 *     d.ideas[0].deleteAt(13, 8)
 *     d.ideas[0].insertAt(13, "object")
 * })
 *
 * let doc3 = automerge.merge(doc1, doc2)
 * // doc3 is now {ideas: ["an immutable object", "which records its history"]}
 * ```
 *
 * ## Applying changes from another document
 *
 * You can get a representation of the result of the last {@link change} you made
 * to a document with {@link getLastLocalChange} and you can apply that change to
 * another document using {@link applyChanges}.
 *
 * If you need to get just the changes which are in one document but not in another
 * you can use {@link getHeads} to get the heads of the document without the
 * changes and then {@link getMissingDeps}, passing the result of {@link getHeads}
 * on the document with the changes.
 *
 * ## Saving and loading documents
 *
 * You can {@link save} a document to generate a compresed binary representation of
 * the document which can be loaded with {@link load}. If you have a document which
 * you have recently made changes to you can generate recent changes with {@link
 * saveIncremental}, this will generate all the changes since you last called
 * `saveIncremental`, the changes generated can be applied to another document with
 * {@link loadIncremental}.
 *
 * ## Viewing different versions of a document
 *
 * Occasionally you may wish to explicitly step to a different point in a document
 * history. One common reason to do this is if you need to obtain a set of changes
 * which take the document from one state to another in order to send those changes
 * to another peer (or to save them somewhere). You can use {@link view} to do this.
 *
 * ```ts
 * import * as automerge from "@automerge/automerge"
 * import * as assert from "assert"
 *
 * let doc = automerge.from({
 *   key1: "value1",
 * })
 *
 * // Make a clone of the document at this point, maybe this is actually on another
 * // peer.
 * let doc2 = automerge.clone < any > doc
 *
 * let heads = automerge.getHeads(doc)
 *
 * doc =
 *   automerge.change <
 *   any >
 *   (doc,
 *   d => {
 *     d.key2 = "value2"
 *   })
 *
 * doc =
 *   automerge.change <
 *   any >
 *   (doc,
 *   d => {
 *     d.key3 = "value3"
 *   })
 *
 * // At this point we've generated two separate changes, now we want to send
 * // just those changes to someone else
 *
 * // view is a cheap reference based copy of a document at a given set of heads
 * let before = automerge.view(doc, heads)
 *
 * // This view doesn't show the last two changes in the document state
 * assert.deepEqual(before, {
 *   key1: "value1",
 * })
 *
 * // Get the changes to send to doc2
 * let changes = automerge.getChanges(before, doc)
 *
 * // Apply the changes at doc2
 * doc2 = automerge.applyChanges < any > (doc2, changes)[0]
 * assert.deepEqual(doc2, {
 *   key1: "value1",
 *   key2: "value2",
 *   key3: "value3",
 * })
 * ```
 *
 * If you have a {@link view} of a document which you want to make changes to you
 * can {@link clone} the viewed document.
 *
 * ## Syncing
 *
 * The sync protocol is stateful. This means that we start by creating a {@link
 * SyncState} for each peer we are communicating with using {@link initSyncState}.
 * Then we generate a message to send to the peer by calling {@link
 * generateSyncMessage}. When we receive a message from the peer we call {@link
 * receiveSyncMessage}. Here's a simple example of a loop which just keeps two
 * peers in sync.
 *
 * ```ts
 * let sync1 = automerge.initSyncState()
 * let msg: Uint8Array | null
 * ;[sync1, msg] = automerge.generateSyncMessage(doc1, sync1)
 *
 * while (true) {
 *   if (msg != null) {
 *     network.send(msg)
 *   }
 *   let resp: Uint8Array =
 *     (network.receive()[(doc1, sync1, _ignore)] =
 *     automerge.receiveSyncMessage(doc1, sync1, resp)[(sync1, msg)] =
 *       automerge.generateSyncMessage(doc1, sync1))
 * }
 * ```
 *
 * ## Conflicts
 *
 * The only time conflicts occur in automerge documents is in concurrent
 * assignments to the same key in an object. In this case automerge
 * deterministically chooses an arbitrary value to present to the application but
 * you can examine the conflicts using {@link getConflicts}.
 *
 * ```
 * import * as automerge from "@automerge/automerge"
 *
 * type Profile = {
 *     pets: Array<{name: string, type: string}>
 * }
 *
 * let doc1 = automerge.init<Profile>("aaaa")
 * doc1 = automerge.change(doc1, d => {
 *     d.pets = [{name: "Lassie", type: "dog"}]
 * })
 * let doc2 = automerge.init<Profile>("bbbb")
 * doc2 = automerge.merge(doc2, automerge.clone(doc1))
 *
 * doc2 = automerge.change(doc2, d => {
 *     d.pets[0].name = "Beethoven"
 * })
 *
 * doc1 = automerge.change(doc1, d => {
 *     d.pets[0].name = "Babe"
 * })
 *
 * const doc3 = automerge.merge(doc1, doc2)
 *
 * // Note that here we pass `doc3.pets`, not `doc3`
 * let conflicts = automerge.getConflicts(doc3.pets[0], "name")
 *
 * // The two conflicting values are the keys of the conflicts object
 * assert.deepEqual(Object.values(conflicts), ["Babe", "Beethoven"])
 * ```
 *
 * ## Actor IDs
 *
 * By default automerge will generate a random actor ID for you, but most methods
 * for creating a document allow you to set the actor ID. You can get the actor ID
 * associated with the document by calling {@link getActorId}. Actor IDs must not
 * be used in concurrent threads of executiong - all changes by a given actor ID
 * are expected to be sequential.
 *
 * ## Listening to patches
 *
 * Sometimes you want to respond to changes made to an automerge document. In this
 * case you can use the {@link PatchCallback} type to receive notifications when
 * changes have been made.
 *
 * ## Cloning
 *
 * Currently you cannot make mutating changes (i.e. call {@link change}) to a
 * document which you have two pointers to. For example, in this code:
 *
 * ```javascript
 * let doc1 = automerge.init()
 * let doc2 = automerge.change(doc1, d => (d.key = "value"))
 * ```
 *
 * `doc1` and `doc2` are both pointers to the same state. Any attempt to call
 * mutating methods on `doc1` will now result in an error like
 *
 *     Attempting to change an out of date document
 *
 * If you encounter this you need to clone the original document, the above sample
 * would work as:
 *
 * ```javascript
 * let doc1 = automerge.init()
 * let doc2 = automerge.change(automerge.clone(doc1), d => (d.key = "value"))
 * ```
 */ // Properties of the document root object
const $09df12355b460850$export$63b4527a2777036f = Symbol.for("_am_meta"); // symbol used to hide application metadata on automerge objects
const $09df12355b460850$export$8754b71dc67cd5d0 = Symbol.for("_am_trace"); // used for debugging
const $09df12355b460850$export$c5b546cf7251e6ae = Symbol.for("_am_objectId"); // symbol used to hide the object id on automerge objects
const $09df12355b460850$export$1e2e11669870719e = Symbol.for("_am_isProxy"); // symbol used to test if the document is a proxy object
const $09df12355b460850$export$f2b782965eea3685 = Symbol.for("_am_clearCache"); // symbol used to tell a proxy object to clear its cache
const $09df12355b460850$export$54c0d11872b7e6d4 = Symbol.for("_am_uint");
const $09df12355b460850$export$160e8bdd97bfce3a = Symbol.for("_am_int");
const $09df12355b460850$export$b820c9ce995741f7 = Symbol.for("_am_f64");
const $09df12355b460850$export$9de65db2f90f2f15 = Symbol.for("_am_counter");
const $09df12355b460850$export$d597759d33be802e = Symbol.for("_am_text");
const $09df12355b460850$export$52ca57f08d212de3 = Symbol.for("_am_immutableString");


class $d6eb269bf86df424$export$1b74141c5fe63a28 {
    constructor(value){
        this.value = value || 0;
        Reflect.defineProperty(this, (0, $09df12355b460850$export$9de65db2f90f2f15), {
            value: true
        });
    }
    /**
     * A peculiar JavaScript language feature from its early days: if the object
     * `x` has a `valueOf()` method that returns a number, you can use numerical
     * operators on the object `x` directly, such as `x + 1` or `x < 4`.
     * This method is also called when coercing a value to a string by
     * concatenating it with another string, as in `x + ''`.
     * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/valueOf
     */ valueOf() {
        return this.value;
    }
    /**
     * Returns the counter value as a decimal string. If `x` is a counter object,
     * this method is called e.g. when you do `['value: ', x].join('')` or when
     * you use string interpolation: `value: ${x}`.
     */ toString() {
        return this.valueOf().toString();
    }
    /**
     * Returns the counter value, so that a JSON serialization of an Automerge
     * document represents the counter simply as an integer.
     */ toJSON() {
        return this.value;
    }
    /**
     * Increases the value of the counter by `delta`. If `delta` is not given,
     * increases the value of the counter by 1.
     *
     * Will throw an error if used outside of a change callback.
     */ increment(_delta) {
        throw new Error("Counters should not be incremented outside of a change callback");
    }
    /**
     * Decreases the value of the counter by `delta`. If `delta` is not given,
     * decreases the value of the counter by 1.
     *
     * Will throw an error if used outside of a change callback.
     */ decrement(_delta) {
        throw new Error("Counters should not be decremented outside of a change callback");
    }
}
/**
 * An instance of this class is used when a counter is accessed within a change
 * callback.
 */ class $d6eb269bf86df424$var$WriteableCounter extends $d6eb269bf86df424$export$1b74141c5fe63a28 {
    constructor(value, context, path, objectId, key){
        super(value);
        this.context = context;
        this.path = path;
        this.objectId = objectId;
        this.key = key;
    }
    /**
     * Increases the value of the counter by `delta`. If `delta` is not given,
     * increases the value of the counter by 1.
     */ increment(delta) {
        delta = typeof delta === "number" ? delta : 1;
        this.context.increment(this.objectId, this.key, delta);
        this.value += delta;
        return this.value;
    }
    /**
     * Decreases the value of the counter by `delta`. If `delta` is not given,
     * decreases the value of the counter by 1.
     */ decrement(delta) {
        return this.increment(typeof delta === "number" ? -delta : -1);
    }
}
function $d6eb269bf86df424$export$8669c344d38369fd(value, context, path, objectId, key) {
    return new $d6eb269bf86df424$var$WriteableCounter(value, context, path, objectId, key);
} //module.exports = { Counter, getWriteableCounter }




var $9c226d2cfb90e31a$var$_a;
class $9c226d2cfb90e31a$export$3e488ffad70f65de {
    constructor(val){
        // Used to detect whether a value is a ImmutableString object rather than using an instanceof check
        this[$9c226d2cfb90e31a$var$_a] = true;
        this.val = val;
    }
    /**
     * Returns the content of the ImmutableString object as a simple string
     */ toString() {
        return this.val;
    }
    toJSON() {
        return this.val;
    }
}
$9c226d2cfb90e31a$var$_a = (0, $09df12355b460850$export$52ca57f08d212de3);


const $2c6cf4f9e0e5e6b9$var$MAX_I64 = BigInt("9223372036854775807"); // 2n ** 63n - 1n;
function $2c6cf4f9e0e5e6b9$var$parseListIndex(key) {
    if (typeof key === "string" && /^[0-9]+$/.test(key)) key = parseInt(key, 10);
    if (typeof key !== "number") return key;
    if (key < 0 || isNaN(key) || key === Infinity || key === -Infinity) throw new RangeError("A list index must be positive, but you passed " + key);
    return key;
}
function $2c6cf4f9e0e5e6b9$var$valueAt(target, prop) {
    const { context: context, objectId: objectId, path: path } = target;
    const value = context.getWithType(objectId, prop);
    if (value === null) return;
    const datatype = value[0];
    const val = value[1];
    switch(datatype){
        case undefined:
            return;
        case "map":
            return $2c6cf4f9e0e5e6b9$export$42df4b810ff5eb5c(context, val, [
                ...path,
                prop
            ]);
        case "list":
            return $2c6cf4f9e0e5e6b9$export$3c92d7f346eba7cc(context, val, [
                ...path,
                prop
            ]);
        case "text":
            return context.text(val);
        case "str":
            return new (0, $9c226d2cfb90e31a$export$3e488ffad70f65de)(val);
        case "uint":
            return val;
        case "int":
            return val;
        case "f64":
            return val;
        case "boolean":
            return val;
        case "null":
            return null;
        case "bytes":
            return val;
        case "timestamp":
            return val;
        case "counter":
            {
                const counter = (0, $d6eb269bf86df424$export$8669c344d38369fd)(val, context, path, objectId, prop);
                return counter;
            }
        default:
            throw RangeError(`datatype ${datatype} unimplemented`);
    }
}
function $2c6cf4f9e0e5e6b9$var$import_value(value, path, context) {
    const type = typeof value;
    switch(type){
        case "object":
            if (value == null) return [
                null,
                "null"
            ];
            else if (value[0, $09df12355b460850$export$54c0d11872b7e6d4]) return [
                value.value,
                "uint"
            ];
            else if (value[0, $09df12355b460850$export$160e8bdd97bfce3a]) return [
                value.value,
                "int"
            ];
            else if (value[0, $09df12355b460850$export$b820c9ce995741f7]) return [
                value.value,
                "f64"
            ];
            else if (value[0, $09df12355b460850$export$9de65db2f90f2f15]) return [
                value.value,
                "counter"
            ];
            else if (value instanceof Date) return [
                value.getTime(),
                "timestamp"
            ];
            else if ($2c6cf4f9e0e5e6b9$export$c8182079cd36e71f(value)) return [
                value.toString(),
                "str"
            ];
            else if (value instanceof Uint8Array) return [
                value,
                "bytes"
            ];
            else if (value instanceof Array) return [
                value,
                "list"
            ];
            else if (Object.prototype.toString.call(value) === "[object Object]") return [
                value,
                "map"
            ];
            else if ($2c6cf4f9e0e5e6b9$var$isSameDocument(value, context)) throw new RangeError("Cannot create a reference to an existing document object");
            else throw new RangeError(`Cannot assign unknown object: ${value}`);
        case "boolean":
            return [
                value,
                "boolean"
            ];
        case "bigint":
            if (value > $2c6cf4f9e0e5e6b9$var$MAX_I64) return [
                value,
                "uint"
            ];
            else return [
                value,
                "int"
            ];
        case "number":
            if (Number.isInteger(value)) return [
                value,
                "int"
            ];
            else return [
                value,
                "f64"
            ];
        case "string":
            return [
                value,
                "text"
            ];
        case "undefined":
            throw new RangeError([
                `Cannot assign undefined value at ${$2c6cf4f9e0e5e6b9$var$printPath(path)}, `,
                "because `undefined` is not a valid JSON data type. ",
                "You might consider setting the property's value to `null`, ",
                "or using `delete` to remove it altogether."
            ].join(""));
        default:
            throw new RangeError([
                `Cannot assign ${type} value at ${$2c6cf4f9e0e5e6b9$var$printPath(path)}. `,
                `All JSON primitive datatypes (object, array, string, number, boolean, null) `,
                `are supported in an Automerge document; ${type} values are not. `
            ].join(""));
    }
}
// When we assign a value to a property in a proxy we recursively walk through
// the value we are assigning and copy it into the document. This is generally
// desirable behaviour. However, a very common bug is to accidentally assign a
// value which is already in the document to another key within the same
// document, this often leads to surprising behaviour where users expected to
// _move_ the object, but it is instead copied. To avoid this we check if the
// value is from the same document and if it is we throw an error, this means
// we require an explicit Object.assign call to copy the object, thus avoiding
// the footgun
function $2c6cf4f9e0e5e6b9$var$isSameDocument(val, context) {
    var _b, _c;
    // Date is technically an object, but immutable, so allowing people to assign
    // a date from one place in the document to another place in the document is
    // not likely to be a bug
    if (val instanceof Date) return false;
    // this depends on __wbg_ptr being the wasm pointer
    // a new version of wasm-bindgen will break this
    // but the tests should expose the break
    if (val && ((_c = (_b = val[0, $09df12355b460850$export$63b4527a2777036f]) === null || _b === void 0 ? void 0 : _b.handle) === null || _c === void 0 ? void 0 : _c.__wbg_ptr) === context.__wbg_ptr) return true;
    return false;
}
const $2c6cf4f9e0e5e6b9$var$MapHandler = {
    get (target, key) {
        const { context: context, objectId: objectId, cache: cache } = target;
        if (key === Symbol.toStringTag) return target[Symbol.toStringTag];
        if (key === (0, $09df12355b460850$export$c5b546cf7251e6ae)) return objectId;
        if (key === (0, $09df12355b460850$export$1e2e11669870719e)) return true;
        if (key === (0, $09df12355b460850$export$8754b71dc67cd5d0)) return target.trace;
        if (key === (0, $09df12355b460850$export$63b4527a2777036f)) return {
            handle: context
        };
        if (!cache[key]) cache[key] = $2c6cf4f9e0e5e6b9$var$valueAt(target, key);
        return cache[key];
    },
    set (target, key, val) {
        const { context: context, objectId: objectId, path: path } = target;
        target.cache = {}; // reset cache on set
        if ($2c6cf4f9e0e5e6b9$var$isSameDocument(val, context)) throw new RangeError("Cannot create a reference to an existing document object");
        if (key === (0, $09df12355b460850$export$8754b71dc67cd5d0)) {
            target.trace = val;
            return true;
        }
        if (key === (0, $09df12355b460850$export$f2b782965eea3685)) return true;
        const [value, datatype] = $2c6cf4f9e0e5e6b9$var$import_value(val, [
            ...path,
            key
        ], context);
        switch(datatype){
            case "list":
                {
                    const list = context.putObject(objectId, key, []);
                    const proxyList = $2c6cf4f9e0e5e6b9$export$3c92d7f346eba7cc(context, list, [
                        ...path,
                        key
                    ]);
                    for(let i = 0; i < value.length; i++)proxyList[i] = value[i];
                    break;
                }
            case "text":
                context.putObject(objectId, key, value);
                break;
            case "map":
                {
                    const map = context.putObject(objectId, key, {});
                    const proxyMap = $2c6cf4f9e0e5e6b9$export$42df4b810ff5eb5c(context, map, [
                        ...path,
                        key
                    ]);
                    for(const key in value)proxyMap[key] = value[key];
                    break;
                }
            default:
                context.put(objectId, key, value, datatype);
        }
        return true;
    },
    deleteProperty (target, key) {
        const { context: context, objectId: objectId } = target;
        target.cache = {}; // reset cache on delete
        context.delete(objectId, key);
        return true;
    },
    has (target, key) {
        const value = this.get(target, key);
        return value !== undefined;
    },
    getOwnPropertyDescriptor (target, key) {
        // const { context, objectId } = target
        const value = this.get(target, key);
        if (typeof value !== "undefined") return {
            configurable: true,
            enumerable: true,
            value: value
        };
    },
    ownKeys (target) {
        const { context: context, objectId: objectId } = target;
        // FIXME - this is a tmp workaround until fix the dupe key bug in keys()
        const keys = context.keys(objectId);
        return [
            ...new Set(keys)
        ];
    }
};
const $2c6cf4f9e0e5e6b9$var$ListHandler = {
    get (target, index) {
        const { context: context, objectId: objectId } = target;
        index = $2c6cf4f9e0e5e6b9$var$parseListIndex(index);
        if (index === Symbol.hasInstance) return (instance)=>{
            return Array.isArray(instance);
        };
        if (index === Symbol.toStringTag) return target[Symbol.toStringTag];
        if (index === (0, $09df12355b460850$export$c5b546cf7251e6ae)) return objectId;
        if (index === (0, $09df12355b460850$export$1e2e11669870719e)) return true;
        if (index === (0, $09df12355b460850$export$8754b71dc67cd5d0)) return target.trace;
        if (index === (0, $09df12355b460850$export$63b4527a2777036f)) return {
            handle: context
        };
        if (index === "length") return context.length(objectId);
        if (typeof index === "number") return $2c6cf4f9e0e5e6b9$var$valueAt(target, index);
        else return $2c6cf4f9e0e5e6b9$var$listMethods(target)[index];
    },
    set (target, index, val) {
        const { context: context, objectId: objectId, path: path } = target;
        index = $2c6cf4f9e0e5e6b9$var$parseListIndex(index);
        if ($2c6cf4f9e0e5e6b9$var$isSameDocument(val, context)) throw new RangeError("Cannot create a reference to an existing document object");
        if (index === (0, $09df12355b460850$export$f2b782965eea3685)) return true;
        if (index === (0, $09df12355b460850$export$8754b71dc67cd5d0)) {
            target.trace = val;
            return true;
        }
        if (typeof index == "string") throw new RangeError("list index must be a number");
        const [value, datatype] = $2c6cf4f9e0e5e6b9$var$import_value(val, [
            ...path,
            index
        ], context);
        switch(datatype){
            case "list":
                {
                    let list;
                    if (index >= context.length(objectId)) list = context.insertObject(objectId, index, []);
                    else list = context.putObject(objectId, index, []);
                    const proxyList = $2c6cf4f9e0e5e6b9$export$3c92d7f346eba7cc(context, list, [
                        ...path,
                        index
                    ]);
                    proxyList.splice(0, 0, ...value);
                    break;
                }
            case "text":
                if (index >= context.length(objectId)) context.insertObject(objectId, index, value);
                else context.putObject(objectId, index, value);
                break;
            case "map":
                {
                    let map;
                    if (index >= context.length(objectId)) map = context.insertObject(objectId, index, {});
                    else map = context.putObject(objectId, index, {});
                    const proxyMap = $2c6cf4f9e0e5e6b9$export$42df4b810ff5eb5c(context, map, [
                        ...path,
                        index
                    ]);
                    for(const key in value)proxyMap[key] = value[key];
                    break;
                }
            default:
                if (index >= context.length(objectId)) context.insert(objectId, index, value, datatype);
                else context.put(objectId, index, value, datatype);
        }
        return true;
    },
    deleteProperty (target, index) {
        const { context: context, objectId: objectId } = target;
        index = $2c6cf4f9e0e5e6b9$var$parseListIndex(index);
        const elem = context.get(objectId, index);
        if (elem != null && elem[0] == "counter") throw new TypeError("Unsupported operation: deleting a counter from a list");
        context.delete(objectId, index);
        return true;
    },
    has (target, index) {
        const { context: context, objectId: objectId } = target;
        index = $2c6cf4f9e0e5e6b9$var$parseListIndex(index);
        if (typeof index === "number") return index < context.length(objectId);
        return index === "length";
    },
    getOwnPropertyDescriptor (target, index) {
        const { context: context, objectId: objectId } = target;
        if (index === "length") return {
            writable: true,
            value: context.length(objectId)
        };
        if (index === (0, $09df12355b460850$export$c5b546cf7251e6ae)) return {
            configurable: false,
            enumerable: false,
            value: objectId
        };
        index = $2c6cf4f9e0e5e6b9$var$parseListIndex(index);
        const value = $2c6cf4f9e0e5e6b9$var$valueAt(target, index);
        return {
            configurable: true,
            enumerable: true,
            value: value
        };
    },
    getPrototypeOf (target) {
        return Object.getPrototypeOf(target);
    },
    ownKeys () {
        const keys = [];
        // uncommenting this causes assert.deepEqual() to fail when comparing to a pojo array
        // but not uncommenting it causes for (i in list) {} to not enumerate values properly
        //const {context, objectId } = target
        //for (let i = 0; i < target.context.length(objectId); i++) { keys.push(i.toString()) }
        keys.push("length");
        return keys;
    }
};
function $2c6cf4f9e0e5e6b9$export$42df4b810ff5eb5c(context, objectId, path) {
    const target = {
        context: context,
        objectId: objectId,
        path: path || [],
        cache: {}
    };
    const proxied = {};
    Object.assign(proxied, target);
    const result = new Proxy(proxied, $2c6cf4f9e0e5e6b9$var$MapHandler);
    // conversion through unknown is necessary because the types are so different
    return result;
}
function $2c6cf4f9e0e5e6b9$export$3c92d7f346eba7cc(context, objectId, path) {
    const target = {
        context: context,
        objectId: objectId,
        path: path || [],
        cache: {}
    };
    const proxied = [];
    Object.assign(proxied, target);
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    return new Proxy(proxied, $2c6cf4f9e0e5e6b9$var$ListHandler);
}
function $2c6cf4f9e0e5e6b9$export$e99ac7fa6c1fa986(context) {
    /* eslint-disable-next-line */ return $2c6cf4f9e0e5e6b9$export$42df4b810ff5eb5c(context, "_root", []);
}
function $2c6cf4f9e0e5e6b9$var$listMethods(target) {
    const { context: context, objectId: objectId, path: path } = target;
    const methods = {
        at (index) {
            return $2c6cf4f9e0e5e6b9$var$valueAt(target, index);
        },
        deleteAt (index, numDelete) {
            if (typeof numDelete === "number") context.splice(objectId, index, numDelete);
            else context.delete(objectId, index);
            return this;
        },
        fill (val, start, end) {
            const [value, datatype] = $2c6cf4f9e0e5e6b9$var$import_value(val, [
                ...path,
                start
            ], context);
            const length = context.length(objectId);
            start = $2c6cf4f9e0e5e6b9$var$parseListIndex(start || 0);
            end = $2c6cf4f9e0e5e6b9$var$parseListIndex(end || length);
            for(let i = start; i < Math.min(end, length); i++){
                if (datatype === "list" || datatype === "map") context.putObject(objectId, i, value);
                else if (datatype === "text") context.putObject(objectId, i, value);
                else context.put(objectId, i, value, datatype);
            }
            return this;
        },
        indexOf (searchElement, start = 0) {
            const length = context.length(objectId);
            for(let i = start; i < length; i++){
                const valueWithType = context.getWithType(objectId, i);
                if (!valueWithType) continue;
                const [valType, value] = valueWithType;
                // Either the target element is an object, and we return if we have found
                // the same object or it is a primitive value and we return if it matches
                // the current value
                const isObject = [
                    "map",
                    "list",
                    "text"
                ].includes(valType);
                if (!isObject) {
                    // If the element is not an object, then check if the value is equal to the target
                    if (value === searchElement) return i;
                    else continue;
                }
                // if it's an object, but the type of the search element is a string, then we
                // need to check if the object is a text object with the same value as the search element
                if (valType === "text" && typeof searchElement === "string") {
                    if (searchElement === $2c6cf4f9e0e5e6b9$var$valueAt(target, i)) return i;
                }
                // The only possible match now is if the searchElement is an object already in the
                // automerge document with the same object ID as the value
                if (searchElement[0, $09df12355b460850$export$c5b546cf7251e6ae] === value) return i;
            }
            return -1;
        },
        insertAt (index, ...values) {
            this.splice(index, 0, ...values);
            return this;
        },
        pop () {
            const length = context.length(objectId);
            if (length == 0) return undefined;
            const last = $2c6cf4f9e0e5e6b9$var$valueAt(target, length - 1);
            context.delete(objectId, length - 1);
            return last;
        },
        push (...values) {
            const len = context.length(objectId);
            this.splice(len, 0, ...values);
            return context.length(objectId);
        },
        shift () {
            if (context.length(objectId) == 0) return;
            const first = $2c6cf4f9e0e5e6b9$var$valueAt(target, 0);
            context.delete(objectId, 0);
            return first;
        },
        splice (index, del, ...vals) {
            index = $2c6cf4f9e0e5e6b9$var$parseListIndex(index);
            // if del is undefined, delete until the end of the list
            if (typeof del !== "number") del = context.length(objectId) - index;
            del = $2c6cf4f9e0e5e6b9$var$parseListIndex(del);
            for (const val of vals){
                if ($2c6cf4f9e0e5e6b9$var$isSameDocument(val, context)) throw new RangeError("Cannot create a reference to an existing document object");
            }
            const result = [];
            for(let i = 0; i < del; i++){
                const value = $2c6cf4f9e0e5e6b9$var$valueAt(target, index);
                if (value !== undefined) result.push(value);
                context.delete(objectId, index);
            }
            const values = vals.map((val, index)=>{
                try {
                    return $2c6cf4f9e0e5e6b9$var$import_value(val, [
                        ...path
                    ], context);
                } catch (e) {
                    if (e instanceof RangeError) throw new RangeError(`${e.message} (at index ${index} in the input)`);
                    else throw e;
                }
            });
            for (const [value, datatype] of values){
                switch(datatype){
                    case "list":
                        {
                            const list = context.insertObject(objectId, index, []);
                            const proxyList = $2c6cf4f9e0e5e6b9$export$3c92d7f346eba7cc(context, list, [
                                ...path,
                                index
                            ]);
                            proxyList.splice(0, 0, ...value);
                            break;
                        }
                    case "text":
                        context.insertObject(objectId, index, value);
                        break;
                    case "map":
                        {
                            const map = context.insertObject(objectId, index, {});
                            const proxyMap = $2c6cf4f9e0e5e6b9$export$42df4b810ff5eb5c(context, map, [
                                ...path,
                                index
                            ]);
                            for(const key in value)proxyMap[key] = value[key];
                            break;
                        }
                    default:
                        context.insert(objectId, index, value, datatype);
                }
                index += 1;
            }
            return result;
        },
        unshift (...values) {
            this.splice(0, 0, ...values);
            return context.length(objectId);
        },
        entries () {
            let i = 0;
            const iterator = {
                next: ()=>{
                    const value = $2c6cf4f9e0e5e6b9$var$valueAt(target, i);
                    if (value === undefined) return {
                        value: undefined,
                        done: true
                    };
                    else return {
                        value: [
                            i++,
                            value
                        ],
                        done: false
                    };
                },
                [Symbol.iterator] () {
                    return this;
                }
            };
            return iterator;
        },
        keys () {
            let i = 0;
            const len = context.length(objectId);
            const iterator = {
                next: ()=>{
                    if (i < len) return {
                        value: i++,
                        done: false
                    };
                    return {
                        value: undefined,
                        done: true
                    };
                },
                [Symbol.iterator] () {
                    return this;
                }
            };
            return iterator;
        },
        values () {
            let i = 0;
            const iterator = {
                next: ()=>{
                    const value = $2c6cf4f9e0e5e6b9$var$valueAt(target, i++);
                    if (value === undefined) return {
                        value: undefined,
                        done: true
                    };
                    else return {
                        value: value,
                        done: false
                    };
                },
                [Symbol.iterator] () {
                    return this;
                }
            };
            return iterator;
        },
        toArray () {
            const list = [];
            let value;
            do {
                value = $2c6cf4f9e0e5e6b9$var$valueAt(target, list.length);
                if (value !== undefined) list.push(value);
            }while (value !== undefined);
            return list;
        },
        map (f) {
            return this.toArray().map(f);
        },
        toString () {
            return this.toArray().toString();
        },
        toLocaleString () {
            return this.toArray().toLocaleString();
        },
        forEach (f) {
            return this.toArray().forEach(f);
        },
        // todo: real concat function is different
        concat (other) {
            return this.toArray().concat(other);
        },
        every (f) {
            return this.toArray().every(f);
        },
        filter (f) {
            return this.toArray().filter(f);
        },
        find (f) {
            let index = 0;
            for (const v of this){
                if (f(v, index)) return v;
                index += 1;
            }
        },
        findIndex (f) {
            let index = 0;
            for (const v of this){
                if (f(v, index)) return index;
                index += 1;
            }
            return -1;
        },
        includes (elem) {
            return this.find((e)=>e === elem) !== undefined;
        },
        join (sep) {
            return this.toArray().join(sep);
        },
        reduce (f, initialValue) {
            return this.toArray().reduce(f, initialValue);
        },
        reduceRight (f, initialValue) {
            return this.toArray().reduceRight(f, initialValue);
        },
        lastIndexOf (search, fromIndex = Infinity) {
            // this can be faster
            return this.toArray().lastIndexOf(search, fromIndex);
        },
        slice (index, num) {
            return this.toArray().slice(index, num);
        },
        some (f) {
            let index = 0;
            for (const v of this){
                if (f(v, index)) return true;
                index += 1;
            }
            return false;
        },
        [Symbol.iterator]: function*() {
            let i = 0;
            let value = $2c6cf4f9e0e5e6b9$var$valueAt(target, i);
            while(value !== undefined){
                yield value;
                i += 1;
                value = $2c6cf4f9e0e5e6b9$var$valueAt(target, i);
            }
        }
    };
    return methods;
}
function $2c6cf4f9e0e5e6b9$var$textMethods(target) {
    const { context: context, objectId: objectId } = target;
    const methods = {
        set (index, value) {
            return this[index] = value;
        },
        get (index) {
            return this[index];
        },
        toString () {
            return context.text(objectId).replace(/￼/g, "");
        },
        toSpans () {
            const spans = [];
            let chars = "";
            const length = context.length(objectId);
            for(let i = 0; i < length; i++){
                const value = this[i];
                if (typeof value === "string") chars += value;
                else {
                    if (chars.length > 0) {
                        spans.push(chars);
                        chars = "";
                    }
                    spans.push(value);
                }
            }
            if (chars.length > 0) spans.push(chars);
            return spans;
        },
        toJSON () {
            return this.toString();
        },
        indexOf (o, start = 0) {
            const text = context.text(objectId);
            return text.indexOf(o, start);
        },
        insertAt (index, ...values) {
            if (values.every((v)=>typeof v === "string")) context.splice(objectId, index, 0, values.join(""));
            else $2c6cf4f9e0e5e6b9$var$listMethods(target).insertAt(index, ...values);
        }
    };
    return methods;
}
function $2c6cf4f9e0e5e6b9$var$printPath(path) {
    // print the path as a json pointer
    const jsonPointerComponents = path.map((component)=>{
        // if its a number just turn it into a string
        if (typeof component === "number") return component.toString();
        else if (typeof component === "string") // otherwise we have to escape `/` and `~` characters
        return component.replace(/~/g, "~0").replace(/\//g, "~1");
    });
    if (path.length === 0) return "";
    else return "/" + jsonPointerComponents.join("/");
}
function $2c6cf4f9e0e5e6b9$export$c8182079cd36e71f(obj) {
    // We used to determine whether something was a ImmutableString by doing an instanceof check, but
    // this doesn't work if the automerge module is loaded twice somehow. Instead, use the presence
    // of a symbol to determine if something is a ImmutableString
    return typeof obj === "object" && obj !== null && Object.prototype.hasOwnProperty.call(obj, (0, $09df12355b460850$export$52ca57f08d212de3));
}
function $2c6cf4f9e0e5e6b9$export$78f0d2b1c8242b32(obj) {
    // We used to determine whether something was a Counter by doing an instanceof check, but
    // this doesn't work if the automerge module is loaded twice somehow. Instead, use the presence
    // of a symbol to determine if something is a Counter
    return typeof obj === "object" && obj !== null && Object.prototype.hasOwnProperty.call(obj, (0, $09df12355b460850$export$9de65db2f90f2f15));
}




// Convenience classes to allow users to strictly specify the number type they want

class $605735e08f0f9c00$export$fdd676b64b72b00 {
    constructor(value){
        if (!(Number.isInteger(value) && value <= Number.MAX_SAFE_INTEGER && value >= Number.MIN_SAFE_INTEGER)) throw new RangeError(`Value ${value} cannot be a uint`);
        this.value = value;
        Reflect.defineProperty(this, (0, $09df12355b460850$export$160e8bdd97bfce3a), {
            value: true
        });
        Object.freeze(this);
    }
}
class $605735e08f0f9c00$export$f5013dbad57df7b8 {
    constructor(value){
        if (!(Number.isInteger(value) && value <= Number.MAX_SAFE_INTEGER && value >= 0)) throw new RangeError(`Value ${value} cannot be a uint`);
        this.value = value;
        Reflect.defineProperty(this, (0, $09df12355b460850$export$54c0d11872b7e6d4), {
            value: true
        });
        Object.freeze(this);
    }
}
class $605735e08f0f9c00$export$42429e12507a49a2 {
    constructor(value){
        if (typeof value !== "number") throw new RangeError(`Value ${value} cannot be a float64`);
        this.value = value || 0.0;
        Reflect.defineProperty(this, (0, $09df12355b460850$export$b820c9ce995741f7), {
            value: true
        });
        Object.freeze(this);
    }
}





var $077cadf07a74900e$exports = {};

$parcel$defineInteropFlag($077cadf07a74900e$exports);

$parcel$export($077cadf07a74900e$exports, "Automerge", () => $077cadf07a74900e$export$77262bb0ea2cab57);
$parcel$export($077cadf07a74900e$exports, "SyncState", () => $077cadf07a74900e$export$8c8eabe8748e941e);
$parcel$export($077cadf07a74900e$exports, "create", () => $077cadf07a74900e$export$185802fd694ee1f5);
$parcel$export($077cadf07a74900e$exports, "decodeChange", () => $077cadf07a74900e$export$5375c324cca37246);
$parcel$export($077cadf07a74900e$exports, "decodeSyncMessage", () => $077cadf07a74900e$export$f4fe23b15e41e0e4);
$parcel$export($077cadf07a74900e$exports, "decodeSyncState", () => $077cadf07a74900e$export$d01db62e8ae92970);
$parcel$export($077cadf07a74900e$exports, "encodeChange", () => $077cadf07a74900e$export$18b630b4c065867e);
$parcel$export($077cadf07a74900e$exports, "encodeSyncMessage", () => $077cadf07a74900e$export$48610c745f21f5dc);
$parcel$export($077cadf07a74900e$exports, "encodeSyncState", () => $077cadf07a74900e$export$5bc395804aa8bae4);
$parcel$export($077cadf07a74900e$exports, "exportSyncState", () => $077cadf07a74900e$export$43b66e793be9a3ae);
$parcel$export($077cadf07a74900e$exports, "importSyncState", () => $077cadf07a74900e$export$2c8b90bb1097a027);
$parcel$export($077cadf07a74900e$exports, "initSyncState", () => $077cadf07a74900e$export$b43d8a335ef7c02a);
$parcel$export($077cadf07a74900e$exports, "load", () => $077cadf07a74900e$export$11e63f7b0f3d9900);
$parcel$export($077cadf07a74900e$exports, "readBundle", () => $077cadf07a74900e$export$27be6a0b6df0f841);
$parcel$export($077cadf07a74900e$exports, "wasmReleaseInfo", () => $077cadf07a74900e$export$72a9b94654c4937c);
$parcel$export($077cadf07a74900e$exports, "initSync", () => $077cadf07a74900e$export$2ec80ee76a9348bf);
$parcel$export($077cadf07a74900e$exports, "default", () => $077cadf07a74900e$export$2e2bcd8739ae039);
/* @ts-self-types="./automerge_wasm.d.ts" */ class $077cadf07a74900e$export$77262bb0ea2cab57 {
    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create($077cadf07a74900e$export$77262bb0ea2cab57.prototype);
        obj.__wbg_ptr = ptr;
        $077cadf07a74900e$var$AutomergeFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        $077cadf07a74900e$var$AutomergeFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        $077cadf07a74900e$var$wasm.__wbg_automerge_free(ptr, 0);
    }
    /**
     * @param {any} object
     * @param {any} meta
     * @returns {any}
     */ applyAndReturnPatches(object, meta) {
        const ret = $077cadf07a74900e$var$wasm.automerge_applyAndReturnPatches(this.__wbg_ptr, object, meta);
        if (ret[2]) throw $077cadf07a74900e$var$takeFromExternrefTable0(ret[1]);
        return $077cadf07a74900e$var$takeFromExternrefTable0(ret[0]);
    }
    /**
     * @param {Change[]} changes
     */ applyChanges(changes) {
        const ret = $077cadf07a74900e$var$wasm.automerge_applyChanges(this.__wbg_ptr, changes);
        if (ret[1]) throw $077cadf07a74900e$var$takeFromExternrefTable0(ret[0]);
    }
    /**
     * @param {any} object
     * @param {any} meta
     * @returns {any}
     */ applyPatches(object, meta) {
        const ret = $077cadf07a74900e$var$wasm.automerge_applyPatches(this.__wbg_ptr, object, meta);
        if (ret[2]) throw $077cadf07a74900e$var$takeFromExternrefTable0(ret[1]);
        return $077cadf07a74900e$var$takeFromExternrefTable0(ret[0]);
    }
    /**
     * @param {string | null} [actor]
     * @returns {Automerge}
     */ clone(actor) {
        var ptr0 = $077cadf07a74900e$var$isLikeNone(actor) ? 0 : $077cadf07a74900e$var$passStringToWasm0(actor, $077cadf07a74900e$var$wasm.__wbindgen_malloc, $077cadf07a74900e$var$wasm.__wbindgen_realloc);
        var len0 = $077cadf07a74900e$var$WASM_VECTOR_LEN;
        const ret = $077cadf07a74900e$var$wasm.automerge_clone(this.__wbg_ptr, ptr0, len0);
        if (ret[2]) throw $077cadf07a74900e$var$takeFromExternrefTable0(ret[1]);
        return $077cadf07a74900e$export$77262bb0ea2cab57.__wrap(ret[0]);
    }
    /**
     * @param {string | null} [message]
     * @param {number | null} [time]
     * @returns {Hash | null}
     */ commit(message, time) {
        var ptr0 = $077cadf07a74900e$var$isLikeNone(message) ? 0 : $077cadf07a74900e$var$passStringToWasm0(message, $077cadf07a74900e$var$wasm.__wbindgen_malloc, $077cadf07a74900e$var$wasm.__wbindgen_realloc);
        var len0 = $077cadf07a74900e$var$WASM_VECTOR_LEN;
        const ret = $077cadf07a74900e$var$wasm.automerge_commit(this.__wbg_ptr, ptr0, len0, !$077cadf07a74900e$var$isLikeNone(time), $077cadf07a74900e$var$isLikeNone(time) ? 0 : time);
        return ret;
    }
    /**
     * @param {ObjID} obj
     * @param {Prop} prop
     */ delete(obj, prop) {
        const ret = $077cadf07a74900e$var$wasm.automerge_delete(this.__wbg_ptr, obj, prop);
        if (ret[1]) throw $077cadf07a74900e$var$takeFromExternrefTable0(ret[0]);
    }
    /**
     * @param {Heads} before
     * @param {Heads} after
     * @returns {Patch[]}
     */ diff(before, after) {
        const ret = $077cadf07a74900e$var$wasm.automerge_diff(this.__wbg_ptr, before, after);
        if (ret[2]) throw $077cadf07a74900e$var$takeFromExternrefTable0(ret[1]);
        return $077cadf07a74900e$var$takeFromExternrefTable0(ret[0]);
    }
    /**
     * @returns {Patch[]}
     */ diffIncremental() {
        const ret = $077cadf07a74900e$var$wasm.automerge_diffIncremental(this.__wbg_ptr);
        if (ret[2]) throw $077cadf07a74900e$var$takeFromExternrefTable0(ret[1]);
        return $077cadf07a74900e$var$takeFromExternrefTable0(ret[0]);
    }
    /**
     * @param {Prop[] | string} path
     * @param {Heads} before
     * @param {Heads} after
     * @param {any} options
     * @returns {Array<any>}
     */ diffPath(path, before, after, options) {
        const ret = $077cadf07a74900e$var$wasm.automerge_diffPath(this.__wbg_ptr, path, before, after, options);
        if (ret[2]) throw $077cadf07a74900e$var$takeFromExternrefTable0(ret[1]);
        return $077cadf07a74900e$var$takeFromExternrefTable0(ret[0]);
    }
    dump() {
        $077cadf07a74900e$var$wasm.automerge_dump(this.__wbg_ptr);
    }
    /**
     * @param {string | null} [message]
     * @param {number | null} [time]
     * @returns {Hash}
     */ emptyChange(message, time) {
        var ptr0 = $077cadf07a74900e$var$isLikeNone(message) ? 0 : $077cadf07a74900e$var$passStringToWasm0(message, $077cadf07a74900e$var$wasm.__wbindgen_malloc, $077cadf07a74900e$var$wasm.__wbindgen_realloc);
        var len0 = $077cadf07a74900e$var$WASM_VECTOR_LEN;
        const ret = $077cadf07a74900e$var$wasm.automerge_emptyChange(this.__wbg_ptr, ptr0, len0, !$077cadf07a74900e$var$isLikeNone(time), $077cadf07a74900e$var$isLikeNone(time) ? 0 : time);
        return ret;
    }
    /**
     * @param {boolean} enable
     * @returns {boolean}
     */ enableFreeze(enable) {
        const ret = $077cadf07a74900e$var$wasm.automerge_enableFreeze(this.__wbg_ptr, enable);
        if (ret[2]) throw $077cadf07a74900e$var$takeFromExternrefTable0(ret[1]);
        return ret[0] !== 0;
    }
    /**
     * @param {string | null | undefined} actor
     * @param {any} heads
     * @returns {Automerge}
     */ fork(actor, heads) {
        var ptr0 = $077cadf07a74900e$var$isLikeNone(actor) ? 0 : $077cadf07a74900e$var$passStringToWasm0(actor, $077cadf07a74900e$var$wasm.__wbindgen_malloc, $077cadf07a74900e$var$wasm.__wbindgen_realloc);
        var len0 = $077cadf07a74900e$var$WASM_VECTOR_LEN;
        const ret = $077cadf07a74900e$var$wasm.automerge_fork(this.__wbg_ptr, ptr0, len0, heads);
        if (ret[2]) throw $077cadf07a74900e$var$takeFromExternrefTable0(ret[1]);
        return $077cadf07a74900e$export$77262bb0ea2cab57.__wrap(ret[0]);
    }
    /**
     * @param {SyncState} state
     * @returns {SyncMessage | null}
     */ generateSyncMessage(state) {
        $077cadf07a74900e$var$_assertClass(state, $077cadf07a74900e$export$8c8eabe8748e941e);
        const ret = $077cadf07a74900e$var$wasm.automerge_generateSyncMessage(this.__wbg_ptr, state.__wbg_ptr);
        return ret;
    }
    /**
     * @param {any} obj
     * @param {any} prop
     * @param {any} heads
     * @returns {any}
     */ get(obj, prop, heads) {
        const ret = $077cadf07a74900e$var$wasm.automerge_get(this.__wbg_ptr, obj, prop, heads);
        if (ret[2]) throw $077cadf07a74900e$var$takeFromExternrefTable0(ret[1]);
        return $077cadf07a74900e$var$takeFromExternrefTable0(ret[0]);
    }
    /**
     * @returns {Actor}
     */ getActorId() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = $077cadf07a74900e$var$wasm.automerge_getActorId(this.__wbg_ptr);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return $077cadf07a74900e$var$getStringFromWasm0(ret[0], ret[1]);
        } finally{
            $077cadf07a74900e$var$wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @param {any} obj
     * @param {any} arg
     * @param {any} heads
     * @returns {Array<any>}
     */ getAll(obj, arg, heads) {
        const ret = $077cadf07a74900e$var$wasm.automerge_getAll(this.__wbg_ptr, obj, arg, heads);
        if (ret[2]) throw $077cadf07a74900e$var$takeFromExternrefTable0(ret[1]);
        return $077cadf07a74900e$var$takeFromExternrefTable0(ret[0]);
    }
    /**
     * @param {any} text
     * @param {number} index
     * @param {any} heads
     * @returns {any}
     */ getBlock(text, index, heads) {
        const ret = $077cadf07a74900e$var$wasm.automerge_getBlock(this.__wbg_ptr, text, index, heads);
        if (ret[2]) throw $077cadf07a74900e$var$takeFromExternrefTable0(ret[1]);
        return $077cadf07a74900e$var$takeFromExternrefTable0(ret[0]);
    }
    /**
     * @param {Hash} hash
     * @returns {Change | null}
     */ getChangeByHash(hash) {
        const ret = $077cadf07a74900e$var$wasm.automerge_getChangeByHash(this.__wbg_ptr, hash);
        if (ret[2]) throw $077cadf07a74900e$var$takeFromExternrefTable0(ret[1]);
        return $077cadf07a74900e$var$takeFromExternrefTable0(ret[0]);
    }
    /**
     * @param {Hash} hash
     * @returns {ChangeMetadata | null}
     */ getChangeMetaByHash(hash) {
        const ret = $077cadf07a74900e$var$wasm.automerge_getChangeMetaByHash(this.__wbg_ptr, hash);
        if (ret[2]) throw $077cadf07a74900e$var$takeFromExternrefTable0(ret[1]);
        return $077cadf07a74900e$var$takeFromExternrefTable0(ret[0]);
    }
    /**
     * @param {Heads} have_deps
     * @returns {Change[]}
     */ getChanges(have_deps) {
        const ret = $077cadf07a74900e$var$wasm.automerge_getChanges(this.__wbg_ptr, have_deps);
        if (ret[2]) throw $077cadf07a74900e$var$takeFromExternrefTable0(ret[1]);
        return $077cadf07a74900e$var$takeFromExternrefTable0(ret[0]);
    }
    /**
     * @param {Automerge} other
     * @returns {Change[]}
     */ getChangesAdded(other) {
        $077cadf07a74900e$var$_assertClass(other, $077cadf07a74900e$export$77262bb0ea2cab57);
        const ret = $077cadf07a74900e$var$wasm.automerge_getChangesAdded(this.__wbg_ptr, other.__wbg_ptr);
        return ret;
    }
    /**
     * @param {Heads} have_deps
     * @returns {ChangeMetadata[]}
     */ getChangesMeta(have_deps) {
        const ret = $077cadf07a74900e$var$wasm.automerge_getChangesMeta(this.__wbg_ptr, have_deps);
        if (ret[2]) throw $077cadf07a74900e$var$takeFromExternrefTable0(ret[1]);
        return $077cadf07a74900e$var$takeFromExternrefTable0(ret[0]);
    }
    /**
     * @param {any} obj
     * @param {any} position
     * @param {any} heads
     * @param {any} move_cursor
     * @returns {string}
     */ getCursor(obj, position, heads, move_cursor) {
        let deferred2_0;
        let deferred2_1;
        try {
            const ret = $077cadf07a74900e$var$wasm.automerge_getCursor(this.__wbg_ptr, obj, position, heads, move_cursor);
            var ptr1 = ret[0];
            var len1 = ret[1];
            if (ret[3]) {
                ptr1 = 0;
                len1 = 0;
                throw $077cadf07a74900e$var$takeFromExternrefTable0(ret[2]);
            }
            deferred2_0 = ptr1;
            deferred2_1 = len1;
            return $077cadf07a74900e$var$getStringFromWasm0(ptr1, len1);
        } finally{
            $077cadf07a74900e$var$wasm.__wbindgen_free(deferred2_0, deferred2_1, 1);
        }
    }
    /**
     * @param {any} obj
     * @param {any} cursor
     * @param {any} heads
     * @returns {number}
     */ getCursorPosition(obj, cursor, heads) {
        const ret = $077cadf07a74900e$var$wasm.automerge_getCursorPosition(this.__wbg_ptr, obj, cursor, heads);
        if (ret[2]) throw $077cadf07a74900e$var$takeFromExternrefTable0(ret[1]);
        return ret[0];
    }
    /**
     * @param {Hash} hash
     * @returns {DecodedChange | null}
     */ getDecodedChangeByHash(hash) {
        const ret = $077cadf07a74900e$var$wasm.automerge_getDecodedChangeByHash(this.__wbg_ptr, hash);
        if (ret[2]) throw $077cadf07a74900e$var$takeFromExternrefTable0(ret[1]);
        return $077cadf07a74900e$var$takeFromExternrefTable0(ret[0]);
    }
    /**
     * @returns {Heads}
     */ getHeads() {
        const ret = $077cadf07a74900e$var$wasm.automerge_getHeads(this.__wbg_ptr);
        return ret;
    }
    /**
     * @returns {Change | null}
     */ getLastLocalChange() {
        const ret = $077cadf07a74900e$var$wasm.automerge_getLastLocalChange(this.__wbg_ptr);
        return ret;
    }
    /**
     * @param {any} heads
     * @returns {Array<any>}
     */ getMissingDeps(heads) {
        const ret = $077cadf07a74900e$var$wasm.automerge_getMissingDeps(this.__wbg_ptr, heads);
        if (ret[2]) throw $077cadf07a74900e$var$takeFromExternrefTable0(ret[1]);
        return $077cadf07a74900e$var$takeFromExternrefTable0(ret[0]);
    }
    /**
     * @param {any} obj
     * @param {any} prop
     * @param {any} heads
     * @returns {any}
     */ getWithType(obj, prop, heads) {
        const ret = $077cadf07a74900e$var$wasm.automerge_getWithType(this.__wbg_ptr, obj, prop, heads);
        if (ret[2]) throw $077cadf07a74900e$var$takeFromExternrefTable0(ret[1]);
        return $077cadf07a74900e$var$takeFromExternrefTable0(ret[0]);
    }
    /**
     * @param {SyncState} state
     * @returns {boolean}
     */ hasOurChanges(state) {
        $077cadf07a74900e$var$_assertClass(state, $077cadf07a74900e$export$8c8eabe8748e941e);
        const ret = $077cadf07a74900e$var$wasm.automerge_hasOurChanges(this.__wbg_ptr, state.__wbg_ptr);
        return ret !== 0;
    }
    /**
     * @param {ObjID} obj
     * @param {Prop} prop
     * @param {number} value
     */ increment(obj, prop, value) {
        const ret = $077cadf07a74900e$var$wasm.automerge_increment(this.__wbg_ptr, obj, prop, value);
        if (ret[1]) throw $077cadf07a74900e$var$takeFromExternrefTable0(ret[0]);
    }
    /**
     * @param {any} obj
     * @param {number} index
     * @param {any} value
     * @param {any} datatype
     */ insert(obj, index, value, datatype) {
        const ret = $077cadf07a74900e$var$wasm.automerge_insert(this.__wbg_ptr, obj, index, value, datatype);
        if (ret[1]) throw $077cadf07a74900e$var$takeFromExternrefTable0(ret[0]);
    }
    /**
     * @param {ObjID} obj
     * @param {number} index
     * @param {ObjType} value
     * @returns {ObjID}
     */ insertObject(obj, index, value) {
        let deferred2_0;
        let deferred2_1;
        try {
            const ret = $077cadf07a74900e$var$wasm.automerge_insertObject(this.__wbg_ptr, obj, index, value);
            var ptr1 = ret[0];
            var len1 = ret[1];
            if (ret[3]) {
                ptr1 = 0;
                len1 = 0;
                throw $077cadf07a74900e$var$takeFromExternrefTable0(ret[2]);
            }
            deferred2_0 = ptr1;
            deferred2_1 = len1;
            return $077cadf07a74900e$var$getStringFromWasm0(ptr1, len1);
        } finally{
            $077cadf07a74900e$var$wasm.__wbindgen_free(deferred2_0, deferred2_1, 1);
        }
    }
    integrate() {
        $077cadf07a74900e$var$wasm.automerge_integrate(this.__wbg_ptr);
    }
    /**
     * @param {Heads} heads
     */ isolate(heads) {
        const ret = $077cadf07a74900e$var$wasm.automerge_isolate(this.__wbg_ptr, heads);
        if (ret[1]) throw $077cadf07a74900e$var$takeFromExternrefTable0(ret[0]);
    }
    /**
     * @param {ObjID} obj
     * @param {number} index
     */ joinBlock(obj, index) {
        const ret = $077cadf07a74900e$var$wasm.automerge_joinBlock(this.__wbg_ptr, obj, index);
        if (ret[1]) throw $077cadf07a74900e$var$takeFromExternrefTable0(ret[0]);
    }
    /**
     * @param {any} obj
     * @param {any} heads
     * @returns {Array<any>}
     */ keys(obj, heads) {
        const ret = $077cadf07a74900e$var$wasm.automerge_keys(this.__wbg_ptr, obj, heads);
        if (ret[2]) throw $077cadf07a74900e$var$takeFromExternrefTable0(ret[1]);
        return $077cadf07a74900e$var$takeFromExternrefTable0(ret[0]);
    }
    /**
     * @param {any} obj
     * @param {any} heads
     * @returns {number}
     */ length(obj, heads) {
        const ret = $077cadf07a74900e$var$wasm.automerge_length(this.__wbg_ptr, obj, heads);
        if (ret[2]) throw $077cadf07a74900e$var$takeFromExternrefTable0(ret[1]);
        return ret[0];
    }
    /**
     * @param {Uint8Array} data
     * @returns {number}
     */ loadIncremental(data) {
        const ret = $077cadf07a74900e$var$wasm.automerge_loadIncremental(this.__wbg_ptr, data);
        if (ret[2]) throw $077cadf07a74900e$var$takeFromExternrefTable0(ret[1]);
        return ret[0];
    }
    /**
     * @param {any} obj
     * @param {any} range
     * @param {any} name
     * @param {any} value
     * @param {any} datatype
     */ mark(obj, range, name, value, datatype) {
        const ret = $077cadf07a74900e$var$wasm.automerge_mark(this.__wbg_ptr, obj, range, name, value, datatype);
        if (ret[1]) throw $077cadf07a74900e$var$takeFromExternrefTable0(ret[0]);
    }
    /**
     * @param {any} obj
     * @param {any} heads
     * @returns {any}
     */ marks(obj, heads) {
        const ret = $077cadf07a74900e$var$wasm.automerge_marks(this.__wbg_ptr, obj, heads);
        if (ret[2]) throw $077cadf07a74900e$var$takeFromExternrefTable0(ret[1]);
        return $077cadf07a74900e$var$takeFromExternrefTable0(ret[0]);
    }
    /**
     * @param {any} obj
     * @param {number} index
     * @param {any} heads
     * @returns {object}
     */ marksAt(obj, index, heads) {
        const ret = $077cadf07a74900e$var$wasm.automerge_marksAt(this.__wbg_ptr, obj, index, heads);
        if (ret[2]) throw $077cadf07a74900e$var$takeFromExternrefTable0(ret[1]);
        return $077cadf07a74900e$var$takeFromExternrefTable0(ret[0]);
    }
    /**
     * @param {any} obj
     * @param {any} heads
     * @param {any} meta
     * @returns {any}
     */ materialize(obj, heads, meta) {
        const ret = $077cadf07a74900e$var$wasm.automerge_materialize(this.__wbg_ptr, obj, heads, meta);
        if (ret[2]) throw $077cadf07a74900e$var$takeFromExternrefTable0(ret[1]);
        return $077cadf07a74900e$var$takeFromExternrefTable0(ret[0]);
    }
    /**
     * @param {Automerge} other
     * @returns {Heads}
     */ merge(other) {
        $077cadf07a74900e$var$_assertClass(other, $077cadf07a74900e$export$77262bb0ea2cab57);
        const ret = $077cadf07a74900e$var$wasm.automerge_merge(this.__wbg_ptr, other.__wbg_ptr);
        if (ret[2]) throw $077cadf07a74900e$var$takeFromExternrefTable0(ret[1]);
        return $077cadf07a74900e$var$takeFromExternrefTable0(ret[0]);
    }
    /**
     * @param {string | null} [actor]
     * @returns {Automerge}
     */ static new(actor) {
        var ptr0 = $077cadf07a74900e$var$isLikeNone(actor) ? 0 : $077cadf07a74900e$var$passStringToWasm0(actor, $077cadf07a74900e$var$wasm.__wbindgen_malloc, $077cadf07a74900e$var$wasm.__wbindgen_realloc);
        var len0 = $077cadf07a74900e$var$WASM_VECTOR_LEN;
        const ret = $077cadf07a74900e$var$wasm.automerge_new(ptr0, len0);
        if (ret[2]) throw $077cadf07a74900e$var$takeFromExternrefTable0(ret[1]);
        return $077cadf07a74900e$export$77262bb0ea2cab57.__wrap(ret[0]);
    }
    /**
     * @param {any} obj
     * @param {any} heads
     * @returns {object}
     */ objInfo(obj, heads) {
        const ret = $077cadf07a74900e$var$wasm.automerge_objInfo(this.__wbg_ptr, obj, heads);
        if (ret[2]) throw $077cadf07a74900e$var$takeFromExternrefTable0(ret[1]);
        return $077cadf07a74900e$var$takeFromExternrefTable0(ret[0]);
    }
    /**
     * @returns {number}
     */ pendingOps() {
        const ret = $077cadf07a74900e$var$wasm.automerge_pendingOps(this.__wbg_ptr);
        return ret;
    }
    /**
     * @param {any} obj
     * @param {any} value
     * @param {any} datatype
     */ push(obj, value, datatype) {
        const ret = $077cadf07a74900e$var$wasm.automerge_push(this.__wbg_ptr, obj, value, datatype);
        if (ret[1]) throw $077cadf07a74900e$var$takeFromExternrefTable0(ret[0]);
    }
    /**
     * @param {ObjID} obj
     * @param {ObjType} value
     * @returns {ObjID}
     */ pushObject(obj, value) {
        let deferred2_0;
        let deferred2_1;
        try {
            const ret = $077cadf07a74900e$var$wasm.automerge_pushObject(this.__wbg_ptr, obj, value);
            var ptr1 = ret[0];
            var len1 = ret[1];
            if (ret[3]) {
                ptr1 = 0;
                len1 = 0;
                throw $077cadf07a74900e$var$takeFromExternrefTable0(ret[2]);
            }
            deferred2_0 = ptr1;
            deferred2_1 = len1;
            return $077cadf07a74900e$var$getStringFromWasm0(ptr1, len1);
        } finally{
            $077cadf07a74900e$var$wasm.__wbindgen_free(deferred2_0, deferred2_1, 1);
        }
    }
    /**
     * @param {any} obj
     * @param {any} prop
     * @param {any} value
     * @param {any} datatype
     */ put(obj, prop, value, datatype) {
        const ret = $077cadf07a74900e$var$wasm.automerge_put(this.__wbg_ptr, obj, prop, value, datatype);
        if (ret[1]) throw $077cadf07a74900e$var$takeFromExternrefTable0(ret[0]);
    }
    /**
     * @param {ObjID} obj
     * @param {Prop} prop
     * @param {ObjType} value
     * @returns {ObjID}
     */ putObject(obj, prop, value) {
        const ret = $077cadf07a74900e$var$wasm.automerge_putObject(this.__wbg_ptr, obj, prop, value);
        if (ret[2]) throw $077cadf07a74900e$var$takeFromExternrefTable0(ret[1]);
        return $077cadf07a74900e$var$takeFromExternrefTable0(ret[0]);
    }
    /**
     * @param {SyncState} state
     * @param {SyncMessage} message
     */ receiveSyncMessage(state, message) {
        $077cadf07a74900e$var$_assertClass(state, $077cadf07a74900e$export$8c8eabe8748e941e);
        const ret = $077cadf07a74900e$var$wasm.automerge_receiveSyncMessage(this.__wbg_ptr, state.__wbg_ptr, message);
        if (ret[1]) throw $077cadf07a74900e$var$takeFromExternrefTable0(ret[0]);
    }
    /**
     * @param {string} datatype
     * @param {Function} construct
     * @param {(arg: any) => any | undefined} deconstruct
     */ registerDatatype(datatype, construct, deconstruct) {
        const ret = $077cadf07a74900e$var$wasm.automerge_registerDatatype(this.__wbg_ptr, datatype, construct, deconstruct);
        if (ret[1]) throw $077cadf07a74900e$var$takeFromExternrefTable0(ret[0]);
    }
    resetDiffCursor() {
        $077cadf07a74900e$var$wasm.automerge_resetDiffCursor(this.__wbg_ptr);
    }
    /**
     * @returns {number}
     */ rollback() {
        const ret = $077cadf07a74900e$var$wasm.automerge_rollback(this.__wbg_ptr);
        return ret;
    }
    /**
     * @returns {Uint8Array}
     */ save() {
        const ret = $077cadf07a74900e$var$wasm.automerge_save(this.__wbg_ptr);
        return ret;
    }
    /**
     * @returns {Uint8Array}
     */ saveAndVerify() {
        const ret = $077cadf07a74900e$var$wasm.automerge_saveAndVerify(this.__wbg_ptr);
        if (ret[2]) throw $077cadf07a74900e$var$takeFromExternrefTable0(ret[1]);
        return $077cadf07a74900e$var$takeFromExternrefTable0(ret[0]);
    }
    /**
     * @param {any} hashes
     * @returns {Uint8Array}
     */ saveBundle(hashes) {
        const ret = $077cadf07a74900e$var$wasm.automerge_saveBundle(this.__wbg_ptr, hashes);
        if (ret[2]) throw $077cadf07a74900e$var$takeFromExternrefTable0(ret[1]);
        return $077cadf07a74900e$var$takeFromExternrefTable0(ret[0]);
    }
    /**
     * @returns {Uint8Array}
     */ saveIncremental() {
        const ret = $077cadf07a74900e$var$wasm.automerge_saveIncremental(this.__wbg_ptr);
        return ret;
    }
    /**
     * @returns {Uint8Array}
     */ saveNoCompress() {
        const ret = $077cadf07a74900e$var$wasm.automerge_saveNoCompress(this.__wbg_ptr);
        return ret;
    }
    /**
     * @param {Heads} heads
     * @returns {Uint8Array}
     */ saveSince(heads) {
        const ret = $077cadf07a74900e$var$wasm.automerge_saveSince(this.__wbg_ptr, heads);
        if (ret[2]) throw $077cadf07a74900e$var$takeFromExternrefTable0(ret[1]);
        return $077cadf07a74900e$var$takeFromExternrefTable0(ret[0]);
    }
    /**
     * @param {any} obj
     * @param {any} heads
     * @returns {Array<any>}
     */ spans(obj, heads) {
        const ret = $077cadf07a74900e$var$wasm.automerge_spans(this.__wbg_ptr, obj, heads);
        if (ret[2]) throw $077cadf07a74900e$var$takeFromExternrefTable0(ret[1]);
        return $077cadf07a74900e$var$takeFromExternrefTable0(ret[0]);
    }
    /**
     * @param {any} obj
     * @param {number} start
     * @param {number} delete_count
     * @param {any} text
     */ splice(obj, start, delete_count, text) {
        const ret = $077cadf07a74900e$var$wasm.automerge_splice(this.__wbg_ptr, obj, start, delete_count, text);
        if (ret[1]) throw $077cadf07a74900e$var$takeFromExternrefTable0(ret[0]);
    }
    /**
     * @param {ObjID} obj
     * @param {number} index
     * @param {{[key: string]: MaterializeValue}} block
     */ splitBlock(obj, index, block) {
        const ret = $077cadf07a74900e$var$wasm.automerge_splitBlock(this.__wbg_ptr, obj, index, block);
        if (ret[1]) throw $077cadf07a74900e$var$takeFromExternrefTable0(ret[0]);
    }
    /**
     * @returns {Stats}
     */ stats() {
        const ret = $077cadf07a74900e$var$wasm.automerge_stats(this.__wbg_ptr);
        return ret;
    }
    /**
     * @param {any} obj
     * @param {any} heads
     * @returns {string}
     */ text(obj, heads) {
        let deferred2_0;
        let deferred2_1;
        try {
            const ret = $077cadf07a74900e$var$wasm.automerge_text(this.__wbg_ptr, obj, heads);
            var ptr1 = ret[0];
            var len1 = ret[1];
            if (ret[3]) {
                ptr1 = 0;
                len1 = 0;
                throw $077cadf07a74900e$var$takeFromExternrefTable0(ret[2]);
            }
            deferred2_0 = ptr1;
            deferred2_1 = len1;
            return $077cadf07a74900e$var$getStringFromWasm0(ptr1, len1);
        } finally{
            $077cadf07a74900e$var$wasm.__wbindgen_free(deferred2_0, deferred2_1, 1);
        }
    }
    /**
     * @param {any} meta
     * @returns {MaterializeValue}
     */ toJS(meta) {
        const ret = $077cadf07a74900e$var$wasm.automerge_toJS(this.__wbg_ptr, meta);
        if (ret[2]) throw $077cadf07a74900e$var$takeFromExternrefTable0(ret[1]);
        return $077cadf07a74900e$var$takeFromExternrefTable0(ret[0]);
    }
    /**
     * @returns {Hash[]}
     */ topoHistoryTraversal() {
        const ret = $077cadf07a74900e$var$wasm.automerge_topoHistoryTraversal(this.__wbg_ptr);
        return ret;
    }
    /**
     * @param {ObjID} obj
     * @param {MarkRange} range
     * @param {string} name
     */ unmark(obj, range, name) {
        const ret = $077cadf07a74900e$var$wasm.automerge_unmark(this.__wbg_ptr, obj, range, name);
        if (ret[1]) throw $077cadf07a74900e$var$takeFromExternrefTable0(ret[0]);
    }
    /**
     * @param {ObjID} obj
     * @param {number} index
     * @param {{[key: string]: MaterializeValue}} block
     */ updateBlock(obj, index, block) {
        const ret = $077cadf07a74900e$var$wasm.automerge_updateBlock(this.__wbg_ptr, obj, index, block);
        if (ret[1]) throw $077cadf07a74900e$var$takeFromExternrefTable0(ret[0]);
    }
    updateDiffCursor() {
        $077cadf07a74900e$var$wasm.automerge_updateDiffCursor(this.__wbg_ptr);
    }
    /**
     * @param {ObjID} obj
     * @param {Span[]} args
     * @param {UpdateSpansConfig | undefined | null} config
     */ updateSpans(obj, args, config) {
        const ret = $077cadf07a74900e$var$wasm.automerge_updateSpans(this.__wbg_ptr, obj, args, config);
        if (ret[1]) throw $077cadf07a74900e$var$takeFromExternrefTable0(ret[0]);
    }
    /**
     * @param {ObjID} obj
     * @param {string} new_text
     */ updateText(obj, new_text) {
        const ret = $077cadf07a74900e$var$wasm.automerge_updateText(this.__wbg_ptr, obj, new_text);
        if (ret[1]) throw $077cadf07a74900e$var$takeFromExternrefTable0(ret[0]);
    }
}
if (Symbol.dispose) $077cadf07a74900e$export$77262bb0ea2cab57.prototype[Symbol.dispose] = $077cadf07a74900e$export$77262bb0ea2cab57.prototype.free;
class $077cadf07a74900e$export$8c8eabe8748e941e {
    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create($077cadf07a74900e$export$8c8eabe8748e941e.prototype);
        obj.__wbg_ptr = ptr;
        $077cadf07a74900e$var$SyncStateFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        $077cadf07a74900e$var$SyncStateFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        $077cadf07a74900e$var$wasm.__wbg_syncstate_free(ptr, 0);
    }
    /**
     * @returns {SyncState}
     */ clone() {
        const ret = $077cadf07a74900e$var$wasm.syncstate_clone(this.__wbg_ptr);
        return $077cadf07a74900e$export$8c8eabe8748e941e.__wrap(ret);
    }
    /**
     * @returns {Heads}
     */ get lastSentHeads() {
        const ret = $077cadf07a74900e$var$wasm.syncstate_lastSentHeads(this.__wbg_ptr);
        return ret;
    }
    /**
     * @param {Heads} heads
     */ set lastSentHeads(heads) {
        const ret = $077cadf07a74900e$var$wasm.syncstate_set_lastSentHeads(this.__wbg_ptr, heads);
        if (ret[1]) throw $077cadf07a74900e$var$takeFromExternrefTable0(ret[0]);
    }
    /**
     * @param {Heads} hashes
     */ set sentHashes(hashes) {
        const ret = $077cadf07a74900e$var$wasm.syncstate_set_sentHashes(this.__wbg_ptr, hashes);
        if (ret[1]) throw $077cadf07a74900e$var$takeFromExternrefTable0(ret[0]);
    }
    /**
     * @returns {Heads}
     */ get sharedHeads() {
        const ret = $077cadf07a74900e$var$wasm.syncstate_sharedHeads(this.__wbg_ptr);
        return ret;
    }
}
if (Symbol.dispose) $077cadf07a74900e$export$8c8eabe8748e941e.prototype[Symbol.dispose] = $077cadf07a74900e$export$8c8eabe8748e941e.prototype.free;
function $077cadf07a74900e$export$185802fd694ee1f5(options) {
    const ret = $077cadf07a74900e$var$wasm.create(options);
    if (ret[2]) throw $077cadf07a74900e$var$takeFromExternrefTable0(ret[1]);
    return $077cadf07a74900e$export$77262bb0ea2cab57.__wrap(ret[0]);
}
function $077cadf07a74900e$export$5375c324cca37246(change) {
    const ret = $077cadf07a74900e$var$wasm.decodeChange(change);
    if (ret[2]) throw $077cadf07a74900e$var$takeFromExternrefTable0(ret[1]);
    return $077cadf07a74900e$var$takeFromExternrefTable0(ret[0]);
}
function $077cadf07a74900e$export$f4fe23b15e41e0e4(msg) {
    const ret = $077cadf07a74900e$var$wasm.decodeSyncMessage(msg);
    if (ret[2]) throw $077cadf07a74900e$var$takeFromExternrefTable0(ret[1]);
    return $077cadf07a74900e$var$takeFromExternrefTable0(ret[0]);
}
function $077cadf07a74900e$export$d01db62e8ae92970(data) {
    const ret = $077cadf07a74900e$var$wasm.decodeSyncState(data);
    if (ret[2]) throw $077cadf07a74900e$var$takeFromExternrefTable0(ret[1]);
    return $077cadf07a74900e$export$8c8eabe8748e941e.__wrap(ret[0]);
}
function $077cadf07a74900e$export$18b630b4c065867e(change) {
    const ret = $077cadf07a74900e$var$wasm.encodeChange(change);
    if (ret[2]) throw $077cadf07a74900e$var$takeFromExternrefTable0(ret[1]);
    return $077cadf07a74900e$var$takeFromExternrefTable0(ret[0]);
}
function $077cadf07a74900e$export$48610c745f21f5dc(message) {
    const ret = $077cadf07a74900e$var$wasm.encodeSyncMessage(message);
    if (ret[2]) throw $077cadf07a74900e$var$takeFromExternrefTable0(ret[1]);
    return $077cadf07a74900e$var$takeFromExternrefTable0(ret[0]);
}
function $077cadf07a74900e$export$5bc395804aa8bae4(state) {
    $077cadf07a74900e$var$_assertClass(state, $077cadf07a74900e$export$8c8eabe8748e941e);
    const ret = $077cadf07a74900e$var$wasm.encodeSyncState(state.__wbg_ptr);
    return ret;
}
function $077cadf07a74900e$export$43b66e793be9a3ae(state) {
    $077cadf07a74900e$var$_assertClass(state, $077cadf07a74900e$export$8c8eabe8748e941e);
    const ret = $077cadf07a74900e$var$wasm.exportSyncState(state.__wbg_ptr);
    return ret;
}
function $077cadf07a74900e$export$2c8b90bb1097a027(state) {
    const ret = $077cadf07a74900e$var$wasm.importSyncState(state);
    if (ret[2]) throw $077cadf07a74900e$var$takeFromExternrefTable0(ret[1]);
    return $077cadf07a74900e$export$8c8eabe8748e941e.__wrap(ret[0]);
}
function $077cadf07a74900e$export$b43d8a335ef7c02a() {
    const ret = $077cadf07a74900e$var$wasm.initSyncState();
    return $077cadf07a74900e$export$8c8eabe8748e941e.__wrap(ret);
}
function $077cadf07a74900e$export$11e63f7b0f3d9900(data, options) {
    const ret = $077cadf07a74900e$var$wasm.load(data, options);
    if (ret[2]) throw $077cadf07a74900e$var$takeFromExternrefTable0(ret[1]);
    return $077cadf07a74900e$export$77262bb0ea2cab57.__wrap(ret[0]);
}
function $077cadf07a74900e$export$27be6a0b6df0f841(bundle) {
    const ret = $077cadf07a74900e$var$wasm.readBundle(bundle);
    if (ret[2]) throw $077cadf07a74900e$var$takeFromExternrefTable0(ret[1]);
    return $077cadf07a74900e$var$takeFromExternrefTable0(ret[0]);
}
function $077cadf07a74900e$export$72a9b94654c4937c() {
    const ret = $077cadf07a74900e$var$wasm.wasmReleaseInfo();
    return ret;
}
function $077cadf07a74900e$var$__wbg_get_imports() {
    const import0 = {
        __proto__: null,
        __wbg_BigInt_b7bbccdff258c9f2: function(arg0) {
            const ret = BigInt(arg0);
            return ret;
        },
        __wbg_Error_8c4e43fe74559d73: function(arg0, arg1) {
            const ret = Error($077cadf07a74900e$var$getStringFromWasm0(arg0, arg1));
            return ret;
        },
        __wbg_String_8f0eb39a4a4c2f66: function(arg0, arg1) {
            const ret = String(arg1);
            const ptr1 = $077cadf07a74900e$var$passStringToWasm0(ret, $077cadf07a74900e$var$wasm.__wbindgen_malloc, $077cadf07a74900e$var$wasm.__wbindgen_realloc);
            const len1 = $077cadf07a74900e$var$WASM_VECTOR_LEN;
            $077cadf07a74900e$var$getDataViewMemory0().setInt32(arg0 + 4, len1, true);
            $077cadf07a74900e$var$getDataViewMemory0().setInt32(arg0 + 0, ptr1, true);
        },
        __wbg___wbindgen_boolean_get_bbbb1c18aa2f5e25: function(arg0) {
            const v = arg0;
            const ret = typeof v === 'boolean' ? v : undefined;
            return $077cadf07a74900e$var$isLikeNone(ret) ? 0xFFFFFF : ret ? 1 : 0;
        },
        __wbg___wbindgen_debug_string_0bc8482c6e3508ae: function(arg0, arg1) {
            const ret = $077cadf07a74900e$var$debugString(arg1);
            const ptr1 = $077cadf07a74900e$var$passStringToWasm0(ret, $077cadf07a74900e$var$wasm.__wbindgen_malloc, $077cadf07a74900e$var$wasm.__wbindgen_realloc);
            const len1 = $077cadf07a74900e$var$WASM_VECTOR_LEN;
            $077cadf07a74900e$var$getDataViewMemory0().setInt32(arg0 + 4, len1, true);
            $077cadf07a74900e$var$getDataViewMemory0().setInt32(arg0 + 0, ptr1, true);
        },
        __wbg___wbindgen_gt_d7bb3629eac381f5: function(arg0, arg1) {
            const ret = arg0 > arg1;
            return ret;
        },
        __wbg___wbindgen_is_bigint_31b12575b56f32fc: function(arg0) {
            const ret = typeof arg0 === 'bigint';
            return ret;
        },
        __wbg___wbindgen_is_function_0095a73b8b156f76: function(arg0) {
            const ret = typeof arg0 === 'function';
            return ret;
        },
        __wbg___wbindgen_is_null_ac34f5003991759a: function(arg0) {
            const ret = arg0 === null;
            return ret;
        },
        __wbg___wbindgen_is_object_5ae8e5880f2c1fbd: function(arg0) {
            const val = arg0;
            const ret = typeof val === 'object' && val !== null;
            return ret;
        },
        __wbg___wbindgen_is_string_cd444516edc5b180: function(arg0) {
            const ret = typeof arg0 === 'string';
            return ret;
        },
        __wbg___wbindgen_is_undefined_9e4d92534c42d778: function(arg0) {
            const ret = arg0 === undefined;
            return ret;
        },
        __wbg___wbindgen_jsval_loose_eq_9dd77d8cd6671811: function(arg0, arg1) {
            const ret = arg0 == arg1;
            return ret;
        },
        __wbg___wbindgen_lt_bb59cc3d23526e0d: function(arg0, arg1) {
            const ret = arg0 < arg1;
            return ret;
        },
        __wbg___wbindgen_neg_6b4d356dff49dcc6: function(arg0) {
            const ret = -arg0;
            return ret;
        },
        __wbg___wbindgen_number_get_8ff4255516ccad3e: function(arg0, arg1) {
            const obj = arg1;
            const ret = typeof obj === 'number' ? obj : undefined;
            $077cadf07a74900e$var$getDataViewMemory0().setFloat64(arg0 + 8, $077cadf07a74900e$var$isLikeNone(ret) ? 0 : ret, true);
            $077cadf07a74900e$var$getDataViewMemory0().setInt32(arg0 + 0, !$077cadf07a74900e$var$isLikeNone(ret), true);
        },
        __wbg___wbindgen_string_get_72fb696202c56729: function(arg0, arg1) {
            const obj = arg1;
            const ret = typeof obj === 'string' ? obj : undefined;
            var ptr1 = $077cadf07a74900e$var$isLikeNone(ret) ? 0 : $077cadf07a74900e$var$passStringToWasm0(ret, $077cadf07a74900e$var$wasm.__wbindgen_malloc, $077cadf07a74900e$var$wasm.__wbindgen_realloc);
            var len1 = $077cadf07a74900e$var$WASM_VECTOR_LEN;
            $077cadf07a74900e$var$getDataViewMemory0().setInt32(arg0 + 4, len1, true);
            $077cadf07a74900e$var$getDataViewMemory0().setInt32(arg0 + 0, ptr1, true);
        },
        __wbg___wbindgen_throw_be289d5034ed271b: function(arg0, arg1) {
            throw new Error($077cadf07a74900e$var$getStringFromWasm0(arg0, arg1));
        },
        __wbg_apply_2e22c45cb4f12415: function() {
            return $077cadf07a74900e$var$handleError(function(arg0, arg1, arg2) {
                const ret = Reflect.apply(arg0, arg1, arg2);
                return ret;
            }, arguments);
        },
        __wbg_assign_6170c0d04d5c26f4: function(arg0, arg1) {
            const ret = Object.assign(arg0, arg1);
            return ret;
        },
        __wbg_call_389efe28435a9388: function() {
            return $077cadf07a74900e$var$handleError(function(arg0, arg1) {
                const ret = arg0.call(arg1);
                return ret;
            }, arguments);
        },
        __wbg_call_4708e0c13bdc8e95: function() {
            return $077cadf07a74900e$var$handleError(function(arg0, arg1, arg2) {
                const ret = arg0.call(arg1, arg2);
                return ret;
            }, arguments);
        },
        __wbg_concat_f6e5ebc81f4917f1: function(arg0, arg1) {
            const ret = arg0.concat(arg1);
            return ret;
        },
        __wbg_defineProperty_fc8692a66be8fe2d: function(arg0, arg1, arg2) {
            const ret = Object.defineProperty(arg0, arg1, arg2);
            return ret;
        },
        __wbg_deleteProperty_8c8a05da881fea59: function() {
            return $077cadf07a74900e$var$handleError(function(arg0, arg1) {
                const ret = Reflect.deleteProperty(arg0, arg1);
                return ret;
            }, arguments);
        },
        __wbg_done_57b39ecd9addfe81: function(arg0) {
            const ret = arg0.done;
            return ret;
        },
        __wbg_entries_58c7934c745daac7: function(arg0) {
            const ret = Object.entries(arg0);
            return ret;
        },
        __wbg_error_7534b8e9a36f1ab4: function(arg0, arg1) {
            let deferred0_0;
            let deferred0_1;
            try {
                deferred0_0 = arg0;
                deferred0_1 = arg1;
                console.error($077cadf07a74900e$var$getStringFromWasm0(arg0, arg1));
            } finally{
                $077cadf07a74900e$var$wasm.__wbindgen_free(deferred0_0, deferred0_1, 1);
            }
        },
        __wbg_for_c3adefd268cb6f1c: function(arg0, arg1) {
            const ret = Symbol.for($077cadf07a74900e$var$getStringFromWasm0(arg0, arg1));
            return ret;
        },
        __wbg_freeze_661d9047fd889cd0: function(arg0) {
            const ret = Object.freeze(arg0);
            return ret;
        },
        __wbg_from_bddd64e7d5ff6941: function(arg0) {
            const ret = Array.from(arg0);
            return ret;
        },
        __wbg_getRandomValues_1c61fac11405ffdc: function() {
            return $077cadf07a74900e$var$handleError(function(arg0, arg1) {
                globalThis.crypto.getRandomValues($077cadf07a74900e$var$getArrayU8FromWasm0(arg0, arg1));
            }, arguments);
        },
        __wbg_getTime_1e3cd1391c5c3995: function(arg0) {
            const ret = arg0.getTime();
            return ret;
        },
        __wbg_get_9b94d73e6221f75c: function(arg0, arg1) {
            const ret = arg0[arg1 >>> 0];
            return ret;
        },
        __wbg_get_b3ed3ad4be2bc8ac: function() {
            return $077cadf07a74900e$var$handleError(function(arg0, arg1) {
                const ret = Reflect.get(arg0, arg1);
                return ret;
            }, arguments);
        },
        __wbg_instanceof_ArrayBuffer_c367199e2fa2aa04: function(arg0) {
            let result;
            try {
                result = arg0 instanceof ArrayBuffer;
            } catch (_) {
                result = false;
            }
            const ret = result;
            return ret;
        },
        __wbg_instanceof_Date_1b9f15b87f10aa4c: function(arg0) {
            let result;
            try {
                result = arg0 instanceof Date;
            } catch (_) {
                result = false;
            }
            const ret = result;
            return ret;
        },
        __wbg_instanceof_Object_1c6af87502b733ed: function(arg0) {
            let result;
            try {
                result = arg0 instanceof Object;
            } catch (_) {
                result = false;
            }
            const ret = result;
            return ret;
        },
        __wbg_instanceof_Uint8Array_9b9075935c74707c: function(arg0) {
            let result;
            try {
                result = arg0 instanceof Uint8Array;
            } catch (_) {
                result = false;
            }
            const ret = result;
            return ret;
        },
        __wbg_isArray_a2cef7634fcb7c0d: function(arg0) {
            const ret = Array.isArray(arg0);
            return ret;
        },
        __wbg_isArray_d314bb98fcf08331: function(arg0) {
            const ret = Array.isArray(arg0);
            return ret;
        },
        __wbg_iterator_6ff6560ca1568e55: function() {
            const ret = Symbol.iterator;
            return ret;
        },
        __wbg_keys_b50a709a76add04e: function(arg0) {
            const ret = Object.keys(arg0);
            return ret;
        },
        __wbg_length_32ed9a279acd054c: function(arg0) {
            const ret = arg0.length;
            return ret;
        },
        __wbg_length_35a7bace40f36eac: function(arg0) {
            const ret = arg0.length;
            return ret;
        },
        __wbg_length_68dc7c5cf1b6d349: function(arg0) {
            const ret = arg0.length;
            return ret;
        },
        __wbg_log_6b5ca2e6124b2808: function(arg0) {
            console.log(arg0);
        },
        __wbg_log_b948c93e3e66d64f: function(arg0, arg1) {
            console.log(arg0, arg1);
        },
        __wbg_new_245cd5c49157e602: function(arg0) {
            const ret = new Date(arg0);
            return ret;
        },
        __wbg_new_361308b2356cecd0: function() {
            const ret = new Object();
            return ret;
        },
        __wbg_new_3eb36ae241fe6f44: function() {
            const ret = new Array();
            return ret;
        },
        __wbg_new_72b49615380db768: function(arg0, arg1) {
            const ret = new Error($077cadf07a74900e$var$getStringFromWasm0(arg0, arg1));
            return ret;
        },
        __wbg_new_8a6f238a6ece86ea: function() {
            const ret = new Error();
            return ret;
        },
        __wbg_new_911dabf69fa7eb20: function(arg0, arg1) {
            const ret = new RangeError($077cadf07a74900e$var$getStringFromWasm0(arg0, arg1));
            return ret;
        },
        __wbg_new_dd2b680c8bf6ae29: function(arg0) {
            const ret = new Uint8Array(arg0);
            return ret;
        },
        __wbg_new_from_slice_a3d2629dc1826784: function(arg0, arg1) {
            const ret = new Uint8Array($077cadf07a74900e$var$getArrayU8FromWasm0(arg0, arg1));
            return ret;
        },
        __wbg_next_3482f54c49e8af19: function() {
            return $077cadf07a74900e$var$handleError(function(arg0) {
                const ret = arg0.next();
                return ret;
            }, arguments);
        },
        __wbg_next_418f80d8f5303233: function(arg0) {
            const ret = arg0.next;
            return ret;
        },
        __wbg_ownKeys_c7100fb5fa376c6f: function() {
            return $077cadf07a74900e$var$handleError(function(arg0) {
                const ret = Reflect.ownKeys(arg0);
                return ret;
            }, arguments);
        },
        __wbg_prototypesetcall_bdcdcc5842e4d77d: function(arg0, arg1, arg2) {
            Uint8Array.prototype.set.call($077cadf07a74900e$var$getArrayU8FromWasm0(arg0, arg1), arg2);
        },
        __wbg_push_8ffdcb2063340ba5: function(arg0, arg1) {
            const ret = arg0.push(arg1);
            return ret;
        },
        __wbg_set_3f1d0b984ed272ed: function(arg0, arg1, arg2) {
            arg0[arg1] = arg2;
        },
        __wbg_set_6cb8631f80447a67: function() {
            return $077cadf07a74900e$var$handleError(function(arg0, arg1, arg2) {
                const ret = Reflect.set(arg0, arg1, arg2);
                return ret;
            }, arguments);
        },
        __wbg_set_f43e577aea94465b: function(arg0, arg1, arg2) {
            arg0[arg1 >>> 0] = arg2;
        },
        __wbg_slice_b0fa09b1e0041d42: function(arg0, arg1, arg2) {
            const ret = arg0.slice(arg1 >>> 0, arg2 >>> 0);
            return ret;
        },
        __wbg_stack_0ed75d68575b0f3c: function(arg0, arg1) {
            const ret = arg1.stack;
            const ptr1 = $077cadf07a74900e$var$passStringToWasm0(ret, $077cadf07a74900e$var$wasm.__wbindgen_malloc, $077cadf07a74900e$var$wasm.__wbindgen_realloc);
            const len1 = $077cadf07a74900e$var$WASM_VECTOR_LEN;
            $077cadf07a74900e$var$getDataViewMemory0().setInt32(arg0 + 4, len1, true);
            $077cadf07a74900e$var$getDataViewMemory0().setInt32(arg0 + 0, ptr1, true);
        },
        __wbg_stringify_e4a940b133e6b7d8: function(arg0, arg1) {
            const ret = JSON.stringify(arg1);
            var ptr1 = $077cadf07a74900e$var$isLikeNone(ret) ? 0 : $077cadf07a74900e$var$passStringToWasm0(ret, $077cadf07a74900e$var$wasm.__wbindgen_malloc, $077cadf07a74900e$var$wasm.__wbindgen_realloc);
            var len1 = $077cadf07a74900e$var$WASM_VECTOR_LEN;
            $077cadf07a74900e$var$getDataViewMemory0().setInt32(arg0 + 4, len1, true);
            $077cadf07a74900e$var$getDataViewMemory0().setInt32(arg0 + 0, ptr1, true);
        },
        __wbg_toString_3cadee6e7c22b39e: function() {
            return $077cadf07a74900e$var$handleError(function(arg0, arg1) {
                const ret = arg0.toString(arg1);
                return ret;
            }, arguments);
        },
        __wbg_toString_56d946daff83867b: function(arg0, arg1, arg2) {
            const ret = arg1.toString(arg2);
            const ptr1 = $077cadf07a74900e$var$passStringToWasm0(ret, $077cadf07a74900e$var$wasm.__wbindgen_malloc, $077cadf07a74900e$var$wasm.__wbindgen_realloc);
            const len1 = $077cadf07a74900e$var$WASM_VECTOR_LEN;
            $077cadf07a74900e$var$getDataViewMemory0().setInt32(arg0 + 4, len1, true);
            $077cadf07a74900e$var$getDataViewMemory0().setInt32(arg0 + 0, ptr1, true);
        },
        __wbg_toString_b388ecd2d3c517c3: function(arg0) {
            const ret = arg0.toString();
            return ret;
        },
        __wbg_unshift_a4a28a3b4a2e621b: function(arg0, arg1) {
            const ret = arg0.unshift(arg1);
            return ret;
        },
        __wbg_value_0546255b415e96c1: function(arg0) {
            const ret = arg0.value;
            return ret;
        },
        __wbg_values_5da93bc719d272cf: function(arg0) {
            const ret = Object.values(arg0);
            return ret;
        },
        __wbindgen_cast_0000000000000001: function(arg0) {
            // Cast intrinsic for `F64 -> Externref`.
            const ret = arg0;
            return ret;
        },
        __wbindgen_cast_0000000000000002: function(arg0) {
            // Cast intrinsic for `I64 -> Externref`.
            const ret = arg0;
            return ret;
        },
        __wbindgen_cast_0000000000000003: function(arg0, arg1) {
            // Cast intrinsic for `Ref(String) -> Externref`.
            const ret = $077cadf07a74900e$var$getStringFromWasm0(arg0, arg1);
            return ret;
        },
        __wbindgen_cast_0000000000000004: function(arg0) {
            // Cast intrinsic for `U64 -> Externref`.
            const ret = BigInt.asUintN(64, arg0);
            return ret;
        },
        __wbindgen_init_externref_table: function() {
            const table = $077cadf07a74900e$var$wasm.__wbindgen_externrefs;
            const offset = table.grow(4);
            table.set(0, undefined);
            table.set(offset + 0, undefined);
            table.set(offset + 1, null);
            table.set(offset + 2, true);
            table.set(offset + 3, false);
        }
    };
    return {
        __proto__: null,
        "./automerge_wasm_bg.js": import0
    };
}
const $077cadf07a74900e$var$AutomergeFinalization = typeof FinalizationRegistry === 'undefined' ? {
    register: ()=>{},
    unregister: ()=>{}
} : new FinalizationRegistry((ptr)=>$077cadf07a74900e$var$wasm.__wbg_automerge_free(ptr >>> 0, 1));
const $077cadf07a74900e$var$SyncStateFinalization = typeof FinalizationRegistry === 'undefined' ? {
    register: ()=>{},
    unregister: ()=>{}
} : new FinalizationRegistry((ptr)=>$077cadf07a74900e$var$wasm.__wbg_syncstate_free(ptr >>> 0, 1));
function $077cadf07a74900e$var$addToExternrefTable0(obj) {
    const idx = $077cadf07a74900e$var$wasm.__externref_table_alloc();
    $077cadf07a74900e$var$wasm.__wbindgen_externrefs.set(idx, obj);
    return idx;
}
function $077cadf07a74900e$var$_assertClass(instance, klass) {
    if (!(instance instanceof klass)) throw new Error(`expected instance of ${klass.name}`);
}
function $077cadf07a74900e$var$debugString(val) {
    // primitive types
    const type = typeof val;
    if (type == 'number' || type == 'boolean' || val == null) return `${val}`;
    if (type == 'string') return `"${val}"`;
    if (type == 'symbol') {
        const description = val.description;
        if (description == null) return 'Symbol';
        else return `Symbol(${description})`;
    }
    if (type == 'function') {
        const name = val.name;
        if (typeof name == 'string' && name.length > 0) return `Function(${name})`;
        else return 'Function';
    }
    // objects
    if (Array.isArray(val)) {
        const length = val.length;
        let debug = '[';
        if (length > 0) debug += $077cadf07a74900e$var$debugString(val[0]);
        for(let i = 1; i < length; i++)debug += ', ' + $077cadf07a74900e$var$debugString(val[i]);
        debug += ']';
        return debug;
    }
    // Test for built-in
    const builtInMatches = /\[object ([^\]]+)\]/.exec(toString.call(val));
    let className;
    if (builtInMatches && builtInMatches.length > 1) className = builtInMatches[1];
    else // Failed to match the standard '[object ClassName]'
    return toString.call(val);
    if (className == 'Object') // we're a user defined class or Object
    // JSON.stringify avoids problems with cycles, and is generally much
    // easier than looping through ownProperties of `val`.
    try {
        return 'Object(' + JSON.stringify(val) + ')';
    } catch (_) {
        return 'Object';
    }
    // errors
    if (val instanceof Error) return `${val.name}: ${val.message}\n${val.stack}`;
    // TODO we could test for more things here, like `Set`s and `Map`s.
    return className;
}
function $077cadf07a74900e$var$getArrayU8FromWasm0(ptr, len) {
    ptr = ptr >>> 0;
    return $077cadf07a74900e$var$getUint8ArrayMemory0().subarray(ptr / 1, ptr / 1 + len);
}
let $077cadf07a74900e$var$cachedDataViewMemory0 = null;
function $077cadf07a74900e$var$getDataViewMemory0() {
    if ($077cadf07a74900e$var$cachedDataViewMemory0 === null || $077cadf07a74900e$var$cachedDataViewMemory0.buffer.detached === true || $077cadf07a74900e$var$cachedDataViewMemory0.buffer.detached === undefined && $077cadf07a74900e$var$cachedDataViewMemory0.buffer !== $077cadf07a74900e$var$wasm.memory.buffer) $077cadf07a74900e$var$cachedDataViewMemory0 = new DataView($077cadf07a74900e$var$wasm.memory.buffer);
    return $077cadf07a74900e$var$cachedDataViewMemory0;
}
function $077cadf07a74900e$var$getStringFromWasm0(ptr, len) {
    ptr = ptr >>> 0;
    return $077cadf07a74900e$var$decodeText(ptr, len);
}
let $077cadf07a74900e$var$cachedUint8ArrayMemory0 = null;
function $077cadf07a74900e$var$getUint8ArrayMemory0() {
    if ($077cadf07a74900e$var$cachedUint8ArrayMemory0 === null || $077cadf07a74900e$var$cachedUint8ArrayMemory0.byteLength === 0) $077cadf07a74900e$var$cachedUint8ArrayMemory0 = new Uint8Array($077cadf07a74900e$var$wasm.memory.buffer);
    return $077cadf07a74900e$var$cachedUint8ArrayMemory0;
}
function $077cadf07a74900e$var$handleError(f, args) {
    try {
        return f.apply(this, args);
    } catch (e) {
        const idx = $077cadf07a74900e$var$addToExternrefTable0(e);
        $077cadf07a74900e$var$wasm.__wbindgen_exn_store(idx);
    }
}
function $077cadf07a74900e$var$isLikeNone(x) {
    return x === undefined || x === null;
}
function $077cadf07a74900e$var$passStringToWasm0(arg, malloc, realloc) {
    if (realloc === undefined) {
        const buf = $077cadf07a74900e$var$cachedTextEncoder.encode(arg);
        const ptr = malloc(buf.length, 1) >>> 0;
        $077cadf07a74900e$var$getUint8ArrayMemory0().subarray(ptr, ptr + buf.length).set(buf);
        $077cadf07a74900e$var$WASM_VECTOR_LEN = buf.length;
        return ptr;
    }
    let len = arg.length;
    let ptr = malloc(len, 1) >>> 0;
    const mem = $077cadf07a74900e$var$getUint8ArrayMemory0();
    let offset = 0;
    for(; offset < len; offset++){
        const code = arg.charCodeAt(offset);
        if (code > 0x7F) break;
        mem[ptr + offset] = code;
    }
    if (offset !== len) {
        if (offset !== 0) arg = arg.slice(offset);
        ptr = realloc(ptr, len, len = offset + arg.length * 3, 1) >>> 0;
        const view = $077cadf07a74900e$var$getUint8ArrayMemory0().subarray(ptr + offset, ptr + len);
        const ret = $077cadf07a74900e$var$cachedTextEncoder.encodeInto(arg, view);
        offset += ret.written;
        ptr = realloc(ptr, len, offset, 1) >>> 0;
    }
    $077cadf07a74900e$var$WASM_VECTOR_LEN = offset;
    return ptr;
}
function $077cadf07a74900e$var$takeFromExternrefTable0(idx) {
    const value = $077cadf07a74900e$var$wasm.__wbindgen_externrefs.get(idx);
    $077cadf07a74900e$var$wasm.__externref_table_dealloc(idx);
    return value;
}
let $077cadf07a74900e$var$cachedTextDecoder = new TextDecoder('utf-8', {
    ignoreBOM: true,
    fatal: true
});
$077cadf07a74900e$var$cachedTextDecoder.decode();
const $077cadf07a74900e$var$MAX_SAFARI_DECODE_BYTES = 2146435072;
let $077cadf07a74900e$var$numBytesDecoded = 0;
function $077cadf07a74900e$var$decodeText(ptr, len) {
    $077cadf07a74900e$var$numBytesDecoded += len;
    if ($077cadf07a74900e$var$numBytesDecoded >= $077cadf07a74900e$var$MAX_SAFARI_DECODE_BYTES) {
        $077cadf07a74900e$var$cachedTextDecoder = new TextDecoder('utf-8', {
            ignoreBOM: true,
            fatal: true
        });
        $077cadf07a74900e$var$cachedTextDecoder.decode();
        $077cadf07a74900e$var$numBytesDecoded = len;
    }
    return $077cadf07a74900e$var$cachedTextDecoder.decode($077cadf07a74900e$var$getUint8ArrayMemory0().subarray(ptr, ptr + len));
}
const $077cadf07a74900e$var$cachedTextEncoder = new TextEncoder();
if (!('encodeInto' in $077cadf07a74900e$var$cachedTextEncoder)) $077cadf07a74900e$var$cachedTextEncoder.encodeInto = function(arg, view) {
    const buf = $077cadf07a74900e$var$cachedTextEncoder.encode(arg);
    view.set(buf);
    return {
        read: arg.length,
        written: buf.length
    };
};
let $077cadf07a74900e$var$WASM_VECTOR_LEN = 0;
let $077cadf07a74900e$var$wasmModule, $077cadf07a74900e$var$wasm;
function $077cadf07a74900e$var$__wbg_finalize_init(instance, module) {
    $077cadf07a74900e$var$wasm = instance.exports;
    $077cadf07a74900e$var$wasmModule = module;
    $077cadf07a74900e$var$cachedDataViewMemory0 = null;
    $077cadf07a74900e$var$cachedUint8ArrayMemory0 = null;
    $077cadf07a74900e$var$wasm.__wbindgen_start();
    return $077cadf07a74900e$var$wasm;
}
async function $077cadf07a74900e$var$__wbg_load(module, imports) {
    if (typeof Response === 'function' && module instanceof Response) {
        if (typeof WebAssembly.instantiateStreaming === 'function') try {
            return await WebAssembly.instantiateStreaming(module, imports);
        } catch (e) {
            const validResponse = module.ok && expectedResponseType(module.type);
            if (validResponse && module.headers.get('Content-Type') !== 'application/wasm') console.warn("`WebAssembly.instantiateStreaming` failed because your server does not serve Wasm with `application/wasm` MIME type. Falling back to `WebAssembly.instantiate` which is slower. Original error:\n", e);
            else throw e;
        }
        const bytes = await module.arrayBuffer();
        return await WebAssembly.instantiate(bytes, imports);
    } else {
        const instance = await WebAssembly.instantiate(module, imports);
        if (instance instanceof WebAssembly.Instance) return {
            instance: instance,
            module: module
        };
        else return instance;
    }
    function expectedResponseType(type) {
        switch(type){
            case 'basic':
            case 'cors':
            case 'default':
                return true;
        }
        return false;
    }
}
function $077cadf07a74900e$export$2ec80ee76a9348bf(module) {
    if ($077cadf07a74900e$var$wasm !== undefined) return $077cadf07a74900e$var$wasm;
    if (module !== undefined) {
        if (Object.getPrototypeOf(module) === Object.prototype) ({ module: module } = module);
        else console.warn('using deprecated parameters for `initSync()`; pass a single object instead');
    }
    const imports = $077cadf07a74900e$var$__wbg_get_imports();
    if (!(module instanceof WebAssembly.Module)) module = new WebAssembly.Module(module);
    const instance = new WebAssembly.Instance(module, imports);
    return $077cadf07a74900e$var$__wbg_finalize_init(instance, module);
}
var $b7fa36911cc200b2$exports = {};
$b7fa36911cc200b2$exports = import.meta.resolve("4qml5");


async function $077cadf07a74900e$export$2e2bcd8739ae039(module_or_path) {
    if ($077cadf07a74900e$var$wasm !== undefined) return $077cadf07a74900e$var$wasm;
    if (module_or_path !== undefined) {
        if (Object.getPrototypeOf(module_or_path) === Object.prototype) ({ module_or_path: module_or_path } = module_or_path);
        else console.warn('using deprecated parameters for the initialization function; pass a single object instead');
    }
    if (module_or_path === undefined) module_or_path = new URL($b7fa36911cc200b2$exports);
    const imports = $077cadf07a74900e$var$__wbg_get_imports();
    if (typeof module_or_path === 'string' || typeof Request === 'function' && module_or_path instanceof Request || typeof URL === 'function' && module_or_path instanceof URL) module_or_path = fetch(module_or_path);
    const { instance: instance, module: module } = await $077cadf07a74900e$var$__wbg_load(await module_or_path, imports);
    return $077cadf07a74900e$var$__wbg_finalize_init(instance, module);
}


let $20f61774070fc636$var$_initialized = false;
let $20f61774070fc636$var$_initializeListeners = [];
function $20f61774070fc636$export$f8cf94ed36705bd4(api) {
    for(const k in api)$20f61774070fc636$export$67167fe116efc7bf[k] = api[k];
    $20f61774070fc636$var$_initialized = true;
    for (const listener of $20f61774070fc636$var$_initializeListeners)listener();
}
const $20f61774070fc636$export$67167fe116efc7bf = {
    create (options) {
        throw new RangeError("Automerge.use() not called");
    },
    load (data, options) {
        throw new RangeError("Automerge.use() not called (load)");
    },
    encodeChange (change) {
        throw new RangeError("Automerge.use() not called (encodeChange)");
    },
    decodeChange (change) {
        throw new RangeError("Automerge.use() not called (decodeChange)");
    },
    initSyncState () {
        throw new RangeError("Automerge.use() not called (initSyncState)");
    },
    encodeSyncMessage (message) {
        throw new RangeError("Automerge.use() not called (encodeSyncMessage)");
    },
    decodeSyncMessage (msg) {
        throw new RangeError("Automerge.use() not called (decodeSyncMessage)");
    },
    encodeSyncState (state) {
        throw new RangeError("Automerge.use() not called (encodeSyncState)");
    },
    decodeSyncState (data) {
        throw new RangeError("Automerge.use() not called (decodeSyncState)");
    },
    exportSyncState (state) {
        throw new RangeError("Automerge.use() not called (exportSyncState)");
    },
    importSyncState (state) {
        throw new RangeError("Automerge.use() not called (importSyncState)");
    },
    readBundle (data) {
        throw new RangeError("Automerge.use() not called (readBundle)");
    },
    wasmReleaseInfo () {
        throw new RangeError("Automerge.use() not called (wasmReleaseInfo)");
    }
};
function $20f61774070fc636$export$f3ec8fcd2e9cfe3c(wasmBlob) {
    return (0, $077cadf07a74900e$export$2e2bcd8739ae039)({
        module_or_path: wasmBlob
    }).then((_)=>{
        $20f61774070fc636$export$f8cf94ed36705bd4($077cadf07a74900e$exports);
    });
}
function $20f61774070fc636$export$81fbf86d1802310a(wasmBase64) {
    return $20f61774070fc636$export$f3ec8fcd2e9cfe3c(Uint8Array.from(atob(wasmBase64), (c)=>c.charCodeAt(0)));
}
function $20f61774070fc636$export$67155acd1479600c() {
    if ($20f61774070fc636$var$_initialized) return Promise.resolve();
    return new Promise((resolve)=>{
        $20f61774070fc636$var$_initializeListeners.push(resolve);
    });
}
function $20f61774070fc636$export$a4ae9d50e0e28466() {
    return $20f61774070fc636$var$_initialized;
}


// AUTO-GENERATED FILE - DO NOT EDIT
// Generated by scripts/build.mjs
const $d4e5ce81b0a35089$export$9646e8eaf4404a99 = "b8dfc4845c50633f9d850a5d4e2a4219d518f8ad";




function $5a67821114116577$export$6d8ca84c54f94639(doc, checkroot = true) {
    if (typeof doc !== "object") throw new RangeError("must be the document root");
    const state = Reflect.get(doc, (0, $09df12355b460850$export$63b4527a2777036f));
    if (state === undefined || state == null || checkroot && $5a67821114116577$export$26391e4273c2bed8(doc) !== "_root") throw new RangeError("must be the document root");
    return state;
}
function $5a67821114116577$export$7da86ae3d2259140(doc) {
    Reflect.set(doc, (0, $09df12355b460850$export$f2b782965eea3685), true);
}
function $5a67821114116577$export$9444333e8e732d8d(doc) {
    return Reflect.get(doc, (0, $09df12355b460850$export$8754b71dc67cd5d0));
}
function $5a67821114116577$export$26391e4273c2bed8(doc) {
    if (!(typeof doc === "object") || doc === null) return null;
    return Reflect.get(doc, (0, $09df12355b460850$export$c5b546cf7251e6ae));
}
function $5a67821114116577$export$4f93edc2421ad977(doc) {
    return !!Reflect.get(doc, (0, $09df12355b460850$export$1e2e11669870719e));
}



function $e829ce60ecf8c286$export$7383fd3fd73657b6(doc, patch) {
    let path = $e829ce60ecf8c286$var$resolvePath(doc, patch.path);
    if (patch.action === "put") $e829ce60ecf8c286$var$applyPutPatch(doc, path, patch);
    else if (patch.action === "insert") $e829ce60ecf8c286$var$applyInsertPatch(doc, path, patch);
    else if (patch.action === "del") $e829ce60ecf8c286$var$applyDelPatch(doc, path, patch);
    else if (patch.action === "splice") $e829ce60ecf8c286$var$applySplicePatch(doc, path, patch);
    else if (patch.action === "inc") $e829ce60ecf8c286$var$applyIncPatch(doc, path, patch);
    else if (patch.action === "mark") $e829ce60ecf8c286$var$applyMarkPatch(doc, path, patch);
    else if (patch.action === "unmark") $e829ce60ecf8c286$var$applyUnmarkPatch(doc, path, patch);
    else if (patch.action === "conflict") ;
    else throw new RangeError(`unsupported patch: ${patch}`);
}
function $e829ce60ecf8c286$var$applyPutPatch(doc, path, patch) {
    let { obj: parent, prop: prop } = $e829ce60ecf8c286$var$pathElemAt(path, -1);
    parent[prop] = patch.value;
}
function $e829ce60ecf8c286$var$applyInsertPatch(doc, path, patch) {
    let { obj: parent, prop: prop } = $e829ce60ecf8c286$var$pathElemAt(path, -1);
    if (!Array.isArray(parent)) throw new RangeError(`target is not an array for patch`);
    if (!(typeof prop === "number")) throw new RangeError(`index is not a number for patch`);
    parent.splice(prop, 0, ...patch.values);
}
function $e829ce60ecf8c286$var$applyDelPatch(doc, path, patch) {
    let { obj: parent, prop: prop, parentPath: parentPath } = $e829ce60ecf8c286$var$pathElemAt(path, -1);
    if (!(typeof prop === "number")) throw new RangeError(`index is not a number for patch`);
    if (Array.isArray(parent)) parent.splice(prop, patch.length || 1);
    else if (typeof parent === "string") {
        if ((0, $8a8016b162b6f8b4$export$fcc9d0637a2c39af)(doc)) (0, $8a8016b162b6f8b4$export$869882364835d202)(doc, parentPath, prop, patch.length || 1);
        else {
            let { obj: grandParent, prop: grandParentProp } = $e829ce60ecf8c286$var$pathElemAt(path, -2);
            if (typeof prop !== "number") throw new RangeError(`index is not a number for patch`);
            let target = grandParent[grandParentProp];
            if (target == null || typeof target !== "string") throw new RangeError(`target is not a string for patch`);
            let newString = target.slice(0, prop) + target.slice(prop + (patch.length || 1));
            grandParent[grandParentProp] = newString;
        }
    } else throw new RangeError(`target is not an array or string for patch`);
}
function $e829ce60ecf8c286$var$applySplicePatch(doc, path, patch) {
    if ((0, $8a8016b162b6f8b4$export$fcc9d0637a2c39af)(doc)) {
        let { obj: parent, prop: prop, parentPath: parentPath } = $e829ce60ecf8c286$var$pathElemAt(path, -1);
        if (!(typeof prop === "number")) throw new RangeError(`index is not a number for patch`);
        (0, $8a8016b162b6f8b4$export$869882364835d202)(doc, parentPath, prop, 0, patch.value);
    } else {
        let { obj: parent, prop: prop } = $e829ce60ecf8c286$var$pathElemAt(path, -1);
        let { obj: grandParent, prop: grandParentProp } = $e829ce60ecf8c286$var$pathElemAt(path, -2);
        if (typeof prop !== "number") throw new RangeError(`index is not a number for patch`);
        let target = grandParent[grandParentProp];
        if (target == null || typeof target !== "string") throw new RangeError(`target is not a string for patch`);
        let newString = target.slice(0, prop) + patch.value + target.slice(prop);
        grandParent[grandParentProp] = newString;
    }
}
function $e829ce60ecf8c286$var$applyIncPatch(doc, path, patch) {
    let { obj: parent, prop: prop } = $e829ce60ecf8c286$var$pathElemAt(path, -1);
    const counter = parent[prop];
    if ((0, $8a8016b162b6f8b4$export$fcc9d0637a2c39af)(doc)) {
        if (!(0, $2c6cf4f9e0e5e6b9$export$78f0d2b1c8242b32)(counter)) throw new RangeError(`target is not a counter for patch`);
        counter.increment(patch.value);
    } else {
        if (!(typeof counter === "number")) throw new RangeError(`target is not a number for patch`);
        parent[prop] = counter + patch.value;
    }
}
function $e829ce60ecf8c286$var$applyMarkPatch(doc, path, patch) {
    let { obj: parent, prop: prop } = $e829ce60ecf8c286$var$pathElemAt(path, -1);
    if (!(0, $8a8016b162b6f8b4$export$fcc9d0637a2c39af)(doc)) return;
    for (const markSpec of patch.marks)(0, $8a8016b162b6f8b4$export$bf7f2fce5c1cf636)(doc, patch.path, // TODO: add mark expansion to patches. This will require emitting
    // the expand values in patches.
    {
        start: markSpec.start,
        end: markSpec.end,
        expand: "none"
    }, markSpec.name, markSpec.value);
}
function $e829ce60ecf8c286$var$applyUnmarkPatch(doc, path, patch) {
    if (!(0, $8a8016b162b6f8b4$export$fcc9d0637a2c39af)(doc)) return;
    (0, $8a8016b162b6f8b4$export$3522532a010241a0)(doc, patch.path, {
        start: patch.start,
        end: patch.end,
        expand: "none"
    }, patch.name);
}
function $e829ce60ecf8c286$export$a8b8e03e6bbe5473(doc, patches) {
    for (const patch of patches)$e829ce60ecf8c286$export$7383fd3fd73657b6(doc, patch);
}
/**
 * Walk through a path with an object and for each element in the path return a resolved path element.
 *
 * A resolved path element looks like this:
 *
 * ```typescript
 * {
 *   obj: any,           // The object that this element in the path is a property of
 *   prop: Prop,         // The property within `obj` that this path element points at
 *   parentPath: Prop[]  // The path to `obj` within the original `doc` passed to `resolvePath`
 * }
 * ````
 *
 * For example, given an object like this:
 *
 * ```typescript
 * {
 *      todos: [{ task: "remember the milk"}]
 * }
 * ```
 *
 * Then `resolvePath(doc, ["todos", 0, "task"])` would return:
 *
 * ```typescript
 * [
 *   { obj: { todos: [{ task: "remember the milk"}] }, prop: "todos", parentPath: [] },
 *   { obj: [{ task: "remember the milk"}], prop: 0, parentPath: ["todos"] },
 *   { obj: { task: "remember the milk" }, prop: "task", parentPath: ["todos", 0] }
 * ]
 * ```
 */ function $e829ce60ecf8c286$var$resolvePath(doc, path) {
    const result = [];
    let current = doc;
    let currentPath = [];
    for (const [index, prop] of path.entries()){
        result.push({
            obj: current,
            prop: prop,
            parentPath: currentPath.slice()
        });
        currentPath.push(prop);
        if (index !== path.length - 1) {
            if (current == null || typeof current != "object") // If we're not the last item in the path then we need the current
            // object to be an object so we can access it in the next iteration
            throw new Error(`Invalid path: ${path}`);
            current = current[prop];
        } else break;
    }
    return result;
}
/**
 * Get an element from a resolved path, throwing an exception if the element does not exist
 *
 * @param resolved - The path to lookup in
 * @param index    - The index of the element to lookup, negative indices search backwards
 */ function $e829ce60ecf8c286$var$pathElemAt(resolved, index) {
    let result = resolved.at(index);
    if (result == undefined) throw new Error("invalid path");
    return result;
}
function $e829ce60ecf8c286$var$reversed(array) {
    return array.slice().reverse();
}




function $e0582db77798271b$export$508f655860fe27d(context, objectId, prop, withinChangeCallback) {
    const values = context.getAll(objectId, prop);
    if (values.length <= 1) return;
    const result = {};
    for (const fullVal of values)switch(fullVal[0]){
        case "map":
            if (withinChangeCallback) result[fullVal[1]] = (0, $2c6cf4f9e0e5e6b9$export$42df4b810ff5eb5c)(context, fullVal[1], [
                prop
            ]);
            else result[fullVal[1]] = $e0582db77798271b$var$reifyFullValue(context, [
                fullVal[0],
                fullVal[1]
            ]);
            break;
        case "list":
            if (withinChangeCallback) result[fullVal[1]] = (0, $2c6cf4f9e0e5e6b9$export$3c92d7f346eba7cc)(context, fullVal[1], [
                prop
            ]);
            else result[fullVal[1]] = $e0582db77798271b$var$reifyFullValue(context, [
                fullVal[0],
                fullVal[1]
            ]);
            break;
        case "text":
            result[fullVal[1]] = context.text(fullVal[1]);
            break;
        case "str":
        case "uint":
        case "int":
        case "f64":
        case "boolean":
        case "bytes":
        case "null":
            result[fullVal[2]] = fullVal[1];
            break;
        case "counter":
            result[fullVal[2]] = new (0, $d6eb269bf86df424$export$1b74141c5fe63a28)(fullVal[1]);
            break;
        case "timestamp":
            result[fullVal[2]] = new Date(fullVal[1]);
            break;
        default:
            throw RangeError(`datatype ${fullVal[0]} unimplemented`);
    }
    return result;
}
function $e0582db77798271b$var$reifyFullValue(context, fullValue) {
    switch(fullValue[0]){
        case "map":
            const mapResult = {};
            for (const key of context.keys(fullValue[1])){
                let subVal = context.getWithType(fullValue[1], key);
                if (!subVal) throw new Error("unexpected null map value");
                mapResult[key] = $e0582db77798271b$var$reifyFullValue(context, subVal);
            }
            return Object.freeze(mapResult);
        case "list":
            const listResult = [];
            const length = context.length(fullValue[1]);
            for(let i = 0; i < length; i++){
                let subVal = context.getWithType(fullValue[1], i);
                if (!subVal) throw new Error("unexpected null list element");
                listResult.push($e0582db77798271b$var$reifyFullValue(context, subVal));
            }
            return Object.freeze(listResult);
        case "text":
            return context.text(fullValue[1]);
        case "str":
        case "uint":
        case "int":
        case "f64":
        case "boolean":
        case "bytes":
        case "null":
            return fullValue[1];
        case "counter":
            return new (0, $d6eb269bf86df424$export$1b74141c5fe63a28)(fullValue[1]);
        case "timestamp":
            return new Date(fullValue[1]);
        default:
            throw RangeError(`datatype ${fullValue[0]} unimplemented`);
    }
}


var $8a8016b162b6f8b4$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $8a8016b162b6f8b4$var$_SyncStateSymbol = Symbol("_syncstate");
function $8a8016b162b6f8b4$export$9f200c4466975173(list, index, ...values) {
    if (!(0, $5a67821114116577$export$4f93edc2421ad977)(list)) throw new RangeError("object cannot be modified outside of a change block");
    list.insertAt(index, ...values);
}
function $8a8016b162b6f8b4$export$90f9093465da3136(list, index, numDelete) {
    if (!(0, $5a67821114116577$export$4f93edc2421ad977)(list)) throw new RangeError("object cannot be modified outside of a change block");
    list.deleteAt(index, numDelete);
}
function $8a8016b162b6f8b4$export$1f96ae73734a86cc(api) {
    (0, $20f61774070fc636$export$f8cf94ed36705bd4)(api);
}
function $8a8016b162b6f8b4$export$b098501f764cdf30(doc) {
    return (0, $5a67821114116577$export$6d8ca84c54f94639)(doc).handle;
}
function $8a8016b162b6f8b4$var$importOpts(_actor) {
    if (typeof _actor === "object") return _actor;
    else return {
        actor: _actor
    };
}
function $8a8016b162b6f8b4$export$b5fee91f3be7b37b(state, heads) {
    const n = (0, $5a67821114116577$export$6d8ca84c54f94639)(state);
    return n.handle.getChanges(heads);
}
function $8a8016b162b6f8b4$export$36b332e762c91922(state, heads) {
    const n = (0, $5a67821114116577$export$6d8ca84c54f94639)(state);
    return n.handle.getChangesMeta(heads);
}
function $8a8016b162b6f8b4$var$cursorToIndex(state, value, index) {
    if (typeof index == "string") {
        if (/^-?[0-9]+@[0-9a-zA-Z]+$|^[se]$/.test(index)) return state.handle.getCursorPosition(value, index);
        else throw new RangeError("index must be a number or cursor");
    } else return index;
}
function $8a8016b162b6f8b4$export$2cd8252107eb640b(_opts) {
    const opts = $8a8016b162b6f8b4$var$importOpts(_opts);
    const freeze = !!opts.freeze;
    const patchCallback = opts.patchCallback;
    const actor = opts.actor;
    const handle = (0, $20f61774070fc636$export$67167fe116efc7bf).create({
        actor: actor
    });
    handle.enableFreeze(!!opts.freeze);
    $8a8016b162b6f8b4$var$registerDatatypes(handle);
    const doc = handle.materialize("/", undefined, {
        handle: handle,
        heads: undefined,
        freeze: freeze,
        patchCallback: patchCallback
    });
    return doc;
}
function $8a8016b162b6f8b4$export$c4ddc81c7b2c8d7a(doc, heads) {
    const state = (0, $5a67821114116577$export$6d8ca84c54f94639)(doc);
    const handle = state.handle;
    return state.handle.materialize("/", heads, Object.assign(Object.assign({}, state), {
        handle: handle,
        heads: heads
    }));
}
function $8a8016b162b6f8b4$export$9cd59f9826255e47(doc, _opts) {
    const state = (0, $5a67821114116577$export$6d8ca84c54f94639)(doc);
    const heads = state.heads;
    const opts = $8a8016b162b6f8b4$var$importOpts(_opts);
    const handle = state.handle.fork(opts.actor, heads);
    handle.updateDiffCursor();
    // `change` uses the presence of state.heads to determine if we are in a view
    // set it to undefined to indicate that this is a full fat document
    const { heads: _oldHeads } = state, stateSansHeads = $8a8016b162b6f8b4$var$__rest(state, [
        "heads"
    ]);
    stateSansHeads.patchCallback = opts.patchCallback;
    return handle.applyPatches(doc, Object.assign(Object.assign({}, stateSansHeads), {
        handle: handle
    }));
}
function $8a8016b162b6f8b4$export$13e2de3c33d99539(doc) {
    return (0, $5a67821114116577$export$6d8ca84c54f94639)(doc).handle.free();
}
function $8a8016b162b6f8b4$export$6788812c4e6611e6(initialState, _opts) {
    return $8a8016b162b6f8b4$var$_change($8a8016b162b6f8b4$export$2cd8252107eb640b(_opts), "from", {}, (d)=>Object.assign(d, initialState)).newDoc;
}
function $8a8016b162b6f8b4$export$d8a7b8f475ec0161(doc, options, callback) {
    if (typeof options === "function") return $8a8016b162b6f8b4$var$_change(doc, "change", {}, options).newDoc;
    else if (typeof callback === "function") {
        if (typeof options === "string") options = {
            message: options
        };
        return $8a8016b162b6f8b4$var$_change(doc, "change", options, callback).newDoc;
    } else throw RangeError("Invalid args for change");
}
function $8a8016b162b6f8b4$export$9ebb21f6bf9e6a11(doc, scope, options, callback) {
    if (typeof options === "function") return $8a8016b162b6f8b4$var$_change(doc, "changeAt", {}, options, scope);
    else if (typeof callback === "function") {
        if (typeof options === "string") options = {
            message: options
        };
        return $8a8016b162b6f8b4$var$_change(doc, "changeAt", options, callback, scope);
    } else throw RangeError("Invalid args for changeAt");
}
function $8a8016b162b6f8b4$var$progressDocument(doc, source, heads, callback) {
    if (heads == null) return doc;
    const state = (0, $5a67821114116577$export$6d8ca84c54f94639)(doc);
    const nextState = Object.assign(Object.assign({}, state), {
        heads: undefined
    });
    const { value: nextDoc, patches: patches } = state.handle.applyAndReturnPatches(doc, nextState);
    if (patches.length > 0) {
        if (callback != null) callback(patches, {
            before: doc,
            after: nextDoc,
            source: source
        });
        const newState = (0, $5a67821114116577$export$6d8ca84c54f94639)(nextDoc);
        newState.mostRecentPatch = {
            before: (0, $5a67821114116577$export$6d8ca84c54f94639)(doc).heads,
            after: newState.handle.getHeads(),
            patches: patches
        };
    }
    state.heads = heads;
    return nextDoc;
}
function $8a8016b162b6f8b4$var$_change(doc, source, options, callback, scope) {
    if (typeof callback !== "function") throw new RangeError("invalid change function");
    const state = (0, $5a67821114116577$export$6d8ca84c54f94639)(doc);
    if (doc === undefined || state === undefined) throw new RangeError("must be the document root");
    if (state.heads) throw new RangeError("Attempting to change an outdated document.  Use Automerge.clone() if you wish to make a writable copy.");
    if ((0, $5a67821114116577$export$4f93edc2421ad977)(doc)) throw new RangeError("Calls to Automerge.change cannot be nested");
    let heads = state.handle.getHeads();
    if (scope && $8a8016b162b6f8b4$var$headsEqual(scope, heads)) scope = undefined;
    if (scope) {
        state.handle.isolate(scope);
        heads = scope;
    }
    if (!("time" in options)) options.time = Math.floor(Date.now() / 1000);
    try {
        state.heads = heads;
        const root = (0, $2c6cf4f9e0e5e6b9$export$e99ac7fa6c1fa986)(state.handle);
        callback(root);
        if (state.handle.pendingOps() === 0) {
            state.heads = undefined;
            if (scope) state.handle.integrate();
            return {
                newDoc: doc,
                newHeads: null
            };
        } else {
            const newHead = state.handle.commit(options.message, options.time);
            state.handle.integrate();
            return {
                newDoc: $8a8016b162b6f8b4$var$progressDocument(doc, source, heads, options.patchCallback || state.patchCallback),
                newHeads: newHead != null ? [
                    newHead
                ] : null
            };
        }
    } catch (e) {
        state.heads = undefined;
        state.handle.rollback();
        throw e;
    }
}
function $8a8016b162b6f8b4$export$692563bcee5d4d36(doc, options) {
    if (options === undefined) options = {};
    if (typeof options === "string") options = {
        message: options
    };
    if (!("time" in options)) options.time = Math.floor(Date.now() / 1000);
    const state = (0, $5a67821114116577$export$6d8ca84c54f94639)(doc);
    if (state.heads) throw new RangeError("Attempting to change an outdated document.  Use Automerge.clone() if you wish to make a writable copy.");
    if ((0, $5a67821114116577$export$4f93edc2421ad977)(doc)) throw new RangeError("Calls to Automerge.change cannot be nested");
    const heads = state.handle.getHeads();
    state.handle.emptyChange(options.message, options.time);
    return $8a8016b162b6f8b4$var$progressDocument(doc, "emptyChange", heads);
}
function $8a8016b162b6f8b4$export$11e63f7b0f3d9900(data, _opts) {
    const opts = $8a8016b162b6f8b4$var$importOpts(_opts);
    if (opts.patchCallback) return $8a8016b162b6f8b4$export$b6f73f242929a241($8a8016b162b6f8b4$export$2cd8252107eb640b(opts), data);
    const actor = opts.actor;
    const patchCallback = opts.patchCallback;
    const unchecked = opts.unchecked || false;
    const allowMissingDeps = opts.allowMissingChanges || false;
    const convertImmutableStringsToText = opts.convertImmutableStringsToText || false;
    const handle = (0, $20f61774070fc636$export$67167fe116efc7bf).load(data, {
        actor: actor,
        unchecked: unchecked,
        allowMissingDeps: allowMissingDeps,
        convertImmutableStringsToText: convertImmutableStringsToText
    });
    handle.enableFreeze(!!opts.freeze);
    $8a8016b162b6f8b4$var$registerDatatypes(handle);
    const doc = handle.materialize("/", undefined, {
        handle: handle,
        heads: undefined,
        patchCallback: patchCallback
    });
    return doc;
}
function $8a8016b162b6f8b4$export$b6f73f242929a241(doc, data, opts) {
    if (!opts) opts = {};
    const state = (0, $5a67821114116577$export$6d8ca84c54f94639)(doc);
    if (state.heads) throw new RangeError("Attempting to change an out of date document - set at: " + (0, $5a67821114116577$export$9444333e8e732d8d)(doc));
    if ((0, $5a67821114116577$export$4f93edc2421ad977)(doc)) throw new RangeError("Calls to Automerge.change cannot be nested");
    const heads = state.handle.getHeads();
    state.handle.loadIncremental(data);
    return $8a8016b162b6f8b4$var$progressDocument(doc, "loadIncremental", heads, opts.patchCallback || state.patchCallback);
}
function $8a8016b162b6f8b4$export$2b291c2340b9db57(doc) {
    const state = (0, $5a67821114116577$export$6d8ca84c54f94639)(doc);
    if (state.heads) throw new RangeError("Attempting to change an out of date document - set at: " + (0, $5a67821114116577$export$9444333e8e732d8d)(doc));
    if ((0, $5a67821114116577$export$4f93edc2421ad977)(doc)) throw new RangeError("Calls to Automerge.change cannot be nested");
    return state.handle.saveIncremental();
}
function $8a8016b162b6f8b4$export$a1544dad697b423d(doc) {
    return (0, $5a67821114116577$export$6d8ca84c54f94639)(doc).handle.save();
}
function $8a8016b162b6f8b4$export$4950aa0f605343fb(local, remote) {
    const localState = (0, $5a67821114116577$export$6d8ca84c54f94639)(local);
    if (localState.heads) throw new RangeError("Attempting to change an out of date document - set at: " + (0, $5a67821114116577$export$9444333e8e732d8d)(local));
    const heads = localState.handle.getHeads();
    const remoteState = (0, $5a67821114116577$export$6d8ca84c54f94639)(remote);
    const changes = localState.handle.getChangesAdded(remoteState.handle);
    localState.handle.applyChanges(changes);
    return $8a8016b162b6f8b4$var$progressDocument(local, "merge", heads, localState.patchCallback);
}
function $8a8016b162b6f8b4$export$f0d214680912fa6b(doc) {
    const state = (0, $5a67821114116577$export$6d8ca84c54f94639)(doc);
    return state.handle.getActorId();
}
function $8a8016b162b6f8b4$export$733bb30b9159fd88(doc, prop) {
    const state = (0, $5a67821114116577$export$6d8ca84c54f94639)(doc, false);
    const objectId = (0, $5a67821114116577$export$26391e4273c2bed8)(doc);
    if (objectId != null) {
        const withinChangeCallback = (0, $5a67821114116577$export$4f93edc2421ad977)(doc);
        return (0, $e0582db77798271b$export$508f655860fe27d)(state.handle, objectId, prop, withinChangeCallback);
    } else return undefined;
}
function $8a8016b162b6f8b4$export$62c3fa1181e3bd22(doc) {
    const state = (0, $5a67821114116577$export$6d8ca84c54f94639)(doc);
    return state.handle.getLastLocalChange() || undefined;
}
function $8a8016b162b6f8b4$export$fa986b91291934c7(doc, prop) {
    if (prop) {
        const state = (0, $5a67821114116577$export$6d8ca84c54f94639)(doc, false);
        const objectId = (0, $5a67821114116577$export$26391e4273c2bed8)(doc);
        if (!state || !objectId) return null;
        return state.handle.get(objectId, prop);
    } else return (0, $5a67821114116577$export$26391e4273c2bed8)(doc);
}
function $8a8016b162b6f8b4$export$db14845dcbb6e6df(oldState, newState) {
    const n = (0, $5a67821114116577$export$6d8ca84c54f94639)(newState);
    return n.handle.getChanges($8a8016b162b6f8b4$export$7e7f210e394c71d1(oldState));
}
function $8a8016b162b6f8b4$export$56552f518dc96f0f(doc) {
    const state = (0, $5a67821114116577$export$6d8ca84c54f94639)(doc);
    return state.handle.getChanges([]);
}
function $8a8016b162b6f8b4$export$10db731c0a813ec1(doc, changes, opts) {
    const state = (0, $5a67821114116577$export$6d8ca84c54f94639)(doc);
    if (!opts) opts = {};
    if (state.heads) throw new RangeError("Attempting to change an outdated document.  Use Automerge.clone() if you wish to make a writable copy.");
    if ((0, $5a67821114116577$export$4f93edc2421ad977)(doc)) throw new RangeError("Calls to Automerge.change cannot be nested");
    const heads = state.handle.getHeads();
    state.handle.applyChanges(changes);
    state.heads = heads;
    return [
        $8a8016b162b6f8b4$var$progressDocument(doc, "applyChanges", heads, opts.patchCallback || state.patchCallback)
    ];
}
function $8a8016b162b6f8b4$export$f9582a3c130d9538(doc) {
    const history = $8a8016b162b6f8b4$export$56552f518dc96f0f(doc);
    return history.map((change, index)=>({
            get change () {
                return $8a8016b162b6f8b4$export$5375c324cca37246(change);
            },
            get snapshot () {
                const [state] = $8a8016b162b6f8b4$export$10db731c0a813ec1($8a8016b162b6f8b4$export$2cd8252107eb640b(), history.slice(0, index + 1));
                return state;
            }
        }));
}
function $8a8016b162b6f8b4$export$a37e3c603d7117e5(doc, before, after) {
    $8a8016b162b6f8b4$var$checkHeads(before, "before heads");
    $8a8016b162b6f8b4$var$checkHeads(after, "after heads");
    const state = (0, $5a67821114116577$export$6d8ca84c54f94639)(doc);
    if (state.mostRecentPatch && $8a8016b162b6f8b4$export$e9bab7fafb253603(state.mostRecentPatch.before, before) && $8a8016b162b6f8b4$export$e9bab7fafb253603(state.mostRecentPatch.after, after)) return state.mostRecentPatch.patches;
    return state.handle.diff(before, after);
}
function $8a8016b162b6f8b4$export$1c1286c580668e1(doc, path, before, after, opts) {
    $8a8016b162b6f8b4$var$checkHeads(before, "before");
    $8a8016b162b6f8b4$var$checkHeads(after, "after");
    const state = (0, $5a67821114116577$export$6d8ca84c54f94639)(doc);
    const objPath = $8a8016b162b6f8b4$var$absoluteObjPath(doc, path, "diff");
    return state.handle.diffPath(objPath, before, after, opts);
}
function $8a8016b162b6f8b4$var$headsEqual(heads1, heads2) {
    if (heads1.length !== heads2.length) return false;
    for(let i = 0; i < heads1.length; i++){
        if (heads1[i] !== heads2[i]) return false;
    }
    return true;
}
function $8a8016b162b6f8b4$var$checkHeads(heads, fieldname) {
    if (!Array.isArray(heads)) throw new Error(`invalid ${fieldname}: must be an array`);
}
function $8a8016b162b6f8b4$export$e9bab7fafb253603(val1, val2) {
    if (!$8a8016b162b6f8b4$var$isObject(val1) || !$8a8016b162b6f8b4$var$isObject(val2)) return val1 === val2;
    const keys1 = Object.keys(val1).sort(), keys2 = Object.keys(val2).sort();
    if (keys1.length !== keys2.length) return false;
    for(let i = 0; i < keys1.length; i++){
        if (keys1[i] !== keys2[i]) return false;
        if (!$8a8016b162b6f8b4$export$e9bab7fafb253603(val1[keys1[i]], val2[keys2[i]])) return false;
    }
    return true;
}
function $8a8016b162b6f8b4$export$5bc395804aa8bae4(state) {
    const sync = (0, $20f61774070fc636$export$67167fe116efc7bf).importSyncState(state);
    const result = (0, $20f61774070fc636$export$67167fe116efc7bf).encodeSyncState(sync);
    sync.free();
    return result;
}
function $8a8016b162b6f8b4$export$d01db62e8ae92970(state) {
    const sync = (0, $20f61774070fc636$export$67167fe116efc7bf).decodeSyncState(state);
    const result = (0, $20f61774070fc636$export$67167fe116efc7bf).exportSyncState(sync);
    sync.free();
    return result;
}
function $8a8016b162b6f8b4$export$dacf59db213583ec(doc, inState) {
    const state = (0, $5a67821114116577$export$6d8ca84c54f94639)(doc);
    const syncState = (0, $20f61774070fc636$export$67167fe116efc7bf).importSyncState(inState);
    const message = state.handle.generateSyncMessage(syncState);
    const outState = (0, $20f61774070fc636$export$67167fe116efc7bf).exportSyncState(syncState);
    return [
        outState,
        message
    ];
}
function $8a8016b162b6f8b4$export$f7b55ecd2db2a06a(doc, inState, message, opts) {
    const syncState = (0, $20f61774070fc636$export$67167fe116efc7bf).importSyncState(inState);
    if (!opts) opts = {};
    const state = (0, $5a67821114116577$export$6d8ca84c54f94639)(doc);
    if (state.heads) throw new RangeError("Attempting to change an outdated document.  Use Automerge.clone() if you wish to make a writable copy.");
    if ((0, $5a67821114116577$export$4f93edc2421ad977)(doc)) throw new RangeError("Calls to Automerge.change cannot be nested");
    const heads = state.handle.getHeads();
    state.handle.receiveSyncMessage(syncState, message);
    const outSyncState = (0, $20f61774070fc636$export$67167fe116efc7bf).exportSyncState(syncState);
    return [
        $8a8016b162b6f8b4$var$progressDocument(doc, "receiveSyncMessage", heads, opts.patchCallback || state.patchCallback),
        outSyncState,
        null
    ];
}
function $8a8016b162b6f8b4$export$71dccf3f6c358c8e(doc, remoteState) {
    const state = (0, $5a67821114116577$export$6d8ca84c54f94639)(doc);
    const syncState = (0, $20f61774070fc636$export$67167fe116efc7bf).importSyncState(remoteState);
    return state.handle.hasOurChanges(syncState);
}
function $8a8016b162b6f8b4$export$b43d8a335ef7c02a() {
    return (0, $20f61774070fc636$export$67167fe116efc7bf).exportSyncState((0, $20f61774070fc636$export$67167fe116efc7bf).initSyncState());
}
function $8a8016b162b6f8b4$export$18b630b4c065867e(change) {
    return (0, $20f61774070fc636$export$67167fe116efc7bf).encodeChange(change);
}
function $8a8016b162b6f8b4$export$5375c324cca37246(data) {
    return (0, $20f61774070fc636$export$67167fe116efc7bf).decodeChange(data);
}
function $8a8016b162b6f8b4$export$48610c745f21f5dc(message) {
    return (0, $20f61774070fc636$export$67167fe116efc7bf).encodeSyncMessage(message);
}
function $8a8016b162b6f8b4$export$f4fe23b15e41e0e4(message) {
    return (0, $20f61774070fc636$export$67167fe116efc7bf).decodeSyncMessage(message);
}
function $8a8016b162b6f8b4$export$cdf452a5d2a784c3(doc, heads) {
    const state = (0, $5a67821114116577$export$6d8ca84c54f94639)(doc);
    return state.handle.getMissingDeps(heads);
}
function $8a8016b162b6f8b4$export$7e7f210e394c71d1(doc) {
    const state = (0, $5a67821114116577$export$6d8ca84c54f94639)(doc);
    return state.heads || state.handle.getHeads();
}
function $8a8016b162b6f8b4$export$2069a8a5a76faa2(doc) {
    const state = (0, $5a67821114116577$export$6d8ca84c54f94639)(doc);
    state.handle.dump();
}
function $8a8016b162b6f8b4$export$f08965dd1304d490(doc) {
    const state = (0, $5a67821114116577$export$6d8ca84c54f94639)(doc);
    const enabled = state.handle.enableFreeze(false);
    const result = state.handle.materialize("/", state.heads);
    state.handle.enableFreeze(enabled);
    return result;
}
function $8a8016b162b6f8b4$export$fcc9d0637a2c39af(doc) {
    if (typeof doc == "object" && doc !== null) return $8a8016b162b6f8b4$export$fa986b91291934c7(doc) === "_root" && !!Reflect.get(doc, (0, $09df12355b460850$export$63b4527a2777036f));
    else return false;
}
function $8a8016b162b6f8b4$var$isObject(obj) {
    return typeof obj === "object" && obj !== null;
}
function $8a8016b162b6f8b4$export$280a1d2350555d65(doc, heads) {
    const state = (0, $5a67821114116577$export$6d8ca84c54f94639)(doc);
    const result = state.handle.saveSince(heads);
    return result;
}
function $8a8016b162b6f8b4$export$8345d9922cc874a6(doc, heads) {
    const state = (0, $5a67821114116577$export$6d8ca84c54f94639)(doc);
    for (const hash of heads){
        if (!state.handle.getChangeByHash(hash)) return false;
    }
    return true;
}
function $8a8016b162b6f8b4$var$registerDatatypes(handle) {
    handle.registerDatatype("counter", (n)=>new (0, $d6eb269bf86df424$export$1b74141c5fe63a28)(n), (n)=>{
        if (n instanceof (0, $d6eb269bf86df424$export$1b74141c5fe63a28)) return n.value;
    });
    handle.registerDatatype("str", (n)=>{
        return new (0, $9c226d2cfb90e31a$export$3e488ffad70f65de)(n);
    }, (s)=>{
        if ((0, $2c6cf4f9e0e5e6b9$export$c8182079cd36e71f)(s)) return s.val;
    });
}
function $8a8016b162b6f8b4$export$39afa9af7606e7c5(doc) {
    const state = (0, $5a67821114116577$export$6d8ca84c54f94639)(doc);
    return state.handle.topoHistoryTraversal();
}
function $8a8016b162b6f8b4$export$2e3829b21a187e71(doc, changeHash) {
    const state = (0, $5a67821114116577$export$6d8ca84c54f94639)(doc);
    return state.handle.getDecodedChangeByHash(changeHash);
}
function $8a8016b162b6f8b4$export$7804429c45dff272(doc) {
    var _a, _b, _c, _d, _e, _f;
    const state = (0, $5a67821114116577$export$6d8ca84c54f94639)(doc);
    const wasmStats = state.handle.stats();
    const release = $8a8016b162b6f8b4$export$2e6d6b4acfcb5974();
    return Object.assign(Object.assign({}, wasmStats), {
        cargoPackageName: (_b = (_a = release.wasm) === null || _a === void 0 ? void 0 : _a.cargoPackageName) !== null && _b !== void 0 ? _b : "unknown",
        cargoPackageVersion: (_d = (_c = release.wasm) === null || _c === void 0 ? void 0 : _c.cargoPackageVersion) !== null && _d !== void 0 ? _d : "unknown",
        rustcVersion: (_f = (_e = release.wasm) === null || _e === void 0 ? void 0 : _e.rustcVersion) !== null && _f !== void 0 ? _f : "unknown"
    });
}
function $8a8016b162b6f8b4$export$2e6d6b4acfcb5974() {
    let wasm = null;
    try {
        wasm = (0, $20f61774070fc636$export$67167fe116efc7bf).wasmReleaseInfo();
    } catch (_a) {
    // WASM not initialized - leave as null
    }
    return {
        js: {
            gitHead: (0, $d4e5ce81b0a35089$export$9646e8eaf4404a99)
        },
        wasm: wasm
    };
}
function $8a8016b162b6f8b4$export$869882364835d202(doc, path, index, del, newText) {
    const objPath = $8a8016b162b6f8b4$var$absoluteObjPath(doc, path, "splice");
    if (!(0, $5a67821114116577$export$4f93edc2421ad977)(doc)) throw new RangeError("object cannot be modified outside of a change block");
    const state = (0, $5a67821114116577$export$6d8ca84c54f94639)(doc, false);
    (0, $5a67821114116577$export$7da86ae3d2259140)(doc);
    index = $8a8016b162b6f8b4$var$cursorToIndex(state, objPath, index);
    try {
        return state.handle.splice(objPath, index, del, newText);
    } catch (e) {
        throw new RangeError(`Cannot splice: ${e}`);
    }
}
function $8a8016b162b6f8b4$export$482314a40d8c0657(doc, path, newText) {
    const objPath = $8a8016b162b6f8b4$var$absoluteObjPath(doc, path, "updateText");
    if (!(0, $5a67821114116577$export$4f93edc2421ad977)(doc)) throw new RangeError("object cannot be modified outside of a change block");
    const state = (0, $5a67821114116577$export$6d8ca84c54f94639)(doc, false);
    (0, $5a67821114116577$export$7da86ae3d2259140)(doc);
    try {
        return state.handle.updateText(objPath, newText);
    } catch (e) {
        throw new RangeError(`Cannot updateText: ${e}`);
    }
}
function $8a8016b162b6f8b4$export$510f7f0b36829788(doc, path) {
    const state = (0, $5a67821114116577$export$6d8ca84c54f94639)(doc, false);
    const objPath = $8a8016b162b6f8b4$var$absoluteObjPath(doc, path, "spans");
    try {
        return state.handle.spans(objPath, state.heads);
    } catch (e) {
        throw new RangeError(`Cannot splice: ${e}`);
    }
}
function $8a8016b162b6f8b4$export$837bd02682cd3db9(doc, path, index) {
    const objPath = $8a8016b162b6f8b4$var$absoluteObjPath(doc, path, "splitBlock");
    const state = (0, $5a67821114116577$export$6d8ca84c54f94639)(doc, false);
    index = $8a8016b162b6f8b4$var$cursorToIndex(state, objPath, index);
    try {
        return state.handle.getBlock(objPath, index);
    } catch (e) {
        throw new RangeError(`Cannot get block: ${e}`);
    }
}
function $8a8016b162b6f8b4$export$e99155638ff4dff0(doc, path, index, block) {
    if (!(0, $5a67821114116577$export$4f93edc2421ad977)(doc)) throw new RangeError("object cannot be modified outside of a change block");
    const objPath = $8a8016b162b6f8b4$var$absoluteObjPath(doc, path, "splitBlock");
    const state = (0, $5a67821114116577$export$6d8ca84c54f94639)(doc, false);
    (0, $5a67821114116577$export$7da86ae3d2259140)(doc);
    index = $8a8016b162b6f8b4$var$cursorToIndex(state, objPath, index);
    try {
        state.handle.splitBlock(objPath, index, block);
    } catch (e) {
        throw new RangeError(`Cannot splice: ${e}`);
    }
}
function $8a8016b162b6f8b4$export$c832d53646896db1(doc, path, index) {
    if (!(0, $5a67821114116577$export$4f93edc2421ad977)(doc)) throw new RangeError("object cannot be modified outside of a change block");
    const objPath = $8a8016b162b6f8b4$var$absoluteObjPath(doc, path, "joinBlock");
    const state = (0, $5a67821114116577$export$6d8ca84c54f94639)(doc, false);
    (0, $5a67821114116577$export$7da86ae3d2259140)(doc);
    index = $8a8016b162b6f8b4$var$cursorToIndex(state, objPath, index);
    try {
        state.handle.joinBlock(objPath, index);
    } catch (e) {
        throw new RangeError(`Cannot joinBlock: ${e}`);
    }
}
function $8a8016b162b6f8b4$export$90b0715df0f454c7(doc, path, index, block) {
    if (!(0, $5a67821114116577$export$4f93edc2421ad977)(doc)) throw new RangeError("object cannot be modified outside of a change block");
    const objPath = $8a8016b162b6f8b4$var$absoluteObjPath(doc, path, "updateBlock");
    const state = (0, $5a67821114116577$export$6d8ca84c54f94639)(doc, false);
    (0, $5a67821114116577$export$7da86ae3d2259140)(doc);
    index = $8a8016b162b6f8b4$var$cursorToIndex(state, objPath, index);
    try {
        state.handle.updateBlock(objPath, index, block);
    } catch (e) {
        throw new RangeError(`Cannot updateBlock: ${e}`);
    }
}
function $8a8016b162b6f8b4$export$7b9932265f1bad4f(doc, path, newSpans, config) {
    if (!(0, $5a67821114116577$export$4f93edc2421ad977)(doc)) throw new RangeError("object cannot be modified outside of a change block");
    const objPath = $8a8016b162b6f8b4$var$absoluteObjPath(doc, path, "updateSpans");
    const state = (0, $5a67821114116577$export$6d8ca84c54f94639)(doc, false);
    (0, $5a67821114116577$export$7da86ae3d2259140)(doc);
    try {
        state.handle.updateSpans(objPath, newSpans, config);
    } catch (e) {
        throw new RangeError(`Cannot updateSpans: ${e}`);
    }
}
function $8a8016b162b6f8b4$export$da3f040fb23d21f(doc, path, position, move) {
    const objPath = $8a8016b162b6f8b4$var$absoluteObjPath(doc, path, "getCursor");
    const state = (0, $5a67821114116577$export$6d8ca84c54f94639)(doc, false);
    try {
        return state.handle.getCursor(objPath, position, state.heads, move);
    } catch (e) {
        throw new RangeError(`Cannot getCursor: ${e}`);
    }
}
function $8a8016b162b6f8b4$export$47774cf7fb07bfc4(doc, path, cursor) {
    const objPath = $8a8016b162b6f8b4$var$absoluteObjPath(doc, path, "getCursorPosition");
    const state = (0, $5a67821114116577$export$6d8ca84c54f94639)(doc, false);
    try {
        return state.handle.getCursorPosition(objPath, cursor, state.heads);
    } catch (e) {
        throw new RangeError(`Cannot getCursorPosition: ${e}`);
    }
}
function $8a8016b162b6f8b4$export$bf7f2fce5c1cf636(doc, path, range, name, value) {
    const objPath = $8a8016b162b6f8b4$var$absoluteObjPath(doc, path, "mark");
    if (!(0, $5a67821114116577$export$4f93edc2421ad977)(doc)) throw new RangeError("object cannot be modified outside of a change block");
    const state = (0, $5a67821114116577$export$6d8ca84c54f94639)(doc, false);
    try {
        return state.handle.mark(objPath, range, name, value);
    } catch (e) {
        throw new RangeError(`Cannot mark: ${e}`);
    }
}
function $8a8016b162b6f8b4$export$3522532a010241a0(doc, path, range, name) {
    const objPath = $8a8016b162b6f8b4$var$absoluteObjPath(doc, path, "unmark");
    if (!(0, $5a67821114116577$export$4f93edc2421ad977)(doc)) throw new RangeError("object cannot be modified outside of a change block");
    const state = (0, $5a67821114116577$export$6d8ca84c54f94639)(doc, false);
    try {
        return state.handle.unmark(objPath, range, name);
    } catch (e) {
        throw new RangeError(`Cannot unmark: ${e}`);
    }
}
function $8a8016b162b6f8b4$export$3a8025f2f3e0c64(doc, path) {
    const objPath = $8a8016b162b6f8b4$var$absoluteObjPath(doc, path, "marks");
    const state = (0, $5a67821114116577$export$6d8ca84c54f94639)(doc, false);
    try {
        return state.handle.marks(objPath);
    } catch (e) {
        throw new RangeError(`Cannot call marks(): ${e}`);
    }
}
function $8a8016b162b6f8b4$export$126fabfc9a1e7981(doc, path, index) {
    const objPath = $8a8016b162b6f8b4$var$absoluteObjPath(doc, path, "marksAt");
    const state = (0, $5a67821114116577$export$6d8ca84c54f94639)(doc, false);
    try {
        return state.handle.marksAt(objPath, index);
    } catch (e) {
        throw new RangeError(`Cannot call marksAt(): ${e}`);
    }
}
function $8a8016b162b6f8b4$var$absoluteObjPath(doc, path, functionName) {
    path = path.slice();
    const objectId = (0, $5a67821114116577$export$26391e4273c2bed8)(doc);
    if (!objectId) throw new RangeError(`invalid object for ${functionName}`);
    path.unshift(objectId);
    return path.join("/");
}
const $8a8016b162b6f8b4$export$eab0fb792e5f13ed = (0, $2c6cf4f9e0e5e6b9$export$c8182079cd36e71f);
const $8a8016b162b6f8b4$export$273a6633ac335954 = (0, $9c226d2cfb90e31a$export$3e488ffad70f65de);
function $8a8016b162b6f8b4$export$9ee21599e82fa974(doc, hashes) {
    const state = (0, $5a67821114116577$export$6d8ca84c54f94639)(doc, false);
    return state.handle.saveBundle(hashes);
}
function $8a8016b162b6f8b4$export$27be6a0b6df0f841(bundle) {
    return (0, $20f61774070fc636$export$67167fe116efc7bf).readBundle(bundle);
}






/**
 * @packageDocumentation
 *
 * The [`automerge`](https://www.npmjs.com/package/@automerge/automerge) CRDT
 * provides a core CRDT data structure and an implementation of a storage
 * format and sync protocol but doesn't provide the plumbing to use these tools
 * in a JS application. `automerge-repo` provides the plumbing.
 *
 * The main entry point is the {@link Repo} class, which you instantiate with
 * a {@link StorageAdapter} and zero or more {@link NetworkAdapter}s. Once you
 * have a repo you can use it to create {@link DocHandle}s. {@link DocHandle}s
 * are a reference to a document, identified by a {@link AutomergeUrl}, a place to
 * listen for changes to the document, and to make new changes.
 *
 * A typical example of how to use this library then might look like this:
 *
 * ```typescript
 * import { Repo } from "@automerge/automerge-repo";
 *
 * const repo = new Repo({
 *   storage: <storage adapter>,
 *   network: [<network adapter>, <network adapter>]
 * })
 *
 * const handle = repo.create
 * ```
 */ 

var $1SXIy = parcelRequire("1SXIy");
var $28edd11f6c7e9f5f$exports = {};
'use strict';
var $28edd11f6c7e9f5f$var$has = Object.prototype.hasOwnProperty, $28edd11f6c7e9f5f$var$prefix = '~';
/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @private
 */ function $28edd11f6c7e9f5f$var$Events() {}
//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if (Object.create) {
    $28edd11f6c7e9f5f$var$Events.prototype = Object.create(null);
    //
    // This hack is needed because the `__proto__` property is still inherited in
    // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
    //
    if (!new $28edd11f6c7e9f5f$var$Events().__proto__) $28edd11f6c7e9f5f$var$prefix = false;
}
/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @private
 */ function $28edd11f6c7e9f5f$var$EE(fn, context, once) {
    this.fn = fn;
    this.context = context;
    this.once = once || false;
}
/**
 * Add a listener for a given event.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} once Specify if the listener is a one-time listener.
 * @returns {EventEmitter}
 * @private
 */ function $28edd11f6c7e9f5f$var$addListener(emitter, event, fn, context, once) {
    if (typeof fn !== 'function') throw new TypeError('The listener must be a function');
    var listener = new $28edd11f6c7e9f5f$var$EE(fn, context || emitter, once), evt = $28edd11f6c7e9f5f$var$prefix ? $28edd11f6c7e9f5f$var$prefix + event : event;
    if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
    else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
    else emitter._events[evt] = [
        emitter._events[evt],
        listener
    ];
    return emitter;
}
/**
 * Clear event by name.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} evt The Event name.
 * @private
 */ function $28edd11f6c7e9f5f$var$clearEvent(emitter, evt) {
    if (--emitter._eventsCount === 0) emitter._events = new $28edd11f6c7e9f5f$var$Events();
    else delete emitter._events[evt];
}
/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @public
 */ function $28edd11f6c7e9f5f$var$EventEmitter() {
    this._events = new $28edd11f6c7e9f5f$var$Events();
    this._eventsCount = 0;
}
/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @public
 */ $28edd11f6c7e9f5f$var$EventEmitter.prototype.eventNames = function eventNames() {
    var names = [], events, name;
    if (this._eventsCount === 0) return names;
    for(name in events = this._events)if ($28edd11f6c7e9f5f$var$has.call(events, name)) names.push($28edd11f6c7e9f5f$var$prefix ? name.slice(1) : name);
    if (Object.getOwnPropertySymbols) return names.concat(Object.getOwnPropertySymbols(events));
    return names;
};
/**
 * Return the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Array} The registered listeners.
 * @public
 */ $28edd11f6c7e9f5f$var$EventEmitter.prototype.listeners = function listeners(event) {
    var evt = $28edd11f6c7e9f5f$var$prefix ? $28edd11f6c7e9f5f$var$prefix + event : event, handlers = this._events[evt];
    if (!handlers) return [];
    if (handlers.fn) return [
        handlers.fn
    ];
    for(var i = 0, l = handlers.length, ee = new Array(l); i < l; i++)ee[i] = handlers[i].fn;
    return ee;
};
/**
 * Return the number of listeners listening to a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Number} The number of listeners.
 * @public
 */ $28edd11f6c7e9f5f$var$EventEmitter.prototype.listenerCount = function listenerCount(event) {
    var evt = $28edd11f6c7e9f5f$var$prefix ? $28edd11f6c7e9f5f$var$prefix + event : event, listeners = this._events[evt];
    if (!listeners) return 0;
    if (listeners.fn) return 1;
    return listeners.length;
};
/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @public
 */ $28edd11f6c7e9f5f$var$EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
    var evt = $28edd11f6c7e9f5f$var$prefix ? $28edd11f6c7e9f5f$var$prefix + event : event;
    if (!this._events[evt]) return false;
    var listeners = this._events[evt], len = arguments.length, args, i;
    if (listeners.fn) {
        if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
        switch(len){
            case 1:
                return listeners.fn.call(listeners.context), true;
            case 2:
                return listeners.fn.call(listeners.context, a1), true;
            case 3:
                return listeners.fn.call(listeners.context, a1, a2), true;
            case 4:
                return listeners.fn.call(listeners.context, a1, a2, a3), true;
            case 5:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
            case 6:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
        }
        for(i = 1, args = new Array(len - 1); i < len; i++)args[i - 1] = arguments[i];
        listeners.fn.apply(listeners.context, args);
    } else {
        var length = listeners.length, j;
        for(i = 0; i < length; i++){
            if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
            switch(len){
                case 1:
                    listeners[i].fn.call(listeners[i].context);
                    break;
                case 2:
                    listeners[i].fn.call(listeners[i].context, a1);
                    break;
                case 3:
                    listeners[i].fn.call(listeners[i].context, a1, a2);
                    break;
                case 4:
                    listeners[i].fn.call(listeners[i].context, a1, a2, a3);
                    break;
                default:
                    if (!args) for(j = 1, args = new Array(len - 1); j < len; j++)args[j - 1] = arguments[j];
                    listeners[i].fn.apply(listeners[i].context, args);
            }
        }
    }
    return true;
};
/**
 * Add a listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $28edd11f6c7e9f5f$var$EventEmitter.prototype.on = function on(event, fn, context) {
    return $28edd11f6c7e9f5f$var$addListener(this, event, fn, context, false);
};
/**
 * Add a one-time listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $28edd11f6c7e9f5f$var$EventEmitter.prototype.once = function once(event, fn, context) {
    return $28edd11f6c7e9f5f$var$addListener(this, event, fn, context, true);
};
/**
 * Remove the listeners of a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {*} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @public
 */ $28edd11f6c7e9f5f$var$EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
    var evt = $28edd11f6c7e9f5f$var$prefix ? $28edd11f6c7e9f5f$var$prefix + event : event;
    if (!this._events[evt]) return this;
    if (!fn) {
        $28edd11f6c7e9f5f$var$clearEvent(this, evt);
        return this;
    }
    var listeners = this._events[evt];
    if (listeners.fn) {
        if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) $28edd11f6c7e9f5f$var$clearEvent(this, evt);
    } else {
        for(var i = 0, events = [], length = listeners.length; i < length; i++)if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) events.push(listeners[i]);
        //
        // Reset the array, or remove it completely if we have no more listeners.
        //
        if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
        else $28edd11f6c7e9f5f$var$clearEvent(this, evt);
    }
    return this;
};
/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {(String|Symbol)} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @public
 */ $28edd11f6c7e9f5f$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
    var evt;
    if (event) {
        evt = $28edd11f6c7e9f5f$var$prefix ? $28edd11f6c7e9f5f$var$prefix + event : event;
        if (this._events[evt]) $28edd11f6c7e9f5f$var$clearEvent(this, evt);
    } else {
        this._events = new $28edd11f6c7e9f5f$var$Events();
        this._eventsCount = 0;
    }
    return this;
};
//
// Alias methods names because people roll like that.
//
$28edd11f6c7e9f5f$var$EventEmitter.prototype.off = $28edd11f6c7e9f5f$var$EventEmitter.prototype.removeListener;
$28edd11f6c7e9f5f$var$EventEmitter.prototype.addListener = $28edd11f6c7e9f5f$var$EventEmitter.prototype.on;
//
// Expose the prefix.
//
$28edd11f6c7e9f5f$var$EventEmitter.prefixed = $28edd11f6c7e9f5f$var$prefix;
//
// Allow `EventEmitter` to be imported as module namespace.
//
$28edd11f6c7e9f5f$var$EventEmitter.EventEmitter = $28edd11f6c7e9f5f$var$EventEmitter;
$28edd11f6c7e9f5f$exports = $28edd11f6c7e9f5f$var$EventEmitter;


var $70aaa28ae275c84c$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($28edd11f6c7e9f5f$exports)));


// From https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/globalThis
function $3d6864ccf6dcf000$export$a4e55266d2135a7f() {
    if (typeof globalThis !== 'undefined') return globalThis;
    if (typeof self !== 'undefined') return self;
    if (typeof window !== 'undefined') return window;
    if (typeof $parcel$global !== 'undefined') return $parcel$global;
}
function $3d6864ccf6dcf000$var$getDevTools() {
    const w = $3d6864ccf6dcf000$export$a4e55266d2135a7f();
    if (w.__xstate__) return w.__xstate__;
    return undefined;
}
function $3d6864ccf6dcf000$export$4d7a7d14704ebc13(service) {
    if (typeof window === 'undefined') return;
    const devTools = $3d6864ccf6dcf000$var$getDevTools();
    if (devTools) devTools.register(service);
}
const $3d6864ccf6dcf000$export$3ee8010769463234 = (service)=>{
    if (typeof window === 'undefined') return;
    const devTools = $3d6864ccf6dcf000$var$getDevTools();
    if (devTools) devTools.register(service);
};


class $59def02d21be1ba1$var$Mailbox {
    constructor(_process){
        this._process = _process;
        this._active = false;
        this._current = null;
        this._last = null;
    }
    start() {
        this._active = true;
        this.flush();
    }
    clear() {
        // we can't set _current to null because we might be currently processing
        // and enqueue following clear shouldn't start processing the enqueued item immediately
        if (this._current) {
            this._current.next = null;
            this._last = this._current;
        }
    }
    enqueue(event) {
        const enqueued = {
            value: event,
            next: null
        };
        if (this._current) {
            this._last.next = enqueued;
            this._last = enqueued;
            return;
        }
        this._current = enqueued;
        this._last = enqueued;
        if (this._active) this.flush();
    }
    flush() {
        while(this._current){
            // atm the given _process is responsible for implementing proper try/catch handling
            // we assume here that this won't throw in a way that can affect this mailbox
            const consumed = this._current;
            this._process(consumed.value);
            this._current = consumed.next;
        }
        this._last = null;
    }
}
const $59def02d21be1ba1$export$25ce5a424b770e84 = '.';
const $59def02d21be1ba1$var$TARGETLESS_KEY = '';
const $59def02d21be1ba1$export$a07804094c3ecf2d = '';
const $59def02d21be1ba1$var$STATE_IDENTIFIER = '#';
const $59def02d21be1ba1$var$WILDCARD = '*';
const $59def02d21be1ba1$var$XSTATE_INIT = 'xstate.init';
const $59def02d21be1ba1$export$71cec2538cb2c617 = 'xstate.error';
const $59def02d21be1ba1$export$78acf4525d8a74c4 = 'xstate.stop';
/**
 * Returns an event that represents an implicit event that is sent after the
 * specified `delay`.
 *
 * @param delayRef The delay in milliseconds
 * @param id The state node ID where this event is handled
 */ function $59def02d21be1ba1$var$createAfterEvent(delayRef, id) {
    return {
        type: `xstate.after.${delayRef}.${id}`
    };
}
/**
 * Returns an event that represents that a final state node has been reached in
 * the parent state node.
 *
 * @param id The final state node's parent state node `id`
 * @param output The data to pass into the event
 */ function $59def02d21be1ba1$var$createDoneStateEvent(id, output) {
    return {
        type: `xstate.done.state.${id}`,
        output: output
    };
}
/**
 * Returns an event that represents that an invoked service has terminated.
 *
 * An invoked service is terminated when it has reached a top-level final state
 * node, but not when it is canceled.
 *
 * @param invokeId The invoked service ID
 * @param output The data to pass into the event
 */ function $59def02d21be1ba1$var$createDoneActorEvent(invokeId, output) {
    return {
        type: `xstate.done.actor.${invokeId}`,
        output: output,
        actorId: invokeId
    };
}
function $59def02d21be1ba1$export$8743009a87fcb00f(id, error) {
    return {
        type: `xstate.error.actor.${id}`,
        error: error,
        actorId: id
    };
}
function $59def02d21be1ba1$export$f1e1789686576879(input) {
    return {
        type: $59def02d21be1ba1$var$XSTATE_INIT,
        input: input
    };
}
/**
 * This function makes sure that unhandled errors are thrown in a separate
 * macrotask. It allows those errors to be detected by global error handlers and
 * reported to bug tracking services without interrupting our own stack of
 * execution.
 *
 * @param err Error to be thrown
 */ function $59def02d21be1ba1$var$reportUnhandledError(err) {
    setTimeout(()=>{
        throw err;
    });
}
const $59def02d21be1ba1$var$symbolObservable = (()=>typeof Symbol === 'function' && Symbol.observable || '@@observable')();
function $59def02d21be1ba1$export$3b14a55fb2447963(parentStateId, childStateId) {
    const parentStateValue = $59def02d21be1ba1$var$toStateValue(parentStateId);
    const childStateValue = $59def02d21be1ba1$var$toStateValue(childStateId);
    if (typeof childStateValue === 'string') {
        if (typeof parentStateValue === 'string') return childStateValue === parentStateValue;
        // Parent more specific than child
        return false;
    }
    if (typeof parentStateValue === 'string') return parentStateValue in childStateValue;
    return Object.keys(parentStateValue).every((key)=>{
        if (!(key in childStateValue)) return false;
        return $59def02d21be1ba1$export$3b14a55fb2447963(parentStateValue[key], childStateValue[key]);
    });
}
function $59def02d21be1ba1$export$3722cfe417b6ed86(stateId) {
    if ($59def02d21be1ba1$var$isArray(stateId)) return stateId;
    const result = [];
    let segment = '';
    for(let i = 0; i < stateId.length; i++){
        const char = stateId.charCodeAt(i);
        switch(char){
            // \
            case 92:
                // consume the next character
                segment += stateId[i + 1];
                // and skip over it
                i++;
                continue;
            // .
            case 46:
                result.push(segment);
                segment = '';
                continue;
        }
        segment += stateId[i];
    }
    result.push(segment);
    return result;
}
function $59def02d21be1ba1$var$toStateValue(stateValue) {
    if ($59def02d21be1ba1$export$882b5998b3b9117c(stateValue)) return stateValue.value;
    if (typeof stateValue !== 'string') return stateValue;
    const statePath = $59def02d21be1ba1$export$3722cfe417b6ed86(stateValue);
    return $59def02d21be1ba1$export$90a7f3efeed30595(statePath);
}
function $59def02d21be1ba1$export$90a7f3efeed30595(statePath) {
    if (statePath.length === 1) return statePath[0];
    const value = {};
    let marker = value;
    for(let i = 0; i < statePath.length - 1; i++)if (i === statePath.length - 2) marker[statePath[i]] = statePath[i + 1];
    else {
        const previous = marker;
        marker = {};
        previous[statePath[i]] = marker;
    }
    return value;
}
function $59def02d21be1ba1$export$4a5767248b18ef41(collection, iteratee) {
    const result = {};
    const collectionKeys = Object.keys(collection);
    for(let i = 0; i < collectionKeys.length; i++){
        const key = collectionKeys[i];
        result[key] = iteratee(collection[key], key, collection, i);
    }
    return result;
}
function $59def02d21be1ba1$var$toArrayStrict(value) {
    if ($59def02d21be1ba1$var$isArray(value)) return value;
    return [
        value
    ];
}
function $59def02d21be1ba1$export$625550452a3fa3ec(value) {
    if (value === undefined) return [];
    return $59def02d21be1ba1$var$toArrayStrict(value);
}
function $59def02d21be1ba1$var$resolveOutput(mapper, context, event, self) {
    if (typeof mapper === 'function') return mapper({
        context: context,
        event: event,
        self: self
    });
    return mapper;
}
function $59def02d21be1ba1$var$isArray(value) {
    return Array.isArray(value);
}
function $59def02d21be1ba1$var$isErrorActorEvent(event) {
    return event.type.startsWith('xstate.error.actor');
}
function $59def02d21be1ba1$export$ef35774e6d314e91(configLike) {
    return $59def02d21be1ba1$var$toArrayStrict(configLike).map((transitionLike)=>{
        if (typeof transitionLike === 'undefined' || typeof transitionLike === 'string') return {
            target: transitionLike
        };
        return transitionLike;
    });
}
function $59def02d21be1ba1$var$normalizeTarget(target) {
    if (target === undefined || target === $59def02d21be1ba1$var$TARGETLESS_KEY) return undefined;
    return $59def02d21be1ba1$export$625550452a3fa3ec(target);
}
function $59def02d21be1ba1$export$efccba1c4a2ef57b(nextHandler, errorHandler, completionHandler) {
    const isObserver = typeof nextHandler === 'object';
    const self = isObserver ? nextHandler : undefined;
    return {
        next: (isObserver ? nextHandler.next : nextHandler)?.bind(self),
        error: (isObserver ? nextHandler.error : errorHandler)?.bind(self),
        complete: (isObserver ? nextHandler.complete : completionHandler)?.bind(self)
    };
}
function $59def02d21be1ba1$export$a9c23c6ac3fc3eca(stateNodeId, index) {
    return `${index}.${stateNodeId}`;
}
function $59def02d21be1ba1$export$e7c866399fa523f5(machine, src) {
    const match = src.match(/^xstate\.invoke\.(\d+)\.(.*)/);
    if (!match) return machine.implementations.actors[src];
    const [, indexStr, nodeId] = match;
    const node = machine.getStateNodeById(nodeId);
    const invokeConfig = node.config.invoke;
    return (Array.isArray(invokeConfig) ? invokeConfig[indexStr] : invokeConfig).src;
}
function $59def02d21be1ba1$export$9e5f44173e64f162(snapshot) {
    return [
        ...new Set([
            ...snapshot._nodes.flatMap((sn)=>sn.ownEvents)
        ])
    ];
}
/**
 * Checks if an event type matches an event descriptor, supporting wildcards.
 * Event descriptors can be:
 *
 * - Exact matches: "event.type"
 * - Wildcard: "*"
 * - Partial matches: "event.*"
 *
 * @param eventType - The actual event type string
 * @param descriptor - The event descriptor to match against
 * @returns True if the event type matches the descriptor
 */ function $59def02d21be1ba1$export$953cecd6e717a553(eventType, descriptor) {
    if (descriptor === eventType) return true;
    if (descriptor === $59def02d21be1ba1$var$WILDCARD) return true;
    if (!descriptor.endsWith('.*')) return false;
    const partialEventTokens = descriptor.split('.');
    const eventTokens = eventType.split('.');
    for(let tokenIndex = 0; tokenIndex < partialEventTokens.length; tokenIndex++){
        const partialEventToken = partialEventTokens[tokenIndex];
        const eventToken = eventTokens[tokenIndex];
        if (partialEventToken === '*') {
            const isLastToken = tokenIndex === partialEventTokens.length - 1;
            return isLastToken;
        }
        if (partialEventToken !== eventToken) return false;
    }
    return true;
}
function $59def02d21be1ba1$var$createScheduledEventId(actorRef, id) {
    return `${actorRef.sessionId}.${id}`;
}
let $59def02d21be1ba1$var$idCounter = 0;
function $59def02d21be1ba1$var$createSystem(rootActor, options) {
    const children = new Map();
    const keyedActors = new Map();
    const reverseKeyedActors = new WeakMap();
    const inspectionObservers = new Set();
    const timerMap = {};
    const { clock: clock, logger: logger } = options;
    const scheduler = {
        schedule: (source, target, event, delay, id = Math.random().toString(36).slice(2))=>{
            const scheduledEvent = {
                source: source,
                target: target,
                event: event,
                delay: delay,
                id: id,
                startedAt: Date.now()
            };
            const scheduledEventId = $59def02d21be1ba1$var$createScheduledEventId(source, id);
            system._snapshot._scheduledEvents[scheduledEventId] = scheduledEvent;
            const timeout = clock.setTimeout(()=>{
                delete timerMap[scheduledEventId];
                delete system._snapshot._scheduledEvents[scheduledEventId];
                system._relay(source, target, event);
            }, delay);
            timerMap[scheduledEventId] = timeout;
        },
        cancel: (source, id)=>{
            const scheduledEventId = $59def02d21be1ba1$var$createScheduledEventId(source, id);
            const timeout = timerMap[scheduledEventId];
            delete timerMap[scheduledEventId];
            delete system._snapshot._scheduledEvents[scheduledEventId];
            if (timeout !== undefined) clock.clearTimeout(timeout);
        },
        cancelAll: (actorRef)=>{
            for(const scheduledEventId in system._snapshot._scheduledEvents){
                const scheduledEvent = system._snapshot._scheduledEvents[scheduledEventId];
                if (scheduledEvent.source === actorRef) scheduler.cancel(actorRef, scheduledEvent.id);
            }
        }
    };
    const sendInspectionEvent = (event)=>{
        if (!inspectionObservers.size) return;
        const resolvedInspectionEvent = {
            ...event,
            rootId: rootActor.sessionId
        };
        inspectionObservers.forEach((observer)=>observer.next?.(resolvedInspectionEvent));
    };
    const system = {
        _snapshot: {
            _scheduledEvents: (options?.snapshot && options.snapshot.scheduler) ?? {}
        },
        _bookId: ()=>`x:${$59def02d21be1ba1$var$idCounter++}`,
        _register: (sessionId, actorRef)=>{
            children.set(sessionId, actorRef);
            return sessionId;
        },
        _unregister: (actorRef)=>{
            children.delete(actorRef.sessionId);
            const systemId = reverseKeyedActors.get(actorRef);
            if (systemId !== undefined) {
                keyedActors.delete(systemId);
                reverseKeyedActors.delete(actorRef);
            }
        },
        get: (systemId)=>{
            return keyedActors.get(systemId);
        },
        getAll: ()=>{
            return Object.fromEntries(keyedActors.entries());
        },
        _set: (systemId, actorRef)=>{
            const existing = keyedActors.get(systemId);
            if (existing && existing !== actorRef) throw new Error(`Actor with system ID '${systemId}' already exists.`);
            keyedActors.set(systemId, actorRef);
            reverseKeyedActors.set(actorRef, systemId);
        },
        inspect: (observerOrFn)=>{
            const observer = $59def02d21be1ba1$export$efccba1c4a2ef57b(observerOrFn);
            inspectionObservers.add(observer);
            return {
                unsubscribe () {
                    inspectionObservers.delete(observer);
                }
            };
        },
        _sendInspectionEvent: sendInspectionEvent,
        _relay: (source, target, event)=>{
            system._sendInspectionEvent({
                type: '@xstate.event',
                sourceRef: source,
                actorRef: target,
                event: event
            });
            target._send(event);
        },
        scheduler: scheduler,
        getSnapshot: ()=>{
            return {
                _scheduledEvents: {
                    ...system._snapshot._scheduledEvents
                }
            };
        },
        start: ()=>{
            const scheduledEvents = system._snapshot._scheduledEvents;
            system._snapshot._scheduledEvents = {};
            for(const scheduledId in scheduledEvents){
                const { source: source, target: target, event: event, delay: delay, id: id } = scheduledEvents[scheduledId];
                scheduler.schedule(source, target, event, delay, id);
            }
        },
        _clock: clock,
        _logger: logger
    };
    return system;
}
// those are needed to make JSDoc `@link` work properly
let $59def02d21be1ba1$var$executingCustomAction = false;
const $59def02d21be1ba1$export$3d8c2f653ac9d0b9 = 1;
// those values are currently used by @xstate/react directly so it's important to keep the assigned values in sync
let $59def02d21be1ba1$export$dc98b0b04f4c7758 = /*#__PURE__*/ function(ProcessingStatus) {
    ProcessingStatus[ProcessingStatus["NotStarted"] = 0] = "NotStarted";
    ProcessingStatus[ProcessingStatus["Running"] = 1] = "Running";
    ProcessingStatus[ProcessingStatus["Stopped"] = 2] = "Stopped";
    return ProcessingStatus;
}({});
const $59def02d21be1ba1$var$defaultOptions = {
    clock: {
        setTimeout: (fn, ms)=>{
            return setTimeout(fn, ms);
        },
        clearTimeout: (id)=>{
            return clearTimeout(id);
        }
    },
    logger: console.log.bind(console),
    devTools: false
};
/**
 * An Actor is a running process that can receive events, send events and change
 * its behavior based on the events it receives, which can cause effects outside
 * of the actor. When you run a state machine, it becomes an actor.
 */ class $59def02d21be1ba1$export$ebd11618f299a286 {
    /**
   * Creates a new actor instance for the given logic with the provided options,
   * if any.
   *
   * @param logic The logic to create an actor from
   * @param options Actor options
   */ constructor(logic, options){
        this.logic = logic;
        /** The current internal state of the actor. */ this._snapshot = void 0;
        /**
     * The clock that is responsible for setting and clearing timeouts, such as
     * delayed events and transitions.
     */ this.clock = void 0;
        this.options = void 0;
        /** The unique identifier for this actor relative to its parent. */ this.id = void 0;
        this.mailbox = new $59def02d21be1ba1$var$Mailbox(this._process.bind(this));
        this.observers = new Set();
        this.eventListeners = new Map();
        this.logger = void 0;
        /** @internal */ this._processingStatus = $59def02d21be1ba1$export$dc98b0b04f4c7758.NotStarted;
        // Actor Ref
        this._parent = void 0;
        /** @internal */ this._syncSnapshot = void 0;
        this.ref = void 0;
        // TODO: add typings for system
        this._actorScope = void 0;
        this.systemId = void 0;
        /** The globally unique process ID for this invocation. */ this.sessionId = void 0;
        /** The system to which this actor belongs. */ this.system = void 0;
        this._doneEvent = void 0;
        this.src = void 0;
        // array of functions to defer
        this._deferred = [];
        const resolvedOptions = {
            ...$59def02d21be1ba1$var$defaultOptions,
            ...options
        };
        const { clock: clock, logger: logger, parent: parent, syncSnapshot: syncSnapshot, id: id, systemId: systemId, inspect: inspect } = resolvedOptions;
        this.system = parent ? parent.system : $59def02d21be1ba1$var$createSystem(this, {
            clock: clock,
            logger: logger
        });
        if (inspect && !parent) // Always inspect at the system-level
        this.system.inspect($59def02d21be1ba1$export$efccba1c4a2ef57b(inspect));
        this.sessionId = this.system._bookId();
        this.id = id ?? this.sessionId;
        this.logger = options?.logger ?? this.system._logger;
        this.clock = options?.clock ?? this.system._clock;
        this._parent = parent;
        this._syncSnapshot = syncSnapshot;
        this.options = resolvedOptions;
        this.src = resolvedOptions.src ?? logic;
        this.ref = this;
        this._actorScope = {
            self: this,
            id: this.id,
            sessionId: this.sessionId,
            logger: this.logger,
            defer: (fn)=>{
                this._deferred.push(fn);
            },
            system: this.system,
            stopChild: (child)=>{
                if (child._parent !== this) throw new Error(`Cannot stop child actor ${child.id} of ${this.id} because it is not a child`);
                child._stop();
            },
            emit: (emittedEvent)=>{
                const listeners = this.eventListeners.get(emittedEvent.type);
                const wildcardListener = this.eventListeners.get('*');
                if (!listeners && !wildcardListener) return;
                const allListeners = [
                    ...listeners ? listeners.values() : [],
                    ...wildcardListener ? wildcardListener.values() : []
                ];
                for (const handler of allListeners)try {
                    handler(emittedEvent);
                } catch (err) {
                    $59def02d21be1ba1$var$reportUnhandledError(err);
                }
            },
            actionExecutor: (action)=>{
                const exec = ()=>{
                    this._actorScope.system._sendInspectionEvent({
                        type: '@xstate.action',
                        actorRef: this,
                        action: {
                            type: action.type,
                            params: action.params
                        }
                    });
                    if (!action.exec) return;
                    const saveExecutingCustomAction = $59def02d21be1ba1$var$executingCustomAction;
                    try {
                        $59def02d21be1ba1$var$executingCustomAction = true;
                        action.exec(action.info, action.params);
                    } finally{
                        $59def02d21be1ba1$var$executingCustomAction = saveExecutingCustomAction;
                    }
                };
                if (this._processingStatus === $59def02d21be1ba1$export$dc98b0b04f4c7758.Running) exec();
                else this._deferred.push(exec);
            }
        };
        // Ensure that the send method is bound to this Actor instance
        // if destructured
        this.send = this.send.bind(this);
        this.system._sendInspectionEvent({
            type: '@xstate.actor',
            actorRef: this
        });
        if (systemId) {
            this.systemId = systemId;
            this.system._set(systemId, this);
        }
        this._initState(options?.snapshot ?? options?.state);
        if (systemId && this._snapshot.status !== 'active') this.system._unregister(this);
    }
    _initState(persistedState) {
        try {
            this._snapshot = persistedState ? this.logic.restoreSnapshot ? this.logic.restoreSnapshot(persistedState, this._actorScope) : persistedState : this.logic.getInitialSnapshot(this._actorScope, this.options?.input);
        } catch (err) {
            // if we get here then it means that we assign a value to this._snapshot that is not of the correct type
            // we can't get the true `TSnapshot & { status: 'error'; }`, it's impossible
            // so right now this is a lie of sorts
            this._snapshot = {
                status: 'error',
                output: undefined,
                error: err
            };
        }
    }
    update(snapshot, event) {
        // Update state
        this._snapshot = snapshot;
        // Execute deferred effects
        let deferredFn;
        while(deferredFn = this._deferred.shift())try {
            deferredFn();
        } catch (err) {
            // this error can only be caught when executing *initial* actions
            // it's the only time when we call actions provided by the user through those deferreds
            // when the actor is already running we always execute them synchronously while transitioning
            // no "builtin deferred" should actually throw an error since they are either safe
            // or the control flow is passed through the mailbox and errors should be caught by the `_process` used by the mailbox
            this._deferred.length = 0;
            this._snapshot = {
                ...snapshot,
                status: 'error',
                error: err
            };
        }
        switch(this._snapshot.status){
            case 'active':
                for (const observer of this.observers)try {
                    observer.next?.(snapshot);
                } catch (err) {
                    $59def02d21be1ba1$var$reportUnhandledError(err);
                }
                break;
            case 'done':
                // next observers are meant to be notified about done snapshots
                // this can be seen as something that is different from how observable work
                // but with observables `complete` callback is called without any arguments
                // it's more ergonomic for XState to treat a done snapshot as a "next" value
                // and the completion event as something that is separate,
                // something that merely follows emitting that done snapshot
                for (const observer of this.observers)try {
                    observer.next?.(snapshot);
                } catch (err) {
                    $59def02d21be1ba1$var$reportUnhandledError(err);
                }
                this._stopProcedure();
                this._complete();
                this._doneEvent = $59def02d21be1ba1$var$createDoneActorEvent(this.id, this._snapshot.output);
                if (this._parent) this.system._relay(this, this._parent, this._doneEvent);
                break;
            case 'error':
                this._error(this._snapshot.error);
                break;
        }
        this.system._sendInspectionEvent({
            type: '@xstate.snapshot',
            actorRef: this,
            event: event,
            snapshot: snapshot
        });
    }
    /**
   * Subscribe an observer to an actor’s snapshot values.
   *
   * @remarks
   * The observer will receive the actor’s snapshot value when it is emitted.
   * The observer can be:
   *
   * - A plain function that receives the latest snapshot, or
   * - An observer object whose `.next(snapshot)` method receives the latest
   *   snapshot
   *
   * @example
   *
   * ```ts
   * // Observer as a plain function
   * const subscription = actor.subscribe((snapshot) => {
   *   console.log(snapshot);
   * });
   * ```
   *
   * @example
   *
   * ```ts
   * // Observer as an object
   * const subscription = actor.subscribe({
   *   next(snapshot) {
   *     console.log(snapshot);
   *   },
   *   error(err) {
   *     // ...
   *   },
   *   complete() {
   *     // ...
   *   }
   * });
   * ```
   *
   * The return value of `actor.subscribe(observer)` is a subscription object
   * that has an `.unsubscribe()` method. You can call
   * `subscription.unsubscribe()` to unsubscribe the observer:
   *
   * @example
   *
   * ```ts
   * const subscription = actor.subscribe((snapshot) => {
   *   // ...
   * });
   *
   * // Unsubscribe the observer
   * subscription.unsubscribe();
   * ```
   *
   * When the actor is stopped, all of its observers will automatically be
   * unsubscribed.
   *
   * @param observer - Either a plain function that receives the latest
   *   snapshot, or an observer object whose `.next(snapshot)` method receives
   *   the latest snapshot
   */ subscribe(nextListenerOrObserver, errorListener, completeListener) {
        const observer = $59def02d21be1ba1$export$efccba1c4a2ef57b(nextListenerOrObserver, errorListener, completeListener);
        if (this._processingStatus !== $59def02d21be1ba1$export$dc98b0b04f4c7758.Stopped) this.observers.add(observer);
        else switch(this._snapshot.status){
            case 'done':
                try {
                    observer.complete?.();
                } catch (err) {
                    $59def02d21be1ba1$var$reportUnhandledError(err);
                }
                break;
            case 'error':
                {
                    const err = this._snapshot.error;
                    if (!observer.error) $59def02d21be1ba1$var$reportUnhandledError(err);
                    else try {
                        observer.error(err);
                    } catch (err) {
                        $59def02d21be1ba1$var$reportUnhandledError(err);
                    }
                    break;
                }
        }
        return {
            unsubscribe: ()=>{
                this.observers.delete(observer);
            }
        };
    }
    on(type, handler) {
        let listeners = this.eventListeners.get(type);
        if (!listeners) {
            listeners = new Set();
            this.eventListeners.set(type, listeners);
        }
        const wrappedHandler = handler.bind(undefined);
        listeners.add(wrappedHandler);
        return {
            unsubscribe: ()=>{
                listeners.delete(wrappedHandler);
            }
        };
    }
    /** Starts the Actor from the initial state */ start() {
        if (this._processingStatus === $59def02d21be1ba1$export$dc98b0b04f4c7758.Running) // Do not restart the service if it is already started
        return this;
        if (this._syncSnapshot) this.subscribe({
            next: (snapshot)=>{
                if (snapshot.status === 'active') this.system._relay(this, this._parent, {
                    type: `xstate.snapshot.${this.id}`,
                    snapshot: snapshot
                });
            },
            error: ()=>{}
        });
        this.system._register(this.sessionId, this);
        if (this.systemId) this.system._set(this.systemId, this);
        this._processingStatus = $59def02d21be1ba1$export$dc98b0b04f4c7758.Running;
        // TODO: this isn't correct when rehydrating
        const initEvent = $59def02d21be1ba1$export$f1e1789686576879(this.options.input);
        this.system._sendInspectionEvent({
            type: '@xstate.event',
            sourceRef: this._parent,
            actorRef: this,
            event: initEvent
        });
        const status = this._snapshot.status;
        switch(status){
            case 'done':
                // a state machine can be "done" upon initialization (it could reach a final state using initial microsteps)
                // we still need to complete observers, flush deferreds etc
                this.update(this._snapshot, initEvent);
                // TODO: rethink cleanup of observers, mailbox, etc
                return this;
            case 'error':
                this._error(this._snapshot.error);
                return this;
        }
        if (!this._parent) this.system.start();
        if (this.logic.start) try {
            this.logic.start(this._snapshot, this._actorScope);
        } catch (err) {
            this._snapshot = {
                ...this._snapshot,
                status: 'error',
                error: err
            };
            this._error(err);
            return this;
        }
        // TODO: this notifies all subscribers but usually this is redundant
        // there is no real change happening here
        // we need to rethink if this needs to be refactored
        this.update(this._snapshot, initEvent);
        if (this.options.devTools) this.attachDevTools();
        this.mailbox.start();
        return this;
    }
    _process(event) {
        let nextState;
        let caughtError;
        try {
            nextState = this.logic.transition(this._snapshot, event, this._actorScope);
        } catch (err) {
            // we wrap it in a box so we can rethrow it later even if falsy value gets caught here
            caughtError = {
                err: err
            };
        }
        if (caughtError) {
            const { err: err } = caughtError;
            this._snapshot = {
                ...this._snapshot,
                status: 'error',
                error: err
            };
            this._error(err);
            return;
        }
        this.update(nextState, event);
        if (event.type === $59def02d21be1ba1$export$78acf4525d8a74c4) {
            this._stopProcedure();
            this._complete();
        }
    }
    _stop() {
        if (this._processingStatus === $59def02d21be1ba1$export$dc98b0b04f4c7758.Stopped) return this;
        this.mailbox.clear();
        if (this._processingStatus === $59def02d21be1ba1$export$dc98b0b04f4c7758.NotStarted) {
            this._processingStatus = $59def02d21be1ba1$export$dc98b0b04f4c7758.Stopped;
            return this;
        }
        this.mailbox.enqueue({
            type: $59def02d21be1ba1$export$78acf4525d8a74c4
        });
        return this;
    }
    /** Stops the Actor and unsubscribe all listeners. */ stop() {
        if (this._parent) throw new Error('A non-root actor cannot be stopped directly.');
        return this._stop();
    }
    _complete() {
        for (const observer of this.observers)try {
            observer.complete?.();
        } catch (err) {
            $59def02d21be1ba1$var$reportUnhandledError(err);
        }
        this.observers.clear();
        this.eventListeners.clear();
    }
    _reportError(err) {
        if (!this.observers.size) {
            if (!this._parent) $59def02d21be1ba1$var$reportUnhandledError(err);
            this.eventListeners.clear();
            return;
        }
        let reportError = false;
        for (const observer of this.observers){
            const errorListener = observer.error;
            reportError ||= !errorListener;
            try {
                errorListener?.(err);
            } catch (err2) {
                $59def02d21be1ba1$var$reportUnhandledError(err2);
            }
        }
        this.observers.clear();
        this.eventListeners.clear();
        if (reportError) $59def02d21be1ba1$var$reportUnhandledError(err);
    }
    _error(err) {
        this._stopProcedure();
        this._reportError(err);
        if (this._parent) this.system._relay(this, this._parent, $59def02d21be1ba1$export$8743009a87fcb00f(this.id, err));
    }
    // TODO: atm children don't belong entirely to the actor so
    // in a way - it's not even super aware of them
    // so we can't stop them from here but we really should!
    // right now, they are being stopped within the machine's transition
    // but that could throw and leave us with "orphaned" active actors
    _stopProcedure() {
        if (this._processingStatus !== $59def02d21be1ba1$export$dc98b0b04f4c7758.Running) // Actor already stopped; do nothing
        return this;
        // Cancel all delayed events
        this.system.scheduler.cancelAll(this);
        // TODO: mailbox.reset
        this.mailbox.clear();
        // TODO: after `stop` we must prepare ourselves for receiving events again
        // events sent *after* stop signal must be queued
        // it seems like this should be the common behavior for all of our consumers
        // so perhaps this should be unified somehow for all of them
        this.mailbox = new $59def02d21be1ba1$var$Mailbox(this._process.bind(this));
        this._processingStatus = $59def02d21be1ba1$export$dc98b0b04f4c7758.Stopped;
        this.system._unregister(this);
        return this;
    }
    /** @internal */ _send(event) {
        if (this._processingStatus === $59def02d21be1ba1$export$dc98b0b04f4c7758.Stopped) return;
        this.mailbox.enqueue(event);
    }
    /**
   * Sends an event to the running Actor to trigger a transition.
   *
   * @param event The event to send
   */ send(event) {
        this.system._relay(undefined, this, event);
    }
    attachDevTools() {
        const { devTools: devTools } = this.options;
        if (devTools) {
            const resolvedDevToolsAdapter = typeof devTools === 'function' ? devTools : (0, $3d6864ccf6dcf000$export$3ee8010769463234);
            resolvedDevToolsAdapter(this);
        }
    }
    toJSON() {
        return {
            xstate$$type: $59def02d21be1ba1$export$3d8c2f653ac9d0b9,
            id: this.id
        };
    }
    /**
   * Obtain the internal state of the actor, which can be persisted.
   *
   * @remarks
   * The internal state can be persisted from any actor, not only machines.
   *
   * Note that the persisted state is not the same as the snapshot from
   * {@link Actor.getSnapshot}. Persisted state represents the internal state of
   * the actor, while snapshots represent the actor's last emitted value.
   *
   * Can be restored with {@link ActorOptions.state}
   * @see https://stately.ai/docs/persistence
   */ getPersistedSnapshot(options) {
        return this.logic.getPersistedSnapshot(this._snapshot, options);
    }
    [$59def02d21be1ba1$var$symbolObservable]() {
        return this;
    }
    /**
   * Read an actor’s snapshot synchronously.
   *
   * @remarks
   * The snapshot represent an actor's last emitted value.
   *
   * When an actor receives an event, its internal state may change. An actor
   * may emit a snapshot when a state transition occurs.
   *
   * Note that some actors, such as callback actors generated with
   * `fromCallback`, will not emit snapshots.
   * @see {@link Actor.subscribe} to subscribe to an actor’s snapshot values.
   * @see {@link Actor.getPersistedSnapshot} to persist the internal state of an actor (which is more than just a snapshot).
   */ getSnapshot() {
        return this._snapshot;
    }
}
/**
 * Creates a new actor instance for the given actor logic with the provided
 * options, if any.
 *
 * @remarks
 * When you create an actor from actor logic via `createActor(logic)`, you
 * implicitly create an actor system where the created actor is the root actor.
 * Any actors spawned from this root actor and its descendants are part of that
 * actor system.
 * @example
 *
 * ```ts
 * import { createActor } from 'xstate';
 * import { someActorLogic } from './someActorLogic.ts';
 *
 * // Creating the actor, which implicitly creates an actor system with itself as the root actor
 * const actor = createActor(someActorLogic);
 *
 * actor.subscribe((snapshot) => {
 *   console.log(snapshot);
 * });
 *
 * // Actors must be started by calling `actor.start()`, which will also start the actor system.
 * actor.start();
 *
 * // Actors can receive events
 * actor.send({ type: 'someEvent' });
 *
 * // You can stop root actors by calling `actor.stop()`, which will also stop the actor system and all actors in that system.
 * actor.stop();
 * ```
 *
 * @param logic - The actor logic to create an actor from. For a state machine
 *   actor logic creator, see {@link createMachine}. Other actor logic creators
 *   include {@link fromCallback}, {@link fromEventObservable},
 *   {@link fromObservable}, {@link fromPromise}, and {@link fromTransition}.
 * @param options - Actor options
 */ function $59def02d21be1ba1$export$db3b6bfb95261072(logic, ...[options]) {
    return new $59def02d21be1ba1$export$ebd11618f299a286(logic, options);
}
/**
 * Creates a new Interpreter instance for the given machine with the provided
 * options, if any.
 *
 * @deprecated Use `createActor` instead
 * @alias
 */ const $59def02d21be1ba1$export$dda1d9f60106f0e9 = $59def02d21be1ba1$export$db3b6bfb95261072;
/**
 * @deprecated Use `Actor` instead.
 * @alias
 */ function $59def02d21be1ba1$var$resolveCancel(_, snapshot, actionArgs, actionParams, { sendId: sendId }) {
    const resolvedSendId = typeof sendId === 'function' ? sendId(actionArgs, actionParams) : sendId;
    return [
        snapshot,
        {
            sendId: resolvedSendId
        },
        undefined
    ];
}
function $59def02d21be1ba1$var$executeCancel(actorScope, params) {
    actorScope.defer(()=>{
        actorScope.system.scheduler.cancel(actorScope.self, params.sendId);
    });
}
/**
 * Cancels a delayed `sendTo(...)` action that is waiting to be executed. The
 * canceled `sendTo(...)` action will not send its event or execute, unless the
 * `delay` has already elapsed before `cancel(...)` is called.
 *
 * @example
 *
 * ```ts
 * import { createMachine, sendTo, cancel } from 'xstate';
 *
 * const machine = createMachine({
 *   // ...
 *   on: {
 *     sendEvent: {
 *       actions: sendTo(
 *         'some-actor',
 *         { type: 'someEvent' },
 *         {
 *           id: 'some-id',
 *           delay: 1000
 *         }
 *       )
 *     },
 *     cancelEvent: {
 *       actions: cancel('some-id')
 *     }
 *   }
 * });
 * ```
 *
 * @param sendId The `id` of the `sendTo(...)` action to cancel.
 */ function $59def02d21be1ba1$export$407448d2b89b1813(sendId) {
    function cancel(_args, _params) {}
    cancel.type = 'xstate.cancel';
    cancel.sendId = sendId;
    cancel.resolve = $59def02d21be1ba1$var$resolveCancel;
    cancel.execute = $59def02d21be1ba1$var$executeCancel;
    return cancel;
}
function $59def02d21be1ba1$var$resolveSpawn(actorScope, snapshot, actionArgs, _actionParams, { id: id, systemId: systemId, src: src, input: input, syncSnapshot: syncSnapshot }) {
    const logic = typeof src === 'string' ? $59def02d21be1ba1$export$e7c866399fa523f5(snapshot.machine, src) : src;
    const resolvedId = typeof id === 'function' ? id(actionArgs) : id;
    let actorRef;
    let resolvedInput = undefined;
    if (logic) {
        resolvedInput = typeof input === 'function' ? input({
            context: snapshot.context,
            event: actionArgs.event,
            self: actorScope.self
        }) : input;
        actorRef = $59def02d21be1ba1$export$db3b6bfb95261072(logic, {
            id: resolvedId,
            src: src,
            parent: actorScope.self,
            syncSnapshot: syncSnapshot,
            systemId: systemId,
            input: resolvedInput
        });
    }
    return [
        $59def02d21be1ba1$export$71511d61b312f219(snapshot, {
            children: {
                ...snapshot.children,
                [resolvedId]: actorRef
            }
        }),
        {
            id: id,
            systemId: systemId,
            actorRef: actorRef,
            src: src,
            input: resolvedInput
        },
        undefined
    ];
}
function $59def02d21be1ba1$var$executeSpawn(actorScope, { actorRef: actorRef }) {
    if (!actorRef) return;
    actorScope.defer(()=>{
        if (actorRef._processingStatus === $59def02d21be1ba1$export$dc98b0b04f4c7758.Stopped) return;
        actorRef.start();
    });
}
function $59def02d21be1ba1$export$8b22cf2602fb60ce(...[src, { id: id, systemId: systemId, input: input, syncSnapshot: syncSnapshot = false } = {}]) {
    function spawnChild1(_args, _params) {}
    spawnChild1.type = 'xstate.spawnChild';
    spawnChild1.id = id;
    spawnChild1.systemId = systemId;
    spawnChild1.src = src;
    spawnChild1.input = input;
    spawnChild1.syncSnapshot = syncSnapshot;
    spawnChild1.resolve = $59def02d21be1ba1$var$resolveSpawn;
    spawnChild1.execute = $59def02d21be1ba1$var$executeSpawn;
    return spawnChild1;
}
function $59def02d21be1ba1$var$resolveStop(_, snapshot, args, actionParams, { actorRef: actorRef }) {
    const actorRefOrString = typeof actorRef === 'function' ? actorRef(args, actionParams) : actorRef;
    const resolvedActorRef = typeof actorRefOrString === 'string' ? snapshot.children[actorRefOrString] : actorRefOrString;
    let children = snapshot.children;
    if (resolvedActorRef) {
        children = {
            ...children
        };
        delete children[resolvedActorRef.id];
    }
    return [
        $59def02d21be1ba1$export$71511d61b312f219(snapshot, {
            children: children
        }),
        resolvedActorRef,
        undefined
    ];
}
function $59def02d21be1ba1$var$unregisterRecursively(actorScope, actorRef) {
    // unregister children first (depth-first)
    const snapshot = actorRef.getSnapshot();
    if (snapshot && 'children' in snapshot) for (const child of Object.values(snapshot.children))$59def02d21be1ba1$var$unregisterRecursively(actorScope, child);
    actorScope.system._unregister(actorRef);
}
function $59def02d21be1ba1$var$executeStop(actorScope, actorRef) {
    if (!actorRef) return;
    // we need to eagerly unregister it here so a new actor with the same systemId can be registered immediately
    // since we defer actual stopping of the actor but we don't defer actor creations (and we can't do that)
    // this could throw on `systemId` collision, for example, when dealing with reentering transitions
    // we also need to recursively unregister all nested children's systemIds
    $59def02d21be1ba1$var$unregisterRecursively(actorScope, actorRef);
    // this allows us to prevent an actor from being started if it gets stopped within the same macrostep
    // this can happen, for example, when the invoking state is being exited immediately by an always transition
    if (actorRef._processingStatus !== $59def02d21be1ba1$export$dc98b0b04f4c7758.Running) {
        actorScope.stopChild(actorRef);
        return;
    }
    // stopping a child enqueues a stop event in the child actor's mailbox
    // we need for all of the already enqueued events to be processed before we stop the child
    // the parent itself might want to send some events to a child (for example from exit actions on the invoking state)
    // and we don't want to ignore those events
    actorScope.defer(()=>{
        actorScope.stopChild(actorRef);
    });
}
/**
 * Stops a child actor.
 *
 * @param actorRef The actor to stop.
 */ function $59def02d21be1ba1$export$2408f22a0fab9ae5(actorRef) {
    function stop(_args, _params) {}
    stop.type = 'xstate.stopChild';
    stop.actorRef = actorRef;
    stop.resolve = $59def02d21be1ba1$var$resolveStop;
    stop.execute = $59def02d21be1ba1$var$executeStop;
    return stop;
}
/**
 * Stops a child actor.
 *
 * @deprecated Use `stopChild(...)` instead
 * @alias
 */ const $59def02d21be1ba1$export$d141bba7fdc215a3 = $59def02d21be1ba1$export$2408f22a0fab9ae5;
function $59def02d21be1ba1$var$checkStateIn(snapshot, _, { stateValue: stateValue }) {
    if (typeof stateValue === 'string' && $59def02d21be1ba1$export$db202ddc8be9136(stateValue)) {
        const target = snapshot.machine.getStateNodeById(stateValue);
        return snapshot._nodes.some((sn)=>sn === target);
    }
    return snapshot.matches(stateValue);
}
function $59def02d21be1ba1$export$342063e11d6c3cad(stateValue) {
    function stateIn() {
        return false;
    }
    stateIn.check = $59def02d21be1ba1$var$checkStateIn;
    stateIn.stateValue = stateValue;
    return stateIn;
}
function $59def02d21be1ba1$var$checkNot(snapshot, { context: context, event: event }, { guards: guards }) {
    return !$59def02d21be1ba1$export$96f57966bedc81b4(guards[0], context, event, snapshot);
}
/**
 * Higher-order guard that evaluates to `true` if the `guard` passed to it
 * evaluates to `false`.
 *
 * @category Guards
 * @example
 *
 * ```ts
 * import { setup, not } from 'xstate';
 *
 * const machine = setup({
 *   guards: {
 *     someNamedGuard: () => false
 *   }
 * }).createMachine({
 *   on: {
 *     someEvent: {
 *       guard: not('someNamedGuard'),
 *       actions: () => {
 *         // will be executed if guard in `not(...)`
 *         // evaluates to `false`
 *       }
 *     }
 *   }
 * });
 * ```
 *
 * @returns A guard
 */ function $59def02d21be1ba1$export$7ccc53e8f1e7dfc5(guard) {
    function not(_args, _params) {
        return false;
    }
    not.check = $59def02d21be1ba1$var$checkNot;
    not.guards = [
        guard
    ];
    return not;
}
function $59def02d21be1ba1$var$checkAnd(snapshot, { context: context, event: event }, { guards: guards }) {
    return guards.every((guard)=>$59def02d21be1ba1$export$96f57966bedc81b4(guard, context, event, snapshot));
}
/**
 * Higher-order guard that evaluates to `true` if all `guards` passed to it
 * evaluate to `true`.
 *
 * @category Guards
 * @example
 *
 * ```ts
 * import { setup, and } from 'xstate';
 *
 * const machine = setup({
 *   guards: {
 *     someNamedGuard: () => true
 *   }
 * }).createMachine({
 *   on: {
 *     someEvent: {
 *       guard: and([({ context }) => context.value > 0, 'someNamedGuard']),
 *       actions: () => {
 *         // will be executed if all guards in `and(...)`
 *         // evaluate to true
 *       }
 *     }
 *   }
 * });
 * ```
 *
 * @returns A guard action object
 */ function $59def02d21be1ba1$export$35e795649ee09318(guards) {
    function and(_args, _params) {
        return false;
    }
    and.check = $59def02d21be1ba1$var$checkAnd;
    and.guards = guards;
    return and;
}
function $59def02d21be1ba1$var$checkOr(snapshot, { context: context, event: event }, { guards: guards }) {
    return guards.some((guard)=>$59def02d21be1ba1$export$96f57966bedc81b4(guard, context, event, snapshot));
}
/**
 * Higher-order guard that evaluates to `true` if any of the `guards` passed to
 * it evaluate to `true`.
 *
 * @category Guards
 * @example
 *
 * ```ts
 * import { setup, or } from 'xstate';
 *
 * const machine = setup({
 *   guards: {
 *     someNamedGuard: () => true
 *   }
 * }).createMachine({
 *   on: {
 *     someEvent: {
 *       guard: or([({ context }) => context.value > 0, 'someNamedGuard']),
 *       actions: () => {
 *         // will be executed if any of the guards in `or(...)`
 *         // evaluate to true
 *       }
 *     }
 *   }
 * });
 * ```
 *
 * @returns A guard action object
 */ function $59def02d21be1ba1$export$ae1af26003f05816(guards) {
    function or(_args, _params) {
        return false;
    }
    or.check = $59def02d21be1ba1$var$checkOr;
    or.guards = guards;
    return or;
}
// TODO: throw on cycles (depth check should be enough)
function $59def02d21be1ba1$export$96f57966bedc81b4(guard, context, event, snapshot) {
    const { machine: machine } = snapshot;
    const isInline = typeof guard === 'function';
    const resolved = isInline ? guard : machine.implementations.guards[typeof guard === 'string' ? guard : guard.type];
    if (!isInline && !resolved) throw new Error(`Guard '${typeof guard === 'string' ? guard : guard.type}' is not implemented.'.`);
    if (typeof resolved !== 'function') return $59def02d21be1ba1$export$96f57966bedc81b4(resolved, context, event, snapshot);
    const guardArgs = {
        context: context,
        event: event
    };
    const guardParams = isInline || typeof guard === 'string' ? undefined : 'params' in guard ? typeof guard.params === 'function' ? guard.params({
        context: context,
        event: event
    }) : guard.params : undefined;
    if (!('check' in resolved)) // the existing type of `.guards` assumes non-nullable `TExpressionGuard`
    // inline guards expect `TExpressionGuard` to be set to `undefined`
    // it's fine to cast this here, our logic makes sure that we call those 2 "variants" correctly
    return resolved(guardArgs, guardParams);
    const builtinGuard = resolved;
    return builtinGuard.check(snapshot, guardArgs, resolved // this holds all params
    );
}
function $59def02d21be1ba1$export$2d1720544b23b823(stateNode) {
    return stateNode.type === 'atomic' || stateNode.type === 'final';
}
function $59def02d21be1ba1$var$getChildren(stateNode) {
    return Object.values(stateNode.states).filter((sn)=>sn.type !== 'history');
}
function $59def02d21be1ba1$export$39b482c5e57630a8(stateNode, toStateNode) {
    const ancestors = [];
    if (toStateNode === stateNode) return ancestors;
    // add all ancestors
    let m = stateNode.parent;
    while(m && m !== toStateNode){
        ancestors.push(m);
        m = m.parent;
    }
    return ancestors;
}
function $59def02d21be1ba1$export$3466f893ebf79586(stateNodes) {
    const nodeSet = new Set(stateNodes);
    const adjList = $59def02d21be1ba1$var$getAdjList(nodeSet);
    // add descendants
    for (const s of nodeSet)// if previously active, add existing child nodes
    if (s.type === 'compound' && (!adjList.get(s) || !adjList.get(s).length)) $59def02d21be1ba1$var$getInitialStateNodesWithTheirAncestors(s).forEach((sn)=>nodeSet.add(sn));
    else {
        if (s.type === 'parallel') for (const child of $59def02d21be1ba1$var$getChildren(s)){
            if (child.type === 'history') continue;
            if (!nodeSet.has(child)) {
                const initialStates = $59def02d21be1ba1$var$getInitialStateNodesWithTheirAncestors(child);
                for (const initialStateNode of initialStates)nodeSet.add(initialStateNode);
            }
        }
    }
    // add all ancestors
    for (const s of nodeSet){
        let m = s.parent;
        while(m){
            nodeSet.add(m);
            m = m.parent;
        }
    }
    return nodeSet;
}
function $59def02d21be1ba1$var$getValueFromAdj(baseNode, adjList) {
    const childStateNodes = adjList.get(baseNode);
    if (!childStateNodes) return {}; // todo: fix?
    if (baseNode.type === 'compound') {
        const childStateNode = childStateNodes[0];
        if (childStateNode) {
            if ($59def02d21be1ba1$export$2d1720544b23b823(childStateNode)) return childStateNode.key;
        } else return {};
    }
    const stateValue = {};
    for (const childStateNode of childStateNodes)stateValue[childStateNode.key] = $59def02d21be1ba1$var$getValueFromAdj(childStateNode, adjList);
    return stateValue;
}
function $59def02d21be1ba1$var$getAdjList(stateNodes) {
    const adjList = new Map();
    for (const s of stateNodes){
        if (!adjList.has(s)) adjList.set(s, []);
        if (s.parent) {
            if (!adjList.has(s.parent)) adjList.set(s.parent, []);
            adjList.get(s.parent).push(s);
        }
    }
    return adjList;
}
function $59def02d21be1ba1$var$getStateValue(rootNode, stateNodes) {
    const config = $59def02d21be1ba1$export$3466f893ebf79586(stateNodes);
    return $59def02d21be1ba1$var$getValueFromAdj(rootNode, $59def02d21be1ba1$var$getAdjList(config));
}
function $59def02d21be1ba1$export$3a1a48c8f6ef640e(stateNodeSet, stateNode) {
    if (stateNode.type === 'compound') return $59def02d21be1ba1$var$getChildren(stateNode).some((s)=>s.type === 'final' && stateNodeSet.has(s));
    if (stateNode.type === 'parallel') return $59def02d21be1ba1$var$getChildren(stateNode).every((sn)=>$59def02d21be1ba1$export$3a1a48c8f6ef640e(stateNodeSet, sn));
    return stateNode.type === 'final';
}
const $59def02d21be1ba1$export$db202ddc8be9136 = (str)=>str[0] === $59def02d21be1ba1$var$STATE_IDENTIFIER;
function $59def02d21be1ba1$export$7f8ddf7c7c20b3cd(stateNode, receivedEventType) {
    const candidates = stateNode.transitions.get(receivedEventType) || [
        ...stateNode.transitions.keys()
    ].filter((eventDescriptor)=>$59def02d21be1ba1$export$953cecd6e717a553(receivedEventType, eventDescriptor)).sort((a, b)=>b.length - a.length).flatMap((key)=>stateNode.transitions.get(key));
    return candidates;
}
/** All delayed transitions from the config. */ function $59def02d21be1ba1$export$d66501df72047452(stateNode) {
    const afterConfig = stateNode.config.after;
    if (!afterConfig) return [];
    const mutateEntryExit = (delay)=>{
        const afterEvent = $59def02d21be1ba1$var$createAfterEvent(delay, stateNode.id);
        const eventType = afterEvent.type;
        stateNode.entry.push($59def02d21be1ba1$export$43caf9889c228507(afterEvent, {
            id: eventType,
            delay: delay
        }));
        stateNode.exit.push($59def02d21be1ba1$export$407448d2b89b1813(eventType));
        return eventType;
    };
    const delayedTransitions = Object.keys(afterConfig).flatMap((delay)=>{
        const configTransition = afterConfig[delay];
        const resolvedTransition = typeof configTransition === 'string' ? {
            target: configTransition
        } : configTransition;
        const resolvedDelay = Number.isNaN(+delay) ? delay : +delay;
        const eventType = mutateEntryExit(resolvedDelay);
        return $59def02d21be1ba1$export$625550452a3fa3ec(resolvedTransition).map((transition)=>({
                ...transition,
                event: eventType,
                delay: resolvedDelay
            }));
    });
    return delayedTransitions.map((delayedTransition)=>{
        const { delay: delay } = delayedTransition;
        return {
            ...$59def02d21be1ba1$export$e7094788287c5e9b(stateNode, delayedTransition.event, delayedTransition),
            delay: delay
        };
    });
}
function $59def02d21be1ba1$export$e7094788287c5e9b(stateNode, descriptor, transitionConfig) {
    const normalizedTarget = $59def02d21be1ba1$var$normalizeTarget(transitionConfig.target);
    const reenter = transitionConfig.reenter ?? false;
    const target = $59def02d21be1ba1$var$resolveTarget(stateNode, normalizedTarget);
    const transition = {
        ...transitionConfig,
        actions: $59def02d21be1ba1$export$625550452a3fa3ec(transitionConfig.actions),
        guard: transitionConfig.guard,
        target: target,
        source: stateNode,
        reenter: reenter,
        eventType: descriptor,
        toJSON: ()=>({
                ...transition,
                source: `#${stateNode.id}`,
                target: target ? target.map((t)=>`#${t.id}`) : undefined
            })
    };
    return transition;
}
function $59def02d21be1ba1$export$df995fae86a55f06(stateNode) {
    const transitions = new Map();
    if (stateNode.config.on) for (const descriptor of Object.keys(stateNode.config.on)){
        if (descriptor === $59def02d21be1ba1$export$a07804094c3ecf2d) throw new Error('Null events ("") cannot be specified as a transition key. Use `always: { ... }` instead.');
        const transitionsConfig = stateNode.config.on[descriptor];
        transitions.set(descriptor, $59def02d21be1ba1$export$ef35774e6d314e91(transitionsConfig).map((t)=>$59def02d21be1ba1$export$e7094788287c5e9b(stateNode, descriptor, t)));
    }
    if (stateNode.config.onDone) {
        const descriptor = `xstate.done.state.${stateNode.id}`;
        transitions.set(descriptor, $59def02d21be1ba1$export$ef35774e6d314e91(stateNode.config.onDone).map((t)=>$59def02d21be1ba1$export$e7094788287c5e9b(stateNode, descriptor, t)));
    }
    for (const invokeDef of stateNode.invoke){
        if (invokeDef.onDone) {
            const descriptor = `xstate.done.actor.${invokeDef.id}`;
            transitions.set(descriptor, $59def02d21be1ba1$export$ef35774e6d314e91(invokeDef.onDone).map((t)=>$59def02d21be1ba1$export$e7094788287c5e9b(stateNode, descriptor, t)));
        }
        if (invokeDef.onError) {
            const descriptor = `xstate.error.actor.${invokeDef.id}`;
            transitions.set(descriptor, $59def02d21be1ba1$export$ef35774e6d314e91(invokeDef.onError).map((t)=>$59def02d21be1ba1$export$e7094788287c5e9b(stateNode, descriptor, t)));
        }
        if (invokeDef.onSnapshot) {
            const descriptor = `xstate.snapshot.${invokeDef.id}`;
            transitions.set(descriptor, $59def02d21be1ba1$export$ef35774e6d314e91(invokeDef.onSnapshot).map((t)=>$59def02d21be1ba1$export$e7094788287c5e9b(stateNode, descriptor, t)));
        }
    }
    for (const delayedTransition of stateNode.after){
        let existing = transitions.get(delayedTransition.eventType);
        if (!existing) {
            existing = [];
            transitions.set(delayedTransition.eventType, existing);
        }
        existing.push(delayedTransition);
    }
    return transitions;
}
/**
 * Collects route transitions from all descendants with explicit IDs. Called
 * once on the root node to avoid O(N²) repeated traversals.
 */ function $59def02d21be1ba1$export$9bb611d729802a56(rootStateNode) {
    const routeTransitions = [];
    const collectRoutes = (states)=>{
        Object.values(states).forEach((sn)=>{
            if (sn.config.route && sn.config.id) {
                const routeId = sn.config.id;
                const userGuard = sn.config.route.guard;
                const routeGuard = (args, params)=>{
                    if (args.event.to !== `#${routeId}`) return false;
                    if (!userGuard) return true;
                    if (typeof userGuard === 'function') return userGuard(args, params);
                    return true;
                };
                const transition = {
                    ...sn.config.route,
                    guard: routeGuard,
                    target: `#${routeId}`
                };
                routeTransitions.push($59def02d21be1ba1$export$e7094788287c5e9b(rootStateNode, 'xstate.route', transition));
            }
            if (sn.states) collectRoutes(sn.states);
        });
    };
    collectRoutes(rootStateNode.states);
    if (routeTransitions.length > 0) rootStateNode.transitions.set('xstate.route', routeTransitions);
}
function $59def02d21be1ba1$export$2329c99376c9d0a4(stateNode, _target) {
    const resolvedTarget = typeof _target === 'string' ? stateNode.states[_target] : _target ? stateNode.states[_target.target] : undefined;
    if (!resolvedTarget && _target) throw new Error(// eslint-disable-next-line @typescript-eslint/restrict-template-expressions, @typescript-eslint/no-base-to-string
    `Initial state node "${_target}" not found on parent state node #${stateNode.id}`);
    const transition = {
        source: stateNode,
        actions: !_target || typeof _target === 'string' ? [] : $59def02d21be1ba1$export$625550452a3fa3ec(_target.actions),
        eventType: null,
        reenter: false,
        target: resolvedTarget ? [
            resolvedTarget
        ] : [],
        toJSON: ()=>({
                ...transition,
                source: `#${stateNode.id}`,
                target: resolvedTarget ? [
                    `#${resolvedTarget.id}`
                ] : []
            })
    };
    return transition;
}
function $59def02d21be1ba1$var$resolveTarget(stateNode, targets) {
    if (targets === undefined) // an undefined target signals that the state node should not transition from that state when receiving that event
    return undefined;
    return targets.map((target)=>{
        if (typeof target !== 'string') return target;
        if ($59def02d21be1ba1$export$db202ddc8be9136(target)) return stateNode.machine.getStateNodeById(target);
        const isInternalTarget = target[0] === $59def02d21be1ba1$export$25ce5a424b770e84;
        // If internal target is defined on machine,
        // do not include machine key on target
        if (isInternalTarget && !stateNode.parent) return $59def02d21be1ba1$export$971d5caa766a69d7(stateNode, target.slice(1));
        const resolvedTarget = isInternalTarget ? stateNode.key + target : target;
        if (stateNode.parent) try {
            const targetStateNode = $59def02d21be1ba1$export$971d5caa766a69d7(stateNode.parent, resolvedTarget);
            return targetStateNode;
        } catch (err) {
            throw new Error(`Invalid transition definition for state node '${stateNode.id}':\n${err.message}`);
        }
        else throw new Error(`Invalid target: "${target}" is not a valid target from the root node. Did you mean ".${target}"?`);
    });
}
function $59def02d21be1ba1$var$resolveHistoryDefaultTransition(stateNode) {
    const normalizedTarget = $59def02d21be1ba1$var$normalizeTarget(stateNode.config.target);
    if (!normalizedTarget) return stateNode.parent.initial;
    return {
        target: normalizedTarget.map((t)=>typeof t === 'string' ? $59def02d21be1ba1$export$971d5caa766a69d7(stateNode.parent, t) : t)
    };
}
function $59def02d21be1ba1$var$isHistoryNode(stateNode) {
    return stateNode.type === 'history';
}
function $59def02d21be1ba1$var$getInitialStateNodesWithTheirAncestors(stateNode) {
    const states = $59def02d21be1ba1$var$getInitialStateNodes(stateNode);
    for (const initialState of states)for (const ancestor of $59def02d21be1ba1$export$39b482c5e57630a8(initialState, stateNode))states.add(ancestor);
    return states;
}
function $59def02d21be1ba1$var$getInitialStateNodes(stateNode) {
    const set = new Set();
    function iter(descStateNode) {
        if (set.has(descStateNode)) return;
        set.add(descStateNode);
        if (descStateNode.type === 'compound') iter(descStateNode.initial.target[0]);
        else if (descStateNode.type === 'parallel') for (const child of $59def02d21be1ba1$var$getChildren(descStateNode))iter(child);
    }
    iter(stateNode);
    return set;
}
/** Returns the child state node from its relative `stateKey`, or throws. */ function $59def02d21be1ba1$var$getStateNode(stateNode, stateKey) {
    if ($59def02d21be1ba1$export$db202ddc8be9136(stateKey)) return stateNode.machine.getStateNodeById(stateKey);
    if (!stateNode.states) throw new Error(`Unable to retrieve child state '${stateKey}' from '${stateNode.id}'; no child states exist.`);
    const result = stateNode.states[stateKey];
    if (!result) throw new Error(`Child state '${stateKey}' does not exist on '${stateNode.id}'`);
    return result;
}
/**
 * Returns the relative state node from the given `statePath`, or throws.
 *
 * @param statePath The string or string array relative path to the state node.
 */ function $59def02d21be1ba1$export$971d5caa766a69d7(stateNode, statePath) {
    if (typeof statePath === 'string' && $59def02d21be1ba1$export$db202ddc8be9136(statePath)) try {
        return stateNode.machine.getStateNodeById(statePath);
    } catch  {
    // try individual paths
    // throw e;
    }
    const arrayStatePath = $59def02d21be1ba1$export$3722cfe417b6ed86(statePath).slice();
    let currentStateNode = stateNode;
    while(arrayStatePath.length){
        const key = arrayStatePath.shift();
        if (!key.length) break;
        currentStateNode = $59def02d21be1ba1$var$getStateNode(currentStateNode, key);
    }
    return currentStateNode;
}
/**
 * Returns the state nodes represented by the current state value.
 *
 * @param stateValue The state value or State instance
 */ function $59def02d21be1ba1$export$ffb5f4729a158638(stateNode, stateValue) {
    if (typeof stateValue === 'string') {
        const childStateNode = stateNode.states[stateValue];
        if (!childStateNode) throw new Error(`State '${stateValue}' does not exist on '${stateNode.id}'`);
        return [
            stateNode,
            childStateNode
        ];
    }
    const childStateKeys = Object.keys(stateValue);
    const childStateNodes = childStateKeys.map((subStateKey)=>$59def02d21be1ba1$var$getStateNode(stateNode, subStateKey)).filter(Boolean);
    return [
        stateNode.machine.root,
        stateNode
    ].concat(childStateNodes, childStateKeys.reduce((allSubStateNodes, subStateKey)=>{
        const subStateNode = $59def02d21be1ba1$var$getStateNode(stateNode, subStateKey);
        if (!subStateNode) return allSubStateNodes;
        const subStateNodes = $59def02d21be1ba1$export$ffb5f4729a158638(subStateNode, stateValue[subStateKey]);
        return allSubStateNodes.concat(subStateNodes);
    }, []));
}
function $59def02d21be1ba1$var$transitionAtomicNode(stateNode, stateValue, snapshot, event) {
    const childStateNode = $59def02d21be1ba1$var$getStateNode(stateNode, stateValue);
    const next = childStateNode.next(snapshot, event);
    if (!next || !next.length) return stateNode.next(snapshot, event);
    return next;
}
function $59def02d21be1ba1$var$transitionCompoundNode(stateNode, stateValue, snapshot, event) {
    const subStateKeys = Object.keys(stateValue);
    const childStateNode = $59def02d21be1ba1$var$getStateNode(stateNode, subStateKeys[0]);
    const next = $59def02d21be1ba1$export$c4ce752e73470fba(childStateNode, stateValue[subStateKeys[0]], snapshot, event);
    if (!next || !next.length) return stateNode.next(snapshot, event);
    return next;
}
function $59def02d21be1ba1$var$transitionParallelNode(stateNode, stateValue, snapshot, event) {
    const allInnerTransitions = [];
    for (const subStateKey of Object.keys(stateValue)){
        const subStateValue = stateValue[subStateKey];
        if (!subStateValue) continue;
        const subStateNode = $59def02d21be1ba1$var$getStateNode(stateNode, subStateKey);
        const innerTransitions = $59def02d21be1ba1$export$c4ce752e73470fba(subStateNode, subStateValue, snapshot, event);
        if (innerTransitions) allInnerTransitions.push(...innerTransitions);
    }
    if (!allInnerTransitions.length) return stateNode.next(snapshot, event);
    return allInnerTransitions;
}
function $59def02d21be1ba1$export$c4ce752e73470fba(stateNode, stateValue, snapshot, event) {
    // leaf node
    if (typeof stateValue === 'string') return $59def02d21be1ba1$var$transitionAtomicNode(stateNode, stateValue, snapshot, event);
    // compound node
    if (Object.keys(stateValue).length === 1) return $59def02d21be1ba1$var$transitionCompoundNode(stateNode, stateValue, snapshot, event);
    // parallel node
    return $59def02d21be1ba1$var$transitionParallelNode(stateNode, stateValue, snapshot, event);
}
function $59def02d21be1ba1$var$getHistoryNodes(stateNode) {
    return Object.keys(stateNode.states).map((key)=>stateNode.states[key]).filter((sn)=>sn.type === 'history');
}
function $59def02d21be1ba1$var$isDescendant(childStateNode, parentStateNode) {
    let marker = childStateNode;
    while(marker.parent && marker.parent !== parentStateNode)marker = marker.parent;
    return marker.parent === parentStateNode;
}
function $59def02d21be1ba1$var$hasIntersection(s1, s2) {
    const set1 = new Set(s1);
    const set2 = new Set(s2);
    for (const item of set1){
        if (set2.has(item)) return true;
    }
    for (const item of set2){
        if (set1.has(item)) return true;
    }
    return false;
}
function $59def02d21be1ba1$var$removeConflictingTransitions(enabledTransitions, stateNodeSet, historyValue) {
    const filteredTransitions = new Set();
    for (const t1 of enabledTransitions){
        let t1Preempted = false;
        const transitionsToRemove = new Set();
        for (const t2 of filteredTransitions)if ($59def02d21be1ba1$var$hasIntersection($59def02d21be1ba1$var$computeExitSet([
            t1
        ], stateNodeSet, historyValue), $59def02d21be1ba1$var$computeExitSet([
            t2
        ], stateNodeSet, historyValue))) {
            if ($59def02d21be1ba1$var$isDescendant(t1.source, t2.source)) transitionsToRemove.add(t2);
            else {
                t1Preempted = true;
                break;
            }
        }
        if (!t1Preempted) {
            for (const t3 of transitionsToRemove)filteredTransitions.delete(t3);
            filteredTransitions.add(t1);
        }
    }
    return Array.from(filteredTransitions);
}
function $59def02d21be1ba1$var$findLeastCommonAncestor(stateNodes) {
    const [head, ...tail] = stateNodes;
    for (const ancestor of $59def02d21be1ba1$export$39b482c5e57630a8(head, undefined)){
        if (tail.every((sn)=>$59def02d21be1ba1$var$isDescendant(sn, ancestor))) return ancestor;
    }
}
function $59def02d21be1ba1$var$getEffectiveTargetStates(transition, historyValue) {
    if (!transition.target) return [];
    const targets = new Set();
    for (const targetNode of transition.target)if ($59def02d21be1ba1$var$isHistoryNode(targetNode)) {
        if (historyValue[targetNode.id]) for (const node of historyValue[targetNode.id])targets.add(node);
        else for (const node of $59def02d21be1ba1$var$getEffectiveTargetStates($59def02d21be1ba1$var$resolveHistoryDefaultTransition(targetNode), historyValue))targets.add(node);
    } else targets.add(targetNode);
    return [
        ...targets
    ];
}
function $59def02d21be1ba1$var$getTransitionDomain(transition, historyValue) {
    const targetStates = $59def02d21be1ba1$var$getEffectiveTargetStates(transition, historyValue);
    if (!targetStates) return;
    if (!transition.reenter && targetStates.every((target)=>target === transition.source || $59def02d21be1ba1$var$isDescendant(target, transition.source))) return transition.source;
    const lca = $59def02d21be1ba1$var$findLeastCommonAncestor(targetStates.concat(transition.source));
    if (lca) return lca;
    // at this point we know that it's a root transition since LCA couldn't be found
    if (transition.reenter) return;
    return transition.source.machine.root;
}
function $59def02d21be1ba1$var$computeExitSet(transitions, stateNodeSet, historyValue) {
    const statesToExit = new Set();
    for (const t of transitions)if (t.target?.length) {
        const domain = $59def02d21be1ba1$var$getTransitionDomain(t, historyValue);
        if (t.reenter && t.source === domain) statesToExit.add(domain);
        for (const stateNode of stateNodeSet)if ($59def02d21be1ba1$var$isDescendant(stateNode, domain)) statesToExit.add(stateNode);
    }
    return [
        ...statesToExit
    ];
}
function $59def02d21be1ba1$var$areStateNodeCollectionsEqual(prevStateNodes, nextStateNodeSet) {
    if (prevStateNodes.length !== nextStateNodeSet.size) return false;
    for (const node of prevStateNodes){
        if (!nextStateNodeSet.has(node)) return false;
    }
    return true;
}
function $59def02d21be1ba1$export$23f2a1d2818174ef(root, preInitialState, actorScope, initEvent, internalQueue) {
    return $59def02d21be1ba1$var$microstep([
        {
            target: [
                ...$59def02d21be1ba1$var$getInitialStateNodes(root)
            ],
            source: root,
            reenter: true,
            actions: [],
            eventType: null,
            toJSON: null
        }
    ], preInitialState, actorScope, initEvent, true, internalQueue);
}
/** https://www.w3.org/TR/scxml/#microstepProcedure */ function $59def02d21be1ba1$var$microstep(transitions, currentSnapshot, actorScope, event, isInitial, internalQueue) {
    const actions = [];
    if (!transitions.length) return [
        currentSnapshot,
        actions
    ];
    const originalExecutor = actorScope.actionExecutor;
    actorScope.actionExecutor = (action)=>{
        actions.push(action);
        originalExecutor(action);
    };
    try {
        const mutStateNodeSet = new Set(currentSnapshot._nodes);
        let historyValue = currentSnapshot.historyValue;
        const filteredTransitions = $59def02d21be1ba1$var$removeConflictingTransitions(transitions, mutStateNodeSet, historyValue);
        let nextState = currentSnapshot;
        // Exit states
        if (!isInitial) [nextState, historyValue] = $59def02d21be1ba1$var$exitStates(nextState, event, actorScope, filteredTransitions, mutStateNodeSet, historyValue, internalQueue, actorScope.actionExecutor);
        // Execute transition content
        nextState = $59def02d21be1ba1$export$56c0d5a1e737357d(nextState, event, actorScope, filteredTransitions.flatMap((t)=>t.actions), internalQueue, undefined);
        // Enter states
        nextState = $59def02d21be1ba1$var$enterStates(nextState, event, actorScope, filteredTransitions, mutStateNodeSet, internalQueue, historyValue, isInitial);
        const nextStateNodes = [
            ...mutStateNodeSet
        ];
        if (nextState.status === 'done') nextState = $59def02d21be1ba1$export$56c0d5a1e737357d(nextState, event, actorScope, nextStateNodes.sort((a, b)=>b.order - a.order).flatMap((state)=>state.exit), internalQueue, undefined);
        // eslint-disable-next-line no-useless-catch
        try {
            if (historyValue === currentSnapshot.historyValue && $59def02d21be1ba1$var$areStateNodeCollectionsEqual(currentSnapshot._nodes, mutStateNodeSet)) return [
                nextState,
                actions
            ];
            return [
                $59def02d21be1ba1$export$71511d61b312f219(nextState, {
                    _nodes: nextStateNodes,
                    historyValue: historyValue
                }),
                actions
            ];
        } catch (e) {
            // TODO: Refactor this once proper error handling is implemented.
            // See https://github.com/statelyai/rfcs/pull/4
            throw e;
        }
    } finally{
        actorScope.actionExecutor = originalExecutor;
    }
}
function $59def02d21be1ba1$var$getMachineOutput(snapshot, event, actorScope, rootNode, rootCompletionNode) {
    if (rootNode.output === undefined) return;
    const doneStateEvent = $59def02d21be1ba1$var$createDoneStateEvent(rootCompletionNode.id, rootCompletionNode.output !== undefined && rootCompletionNode.parent ? $59def02d21be1ba1$var$resolveOutput(rootCompletionNode.output, snapshot.context, event, actorScope.self) : undefined);
    return $59def02d21be1ba1$var$resolveOutput(rootNode.output, snapshot.context, doneStateEvent, actorScope.self);
}
function $59def02d21be1ba1$var$enterStates(currentSnapshot, event, actorScope, filteredTransitions, mutStateNodeSet, internalQueue, historyValue, isInitial) {
    let nextSnapshot = currentSnapshot;
    const statesToEnter = new Set();
    // those are states that were directly targeted or indirectly targeted by the explicit target
    // in other words, those are states for which initial actions should be executed
    // when we target `#deep_child` initial actions of its ancestors shouldn't be executed
    const statesForDefaultEntry = new Set();
    $59def02d21be1ba1$var$computeEntrySet(filteredTransitions, historyValue, statesForDefaultEntry, statesToEnter);
    // In the initial state, the root state node is "entered".
    if (isInitial) statesForDefaultEntry.add(currentSnapshot.machine.root);
    const completedNodes = new Set();
    for (const stateNodeToEnter of [
        ...statesToEnter
    ].sort((a, b)=>a.order - b.order)){
        mutStateNodeSet.add(stateNodeToEnter);
        const actions = [];
        // Add entry actions
        actions.push(...stateNodeToEnter.entry);
        for (const invokeDef of stateNodeToEnter.invoke)actions.push($59def02d21be1ba1$export$8b22cf2602fb60ce(invokeDef.src, {
            ...invokeDef,
            syncSnapshot: !!invokeDef.onSnapshot
        }));
        if (statesForDefaultEntry.has(stateNodeToEnter)) {
            const initialActions = stateNodeToEnter.initial.actions;
            actions.push(...initialActions);
        }
        nextSnapshot = $59def02d21be1ba1$export$56c0d5a1e737357d(nextSnapshot, event, actorScope, actions, internalQueue, stateNodeToEnter.invoke.map((invokeDef)=>invokeDef.id));
        if (stateNodeToEnter.type === 'final') {
            const parent = stateNodeToEnter.parent;
            let ancestorMarker = parent?.type === 'parallel' ? parent : parent?.parent;
            let rootCompletionNode = ancestorMarker || stateNodeToEnter;
            if (parent?.type === 'compound') internalQueue.push($59def02d21be1ba1$var$createDoneStateEvent(parent.id, stateNodeToEnter.output !== undefined ? $59def02d21be1ba1$var$resolveOutput(stateNodeToEnter.output, nextSnapshot.context, event, actorScope.self) : undefined));
            while(ancestorMarker?.type === 'parallel' && !completedNodes.has(ancestorMarker) && $59def02d21be1ba1$export$3a1a48c8f6ef640e(mutStateNodeSet, ancestorMarker)){
                completedNodes.add(ancestorMarker);
                internalQueue.push($59def02d21be1ba1$var$createDoneStateEvent(ancestorMarker.id));
                rootCompletionNode = ancestorMarker;
                ancestorMarker = ancestorMarker.parent;
            }
            if (ancestorMarker) continue;
            nextSnapshot = $59def02d21be1ba1$export$71511d61b312f219(nextSnapshot, {
                status: 'done',
                output: $59def02d21be1ba1$var$getMachineOutput(nextSnapshot, event, actorScope, nextSnapshot.machine.root, rootCompletionNode)
            });
        }
    }
    return nextSnapshot;
}
function $59def02d21be1ba1$var$computeEntrySet(transitions, historyValue, statesForDefaultEntry, statesToEnter) {
    for (const t of transitions){
        const domain = $59def02d21be1ba1$var$getTransitionDomain(t, historyValue);
        for (const s of t.target || []){
            if (!$59def02d21be1ba1$var$isHistoryNode(s) && // if the target is different than the source then it will *definitely* be entered
            (t.source !== s || // we know that the domain can't lie within the source
            // if it's different than the source then it's outside of it and it means that the target has to be entered as well
            t.source !== domain || // reentering transitions always enter the target, even if it's the source itself
            t.reenter)) {
                statesToEnter.add(s);
                statesForDefaultEntry.add(s);
            }
            $59def02d21be1ba1$var$addDescendantStatesToEnter(s, historyValue, statesForDefaultEntry, statesToEnter);
        }
        const targetStates = $59def02d21be1ba1$var$getEffectiveTargetStates(t, historyValue);
        for (const s of targetStates){
            const ancestors = $59def02d21be1ba1$export$39b482c5e57630a8(s, domain);
            if (domain?.type === 'parallel') ancestors.push(domain);
            $59def02d21be1ba1$var$addAncestorStatesToEnter(statesToEnter, historyValue, statesForDefaultEntry, ancestors, !t.source.parent && t.reenter ? undefined : domain);
        }
    }
}
function $59def02d21be1ba1$var$addDescendantStatesToEnter(stateNode, historyValue, statesForDefaultEntry, statesToEnter) {
    if ($59def02d21be1ba1$var$isHistoryNode(stateNode)) {
        if (historyValue[stateNode.id]) {
            const historyStateNodes = historyValue[stateNode.id];
            for (const s of historyStateNodes){
                statesToEnter.add(s);
                $59def02d21be1ba1$var$addDescendantStatesToEnter(s, historyValue, statesForDefaultEntry, statesToEnter);
            }
            for (const s of historyStateNodes)$59def02d21be1ba1$var$addProperAncestorStatesToEnter(s, stateNode.parent, statesToEnter, historyValue, statesForDefaultEntry);
        } else {
            const historyDefaultTransition = $59def02d21be1ba1$var$resolveHistoryDefaultTransition(stateNode);
            for (const s of historyDefaultTransition.target){
                statesToEnter.add(s);
                if (historyDefaultTransition === stateNode.parent?.initial) statesForDefaultEntry.add(stateNode.parent);
                $59def02d21be1ba1$var$addDescendantStatesToEnter(s, historyValue, statesForDefaultEntry, statesToEnter);
            }
            for (const s of historyDefaultTransition.target)$59def02d21be1ba1$var$addProperAncestorStatesToEnter(s, stateNode.parent, statesToEnter, historyValue, statesForDefaultEntry);
        }
    } else {
        if (stateNode.type === 'compound') {
            const [initialState] = stateNode.initial.target;
            if (!$59def02d21be1ba1$var$isHistoryNode(initialState)) {
                statesToEnter.add(initialState);
                statesForDefaultEntry.add(initialState);
            }
            $59def02d21be1ba1$var$addDescendantStatesToEnter(initialState, historyValue, statesForDefaultEntry, statesToEnter);
            $59def02d21be1ba1$var$addProperAncestorStatesToEnter(initialState, stateNode, statesToEnter, historyValue, statesForDefaultEntry);
        } else if (stateNode.type === 'parallel') {
            for (const child of $59def02d21be1ba1$var$getChildren(stateNode).filter((sn)=>!$59def02d21be1ba1$var$isHistoryNode(sn)))if (![
                ...statesToEnter
            ].some((s)=>$59def02d21be1ba1$var$isDescendant(s, child))) {
                if (!$59def02d21be1ba1$var$isHistoryNode(child)) {
                    statesToEnter.add(child);
                    statesForDefaultEntry.add(child);
                }
                $59def02d21be1ba1$var$addDescendantStatesToEnter(child, historyValue, statesForDefaultEntry, statesToEnter);
            }
        }
    }
}
function $59def02d21be1ba1$var$addAncestorStatesToEnter(statesToEnter, historyValue, statesForDefaultEntry, ancestors, reentrancyDomain) {
    for (const anc of ancestors){
        if (!reentrancyDomain || $59def02d21be1ba1$var$isDescendant(anc, reentrancyDomain)) statesToEnter.add(anc);
        if (anc.type === 'parallel') {
            for (const child of $59def02d21be1ba1$var$getChildren(anc).filter((sn)=>!$59def02d21be1ba1$var$isHistoryNode(sn)))if (![
                ...statesToEnter
            ].some((s)=>$59def02d21be1ba1$var$isDescendant(s, child))) {
                statesToEnter.add(child);
                $59def02d21be1ba1$var$addDescendantStatesToEnter(child, historyValue, statesForDefaultEntry, statesToEnter);
            }
        }
    }
}
function $59def02d21be1ba1$var$addProperAncestorStatesToEnter(stateNode, toStateNode, statesToEnter, historyValue, statesForDefaultEntry) {
    $59def02d21be1ba1$var$addAncestorStatesToEnter(statesToEnter, historyValue, statesForDefaultEntry, $59def02d21be1ba1$export$39b482c5e57630a8(stateNode, toStateNode));
}
function $59def02d21be1ba1$var$exitStates(currentSnapshot, event, actorScope, transitions, mutStateNodeSet, historyValue, internalQueue, _actionExecutor) {
    let nextSnapshot = currentSnapshot;
    const statesToExit = $59def02d21be1ba1$var$computeExitSet(transitions, mutStateNodeSet, historyValue);
    statesToExit.sort((a, b)=>b.order - a.order);
    let changedHistory;
    // From SCXML algorithm: https://www.w3.org/TR/scxml/#exitStates
    for (const exitStateNode of statesToExit)for (const historyNode of $59def02d21be1ba1$var$getHistoryNodes(exitStateNode)){
        let predicate;
        if (historyNode.history === 'deep') predicate = (sn)=>$59def02d21be1ba1$export$2d1720544b23b823(sn) && $59def02d21be1ba1$var$isDescendant(sn, exitStateNode);
        else predicate = (sn)=>{
            return sn.parent === exitStateNode;
        };
        changedHistory ??= {
            ...historyValue
        };
        changedHistory[historyNode.id] = Array.from(mutStateNodeSet).filter(predicate);
    }
    for (const s of statesToExit){
        nextSnapshot = $59def02d21be1ba1$export$56c0d5a1e737357d(nextSnapshot, event, actorScope, [
            ...s.exit,
            ...s.invoke.map((def)=>$59def02d21be1ba1$export$2408f22a0fab9ae5(def.id))
        ], internalQueue, undefined);
        mutStateNodeSet.delete(s);
    }
    return [
        nextSnapshot,
        changedHistory || historyValue
    ];
}
function $59def02d21be1ba1$var$getAction(machine, actionType) {
    return machine.implementations.actions[actionType];
}
function $59def02d21be1ba1$var$resolveAndExecuteActionsWithContext(currentSnapshot, event, actorScope, actions, extra, retries) {
    const { machine: machine } = currentSnapshot;
    let intermediateSnapshot = currentSnapshot;
    for (const action of actions){
        const isInline = typeof action === 'function';
        const resolvedAction = isInline ? action : // the existing type of `.actions` assumes non-nullable `TExpressionAction`
        // it's fine to cast this here to get a common type and lack of errors in the rest of the code
        // our logic below makes sure that we call those 2 "variants" correctly
        $59def02d21be1ba1$var$getAction(machine, typeof action === 'string' ? action : action.type);
        const actionArgs = {
            context: intermediateSnapshot.context,
            event: event,
            self: actorScope.self,
            system: actorScope.system
        };
        const actionParams = isInline || typeof action === 'string' ? undefined : 'params' in action ? typeof action.params === 'function' ? action.params({
            context: intermediateSnapshot.context,
            event: event
        }) : action.params : undefined;
        if (!resolvedAction || !('resolve' in resolvedAction)) {
            actorScope.actionExecutor({
                type: typeof action === 'string' ? action : typeof action === 'object' ? action.type : action.name || '(anonymous)',
                info: actionArgs,
                params: actionParams,
                exec: resolvedAction
            });
            continue;
        }
        const builtinAction = resolvedAction;
        const [nextState, params, actions] = builtinAction.resolve(actorScope, intermediateSnapshot, actionArgs, actionParams, resolvedAction, // this holds all params
        extra);
        intermediateSnapshot = nextState;
        if ('retryResolve' in builtinAction) retries?.push([
            builtinAction,
            params
        ]);
        if ('execute' in builtinAction) actorScope.actionExecutor({
            type: builtinAction.type,
            info: actionArgs,
            params: params,
            exec: builtinAction.execute.bind(null, actorScope, params)
        });
        if (actions) intermediateSnapshot = $59def02d21be1ba1$var$resolveAndExecuteActionsWithContext(intermediateSnapshot, event, actorScope, actions, extra, retries);
    }
    return intermediateSnapshot;
}
function $59def02d21be1ba1$export$56c0d5a1e737357d(currentSnapshot, event, actorScope, actions, internalQueue, deferredActorIds) {
    const retries = deferredActorIds ? [] : undefined;
    const nextState = $59def02d21be1ba1$var$resolveAndExecuteActionsWithContext(currentSnapshot, event, actorScope, actions, {
        internalQueue: internalQueue,
        deferredActorIds: deferredActorIds
    }, retries);
    retries?.forEach(([builtinAction, params])=>{
        builtinAction.retryResolve(actorScope, nextState, params);
    });
    return nextState;
}
function $59def02d21be1ba1$export$4368d992c4eafac0(snapshot, event, actorScope, internalQueue) {
    let nextSnapshot = snapshot;
    const microsteps = [];
    function addMicrostep(step, event, transitions) {
        actorScope.system._sendInspectionEvent({
            type: '@xstate.microstep',
            actorRef: actorScope.self,
            event: event,
            snapshot: step[0],
            _transitions: transitions
        });
        microsteps.push(step);
    }
    // Handle stop event
    if (event.type === $59def02d21be1ba1$export$78acf4525d8a74c4) {
        nextSnapshot = $59def02d21be1ba1$export$71511d61b312f219($59def02d21be1ba1$var$stopChildren(nextSnapshot, event, actorScope), {
            status: 'stopped'
        });
        addMicrostep([
            nextSnapshot,
            []
        ], event, []);
        return {
            snapshot: nextSnapshot,
            microsteps: microsteps
        };
    }
    let nextEvent = event;
    // Assume the state is at rest (no raised events)
    // Determine the next state based on the next microstep
    if (nextEvent.type !== $59def02d21be1ba1$var$XSTATE_INIT) {
        const currentEvent = nextEvent;
        const isErr = $59def02d21be1ba1$var$isErrorActorEvent(currentEvent);
        const transitions = $59def02d21be1ba1$var$selectTransitions(currentEvent, nextSnapshot);
        if (isErr && !transitions.length) {
            // TODO: we should likely only allow transitions selected by very explicit descriptors
            // `*` shouldn't be matched, likely `xstate.error.*` shouldn't be either
            // similarly `xstate.error.actor.*` and `xstate.error.actor.todo.*` have to be considered too
            nextSnapshot = $59def02d21be1ba1$export$71511d61b312f219(snapshot, {
                status: 'error',
                error: currentEvent.error
            });
            addMicrostep([
                nextSnapshot,
                []
            ], currentEvent, []);
            return {
                snapshot: nextSnapshot,
                microsteps: microsteps
            };
        }
        const step = $59def02d21be1ba1$var$microstep(transitions, snapshot, actorScope, nextEvent, false, // isInitial
        internalQueue);
        nextSnapshot = step[0];
        addMicrostep(step, currentEvent, transitions);
    }
    let shouldSelectEventlessTransitions = true;
    while(nextSnapshot.status === 'active'){
        let enabledTransitions = shouldSelectEventlessTransitions ? $59def02d21be1ba1$var$selectEventlessTransitions(nextSnapshot, nextEvent) : [];
        // eventless transitions should always be selected after selecting *regular* transitions
        // by assigning `undefined` to `previousState` we ensure that `shouldSelectEventlessTransitions` gets always computed to true in such a case
        const previousState = enabledTransitions.length ? nextSnapshot : undefined;
        if (!enabledTransitions.length) {
            if (!internalQueue.length) break;
            nextEvent = internalQueue.shift();
            enabledTransitions = $59def02d21be1ba1$var$selectTransitions(nextEvent, nextSnapshot);
        }
        const step = $59def02d21be1ba1$var$microstep(enabledTransitions, nextSnapshot, actorScope, nextEvent, false, internalQueue);
        nextSnapshot = step[0];
        shouldSelectEventlessTransitions = nextSnapshot !== previousState;
        addMicrostep(step, nextEvent, enabledTransitions);
    }
    if (nextSnapshot.status !== 'active') $59def02d21be1ba1$var$stopChildren(nextSnapshot, nextEvent, actorScope);
    return {
        snapshot: nextSnapshot,
        microsteps: microsteps
    };
}
function $59def02d21be1ba1$var$stopChildren(nextState, event, actorScope) {
    return $59def02d21be1ba1$export$56c0d5a1e737357d(nextState, event, actorScope, Object.values(nextState.children).map((child)=>$59def02d21be1ba1$export$2408f22a0fab9ae5(child)), [], undefined);
}
function $59def02d21be1ba1$var$selectTransitions(event, nextState) {
    return nextState.machine.getTransitionData(nextState, event);
}
function $59def02d21be1ba1$var$selectEventlessTransitions(nextState, event) {
    const enabledTransitionSet = new Set();
    const atomicStates = nextState._nodes.filter($59def02d21be1ba1$export$2d1720544b23b823);
    for (const stateNode of atomicStates)loop: for (const s of [
        stateNode
    ].concat($59def02d21be1ba1$export$39b482c5e57630a8(stateNode, undefined))){
        if (!s.always) continue;
        for (const transition of s.always)if (transition.guard === undefined || $59def02d21be1ba1$export$96f57966bedc81b4(transition.guard, nextState.context, event, nextState)) {
            enabledTransitionSet.add(transition);
            break loop;
        }
    }
    return $59def02d21be1ba1$var$removeConflictingTransitions(Array.from(enabledTransitionSet), new Set(nextState._nodes), nextState.historyValue);
}
/**
 * Resolves a partial state value with its full representation in the state
 * node's machine.
 *
 * @param stateValue The partial state value to resolve.
 */ function $59def02d21be1ba1$export$b4171a6734a65d42(rootNode, stateValue) {
    const allStateNodes = $59def02d21be1ba1$export$3466f893ebf79586($59def02d21be1ba1$export$ffb5f4729a158638(rootNode, stateValue));
    return $59def02d21be1ba1$var$getStateValue(rootNode, [
        ...allStateNodes
    ]);
}
function $59def02d21be1ba1$export$882b5998b3b9117c(value) {
    return !!value && typeof value === 'object' && 'machine' in value && 'value' in value;
}
const $59def02d21be1ba1$var$machineSnapshotMatches = function matches(testValue) {
    return $59def02d21be1ba1$export$3b14a55fb2447963(testValue, this.value);
};
const $59def02d21be1ba1$var$machineSnapshotHasTag = function hasTag(tag) {
    return this.tags.has(tag);
};
const $59def02d21be1ba1$var$machineSnapshotCan = function can(event) {
    const transitionData = this.machine.getTransitionData(this, event);
    return !!transitionData?.length && // Check that at least one transition is not forbidden
    transitionData.some((t)=>t.target !== undefined || t.actions.length);
};
const $59def02d21be1ba1$var$machineSnapshotToJSON = function toJSON() {
    const { _nodes: nodes, tags: tags, machine: machine, getMeta: getMeta, toJSON: toJSON, can: can, hasTag: hasTag, matches: matches, ...jsonValues } = this;
    return {
        ...jsonValues,
        tags: Array.from(tags)
    };
};
const $59def02d21be1ba1$var$machineSnapshotGetMeta = function getMeta() {
    return this._nodes.reduce((acc, stateNode)=>{
        if (stateNode.meta !== undefined) acc[stateNode.id] = stateNode.meta;
        return acc;
    }, {});
};
function $59def02d21be1ba1$export$61196ced6d74a310(config, machine) {
    return {
        status: config.status,
        output: config.output,
        error: config.error,
        machine: machine,
        context: config.context,
        _nodes: config._nodes,
        value: $59def02d21be1ba1$var$getStateValue(machine.root, config._nodes),
        tags: new Set(config._nodes.flatMap((sn)=>sn.tags)),
        children: config.children,
        historyValue: config.historyValue || {},
        matches: $59def02d21be1ba1$var$machineSnapshotMatches,
        hasTag: $59def02d21be1ba1$var$machineSnapshotHasTag,
        can: $59def02d21be1ba1$var$machineSnapshotCan,
        getMeta: $59def02d21be1ba1$var$machineSnapshotGetMeta,
        toJSON: $59def02d21be1ba1$var$machineSnapshotToJSON
    };
}
function $59def02d21be1ba1$export$71511d61b312f219(snapshot, config = {}) {
    return $59def02d21be1ba1$export$61196ced6d74a310({
        ...snapshot,
        ...config
    }, snapshot.machine);
}
function $59def02d21be1ba1$var$serializeHistoryValue(historyValue) {
    if (typeof historyValue !== 'object' || historyValue === null) return {};
    const result = {};
    for(const key in historyValue){
        const value = historyValue[key];
        if (Array.isArray(value)) result[key] = value.map((item)=>({
                id: item.id
            }));
    }
    return result;
}
function $59def02d21be1ba1$export$3a6d5c9ae78a2c08(snapshot, options) {
    const { _nodes: nodes, tags: tags, machine: machine, children: children, context: context, can: can, hasTag: hasTag, matches: matches, getMeta: getMeta, toJSON: toJSON, ...jsonValues } = snapshot;
    const childrenJson = {};
    for(const id in children){
        const child = children[id];
        childrenJson[id] = {
            snapshot: child.getPersistedSnapshot(options),
            src: child.src,
            systemId: child.systemId,
            syncSnapshot: child._syncSnapshot
        };
    }
    const persisted = {
        ...jsonValues,
        context: $59def02d21be1ba1$var$persistContext(context),
        children: childrenJson,
        historyValue: $59def02d21be1ba1$var$serializeHistoryValue(jsonValues.historyValue)
    };
    return persisted;
}
function $59def02d21be1ba1$var$persistContext(contextPart) {
    let copy;
    for(const key in contextPart){
        const value = contextPart[key];
        if (value && typeof value === 'object') {
            if ('sessionId' in value && 'send' in value && 'ref' in value) {
                copy ??= Array.isArray(contextPart) ? contextPart.slice() : {
                    ...contextPart
                };
                copy[key] = {
                    xstate$$type: $59def02d21be1ba1$export$3d8c2f653ac9d0b9,
                    id: value.id
                };
            } else {
                const result = $59def02d21be1ba1$var$persistContext(value);
                if (result !== value) {
                    copy ??= Array.isArray(contextPart) ? contextPart.slice() : {
                        ...contextPart
                    };
                    copy[key] = result;
                }
            }
        }
    }
    return copy ?? contextPart;
}
function $59def02d21be1ba1$var$resolveRaise(_, snapshot, args, actionParams, { event: eventOrExpr, id: id, delay: delay }, { internalQueue: internalQueue }) {
    const delaysMap = snapshot.machine.implementations.delays;
    if (typeof eventOrExpr === 'string') throw new Error(// eslint-disable-next-line @typescript-eslint/restrict-template-expressions
    `Only event objects may be used with raise; use raise({ type: "${eventOrExpr}" }) instead`);
    const resolvedEvent = typeof eventOrExpr === 'function' ? eventOrExpr(args, actionParams) : eventOrExpr;
    let resolvedDelay;
    if (typeof delay === 'string') {
        const configDelay = delaysMap && delaysMap[delay];
        resolvedDelay = typeof configDelay === 'function' ? configDelay(args, actionParams) : configDelay;
    } else resolvedDelay = typeof delay === 'function' ? delay(args, actionParams) : delay;
    if (typeof resolvedDelay !== 'number') internalQueue.push(resolvedEvent);
    return [
        snapshot,
        {
            event: resolvedEvent,
            id: id,
            delay: resolvedDelay
        },
        undefined
    ];
}
function $59def02d21be1ba1$var$executeRaise(actorScope, params) {
    const { event: event, delay: delay, id: id } = params;
    if (typeof delay === 'number') {
        actorScope.defer(()=>{
            const self = actorScope.self;
            actorScope.system.scheduler.schedule(self, self, event, delay, id);
        });
        return;
    }
}
/**
 * Raises an event. This places the event in the internal event queue, so that
 * the event is immediately consumed by the machine in the current step.
 *
 * @param eventType The event to raise.
 */ function $59def02d21be1ba1$export$43caf9889c228507(eventOrExpr, options) {
    function raise(_args, _params) {}
    raise.type = 'xstate.raise';
    raise.event = eventOrExpr;
    raise.id = options?.id;
    raise.delay = options?.delay;
    raise.resolve = $59def02d21be1ba1$var$resolveRaise;
    raise.execute = $59def02d21be1ba1$var$executeRaise;
    return raise;
}



/**
 * Represents an actor created by `fromTransition`.
 *
 * The type of `self` within the actor's logic.
 *
 * @example
 *
 * ```ts
 * import {
 *   fromTransition,
 *   createActor,
 *   type AnyActorSystem
 * } from 'xstate';
 *
 * //* The actor's stored context.
 * type Context = {
 *   // The current count.
 *   count: number;
 *   // The amount to increase `count` by.
 *   step: number;
 * };
 * // The events the actor receives.
 * type Event = { type: 'increment' };
 * // The actor's input.
 * type Input = { step?: number };
 *
 * // Actor logic that increments `count` by `step` when it receives an event of
 * // type `increment`.
 * const logic = fromTransition<Context, Event, AnyActorSystem, Input>(
 *   (state, event, actorScope) => {
 *     actorScope.self;
 *     //         ^? TransitionActorRef<Context, Event>
 *
 *     if (event.type === 'increment') {
 *       return {
 *         ...state,
 *         count: state.count + state.step
 *       };
 *     }
 *     return state;
 *   },
 *   ({ input, self }) => {
 *     self;
 *     // ^? TransitionActorRef<Context, Event>
 *
 *     return {
 *       count: 0,
 *       step: input.step ?? 1
 *     };
 *   }
 * );
 *
 * const actor = createActor(logic, { input: { step: 10 } });
 * //    ^? TransitionActorRef<Context, Event>
 * ```
 *
 * @see {@link fromTransition}
 */ /**
 * Returns actor logic given a transition function and its initial state.
 *
 * A “transition function” is a function that takes the current `state` and
 * received `event` object as arguments, and returns the next state, similar to
 * a reducer.
 *
 * Actors created from transition logic (“transition actors”) can:
 *
 * - Receive events
 * - Emit snapshots of its state
 *
 * The transition function’s `state` is used as its transition actor’s
 * `context`.
 *
 * Note that the "state" for a transition function is provided by the initial
 * state argument, and is not the same as the State object of an actor or a
 * state within a machine configuration.
 *
 * @example
 *
 * ```ts
 * const transitionLogic = fromTransition(
 *   (state, event) => {
 *     if (event.type === 'increment') {
 *       return {
 *         ...state,
 *         count: state.count + 1
 *       };
 *     }
 *     return state;
 *   },
 *   { count: 0 }
 * );
 *
 * const transitionActor = createActor(transitionLogic);
 * transitionActor.subscribe((snapshot) => {
 *   console.log(snapshot);
 * });
 * transitionActor.start();
 * // => {
 * //   status: 'active',
 * //   context: { count: 0 },
 * //   ...
 * // }
 *
 * transitionActor.send({ type: 'increment' });
 * // => {
 * //   status: 'active',
 * //   context: { count: 1 },
 * //   ...
 * // }
 * ```
 *
 * @param transition The transition function used to describe the transition
 *   logic. It should return the next state given the current state and event.
 *   It receives the following arguments:
 *
 *   - `state` - the current state.
 *   - `event` - the received event.
 *   - `actorScope` - the actor scope object, with properties like `self` and
 *       `system`.
 *
 * @param initialContext The initial state of the transition function, either an
 *   object representing the state, or a function which returns a state object.
 *   If a function, it will receive as its only argument an object with the
 *   following properties:
 *
 *   - `input` - the `input` provided to its parent transition actor.
 *   - `self` - a reference to its parent transition actor.
 *
 * @returns Actor logic
 * @see {@link https://stately.ai/docs/input | Input docs} for more information about how input is passed
 */ function $62ef9efea04b2fd2$export$439a4be7208a15ca(transition, initialContext) {
    return {
        config: transition,
        transition: (snapshot, event, actorScope)=>{
            return {
                ...snapshot,
                context: transition(snapshot.context, event, actorScope)
            };
        },
        getInitialSnapshot: (_, input)=>{
            return {
                status: 'active',
                output: undefined,
                error: undefined,
                context: typeof initialContext === 'function' ? initialContext({
                    input: input
                }) : initialContext
            };
        },
        getPersistedSnapshot: (snapshot)=>snapshot,
        restoreSnapshot: (snapshot)=>snapshot
    };
}
const $62ef9efea04b2fd2$var$instanceStates = /* #__PURE__ */ new WeakMap();
/**
 * Represents an actor created by `fromCallback`.
 *
 * The type of `self` within the actor's logic.
 *
 * @example
 *
 * ```ts
 * import { fromCallback, createActor } from 'xstate';
 *
 * // The events the actor receives.
 * type Event = { type: 'someEvent' };
 * // The actor's input.
 * type Input = { name: string };
 *
 * // Actor logic that logs whenever it receives an event of type `someEvent`.
 * const logic = fromCallback<Event, Input>(({ self, input, receive }) => {
 *   self;
 *   // ^? CallbackActorRef<Event, Input>
 *
 *   receive((event) => {
 *     if (event.type === 'someEvent') {
 *       console.log(`${input.name}: received "someEvent" event`);
 *       // logs 'myActor: received "someEvent" event'
 *     }
 *   });
 * });
 *
 * const actor = createActor(logic, { input: { name: 'myActor' } });
 * //    ^? CallbackActorRef<Event, Input>
 * ```
 *
 * @see {@link fromCallback}
 */ /**
 * An actor logic creator which returns callback logic as defined by a callback
 * function.
 *
 * @remarks
 * Useful for subscription-based or other free-form logic that can send events
 * back to the parent actor.
 *
 * Actors created from callback logic (“callback actors”) can:
 *
 * - Receive events via the `receive` function
 * - Send events to the parent actor via the `sendBack` function
 *
 * Callback actors are a bit different from other actors in that they:
 *
 * - Do not work with `onDone`
 * - Do not produce a snapshot using `.getSnapshot()`
 * - Do not emit values when used with `.subscribe()`
 * - Can not be stopped with `.stop()`
 *
 * @example
 *
 * ```typescript
 * const callbackLogic = fromCallback(({ sendBack, receive }) => {
 *   let lockStatus = 'unlocked';
 *
 *   const handler = (event) => {
 *     if (lockStatus === 'locked') {
 *       return;
 *     }
 *     sendBack(event);
 *   };
 *
 *   receive((event) => {
 *     if (event.type === 'lock') {
 *       lockStatus = 'locked';
 *     } else if (event.type === 'unlock') {
 *       lockStatus = 'unlocked';
 *     }
 *   });
 *
 *   document.body.addEventListener('click', handler);
 *
 *   return () => {
 *     document.body.removeEventListener('click', handler);
 *   };
 * });
 * ```
 *
 * @param callback - The callback function used to describe the callback logic
 *   The callback function is passed an object with the following properties:
 *
 *   - `receive` - A function that can send events back to the parent actor; the
 *       listener is then called whenever events are received by the callback
 *       actor
 *   - `sendBack` - A function that can send events back to the parent actor
 *   - `input` - Data that was provided to the callback actor
 *   - `self` - The parent actor of the callback actor
 *   - `system` - The actor system to which the callback actor belongs The callback
 *       function can (optionally) return a cleanup function, which is called
 *       when the actor is stopped.
 *
 * @returns Callback logic
 * @see {@link CallbackLogicFunction} for more information about the callback function and its object argument
 * @see {@link https://stately.ai/docs/input | Input docs} for more information about how input is passed
 */ function $62ef9efea04b2fd2$export$d0deb4828877173(callback) {
    const logic = {
        config: callback,
        start: (state, actorScope)=>{
            const { self: self, system: system, emit: emit } = actorScope;
            const callbackState = {
                receivers: undefined,
                dispose: undefined
            };
            $62ef9efea04b2fd2$var$instanceStates.set(self, callbackState);
            callbackState.dispose = callback({
                input: state.input,
                system: system,
                self: self,
                sendBack: (event)=>{
                    if (self.getSnapshot().status === 'stopped') return;
                    if (self._parent) system._relay(self, self._parent, event);
                },
                receive: (listener)=>{
                    callbackState.receivers ??= new Set();
                    callbackState.receivers.add(listener);
                },
                emit: emit
            });
        },
        transition: (state, event, actorScope)=>{
            const callbackState = $62ef9efea04b2fd2$var$instanceStates.get(actorScope.self);
            if (event.type === (0, $59def02d21be1ba1$export$78acf4525d8a74c4)) {
                state = {
                    ...state,
                    status: 'stopped',
                    error: undefined
                };
                $62ef9efea04b2fd2$var$instanceStates.delete(actorScope.self);
                callbackState.receivers?.clear();
                callbackState.dispose?.();
                return state;
            }
            callbackState.receivers?.forEach((receiver)=>receiver(event));
            return state;
        },
        getInitialSnapshot: (_, input)=>{
            return {
                status: 'active',
                output: undefined,
                error: undefined,
                input: input
            };
        },
        getPersistedSnapshot: (snapshot)=>snapshot,
        restoreSnapshot: (snapshot)=>snapshot
    };
    return logic;
}
const $62ef9efea04b2fd2$var$XSTATE_OBSERVABLE_NEXT = 'xstate.observable.next';
const $62ef9efea04b2fd2$var$XSTATE_OBSERVABLE_ERROR = 'xstate.observable.error';
const $62ef9efea04b2fd2$var$XSTATE_OBSERVABLE_COMPLETE = 'xstate.observable.complete';
/**
 * Represents an actor created by `fromObservable` or `fromEventObservable`.
 *
 * The type of `self` within the actor's logic.
 *
 * @example
 *
 * ```ts
 * import { fromObservable, createActor } from 'xstate';
 * import { interval } from 'rxjs';
 *
 * // The type of the value observed by the actor's logic.
 * type Context = number;
 * // The actor's input.
 * type Input = { period?: number };
 *
 * // Actor logic that observes a number incremented every `input.period`
 * // milliseconds (default: 1_000).
 * const logic = fromObservable<Context, Input>(({ input, self }) => {
 *   self;
 *   // ^? ObservableActorRef<Event, Input>
 *
 *   return interval(input.period ?? 1_000);
 * });
 *
 * const actor = createActor(logic, { input: { period: 2_000 } });
 * //    ^? ObservableActorRef<Event, Input>
 * ```
 *
 * @see {@link fromObservable}
 * @see {@link fromEventObservable}
 */ /**
 * Observable actor logic is described by an observable stream of values. Actors
 * created from observable logic (“observable actors”) can:
 *
 * - Emit snapshots of the observable’s emitted value
 *
 * The observable’s emitted value is used as its observable actor’s `context`.
 *
 * Sending events to observable actors will have no effect.
 *
 * @example
 *
 * ```ts
 * import { fromObservable, createActor } from 'xstate';
 * import { interval } from 'rxjs';
 *
 * const logic = fromObservable((obj) => interval(1000));
 *
 * const actor = createActor(logic);
 *
 * actor.subscribe((snapshot) => {
 *   console.log(snapshot.context);
 * });
 *
 * actor.start();
 * // At every second:
 * // Logs 0
 * // Logs 1
 * // Logs 2
 * // ...
 * ```
 *
 * @param observableCreator A function that creates an observable. It receives
 *   one argument, an object with the following properties:
 *
 *   - `input` - Data that was provided to the observable actor
 *   - `self` - The parent actor
 *   - `system` - The actor system to which the observable actor belongs
 *
 *   It should return a {@link Subscribable}, which is compatible with an RxJS
 *   Observable, although RxJS is not required to create them.
 * @see {@link https://rxjs.dev} for documentation on RxJS Observable and observable creators.
 * @see {@link Subscribable} interface in XState, which is based on and compatible with RxJS Observable.
 */ function $62ef9efea04b2fd2$export$4b2432e2d8723823(observableCreator) {
    // TODO: add event types
    const logic = {
        config: observableCreator,
        transition: (snapshot, event)=>{
            if (snapshot.status !== 'active') return snapshot;
            switch(event.type){
                case $62ef9efea04b2fd2$var$XSTATE_OBSERVABLE_NEXT:
                    {
                        const newSnapshot = {
                            ...snapshot,
                            context: event.data
                        };
                        return newSnapshot;
                    }
                case $62ef9efea04b2fd2$var$XSTATE_OBSERVABLE_ERROR:
                    return {
                        ...snapshot,
                        status: 'error',
                        error: event.data,
                        input: undefined,
                        _subscription: undefined
                    };
                case $62ef9efea04b2fd2$var$XSTATE_OBSERVABLE_COMPLETE:
                    return {
                        ...snapshot,
                        status: 'done',
                        input: undefined,
                        _subscription: undefined
                    };
                case 0, $59def02d21be1ba1$export$78acf4525d8a74c4:
                    snapshot._subscription.unsubscribe();
                    return {
                        ...snapshot,
                        status: 'stopped',
                        input: undefined,
                        _subscription: undefined
                    };
                default:
                    return snapshot;
            }
        },
        getInitialSnapshot: (_, input)=>{
            return {
                status: 'active',
                output: undefined,
                error: undefined,
                context: undefined,
                input: input,
                _subscription: undefined
            };
        },
        start: (state, { self: self, system: system, emit: emit })=>{
            if (state.status === 'done') // Do not restart a completed observable
            return;
            state._subscription = observableCreator({
                input: state.input,
                system: system,
                self: self,
                emit: emit
            }).subscribe({
                next: (value)=>{
                    system._relay(self, self, {
                        type: $62ef9efea04b2fd2$var$XSTATE_OBSERVABLE_NEXT,
                        data: value
                    });
                },
                error: (err)=>{
                    system._relay(self, self, {
                        type: $62ef9efea04b2fd2$var$XSTATE_OBSERVABLE_ERROR,
                        data: err
                    });
                },
                complete: ()=>{
                    system._relay(self, self, {
                        type: $62ef9efea04b2fd2$var$XSTATE_OBSERVABLE_COMPLETE
                    });
                }
            });
        },
        getPersistedSnapshot: ({ _subscription: _subscription, ...state })=>state,
        restoreSnapshot: (state)=>({
                ...state,
                _subscription: undefined
            })
    };
    return logic;
}
/**
 * Creates event observable logic that listens to an observable that delivers
 * event objects.
 *
 * Event observable actor logic is described by an observable stream of
 * {@link https://stately.ai/docs/transitions#event-objects | event objects}.
 * Actors created from event observable logic (“event observable actors”) can:
 *
 * - Implicitly send events to its parent actor
 * - Emit snapshots of its emitted event objects
 *
 * Sending events to event observable actors will have no effect.
 *
 * @example
 *
 * ```ts
 * import {
 *   fromEventObservable,
 *   Subscribable,
 *   EventObject,
 *   createMachine,
 *   createActor
 * } from 'xstate';
 * import { fromEvent } from 'rxjs';
 *
 * const mouseClickLogic = fromEventObservable(
 *   () => fromEvent(document.body, 'click') as Subscribable<EventObject>
 * );
 *
 * const canvasMachine = createMachine({
 *   invoke: {
 *     // Will send mouse `click` events to the canvas actor
 *     src: mouseClickLogic
 *   }
 * });
 *
 * const canvasActor = createActor(canvasMachine);
 * canvasActor.start();
 * ```
 *
 * @param lazyObservable A function that creates an observable that delivers
 *   event objects. It receives one argument, an object with the following
 *   properties:
 *
 *   - `input` - Data that was provided to the event observable actor
 *   - `self` - The parent actor
 *   - `system` - The actor system to which the event observable actor belongs.
 *
 *   It should return a {@link Subscribable}, which is compatible with an RxJS
 *   Observable, although RxJS is not required to create them.
 */ function $62ef9efea04b2fd2$export$32b16bdebc365919(lazyObservable) {
    // TODO: event types
    const logic = {
        config: lazyObservable,
        transition: (state, event)=>{
            if (state.status !== 'active') return state;
            switch(event.type){
                case $62ef9efea04b2fd2$var$XSTATE_OBSERVABLE_ERROR:
                    return {
                        ...state,
                        status: 'error',
                        error: event.data,
                        input: undefined,
                        _subscription: undefined
                    };
                case $62ef9efea04b2fd2$var$XSTATE_OBSERVABLE_COMPLETE:
                    return {
                        ...state,
                        status: 'done',
                        input: undefined,
                        _subscription: undefined
                    };
                case 0, $59def02d21be1ba1$export$78acf4525d8a74c4:
                    state._subscription.unsubscribe();
                    return {
                        ...state,
                        status: 'stopped',
                        input: undefined,
                        _subscription: undefined
                    };
                default:
                    return state;
            }
        },
        getInitialSnapshot: (_, input)=>{
            return {
                status: 'active',
                output: undefined,
                error: undefined,
                context: undefined,
                input: input,
                _subscription: undefined
            };
        },
        start: (state, { self: self, system: system, emit: emit })=>{
            if (state.status === 'done') // Do not restart a completed observable
            return;
            state._subscription = lazyObservable({
                input: state.input,
                system: system,
                self: self,
                emit: emit
            }).subscribe({
                next: (value)=>{
                    if (self._parent) system._relay(self, self._parent, value);
                },
                error: (err)=>{
                    system._relay(self, self, {
                        type: $62ef9efea04b2fd2$var$XSTATE_OBSERVABLE_ERROR,
                        data: err
                    });
                },
                complete: ()=>{
                    system._relay(self, self, {
                        type: $62ef9efea04b2fd2$var$XSTATE_OBSERVABLE_COMPLETE
                    });
                }
            });
        },
        getPersistedSnapshot: ({ _subscription: _subscription, ...snapshot })=>snapshot,
        restoreSnapshot: (snapshot)=>({
                ...snapshot,
                _subscription: undefined
            })
    };
    return logic;
}
const $62ef9efea04b2fd2$var$XSTATE_PROMISE_RESOLVE = 'xstate.promise.resolve';
const $62ef9efea04b2fd2$var$XSTATE_PROMISE_REJECT = 'xstate.promise.reject';
/**
 * Represents an actor created by `fromPromise`.
 *
 * The type of `self` within the actor's logic.
 *
 * @example
 *
 * ```ts
 * import { fromPromise, createActor } from 'xstate';
 *
 * // The actor's resolved output
 * type Output = string;
 * // The actor's input.
 * type Input = { message: string };
 *
 * // Actor logic that fetches the url of an image of a cat saying `input.message`.
 * const logic = fromPromise<Output, Input>(async ({ input, self }) => {
 *   self;
 *   // ^? PromiseActorRef<Output, Input>
 *
 *   const data = await fetch(
 *     `https://cataas.com/cat/says/${input.message}`
 *   );
 *   const url = await data.json();
 *   return url;
 * });
 *
 * const actor = createActor(logic, { input: { message: 'hello world' } });
 * //    ^? PromiseActorRef<Output, Input>
 * ```
 *
 * @see {@link fromPromise}
 */ const $62ef9efea04b2fd2$var$controllerMap = new WeakMap();
/**
 * An actor logic creator which returns promise logic as defined by an async
 * process that resolves or rejects after some time.
 *
 * Actors created from promise actor logic (“promise actors”) can:
 *
 * - Emit the resolved value of the promise
 * - Output the resolved value of the promise
 *
 * Sending events to promise actors will have no effect.
 *
 * @example
 *
 * ```ts
 * const promiseLogic = fromPromise(async () => {
 *   const result = await fetch('https://example.com/...').then((data) =>
 *     data.json()
 *   );
 *
 *   return result;
 * });
 *
 * const promiseActor = createActor(promiseLogic);
 * promiseActor.subscribe((snapshot) => {
 *   console.log(snapshot);
 * });
 * promiseActor.start();
 * // => {
 * //   output: undefined,
 * //   status: 'active'
 * //   ...
 * // }
 *
 * // After promise resolves
 * // => {
 * //   output: { ... },
 * //   status: 'done',
 * //   ...
 * // }
 * ```
 *
 * @param promiseCreator A function which returns a Promise, and accepts an
 *   object with the following properties:
 *
 *   - `input` - Data that was provided to the promise actor
 *   - `self` - The parent actor of the promise actor
 *   - `system` - The actor system to which the promise actor belongs
 *
 * @see {@link https://stately.ai/docs/input | Input docs} for more information about how input is passed
 */ function $62ef9efea04b2fd2$export$60f45028237c39d1(promiseCreator) {
    const logic = {
        config: promiseCreator,
        transition: (state, event, scope)=>{
            if (state.status !== 'active') return state;
            switch(event.type){
                case $62ef9efea04b2fd2$var$XSTATE_PROMISE_RESOLVE:
                    {
                        const resolvedValue = event.data;
                        return {
                            ...state,
                            status: 'done',
                            output: resolvedValue,
                            input: undefined
                        };
                    }
                case $62ef9efea04b2fd2$var$XSTATE_PROMISE_REJECT:
                    return {
                        ...state,
                        status: 'error',
                        error: event.data,
                        input: undefined
                    };
                case 0, $59def02d21be1ba1$export$78acf4525d8a74c4:
                    $62ef9efea04b2fd2$var$controllerMap.get(scope.self)?.abort();
                    $62ef9efea04b2fd2$var$controllerMap.delete(scope.self);
                    return {
                        ...state,
                        status: 'stopped',
                        input: undefined
                    };
                default:
                    return state;
            }
        },
        start: (state, { self: self, system: system, emit: emit })=>{
            // TODO: determine how to allow customizing this so that promises
            // can be restarted if necessary
            if (state.status !== 'active') return;
            const controller = new AbortController();
            $62ef9efea04b2fd2$var$controllerMap.set(self, controller);
            const resolvedPromise = Promise.resolve(promiseCreator({
                input: state.input,
                system: system,
                self: self,
                signal: controller.signal,
                emit: emit
            }));
            resolvedPromise.then((response)=>{
                if (self.getSnapshot().status !== 'active') return;
                $62ef9efea04b2fd2$var$controllerMap.delete(self);
                system._relay(self, self, {
                    type: $62ef9efea04b2fd2$var$XSTATE_PROMISE_RESOLVE,
                    data: response
                });
            }, (errorData)=>{
                if (self.getSnapshot().status !== 'active') return;
                $62ef9efea04b2fd2$var$controllerMap.delete(self);
                system._relay(self, self, {
                    type: $62ef9efea04b2fd2$var$XSTATE_PROMISE_REJECT,
                    data: errorData
                });
            });
        },
        getInitialSnapshot: (_, input)=>{
            return {
                status: 'active',
                output: undefined,
                error: undefined,
                input: input
            };
        },
        getPersistedSnapshot: (snapshot)=>snapshot,
        restoreSnapshot: (snapshot)=>snapshot
    };
    return logic;
}
const $62ef9efea04b2fd2$var$emptyLogic = $62ef9efea04b2fd2$export$439a4be7208a15ca((_)=>undefined, undefined);
function $62ef9efea04b2fd2$export$302970cd5518279b() {
    return (0, $59def02d21be1ba1$export$db3b6bfb95261072)($62ef9efea04b2fd2$var$emptyLogic);
}





function $174145984b82c661$var$createSpawner(actorScope, { machine: machine, context: context }, event, spawnedChildren) {
    const spawn = (src, options)=>{
        if (typeof src === 'string') {
            const logic = (0, $59def02d21be1ba1$export$e7c866399fa523f5)(machine, src);
            if (!logic) throw new Error(`Actor logic '${src}' not implemented in machine '${machine.id}'`);
            const actorRef = (0, $59def02d21be1ba1$export$db3b6bfb95261072)(logic, {
                id: options?.id,
                parent: actorScope.self,
                syncSnapshot: options?.syncSnapshot,
                input: typeof options?.input === 'function' ? options.input({
                    context: context,
                    event: event,
                    self: actorScope.self
                }) : options?.input,
                src: src,
                systemId: options?.systemId
            });
            spawnedChildren[actorRef.id] = actorRef;
            return actorRef;
        } else {
            const actorRef = (0, $59def02d21be1ba1$export$db3b6bfb95261072)(src, {
                id: options?.id,
                parent: actorScope.self,
                syncSnapshot: options?.syncSnapshot,
                input: options?.input,
                src: src,
                systemId: options?.systemId
            });
            return actorRef;
        }
    };
    return (src, options)=>{
        const actorRef = spawn(src, options); // TODO: fix types
        spawnedChildren[actorRef.id] = actorRef;
        actorScope.defer(()=>{
            if (actorRef._processingStatus === (0, $59def02d21be1ba1$export$dc98b0b04f4c7758).Stopped) return;
            actorRef.start();
        });
        return actorRef;
    };
}
function $174145984b82c661$var$resolveAssign(actorScope, snapshot, actionArgs, actionParams, { assignment: assignment }) {
    if (!snapshot.context) throw new Error('Cannot assign to undefined `context`. Ensure that `context` is defined in the machine config.');
    const spawnedChildren = {};
    const assignArgs = {
        context: snapshot.context,
        event: actionArgs.event,
        spawn: $174145984b82c661$var$createSpawner(actorScope, snapshot, actionArgs.event, spawnedChildren),
        self: actorScope.self,
        system: actorScope.system
    };
    let partialUpdate = {};
    if (typeof assignment === 'function') partialUpdate = assignment(assignArgs, actionParams);
    else for (const key of Object.keys(assignment)){
        const propAssignment = assignment[key];
        partialUpdate[key] = typeof propAssignment === 'function' ? propAssignment(assignArgs, actionParams) : propAssignment;
    }
    const updatedContext = Object.assign({}, snapshot.context, partialUpdate);
    return [
        (0, $59def02d21be1ba1$export$71511d61b312f219)(snapshot, {
            context: updatedContext,
            children: Object.keys(spawnedChildren).length ? {
                ...snapshot.children,
                ...spawnedChildren
            } : snapshot.children
        }),
        undefined,
        undefined
    ];
}
/**
 * Updates the current context of the machine.
 *
 * @example
 *
 * ```ts
 * import { createMachine, assign } from 'xstate';
 *
 * const countMachine = createMachine({
 *   context: {
 *     count: 0,
 *     message: ''
 *   },
 *   on: {
 *     inc: {
 *       actions: assign({
 *         count: ({ context }) => context.count + 1
 *       })
 *     },
 *     updateMessage: {
 *       actions: assign(({ context, event }) => {
 *         return {
 *           message: event.message.trim()
 *         };
 *       })
 *     }
 *   }
 * });
 * ```
 *
 * @param assignment An object that represents the partial context to update, or
 *   a function that returns an object that represents the partial context to
 *   update.
 */ function $174145984b82c661$export$407448d2b89b1813(assignment) {
    function assign(_args, _params) {}
    assign.type = 'xstate.assign';
    assign.assignment = assignment;
    assign.resolve = $174145984b82c661$var$resolveAssign;
    return assign;
}


const $e74e3f2e30f36024$var$cache = new WeakMap();
function $e74e3f2e30f36024$var$memo(object, key, fn) {
    let memoizedData = $e74e3f2e30f36024$var$cache.get(object);
    if (!memoizedData) {
        memoizedData = {
            [key]: fn()
        };
        $e74e3f2e30f36024$var$cache.set(object, memoizedData);
    } else if (!(key in memoizedData)) memoizedData[key] = fn();
    return memoizedData[key];
}
const $e74e3f2e30f36024$var$EMPTY_OBJECT = {};
const $e74e3f2e30f36024$var$toSerializableAction = (action)=>{
    if (typeof action === 'string') return {
        type: action
    };
    if (typeof action === 'function') {
        if ('resolve' in action) return {
            type: action.type
        };
        return {
            type: action.name
        };
    }
    return action;
};
class $e74e3f2e30f36024$export$407448d2b89b1813 {
    constructor(/** The raw config used to create the machine. */ config, options){
        this.config = config;
        /**
     * The relative key of the state node, which represents its location in the
     * overall state value.
     */ this.key = void 0;
        /** The unique ID of the state node. */ this.id = void 0;
        /**
     * The type of this state node:
     *
     * - `'atomic'` - no child state nodes
     * - `'compound'` - nested child state nodes (XOR)
     * - `'parallel'` - orthogonal nested child state nodes (AND)
     * - `'history'` - history state node
     * - `'final'` - final state node
     */ this.type = void 0;
        /** The string path from the root machine node to this node. */ this.path = void 0;
        /** The child state nodes. */ this.states = void 0;
        /**
     * The type of history on this state node. Can be:
     *
     * - `'shallow'` - recalls only top-level historical state value
     * - `'deep'` - recalls historical state value at all levels
     */ this.history = void 0;
        /** The action(s) to be executed upon entering the state node. */ this.entry = void 0;
        /** The action(s) to be executed upon exiting the state node. */ this.exit = void 0;
        /** The parent state node. */ this.parent = void 0;
        /** The root machine node. */ this.machine = void 0;
        /**
     * The meta data associated with this state node, which will be returned in
     * State instances.
     */ this.meta = void 0;
        /**
     * The output data sent with the "xstate.done.state._id_" event if this is a
     * final state node.
     */ this.output = void 0;
        /**
     * The order this state node appears. Corresponds to the implicit document
     * order.
     */ this.order = -1;
        this.description = void 0;
        this.tags = [];
        this.transitions = void 0;
        this.always = void 0;
        this.parent = options._parent;
        this.key = options._key;
        this.machine = options._machine;
        this.path = this.parent ? this.parent.path.concat(this.key) : [];
        this.id = this.config.id || [
            this.machine.id,
            ...this.path
        ].join((0, $59def02d21be1ba1$export$25ce5a424b770e84));
        this.type = this.config.type || (this.config.states && Object.keys(this.config.states).length ? 'compound' : this.config.history ? 'history' : 'atomic');
        this.description = this.config.description;
        this.order = this.machine.idMap.size;
        this.machine.idMap.set(this.id, this);
        this.states = this.config.states ? (0, $59def02d21be1ba1$export$4a5767248b18ef41)(this.config.states, (stateConfig, key)=>{
            const stateNode = new $e74e3f2e30f36024$export$407448d2b89b1813(stateConfig, {
                _parent: this,
                _key: key,
                _machine: this.machine
            });
            return stateNode;
        }) : $e74e3f2e30f36024$var$EMPTY_OBJECT;
        if (this.type === 'compound' && !this.config.initial) throw new Error(`No initial state specified for compound state node "#${this.id}". Try adding { initial: "${Object.keys(this.states)[0]}" } to the state config.`);
        // History config
        this.history = this.config.history === true ? 'shallow' : this.config.history || false;
        this.entry = (0, $59def02d21be1ba1$export$625550452a3fa3ec)(this.config.entry).slice();
        this.exit = (0, $59def02d21be1ba1$export$625550452a3fa3ec)(this.config.exit).slice();
        this.meta = this.config.meta;
        this.output = this.type === 'final' || !this.parent ? this.config.output : undefined;
        this.tags = (0, $59def02d21be1ba1$export$625550452a3fa3ec)(config.tags).slice();
    }
    /** @internal */ _initialize() {
        this.transitions = (0, $59def02d21be1ba1$export$df995fae86a55f06)(this);
        if (this.config.always) this.always = (0, $59def02d21be1ba1$export$ef35774e6d314e91)(this.config.always).map((t)=>(0, $59def02d21be1ba1$export$e7094788287c5e9b)(this, (0, $59def02d21be1ba1$export$a07804094c3ecf2d), t));
        Object.keys(this.states).forEach((key)=>{
            this.states[key]._initialize();
        });
    }
    /** The well-structured state node definition. */ get definition() {
        return {
            id: this.id,
            key: this.key,
            version: this.machine.version,
            type: this.type,
            initial: this.initial ? {
                target: this.initial.target,
                source: this,
                actions: this.initial.actions.map($e74e3f2e30f36024$var$toSerializableAction),
                eventType: null,
                reenter: false,
                toJSON: ()=>({
                        target: this.initial.target.map((t)=>`#${t.id}`),
                        source: `#${this.id}`,
                        actions: this.initial.actions.map($e74e3f2e30f36024$var$toSerializableAction),
                        eventType: null
                    })
            } : undefined,
            history: this.history,
            states: (0, $59def02d21be1ba1$export$4a5767248b18ef41)(this.states, (state)=>{
                return state.definition;
            }),
            on: this.on,
            transitions: [
                ...this.transitions.values()
            ].flat().map((t)=>({
                    ...t,
                    actions: t.actions.map($e74e3f2e30f36024$var$toSerializableAction)
                })),
            entry: this.entry.map($e74e3f2e30f36024$var$toSerializableAction),
            exit: this.exit.map($e74e3f2e30f36024$var$toSerializableAction),
            meta: this.meta,
            order: this.order || -1,
            output: this.output,
            invoke: this.invoke,
            description: this.description,
            tags: this.tags
        };
    }
    /** @internal */ toJSON() {
        return this.definition;
    }
    /** The logic invoked as actors by this state node. */ get invoke() {
        return $e74e3f2e30f36024$var$memo(this, 'invoke', ()=>(0, $59def02d21be1ba1$export$625550452a3fa3ec)(this.config.invoke).map((invokeConfig, i)=>{
                const { src: src, systemId: systemId } = invokeConfig;
                const resolvedId = invokeConfig.id ?? (0, $59def02d21be1ba1$export$a9c23c6ac3fc3eca)(this.id, i);
                const sourceName = typeof src === 'string' ? src : `xstate.invoke.${(0, $59def02d21be1ba1$export$a9c23c6ac3fc3eca)(this.id, i)}`;
                return {
                    ...invokeConfig,
                    src: sourceName,
                    id: resolvedId,
                    systemId: systemId,
                    toJSON () {
                        const { onDone: onDone, onError: onError, ...invokeDefValues } = invokeConfig;
                        return {
                            ...invokeDefValues,
                            type: 'xstate.invoke',
                            src: sourceName,
                            id: resolvedId
                        };
                    }
                };
            }));
    }
    /** The mapping of events to transitions. */ get on() {
        return $e74e3f2e30f36024$var$memo(this, 'on', ()=>{
            const transitions = this.transitions;
            return [
                ...transitions
            ].flatMap(([descriptor, t])=>t.map((t)=>[
                        descriptor,
                        t
                    ])).reduce((map, [descriptor, transition])=>{
                map[descriptor] = map[descriptor] || [];
                map[descriptor].push(transition);
                return map;
            }, {});
        });
    }
    get after() {
        return $e74e3f2e30f36024$var$memo(this, 'delayedTransitions', ()=>(0, $59def02d21be1ba1$export$d66501df72047452)(this));
    }
    get initial() {
        return $e74e3f2e30f36024$var$memo(this, 'initial', ()=>(0, $59def02d21be1ba1$export$2329c99376c9d0a4)(this, this.config.initial));
    }
    /** @internal */ next(snapshot, event) {
        const eventType = event.type;
        const actions = [];
        let selectedTransition;
        const candidates = $e74e3f2e30f36024$var$memo(this, `candidates-${eventType}`, ()=>(0, $59def02d21be1ba1$export$7f8ddf7c7c20b3cd)(this, eventType));
        for (const candidate of candidates){
            const { guard: guard } = candidate;
            const resolvedContext = snapshot.context;
            let guardPassed = false;
            try {
                guardPassed = !guard || (0, $59def02d21be1ba1$export$96f57966bedc81b4)(guard, resolvedContext, event, snapshot);
            } catch (err) {
                const guardType = typeof guard === 'string' ? guard : typeof guard === 'object' ? guard.type : undefined;
                throw new Error(`Unable to evaluate guard ${guardType ? `'${guardType}' ` : ''}in transition for event '${eventType}' in state node '${this.id}':\n${err.message}`);
            }
            if (guardPassed) {
                actions.push(...candidate.actions);
                selectedTransition = candidate;
                break;
            }
        }
        return selectedTransition ? [
            selectedTransition
        ] : undefined;
    }
    /** All the event types accepted by this state node and its descendants. */ get events() {
        return $e74e3f2e30f36024$var$memo(this, 'events', ()=>{
            const { states: states } = this;
            const events = new Set(this.ownEvents);
            if (states) for (const stateId of Object.keys(states)){
                const state = states[stateId];
                if (state.states) for (const event of state.events)events.add(`${event}`);
            }
            return Array.from(events);
        });
    }
    /**
   * All the events that have transitions directly from this state node.
   *
   * Excludes any inert events.
   */ get ownEvents() {
        const keys = Object.keys(Object.fromEntries(this.transitions));
        const events = new Set(keys.filter((descriptor)=>{
            return this.transitions.get(descriptor).some((transition)=>!(!transition.target && !transition.actions.length && !transition.reenter));
        }));
        return Array.from(events);
    }
}
const $e74e3f2e30f36024$var$STATE_IDENTIFIER = '#';
class $e74e3f2e30f36024$export$25ce5a424b770e84 {
    constructor(/** The raw config used to create the machine. */ config, implementations){
        this.config = config;
        /** The machine's own version. */ this.version = void 0;
        this.schemas = void 0;
        this.implementations = void 0;
        /** @internal */ this.__xstatenode = true;
        /** @internal */ this.idMap = new Map();
        this.root = void 0;
        this.id = void 0;
        this.states = void 0;
        this.events = void 0;
        this.id = config.id || '(machine)';
        this.implementations = {
            actors: implementations?.actors ?? {},
            actions: implementations?.actions ?? {},
            delays: implementations?.delays ?? {},
            guards: implementations?.guards ?? {}
        };
        this.version = this.config.version;
        this.schemas = this.config.schemas;
        this.transition = this.transition.bind(this);
        this.getInitialSnapshot = this.getInitialSnapshot.bind(this);
        this.getPersistedSnapshot = this.getPersistedSnapshot.bind(this);
        this.restoreSnapshot = this.restoreSnapshot.bind(this);
        this.start = this.start.bind(this);
        this.root = new $e74e3f2e30f36024$export$407448d2b89b1813(config, {
            _key: this.id,
            _machine: this
        });
        this.root._initialize();
        (0, $59def02d21be1ba1$export$9bb611d729802a56)(this.root);
        this.states = this.root.states; // TODO: remove!
        this.events = this.root.events;
    }
    /**
   * Clones this state machine with the provided implementations.
   *
   * @param implementations Options (`actions`, `guards`, `actors`, `delays`) to
   *   recursively merge with the existing options.
   * @returns A new `StateMachine` instance with the provided implementations.
   */ provide(implementations) {
        const { actions: actions, guards: guards, actors: actors, delays: delays } = this.implementations;
        return new $e74e3f2e30f36024$export$25ce5a424b770e84(this.config, {
            actions: {
                ...actions,
                ...implementations.actions
            },
            guards: {
                ...guards,
                ...implementations.guards
            },
            actors: {
                ...actors,
                ...implementations.actors
            },
            delays: {
                ...delays,
                ...implementations.delays
            }
        });
    }
    resolveState(config) {
        const resolvedStateValue = (0, $59def02d21be1ba1$export$b4171a6734a65d42)(this.root, config.value);
        const nodeSet = (0, $59def02d21be1ba1$export$3466f893ebf79586)((0, $59def02d21be1ba1$export$ffb5f4729a158638)(this.root, resolvedStateValue));
        return (0, $59def02d21be1ba1$export$61196ced6d74a310)({
            _nodes: [
                ...nodeSet
            ],
            context: config.context || {},
            children: {},
            status: (0, $59def02d21be1ba1$export$3a1a48c8f6ef640e)(nodeSet, this.root) ? 'done' : config.status || 'active',
            output: config.output,
            error: config.error,
            historyValue: config.historyValue
        }, this);
    }
    /**
   * Determines the next snapshot given the current `snapshot` and received
   * `event`. Calculates a full macrostep from all microsteps.
   *
   * @param snapshot The current snapshot
   * @param event The received event
   */ transition(snapshot, event, actorScope) {
        return (0, $59def02d21be1ba1$export$4368d992c4eafac0)(snapshot, event, actorScope, []).snapshot;
    }
    /**
   * Determines the next state given the current `state` and `event`. Calculates
   * a microstep.
   *
   * @param state The current state
   * @param event The received event
   */ microstep(snapshot, event, actorScope) {
        return (0, $59def02d21be1ba1$export$4368d992c4eafac0)(snapshot, event, actorScope, []).microsteps.map(([s])=>s);
    }
    getTransitionData(snapshot, event) {
        return (0, $59def02d21be1ba1$export$c4ce752e73470fba)(this.root, snapshot.value, snapshot, event) || [];
    }
    /**
   * The initial state _before_ evaluating any microsteps. This "pre-initial"
   * state is provided to initial actions executed in the initial state.
   *
   * @internal
   */ _getPreInitialState(actorScope, initEvent, internalQueue) {
        const { context: context } = this.config;
        const preInitial = (0, $59def02d21be1ba1$export$61196ced6d74a310)({
            context: typeof context !== 'function' && context ? context : {},
            _nodes: [
                this.root
            ],
            children: {},
            status: 'active'
        }, this);
        if (typeof context === 'function') {
            const assignment = ({ spawn: spawn, event: event, self: self })=>context({
                    spawn: spawn,
                    input: event.input,
                    self: self
                });
            return (0, $59def02d21be1ba1$export$56c0d5a1e737357d)(preInitial, initEvent, actorScope, [
                (0, $174145984b82c661$export$407448d2b89b1813)(assignment)
            ], internalQueue, undefined);
        }
        return preInitial;
    }
    /**
   * Returns the initial `State` instance, with reference to `self` as an
   * `ActorRef`.
   */ getInitialSnapshot(actorScope, input) {
        const initEvent = (0, $59def02d21be1ba1$export$f1e1789686576879)(input); // TODO: fix;
        const internalQueue = [];
        const preInitialState = this._getPreInitialState(actorScope, initEvent, internalQueue);
        const [nextState] = (0, $59def02d21be1ba1$export$23f2a1d2818174ef)(this.root, preInitialState, actorScope, initEvent, internalQueue);
        const { snapshot: macroState } = (0, $59def02d21be1ba1$export$4368d992c4eafac0)(nextState, initEvent, actorScope, internalQueue);
        return macroState;
    }
    start(snapshot) {
        Object.values(snapshot.children).forEach((child)=>{
            if (child.getSnapshot().status === 'active') child.start();
        });
    }
    getStateNodeById(stateId) {
        const fullPath = (0, $59def02d21be1ba1$export$3722cfe417b6ed86)(stateId);
        const relativePath = fullPath.slice(1);
        const resolvedStateId = (0, $59def02d21be1ba1$export$db202ddc8be9136)(fullPath[0]) ? fullPath[0].slice($e74e3f2e30f36024$var$STATE_IDENTIFIER.length) : fullPath[0];
        const stateNode = this.idMap.get(resolvedStateId);
        if (!stateNode) throw new Error(`Child state node '#${resolvedStateId}' does not exist on machine '${this.id}'`);
        return (0, $59def02d21be1ba1$export$971d5caa766a69d7)(stateNode, relativePath);
    }
    get definition() {
        return this.root.definition;
    }
    toJSON() {
        return this.definition;
    }
    getPersistedSnapshot(snapshot, options) {
        return (0, $59def02d21be1ba1$export$3a6d5c9ae78a2c08)(snapshot, options);
    }
    restoreSnapshot(snapshot, _actorScope) {
        const children = {};
        const snapshotChildren = snapshot.children;
        Object.keys(snapshotChildren).forEach((actorId)=>{
            const actorData = snapshotChildren[actorId];
            const childState = actorData.snapshot;
            const src = actorData.src;
            const logic = typeof src === 'string' ? (0, $59def02d21be1ba1$export$e7c866399fa523f5)(this, src) : src;
            if (!logic) return;
            const actorRef = (0, $59def02d21be1ba1$export$db3b6bfb95261072)(logic, {
                id: actorId,
                parent: _actorScope.self,
                syncSnapshot: actorData.syncSnapshot,
                snapshot: childState,
                src: src,
                systemId: actorData.systemId
            });
            children[actorId] = actorRef;
        });
        function resolveHistoryReferencedState(root, referenced) {
            if (referenced instanceof $e74e3f2e30f36024$export$407448d2b89b1813) return referenced;
            try {
                return root.machine.getStateNodeById(referenced.id);
            } catch  {}
        }
        function reviveHistoryValue(root, historyValue) {
            if (!historyValue || typeof historyValue !== 'object') return {};
            const revived = {};
            for(const key in historyValue){
                const arr = historyValue[key];
                for (const item of arr){
                    const resolved = resolveHistoryReferencedState(root, item);
                    if (!resolved) continue;
                    revived[key] ??= [];
                    revived[key].push(resolved);
                }
            }
            return revived;
        }
        const revivedHistoryValue = reviveHistoryValue(this.root, snapshot.historyValue);
        const restoredSnapshot = (0, $59def02d21be1ba1$export$61196ced6d74a310)({
            ...snapshot,
            children: children,
            _nodes: Array.from((0, $59def02d21be1ba1$export$3466f893ebf79586)((0, $59def02d21be1ba1$export$ffb5f4729a158638)(this.root, snapshot.value))),
            historyValue: revivedHistoryValue
        }, this);
        const seen = new Set();
        function reviveContext(contextPart, children) {
            if (seen.has(contextPart)) return;
            seen.add(contextPart);
            for(const key in contextPart){
                const value = contextPart[key];
                if (value && typeof value === 'object') {
                    if ('xstate$$type' in value && value.xstate$$type === (0, $59def02d21be1ba1$export$3d8c2f653ac9d0b9)) {
                        contextPart[key] = children[value.id];
                        continue;
                    }
                    reviveContext(value, children);
                }
            }
        }
        reviveContext(restoredSnapshot.context, children);
        return restoredSnapshot;
    }
}





function $2611ac0f561feabf$var$resolveEmit(_, snapshot, args, actionParams, { event: eventOrExpr }) {
    const resolvedEvent = typeof eventOrExpr === 'function' ? eventOrExpr(args, actionParams) : eventOrExpr;
    return [
        snapshot,
        {
            event: resolvedEvent
        },
        undefined
    ];
}
function $2611ac0f561feabf$var$executeEmit(actorScope, { event: event }) {
    actorScope.defer(()=>actorScope.emit(event));
}
/**
 * Emits an event to event handlers registered on the actor via `actor.on(event,
 * handler)`.
 *
 * @example
 *
 * ```ts
 * import { emit } from 'xstate';
 *
 * const machine = createMachine({
 *   // ...
 *   on: {
 *     something: {
 *       actions: emit({
 *         type: 'emitted',
 *         some: 'data'
 *       })
 *     }
 *   }
 *   // ...
 * });
 *
 * const actor = createActor(machine).start();
 *
 * actor.on('emitted', (event) => {
 *   console.log(event);
 * });
 *
 * actor.send({ type: 'something' });
 * // logs:
 * // {
 * //   type: 'emitted',
 * //   some: 'data'
 * // }
 * ```
 */ function $2611ac0f561feabf$export$407448d2b89b1813(/** The event to emit, or an expression that returns an event to emit. */ eventOrExpr) {
    function emit(_args, _params) {}
    emit.type = 'xstate.emit';
    emit.event = eventOrExpr;
    emit.resolve = $2611ac0f561feabf$var$resolveEmit;
    emit.execute = $2611ac0f561feabf$var$executeEmit;
    return emit;
}
// this is needed to make JSDoc `@link` work properly
/**
 * @remarks
 * `T | unknown` reduces to `unknown` and that can be problematic when it comes
 * to contextual typing. It especially is a problem when the union has a
 * function member, like here:
 *
 * ```ts
 * declare function test(
 *   cbOrVal: ((arg: number) => unknown) | unknown
 * ): void;
 * test((arg) => {}); // oops, implicit any
 * ```
 *
 * This type can be used to avoid this problem. This union represents the same
 * value space as `unknown`.
 */ // https://github.com/microsoft/TypeScript/issues/23182#issuecomment-379091887
// @TODO: we can't use native `NoInfer` as we need those:
// https://github.com/microsoft/TypeScript/pull/61092
// https://github.com/microsoft/TypeScript/pull/61077
// but even with those fixes native NoInfer still doesn't work - further issues have to be reproduced and fixed
/** @deprecated Use the built-in `NoInfer` type instead */ /** The full definition of an event, with a string `type`. */ /**
 * The string or object representing the state value relative to the parent
 * state node.
 *
 * @remarks
 * - For a child atomic state node, this is a string, e.g., `"pending"`.
 * - For complex state nodes, this is an object, e.g., `{ success:
 *   "someChildState" }`.
 */ /** @deprecated Use `AnyMachineSnapshot` instead */ // TODO: possibly refactor this somehow, use even a simpler type, and maybe even make `machine.options` private or something
/** @ignore */ let $2611ac0f561feabf$export$25ce5a424b770e84 = /*#__PURE__*/ function(SpecialTargets) {
    SpecialTargets["Parent"] = "#_parent";
    SpecialTargets["Internal"] = "#_internal";
    return SpecialTargets;
}({});
/** @deprecated Use `AnyActor` instead. */ // Based on RxJS types
// TODO: in v6, this should only accept AnyActorLogic, like ActorRefFromLogic
/** @deprecated Use `Actor<T>` instead. */ /**
 * Represents logic which can be used by an actor.
 *
 * @template TSnapshot - The type of the snapshot.
 * @template TEvent - The type of the event object.
 * @template TInput - The type of the input.
 * @template TSystem - The type of the actor system.
 */ /** @deprecated */ // TODO: cover all that can be actually returned
function $2611ac0f561feabf$var$resolveSendTo(actorScope, snapshot, args, actionParams, { to: to, event: eventOrExpr, id: id, delay: delay }, extra) {
    const delaysMap = snapshot.machine.implementations.delays;
    if (typeof eventOrExpr === 'string') throw new Error(// eslint-disable-next-line @typescript-eslint/restrict-template-expressions
    `Only event objects may be used with sendTo; use sendTo({ type: "${eventOrExpr}" }) instead`);
    const resolvedEvent = typeof eventOrExpr === 'function' ? eventOrExpr(args, actionParams) : eventOrExpr;
    let resolvedDelay;
    if (typeof delay === 'string') {
        const configDelay = delaysMap && delaysMap[delay];
        resolvedDelay = typeof configDelay === 'function' ? configDelay(args, actionParams) : configDelay;
    } else resolvedDelay = typeof delay === 'function' ? delay(args, actionParams) : delay;
    const resolvedTarget = typeof to === 'function' ? to(args, actionParams) : to;
    let targetActorRef;
    if (typeof resolvedTarget === 'string') {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-enum-comparison
        if (resolvedTarget === $2611ac0f561feabf$export$25ce5a424b770e84.Parent) targetActorRef = actorScope.self._parent;
        else if (resolvedTarget === $2611ac0f561feabf$export$25ce5a424b770e84.Internal) targetActorRef = actorScope.self;
        else if (resolvedTarget.startsWith('#_')) // SCXML compatibility: https://www.w3.org/TR/scxml/#SCXMLEventProcessor
        // #_invokeid. If the target is the special term '#_invokeid', where invokeid is the invokeid of an SCXML session that the sending session has created by <invoke>, the Processor must add the event to the external queue of that session.
        targetActorRef = snapshot.children[resolvedTarget.slice(2)];
        else targetActorRef = extra.deferredActorIds?.includes(resolvedTarget) ? resolvedTarget : snapshot.children[resolvedTarget];
        if (!targetActorRef) throw new Error(`Unable to send event to actor '${resolvedTarget}' from machine '${snapshot.machine.id}'.`);
    } else targetActorRef = resolvedTarget || actorScope.self;
    return [
        snapshot,
        {
            to: targetActorRef,
            targetId: typeof resolvedTarget === 'string' ? resolvedTarget : undefined,
            event: resolvedEvent,
            id: id,
            delay: resolvedDelay
        },
        undefined
    ];
}
function $2611ac0f561feabf$var$retryResolveSendTo(_, snapshot, params) {
    if (typeof params.to === 'string') params.to = snapshot.children[params.to];
}
function $2611ac0f561feabf$var$executeSendTo(actorScope, params) {
    // this forms an outgoing events queue
    // thanks to that the recipient actors are able to read the *updated* snapshot value of the sender
    actorScope.defer(()=>{
        const { to: to, event: event, delay: delay, id: id } = params;
        if (typeof delay === 'number') {
            actorScope.system.scheduler.schedule(actorScope.self, to, event, delay, id);
            return;
        }
        actorScope.system._relay(actorScope.self, // at this point, in a deferred task, it should already be mutated by retryResolveSendTo
        // if it initially started as a string
        to, event.type === (0, $59def02d21be1ba1$export$71cec2538cb2c617) ? (0, $59def02d21be1ba1$export$8743009a87fcb00f)(actorScope.self.id, event.data) : event);
    });
}
/**
 * Sends an event to an actor.
 *
 * @param actor The `ActorRef` to send the event to.
 * @param event The event to send, or an expression that evaluates to the event
 *   to send
 * @param options Send action options
 *
 *   - `id` - The unique send event identifier (used with `cancel()`).
 *   - `delay` - The number of milliseconds to delay the sending of the event.
 */ function $2611ac0f561feabf$export$2408f22a0fab9ae5(to, eventOrExpr, options) {
    function sendTo(_args, _params) {}
    sendTo.type = 'xstate.sendTo';
    sendTo.to = to;
    sendTo.event = eventOrExpr;
    sendTo.id = options?.id;
    sendTo.delay = options?.delay;
    sendTo.resolve = $2611ac0f561feabf$var$resolveSendTo;
    sendTo.retryResolve = $2611ac0f561feabf$var$retryResolveSendTo;
    sendTo.execute = $2611ac0f561feabf$var$executeSendTo;
    return sendTo;
}
/**
 * Sends an event to this machine's parent.
 *
 * @param event The event to send to the parent machine.
 * @param options Options to pass into the send event.
 */ function $2611ac0f561feabf$export$8b22cf2602fb60ce(event, options) {
    return $2611ac0f561feabf$export$2408f22a0fab9ae5($2611ac0f561feabf$export$25ce5a424b770e84.Parent, event, options);
}
/**
 * Forwards (sends) an event to the `target` actor.
 *
 * @param target The target actor to forward the event to.
 * @param options Options to pass into the send action creator.
 */ function $2611ac0f561feabf$export$2d1720544b23b823(target, options) {
    return $2611ac0f561feabf$export$2408f22a0fab9ae5(target, ({ event: event })=>event, options);
}
function $2611ac0f561feabf$var$resolveEnqueueActions(actorScope, snapshot, args, actionParams, { collect: collect }) {
    const actions = [];
    const enqueue = function enqueue(action) {
        actions.push(action);
    };
    enqueue.assign = (...args)=>{
        actions.push((0, $174145984b82c661$export$407448d2b89b1813)(...args));
    };
    enqueue.cancel = (...args)=>{
        actions.push((0, $59def02d21be1ba1$export$407448d2b89b1813)(...args));
    };
    enqueue.raise = (...args)=>{
        // for some reason it fails to infer `TDelay` from `...args` here and picks its default (`never`)
        // then it fails to typecheck that because `...args` use `string` in place of `TDelay`
        actions.push((0, $59def02d21be1ba1$export$43caf9889c228507)(...args));
    };
    enqueue.sendTo = (...args)=>{
        // for some reason it fails to infer `TDelay` from `...args` here and picks its default (`never`)
        // then it fails to typecheck that because `...args` use `string` in place of `TDelay
        actions.push($2611ac0f561feabf$export$2408f22a0fab9ae5(...args));
    };
    enqueue.sendParent = (...args)=>{
        actions.push($2611ac0f561feabf$export$8b22cf2602fb60ce(...args));
    };
    enqueue.spawnChild = (...args)=>{
        actions.push((0, $59def02d21be1ba1$export$8b22cf2602fb60ce)(...args));
    };
    enqueue.stopChild = (...args)=>{
        actions.push((0, $59def02d21be1ba1$export$2408f22a0fab9ae5)(...args));
    };
    enqueue.emit = (...args)=>{
        actions.push($2611ac0f561feabf$export$407448d2b89b1813(...args));
    };
    collect({
        context: args.context,
        event: args.event,
        enqueue: enqueue,
        check: (guard)=>(0, $59def02d21be1ba1$export$96f57966bedc81b4)(guard, snapshot.context, args.event, snapshot),
        self: actorScope.self,
        system: actorScope.system
    }, actionParams);
    return [
        snapshot,
        undefined,
        actions
    ];
}
/**
 * Creates an action object that will execute actions that are queued by the
 * `enqueue(action)` function.
 *
 * @example
 *
 * ```ts
 * import { createMachine, enqueueActions } from 'xstate';
 *
 * const machine = createMachine({
 *   entry: enqueueActions(({ enqueue, check }) => {
 *     enqueue.assign({ count: 0 });
 *
 *     if (check('someGuard')) {
 *       enqueue.assign({ count: 1 });
 *     }
 *
 *     enqueue('someAction');
 *   })
 * });
 * ```
 */ function $2611ac0f561feabf$export$f1e1789686576879(collect) {
    function enqueueActions(_args, _params) {}
    enqueueActions.type = 'xstate.enqueueActions';
    enqueueActions.collect = collect;
    enqueueActions.resolve = $2611ac0f561feabf$var$resolveEnqueueActions;
    return enqueueActions;
}
function $2611ac0f561feabf$var$resolveLog(_, snapshot, actionArgs, actionParams, { value: value, label: label }) {
    return [
        snapshot,
        {
            value: typeof value === 'function' ? value(actionArgs, actionParams) : value,
            label: label
        },
        undefined
    ];
}
function $2611ac0f561feabf$var$executeLog({ logger: logger }, { value: value, label: label }) {
    if (label) logger(label, value);
    else logger(value);
}
/**
 * @param expr The expression function to evaluate which will be logged. Takes
 *   in 2 arguments:
 *
 *   - `ctx` - the current state context
 *   - `event` - the event that caused this action to be executed.
 *
 * @param label The label to give to the logged expression.
 */ function $2611ac0f561feabf$export$882b5998b3b9117c(value = ({ context: context, event: event })=>({
        context: context,
        event: event
    }), label) {
    function log1(_args, _params) {}
    log1.type = 'xstate.log';
    log1.value = value;
    log1.label = label;
    log1.resolve = $2611ac0f561feabf$var$resolveLog;
    log1.execute = $2611ac0f561feabf$var$executeLog;
    return log1;
}



/**
 * Asserts that the given event object is of the specified type or types. Throws
 * an error if the event object is not of the specified types.
 *
 * @example
 *
 * ```ts
 * // ...
 * entry: ({ event }) => {
 *   assertEvent(event, 'doNothing');
 *   // event is { type: 'doNothing' }
 * },
 * // ...
 * exit: ({ event }) => {
 *   assertEvent(event, 'greet');
 *   // event is { type: 'greet'; message: string }
 *
 *   assertEvent(event, ['greet', 'notify']);
 *   // event is { type: 'greet'; message: string }
 *   // or { type: 'notify'; message: string; level: 'info' | 'error' }
 * },
 * ```
 */ function $21113145bdbb9065$export$b3e112bfd3a4f448(event, type) {
    const types = (0, $59def02d21be1ba1$export$625550452a3fa3ec)(type);
    const matches = types.some((descriptor)=>(0, $59def02d21be1ba1$export$953cecd6e717a553)(event.type, descriptor));
    if (!matches) {
        const typesText = types.length === 1 ? `type matching "${types[0]}"` : `one of types matching "${types.join('", "')}"`;
        throw new Error(`Expected event ${JSON.stringify(event)} to have ${typesText}`);
    }
}
/**
 * Creates a state machine (statechart) with the given configuration.
 *
 * The state machine represents the pure logic of a state machine actor.
 *
 * @example
 *
 * ```ts
 * import { createMachine } from 'xstate';
 *
 * const lightMachine = createMachine({
 *   id: 'light',
 *   initial: 'green',
 *   states: {
 *     green: {
 *       on: {
 *         TIMER: { target: 'yellow' }
 *       }
 *     },
 *     yellow: {
 *       on: {
 *         TIMER: { target: 'red' }
 *       }
 *     },
 *     red: {
 *       on: {
 *         TIMER: { target: 'green' }
 *       }
 *     }
 *   }
 * });
 *
 * const lightActor = createActor(lightMachine);
 * lightActor.start();
 *
 * lightActor.send({ type: 'TIMER' });
 * ```
 *
 * @param config The state machine configuration.
 * @param options DEPRECATED: use `setup({ ... })` or `machine.provide({ ... })`
 *   to provide machine implementations instead.
 */ function $21113145bdbb9065$export$aaa7fa18f8e9b2e8(config, implementations) {
    return new (0, $e74e3f2e30f36024$export$25ce5a424b770e84)(config, implementations);
}
/** @internal */ function $21113145bdbb9065$var$createInertActorScope(actorLogic) {
    const self = (0, $59def02d21be1ba1$export$db3b6bfb95261072)(actorLogic);
    const inertActorScope = {
        self: self,
        defer: ()=>{},
        id: '',
        logger: ()=>{},
        sessionId: '',
        stopChild: ()=>{},
        system: self.system,
        emit: ()=>{},
        actionExecutor: ()=>{}
    };
    return inertActorScope;
}
/** @deprecated Use `initialTransition(…)` instead. */ function $21113145bdbb9065$export$e1c3f9a97f5088ae(actorLogic, ...[input]) {
    const actorScope = $21113145bdbb9065$var$createInertActorScope(actorLogic);
    return actorLogic.getInitialSnapshot(actorScope, input);
}
/**
 * Determines the next snapshot for the given `actorLogic` based on the given
 * `snapshot` and `event`.
 *
 * If the `snapshot` is `undefined`, the initial snapshot of the `actorLogic` is
 * used.
 *
 * @deprecated Use `transition(…)` instead.
 * @example
 *
 * ```ts
 * import { getNextSnapshot } from 'xstate';
 * import { trafficLightMachine } from './trafficLightMachine.ts';
 *
 * const nextSnapshot = getNextSnapshot(
 *   trafficLightMachine, // actor logic
 *   undefined, // snapshot (or initial state if undefined)
 *   { type: 'TIMER' }
 * ); // event object
 *
 * console.log(nextSnapshot.value);
 * // => 'yellow'
 *
 * const nextSnapshot2 = getNextSnapshot(
 *   trafficLightMachine, // actor logic
 *   nextSnapshot, // snapshot
 *   { type: 'TIMER' }
 * ); // event object
 *
 * console.log(nextSnapshot2.value);
 * // =>'red'
 * ```
 */ function $21113145bdbb9065$export$3629c64713e6dfd7(actorLogic, snapshot, event) {
    const inertActorScope = $21113145bdbb9065$var$createInertActorScope(actorLogic);
    inertActorScope.self._snapshot = snapshot;
    return actorLogic.transition(snapshot, event, inertActorScope);
}
// at the moment we allow extra actors - ones that are not specified by `children`
// this could be reconsidered in the future
// used to keep only StateSchema relevant keys
// this helps with type serialization as it makes the inferred type much shorter when dealing with huge configs
function $21113145bdbb9065$export$de27182ff8187d6c({ schemas: schemas, actors: actors, actions: actions, guards: guards, delays: delays }) {
    return {
        assign: $174145984b82c661$export$407448d2b89b1813,
        sendTo: $2611ac0f561feabf$export$2408f22a0fab9ae5,
        raise: $59def02d21be1ba1$export$43caf9889c228507,
        log: $2611ac0f561feabf$export$882b5998b3b9117c,
        cancel: $59def02d21be1ba1$export$407448d2b89b1813,
        stopChild: $59def02d21be1ba1$export$2408f22a0fab9ae5,
        enqueueActions: $2611ac0f561feabf$export$f1e1789686576879,
        emit: $2611ac0f561feabf$export$407448d2b89b1813,
        spawnChild: $59def02d21be1ba1$export$8b22cf2602fb60ce,
        createStateConfig: (config)=>config,
        createAction: (fn)=>fn,
        createMachine: (config)=>$21113145bdbb9065$export$aaa7fa18f8e9b2e8({
                ...config,
                schemas: schemas
            }, {
                actors: actors,
                actions: actions,
                guards: guards,
                delays: delays
            }),
        extend: (extended)=>$21113145bdbb9065$export$de27182ff8187d6c({
                schemas: schemas,
                actors: actors,
                actions: {
                    ...actions,
                    ...extended.actions
                },
                guards: {
                    ...guards,
                    ...extended.guards
                },
                delays: {
                    ...delays,
                    ...extended.delays
                }
            })
    };
}
// eslint-disable-next-line @typescript-eslint/no-unsafe-declaration-merging
// eslint-disable-next-line @typescript-eslint/no-unsafe-declaration-merging
class $21113145bdbb9065$export$7413adad607e2cdf {
    constructor(){
        this.timeouts = new Map();
        this._now = 0;
        this._id = 0;
        this._flushing = false;
        this._flushingInvalidated = false;
    }
    now() {
        return this._now;
    }
    getId() {
        return this._id++;
    }
    setTimeout(fn, timeout) {
        this._flushingInvalidated = this._flushing;
        const id = this.getId();
        this.timeouts.set(id, {
            start: this.now(),
            timeout: timeout,
            fn: fn
        });
        return id;
    }
    clearTimeout(id) {
        this._flushingInvalidated = this._flushing;
        this.timeouts.delete(id);
    }
    set(time) {
        if (this._now > time) throw new Error('Unable to travel back in time');
        this._now = time;
        this.flushTimeouts();
    }
    flushTimeouts() {
        if (this._flushing) {
            this._flushingInvalidated = true;
            return;
        }
        this._flushing = true;
        const sorted = [
            ...this.timeouts
        ].sort(([_idA, timeoutA], [_idB, timeoutB])=>{
            const endA = timeoutA.start + timeoutA.timeout;
            const endB = timeoutB.start + timeoutB.timeout;
            return endB > endA ? -1 : 1;
        });
        for (const [id, timeout] of sorted){
            if (this._flushingInvalidated) {
                this._flushingInvalidated = false;
                this._flushing = false;
                this.flushTimeouts();
                return;
            }
            if (this.now() - timeout.start >= timeout.timeout) {
                this.timeouts.delete(id);
                timeout.fn.call(null);
            }
        }
        this._flushing = false;
    }
    increment(ms) {
        this._now += ms;
        this.flushTimeouts();
    }
}
/**
 * Returns a promise that resolves to the `output` of the actor when it is done.
 *
 * @example
 *
 * ```ts
 * const machine = createMachine({
 *   // ...
 *   output: {
 *     count: 42
 *   }
 * });
 *
 * const actor = createActor(machine);
 *
 * actor.start();
 *
 * const output = await toPromise(actor);
 *
 * console.log(output);
 * // logs { count: 42 }
 * ```
 */ function $21113145bdbb9065$export$4dbaaf6c79705e6c(actor) {
    return new Promise((resolve, reject)=>{
        actor.subscribe({
            complete: ()=>{
                resolve(actor.getSnapshot().output);
            },
            error: reject
        });
    });
}
/**
 * Given actor `logic`, a `snapshot`, and an `event`, returns a tuple of the
 * `nextSnapshot` and `actions` to execute.
 *
 * This is a pure function that does not execute `actions`.
 */ function $21113145bdbb9065$export$66bb15e2994e6a26(logic, snapshot, event) {
    const executableActions = [];
    const actorScope = $21113145bdbb9065$var$createInertActorScope(logic);
    actorScope.actionExecutor = (action)=>{
        executableActions.push(action);
    };
    const nextSnapshot = logic.transition(snapshot, event, actorScope);
    return [
        nextSnapshot,
        executableActions
    ];
}
/**
 * Given actor `logic` and optional `input`, returns a tuple of the
 * `nextSnapshot` and `actions` to execute from the initial transition (no
 * previous state).
 *
 * This is a pure function that does not execute `actions`.
 */ function $21113145bdbb9065$export$5f4d25c77127242(logic, ...[input]) {
    const executableActions = [];
    const actorScope = $21113145bdbb9065$var$createInertActorScope(logic);
    actorScope.actionExecutor = (action)=>{
        executableActions.push(action);
    };
    const nextSnapshot = logic.getInitialSnapshot(actorScope, input);
    return [
        nextSnapshot,
        executableActions
    ];
}
/**
 * Given a state `machine`, a `snapshot`, and an `event`, returns an array of
 * microsteps, where each microstep is a tuple of `[snapshot, actions]`.
 *
 * This is a pure function that does not execute `actions`.
 */ function $21113145bdbb9065$export$aaa3dc98332e25f1(machine, snapshot, event) {
    const actorScope = $21113145bdbb9065$var$createInertActorScope(machine);
    const { microsteps: microsteps } = (0, $59def02d21be1ba1$export$4368d992c4eafac0)(snapshot, event, actorScope, []);
    return microsteps;
}
/**
 * Given a state `machine` and optional `input`, returns an array of microsteps
 * from the initial transition, where each microstep is a tuple of `[snapshot,
 * actions]`.
 *
 * This is a pure function that does not execute `actions`.
 */ function $21113145bdbb9065$export$9eaacda37ab3a8c3(machine, ...[input]) {
    const actorScope = $21113145bdbb9065$var$createInertActorScope(machine);
    const initEvent = (0, $59def02d21be1ba1$export$f1e1789686576879)(input);
    const internalQueue = [];
    const preInitialSnapshot = machine._getPreInitialState(actorScope, initEvent, internalQueue);
    const first = (0, $59def02d21be1ba1$export$23f2a1d2818174ef)(machine.root, preInitialSnapshot, actorScope, initEvent, internalQueue);
    const { microsteps: microsteps } = (0, $59def02d21be1ba1$export$4368d992c4eafac0)(first[0], initEvent, actorScope, internalQueue);
    return [
        first,
        ...microsteps
    ];
}
/**
 * Gets all potential next transitions from the current state.
 *
 * Returns all transitions that are available from the current state, including:
 *
 * - All transitions from atomic states (leaf states in the current state
 *   configuration)
 * - All transitions from ancestor states (parent states that may handle events)
 * - All guarded transitions (regardless of whether their guards would pass)
 * - Always (eventless) transitions
 * - After (delayed) transitions
 *
 * The order of transitions is deterministic:
 *
 * 1. Atomic states are processed in document order
 * 2. For each atomic state, transitions are collected from the state itself first,
 *    then its ancestors
 * 3. Within each state node, transitions are in the order they appear in the state
 *    definition
 *
 * @param state - The current machine snapshot
 * @returns Array of transition definitions from the current state, in
 *   deterministic order
 */ function $21113145bdbb9065$export$2963dba33c6acde3(state) {
    const potentialTransitions = [];
    const atomicStates = state._nodes.filter((0, $59def02d21be1ba1$export$2d1720544b23b823));
    const visited = new Set();
    // Collect all transitions from atomic states and their ancestors
    // Process atomic states in document order (as they appear in state._nodes)
    for (const stateNode of atomicStates)// For each atomic state, process the state itself first, then its ancestors
    // This ensures child state transitions come before parent state transitions
    for (const s of [
        stateNode
    ].concat((0, $59def02d21be1ba1$export$39b482c5e57630a8)(stateNode, undefined))){
        if (visited.has(s.id)) continue;
        visited.add(s.id);
        // Get all transitions for each event type
        // Include ALL transitions, even if the same event type appears in multiple state nodes
        // This is important for guarded transitions - all are "potential" regardless of guard evaluation
        for (const [, transitions] of s.transitions)potentialTransitions.push(...transitions);
        // Also include always (eventless) transitions
        if (s.always) potentialTransitions.push(...s.always);
    }
    return potentialTransitions;
}
const $21113145bdbb9065$var$defaultWaitForOptions = {
    timeout: Infinity // much more than 10 seconds
};
/**
 * Subscribes to an actor ref and waits for its emitted value to satisfy a
 * predicate, and then resolves with that value. Will throw if the desired state
 * is not reached after an optional timeout. (defaults to Infinity).
 *
 * @example
 *
 * ```js
 * const state = await waitFor(someService, (state) => {
 *   return state.hasTag('loaded');
 * });
 *
 * state.hasTag('loaded'); // true
 * ```
 *
 * @param actorRef The actor ref to subscribe to
 * @param predicate Determines if a value matches the condition to wait for
 * @param options
 * @returns A promise that eventually resolves to the emitted value that matches
 *   the condition
 */ function $21113145bdbb9065$export$9bbfceb27f687c1b(actorRef, predicate, options) {
    const resolvedOptions = {
        ...$21113145bdbb9065$var$defaultWaitForOptions,
        ...options
    };
    return new Promise((res, rej)=>{
        const { signal: signal } = resolvedOptions;
        if (signal?.aborted) {
            // eslint-disable-next-line @typescript-eslint/prefer-promise-reject-errors
            rej(signal.reason);
            return;
        }
        let done = false;
        const handle = resolvedOptions.timeout === Infinity ? undefined : setTimeout(()=>{
            dispose();
            rej(new Error(`Timeout of ${resolvedOptions.timeout} ms exceeded`));
        }, resolvedOptions.timeout);
        const dispose = ()=>{
            clearTimeout(handle);
            done = true;
            sub?.unsubscribe();
            if (abortListener) signal.removeEventListener('abort', abortListener);
        };
        function checkEmitted(emitted) {
            if (predicate(emitted)) {
                dispose();
                res(emitted);
            }
        }
        /**
     * If the `signal` option is provided, this will be the listener for its
     * `abort` event
     */ let abortListener;
        // eslint-disable-next-line prefer-const
        let sub; // avoid TDZ when disposing synchronously
        // See if the current snapshot already matches the predicate
        checkEmitted(actorRef.getSnapshot());
        if (done) return;
        // only define the `abortListener` if the `signal` option is provided
        if (signal) {
            abortListener = ()=>{
                dispose();
                // XState does not "own" the signal, so we should reject with its reason (if any)
                // eslint-disable-next-line @typescript-eslint/prefer-promise-reject-errors
                rej(signal.reason);
            };
            signal.addEventListener('abort', abortListener);
        }
        sub = actorRef.subscribe({
            next: checkEmitted,
            error: (err)=>{
                dispose();
                // eslint-disable-next-line @typescript-eslint/prefer-promise-reject-errors
                rej(err);
            },
            complete: ()=>{
                dispose();
                rej(new Error(`Actor terminated without satisfying predicate`));
            }
        });
        if (done) sub.unsubscribe();
    });
}


var $32c496bfb6c27b56$export$2e2bcd8739ae039 = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;


function $46d323206dcbf256$var$validate(uuid) {
    return typeof uuid === 'string' && (0, $32c496bfb6c27b56$export$2e2bcd8739ae039).test(uuid);
}
var $46d323206dcbf256$export$2e2bcd8739ae039 = $46d323206dcbf256$var$validate;


function $02f33e5afac044cb$var$parse(uuid) {
    if (!(0, $46d323206dcbf256$export$2e2bcd8739ae039)(uuid)) throw TypeError('Invalid UUID');
    let v;
    const arr = new Uint8Array(16); // Parse ########-....-....-....-............
    arr[0] = (v = parseInt(uuid.slice(0, 8), 16)) >>> 24;
    arr[1] = v >>> 16 & 0xff;
    arr[2] = v >>> 8 & 0xff;
    arr[3] = v & 0xff; // Parse ........-####-....-....-............
    arr[4] = (v = parseInt(uuid.slice(9, 13), 16)) >>> 8;
    arr[5] = v & 0xff; // Parse ........-....-####-....-............
    arr[6] = (v = parseInt(uuid.slice(14, 18), 16)) >>> 8;
    arr[7] = v & 0xff; // Parse ........-....-....-####-............
    arr[8] = (v = parseInt(uuid.slice(19, 23), 16)) >>> 8;
    arr[9] = v & 0xff; // Parse ........-....-....-....-############
    // (Use "/" to avoid 32-bit truncation when bit-shifting high-order bytes)
    arr[10] = (v = parseInt(uuid.slice(24, 36), 16)) / 0x10000000000 & 0xff;
    arr[11] = v / 0x100000000 & 0xff;
    arr[12] = v >>> 24 & 0xff;
    arr[13] = v >>> 16 & 0xff;
    arr[14] = v >>> 8 & 0xff;
    arr[15] = v & 0xff;
    return arr;
}
var $02f33e5afac044cb$export$2e2bcd8739ae039 = $02f33e5afac044cb$var$parse;

const $7ffc1f94643dc7e4$var$randomUUID = typeof crypto !== 'undefined' && crypto.randomUUID && crypto.randomUUID.bind(crypto);
var $7ffc1f94643dc7e4$export$2e2bcd8739ae039 = {
    randomUUID: $7ffc1f94643dc7e4$var$randomUUID
};


// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
let $568f4ee4022ba00e$var$getRandomValues;
const $568f4ee4022ba00e$var$rnds8 = new Uint8Array(16);
function $568f4ee4022ba00e$export$2e2bcd8739ae039() {
    // lazy load so that environments that need to polyfill have a chance to do so
    if (!$568f4ee4022ba00e$var$getRandomValues) {
        // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation.
        $568f4ee4022ba00e$var$getRandomValues = typeof crypto !== 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto);
        if (!$568f4ee4022ba00e$var$getRandomValues) throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
    }
    return $568f4ee4022ba00e$var$getRandomValues($568f4ee4022ba00e$var$rnds8);
}



/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ const $1d0137947e8554ce$var$byteToHex = [];
for(let i = 0; i < 256; ++i)$1d0137947e8554ce$var$byteToHex.push((i + 0x100).toString(16).slice(1));
function $1d0137947e8554ce$export$8fb373d660548968(arr, offset = 0) {
    // Note: Be careful editing this code!  It's been tuned for performance
    // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
    return $1d0137947e8554ce$var$byteToHex[arr[offset + 0]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 1]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 2]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 3]] + '-' + $1d0137947e8554ce$var$byteToHex[arr[offset + 4]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 5]] + '-' + $1d0137947e8554ce$var$byteToHex[arr[offset + 6]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 7]] + '-' + $1d0137947e8554ce$var$byteToHex[arr[offset + 8]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 9]] + '-' + $1d0137947e8554ce$var$byteToHex[arr[offset + 10]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 11]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 12]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 13]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 14]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 15]];
}
function $1d0137947e8554ce$var$stringify(arr, offset = 0) {
    const uuid = $1d0137947e8554ce$export$8fb373d660548968(arr, offset); // Consistency check for valid UUID.  If this throws, it's likely due to one
    // of the following:
    // - One or more input array values don't map to a hex octet (leading to
    // "undefined" in the uuid)
    // - Invalid input values for the RFC `version` or `variant` fields
    if (!(0, $46d323206dcbf256$export$2e2bcd8739ae039)(uuid)) throw TypeError('Stringified UUID is invalid');
    return uuid;
}
var $1d0137947e8554ce$export$2e2bcd8739ae039 = $1d0137947e8554ce$var$stringify;


function $3fa3ae484854b431$var$v4(options, buf, offset) {
    if ((0, $7ffc1f94643dc7e4$export$2e2bcd8739ae039).randomUUID && !buf && !options) return (0, $7ffc1f94643dc7e4$export$2e2bcd8739ae039).randomUUID();
    options = options || {};
    const rnds = options.random || (options.rng || (0, $568f4ee4022ba00e$export$2e2bcd8739ae039))(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided
    if (buf) {
        offset = offset || 0;
        for(let i = 0; i < 16; ++i)buf[offset + i] = rnds[i];
        return buf;
    }
    return (0, $1d0137947e8554ce$export$8fb373d660548968)(rnds);
}
var $3fa3ae484854b431$export$2e2bcd8739ae039 = $3fa3ae484854b431$var$v4;


var $f953b6354166cf05$exports = {};
'use strict';
var $510ad3657d73a9d2$exports = {};
"use strict";
Object.defineProperty($510ad3657d73a9d2$exports, "__esModule", {
    value: true
});
$510ad3657d73a9d2$exports.sha224 = $510ad3657d73a9d2$exports.SHA224 = $510ad3657d73a9d2$exports.sha256 = $510ad3657d73a9d2$exports.SHA256 = void 0;
var $cb9d97d4d61a5a71$exports = {};
"use strict";
Object.defineProperty($cb9d97d4d61a5a71$exports, "__esModule", {
    value: true
});
$cb9d97d4d61a5a71$exports.sha512_224 = $cb9d97d4d61a5a71$exports.sha512_256 = $cb9d97d4d61a5a71$exports.sha384 = $cb9d97d4d61a5a71$exports.sha512 = $cb9d97d4d61a5a71$exports.sha224 = $cb9d97d4d61a5a71$exports.sha256 = $cb9d97d4d61a5a71$exports.SHA512_256 = $cb9d97d4d61a5a71$exports.SHA512_224 = $cb9d97d4d61a5a71$exports.SHA384 = $cb9d97d4d61a5a71$exports.SHA512 = $cb9d97d4d61a5a71$exports.SHA224 = $cb9d97d4d61a5a71$exports.SHA256 = void 0;
var $dd17a2ee919821c7$exports = {};
"use strict";
Object.defineProperty($dd17a2ee919821c7$exports, "__esModule", {
    value: true
});
$dd17a2ee919821c7$exports.SHA512_IV = $dd17a2ee919821c7$exports.SHA384_IV = $dd17a2ee919821c7$exports.SHA224_IV = $dd17a2ee919821c7$exports.SHA256_IV = $dd17a2ee919821c7$exports.HashMD = void 0;
$dd17a2ee919821c7$exports.setBigUint64 = $dd17a2ee919821c7$var$setBigUint64;
$dd17a2ee919821c7$exports.Chi = $dd17a2ee919821c7$var$Chi;
$dd17a2ee919821c7$exports.Maj = $dd17a2ee919821c7$var$Maj;
var $29ee4d3171d9809b$exports = {};
"use strict";
/**
 * Utilities for hex, bytes, CSPRNG.
 * @module
 */ /*! noble-hashes - MIT License (c) 2022 Paul Miller (paulmillr.com) */ Object.defineProperty($29ee4d3171d9809b$exports, "__esModule", {
    value: true
});
$29ee4d3171d9809b$exports.wrapXOFConstructorWithOpts = $29ee4d3171d9809b$exports.wrapConstructorWithOpts = $29ee4d3171d9809b$exports.wrapConstructor = $29ee4d3171d9809b$exports.Hash = $29ee4d3171d9809b$exports.nextTick = $29ee4d3171d9809b$exports.swap32IfBE = $29ee4d3171d9809b$exports.byteSwapIfBE = $29ee4d3171d9809b$exports.swap8IfBE = $29ee4d3171d9809b$exports.isLE = void 0;
$29ee4d3171d9809b$exports.isBytes = $29ee4d3171d9809b$var$isBytes;
$29ee4d3171d9809b$exports.anumber = $29ee4d3171d9809b$var$anumber;
$29ee4d3171d9809b$exports.abytes = $29ee4d3171d9809b$var$abytes;
$29ee4d3171d9809b$exports.ahash = $29ee4d3171d9809b$var$ahash;
$29ee4d3171d9809b$exports.aexists = $29ee4d3171d9809b$var$aexists;
$29ee4d3171d9809b$exports.aoutput = $29ee4d3171d9809b$var$aoutput;
$29ee4d3171d9809b$exports.u8 = $29ee4d3171d9809b$var$u8;
$29ee4d3171d9809b$exports.u32 = $29ee4d3171d9809b$var$u32;
$29ee4d3171d9809b$exports.clean = $29ee4d3171d9809b$var$clean;
$29ee4d3171d9809b$exports.createView = $29ee4d3171d9809b$var$createView;
$29ee4d3171d9809b$exports.rotr = $29ee4d3171d9809b$var$rotr;
$29ee4d3171d9809b$exports.rotl = $29ee4d3171d9809b$var$rotl;
$29ee4d3171d9809b$exports.byteSwap = $29ee4d3171d9809b$var$byteSwap;
$29ee4d3171d9809b$exports.byteSwap32 = $29ee4d3171d9809b$var$byteSwap32;
$29ee4d3171d9809b$exports.bytesToHex = $29ee4d3171d9809b$var$bytesToHex;
$29ee4d3171d9809b$exports.hexToBytes = $29ee4d3171d9809b$var$hexToBytes;
$29ee4d3171d9809b$exports.asyncLoop = $29ee4d3171d9809b$var$asyncLoop;
$29ee4d3171d9809b$exports.utf8ToBytes = $29ee4d3171d9809b$var$utf8ToBytes;
$29ee4d3171d9809b$exports.bytesToUtf8 = $29ee4d3171d9809b$var$bytesToUtf8;
$29ee4d3171d9809b$exports.toBytes = $29ee4d3171d9809b$var$toBytes;
$29ee4d3171d9809b$exports.kdfInputToBytes = $29ee4d3171d9809b$var$kdfInputToBytes;
$29ee4d3171d9809b$exports.concatBytes = $29ee4d3171d9809b$var$concatBytes;
$29ee4d3171d9809b$exports.checkOpts = $29ee4d3171d9809b$var$checkOpts;
$29ee4d3171d9809b$exports.createHasher = $29ee4d3171d9809b$var$createHasher;
$29ee4d3171d9809b$exports.createOptHasher = $29ee4d3171d9809b$var$createOptHasher;
$29ee4d3171d9809b$exports.createXOFer = $29ee4d3171d9809b$var$createXOFer;
$29ee4d3171d9809b$exports.randomBytes = $29ee4d3171d9809b$var$randomBytes;
var $a20ad0ecd1be3cb3$exports = {};
"use strict";
Object.defineProperty($a20ad0ecd1be3cb3$exports, "__esModule", {
    value: true
});
$a20ad0ecd1be3cb3$exports.crypto = void 0;
$a20ad0ecd1be3cb3$exports.crypto = typeof globalThis === 'object' && 'crypto' in globalThis ? globalThis.crypto : undefined;


/** Checks if something is Uint8Array. Be careful: nodejs Buffer will return true. */ function $29ee4d3171d9809b$var$isBytes(a) {
    return a instanceof Uint8Array || ArrayBuffer.isView(a) && a.constructor.name === 'Uint8Array';
}
/** Asserts something is positive integer. */ function $29ee4d3171d9809b$var$anumber(n) {
    if (!Number.isSafeInteger(n) || n < 0) throw new Error('positive integer expected, got ' + n);
}
/** Asserts something is Uint8Array. */ function $29ee4d3171d9809b$var$abytes(b, ...lengths) {
    if (!$29ee4d3171d9809b$var$isBytes(b)) throw new Error('Uint8Array expected');
    if (lengths.length > 0 && !lengths.includes(b.length)) throw new Error('Uint8Array expected of length ' + lengths + ', got length=' + b.length);
}
/** Asserts something is hash */ function $29ee4d3171d9809b$var$ahash(h) {
    if (typeof h !== 'function' || typeof h.create !== 'function') throw new Error('Hash should be wrapped by utils.createHasher');
    $29ee4d3171d9809b$var$anumber(h.outputLen);
    $29ee4d3171d9809b$var$anumber(h.blockLen);
}
/** Asserts a hash instance has not been destroyed / finished */ function $29ee4d3171d9809b$var$aexists(instance, checkFinished = true) {
    if (instance.destroyed) throw new Error('Hash instance has been destroyed');
    if (checkFinished && instance.finished) throw new Error('Hash#digest() has already been called');
}
/** Asserts output is properly-sized byte array */ function $29ee4d3171d9809b$var$aoutput(out, instance) {
    $29ee4d3171d9809b$var$abytes(out);
    const min = instance.outputLen;
    if (out.length < min) throw new Error('digestInto() expects output buffer of length at least ' + min);
}
/** Cast u8 / u16 / u32 to u8. */ function $29ee4d3171d9809b$var$u8(arr) {
    return new Uint8Array(arr.buffer, arr.byteOffset, arr.byteLength);
}
/** Cast u8 / u16 / u32 to u32. */ function $29ee4d3171d9809b$var$u32(arr) {
    return new Uint32Array(arr.buffer, arr.byteOffset, Math.floor(arr.byteLength / 4));
}
/** Zeroize a byte array. Warning: JS provides no guarantees. */ function $29ee4d3171d9809b$var$clean(...arrays) {
    for(let i = 0; i < arrays.length; i++)arrays[i].fill(0);
}
/** Create DataView of an array for easy byte-level manipulation. */ function $29ee4d3171d9809b$var$createView(arr) {
    return new DataView(arr.buffer, arr.byteOffset, arr.byteLength);
}
/** The rotate right (circular right shift) operation for uint32 */ function $29ee4d3171d9809b$var$rotr(word, shift) {
    return word << 32 - shift | word >>> shift;
}
/** The rotate left (circular left shift) operation for uint32 */ function $29ee4d3171d9809b$var$rotl(word, shift) {
    return word << shift | word >>> 32 - shift >>> 0;
}
/** Is current platform little-endian? Most are. Big-Endian platform: IBM */ $29ee4d3171d9809b$exports.isLE = (()=>new Uint8Array(new Uint32Array([
        0x11223344
    ]).buffer)[0] === 0x44)();
/** The byte swap operation for uint32 */ function $29ee4d3171d9809b$var$byteSwap(word) {
    return word << 24 & 0xff000000 | word << 8 & 0xff0000 | word >>> 8 & 0xff00 | word >>> 24 & 0xff;
}
/** Conditionally byte swap if on a big-endian platform */ $29ee4d3171d9809b$exports.swap8IfBE = $29ee4d3171d9809b$exports.isLE ? (n)=>n : (n)=>$29ee4d3171d9809b$var$byteSwap(n);
/** @deprecated */ $29ee4d3171d9809b$exports.byteSwapIfBE = $29ee4d3171d9809b$exports.swap8IfBE;
/** In place byte swap for Uint32Array */ function $29ee4d3171d9809b$var$byteSwap32(arr) {
    for(let i = 0; i < arr.length; i++)arr[i] = $29ee4d3171d9809b$var$byteSwap(arr[i]);
    return arr;
}
$29ee4d3171d9809b$exports.swap32IfBE = $29ee4d3171d9809b$exports.isLE ? (u)=>u : $29ee4d3171d9809b$var$byteSwap32;
// Built-in hex conversion https://caniuse.com/mdn-javascript_builtins_uint8array_fromhex
const $29ee4d3171d9809b$var$hasHexBuiltin = /* @__PURE__ */ (()=>// @ts-ignore
    typeof Uint8Array.from([]).toHex === 'function' && typeof Uint8Array.fromHex === 'function')();
// Array where index 0xf0 (240) is mapped to string 'f0'
const $29ee4d3171d9809b$var$hexes = /* @__PURE__ */ Array.from({
    length: 256
}, (_, i)=>i.toString(16).padStart(2, '0'));
/**
 * Convert byte array to hex string. Uses built-in function, when available.
 * @example bytesToHex(Uint8Array.from([0xca, 0xfe, 0x01, 0x23])) // 'cafe0123'
 */ function $29ee4d3171d9809b$var$bytesToHex(bytes) {
    $29ee4d3171d9809b$var$abytes(bytes);
    // @ts-ignore
    if ($29ee4d3171d9809b$var$hasHexBuiltin) return bytes.toHex();
    // pre-caching improves the speed 6x
    let hex = '';
    for(let i = 0; i < bytes.length; i++)hex += $29ee4d3171d9809b$var$hexes[bytes[i]];
    return hex;
}
// We use optimized technique to convert hex string to byte array
const $29ee4d3171d9809b$var$asciis = {
    _0: 48,
    _9: 57,
    A: 65,
    F: 70,
    a: 97,
    f: 102
};
function $29ee4d3171d9809b$var$asciiToBase16(ch) {
    if (ch >= $29ee4d3171d9809b$var$asciis._0 && ch <= $29ee4d3171d9809b$var$asciis._9) return ch - $29ee4d3171d9809b$var$asciis._0; // '2' => 50-48
    if (ch >= $29ee4d3171d9809b$var$asciis.A && ch <= $29ee4d3171d9809b$var$asciis.F) return ch - ($29ee4d3171d9809b$var$asciis.A - 10); // 'B' => 66-(65-10)
    if (ch >= $29ee4d3171d9809b$var$asciis.a && ch <= $29ee4d3171d9809b$var$asciis.f) return ch - ($29ee4d3171d9809b$var$asciis.a - 10); // 'b' => 98-(97-10)
    return;
}
/**
 * Convert hex string to byte array. Uses built-in function, when available.
 * @example hexToBytes('cafe0123') // Uint8Array.from([0xca, 0xfe, 0x01, 0x23])
 */ function $29ee4d3171d9809b$var$hexToBytes(hex) {
    if (typeof hex !== 'string') throw new Error('hex string expected, got ' + typeof hex);
    // @ts-ignore
    if ($29ee4d3171d9809b$var$hasHexBuiltin) return Uint8Array.fromHex(hex);
    const hl = hex.length;
    const al = hl / 2;
    if (hl % 2) throw new Error('hex string expected, got unpadded hex of length ' + hl);
    const array = new Uint8Array(al);
    for(let ai = 0, hi = 0; ai < al; ai++, hi += 2){
        const n1 = $29ee4d3171d9809b$var$asciiToBase16(hex.charCodeAt(hi));
        const n2 = $29ee4d3171d9809b$var$asciiToBase16(hex.charCodeAt(hi + 1));
        if (n1 === undefined || n2 === undefined) {
            const char = hex[hi] + hex[hi + 1];
            throw new Error('hex string expected, got non-hex character "' + char + '" at index ' + hi);
        }
        array[ai] = n1 * 16 + n2; // multiply first octet, e.g. 'a3' => 10*16+3 => 160 + 3 => 163
    }
    return array;
}
/**
 * There is no setImmediate in browser and setTimeout is slow.
 * Call of async fn will return Promise, which will be fullfiled only on
 * next scheduler queue processing step and this is exactly what we need.
 */ const $29ee4d3171d9809b$var$nextTick = async ()=>{};
$29ee4d3171d9809b$exports.nextTick = $29ee4d3171d9809b$var$nextTick;
/** Returns control to thread each 'tick' ms to avoid blocking. */ async function $29ee4d3171d9809b$var$asyncLoop(iters, tick, cb) {
    let ts = Date.now();
    for(let i = 0; i < iters; i++){
        cb(i);
        // Date.now() is not monotonic, so in case if clock goes backwards we return return control too
        const diff = Date.now() - ts;
        if (diff >= 0 && diff < tick) continue;
        await (0, $29ee4d3171d9809b$exports.nextTick)();
        ts += diff;
    }
}
/**
 * Converts string to bytes using UTF8 encoding.
 * @example utf8ToBytes('abc') // Uint8Array.from([97, 98, 99])
 */ function $29ee4d3171d9809b$var$utf8ToBytes(str) {
    if (typeof str !== 'string') throw new Error('string expected');
    return new Uint8Array(new TextEncoder().encode(str)); // https://bugzil.la/1681809
}
/**
 * Converts bytes to string using UTF8 encoding.
 * @example bytesToUtf8(Uint8Array.from([97, 98, 99])) // 'abc'
 */ function $29ee4d3171d9809b$var$bytesToUtf8(bytes) {
    return new TextDecoder().decode(bytes);
}
/**
 * Normalizes (non-hex) string or Uint8Array to Uint8Array.
 * Warning: when Uint8Array is passed, it would NOT get copied.
 * Keep in mind for future mutable operations.
 */ function $29ee4d3171d9809b$var$toBytes(data) {
    if (typeof data === 'string') data = $29ee4d3171d9809b$var$utf8ToBytes(data);
    $29ee4d3171d9809b$var$abytes(data);
    return data;
}
/**
 * Helper for KDFs: consumes uint8array or string.
 * When string is passed, does utf8 decoding, using TextDecoder.
 */ function $29ee4d3171d9809b$var$kdfInputToBytes(data) {
    if (typeof data === 'string') data = $29ee4d3171d9809b$var$utf8ToBytes(data);
    $29ee4d3171d9809b$var$abytes(data);
    return data;
}
/** Copies several Uint8Arrays into one. */ function $29ee4d3171d9809b$var$concatBytes(...arrays) {
    let sum = 0;
    for(let i = 0; i < arrays.length; i++){
        const a = arrays[i];
        $29ee4d3171d9809b$var$abytes(a);
        sum += a.length;
    }
    const res = new Uint8Array(sum);
    for(let i = 0, pad = 0; i < arrays.length; i++){
        const a = arrays[i];
        res.set(a, pad);
        pad += a.length;
    }
    return res;
}
function $29ee4d3171d9809b$var$checkOpts(defaults, opts) {
    if (opts !== undefined && ({}).toString.call(opts) !== '[object Object]') throw new Error('options should be object or undefined');
    const merged = Object.assign(defaults, opts);
    return merged;
}
/** For runtime check if class implements interface */ class $29ee4d3171d9809b$var$Hash {
}
$29ee4d3171d9809b$exports.Hash = $29ee4d3171d9809b$var$Hash;
/** Wraps hash function, creating an interface on top of it */ function $29ee4d3171d9809b$var$createHasher(hashCons) {
    const hashC = (msg)=>hashCons().update($29ee4d3171d9809b$var$toBytes(msg)).digest();
    const tmp = hashCons();
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = ()=>hashCons();
    return hashC;
}
function $29ee4d3171d9809b$var$createOptHasher(hashCons) {
    const hashC = (msg, opts)=>hashCons(opts).update($29ee4d3171d9809b$var$toBytes(msg)).digest();
    const tmp = hashCons({});
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = (opts)=>hashCons(opts);
    return hashC;
}
function $29ee4d3171d9809b$var$createXOFer(hashCons) {
    const hashC = (msg, opts)=>hashCons(opts).update($29ee4d3171d9809b$var$toBytes(msg)).digest();
    const tmp = hashCons({});
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = (opts)=>hashCons(opts);
    return hashC;
}
$29ee4d3171d9809b$exports.wrapConstructor = $29ee4d3171d9809b$var$createHasher;
$29ee4d3171d9809b$exports.wrapConstructorWithOpts = $29ee4d3171d9809b$var$createOptHasher;
$29ee4d3171d9809b$exports.wrapXOFConstructorWithOpts = $29ee4d3171d9809b$var$createXOFer;
/** Cryptographically secure PRNG. Uses internal OS-level `crypto.getRandomValues`. */ function $29ee4d3171d9809b$var$randomBytes(bytesLength = 32) {
    if ($a20ad0ecd1be3cb3$exports.crypto && typeof $a20ad0ecd1be3cb3$exports.crypto.getRandomValues === 'function') return $a20ad0ecd1be3cb3$exports.crypto.getRandomValues(new Uint8Array(bytesLength));
    // Legacy Node.js compatibility
    if ($a20ad0ecd1be3cb3$exports.crypto && typeof $a20ad0ecd1be3cb3$exports.crypto.randomBytes === 'function') return Uint8Array.from($a20ad0ecd1be3cb3$exports.crypto.randomBytes(bytesLength));
    throw new Error('crypto.getRandomValues must be defined');
}


/** Polyfill for Safari 14. https://caniuse.com/mdn-javascript_builtins_dataview_setbiguint64 */ function $dd17a2ee919821c7$var$setBigUint64(view, byteOffset, value, isLE) {
    if (typeof view.setBigUint64 === 'function') return view.setBigUint64(byteOffset, value, isLE);
    const _32n = BigInt(32);
    const _u32_max = BigInt(0xffffffff);
    const wh = Number(value >> _32n & _u32_max);
    const wl = Number(value & _u32_max);
    const h = isLE ? 4 : 0;
    const l = isLE ? 0 : 4;
    view.setUint32(byteOffset + h, wh, isLE);
    view.setUint32(byteOffset + l, wl, isLE);
}
/** Choice: a ? b : c */ function $dd17a2ee919821c7$var$Chi(a, b, c) {
    return a & b ^ ~a & c;
}
/** Majority function, true if any two inputs is true. */ function $dd17a2ee919821c7$var$Maj(a, b, c) {
    return a & b ^ a & c ^ b & c;
}
/**
 * Merkle-Damgard hash construction base class.
 * Could be used to create MD5, RIPEMD, SHA1, SHA2.
 */ class $dd17a2ee919821c7$var$HashMD extends $29ee4d3171d9809b$exports.Hash {
    constructor(blockLen, outputLen, padOffset, isLE){
        super();
        this.finished = false;
        this.length = 0;
        this.pos = 0;
        this.destroyed = false;
        this.blockLen = blockLen;
        this.outputLen = outputLen;
        this.padOffset = padOffset;
        this.isLE = isLE;
        this.buffer = new Uint8Array(blockLen);
        this.view = (0, $29ee4d3171d9809b$exports.createView)(this.buffer);
    }
    update(data) {
        (0, $29ee4d3171d9809b$exports.aexists)(this);
        data = (0, $29ee4d3171d9809b$exports.toBytes)(data);
        (0, $29ee4d3171d9809b$exports.abytes)(data);
        const { view: view, buffer: buffer, blockLen: blockLen } = this;
        const len = data.length;
        for(let pos = 0; pos < len;){
            const take = Math.min(blockLen - this.pos, len - pos);
            // Fast path: we have at least one block in input, cast it to view and process
            if (take === blockLen) {
                const dataView = (0, $29ee4d3171d9809b$exports.createView)(data);
                for(; blockLen <= len - pos; pos += blockLen)this.process(dataView, pos);
                continue;
            }
            buffer.set(data.subarray(pos, pos + take), this.pos);
            this.pos += take;
            pos += take;
            if (this.pos === blockLen) {
                this.process(view, 0);
                this.pos = 0;
            }
        }
        this.length += data.length;
        this.roundClean();
        return this;
    }
    digestInto(out) {
        (0, $29ee4d3171d9809b$exports.aexists)(this);
        (0, $29ee4d3171d9809b$exports.aoutput)(out, this);
        this.finished = true;
        // Padding
        // We can avoid allocation of buffer for padding completely if it
        // was previously not allocated here. But it won't change performance.
        const { buffer: buffer, view: view, blockLen: blockLen, isLE: isLE } = this;
        let { pos: pos } = this;
        // append the bit '1' to the message
        buffer[pos++] = 128;
        (0, $29ee4d3171d9809b$exports.clean)(this.buffer.subarray(pos));
        // we have less than padOffset left in buffer, so we cannot put length in
        // current block, need process it and pad again
        if (this.padOffset > blockLen - pos) {
            this.process(view, 0);
            pos = 0;
        }
        // Pad until full block byte with zeros
        for(let i = pos; i < blockLen; i++)buffer[i] = 0;
        // Note: sha512 requires length to be 128bit integer, but length in JS will overflow before that
        // You need to write around 2 exabytes (u64_max / 8 / (1024**6)) for this to happen.
        // So we just write lowest 64 bits of that value.
        $dd17a2ee919821c7$var$setBigUint64(view, blockLen - 8, BigInt(this.length * 8), isLE);
        this.process(view, 0);
        const oview = (0, $29ee4d3171d9809b$exports.createView)(out);
        const len = this.outputLen;
        // NOTE: we do division by 4 later, which should be fused in single op with modulo by JIT
        if (len % 4) throw new Error('_sha2: outputLen should be aligned to 32bit');
        const outLen = len / 4;
        const state = this.get();
        if (outLen > state.length) throw new Error('_sha2: outputLen bigger than state');
        for(let i = 0; i < outLen; i++)oview.setUint32(4 * i, state[i], isLE);
    }
    digest() {
        const { buffer: buffer, outputLen: outputLen } = this;
        this.digestInto(buffer);
        const res = buffer.slice(0, outputLen);
        this.destroy();
        return res;
    }
    _cloneInto(to) {
        to || (to = new this.constructor());
        to.set(...this.get());
        const { blockLen: blockLen, buffer: buffer, length: length, finished: finished, destroyed: destroyed, pos: pos } = this;
        to.destroyed = destroyed;
        to.finished = finished;
        to.length = length;
        to.pos = pos;
        if (length % blockLen) to.buffer.set(buffer);
        return to;
    }
    clone() {
        return this._cloneInto();
    }
}
$dd17a2ee919821c7$exports.HashMD = $dd17a2ee919821c7$var$HashMD;
/**
 * Initial SHA-2 state: fractional parts of square roots of first 16 primes 2..53.
 * Check out `test/misc/sha2-gen-iv.js` for recomputation guide.
 */ /** Initial SHA256 state. Bits 0..32 of frac part of sqrt of primes 2..19 */ $dd17a2ee919821c7$exports.SHA256_IV = Uint32Array.from([
    0x6a09e667,
    0xbb67ae85,
    0x3c6ef372,
    0xa54ff53a,
    0x510e527f,
    0x9b05688c,
    0x1f83d9ab,
    0x5be0cd19
]);
/** Initial SHA224 state. Bits 32..64 of frac part of sqrt of primes 23..53 */ $dd17a2ee919821c7$exports.SHA224_IV = Uint32Array.from([
    0xc1059ed8,
    0x367cd507,
    0x3070dd17,
    0xf70e5939,
    0xffc00b31,
    0x68581511,
    0x64f98fa7,
    0xbefa4fa4
]);
/** Initial SHA384 state. Bits 0..64 of frac part of sqrt of primes 23..53 */ $dd17a2ee919821c7$exports.SHA384_IV = Uint32Array.from([
    0xcbbb9d5d,
    0xc1059ed8,
    0x629a292a,
    0x367cd507,
    0x9159015a,
    0x3070dd17,
    0x152fecd8,
    0xf70e5939,
    0x67332667,
    0xffc00b31,
    0x8eb44a87,
    0x68581511,
    0xdb0c2e0d,
    0x64f98fa7,
    0x47b5481d,
    0xbefa4fa4
]);
/** Initial SHA512 state. Bits 0..64 of frac part of sqrt of primes 2..19 */ $dd17a2ee919821c7$exports.SHA512_IV = Uint32Array.from([
    0x6a09e667,
    0xf3bcc908,
    0xbb67ae85,
    0x84caa73b,
    0x3c6ef372,
    0xfe94f82b,
    0xa54ff53a,
    0x5f1d36f1,
    0x510e527f,
    0xade682d1,
    0x9b05688c,
    0x2b3e6c1f,
    0x1f83d9ab,
    0xfb41bd6b,
    0x5be0cd19,
    0x137e2179
]);


var $aa71b30d36adb919$exports = {};
"use strict";
Object.defineProperty($aa71b30d36adb919$exports, "__esModule", {
    value: true
});
$aa71b30d36adb919$exports.toBig = $aa71b30d36adb919$exports.shrSL = $aa71b30d36adb919$exports.shrSH = $aa71b30d36adb919$exports.rotrSL = $aa71b30d36adb919$exports.rotrSH = $aa71b30d36adb919$exports.rotrBL = $aa71b30d36adb919$exports.rotrBH = $aa71b30d36adb919$exports.rotr32L = $aa71b30d36adb919$exports.rotr32H = $aa71b30d36adb919$exports.rotlSL = $aa71b30d36adb919$exports.rotlSH = $aa71b30d36adb919$exports.rotlBL = $aa71b30d36adb919$exports.rotlBH = $aa71b30d36adb919$exports.add5L = $aa71b30d36adb919$exports.add5H = $aa71b30d36adb919$exports.add4L = $aa71b30d36adb919$exports.add4H = $aa71b30d36adb919$exports.add3L = $aa71b30d36adb919$exports.add3H = void 0;
$aa71b30d36adb919$exports.add = $aa71b30d36adb919$var$add;
$aa71b30d36adb919$exports.fromBig = $aa71b30d36adb919$var$fromBig;
$aa71b30d36adb919$exports.split = $aa71b30d36adb919$var$split;
/**
 * Internal helpers for u64. BigUint64Array is too slow as per 2025, so we implement it using Uint32Array.
 * @todo re-check https://issues.chromium.org/issues/42212588
 * @module
 */ const $aa71b30d36adb919$var$U32_MASK64 = /* @__PURE__ */ BigInt(2 ** 32 - 1);
const $aa71b30d36adb919$var$_32n = /* @__PURE__ */ BigInt(32);
function $aa71b30d36adb919$var$fromBig(n, le = false) {
    if (le) return {
        h: Number(n & $aa71b30d36adb919$var$U32_MASK64),
        l: Number(n >> $aa71b30d36adb919$var$_32n & $aa71b30d36adb919$var$U32_MASK64)
    };
    return {
        h: Number(n >> $aa71b30d36adb919$var$_32n & $aa71b30d36adb919$var$U32_MASK64) | 0,
        l: Number(n & $aa71b30d36adb919$var$U32_MASK64) | 0
    };
}
function $aa71b30d36adb919$var$split(lst, le = false) {
    const len = lst.length;
    let Ah = new Uint32Array(len);
    let Al = new Uint32Array(len);
    for(let i = 0; i < len; i++){
        const { h: h, l: l } = $aa71b30d36adb919$var$fromBig(lst[i], le);
        [Ah[i], Al[i]] = [
            h,
            l
        ];
    }
    return [
        Ah,
        Al
    ];
}
const $aa71b30d36adb919$var$toBig = (h, l)=>BigInt(h >>> 0) << $aa71b30d36adb919$var$_32n | BigInt(l >>> 0);
$aa71b30d36adb919$exports.toBig = $aa71b30d36adb919$var$toBig;
// for Shift in [0, 32)
const $aa71b30d36adb919$var$shrSH = (h, _l, s)=>h >>> s;
$aa71b30d36adb919$exports.shrSH = $aa71b30d36adb919$var$shrSH;
const $aa71b30d36adb919$var$shrSL = (h, l, s)=>h << 32 - s | l >>> s;
$aa71b30d36adb919$exports.shrSL = $aa71b30d36adb919$var$shrSL;
// Right rotate for Shift in [1, 32)
const $aa71b30d36adb919$var$rotrSH = (h, l, s)=>h >>> s | l << 32 - s;
$aa71b30d36adb919$exports.rotrSH = $aa71b30d36adb919$var$rotrSH;
const $aa71b30d36adb919$var$rotrSL = (h, l, s)=>h << 32 - s | l >>> s;
$aa71b30d36adb919$exports.rotrSL = $aa71b30d36adb919$var$rotrSL;
// Right rotate for Shift in (32, 64), NOTE: 32 is special case.
const $aa71b30d36adb919$var$rotrBH = (h, l, s)=>h << 64 - s | l >>> s - 32;
$aa71b30d36adb919$exports.rotrBH = $aa71b30d36adb919$var$rotrBH;
const $aa71b30d36adb919$var$rotrBL = (h, l, s)=>h >>> s - 32 | l << 64 - s;
$aa71b30d36adb919$exports.rotrBL = $aa71b30d36adb919$var$rotrBL;
// Right rotate for shift===32 (just swaps l&h)
const $aa71b30d36adb919$var$rotr32H = (_h, l)=>l;
$aa71b30d36adb919$exports.rotr32H = $aa71b30d36adb919$var$rotr32H;
const $aa71b30d36adb919$var$rotr32L = (h, _l)=>h;
$aa71b30d36adb919$exports.rotr32L = $aa71b30d36adb919$var$rotr32L;
// Left rotate for Shift in [1, 32)
const $aa71b30d36adb919$var$rotlSH = (h, l, s)=>h << s | l >>> 32 - s;
$aa71b30d36adb919$exports.rotlSH = $aa71b30d36adb919$var$rotlSH;
const $aa71b30d36adb919$var$rotlSL = (h, l, s)=>l << s | h >>> 32 - s;
$aa71b30d36adb919$exports.rotlSL = $aa71b30d36adb919$var$rotlSL;
// Left rotate for Shift in (32, 64), NOTE: 32 is special case.
const $aa71b30d36adb919$var$rotlBH = (h, l, s)=>l << s - 32 | h >>> 64 - s;
$aa71b30d36adb919$exports.rotlBH = $aa71b30d36adb919$var$rotlBH;
const $aa71b30d36adb919$var$rotlBL = (h, l, s)=>h << s - 32 | l >>> 64 - s;
$aa71b30d36adb919$exports.rotlBL = $aa71b30d36adb919$var$rotlBL;
// JS uses 32-bit signed integers for bitwise operations which means we cannot
// simple take carry out of low bit sum by shift, we need to use division.
function $aa71b30d36adb919$var$add(Ah, Al, Bh, Bl) {
    const l = (Al >>> 0) + (Bl >>> 0);
    return {
        h: Ah + Bh + (l / 2 ** 32 | 0) | 0,
        l: l | 0
    };
}
// Addition with more than 2 elements
const $aa71b30d36adb919$var$add3L = (Al, Bl, Cl)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0);
$aa71b30d36adb919$exports.add3L = $aa71b30d36adb919$var$add3L;
const $aa71b30d36adb919$var$add3H = (low, Ah, Bh, Ch)=>Ah + Bh + Ch + (low / 2 ** 32 | 0) | 0;
$aa71b30d36adb919$exports.add3H = $aa71b30d36adb919$var$add3H;
const $aa71b30d36adb919$var$add4L = (Al, Bl, Cl, Dl)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0) + (Dl >>> 0);
$aa71b30d36adb919$exports.add4L = $aa71b30d36adb919$var$add4L;
const $aa71b30d36adb919$var$add4H = (low, Ah, Bh, Ch, Dh)=>Ah + Bh + Ch + Dh + (low / 2 ** 32 | 0) | 0;
$aa71b30d36adb919$exports.add4H = $aa71b30d36adb919$var$add4H;
const $aa71b30d36adb919$var$add5L = (Al, Bl, Cl, Dl, El)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0) + (Dl >>> 0) + (El >>> 0);
$aa71b30d36adb919$exports.add5L = $aa71b30d36adb919$var$add5L;
const $aa71b30d36adb919$var$add5H = (low, Ah, Bh, Ch, Dh, Eh)=>Ah + Bh + Ch + Dh + Eh + (low / 2 ** 32 | 0) | 0;
$aa71b30d36adb919$exports.add5H = $aa71b30d36adb919$var$add5H;
// prettier-ignore
const $aa71b30d36adb919$var$u64 = {
    fromBig: $aa71b30d36adb919$var$fromBig,
    split: $aa71b30d36adb919$var$split,
    toBig: $aa71b30d36adb919$var$toBig,
    shrSH: $aa71b30d36adb919$var$shrSH,
    shrSL: $aa71b30d36adb919$var$shrSL,
    rotrSH: $aa71b30d36adb919$var$rotrSH,
    rotrSL: $aa71b30d36adb919$var$rotrSL,
    rotrBH: $aa71b30d36adb919$var$rotrBH,
    rotrBL: $aa71b30d36adb919$var$rotrBL,
    rotr32H: $aa71b30d36adb919$var$rotr32H,
    rotr32L: $aa71b30d36adb919$var$rotr32L,
    rotlSH: $aa71b30d36adb919$var$rotlSH,
    rotlSL: $aa71b30d36adb919$var$rotlSL,
    rotlBH: $aa71b30d36adb919$var$rotlBH,
    rotlBL: $aa71b30d36adb919$var$rotlBL,
    add: $aa71b30d36adb919$var$add,
    add3L: $aa71b30d36adb919$var$add3L,
    add3H: $aa71b30d36adb919$var$add3H,
    add4L: $aa71b30d36adb919$var$add4L,
    add4H: $aa71b30d36adb919$var$add4H,
    add5H: $aa71b30d36adb919$var$add5H,
    add5L: $aa71b30d36adb919$var$add5L
};
$aa71b30d36adb919$exports.default = $aa71b30d36adb919$var$u64;



/**
 * Round constants:
 * First 32 bits of fractional parts of the cube roots of the first 64 primes 2..311)
 */ // prettier-ignore
const $cb9d97d4d61a5a71$var$SHA256_K = /* @__PURE__ */ Uint32Array.from([
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
]);
/** Reusable temporary buffer. "W" comes straight from spec. */ const $cb9d97d4d61a5a71$var$SHA256_W = /* @__PURE__ */ new Uint32Array(64);
class $cb9d97d4d61a5a71$var$SHA256 extends $dd17a2ee919821c7$exports.HashMD {
    constructor(outputLen = 32){
        super(64, outputLen, 8, false);
        // We cannot use array here since array allows indexing by variable
        // which means optimizer/compiler cannot use registers.
        this.A = $dd17a2ee919821c7$exports.SHA256_IV[0] | 0;
        this.B = $dd17a2ee919821c7$exports.SHA256_IV[1] | 0;
        this.C = $dd17a2ee919821c7$exports.SHA256_IV[2] | 0;
        this.D = $dd17a2ee919821c7$exports.SHA256_IV[3] | 0;
        this.E = $dd17a2ee919821c7$exports.SHA256_IV[4] | 0;
        this.F = $dd17a2ee919821c7$exports.SHA256_IV[5] | 0;
        this.G = $dd17a2ee919821c7$exports.SHA256_IV[6] | 0;
        this.H = $dd17a2ee919821c7$exports.SHA256_IV[7] | 0;
    }
    get() {
        const { A: A, B: B, C: C, D: D, E: E, F: F, G: G, H: H } = this;
        return [
            A,
            B,
            C,
            D,
            E,
            F,
            G,
            H
        ];
    }
    // prettier-ignore
    set(A, B, C, D, E, F, G, H) {
        this.A = A | 0;
        this.B = B | 0;
        this.C = C | 0;
        this.D = D | 0;
        this.E = E | 0;
        this.F = F | 0;
        this.G = G | 0;
        this.H = H | 0;
    }
    process(view, offset) {
        // Extend the first 16 words into the remaining 48 words w[16..63] of the message schedule array
        for(let i = 0; i < 16; i++, offset += 4)$cb9d97d4d61a5a71$var$SHA256_W[i] = view.getUint32(offset, false);
        for(let i = 16; i < 64; i++){
            const W15 = $cb9d97d4d61a5a71$var$SHA256_W[i - 15];
            const W2 = $cb9d97d4d61a5a71$var$SHA256_W[i - 2];
            const s0 = (0, $29ee4d3171d9809b$exports.rotr)(W15, 7) ^ (0, $29ee4d3171d9809b$exports.rotr)(W15, 18) ^ W15 >>> 3;
            const s1 = (0, $29ee4d3171d9809b$exports.rotr)(W2, 17) ^ (0, $29ee4d3171d9809b$exports.rotr)(W2, 19) ^ W2 >>> 10;
            $cb9d97d4d61a5a71$var$SHA256_W[i] = s1 + $cb9d97d4d61a5a71$var$SHA256_W[i - 7] + s0 + $cb9d97d4d61a5a71$var$SHA256_W[i - 16] | 0;
        }
        // Compression function main loop, 64 rounds
        let { A: A, B: B, C: C, D: D, E: E, F: F, G: G, H: H } = this;
        for(let i = 0; i < 64; i++){
            const sigma1 = (0, $29ee4d3171d9809b$exports.rotr)(E, 6) ^ (0, $29ee4d3171d9809b$exports.rotr)(E, 11) ^ (0, $29ee4d3171d9809b$exports.rotr)(E, 25);
            const T1 = H + sigma1 + (0, $dd17a2ee919821c7$exports.Chi)(E, F, G) + $cb9d97d4d61a5a71$var$SHA256_K[i] + $cb9d97d4d61a5a71$var$SHA256_W[i] | 0;
            const sigma0 = (0, $29ee4d3171d9809b$exports.rotr)(A, 2) ^ (0, $29ee4d3171d9809b$exports.rotr)(A, 13) ^ (0, $29ee4d3171d9809b$exports.rotr)(A, 22);
            const T2 = sigma0 + (0, $dd17a2ee919821c7$exports.Maj)(A, B, C) | 0;
            H = G;
            G = F;
            F = E;
            E = D + T1 | 0;
            D = C;
            C = B;
            B = A;
            A = T1 + T2 | 0;
        }
        // Add the compressed chunk to the current hash value
        A = A + this.A | 0;
        B = B + this.B | 0;
        C = C + this.C | 0;
        D = D + this.D | 0;
        E = E + this.E | 0;
        F = F + this.F | 0;
        G = G + this.G | 0;
        H = H + this.H | 0;
        this.set(A, B, C, D, E, F, G, H);
    }
    roundClean() {
        (0, $29ee4d3171d9809b$exports.clean)($cb9d97d4d61a5a71$var$SHA256_W);
    }
    destroy() {
        this.set(0, 0, 0, 0, 0, 0, 0, 0);
        (0, $29ee4d3171d9809b$exports.clean)(this.buffer);
    }
}
$cb9d97d4d61a5a71$exports.SHA256 = $cb9d97d4d61a5a71$var$SHA256;
class $cb9d97d4d61a5a71$var$SHA224 extends $cb9d97d4d61a5a71$var$SHA256 {
    constructor(){
        super(28);
        this.A = $dd17a2ee919821c7$exports.SHA224_IV[0] | 0;
        this.B = $dd17a2ee919821c7$exports.SHA224_IV[1] | 0;
        this.C = $dd17a2ee919821c7$exports.SHA224_IV[2] | 0;
        this.D = $dd17a2ee919821c7$exports.SHA224_IV[3] | 0;
        this.E = $dd17a2ee919821c7$exports.SHA224_IV[4] | 0;
        this.F = $dd17a2ee919821c7$exports.SHA224_IV[5] | 0;
        this.G = $dd17a2ee919821c7$exports.SHA224_IV[6] | 0;
        this.H = $dd17a2ee919821c7$exports.SHA224_IV[7] | 0;
    }
}
$cb9d97d4d61a5a71$exports.SHA224 = $cb9d97d4d61a5a71$var$SHA224;
// SHA2-512 is slower than sha256 in js because u64 operations are slow.
// Round contants
// First 32 bits of the fractional parts of the cube roots of the first 80 primes 2..409
// prettier-ignore
const $cb9d97d4d61a5a71$var$K512 = /* @__PURE__ */ (()=>$aa71b30d36adb919$exports.split([
        '0x428a2f98d728ae22',
        '0x7137449123ef65cd',
        '0xb5c0fbcfec4d3b2f',
        '0xe9b5dba58189dbbc',
        '0x3956c25bf348b538',
        '0x59f111f1b605d019',
        '0x923f82a4af194f9b',
        '0xab1c5ed5da6d8118',
        '0xd807aa98a3030242',
        '0x12835b0145706fbe',
        '0x243185be4ee4b28c',
        '0x550c7dc3d5ffb4e2',
        '0x72be5d74f27b896f',
        '0x80deb1fe3b1696b1',
        '0x9bdc06a725c71235',
        '0xc19bf174cf692694',
        '0xe49b69c19ef14ad2',
        '0xefbe4786384f25e3',
        '0x0fc19dc68b8cd5b5',
        '0x240ca1cc77ac9c65',
        '0x2de92c6f592b0275',
        '0x4a7484aa6ea6e483',
        '0x5cb0a9dcbd41fbd4',
        '0x76f988da831153b5',
        '0x983e5152ee66dfab',
        '0xa831c66d2db43210',
        '0xb00327c898fb213f',
        '0xbf597fc7beef0ee4',
        '0xc6e00bf33da88fc2',
        '0xd5a79147930aa725',
        '0x06ca6351e003826f',
        '0x142929670a0e6e70',
        '0x27b70a8546d22ffc',
        '0x2e1b21385c26c926',
        '0x4d2c6dfc5ac42aed',
        '0x53380d139d95b3df',
        '0x650a73548baf63de',
        '0x766a0abb3c77b2a8',
        '0x81c2c92e47edaee6',
        '0x92722c851482353b',
        '0xa2bfe8a14cf10364',
        '0xa81a664bbc423001',
        '0xc24b8b70d0f89791',
        '0xc76c51a30654be30',
        '0xd192e819d6ef5218',
        '0xd69906245565a910',
        '0xf40e35855771202a',
        '0x106aa07032bbd1b8',
        '0x19a4c116b8d2d0c8',
        '0x1e376c085141ab53',
        '0x2748774cdf8eeb99',
        '0x34b0bcb5e19b48a8',
        '0x391c0cb3c5c95a63',
        '0x4ed8aa4ae3418acb',
        '0x5b9cca4f7763e373',
        '0x682e6ff3d6b2b8a3',
        '0x748f82ee5defb2fc',
        '0x78a5636f43172f60',
        '0x84c87814a1f0ab72',
        '0x8cc702081a6439ec',
        '0x90befffa23631e28',
        '0xa4506cebde82bde9',
        '0xbef9a3f7b2c67915',
        '0xc67178f2e372532b',
        '0xca273eceea26619c',
        '0xd186b8c721c0c207',
        '0xeada7dd6cde0eb1e',
        '0xf57d4f7fee6ed178',
        '0x06f067aa72176fba',
        '0x0a637dc5a2c898a6',
        '0x113f9804bef90dae',
        '0x1b710b35131c471b',
        '0x28db77f523047d84',
        '0x32caab7b40c72493',
        '0x3c9ebe0a15c9bebc',
        '0x431d67c49c100d4c',
        '0x4cc5d4becb3e42b6',
        '0x597f299cfc657e2a',
        '0x5fcb6fab3ad6faec',
        '0x6c44198c4a475817'
    ].map((n)=>BigInt(n))))();
const $cb9d97d4d61a5a71$var$SHA512_Kh = /* @__PURE__ */ (()=>$cb9d97d4d61a5a71$var$K512[0])();
const $cb9d97d4d61a5a71$var$SHA512_Kl = /* @__PURE__ */ (()=>$cb9d97d4d61a5a71$var$K512[1])();
// Reusable temporary buffers
const $cb9d97d4d61a5a71$var$SHA512_W_H = /* @__PURE__ */ new Uint32Array(80);
const $cb9d97d4d61a5a71$var$SHA512_W_L = /* @__PURE__ */ new Uint32Array(80);
class $cb9d97d4d61a5a71$var$SHA512 extends $dd17a2ee919821c7$exports.HashMD {
    constructor(outputLen = 64){
        super(128, outputLen, 16, false);
        // We cannot use array here since array allows indexing by variable
        // which means optimizer/compiler cannot use registers.
        // h -- high 32 bits, l -- low 32 bits
        this.Ah = $dd17a2ee919821c7$exports.SHA512_IV[0] | 0;
        this.Al = $dd17a2ee919821c7$exports.SHA512_IV[1] | 0;
        this.Bh = $dd17a2ee919821c7$exports.SHA512_IV[2] | 0;
        this.Bl = $dd17a2ee919821c7$exports.SHA512_IV[3] | 0;
        this.Ch = $dd17a2ee919821c7$exports.SHA512_IV[4] | 0;
        this.Cl = $dd17a2ee919821c7$exports.SHA512_IV[5] | 0;
        this.Dh = $dd17a2ee919821c7$exports.SHA512_IV[6] | 0;
        this.Dl = $dd17a2ee919821c7$exports.SHA512_IV[7] | 0;
        this.Eh = $dd17a2ee919821c7$exports.SHA512_IV[8] | 0;
        this.El = $dd17a2ee919821c7$exports.SHA512_IV[9] | 0;
        this.Fh = $dd17a2ee919821c7$exports.SHA512_IV[10] | 0;
        this.Fl = $dd17a2ee919821c7$exports.SHA512_IV[11] | 0;
        this.Gh = $dd17a2ee919821c7$exports.SHA512_IV[12] | 0;
        this.Gl = $dd17a2ee919821c7$exports.SHA512_IV[13] | 0;
        this.Hh = $dd17a2ee919821c7$exports.SHA512_IV[14] | 0;
        this.Hl = $dd17a2ee919821c7$exports.SHA512_IV[15] | 0;
    }
    // prettier-ignore
    get() {
        const { Ah: Ah, Al: Al, Bh: Bh, Bl: Bl, Ch: Ch, Cl: Cl, Dh: Dh, Dl: Dl, Eh: Eh, El: El, Fh: Fh, Fl: Fl, Gh: Gh, Gl: Gl, Hh: Hh, Hl: Hl } = this;
        return [
            Ah,
            Al,
            Bh,
            Bl,
            Ch,
            Cl,
            Dh,
            Dl,
            Eh,
            El,
            Fh,
            Fl,
            Gh,
            Gl,
            Hh,
            Hl
        ];
    }
    // prettier-ignore
    set(Ah, Al, Bh, Bl, Ch, Cl, Dh, Dl, Eh, El, Fh, Fl, Gh, Gl, Hh, Hl) {
        this.Ah = Ah | 0;
        this.Al = Al | 0;
        this.Bh = Bh | 0;
        this.Bl = Bl | 0;
        this.Ch = Ch | 0;
        this.Cl = Cl | 0;
        this.Dh = Dh | 0;
        this.Dl = Dl | 0;
        this.Eh = Eh | 0;
        this.El = El | 0;
        this.Fh = Fh | 0;
        this.Fl = Fl | 0;
        this.Gh = Gh | 0;
        this.Gl = Gl | 0;
        this.Hh = Hh | 0;
        this.Hl = Hl | 0;
    }
    process(view, offset) {
        // Extend the first 16 words into the remaining 64 words w[16..79] of the message schedule array
        for(let i = 0; i < 16; i++, offset += 4){
            $cb9d97d4d61a5a71$var$SHA512_W_H[i] = view.getUint32(offset);
            $cb9d97d4d61a5a71$var$SHA512_W_L[i] = view.getUint32(offset += 4);
        }
        for(let i = 16; i < 80; i++){
            // s0 := (w[i-15] rightrotate 1) xor (w[i-15] rightrotate 8) xor (w[i-15] rightshift 7)
            const W15h = $cb9d97d4d61a5a71$var$SHA512_W_H[i - 15] | 0;
            const W15l = $cb9d97d4d61a5a71$var$SHA512_W_L[i - 15] | 0;
            const s0h = $aa71b30d36adb919$exports.rotrSH(W15h, W15l, 1) ^ $aa71b30d36adb919$exports.rotrSH(W15h, W15l, 8) ^ $aa71b30d36adb919$exports.shrSH(W15h, W15l, 7);
            const s0l = $aa71b30d36adb919$exports.rotrSL(W15h, W15l, 1) ^ $aa71b30d36adb919$exports.rotrSL(W15h, W15l, 8) ^ $aa71b30d36adb919$exports.shrSL(W15h, W15l, 7);
            // s1 := (w[i-2] rightrotate 19) xor (w[i-2] rightrotate 61) xor (w[i-2] rightshift 6)
            const W2h = $cb9d97d4d61a5a71$var$SHA512_W_H[i - 2] | 0;
            const W2l = $cb9d97d4d61a5a71$var$SHA512_W_L[i - 2] | 0;
            const s1h = $aa71b30d36adb919$exports.rotrSH(W2h, W2l, 19) ^ $aa71b30d36adb919$exports.rotrBH(W2h, W2l, 61) ^ $aa71b30d36adb919$exports.shrSH(W2h, W2l, 6);
            const s1l = $aa71b30d36adb919$exports.rotrSL(W2h, W2l, 19) ^ $aa71b30d36adb919$exports.rotrBL(W2h, W2l, 61) ^ $aa71b30d36adb919$exports.shrSL(W2h, W2l, 6);
            // SHA256_W[i] = s0 + s1 + SHA256_W[i - 7] + SHA256_W[i - 16];
            const SUMl = $aa71b30d36adb919$exports.add4L(s0l, s1l, $cb9d97d4d61a5a71$var$SHA512_W_L[i - 7], $cb9d97d4d61a5a71$var$SHA512_W_L[i - 16]);
            const SUMh = $aa71b30d36adb919$exports.add4H(SUMl, s0h, s1h, $cb9d97d4d61a5a71$var$SHA512_W_H[i - 7], $cb9d97d4d61a5a71$var$SHA512_W_H[i - 16]);
            $cb9d97d4d61a5a71$var$SHA512_W_H[i] = SUMh | 0;
            $cb9d97d4d61a5a71$var$SHA512_W_L[i] = SUMl | 0;
        }
        let { Ah: Ah, Al: Al, Bh: Bh, Bl: Bl, Ch: Ch, Cl: Cl, Dh: Dh, Dl: Dl, Eh: Eh, El: El, Fh: Fh, Fl: Fl, Gh: Gh, Gl: Gl, Hh: Hh, Hl: Hl } = this;
        // Compression function main loop, 80 rounds
        for(let i = 0; i < 80; i++){
            // S1 := (e rightrotate 14) xor (e rightrotate 18) xor (e rightrotate 41)
            const sigma1h = $aa71b30d36adb919$exports.rotrSH(Eh, El, 14) ^ $aa71b30d36adb919$exports.rotrSH(Eh, El, 18) ^ $aa71b30d36adb919$exports.rotrBH(Eh, El, 41);
            const sigma1l = $aa71b30d36adb919$exports.rotrSL(Eh, El, 14) ^ $aa71b30d36adb919$exports.rotrSL(Eh, El, 18) ^ $aa71b30d36adb919$exports.rotrBL(Eh, El, 41);
            //const T1 = (H + sigma1 + Chi(E, F, G) + SHA256_K[i] + SHA256_W[i]) | 0;
            const CHIh = Eh & Fh ^ ~Eh & Gh;
            const CHIl = El & Fl ^ ~El & Gl;
            // T1 = H + sigma1 + Chi(E, F, G) + SHA512_K[i] + SHA512_W[i]
            // prettier-ignore
            const T1ll = $aa71b30d36adb919$exports.add5L(Hl, sigma1l, CHIl, $cb9d97d4d61a5a71$var$SHA512_Kl[i], $cb9d97d4d61a5a71$var$SHA512_W_L[i]);
            const T1h = $aa71b30d36adb919$exports.add5H(T1ll, Hh, sigma1h, CHIh, $cb9d97d4d61a5a71$var$SHA512_Kh[i], $cb9d97d4d61a5a71$var$SHA512_W_H[i]);
            const T1l = T1ll | 0;
            // S0 := (a rightrotate 28) xor (a rightrotate 34) xor (a rightrotate 39)
            const sigma0h = $aa71b30d36adb919$exports.rotrSH(Ah, Al, 28) ^ $aa71b30d36adb919$exports.rotrBH(Ah, Al, 34) ^ $aa71b30d36adb919$exports.rotrBH(Ah, Al, 39);
            const sigma0l = $aa71b30d36adb919$exports.rotrSL(Ah, Al, 28) ^ $aa71b30d36adb919$exports.rotrBL(Ah, Al, 34) ^ $aa71b30d36adb919$exports.rotrBL(Ah, Al, 39);
            const MAJh = Ah & Bh ^ Ah & Ch ^ Bh & Ch;
            const MAJl = Al & Bl ^ Al & Cl ^ Bl & Cl;
            Hh = Gh | 0;
            Hl = Gl | 0;
            Gh = Fh | 0;
            Gl = Fl | 0;
            Fh = Eh | 0;
            Fl = El | 0;
            ({ h: Eh, l: El } = $aa71b30d36adb919$exports.add(Dh | 0, Dl | 0, T1h | 0, T1l | 0));
            Dh = Ch | 0;
            Dl = Cl | 0;
            Ch = Bh | 0;
            Cl = Bl | 0;
            Bh = Ah | 0;
            Bl = Al | 0;
            const All = $aa71b30d36adb919$exports.add3L(T1l, sigma0l, MAJl);
            Ah = $aa71b30d36adb919$exports.add3H(All, T1h, sigma0h, MAJh);
            Al = All | 0;
        }
        // Add the compressed chunk to the current hash value
        ({ h: Ah, l: Al } = $aa71b30d36adb919$exports.add(this.Ah | 0, this.Al | 0, Ah | 0, Al | 0));
        ({ h: Bh, l: Bl } = $aa71b30d36adb919$exports.add(this.Bh | 0, this.Bl | 0, Bh | 0, Bl | 0));
        ({ h: Ch, l: Cl } = $aa71b30d36adb919$exports.add(this.Ch | 0, this.Cl | 0, Ch | 0, Cl | 0));
        ({ h: Dh, l: Dl } = $aa71b30d36adb919$exports.add(this.Dh | 0, this.Dl | 0, Dh | 0, Dl | 0));
        ({ h: Eh, l: El } = $aa71b30d36adb919$exports.add(this.Eh | 0, this.El | 0, Eh | 0, El | 0));
        ({ h: Fh, l: Fl } = $aa71b30d36adb919$exports.add(this.Fh | 0, this.Fl | 0, Fh | 0, Fl | 0));
        ({ h: Gh, l: Gl } = $aa71b30d36adb919$exports.add(this.Gh | 0, this.Gl | 0, Gh | 0, Gl | 0));
        ({ h: Hh, l: Hl } = $aa71b30d36adb919$exports.add(this.Hh | 0, this.Hl | 0, Hh | 0, Hl | 0));
        this.set(Ah, Al, Bh, Bl, Ch, Cl, Dh, Dl, Eh, El, Fh, Fl, Gh, Gl, Hh, Hl);
    }
    roundClean() {
        (0, $29ee4d3171d9809b$exports.clean)($cb9d97d4d61a5a71$var$SHA512_W_H, $cb9d97d4d61a5a71$var$SHA512_W_L);
    }
    destroy() {
        (0, $29ee4d3171d9809b$exports.clean)(this.buffer);
        this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
    }
}
$cb9d97d4d61a5a71$exports.SHA512 = $cb9d97d4d61a5a71$var$SHA512;
class $cb9d97d4d61a5a71$var$SHA384 extends $cb9d97d4d61a5a71$var$SHA512 {
    constructor(){
        super(48);
        this.Ah = $dd17a2ee919821c7$exports.SHA384_IV[0] | 0;
        this.Al = $dd17a2ee919821c7$exports.SHA384_IV[1] | 0;
        this.Bh = $dd17a2ee919821c7$exports.SHA384_IV[2] | 0;
        this.Bl = $dd17a2ee919821c7$exports.SHA384_IV[3] | 0;
        this.Ch = $dd17a2ee919821c7$exports.SHA384_IV[4] | 0;
        this.Cl = $dd17a2ee919821c7$exports.SHA384_IV[5] | 0;
        this.Dh = $dd17a2ee919821c7$exports.SHA384_IV[6] | 0;
        this.Dl = $dd17a2ee919821c7$exports.SHA384_IV[7] | 0;
        this.Eh = $dd17a2ee919821c7$exports.SHA384_IV[8] | 0;
        this.El = $dd17a2ee919821c7$exports.SHA384_IV[9] | 0;
        this.Fh = $dd17a2ee919821c7$exports.SHA384_IV[10] | 0;
        this.Fl = $dd17a2ee919821c7$exports.SHA384_IV[11] | 0;
        this.Gh = $dd17a2ee919821c7$exports.SHA384_IV[12] | 0;
        this.Gl = $dd17a2ee919821c7$exports.SHA384_IV[13] | 0;
        this.Hh = $dd17a2ee919821c7$exports.SHA384_IV[14] | 0;
        this.Hl = $dd17a2ee919821c7$exports.SHA384_IV[15] | 0;
    }
}
$cb9d97d4d61a5a71$exports.SHA384 = $cb9d97d4d61a5a71$var$SHA384;
/**
 * Truncated SHA512/256 and SHA512/224.
 * SHA512_IV is XORed with 0xa5a5a5a5a5a5a5a5, then used as "intermediary" IV of SHA512/t.
 * Then t hashes string to produce result IV.
 * See `test/misc/sha2-gen-iv.js`.
 */ /** SHA512/224 IV */ const $cb9d97d4d61a5a71$var$T224_IV = /* @__PURE__ */ Uint32Array.from([
    0x8c3d37c8,
    0x19544da2,
    0x73e19966,
    0x89dcd4d6,
    0x1dfab7ae,
    0x32ff9c82,
    0x679dd514,
    0x582f9fcf,
    0x0f6d2b69,
    0x7bd44da8,
    0x77e36f73,
    0x04c48942,
    0x3f9d85a8,
    0x6a1d36c8,
    0x1112e6ad,
    0x91d692a1
]);
/** SHA512/256 IV */ const $cb9d97d4d61a5a71$var$T256_IV = /* @__PURE__ */ Uint32Array.from([
    0x22312194,
    0xfc2bf72c,
    0x9f555fa3,
    0xc84c64c2,
    0x2393b86b,
    0x6f53b151,
    0x96387719,
    0x5940eabd,
    0x96283ee2,
    0xa88effe3,
    0xbe5e1e25,
    0x53863992,
    0x2b0199fc,
    0x2c85b8aa,
    0x0eb72ddc,
    0x81c52ca2
]);
class $cb9d97d4d61a5a71$var$SHA512_224 extends $cb9d97d4d61a5a71$var$SHA512 {
    constructor(){
        super(28);
        this.Ah = $cb9d97d4d61a5a71$var$T224_IV[0] | 0;
        this.Al = $cb9d97d4d61a5a71$var$T224_IV[1] | 0;
        this.Bh = $cb9d97d4d61a5a71$var$T224_IV[2] | 0;
        this.Bl = $cb9d97d4d61a5a71$var$T224_IV[3] | 0;
        this.Ch = $cb9d97d4d61a5a71$var$T224_IV[4] | 0;
        this.Cl = $cb9d97d4d61a5a71$var$T224_IV[5] | 0;
        this.Dh = $cb9d97d4d61a5a71$var$T224_IV[6] | 0;
        this.Dl = $cb9d97d4d61a5a71$var$T224_IV[7] | 0;
        this.Eh = $cb9d97d4d61a5a71$var$T224_IV[8] | 0;
        this.El = $cb9d97d4d61a5a71$var$T224_IV[9] | 0;
        this.Fh = $cb9d97d4d61a5a71$var$T224_IV[10] | 0;
        this.Fl = $cb9d97d4d61a5a71$var$T224_IV[11] | 0;
        this.Gh = $cb9d97d4d61a5a71$var$T224_IV[12] | 0;
        this.Gl = $cb9d97d4d61a5a71$var$T224_IV[13] | 0;
        this.Hh = $cb9d97d4d61a5a71$var$T224_IV[14] | 0;
        this.Hl = $cb9d97d4d61a5a71$var$T224_IV[15] | 0;
    }
}
$cb9d97d4d61a5a71$exports.SHA512_224 = $cb9d97d4d61a5a71$var$SHA512_224;
class $cb9d97d4d61a5a71$var$SHA512_256 extends $cb9d97d4d61a5a71$var$SHA512 {
    constructor(){
        super(32);
        this.Ah = $cb9d97d4d61a5a71$var$T256_IV[0] | 0;
        this.Al = $cb9d97d4d61a5a71$var$T256_IV[1] | 0;
        this.Bh = $cb9d97d4d61a5a71$var$T256_IV[2] | 0;
        this.Bl = $cb9d97d4d61a5a71$var$T256_IV[3] | 0;
        this.Ch = $cb9d97d4d61a5a71$var$T256_IV[4] | 0;
        this.Cl = $cb9d97d4d61a5a71$var$T256_IV[5] | 0;
        this.Dh = $cb9d97d4d61a5a71$var$T256_IV[6] | 0;
        this.Dl = $cb9d97d4d61a5a71$var$T256_IV[7] | 0;
        this.Eh = $cb9d97d4d61a5a71$var$T256_IV[8] | 0;
        this.El = $cb9d97d4d61a5a71$var$T256_IV[9] | 0;
        this.Fh = $cb9d97d4d61a5a71$var$T256_IV[10] | 0;
        this.Fl = $cb9d97d4d61a5a71$var$T256_IV[11] | 0;
        this.Gh = $cb9d97d4d61a5a71$var$T256_IV[12] | 0;
        this.Gl = $cb9d97d4d61a5a71$var$T256_IV[13] | 0;
        this.Hh = $cb9d97d4d61a5a71$var$T256_IV[14] | 0;
        this.Hl = $cb9d97d4d61a5a71$var$T256_IV[15] | 0;
    }
}
$cb9d97d4d61a5a71$exports.SHA512_256 = $cb9d97d4d61a5a71$var$SHA512_256;
/**
 * SHA2-256 hash function from RFC 4634.
 *
 * It is the fastest JS hash, even faster than Blake3.
 * To break sha256 using birthday attack, attackers need to try 2^128 hashes.
 * BTC network is doing 2^70 hashes/sec (2^95 hashes/year) as per 2025.
 */ $cb9d97d4d61a5a71$exports.sha256 = (0, $29ee4d3171d9809b$exports.createHasher)(()=>new $cb9d97d4d61a5a71$var$SHA256());
/** SHA2-224 hash function from RFC 4634 */ $cb9d97d4d61a5a71$exports.sha224 = (0, $29ee4d3171d9809b$exports.createHasher)(()=>new $cb9d97d4d61a5a71$var$SHA224());
/** SHA2-512 hash function from RFC 4634. */ $cb9d97d4d61a5a71$exports.sha512 = (0, $29ee4d3171d9809b$exports.createHasher)(()=>new $cb9d97d4d61a5a71$var$SHA512());
/** SHA2-384 hash function from RFC 4634. */ $cb9d97d4d61a5a71$exports.sha384 = (0, $29ee4d3171d9809b$exports.createHasher)(()=>new $cb9d97d4d61a5a71$var$SHA384());
/**
 * SHA2-512/256 "truncated" hash function, with improved resistance to length extension attacks.
 * See the paper on [truncated SHA512](https://eprint.iacr.org/2010/548.pdf).
 */ $cb9d97d4d61a5a71$exports.sha512_256 = (0, $29ee4d3171d9809b$exports.createHasher)(()=>new $cb9d97d4d61a5a71$var$SHA512_256());
/**
 * SHA2-512/224 "truncated" hash function, with improved resistance to length extension attacks.
 * See the paper on [truncated SHA512](https://eprint.iacr.org/2010/548.pdf).
 */ $cb9d97d4d61a5a71$exports.sha512_224 = (0, $29ee4d3171d9809b$exports.createHasher)(()=>new $cb9d97d4d61a5a71$var$SHA512_224());


/** @deprecated Use import from `noble/hashes/sha2` module */ $510ad3657d73a9d2$exports.SHA256 = $cb9d97d4d61a5a71$exports.SHA256;
/** @deprecated Use import from `noble/hashes/sha2` module */ $510ad3657d73a9d2$exports.sha256 = $cb9d97d4d61a5a71$exports.sha256;
/** @deprecated Use import from `noble/hashes/sha2` module */ $510ad3657d73a9d2$exports.SHA224 = $cb9d97d4d61a5a71$exports.SHA224;
/** @deprecated Use import from `noble/hashes/sha2` module */ $510ad3657d73a9d2$exports.sha224 = $cb9d97d4d61a5a71$exports.sha224;


var $f953b6354166cf05$require$sha256 = $510ad3657d73a9d2$exports.sha256;
var $88ba304516094693$exports = {};
'use strict';
var $8b756b3b8ee97947$exports = {};
var $001e77b0dfd1bf3d$exports = {};
'use strict';
// base-x encoding / decoding
// Copyright (c) 2018 base-x contributors
// Copyright (c) 2014-2018 The Bitcoin Core developers (base58.cpp)
// Distributed under the MIT software license, see the accompanying
// file LICENSE or http://www.opensource.org/licenses/mit-license.php.
function $001e77b0dfd1bf3d$var$base(ALPHABET) {
    if (ALPHABET.length >= 255) throw new TypeError('Alphabet too long');
    var BASE_MAP = new Uint8Array(256);
    for(var j = 0; j < BASE_MAP.length; j++)BASE_MAP[j] = 255;
    for(var i = 0; i < ALPHABET.length; i++){
        var x = ALPHABET.charAt(i);
        var xc = x.charCodeAt(0);
        if (BASE_MAP[xc] !== 255) throw new TypeError(x + ' is ambiguous');
        BASE_MAP[xc] = i;
    }
    var BASE = ALPHABET.length;
    var LEADER = ALPHABET.charAt(0);
    var FACTOR = Math.log(BASE) / Math.log(256) // log(BASE) / log(256), rounded up
    ;
    var iFACTOR = Math.log(256) / Math.log(BASE) // log(256) / log(BASE), rounded up
    ;
    function encode(source) {
        if (source instanceof Uint8Array) ;
        else if (ArrayBuffer.isView(source)) source = new Uint8Array(source.buffer, source.byteOffset, source.byteLength);
        else if (Array.isArray(source)) source = Uint8Array.from(source);
        if (!(source instanceof Uint8Array)) throw new TypeError('Expected Uint8Array');
        if (source.length === 0) return '';
        // Skip & count leading zeroes.
        var zeroes = 0;
        var length = 0;
        var pbegin = 0;
        var pend = source.length;
        while(pbegin !== pend && source[pbegin] === 0){
            pbegin++;
            zeroes++;
        }
        // Allocate enough space in big-endian base58 representation.
        var size = (pend - pbegin) * iFACTOR + 1 >>> 0;
        var b58 = new Uint8Array(size);
        // Process the bytes.
        while(pbegin !== pend){
            var carry = source[pbegin];
            // Apply "b58 = b58 * 256 + ch".
            var i = 0;
            for(var it1 = size - 1; (carry !== 0 || i < length) && it1 !== -1; it1--, i++){
                carry += 256 * b58[it1] >>> 0;
                b58[it1] = carry % BASE >>> 0;
                carry = carry / BASE >>> 0;
            }
            if (carry !== 0) throw new Error('Non-zero carry');
            length = i;
            pbegin++;
        }
        // Skip leading zeroes in base58 result.
        var it2 = size - length;
        while(it2 !== size && b58[it2] === 0)it2++;
        // Translate the result into a string.
        var str = LEADER.repeat(zeroes);
        for(; it2 < size; ++it2)str += ALPHABET.charAt(b58[it2]);
        return str;
    }
    function decodeUnsafe(source) {
        if (typeof source !== 'string') throw new TypeError('Expected String');
        if (source.length === 0) return new Uint8Array();
        var psz = 0;
        // Skip and count leading '1's.
        var zeroes = 0;
        var length = 0;
        while(source[psz] === LEADER){
            zeroes++;
            psz++;
        }
        // Allocate enough space in big-endian base256 representation.
        var size = (source.length - psz) * FACTOR + 1 >>> 0 // log(58) / log(256), rounded up.
        ;
        var b256 = new Uint8Array(size);
        // Process the characters.
        while(source[psz]){
            // Find code of next character
            var charCode = source.charCodeAt(psz);
            // Base map can not be indexed using char code
            if (charCode > 255) return;
            // Decode character
            var carry = BASE_MAP[charCode];
            // Invalid character
            if (carry === 255) return;
            var i = 0;
            for(var it3 = size - 1; (carry !== 0 || i < length) && it3 !== -1; it3--, i++){
                carry += BASE * b256[it3] >>> 0;
                b256[it3] = carry % 256 >>> 0;
                carry = carry / 256 >>> 0;
            }
            if (carry !== 0) throw new Error('Non-zero carry');
            length = i;
            psz++;
        }
        // Skip leading zeroes in b256.
        var it4 = size - length;
        while(it4 !== size && b256[it4] === 0)it4++;
        var vch = new Uint8Array(zeroes + (size - it4));
        var j = zeroes;
        while(it4 !== size)vch[j++] = b256[it4++];
        return vch;
    }
    function decode(string) {
        var buffer = decodeUnsafe(string);
        if (buffer) return buffer;
        throw new Error('Non-base' + BASE + ' character');
    }
    return {
        encode: encode,
        decodeUnsafe: decodeUnsafe,
        decode: decode
    };
}
$001e77b0dfd1bf3d$exports = $001e77b0dfd1bf3d$var$base;


const $8b756b3b8ee97947$var$ALPHABET = '123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz';
$8b756b3b8ee97947$exports = $001e77b0dfd1bf3d$exports($8b756b3b8ee97947$var$ALPHABET);


$88ba304516094693$exports = function(checksumFn) {
    // Encode a buffer as a base58-check encoded string
    function encode(payload) {
        var payloadU8 = Uint8Array.from(payload);
        var checksum = checksumFn(payloadU8);
        var length = payloadU8.length + 4;
        var both = new Uint8Array(length);
        both.set(payloadU8, 0);
        both.set(checksum.subarray(0, 4), payloadU8.length);
        return $8b756b3b8ee97947$exports.encode(both, length);
    }
    function decodeRaw(buffer) {
        var payload = buffer.slice(0, -4);
        var checksum = buffer.slice(-4);
        var newChecksum = checksumFn(payload);
        if (checksum[0] ^ newChecksum[0] | checksum[1] ^ newChecksum[1] | checksum[2] ^ newChecksum[2] | checksum[3] ^ newChecksum[3]) return;
        return payload;
    }
    // Decode a base58-check encoded string to a buffer, no result if checksum is wrong
    function decodeUnsafe(string) {
        var buffer = $8b756b3b8ee97947$exports.decodeUnsafe(string);
        if (!buffer) return;
        return decodeRaw(buffer);
    }
    function decode(string) {
        var buffer = $8b756b3b8ee97947$exports.decode(string);
        var payload = decodeRaw(buffer, checksumFn);
        if (!payload) throw new Error('Invalid checksum');
        return payload;
    }
    return {
        encode: encode,
        decode: decode,
        decodeUnsafe: decodeUnsafe
    };
};


// SHA256(SHA256(buffer))
function $f953b6354166cf05$var$sha256x2(buffer) {
    return $f953b6354166cf05$require$sha256($f953b6354166cf05$require$sha256(buffer));
}
$f953b6354166cf05$exports = $88ba304516094693$exports($f953b6354166cf05$var$sha256x2);


const $dd4507bab065e34f$export$5a4d1aea49a3bbcd = (hexString)=>{
    if (hexString.length % 2 !== 0) throw new Error("Hex string must have an even length");
    const bytes = new Uint8Array(hexString.length / 2);
    for(let i = 0; i < hexString.length; i += 2)bytes[i >> 1] = parseInt(hexString.slice(i, i + 2), 16);
    return bytes;
};
const $dd4507bab065e34f$export$d4d5806f7c45a793 = (data)=>{
    return Array.from(data, (byte)=>byte.toString(16).padStart(2, "0")).join("");
};


const $73665c112ce7e927$export$9cbcb289502f5191 = "automerge:";
const $73665c112ce7e927$export$139eebd34d024bba = (url)=>{
    const [baseUrl, headsSection, ...rest] = url.split("#");
    if (rest.length > 0) throw new Error("Invalid URL: contains multiple heads sections");
    const regex = new RegExp(`^${$73665c112ce7e927$export$9cbcb289502f5191}(\\w+)$`);
    const [, docMatch] = baseUrl.match(regex) || [];
    const documentId = docMatch;
    const binaryDocumentId = $73665c112ce7e927$export$f8897a0881830d9c(documentId);
    if (!binaryDocumentId) throw new Error("Invalid document URL: " + url);
    if (headsSection === undefined) return {
        binaryDocumentId: binaryDocumentId,
        documentId: documentId
    };
    const heads = headsSection === "" ? [] : headsSection.split("|");
    const hexHeads = heads.map((head)=>{
        try {
            return (0, $dd4507bab065e34f$export$d4d5806f7c45a793)((0, (/*@__PURE__*/$parcel$interopDefault($f953b6354166cf05$exports))).decode(head));
        } catch (e) {
            throw new Error(`Invalid head in URL: ${head}`);
        }
    });
    return {
        binaryDocumentId: binaryDocumentId,
        hexHeads: hexHeads,
        documentId: documentId,
        heads: heads
    };
};
const $73665c112ce7e927$export$6d38e899e24621e1 = (arg)=>{
    if (arg instanceof Uint8Array || typeof arg === "string") return $73665c112ce7e927$export$9cbcb289502f5191 + (arg instanceof Uint8Array ? $73665c112ce7e927$export$ba6379d23c8aa3cc(arg) : arg);
    const { documentId: documentId, heads: heads } = arg;
    if (documentId === undefined) throw new Error("Invalid documentId: " + documentId);
    const encodedDocumentId = documentId instanceof Uint8Array ? $73665c112ce7e927$export$ba6379d23c8aa3cc(documentId) : documentId;
    let url = `${$73665c112ce7e927$export$9cbcb289502f5191}${encodedDocumentId}`;
    if (heads !== undefined) {
        heads.forEach((head)=>{
            try {
                (0, (/*@__PURE__*/$parcel$interopDefault($f953b6354166cf05$exports))).decode(head);
            } catch (e) {
                throw new Error(`Invalid head: ${head}`);
            }
        });
        url += "#" + heads.join("|");
    }
    return url;
};
const $73665c112ce7e927$export$d03f6bd302d67263 = (url)=>{
    const { heads: heads } = $73665c112ce7e927$export$139eebd34d024bba(url);
    return heads;
};
const $73665c112ce7e927$export$78f314971fdfe164 = (id)=>$73665c112ce7e927$export$3d350e89349f36dd(id) ? id : $73665c112ce7e927$export$5b92ee9ddd137740(id) ? $73665c112ce7e927$export$6d38e899e24621e1({
        documentId: id
    }) : $73665c112ce7e927$export$6ad459db9a6bcc76(id) ? $73665c112ce7e927$export$3ddb9cf0b930c85(id) : undefined;
const $73665c112ce7e927$export$3d350e89349f36dd = (str)=>{
    if (typeof str !== "string" || !str || !str.startsWith($73665c112ce7e927$export$9cbcb289502f5191)) return false;
    try {
        const { documentId: documentId, heads: heads } = $73665c112ce7e927$export$139eebd34d024bba(str);
        if (!$73665c112ce7e927$export$5b92ee9ddd137740(documentId)) return false;
        if (heads && !heads.every((head)=>{
            try {
                (0, (/*@__PURE__*/$parcel$interopDefault($f953b6354166cf05$exports))).decode(head);
                return true;
            } catch  {
                return false;
            }
        })) return false;
        return true;
    } catch  {
        return false;
    }
};
const $73665c112ce7e927$export$5b92ee9ddd137740 = (str)=>{
    if (typeof str !== "string") return false;
    // try to decode from base58
    const binaryDocumentID = $73665c112ce7e927$export$f8897a0881830d9c(str);
    return binaryDocumentID !== undefined;
};
const $73665c112ce7e927$export$6ad459db9a6bcc76 = (str)=>typeof str === "string" && $46d323206dcbf256$export$2e2bcd8739ae039(str);
const $73665c112ce7e927$export$a64c058c4a74ab18 = ()=>{
    const documentId = $3fa3ae484854b431$export$2e2bcd8739ae039(null, new Uint8Array(16));
    return $73665c112ce7e927$export$6d38e899e24621e1({
        documentId: documentId
    });
};
const $73665c112ce7e927$export$f8897a0881830d9c = (docId)=>(0, (/*@__PURE__*/$parcel$interopDefault($f953b6354166cf05$exports))).decodeUnsafe(docId);
const $73665c112ce7e927$export$ba6379d23c8aa3cc = (docId)=>(0, (/*@__PURE__*/$parcel$interopDefault($f953b6354166cf05$exports))).encode(docId);
const $73665c112ce7e927$export$5b2c9a3be6980e12 = (heads)=>heads.map((h)=>(0, (/*@__PURE__*/$parcel$interopDefault($f953b6354166cf05$exports))).encode((0, $dd4507bab065e34f$export$5a4d1aea49a3bbcd)(h)));
const $73665c112ce7e927$export$ebc2e4a21ab3cd04 = (heads)=>heads.map((h)=>(0, $dd4507bab065e34f$export$d4d5806f7c45a793)((0, (/*@__PURE__*/$parcel$interopDefault($f953b6354166cf05$exports))).decode(h)));
const $73665c112ce7e927$export$3ddb9cf0b930c85 = (str)=>{
    if (!$46d323206dcbf256$export$2e2bcd8739ae039(str)) return undefined;
    const documentId = $02f33e5afac044cb$export$2e2bcd8739ae039(str);
    return $73665c112ce7e927$export$6d38e899e24621e1({
        documentId: documentId
    });
};
const $73665c112ce7e927$export$c1f8c569cf258d73 = (id)=>{
    // binary
    if (id instanceof Uint8Array) return $73665c112ce7e927$export$ba6379d23c8aa3cc(id);
    // url
    if ($73665c112ce7e927$export$3d350e89349f36dd(id)) return $73665c112ce7e927$export$139eebd34d024bba(id).documentId;
    // base58check
    if ($73665c112ce7e927$export$5b92ee9ddd137740(id)) return id;
    // legacy UUID
    if ($73665c112ce7e927$export$6ad459db9a6bcc76(id)) {
        console.warn("Future versions will not support UUIDs as document IDs; use Automerge URLs instead.");
        const binaryDocumentID = $02f33e5afac044cb$export$2e2bcd8739ae039(id);
        return $73665c112ce7e927$export$ba6379d23c8aa3cc(binaryDocumentID);
    }
    // none of the above
    throw new Error(`Invalid AutomergeUrl: '${id}'`);
};


var $801768f2dbeea819$exports = {};

$parcel$export($801768f2dbeea819$exports, "encode", () => $801768f2dbeea819$export$c564cdbbe6da493);
$parcel$export($801768f2dbeea819$exports, "decode", () => $801768f2dbeea819$export$2f872c0f2117be69);
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $51861dfc7ca9d588$export$a143d493d941bafc;
var $51861dfc7ca9d588$export$e4cf37d7f6fb9e0a;
var $51861dfc7ca9d588$export$f99ded8fe4b79145;
var $51861dfc7ca9d588$export$599f31c3813fae4d;
'use strict';
var $eeb0961446aae8e3$export$a48f0734ac7c2329;
var $eeb0961446aae8e3$export$d622b2ad8d90c771;
var $eeb0961446aae8e3$export$6100ba28696e12de;
'use strict';
$eeb0961446aae8e3$export$a48f0734ac7c2329 = $eeb0961446aae8e3$var$byteLength;
$eeb0961446aae8e3$export$d622b2ad8d90c771 = $eeb0961446aae8e3$var$toByteArray;
$eeb0961446aae8e3$export$6100ba28696e12de = $eeb0961446aae8e3$var$fromByteArray;
var $eeb0961446aae8e3$var$lookup = [];
var $eeb0961446aae8e3$var$revLookup = [];
var $eeb0961446aae8e3$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $eeb0961446aae8e3$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $eeb0961446aae8e3$var$i = 0, $eeb0961446aae8e3$var$len = $eeb0961446aae8e3$var$code.length; $eeb0961446aae8e3$var$i < $eeb0961446aae8e3$var$len; ++$eeb0961446aae8e3$var$i){
    $eeb0961446aae8e3$var$lookup[$eeb0961446aae8e3$var$i] = $eeb0961446aae8e3$var$code[$eeb0961446aae8e3$var$i];
    $eeb0961446aae8e3$var$revLookup[$eeb0961446aae8e3$var$code.charCodeAt($eeb0961446aae8e3$var$i)] = $eeb0961446aae8e3$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$eeb0961446aae8e3$var$revLookup['-'.charCodeAt(0)] = 62;
$eeb0961446aae8e3$var$revLookup['_'.charCodeAt(0)] = 63;
function $eeb0961446aae8e3$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $eeb0961446aae8e3$var$byteLength(b64) {
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$toByteArray(b64) {
    var tmp;
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $eeb0961446aae8e3$var$Arr($eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 18 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 2 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 10 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $eeb0961446aae8e3$var$tripletToBase64(num) {
    return $eeb0961446aae8e3$var$lookup[num >> 18 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 12 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 6 & 0x3F] + $eeb0961446aae8e3$var$lookup[num & 0x3F];
}
function $eeb0961446aae8e3$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($eeb0961446aae8e3$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $eeb0961446aae8e3$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($eeb0961446aae8e3$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 2] + $eeb0961446aae8e3$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 10] + $eeb0961446aae8e3$var$lookup[tmp >> 4 & 0x3F] + $eeb0961446aae8e3$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}


/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $7221566bd4d49f44$export$aafa59e2e03f2942;
var $7221566bd4d49f44$export$68d8715fc104d294;
$7221566bd4d49f44$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$7221566bd4d49f44$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};


const $51861dfc7ca9d588$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$51861dfc7ca9d588$export$a143d493d941bafc = $51861dfc7ca9d588$var$Buffer;
$51861dfc7ca9d588$export$e4cf37d7f6fb9e0a = $51861dfc7ca9d588$var$SlowBuffer;
$51861dfc7ca9d588$export$f99ded8fe4b79145 = 50;
const $51861dfc7ca9d588$var$K_MAX_LENGTH = 0x7fffffff;
$51861dfc7ca9d588$export$599f31c3813fae4d = $51861dfc7ca9d588$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT = $51861dfc7ca9d588$var$typedArraySupport();
if (!$51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $51861dfc7ca9d588$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $51861dfc7ca9d588$var$createBuffer(length) {
    if (length > $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $51861dfc7ca9d588$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $51861dfc7ca9d588$var$allocUnsafe(arg);
    }
    return $51861dfc7ca9d588$var$from(arg, encodingOrOffset, length);
}
$51861dfc7ca9d588$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $51861dfc7ca9d588$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $51861dfc7ca9d588$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $51861dfc7ca9d588$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($51861dfc7ca9d588$var$isInstance(value, ArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, ArrayBuffer)) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($51861dfc7ca9d588$var$isInstance(value, SharedArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, SharedArrayBuffer))) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $51861dfc7ca9d588$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $51861dfc7ca9d588$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $51861dfc7ca9d588$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $51861dfc7ca9d588$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $51861dfc7ca9d588$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer, Uint8Array);
function $51861dfc7ca9d588$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $51861dfc7ca9d588$var$alloc(size, fill, encoding) {
    $51861dfc7ca9d588$var$assertSize(size);
    if (size <= 0) return $51861dfc7ca9d588$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $51861dfc7ca9d588$var$createBuffer(size).fill(fill, encoding) : $51861dfc7ca9d588$var$createBuffer(size).fill(fill);
    return $51861dfc7ca9d588$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $51861dfc7ca9d588$var$Buffer.alloc = function(size, fill, encoding) {
    return $51861dfc7ca9d588$var$alloc(size, fill, encoding);
};
function $51861dfc7ca9d588$var$allocUnsafe(size) {
    $51861dfc7ca9d588$var$assertSize(size);
    return $51861dfc7ca9d588$var$createBuffer(size < 0 ? 0 : $51861dfc7ca9d588$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $51861dfc7ca9d588$var$Buffer.allocUnsafe = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $51861dfc7ca9d588$var$Buffer.allocUnsafeSlow = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
function $51861dfc7ca9d588$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $51861dfc7ca9d588$var$byteLength(string, encoding) | 0;
    let buf = $51861dfc7ca9d588$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $51861dfc7ca9d588$var$checked(array.length) | 0;
    const buf = $51861dfc7ca9d588$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayView(arrayView) {
    if ($51861dfc7ca9d588$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $51861dfc7ca9d588$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $51861dfc7ca9d588$var$fromArrayLike(arrayView);
}
function $51861dfc7ca9d588$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
function $51861dfc7ca9d588$var$fromObject(obj) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(obj)) {
        const len = $51861dfc7ca9d588$var$checked(obj.length) | 0;
        const buf = $51861dfc7ca9d588$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $51861dfc7ca9d588$var$numberIsNaN(obj.length)) return $51861dfc7ca9d588$var$createBuffer(0);
        return $51861dfc7ca9d588$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $51861dfc7ca9d588$var$fromArrayLike(obj.data);
}
function $51861dfc7ca9d588$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $51861dfc7ca9d588$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $51861dfc7ca9d588$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $51861dfc7ca9d588$var$Buffer.alloc(+length);
}
$51861dfc7ca9d588$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $51861dfc7ca9d588$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$51861dfc7ca9d588$var$Buffer.compare = function compare(a, b) {
    if ($51861dfc7ca9d588$var$isInstance(a, Uint8Array)) a = $51861dfc7ca9d588$var$Buffer.from(a, a.offset, a.byteLength);
    if ($51861dfc7ca9d588$var$isInstance(b, Uint8Array)) b = $51861dfc7ca9d588$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(a) || !$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$51861dfc7ca9d588$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$51861dfc7ca9d588$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $51861dfc7ca9d588$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $51861dfc7ca9d588$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($51861dfc7ca9d588$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) buf = $51861dfc7ca9d588$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $51861dfc7ca9d588$var$byteLength(string, encoding) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $51861dfc7ca9d588$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $51861dfc7ca9d588$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $51861dfc7ca9d588$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$51861dfc7ca9d588$var$Buffer.byteLength = $51861dfc7ca9d588$var$byteLength;
function $51861dfc7ca9d588$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $51861dfc7ca9d588$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8Slice(this, start, end);
        case 'ascii':
            return $51861dfc7ca9d588$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $51861dfc7ca9d588$var$latin1Slice(this, start, end);
        case 'base64':
            return $51861dfc7ca9d588$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $51861dfc7ca9d588$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$51861dfc7ca9d588$var$Buffer.prototype._isBuffer = true;
function $51861dfc7ca9d588$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$51861dfc7ca9d588$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$51861dfc7ca9d588$var$swap(this, i, i + 1);
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $51861dfc7ca9d588$var$swap(this, i, i + 3);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $51861dfc7ca9d588$var$swap(this, i, i + 7);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 6);
        $51861dfc7ca9d588$var$swap(this, i + 2, i + 5);
        $51861dfc7ca9d588$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $51861dfc7ca9d588$var$utf8Slice(this, 0, length);
    return $51861dfc7ca9d588$var$slowToString.apply(this, arguments);
};
$51861dfc7ca9d588$var$Buffer.prototype.toLocaleString = $51861dfc7ca9d588$var$Buffer.prototype.toString;
$51861dfc7ca9d588$var$Buffer.prototype.equals = function equals(b) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $51861dfc7ca9d588$var$Buffer.compare(this, b) === 0;
};
$51861dfc7ca9d588$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $51861dfc7ca9d588$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($51861dfc7ca9d588$var$customInspectSymbol) $51861dfc7ca9d588$var$Buffer.prototype[$51861dfc7ca9d588$var$customInspectSymbol] = $51861dfc7ca9d588$var$Buffer.prototype.inspect;
$51861dfc7ca9d588$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($51861dfc7ca9d588$var$isInstance(target, Uint8Array)) target = $51861dfc7ca9d588$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $51861dfc7ca9d588$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($51861dfc7ca9d588$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $51861dfc7ca9d588$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $51861dfc7ca9d588$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$51861dfc7ca9d588$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$51861dfc7ca9d588$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $51861dfc7ca9d588$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($51861dfc7ca9d588$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $51861dfc7ca9d588$var$utf8Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $51861dfc7ca9d588$var$asciiWrite(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$asciiToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$base64Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$base64ToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$ucs2Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$51861dfc7ca9d588$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $51861dfc7ca9d588$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $51861dfc7ca9d588$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $51861dfc7ca9d588$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $51861dfc7ca9d588$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$51861dfc7ca9d588$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $51861dfc7ca9d588$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $eeb0961446aae8e3$export$6100ba28696e12de(buf);
    else return $eeb0961446aae8e3$export$6100ba28696e12de(buf.slice(start, end));
}
function $51861dfc7ca9d588$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $51861dfc7ca9d588$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $51861dfc7ca9d588$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $51861dfc7ca9d588$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $51861dfc7ca9d588$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $51861dfc7ca9d588$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $51861dfc7ca9d588$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $51861dfc7ca9d588$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$51861dfc7ca9d588$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $51861dfc7ca9d588$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $51861dfc7ca9d588$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$51861dfc7ca9d588$var$Buffer.prototype.readUintLE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUintBE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint8 = $51861dfc7ca9d588$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$51861dfc7ca9d588$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$51861dfc7ca9d588$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $7221566bd4d49f44$export$aafa59e2e03f2942(this, offset, true, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $7221566bd4d49f44$export$aafa59e2e03f2942(this, offset, false, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $7221566bd4d49f44$export$aafa59e2e03f2942(this, offset, true, 52, 8);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $7221566bd4d49f44$export$aafa59e2e03f2942(this, offset, false, 52, 8);
};
function $51861dfc7ca9d588$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$51861dfc7ca9d588$var$Buffer.prototype.writeUintLE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUintBE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint8 = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $51861dfc7ca9d588$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $51861dfc7ca9d588$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $51861dfc7ca9d588$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $7221566bd4d49f44$export$68d8715fc104d294(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, false, noAssert);
};
function $51861dfc7ca9d588$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $7221566bd4d49f44$export$68d8715fc104d294(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$51861dfc7ca9d588$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$51861dfc7ca9d588$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $51861dfc7ca9d588$var$Buffer.isBuffer(val) ? val : $51861dfc7ca9d588$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $51861dfc7ca9d588$var$errors = {};
function $51861dfc7ca9d588$var$E(sym, getMessage, Base) {
    $51861dfc7ca9d588$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$51861dfc7ca9d588$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$51861dfc7ca9d588$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$51861dfc7ca9d588$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $51861dfc7ca9d588$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $51861dfc7ca9d588$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $51861dfc7ca9d588$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength) {
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $51861dfc7ca9d588$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength);
}
function $51861dfc7ca9d588$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $51861dfc7ca9d588$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $51861dfc7ca9d588$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $51861dfc7ca9d588$var$validateNumber(value, type);
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $51861dfc7ca9d588$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $51861dfc7ca9d588$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $51861dfc7ca9d588$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($51861dfc7ca9d588$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $51861dfc7ca9d588$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $51861dfc7ca9d588$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $51861dfc7ca9d588$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $51861dfc7ca9d588$var$base64ToBytes(str) {
    return $eeb0961446aae8e3$export$d622b2ad8d90c771($51861dfc7ca9d588$var$base64clean(str));
}
function $51861dfc7ca9d588$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $51861dfc7ca9d588$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $51861dfc7ca9d588$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $51861dfc7ca9d588$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $51861dfc7ca9d588$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $51861dfc7ca9d588$var$BufferBigIntNotDefined : fn;
}
function $51861dfc7ca9d588$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}


var $fec591ea5a7df9ff$require$Buffer = $51861dfc7ca9d588$export$a143d493d941bafc;
let $fec591ea5a7df9ff$var$decoder;
try {
    $fec591ea5a7df9ff$var$decoder = new TextDecoder();
} catch (error) {}
let $fec591ea5a7df9ff$var$src;
let $fec591ea5a7df9ff$var$srcEnd;
let $fec591ea5a7df9ff$var$position = 0;
let $fec591ea5a7df9ff$var$alreadySet;
const $fec591ea5a7df9ff$var$EMPTY_ARRAY = [];
const $fec591ea5a7df9ff$var$LEGACY_RECORD_INLINE_ID = 105;
const $fec591ea5a7df9ff$var$RECORD_DEFINITIONS_ID = 0xdffe;
const $fec591ea5a7df9ff$var$RECORD_INLINE_ID = 0xdfff // temporary first-come first-serve tag // proposed tag: 0x7265 // 're'
;
const $fec591ea5a7df9ff$var$BUNDLED_STRINGS_ID = 0xdff9;
const $fec591ea5a7df9ff$var$PACKED_TABLE_TAG_ID = 51;
const $fec591ea5a7df9ff$var$PACKED_REFERENCE_TAG_ID = 6;
const $fec591ea5a7df9ff$var$STOP_CODE = {};
let $fec591ea5a7df9ff$var$maxArraySize = 112810000 // This is the maximum array size in V8. We would potentially detect and set it higher
;
// for JSC, but this is pretty large and should be sufficient for most use cases
let $fec591ea5a7df9ff$var$maxMapSize = 16810000 // JavaScript has a fixed maximum map size of about 16710000, but JS itself enforces this,
;
// so we don't need to
let $fec591ea5a7df9ff$var$maxObjectSize = 16710000; // This is the maximum number of keys in a Map. It takes over a minute to create this
// many keys in an object, so also probably a reasonable choice there.
let $fec591ea5a7df9ff$var$strings = $fec591ea5a7df9ff$var$EMPTY_ARRAY;
let $fec591ea5a7df9ff$var$stringPosition = 0;
let $fec591ea5a7df9ff$var$currentDecoder = {};
let $fec591ea5a7df9ff$var$currentStructures;
let $fec591ea5a7df9ff$var$srcString;
let $fec591ea5a7df9ff$var$srcStringStart = 0;
let $fec591ea5a7df9ff$var$srcStringEnd = 0;
let $fec591ea5a7df9ff$var$bundledStrings;
let $fec591ea5a7df9ff$var$referenceMap;
let $fec591ea5a7df9ff$var$currentExtensions = [];
let $fec591ea5a7df9ff$var$currentExtensionRanges = [];
let $fec591ea5a7df9ff$var$packedValues;
let $fec591ea5a7df9ff$var$dataView;
let $fec591ea5a7df9ff$var$restoreMapsAsObject;
let $fec591ea5a7df9ff$var$defaultOptions = {
    useRecords: false,
    mapsAsObjects: true
};
let $fec591ea5a7df9ff$var$sequentialMode = false;
let $fec591ea5a7df9ff$var$inlineObjectReadThreshold = 2;
var $fec591ea5a7df9ff$var$BlockedFunction // we use search and replace to change the next call to BlockedFunction to avoid CSP issues for
;
// no-eval build
try {
    new Function('');
} catch (error) {
    // if eval variants are not supported, do not create inline object readers ever
    $fec591ea5a7df9ff$var$inlineObjectReadThreshold = Infinity;
}
class $fec591ea5a7df9ff$export$f9de6ca0bc043724 {
    constructor(options){
        if (options) {
            if ((options.keyMap || options._keyMap) && !options.useRecords) {
                options.useRecords = false;
                options.mapsAsObjects = true;
            }
            if (options.useRecords === false && options.mapsAsObjects === undefined) options.mapsAsObjects = true;
            if (options.getStructures) options.getShared = options.getStructures;
            if (options.getShared && !options.structures) (options.structures = []).uninitialized = true // this is what we use to denote an uninitialized structures
            ;
            if (options.keyMap) {
                this.mapKey = new Map();
                for (let [k, v] of Object.entries(options.keyMap))this.mapKey.set(v, k);
            }
        }
        Object.assign(this, options);
    }
    /*
	decodeKey(key) {
		return this.keyMap
			? Object.keys(this.keyMap)[Object.values(this.keyMap).indexOf(key)] || key
			: key
	}
	*/ decodeKey(key) {
        return this.keyMap ? this.mapKey.get(key) || key : key;
    }
    encodeKey(key) {
        return this.keyMap && this.keyMap.hasOwnProperty(key) ? this.keyMap[key] : key;
    }
    encodeKeys(rec) {
        if (!this._keyMap) return rec;
        let map = new Map();
        for (let [k, v] of Object.entries(rec))map.set(this._keyMap.hasOwnProperty(k) ? this._keyMap[k] : k, v);
        return map;
    }
    decodeKeys(map) {
        if (!this._keyMap || map.constructor.name != 'Map') return map;
        if (!this._mapKey) {
            this._mapKey = new Map();
            for (let [k, v] of Object.entries(this._keyMap))this._mapKey.set(v, k);
        }
        let res = {};
        //map.forEach((v,k) => res[Object.keys(this._keyMap)[Object.values(this._keyMap).indexOf(k)] || k] = v)
        map.forEach((v, k)=>res[$fec591ea5a7df9ff$var$safeKey(this._mapKey.has(k) ? this._mapKey.get(k) : k)] = v);
        return res;
    }
    mapDecode(source, end) {
        let res = this.decode(source);
        if (this._keyMap) //Experiemntal support for Optimised KeyMap  decoding 
        switch(res.constructor.name){
            case 'Array':
                return res.map((r)=>this.decodeKeys(r));
        }
        return res;
    }
    decode(source, end) {
        if ($fec591ea5a7df9ff$var$src) // re-entrant execution, save the state and restore it after we do this decode
        return $fec591ea5a7df9ff$var$saveState(()=>{
            $fec591ea5a7df9ff$export$e6f020404d5b6c15();
            return this ? this.decode(source, end) : $fec591ea5a7df9ff$export$f9de6ca0bc043724.prototype.decode.call($fec591ea5a7df9ff$var$defaultOptions, source, end);
        });
        $fec591ea5a7df9ff$var$srcEnd = end > -1 ? end : source.length;
        $fec591ea5a7df9ff$var$position = 0;
        $fec591ea5a7df9ff$var$stringPosition = 0;
        $fec591ea5a7df9ff$var$srcStringEnd = 0;
        $fec591ea5a7df9ff$var$srcString = null;
        $fec591ea5a7df9ff$var$strings = $fec591ea5a7df9ff$var$EMPTY_ARRAY;
        $fec591ea5a7df9ff$var$bundledStrings = null;
        $fec591ea5a7df9ff$var$src = source;
        // this provides cached access to the data view for a buffer if it is getting reused, which is a recommend
        // technique for getting data from a database where it can be copied into an existing buffer instead of creating
        // new ones
        try {
            $fec591ea5a7df9ff$var$dataView = source.dataView || (source.dataView = new DataView(source.buffer, source.byteOffset, source.byteLength));
        } catch (error) {
            // if it doesn't have a buffer, maybe it is the wrong type of object
            $fec591ea5a7df9ff$var$src = null;
            if (source instanceof Uint8Array) throw error;
            throw new Error('Source must be a Uint8Array or Buffer but was a ' + (source && typeof source == 'object' ? source.constructor.name : typeof source));
        }
        if (this instanceof $fec591ea5a7df9ff$export$f9de6ca0bc043724) {
            $fec591ea5a7df9ff$var$currentDecoder = this;
            $fec591ea5a7df9ff$var$packedValues = this.sharedValues && (this.pack ? new Array(this.maxPrivatePackedValues || 16).concat(this.sharedValues) : this.sharedValues);
            if (this.structures) {
                $fec591ea5a7df9ff$var$currentStructures = this.structures;
                return $fec591ea5a7df9ff$export$8cb90b5f58dd32e2();
            } else if (!$fec591ea5a7df9ff$var$currentStructures || $fec591ea5a7df9ff$var$currentStructures.length > 0) $fec591ea5a7df9ff$var$currentStructures = [];
        } else {
            $fec591ea5a7df9ff$var$currentDecoder = $fec591ea5a7df9ff$var$defaultOptions;
            if (!$fec591ea5a7df9ff$var$currentStructures || $fec591ea5a7df9ff$var$currentStructures.length > 0) $fec591ea5a7df9ff$var$currentStructures = [];
            $fec591ea5a7df9ff$var$packedValues = null;
        }
        return $fec591ea5a7df9ff$export$8cb90b5f58dd32e2();
    }
    decodeMultiple(source, forEach) {
        let values, lastPosition = 0;
        try {
            let size = source.length;
            $fec591ea5a7df9ff$var$sequentialMode = true;
            let value = this ? this.decode(source, size) : $fec591ea5a7df9ff$var$defaultDecoder.decode(source, size);
            if (forEach) {
                if (forEach(value) === false) return;
                while($fec591ea5a7df9ff$var$position < size){
                    lastPosition = $fec591ea5a7df9ff$var$position;
                    if (forEach($fec591ea5a7df9ff$export$8cb90b5f58dd32e2()) === false) return;
                }
            } else {
                values = [
                    value
                ];
                while($fec591ea5a7df9ff$var$position < size){
                    lastPosition = $fec591ea5a7df9ff$var$position;
                    values.push($fec591ea5a7df9ff$export$8cb90b5f58dd32e2());
                }
                return values;
            }
        } catch (error) {
            error.lastPosition = lastPosition;
            error.values = values;
            throw error;
        } finally{
            $fec591ea5a7df9ff$var$sequentialMode = false;
            $fec591ea5a7df9ff$export$e6f020404d5b6c15();
        }
    }
}
function $fec591ea5a7df9ff$export$1690e12b840569b9() {
    return $fec591ea5a7df9ff$var$position;
}
function $fec591ea5a7df9ff$export$8cb90b5f58dd32e2() {
    try {
        let result = $fec591ea5a7df9ff$export$aafa59e2e03f2942();
        if ($fec591ea5a7df9ff$var$bundledStrings) {
            if ($fec591ea5a7df9ff$var$position >= $fec591ea5a7df9ff$var$bundledStrings.postBundlePosition) {
                let error = new Error('Unexpected bundle position');
                error.incomplete = true;
                throw error;
            }
            // bundled strings to skip past
            $fec591ea5a7df9ff$var$position = $fec591ea5a7df9ff$var$bundledStrings.postBundlePosition;
            $fec591ea5a7df9ff$var$bundledStrings = null;
        }
        if ($fec591ea5a7df9ff$var$position == $fec591ea5a7df9ff$var$srcEnd) {
            // finished reading this source, cleanup references
            $fec591ea5a7df9ff$var$currentStructures = null;
            $fec591ea5a7df9ff$var$src = null;
            if ($fec591ea5a7df9ff$var$referenceMap) $fec591ea5a7df9ff$var$referenceMap = null;
        } else if ($fec591ea5a7df9ff$var$position > $fec591ea5a7df9ff$var$srcEnd) {
            // over read
            let error = new Error('Unexpected end of CBOR data');
            error.incomplete = true;
            throw error;
        } else if (!$fec591ea5a7df9ff$var$sequentialMode) throw new Error('Data read, but end of buffer not reached');
        // else more to read, but we are reading sequentially, so don't clear source yet
        return result;
    } catch (error) {
        $fec591ea5a7df9ff$export$e6f020404d5b6c15();
        if (error instanceof RangeError || error.message.startsWith('Unexpected end of buffer')) error.incomplete = true;
        throw error;
    }
}
function $fec591ea5a7df9ff$export$aafa59e2e03f2942() {
    let token = $fec591ea5a7df9ff$var$src[$fec591ea5a7df9ff$var$position++];
    let majorType = token >> 5;
    token = token & 0x1f;
    if (token > 0x17) switch(token){
        case 0x18:
            token = $fec591ea5a7df9ff$var$src[$fec591ea5a7df9ff$var$position++];
            break;
        case 0x19:
            if (majorType == 7) return $fec591ea5a7df9ff$var$getFloat16();
            token = $fec591ea5a7df9ff$var$dataView.getUint16($fec591ea5a7df9ff$var$position);
            $fec591ea5a7df9ff$var$position += 2;
            break;
        case 0x1a:
            if (majorType == 7) {
                let value = $fec591ea5a7df9ff$var$dataView.getFloat32($fec591ea5a7df9ff$var$position);
                if ($fec591ea5a7df9ff$var$currentDecoder.useFloat32 > 2) {
                    // this does rounding of numbers that were encoded in 32-bit float to nearest significant decimal digit that could be preserved
                    let multiplier = $fec591ea5a7df9ff$export$c652a5bbb6be7a36[($fec591ea5a7df9ff$var$src[$fec591ea5a7df9ff$var$position] & 0x7f) << 1 | $fec591ea5a7df9ff$var$src[$fec591ea5a7df9ff$var$position + 1] >> 7];
                    $fec591ea5a7df9ff$var$position += 4;
                    return (multiplier * value + (value > 0 ? 0.5 : -0.5) >> 0) / multiplier;
                }
                $fec591ea5a7df9ff$var$position += 4;
                return value;
            }
            token = $fec591ea5a7df9ff$var$dataView.getUint32($fec591ea5a7df9ff$var$position);
            $fec591ea5a7df9ff$var$position += 4;
            if (majorType === 1) return -1 - token; // can't safely use negation operator here
            break;
        case 0x1b:
            if (majorType == 7) {
                let value = $fec591ea5a7df9ff$var$dataView.getFloat64($fec591ea5a7df9ff$var$position);
                $fec591ea5a7df9ff$var$position += 8;
                return value;
            }
            if (majorType > 1) {
                if ($fec591ea5a7df9ff$var$dataView.getUint32($fec591ea5a7df9ff$var$position) > 0) throw new Error('JavaScript does not support arrays, maps, or strings with length over 4294967295');
                token = $fec591ea5a7df9ff$var$dataView.getUint32($fec591ea5a7df9ff$var$position + 4);
            } else if ($fec591ea5a7df9ff$var$currentDecoder.int64AsNumber) {
                token = $fec591ea5a7df9ff$var$dataView.getUint32($fec591ea5a7df9ff$var$position) * 0x100000000;
                token += $fec591ea5a7df9ff$var$dataView.getUint32($fec591ea5a7df9ff$var$position + 4);
            } else token = $fec591ea5a7df9ff$var$dataView.getBigUint64($fec591ea5a7df9ff$var$position);
            $fec591ea5a7df9ff$var$position += 8;
            break;
        case 0x1f:
            // indefinite length
            switch(majorType){
                case 2:
                case 3:
                    throw new Error('Indefinite length not supported for byte or text strings');
                case 4:
                    let array = [];
                    let value, i = 0;
                    while((value = $fec591ea5a7df9ff$export$aafa59e2e03f2942()) != $fec591ea5a7df9ff$var$STOP_CODE){
                        if (i >= $fec591ea5a7df9ff$var$maxArraySize) throw new Error(`Array length exceeds ${$fec591ea5a7df9ff$var$maxArraySize}`);
                        array[i++] = value;
                    }
                    return majorType == 4 ? array : majorType == 3 ? array.join('') : $fec591ea5a7df9ff$require$Buffer.concat(array);
                case 5:
                    let key;
                    if ($fec591ea5a7df9ff$var$currentDecoder.mapsAsObjects) {
                        let object = {};
                        let i = 0;
                        if ($fec591ea5a7df9ff$var$currentDecoder.keyMap) while((key = $fec591ea5a7df9ff$export$aafa59e2e03f2942()) != $fec591ea5a7df9ff$var$STOP_CODE){
                            if (i++ >= $fec591ea5a7df9ff$var$maxMapSize) throw new Error(`Property count exceeds ${$fec591ea5a7df9ff$var$maxMapSize}`);
                            object[$fec591ea5a7df9ff$var$safeKey($fec591ea5a7df9ff$var$currentDecoder.decodeKey(key))] = $fec591ea5a7df9ff$export$aafa59e2e03f2942();
                        }
                        else while((key = $fec591ea5a7df9ff$export$aafa59e2e03f2942()) != $fec591ea5a7df9ff$var$STOP_CODE){
                            if (i++ >= $fec591ea5a7df9ff$var$maxMapSize) throw new Error(`Property count exceeds ${$fec591ea5a7df9ff$var$maxMapSize}`);
                            object[$fec591ea5a7df9ff$var$safeKey(key)] = $fec591ea5a7df9ff$export$aafa59e2e03f2942();
                        }
                        return object;
                    } else {
                        if ($fec591ea5a7df9ff$var$restoreMapsAsObject) {
                            $fec591ea5a7df9ff$var$currentDecoder.mapsAsObjects = true;
                            $fec591ea5a7df9ff$var$restoreMapsAsObject = false;
                        }
                        let map = new Map();
                        if ($fec591ea5a7df9ff$var$currentDecoder.keyMap) {
                            let i = 0;
                            while((key = $fec591ea5a7df9ff$export$aafa59e2e03f2942()) != $fec591ea5a7df9ff$var$STOP_CODE){
                                if (i++ >= $fec591ea5a7df9ff$var$maxMapSize) throw new Error(`Map size exceeds ${$fec591ea5a7df9ff$var$maxMapSize}`);
                                map.set($fec591ea5a7df9ff$var$currentDecoder.decodeKey(key), $fec591ea5a7df9ff$export$aafa59e2e03f2942());
                            }
                        } else {
                            let i = 0;
                            while((key = $fec591ea5a7df9ff$export$aafa59e2e03f2942()) != $fec591ea5a7df9ff$var$STOP_CODE){
                                if (i++ >= $fec591ea5a7df9ff$var$maxMapSize) throw new Error(`Map size exceeds ${$fec591ea5a7df9ff$var$maxMapSize}`);
                                map.set(key, $fec591ea5a7df9ff$export$aafa59e2e03f2942());
                            }
                        }
                        return map;
                    }
                case 7:
                    return $fec591ea5a7df9ff$var$STOP_CODE;
                default:
                    throw new Error('Invalid major type for indefinite length ' + majorType);
            }
        default:
            throw new Error('Unknown token ' + token);
    }
    switch(majorType){
        case 0:
            return token;
        case 1:
            return ~token;
        case 2:
            return $fec591ea5a7df9ff$var$readBin(token);
        case 3:
            if ($fec591ea5a7df9ff$var$srcStringEnd >= $fec591ea5a7df9ff$var$position) return $fec591ea5a7df9ff$var$srcString.slice($fec591ea5a7df9ff$var$position - $fec591ea5a7df9ff$var$srcStringStart, ($fec591ea5a7df9ff$var$position += token) - $fec591ea5a7df9ff$var$srcStringStart);
            if ($fec591ea5a7df9ff$var$srcStringEnd == 0 && $fec591ea5a7df9ff$var$srcEnd < 140 && token < 32) {
                // for small blocks, avoiding the overhead of the extract call is helpful
                let string = token < 16 ? $fec591ea5a7df9ff$var$shortStringInJS(token) : $fec591ea5a7df9ff$var$longStringInJS(token);
                if (string != null) return string;
            }
            return $fec591ea5a7df9ff$var$readFixedString(token);
        case 4:
            if (token >= $fec591ea5a7df9ff$var$maxArraySize) throw new Error(`Array length exceeds ${$fec591ea5a7df9ff$var$maxArraySize}`);
            let array1 = new Array(token);
            //if (currentDecoder.keyMap) for (let i = 0; i < token; i++) array[i] = currentDecoder.decodeKey(read())	
            //else 
            for(let i = 0; i < token; i++)array1[i] = $fec591ea5a7df9ff$export$aafa59e2e03f2942();
            return array1;
        case 5:
            if (token >= $fec591ea5a7df9ff$var$maxMapSize) throw new Error(`Map size exceeds ${$fec591ea5a7df9ff$var$maxArraySize}`);
            if ($fec591ea5a7df9ff$var$currentDecoder.mapsAsObjects) {
                let object = {};
                if ($fec591ea5a7df9ff$var$currentDecoder.keyMap) for(let i = 0; i < token; i++)object[$fec591ea5a7df9ff$var$safeKey($fec591ea5a7df9ff$var$currentDecoder.decodeKey($fec591ea5a7df9ff$export$aafa59e2e03f2942()))] = $fec591ea5a7df9ff$export$aafa59e2e03f2942();
                else for(let i = 0; i < token; i++)object[$fec591ea5a7df9ff$var$safeKey($fec591ea5a7df9ff$export$aafa59e2e03f2942())] = $fec591ea5a7df9ff$export$aafa59e2e03f2942();
                return object;
            } else {
                if ($fec591ea5a7df9ff$var$restoreMapsAsObject) {
                    $fec591ea5a7df9ff$var$currentDecoder.mapsAsObjects = true;
                    $fec591ea5a7df9ff$var$restoreMapsAsObject = false;
                }
                let map = new Map();
                if ($fec591ea5a7df9ff$var$currentDecoder.keyMap) for(let i = 0; i < token; i++)map.set($fec591ea5a7df9ff$var$currentDecoder.decodeKey($fec591ea5a7df9ff$export$aafa59e2e03f2942()), $fec591ea5a7df9ff$export$aafa59e2e03f2942());
                else for(let i = 0; i < token; i++)map.set($fec591ea5a7df9ff$export$aafa59e2e03f2942(), $fec591ea5a7df9ff$export$aafa59e2e03f2942());
                return map;
            }
        case 6:
            if (token >= $fec591ea5a7df9ff$var$BUNDLED_STRINGS_ID) {
                let structure = $fec591ea5a7df9ff$var$currentStructures[token & 0x1fff] // check record structures first
                ;
                // At some point we may provide an option for dynamic tag assignment with a range like token >= 8 && (token < 16 || (token > 0x80 && token < 0xc0) || (token > 0x130 && token < 0x4000))
                if (structure) {
                    if (!structure.read) structure.read = $fec591ea5a7df9ff$var$createStructureReader(structure);
                    return structure.read();
                }
                if (token < 0x10000) {
                    if (token == $fec591ea5a7df9ff$var$RECORD_INLINE_ID) {
                        // currentExtensions as densely stored array (v8 stores arrays densely under about 3000 elements)
                        let length = $fec591ea5a7df9ff$var$readJustLength();
                        let id = $fec591ea5a7df9ff$export$aafa59e2e03f2942();
                        let structure = $fec591ea5a7df9ff$export$aafa59e2e03f2942();
                        $fec591ea5a7df9ff$var$recordDefinition(id, structure);
                        let object = {};
                        if ($fec591ea5a7df9ff$var$currentDecoder.keyMap) for(let i = 2; i < length; i++){
                            let key = $fec591ea5a7df9ff$var$currentDecoder.decodeKey(structure[i - 2]);
                            object[$fec591ea5a7df9ff$var$safeKey(key)] = $fec591ea5a7df9ff$export$aafa59e2e03f2942();
                        }
                        else for(let i = 2; i < length; i++){
                            let key = structure[i - 2];
                            object[$fec591ea5a7df9ff$var$safeKey(key)] = $fec591ea5a7df9ff$export$aafa59e2e03f2942();
                        }
                        return object;
                    } else if (token == $fec591ea5a7df9ff$var$RECORD_DEFINITIONS_ID) {
                        let length = $fec591ea5a7df9ff$var$readJustLength();
                        let id = $fec591ea5a7df9ff$export$aafa59e2e03f2942();
                        for(let i = 2; i < length; i++)$fec591ea5a7df9ff$var$recordDefinition(id++, $fec591ea5a7df9ff$export$aafa59e2e03f2942());
                        return $fec591ea5a7df9ff$export$aafa59e2e03f2942();
                    } else if (token == $fec591ea5a7df9ff$var$BUNDLED_STRINGS_ID) return $fec591ea5a7df9ff$var$readBundleExt();
                    if ($fec591ea5a7df9ff$var$currentDecoder.getShared) {
                        $fec591ea5a7df9ff$var$loadShared();
                        structure = $fec591ea5a7df9ff$var$currentStructures[token & 0x1fff];
                        if (structure) {
                            if (!structure.read) structure.read = $fec591ea5a7df9ff$var$createStructureReader(structure);
                            return structure.read();
                        }
                    }
                }
            }
            let extension = $fec591ea5a7df9ff$var$currentExtensions[token];
            if (extension) {
                if (extension.handlesRead) return extension($fec591ea5a7df9ff$export$aafa59e2e03f2942);
                else return extension($fec591ea5a7df9ff$export$aafa59e2e03f2942());
            } else {
                let input = $fec591ea5a7df9ff$export$aafa59e2e03f2942();
                for(let i = 0; i < $fec591ea5a7df9ff$var$currentExtensionRanges.length; i++){
                    let value = $fec591ea5a7df9ff$var$currentExtensionRanges[i](token, input);
                    if (value !== undefined) return value;
                }
                return new $fec591ea5a7df9ff$export$3288d34c523a1192(input, token);
            }
        case 7:
            switch(token){
                case 0x14:
                    return false;
                case 0x15:
                    return true;
                case 0x16:
                    return null;
                case 0x17:
                    return; // undefined
                case 0x1f:
                default:
                    let packedValue = ($fec591ea5a7df9ff$var$packedValues || $fec591ea5a7df9ff$var$getPackedValues())[token];
                    if (packedValue !== undefined) return packedValue;
                    throw new Error('Unknown token ' + token);
            }
        default:
            if (isNaN(token)) {
                let error = new Error('Unexpected end of CBOR data');
                error.incomplete = true;
                throw error;
            }
            throw new Error('Unknown CBOR token ' + token);
    }
}
const $fec591ea5a7df9ff$var$validName = /^[a-zA-Z_$][a-zA-Z\d_$]*$/;
function $fec591ea5a7df9ff$var$createStructureReader(structure) {
    if (!structure) throw new Error('Structure is required in record definition');
    function readObject() {
        // get the array size from the header
        let length = $fec591ea5a7df9ff$var$src[$fec591ea5a7df9ff$var$position++];
        //let majorType = token >> 5
        length = length & 0x1f;
        if (length > 0x17) switch(length){
            case 0x18:
                length = $fec591ea5a7df9ff$var$src[$fec591ea5a7df9ff$var$position++];
                break;
            case 0x19:
                length = $fec591ea5a7df9ff$var$dataView.getUint16($fec591ea5a7df9ff$var$position);
                $fec591ea5a7df9ff$var$position += 2;
                break;
            case 0x1a:
                length = $fec591ea5a7df9ff$var$dataView.getUint32($fec591ea5a7df9ff$var$position);
                $fec591ea5a7df9ff$var$position += 4;
                break;
            default:
                throw new Error('Expected array header, but got ' + $fec591ea5a7df9ff$var$src[$fec591ea5a7df9ff$var$position - 1]);
        }
        // This initial function is quick to instantiate, but runs slower. After several iterations pay the cost to build the faster function
        let compiledReader = this.compiledReader // first look to see if we have the fast compiled function
        ;
        while(compiledReader){
            // we have a fast compiled object literal reader
            if (compiledReader.propertyCount === length) return compiledReader($fec591ea5a7df9ff$export$aafa59e2e03f2942) // with the right length, so we use it
            ;
            compiledReader = compiledReader.next // see if there is another reader with the right length
            ;
        }
        if (this.slowReads++ >= $fec591ea5a7df9ff$var$inlineObjectReadThreshold) {
            let array = this.length == length ? this : this.slice(0, length);
            compiledReader = $fec591ea5a7df9ff$var$currentDecoder.keyMap ? new Function('r', 'return {' + array.map((k)=>$fec591ea5a7df9ff$var$currentDecoder.decodeKey(k)).map((k)=>$fec591ea5a7df9ff$var$validName.test(k) ? $fec591ea5a7df9ff$var$safeKey(k) + ':r()' : '[' + JSON.stringify(k) + ']:r()').join(',') + '}') : new Function('r', 'return {' + array.map((key)=>$fec591ea5a7df9ff$var$validName.test(key) ? $fec591ea5a7df9ff$var$safeKey(key) + ':r()' : '[' + JSON.stringify(key) + ']:r()').join(',') + '}');
            if (this.compiledReader) compiledReader.next = this.compiledReader // if there is an existing one, we store multiple readers as a linked list because it is usually pretty rare to have multiple readers (of different length) for the same structure
            ;
            compiledReader.propertyCount = length;
            this.compiledReader = compiledReader;
            return compiledReader($fec591ea5a7df9ff$export$aafa59e2e03f2942);
        }
        let object = {};
        if ($fec591ea5a7df9ff$var$currentDecoder.keyMap) for(let i = 0; i < length; i++)object[$fec591ea5a7df9ff$var$safeKey($fec591ea5a7df9ff$var$currentDecoder.decodeKey(this[i]))] = $fec591ea5a7df9ff$export$aafa59e2e03f2942();
        else for(let i = 0; i < length; i++)object[$fec591ea5a7df9ff$var$safeKey(this[i])] = $fec591ea5a7df9ff$export$aafa59e2e03f2942();
        return object;
    }
    structure.slowReads = 0;
    return readObject;
}
function $fec591ea5a7df9ff$var$safeKey(key) {
    // protect against prototype pollution
    if (typeof key === 'string') return key === '__proto__' ? '__proto_' : key;
    if (typeof key === 'number' || typeof key === 'boolean' || typeof key === 'bigint') return key.toString();
    if (key == null) return key + '';
    // protect against expensive (DoS) string conversions
    throw new Error('Invalid property name type ' + typeof key);
}
let $fec591ea5a7df9ff$var$readFixedString = $fec591ea5a7df9ff$var$readStringJS;
let $fec591ea5a7df9ff$var$readString8 = $fec591ea5a7df9ff$var$readStringJS;
let $fec591ea5a7df9ff$var$readString16 = $fec591ea5a7df9ff$var$readStringJS;
let $fec591ea5a7df9ff$var$readString32 = $fec591ea5a7df9ff$var$readStringJS;
let $fec591ea5a7df9ff$export$ae7c2166c4fa454a = false;
function $fec591ea5a7df9ff$export$b9cf06aee99126ca(extractStrings) {
    $fec591ea5a7df9ff$export$ae7c2166c4fa454a = true;
    $fec591ea5a7df9ff$var$readFixedString = readString(1);
    $fec591ea5a7df9ff$var$readString8 = readString(2);
    $fec591ea5a7df9ff$var$readString16 = readString(3);
    $fec591ea5a7df9ff$var$readString32 = readString(5);
    function readString(headerLength) {
        return function readString(length) {
            let string = $fec591ea5a7df9ff$var$strings[$fec591ea5a7df9ff$var$stringPosition++];
            if (string == null) {
                if ($fec591ea5a7df9ff$var$bundledStrings) return $fec591ea5a7df9ff$var$readStringJS(length);
                let extraction = extractStrings($fec591ea5a7df9ff$var$position, $fec591ea5a7df9ff$var$srcEnd, length, $fec591ea5a7df9ff$var$src);
                if (typeof extraction == 'string') {
                    string = extraction;
                    $fec591ea5a7df9ff$var$strings = $fec591ea5a7df9ff$var$EMPTY_ARRAY;
                } else {
                    $fec591ea5a7df9ff$var$strings = extraction;
                    $fec591ea5a7df9ff$var$stringPosition = 1;
                    $fec591ea5a7df9ff$var$srcStringEnd = 1 // even if a utf-8 string was decoded, must indicate we are in the midst of extracted strings and can't skip strings
                    ;
                    string = $fec591ea5a7df9ff$var$strings[0];
                    if (string === undefined) throw new Error('Unexpected end of buffer');
                }
            }
            let srcStringLength = string.length;
            if (srcStringLength <= length) {
                $fec591ea5a7df9ff$var$position += length;
                return string;
            }
            $fec591ea5a7df9ff$var$srcString = string;
            $fec591ea5a7df9ff$var$srcStringStart = $fec591ea5a7df9ff$var$position;
            $fec591ea5a7df9ff$var$srcStringEnd = $fec591ea5a7df9ff$var$position + srcStringLength;
            $fec591ea5a7df9ff$var$position += length;
            return string.slice(0, length) // we know we just want the beginning
            ;
        };
    }
}
function $fec591ea5a7df9ff$var$readStringJS(length) {
    let result;
    if (length < 16) {
        if (result = $fec591ea5a7df9ff$var$shortStringInJS(length)) return result;
    }
    if (length > 64 && $fec591ea5a7df9ff$var$decoder) return $fec591ea5a7df9ff$var$decoder.decode($fec591ea5a7df9ff$var$src.subarray($fec591ea5a7df9ff$var$position, $fec591ea5a7df9ff$var$position += length));
    const end = $fec591ea5a7df9ff$var$position + length;
    const units = [];
    result = '';
    while($fec591ea5a7df9ff$var$position < end){
        const byte1 = $fec591ea5a7df9ff$var$src[$fec591ea5a7df9ff$var$position++];
        if ((byte1 & 0x80) === 0) // 1 byte
        units.push(byte1);
        else if ((byte1 & 0xe0) === 0xc0) {
            // 2 bytes
            const byte2 = $fec591ea5a7df9ff$var$src[$fec591ea5a7df9ff$var$position++] & 0x3f;
            const codePoint = (byte1 & 0x1f) << 6 | byte2;
            // Reject overlong encoding: 2-byte sequences must encode values >= 0x80
            if (codePoint < 0x80) units.push(0xFFFD) // replacement character
            ;
            else units.push(codePoint);
        } else if ((byte1 & 0xf0) === 0xe0) {
            // 3 bytes
            const byte2 = $fec591ea5a7df9ff$var$src[$fec591ea5a7df9ff$var$position++] & 0x3f;
            const byte3 = $fec591ea5a7df9ff$var$src[$fec591ea5a7df9ff$var$position++] & 0x3f;
            const codePoint = (byte1 & 0x1f) << 12 | byte2 << 6 | byte3;
            // Reject overlong encoding: 3-byte sequences must encode values >= 0x800
            // Also reject surrogates (0xD800-0xDFFF)
            if (codePoint < 0x800 || codePoint >= 0xD800 && codePoint <= 0xDFFF) units.push(0xFFFD) // replacement character
            ;
            else units.push(codePoint);
        } else if ((byte1 & 0xf8) === 0xf0) {
            // 4 bytes
            const byte2 = $fec591ea5a7df9ff$var$src[$fec591ea5a7df9ff$var$position++] & 0x3f;
            const byte3 = $fec591ea5a7df9ff$var$src[$fec591ea5a7df9ff$var$position++] & 0x3f;
            const byte4 = $fec591ea5a7df9ff$var$src[$fec591ea5a7df9ff$var$position++] & 0x3f;
            let unit = (byte1 & 0x07) << 0x12 | byte2 << 0x0c | byte3 << 0x06 | byte4;
            // Reject overlong encoding: 4-byte sequences must encode values >= 0x10000
            // Also reject values > 0x10FFFF (maximum valid Unicode)
            if (unit < 0x10000 || unit > 0x10FFFF) units.push(0xFFFD) // replacement character
            ;
            else if (unit > 0xffff) {
                unit -= 0x10000;
                units.push(unit >>> 10 & 0x3ff | 0xd800);
                unit = 0xdc00 | unit & 0x3ff;
                units.push(unit);
            } else units.push(unit);
        } else units.push(0xFFFD) // replacement character for invalid lead byte
        ;
        if (units.length >= 0x1000) {
            result += $fec591ea5a7df9ff$var$fromCharCode.apply(String, units);
            units.length = 0;
        }
    }
    if (units.length > 0) result += $fec591ea5a7df9ff$var$fromCharCode.apply(String, units);
    return result;
}
let $fec591ea5a7df9ff$var$fromCharCode = String.fromCharCode;
function $fec591ea5a7df9ff$var$longStringInJS(length) {
    let start = $fec591ea5a7df9ff$var$position;
    let bytes = new Array(length);
    for(let i = 0; i < length; i++){
        const byte = $fec591ea5a7df9ff$var$src[$fec591ea5a7df9ff$var$position++];
        if ((byte & 0x80) > 0) {
            $fec591ea5a7df9ff$var$position = start;
            return;
        }
        bytes[i] = byte;
    }
    return $fec591ea5a7df9ff$var$fromCharCode.apply(String, bytes);
}
function $fec591ea5a7df9ff$var$shortStringInJS(length) {
    if (length < 4) {
        if (length < 2) {
            if (length === 0) return '';
            else {
                let a = $fec591ea5a7df9ff$var$src[$fec591ea5a7df9ff$var$position++];
                if ((a & 0x80) > 1) {
                    $fec591ea5a7df9ff$var$position -= 1;
                    return;
                }
                return $fec591ea5a7df9ff$var$fromCharCode(a);
            }
        } else {
            let a = $fec591ea5a7df9ff$var$src[$fec591ea5a7df9ff$var$position++];
            let b = $fec591ea5a7df9ff$var$src[$fec591ea5a7df9ff$var$position++];
            if ((a & 0x80) > 0 || (b & 0x80) > 0) {
                $fec591ea5a7df9ff$var$position -= 2;
                return;
            }
            if (length < 3) return $fec591ea5a7df9ff$var$fromCharCode(a, b);
            let c = $fec591ea5a7df9ff$var$src[$fec591ea5a7df9ff$var$position++];
            if ((c & 0x80) > 0) {
                $fec591ea5a7df9ff$var$position -= 3;
                return;
            }
            return $fec591ea5a7df9ff$var$fromCharCode(a, b, c);
        }
    } else {
        let a = $fec591ea5a7df9ff$var$src[$fec591ea5a7df9ff$var$position++];
        let b = $fec591ea5a7df9ff$var$src[$fec591ea5a7df9ff$var$position++];
        let c = $fec591ea5a7df9ff$var$src[$fec591ea5a7df9ff$var$position++];
        let d = $fec591ea5a7df9ff$var$src[$fec591ea5a7df9ff$var$position++];
        if ((a & 0x80) > 0 || (b & 0x80) > 0 || (c & 0x80) > 0 || (d & 0x80) > 0) {
            $fec591ea5a7df9ff$var$position -= 4;
            return;
        }
        if (length < 6) {
            if (length === 4) return $fec591ea5a7df9ff$var$fromCharCode(a, b, c, d);
            else {
                let e = $fec591ea5a7df9ff$var$src[$fec591ea5a7df9ff$var$position++];
                if ((e & 0x80) > 0) {
                    $fec591ea5a7df9ff$var$position -= 5;
                    return;
                }
                return $fec591ea5a7df9ff$var$fromCharCode(a, b, c, d, e);
            }
        } else if (length < 8) {
            let e = $fec591ea5a7df9ff$var$src[$fec591ea5a7df9ff$var$position++];
            let f = $fec591ea5a7df9ff$var$src[$fec591ea5a7df9ff$var$position++];
            if ((e & 0x80) > 0 || (f & 0x80) > 0) {
                $fec591ea5a7df9ff$var$position -= 6;
                return;
            }
            if (length < 7) return $fec591ea5a7df9ff$var$fromCharCode(a, b, c, d, e, f);
            let g = $fec591ea5a7df9ff$var$src[$fec591ea5a7df9ff$var$position++];
            if ((g & 0x80) > 0) {
                $fec591ea5a7df9ff$var$position -= 7;
                return;
            }
            return $fec591ea5a7df9ff$var$fromCharCode(a, b, c, d, e, f, g);
        } else {
            let e = $fec591ea5a7df9ff$var$src[$fec591ea5a7df9ff$var$position++];
            let f = $fec591ea5a7df9ff$var$src[$fec591ea5a7df9ff$var$position++];
            let g = $fec591ea5a7df9ff$var$src[$fec591ea5a7df9ff$var$position++];
            let h = $fec591ea5a7df9ff$var$src[$fec591ea5a7df9ff$var$position++];
            if ((e & 0x80) > 0 || (f & 0x80) > 0 || (g & 0x80) > 0 || (h & 0x80) > 0) {
                $fec591ea5a7df9ff$var$position -= 8;
                return;
            }
            if (length < 10) {
                if (length === 8) return $fec591ea5a7df9ff$var$fromCharCode(a, b, c, d, e, f, g, h);
                else {
                    let i = $fec591ea5a7df9ff$var$src[$fec591ea5a7df9ff$var$position++];
                    if ((i & 0x80) > 0) {
                        $fec591ea5a7df9ff$var$position -= 9;
                        return;
                    }
                    return $fec591ea5a7df9ff$var$fromCharCode(a, b, c, d, e, f, g, h, i);
                }
            } else if (length < 12) {
                let i = $fec591ea5a7df9ff$var$src[$fec591ea5a7df9ff$var$position++];
                let j = $fec591ea5a7df9ff$var$src[$fec591ea5a7df9ff$var$position++];
                if ((i & 0x80) > 0 || (j & 0x80) > 0) {
                    $fec591ea5a7df9ff$var$position -= 10;
                    return;
                }
                if (length < 11) return $fec591ea5a7df9ff$var$fromCharCode(a, b, c, d, e, f, g, h, i, j);
                let k = $fec591ea5a7df9ff$var$src[$fec591ea5a7df9ff$var$position++];
                if ((k & 0x80) > 0) {
                    $fec591ea5a7df9ff$var$position -= 11;
                    return;
                }
                return $fec591ea5a7df9ff$var$fromCharCode(a, b, c, d, e, f, g, h, i, j, k);
            } else {
                let i = $fec591ea5a7df9ff$var$src[$fec591ea5a7df9ff$var$position++];
                let j = $fec591ea5a7df9ff$var$src[$fec591ea5a7df9ff$var$position++];
                let k = $fec591ea5a7df9ff$var$src[$fec591ea5a7df9ff$var$position++];
                let l = $fec591ea5a7df9ff$var$src[$fec591ea5a7df9ff$var$position++];
                if ((i & 0x80) > 0 || (j & 0x80) > 0 || (k & 0x80) > 0 || (l & 0x80) > 0) {
                    $fec591ea5a7df9ff$var$position -= 12;
                    return;
                }
                if (length < 14) {
                    if (length === 12) return $fec591ea5a7df9ff$var$fromCharCode(a, b, c, d, e, f, g, h, i, j, k, l);
                    else {
                        let m = $fec591ea5a7df9ff$var$src[$fec591ea5a7df9ff$var$position++];
                        if ((m & 0x80) > 0) {
                            $fec591ea5a7df9ff$var$position -= 13;
                            return;
                        }
                        return $fec591ea5a7df9ff$var$fromCharCode(a, b, c, d, e, f, g, h, i, j, k, l, m);
                    }
                } else {
                    let m = $fec591ea5a7df9ff$var$src[$fec591ea5a7df9ff$var$position++];
                    let n = $fec591ea5a7df9ff$var$src[$fec591ea5a7df9ff$var$position++];
                    if ((m & 0x80) > 0 || (n & 0x80) > 0) {
                        $fec591ea5a7df9ff$var$position -= 14;
                        return;
                    }
                    if (length < 15) return $fec591ea5a7df9ff$var$fromCharCode(a, b, c, d, e, f, g, h, i, j, k, l, m, n);
                    let o = $fec591ea5a7df9ff$var$src[$fec591ea5a7df9ff$var$position++];
                    if ((o & 0x80) > 0) {
                        $fec591ea5a7df9ff$var$position -= 15;
                        return;
                    }
                    return $fec591ea5a7df9ff$var$fromCharCode(a, b, c, d, e, f, g, h, i, j, k, l, m, n, o);
                }
            }
        }
    }
}
function $fec591ea5a7df9ff$var$readBin(length) {
    return $fec591ea5a7df9ff$var$currentDecoder.copyBuffers ? // specifically use the copying slice (not the node one)
    Uint8Array.prototype.slice.call($fec591ea5a7df9ff$var$src, $fec591ea5a7df9ff$var$position, $fec591ea5a7df9ff$var$position += length) : $fec591ea5a7df9ff$var$src.subarray($fec591ea5a7df9ff$var$position, $fec591ea5a7df9ff$var$position += length);
}
function $fec591ea5a7df9ff$var$readExt(length) {
    let type = $fec591ea5a7df9ff$var$src[$fec591ea5a7df9ff$var$position++];
    if ($fec591ea5a7df9ff$var$currentExtensions[type]) return $fec591ea5a7df9ff$var$currentExtensions[type]($fec591ea5a7df9ff$var$src.subarray($fec591ea5a7df9ff$var$position, $fec591ea5a7df9ff$var$position += length));
    else throw new Error('Unknown extension type ' + type);
}
let $fec591ea5a7df9ff$var$f32Array = new Float32Array(1);
let $fec591ea5a7df9ff$var$u8Array = new Uint8Array($fec591ea5a7df9ff$var$f32Array.buffer, 0, 4);
function $fec591ea5a7df9ff$var$getFloat16() {
    let byte0 = $fec591ea5a7df9ff$var$src[$fec591ea5a7df9ff$var$position++];
    let byte1 = $fec591ea5a7df9ff$var$src[$fec591ea5a7df9ff$var$position++];
    let exponent = (byte0 & 0x7f) >> 2;
    if (exponent === 0x1f) {
        if (byte1 || byte0 & 3) return NaN;
        return byte0 & 0x80 ? -Infinity : Infinity;
    }
    if (exponent === 0) {
        // significand with 10 fractional bits and divided by 2^14
        let abs = ((byte0 & 3) << 8 | byte1) / 16777216;
        return byte0 & 0x80 ? -abs : abs;
    }
    $fec591ea5a7df9ff$var$u8Array[3] = byte0 & 0x80 | // sign bit
    (exponent >> 1) + 56 // 4 of 5 of the exponent bits, re-offset-ed
    ;
    $fec591ea5a7df9ff$var$u8Array[2] = (byte0 & 7) << 5 | // last exponent bit and first two mantissa bits
    byte1 >> 3 // next 5 bits of mantissa
    ;
    $fec591ea5a7df9ff$var$u8Array[1] = byte1 << 5; // last three bits of mantissa
    $fec591ea5a7df9ff$var$u8Array[0] = 0;
    return $fec591ea5a7df9ff$var$f32Array[0];
}
let $fec591ea5a7df9ff$var$keyCache = new Array(4096);
function $fec591ea5a7df9ff$var$readKey() {
    let length = $fec591ea5a7df9ff$var$src[$fec591ea5a7df9ff$var$position++];
    if (length >= 0x60 && length < 0x78) {
        // fixstr, potentially use key cache
        length = length - 0x60;
        if ($fec591ea5a7df9ff$var$srcStringEnd >= $fec591ea5a7df9ff$var$position) return $fec591ea5a7df9ff$var$srcString.slice($fec591ea5a7df9ff$var$position - $fec591ea5a7df9ff$var$srcStringStart, ($fec591ea5a7df9ff$var$position += length) - $fec591ea5a7df9ff$var$srcStringStart);
        else if (!($fec591ea5a7df9ff$var$srcStringEnd == 0 && $fec591ea5a7df9ff$var$srcEnd < 180)) return $fec591ea5a7df9ff$var$readFixedString(length);
    } else {
        $fec591ea5a7df9ff$var$position--;
        return $fec591ea5a7df9ff$export$aafa59e2e03f2942();
    }
    let key = (length << 5 ^ (length > 1 ? $fec591ea5a7df9ff$var$dataView.getUint16($fec591ea5a7df9ff$var$position) : length > 0 ? $fec591ea5a7df9ff$var$src[$fec591ea5a7df9ff$var$position] : 0)) & 0xfff;
    let entry = $fec591ea5a7df9ff$var$keyCache[key];
    let checkPosition = $fec591ea5a7df9ff$var$position;
    let end = $fec591ea5a7df9ff$var$position + length - 3;
    let chunk;
    let i = 0;
    if (entry && entry.bytes == length) {
        while(checkPosition < end){
            chunk = $fec591ea5a7df9ff$var$dataView.getUint32(checkPosition);
            if (chunk != entry[i++]) {
                checkPosition = 0x70000000;
                break;
            }
            checkPosition += 4;
        }
        end += 3;
        while(checkPosition < end){
            chunk = $fec591ea5a7df9ff$var$src[checkPosition++];
            if (chunk != entry[i++]) {
                checkPosition = 0x70000000;
                break;
            }
        }
        if (checkPosition === end) {
            $fec591ea5a7df9ff$var$position = checkPosition;
            return entry.string;
        }
        end -= 3;
        checkPosition = $fec591ea5a7df9ff$var$position;
    }
    entry = [];
    $fec591ea5a7df9ff$var$keyCache[key] = entry;
    entry.bytes = length;
    while(checkPosition < end){
        chunk = $fec591ea5a7df9ff$var$dataView.getUint32(checkPosition);
        entry.push(chunk);
        checkPosition += 4;
    }
    end += 3;
    while(checkPosition < end){
        chunk = $fec591ea5a7df9ff$var$src[checkPosition++];
        entry.push(chunk);
    }
    // for small blocks, avoiding the overhead of the extract call is helpful
    let string = length < 16 ? $fec591ea5a7df9ff$var$shortStringInJS(length) : $fec591ea5a7df9ff$var$longStringInJS(length);
    if (string != null) return entry.string = string;
    return entry.string = $fec591ea5a7df9ff$var$readFixedString(length);
}
class $fec591ea5a7df9ff$export$3288d34c523a1192 {
    constructor(value, tag){
        this.value = value;
        this.tag = tag;
    }
}
$fec591ea5a7df9ff$var$currentExtensions[0] = (dateString)=>{
    // string date extension
    return new Date(dateString);
};
$fec591ea5a7df9ff$var$currentExtensions[1] = (epochSec)=>{
    // numeric date extension
    return new Date(Math.round(epochSec * 1000));
};
$fec591ea5a7df9ff$var$currentExtensions[2] = (buffer)=>{
    // bigint extension
    let value = BigInt(0);
    for(let i = 0, l = buffer.byteLength; i < l; i++)value = BigInt(buffer[i]) + (value << BigInt(8));
    return value;
};
$fec591ea5a7df9ff$var$currentExtensions[3] = (buffer)=>{
    // negative bigint extension
    return BigInt(-1) - $fec591ea5a7df9ff$var$currentExtensions[2](buffer);
};
$fec591ea5a7df9ff$var$currentExtensions[4] = (fraction)=>{
    // best to reparse to maintain accuracy
    return +(fraction[1] + 'e' + fraction[0]);
};
$fec591ea5a7df9ff$var$currentExtensions[5] = (fraction)=>{
    // probably not sufficiently accurate
    return fraction[1] * Math.exp(fraction[0] * Math.log(2));
};
// the registration of the record definition extension
const $fec591ea5a7df9ff$var$recordDefinition = (id, structure)=>{
    id = id - 0xe000;
    let existingStructure = $fec591ea5a7df9ff$var$currentStructures[id];
    if (existingStructure && existingStructure.isShared) ($fec591ea5a7df9ff$var$currentStructures.restoreStructures || ($fec591ea5a7df9ff$var$currentStructures.restoreStructures = []))[id] = existingStructure;
    $fec591ea5a7df9ff$var$currentStructures[id] = structure;
    structure.read = $fec591ea5a7df9ff$var$createStructureReader(structure);
};
$fec591ea5a7df9ff$var$currentExtensions[$fec591ea5a7df9ff$var$LEGACY_RECORD_INLINE_ID] = (data)=>{
    let length = data.length;
    let structure = data[1];
    $fec591ea5a7df9ff$var$recordDefinition(data[0], structure);
    let object = {};
    for(let i = 2; i < length; i++){
        let key = structure[i - 2];
        object[$fec591ea5a7df9ff$var$safeKey(key)] = data[i];
    }
    return object;
};
$fec591ea5a7df9ff$var$currentExtensions[14] = (value)=>{
    if ($fec591ea5a7df9ff$var$bundledStrings) return $fec591ea5a7df9ff$var$bundledStrings[0].slice($fec591ea5a7df9ff$var$bundledStrings.position0, $fec591ea5a7df9ff$var$bundledStrings.position0 += value);
    return new $fec591ea5a7df9ff$export$3288d34c523a1192(value, 14);
};
$fec591ea5a7df9ff$var$currentExtensions[15] = (value)=>{
    if ($fec591ea5a7df9ff$var$bundledStrings) return $fec591ea5a7df9ff$var$bundledStrings[1].slice($fec591ea5a7df9ff$var$bundledStrings.position1, $fec591ea5a7df9ff$var$bundledStrings.position1 += value);
    return new $fec591ea5a7df9ff$export$3288d34c523a1192(value, 15);
};
let $fec591ea5a7df9ff$var$glbl = {
    Error: Error,
    RegExp: RegExp
};
$fec591ea5a7df9ff$var$currentExtensions[27] = (data)=>{
    return ($fec591ea5a7df9ff$var$glbl[data[0]] || Error)(data[1], data[2]);
};
const $fec591ea5a7df9ff$var$packedTable = (read)=>{
    if ($fec591ea5a7df9ff$var$src[$fec591ea5a7df9ff$var$position++] != 0x84) {
        let error = new Error('Packed values structure must be followed by a 4 element array');
        if ($fec591ea5a7df9ff$var$src.length < $fec591ea5a7df9ff$var$position) error.incomplete = true;
        throw error;
    }
    let newPackedValues = read() // packed values
    ;
    if (!newPackedValues || !newPackedValues.length) {
        let error = new Error('Packed values structure must be followed by a 4 element array');
        error.incomplete = true;
        throw error;
    }
    $fec591ea5a7df9ff$var$packedValues = $fec591ea5a7df9ff$var$packedValues ? newPackedValues.concat($fec591ea5a7df9ff$var$packedValues.slice(newPackedValues.length)) : newPackedValues;
    $fec591ea5a7df9ff$var$packedValues.prefixes = read();
    $fec591ea5a7df9ff$var$packedValues.suffixes = read();
    return read() // read the rump
    ;
};
$fec591ea5a7df9ff$var$packedTable.handlesRead = true;
$fec591ea5a7df9ff$var$currentExtensions[51] = $fec591ea5a7df9ff$var$packedTable;
$fec591ea5a7df9ff$var$currentExtensions[$fec591ea5a7df9ff$var$PACKED_REFERENCE_TAG_ID] = (data)=>{
    if (!$fec591ea5a7df9ff$var$packedValues) {
        if ($fec591ea5a7df9ff$var$currentDecoder.getShared) $fec591ea5a7df9ff$var$loadShared();
        else return new $fec591ea5a7df9ff$export$3288d34c523a1192(data, $fec591ea5a7df9ff$var$PACKED_REFERENCE_TAG_ID);
    }
    if (typeof data == 'number') return $fec591ea5a7df9ff$var$packedValues[16 + (data >= 0 ? 2 * data : -2 * data - 1)];
    let error = new Error('No support for non-integer packed references yet');
    if (data === undefined) error.incomplete = true;
    throw error;
};
// The following code is an incomplete implementation of http://cbor.schmorp.de/stringref
// the real thing would need to implemennt more logic to populate the stringRefs table and
// maintain a stack of stringRef "namespaces".
//
// currentExtensions[25] = (id) => {
// 	return stringRefs[id]
// }
// currentExtensions[256] = (read) => {
// 	stringRefs = []
// 	try {
// 		return read()
// 	} finally {
// 		stringRefs = null
// 	}
// }
// currentExtensions[256].handlesRead = true
$fec591ea5a7df9ff$var$currentExtensions[28] = (read)=>{
    // shareable http://cbor.schmorp.de/value-sharing (for structured clones)
    if (!$fec591ea5a7df9ff$var$referenceMap) {
        $fec591ea5a7df9ff$var$referenceMap = new Map();
        $fec591ea5a7df9ff$var$referenceMap.id = 0;
    }
    let id = $fec591ea5a7df9ff$var$referenceMap.id++;
    let startingPosition = $fec591ea5a7df9ff$var$position;
    let token = $fec591ea5a7df9ff$var$src[$fec591ea5a7df9ff$var$position];
    let target;
    // TODO: handle Maps, Sets, and other types that can cycle; this is complicated, because you potentially need to read
    // ahead past references to record structure definitions
    if (token >> 5 == 4) target = [];
    else target = {};
    let refEntry = {
        target: target
    } // a placeholder object
    ;
    $fec591ea5a7df9ff$var$referenceMap.set(id, refEntry);
    let targetProperties = read() // read the next value as the target object to id
    ;
    if (refEntry.used) {
        if (Object.getPrototypeOf(target) !== Object.getPrototypeOf(targetProperties)) {
            // this means that the returned target does not match the targetProperties, so we need rerun the read to
            // have the correctly create instance be assigned as a reference, then we do the copy the properties back to the
            // target
            // reset the position so that the read can be repeated
            $fec591ea5a7df9ff$var$position = startingPosition;
            // the returned instance is our new target for references
            target = targetProperties;
            $fec591ea5a7df9ff$var$referenceMap.set(id, {
                target: target
            });
            targetProperties = read();
        }
        return Object.assign(target, targetProperties);
    }
    refEntry.target = targetProperties // the placeholder wasn't used, replace with the deserialized one
    ;
    return targetProperties // no cycle, can just use the returned read object
    ;
};
$fec591ea5a7df9ff$var$currentExtensions[28].handlesRead = true;
$fec591ea5a7df9ff$var$currentExtensions[29] = (id)=>{
    // sharedref http://cbor.schmorp.de/value-sharing (for structured clones)
    let refEntry = $fec591ea5a7df9ff$var$referenceMap.get(id);
    refEntry.used = true;
    return refEntry.target;
};
$fec591ea5a7df9ff$var$currentExtensions[258] = (array)=>new Set(array); // https://github.com/input-output-hk/cbor-sets-spec/blob/master/CBOR_SETS.md
($fec591ea5a7df9ff$var$currentExtensions[259] = (read)=>{
    // https://github.com/shanewholloway/js-cbor-codec/blob/master/docs/CBOR-259-spec
    // for decoding as a standard Map
    if ($fec591ea5a7df9ff$var$currentDecoder.mapsAsObjects) {
        $fec591ea5a7df9ff$var$currentDecoder.mapsAsObjects = false;
        $fec591ea5a7df9ff$var$restoreMapsAsObject = true;
    }
    return read();
}).handlesRead = true;
function $fec591ea5a7df9ff$var$combine(a, b) {
    if (typeof a === 'string') return a + b;
    if (a instanceof Array) return a.concat(b);
    return Object.assign({}, a, b);
}
function $fec591ea5a7df9ff$var$getPackedValues() {
    if (!$fec591ea5a7df9ff$var$packedValues) {
        if ($fec591ea5a7df9ff$var$currentDecoder.getShared) $fec591ea5a7df9ff$var$loadShared();
        else throw new Error('No packed values available');
    }
    return $fec591ea5a7df9ff$var$packedValues;
}
const $fec591ea5a7df9ff$var$SHARED_DATA_TAG_ID = 0x53687264 // ascii 'Shrd'
;
$fec591ea5a7df9ff$var$currentExtensionRanges.push((tag, input)=>{
    if (tag >= 225 && tag <= 255) return $fec591ea5a7df9ff$var$combine($fec591ea5a7df9ff$var$getPackedValues().prefixes[tag - 224], input);
    if (tag >= 28704 && tag <= 32767) return $fec591ea5a7df9ff$var$combine($fec591ea5a7df9ff$var$getPackedValues().prefixes[tag - 28672], input);
    if (tag >= 1879052288 && tag <= 2147483647) return $fec591ea5a7df9ff$var$combine($fec591ea5a7df9ff$var$getPackedValues().prefixes[tag - 1879048192], input);
    if (tag >= 216 && tag <= 223) return $fec591ea5a7df9ff$var$combine(input, $fec591ea5a7df9ff$var$getPackedValues().suffixes[tag - 216]);
    if (tag >= 27647 && tag <= 28671) return $fec591ea5a7df9ff$var$combine(input, $fec591ea5a7df9ff$var$getPackedValues().suffixes[tag - 27639]);
    if (tag >= 1811940352 && tag <= 1879048191) return $fec591ea5a7df9ff$var$combine(input, $fec591ea5a7df9ff$var$getPackedValues().suffixes[tag - 1811939328]);
    if (tag == $fec591ea5a7df9ff$var$SHARED_DATA_TAG_ID) return {
        packedValues: $fec591ea5a7df9ff$var$packedValues,
        structures: $fec591ea5a7df9ff$var$currentStructures.slice(0),
        version: input
    };
    if (tag == 55799) return input;
});
const $fec591ea5a7df9ff$var$isLittleEndianMachine = new Uint8Array(new Uint16Array([
    1
]).buffer)[0] == 1;
const $fec591ea5a7df9ff$export$aae3eaec024a56b7 = [
    Uint8Array,
    Uint8ClampedArray,
    Uint16Array,
    Uint32Array,
    typeof BigUint64Array == 'undefined' ? {
        name: 'BigUint64Array'
    } : BigUint64Array,
    Int8Array,
    Int16Array,
    Int32Array,
    typeof BigInt64Array == 'undefined' ? {
        name: 'BigInt64Array'
    } : BigInt64Array,
    Float32Array,
    Float64Array
];
const $fec591ea5a7df9ff$var$typedArrayTags = [
    64,
    68,
    69,
    70,
    71,
    72,
    77,
    78,
    79,
    85,
    86
];
for(let i = 0; i < $fec591ea5a7df9ff$export$aae3eaec024a56b7.length; i++)$fec591ea5a7df9ff$var$registerTypedArray($fec591ea5a7df9ff$export$aae3eaec024a56b7[i], $fec591ea5a7df9ff$var$typedArrayTags[i]);
function $fec591ea5a7df9ff$var$registerTypedArray(TypedArray, tag) {
    let dvMethod = 'get' + TypedArray.name.slice(0, -5);
    let bytesPerElement;
    if (typeof TypedArray === 'function') bytesPerElement = TypedArray.BYTES_PER_ELEMENT;
    else TypedArray = null;
    for(let littleEndian = 0; littleEndian < 2; littleEndian++){
        if (!littleEndian && bytesPerElement == 1) continue;
        let sizeShift = bytesPerElement == 2 ? 1 : bytesPerElement == 4 ? 2 : bytesPerElement == 8 ? 3 : 0;
        $fec591ea5a7df9ff$var$currentExtensions[littleEndian ? tag : tag - 4] = bytesPerElement == 1 || littleEndian == $fec591ea5a7df9ff$var$isLittleEndianMachine ? (buffer)=>{
            if (!TypedArray) throw new Error('Could not find typed array for code ' + tag);
            if (!$fec591ea5a7df9ff$var$currentDecoder.copyBuffers) {
                // try provide a direct view, but will only work if we are byte-aligned
                if (bytesPerElement === 1 || bytesPerElement === 2 && !(buffer.byteOffset & 1) || bytesPerElement === 4 && !(buffer.byteOffset & 3) || bytesPerElement === 8 && !(buffer.byteOffset & 7)) return new TypedArray(buffer.buffer, buffer.byteOffset, buffer.byteLength >> sizeShift);
            }
            // we have to slice/copy here to get a new ArrayBuffer, if we are not word/byte aligned
            return new TypedArray(Uint8Array.prototype.slice.call(buffer, 0).buffer);
        } : (buffer)=>{
            if (!TypedArray) throw new Error('Could not find typed array for code ' + tag);
            let dv = new DataView(buffer.buffer, buffer.byteOffset, buffer.byteLength);
            let elements = buffer.length >> sizeShift;
            let ta = new TypedArray(elements);
            let method = dv[dvMethod];
            for(let i = 0; i < elements; i++)ta[i] = method.call(dv, i << sizeShift, littleEndian);
            return ta;
        };
    }
}
function $fec591ea5a7df9ff$var$readBundleExt() {
    let length = $fec591ea5a7df9ff$var$readJustLength();
    let bundlePosition = $fec591ea5a7df9ff$var$position + $fec591ea5a7df9ff$export$aafa59e2e03f2942();
    for(let i = 2; i < length; i++){
        // skip past bundles that were already read
        let bundleLength = $fec591ea5a7df9ff$var$readJustLength() // this will increment position, so must add to position afterwards
        ;
        $fec591ea5a7df9ff$var$position += bundleLength;
    }
    let dataPosition = $fec591ea5a7df9ff$var$position;
    $fec591ea5a7df9ff$var$position = bundlePosition;
    $fec591ea5a7df9ff$var$bundledStrings = [
        $fec591ea5a7df9ff$var$readStringJS($fec591ea5a7df9ff$var$readJustLength()),
        $fec591ea5a7df9ff$var$readStringJS($fec591ea5a7df9ff$var$readJustLength())
    ];
    $fec591ea5a7df9ff$var$bundledStrings.position0 = 0;
    $fec591ea5a7df9ff$var$bundledStrings.position1 = 0;
    $fec591ea5a7df9ff$var$bundledStrings.postBundlePosition = $fec591ea5a7df9ff$var$position;
    $fec591ea5a7df9ff$var$position = dataPosition;
    return $fec591ea5a7df9ff$export$aafa59e2e03f2942();
}
function $fec591ea5a7df9ff$var$readJustLength() {
    let token = $fec591ea5a7df9ff$var$src[$fec591ea5a7df9ff$var$position++] & 0x1f;
    if (token > 0x17) switch(token){
        case 0x18:
            token = $fec591ea5a7df9ff$var$src[$fec591ea5a7df9ff$var$position++];
            break;
        case 0x19:
            token = $fec591ea5a7df9ff$var$dataView.getUint16($fec591ea5a7df9ff$var$position);
            $fec591ea5a7df9ff$var$position += 2;
            break;
        case 0x1a:
            token = $fec591ea5a7df9ff$var$dataView.getUint32($fec591ea5a7df9ff$var$position);
            $fec591ea5a7df9ff$var$position += 4;
            break;
    }
    return token;
}
function $fec591ea5a7df9ff$var$loadShared() {
    if ($fec591ea5a7df9ff$var$currentDecoder.getShared) {
        let sharedData = $fec591ea5a7df9ff$var$saveState(()=>{
            // save the state in case getShared modifies our buffer
            $fec591ea5a7df9ff$var$src = null;
            return $fec591ea5a7df9ff$var$currentDecoder.getShared();
        }) || {};
        let updatedStructures = sharedData.structures || [];
        $fec591ea5a7df9ff$var$currentDecoder.sharedVersion = sharedData.version;
        $fec591ea5a7df9ff$var$packedValues = $fec591ea5a7df9ff$var$currentDecoder.sharedValues = sharedData.packedValues;
        if ($fec591ea5a7df9ff$var$currentStructures === true) $fec591ea5a7df9ff$var$currentDecoder.structures = $fec591ea5a7df9ff$var$currentStructures = updatedStructures;
        else $fec591ea5a7df9ff$var$currentStructures.splice.apply($fec591ea5a7df9ff$var$currentStructures, [
            0,
            updatedStructures.length
        ].concat(updatedStructures));
    }
}
function $fec591ea5a7df9ff$var$saveState(callback) {
    let savedSrcEnd = $fec591ea5a7df9ff$var$srcEnd;
    let savedPosition = $fec591ea5a7df9ff$var$position;
    let savedStringPosition = $fec591ea5a7df9ff$var$stringPosition;
    let savedSrcStringStart = $fec591ea5a7df9ff$var$srcStringStart;
    let savedSrcStringEnd = $fec591ea5a7df9ff$var$srcStringEnd;
    let savedSrcString = $fec591ea5a7df9ff$var$srcString;
    let savedStrings = $fec591ea5a7df9ff$var$strings;
    let savedReferenceMap = $fec591ea5a7df9ff$var$referenceMap;
    let savedBundledStrings = $fec591ea5a7df9ff$var$bundledStrings;
    // TODO: We may need to revisit this if we do more external calls to user code (since it could be slow)
    let savedSrc = new Uint8Array($fec591ea5a7df9ff$var$src.slice(0, $fec591ea5a7df9ff$var$srcEnd)) // we copy the data in case it changes while external data is processed
    ;
    let savedStructures = $fec591ea5a7df9ff$var$currentStructures;
    let savedDecoder = $fec591ea5a7df9ff$var$currentDecoder;
    let savedSequentialMode = $fec591ea5a7df9ff$var$sequentialMode;
    let value = callback();
    $fec591ea5a7df9ff$var$srcEnd = savedSrcEnd;
    $fec591ea5a7df9ff$var$position = savedPosition;
    $fec591ea5a7df9ff$var$stringPosition = savedStringPosition;
    $fec591ea5a7df9ff$var$srcStringStart = savedSrcStringStart;
    $fec591ea5a7df9ff$var$srcStringEnd = savedSrcStringEnd;
    $fec591ea5a7df9ff$var$srcString = savedSrcString;
    $fec591ea5a7df9ff$var$strings = savedStrings;
    $fec591ea5a7df9ff$var$referenceMap = savedReferenceMap;
    $fec591ea5a7df9ff$var$bundledStrings = savedBundledStrings;
    $fec591ea5a7df9ff$var$src = savedSrc;
    $fec591ea5a7df9ff$var$sequentialMode = savedSequentialMode;
    $fec591ea5a7df9ff$var$currentStructures = savedStructures;
    $fec591ea5a7df9ff$var$currentDecoder = savedDecoder;
    $fec591ea5a7df9ff$var$dataView = new DataView($fec591ea5a7df9ff$var$src.buffer, $fec591ea5a7df9ff$var$src.byteOffset, $fec591ea5a7df9ff$var$src.byteLength);
    return value;
}
function $fec591ea5a7df9ff$export$e6f020404d5b6c15() {
    $fec591ea5a7df9ff$var$src = null;
    $fec591ea5a7df9ff$var$referenceMap = null;
    $fec591ea5a7df9ff$var$currentStructures = null;
}
function $fec591ea5a7df9ff$export$4e11b2f4fcd6c82d(extension) {
    $fec591ea5a7df9ff$var$currentExtensions[extension.tag] = extension.decode;
}
function $fec591ea5a7df9ff$export$7fcdb67852ee393(limits) {
    if (limits.maxMapSize) $fec591ea5a7df9ff$var$maxMapSize = limits.maxMapSize;
    if (limits.maxArraySize) $fec591ea5a7df9ff$var$maxArraySize = limits.maxArraySize;
    if (limits.maxObjectSize) $fec591ea5a7df9ff$var$maxObjectSize = limits.maxObjectSize;
}
const $fec591ea5a7df9ff$export$c652a5bbb6be7a36 = new Array(147) // this is a table matching binary exponents to the multiplier to determine significant digit rounding
;
for(let i = 0; i < 256; i++)$fec591ea5a7df9ff$export$c652a5bbb6be7a36[i] = +('1e' + Math.floor(45.15 - i * 0.30103));
let $fec591ea5a7df9ff$var$defaultDecoder = new $fec591ea5a7df9ff$export$f9de6ca0bc043724({
    useRecords: false
});
const $fec591ea5a7df9ff$export$2f872c0f2117be69 = $fec591ea5a7df9ff$var$defaultDecoder.decode;
const $fec591ea5a7df9ff$export$ddfa300a3790ac32 = $fec591ea5a7df9ff$var$defaultDecoder.decodeMultiple;
const $fec591ea5a7df9ff$export$2239e49a3e351685 = {
    NEVER: 0,
    ALWAYS: 1,
    DECIMAL_ROUND: 3,
    DECIMAL_FIT: 4
};
function $fec591ea5a7df9ff$export$36da082398e4f139(float32Number) {
    $fec591ea5a7df9ff$var$f32Array[0] = float32Number;
    let multiplier = $fec591ea5a7df9ff$export$c652a5bbb6be7a36[($fec591ea5a7df9ff$var$u8Array[3] & 0x7f) << 1 | $fec591ea5a7df9ff$var$u8Array[2] >> 7];
    return (multiplier * float32Number + (float32Number > 0 ? 0.5 : -0.5) >> 0) / multiplier;
}


let $c38e2d25b6eee624$var$textEncoder;
try {
    $c38e2d25b6eee624$var$textEncoder = new TextEncoder();
} catch (error) {}
let $c38e2d25b6eee624$var$extensions, $c38e2d25b6eee624$var$extensionClasses;
const $c38e2d25b6eee624$var$Buffer = typeof globalThis === 'object' && globalThis.Buffer;
const $c38e2d25b6eee624$var$hasNodeBuffer = typeof $c38e2d25b6eee624$var$Buffer !== 'undefined';
const $c38e2d25b6eee624$var$ByteArrayAllocate = $c38e2d25b6eee624$var$hasNodeBuffer ? $c38e2d25b6eee624$var$Buffer.allocUnsafeSlow : Uint8Array;
const $c38e2d25b6eee624$var$ByteArray = $c38e2d25b6eee624$var$hasNodeBuffer ? $c38e2d25b6eee624$var$Buffer : Uint8Array;
const $c38e2d25b6eee624$var$MAX_STRUCTURES = 0x100;
const $c38e2d25b6eee624$var$MAX_BUFFER_SIZE = $c38e2d25b6eee624$var$hasNodeBuffer ? 0x100000000 : 0x7fd00000;
let $c38e2d25b6eee624$var$serializationId = 1;
let $c38e2d25b6eee624$var$throwOnIterable;
let $c38e2d25b6eee624$var$target;
let $c38e2d25b6eee624$var$targetView;
let $c38e2d25b6eee624$var$position = 0;
let $c38e2d25b6eee624$var$safeEnd;
let $c38e2d25b6eee624$var$bundledStrings = null;
const $c38e2d25b6eee624$var$MAX_BUNDLE_SIZE = 0xf000;
const $c38e2d25b6eee624$var$hasNonLatin = /[\u0080-\uFFFF]/;
const $c38e2d25b6eee624$var$RECORD_SYMBOL = Symbol('record-id');
class $c38e2d25b6eee624$export$a50aceb0e02a00aa extends (0, $fec591ea5a7df9ff$export$f9de6ca0bc043724) {
    constructor(options){
        super(options);
        this.offset = 0;
        let typeBuffer;
        let start;
        let sharedStructures;
        let hasSharedUpdate;
        let structures;
        let referenceMap;
        options = options || {};
        let encodeUtf8 = $c38e2d25b6eee624$var$ByteArray.prototype.utf8Write ? function(string, position) {
            return $c38e2d25b6eee624$var$target.utf8Write(string, position, $c38e2d25b6eee624$var$target.byteLength - position);
        } : $c38e2d25b6eee624$var$textEncoder && $c38e2d25b6eee624$var$textEncoder.encodeInto ? function(string, position) {
            return $c38e2d25b6eee624$var$textEncoder.encodeInto(string, $c38e2d25b6eee624$var$target.subarray(position)).written;
        } : false;
        let encoder = this;
        let hasSharedStructures = options.structures || options.saveStructures;
        let maxSharedStructures = options.maxSharedStructures;
        if (maxSharedStructures == null) maxSharedStructures = hasSharedStructures ? 128 : 0;
        if (maxSharedStructures > 8190) throw new Error('Maximum maxSharedStructure is 8190');
        let isSequential = options.sequential;
        if (isSequential) maxSharedStructures = 0;
        if (!this.structures) this.structures = [];
        if (this.saveStructures) this.saveShared = this.saveStructures;
        let samplingPackedValues, packedObjectMap1, sharedValues = options.sharedValues;
        let sharedPackedObjectMap1;
        if (sharedValues) {
            sharedPackedObjectMap1 = Object.create(null);
            for(let i = 0, l = sharedValues.length; i < l; i++)sharedPackedObjectMap1[sharedValues[i]] = i;
        }
        let recordIdsToRemove = [];
        let transitionsCount = 0;
        let serializationsSinceTransitionRebuild = 0;
        this.mapEncode = function(value, encodeOptions) {
            // Experimental support for premapping keys using _keyMap instad of keyMap - not optiimised yet)
            if (this._keyMap && !this._mapped) //console.log('encoding ', value)
            switch(value.constructor.name){
                case 'Array':
                    value = value.map((r)=>this.encodeKeys(r));
                    break;
            }
            return this.encode(value, encodeOptions);
        };
        this.encode = function(value, encodeOptions) {
            if (!$c38e2d25b6eee624$var$target) {
                $c38e2d25b6eee624$var$target = new $c38e2d25b6eee624$var$ByteArrayAllocate(8192);
                $c38e2d25b6eee624$var$targetView = new DataView($c38e2d25b6eee624$var$target.buffer, 0, 8192);
                $c38e2d25b6eee624$var$position = 0;
            }
            $c38e2d25b6eee624$var$safeEnd = $c38e2d25b6eee624$var$target.length - 10;
            if ($c38e2d25b6eee624$var$safeEnd - $c38e2d25b6eee624$var$position < 0x800) {
                // don't start too close to the end, 
                $c38e2d25b6eee624$var$target = new $c38e2d25b6eee624$var$ByteArrayAllocate($c38e2d25b6eee624$var$target.length);
                $c38e2d25b6eee624$var$targetView = new DataView($c38e2d25b6eee624$var$target.buffer, 0, $c38e2d25b6eee624$var$target.length);
                $c38e2d25b6eee624$var$safeEnd = $c38e2d25b6eee624$var$target.length - 10;
                $c38e2d25b6eee624$var$position = 0;
            } else if (encodeOptions === $c38e2d25b6eee624$export$d41ac1453288b342) $c38e2d25b6eee624$var$position = $c38e2d25b6eee624$var$position + 7 & 0x7ffffff8 // Word align to make any future copying of this buffer faster
            ;
            start = $c38e2d25b6eee624$var$position;
            if (encoder.useSelfDescribedHeader) {
                $c38e2d25b6eee624$var$targetView.setUint32($c38e2d25b6eee624$var$position, 0xd9d9f700) // tag two byte, then self-descriptive tag
                ;
                $c38e2d25b6eee624$var$position += 3;
            }
            referenceMap = encoder.structuredClone ? new Map() : null;
            if (encoder.bundleStrings && typeof value !== 'string') {
                $c38e2d25b6eee624$var$bundledStrings = [];
                $c38e2d25b6eee624$var$bundledStrings.size = Infinity // force a new bundle start on first string
                ;
            } else $c38e2d25b6eee624$var$bundledStrings = null;
            sharedStructures = encoder.structures;
            if (sharedStructures) {
                if (sharedStructures.uninitialized) {
                    let sharedData = encoder.getShared() || {};
                    encoder.structures = sharedStructures = sharedData.structures || [];
                    encoder.sharedVersion = sharedData.version;
                    let sharedValues = encoder.sharedValues = sharedData.packedValues;
                    if (sharedValues) {
                        sharedPackedObjectMap1 = {};
                        for(let i = 0, l = sharedValues.length; i < l; i++)sharedPackedObjectMap1[sharedValues[i]] = i;
                    }
                }
                let sharedStructuresLength = sharedStructures.length;
                if (sharedStructuresLength > maxSharedStructures && !isSequential) sharedStructuresLength = maxSharedStructures;
                if (!sharedStructures.transitions) {
                    // rebuild our structure transitions
                    sharedStructures.transitions = Object.create(null);
                    for(let i = 0; i < sharedStructuresLength; i++){
                        let keys = sharedStructures[i];
                        //console.log('shared struct keys:', keys)
                        if (!keys) continue;
                        let nextTransition, transition = sharedStructures.transitions;
                        for(let j = 0, l = keys.length; j < l; j++){
                            if (transition[$c38e2d25b6eee624$var$RECORD_SYMBOL] === undefined) transition[$c38e2d25b6eee624$var$RECORD_SYMBOL] = i;
                            let key = keys[j];
                            nextTransition = transition[key];
                            if (!nextTransition) nextTransition = transition[key] = Object.create(null);
                            transition = nextTransition;
                        }
                        transition[$c38e2d25b6eee624$var$RECORD_SYMBOL] = i | 0x100000;
                    }
                }
                if (!isSequential) sharedStructures.nextId = sharedStructuresLength;
            }
            if (hasSharedUpdate) hasSharedUpdate = false;
            structures = sharedStructures || [];
            packedObjectMap1 = sharedPackedObjectMap1;
            if (options.pack) {
                let packedValues = new Map();
                packedValues.values = [];
                packedValues.encoder = encoder;
                packedValues.maxValues = options.maxPrivatePackedValues || (sharedPackedObjectMap1 ? 16 : Infinity);
                packedValues.objectMap = sharedPackedObjectMap1 || false;
                packedValues.samplingPackedValues = samplingPackedValues;
                $c38e2d25b6eee624$var$findRepetitiveStrings(value, packedValues);
                if (packedValues.values.length > 0) {
                    $c38e2d25b6eee624$var$target[$c38e2d25b6eee624$var$position++] = 0xd8 // one-byte tag
                    ;
                    $c38e2d25b6eee624$var$target[$c38e2d25b6eee624$var$position++] = 51 // tag 51 for packed shared structures https://www.potaroo.net/ietf/ids/draft-ietf-cbor-packed-03.txt
                    ;
                    $c38e2d25b6eee624$var$writeArrayHeader(4);
                    let valuesArray = packedValues.values;
                    encode(valuesArray);
                    $c38e2d25b6eee624$var$writeArrayHeader(0) // prefixes
                    ;
                    $c38e2d25b6eee624$var$writeArrayHeader(0) // suffixes
                    ;
                    packedObjectMap1 = Object.create(sharedPackedObjectMap1 || null);
                    for(let i = 0, l = valuesArray.length; i < l; i++)packedObjectMap1[valuesArray[i]] = i;
                }
            }
            $c38e2d25b6eee624$var$throwOnIterable = encodeOptions & $c38e2d25b6eee624$export$e724ae76933ea297;
            try {
                if ($c38e2d25b6eee624$var$throwOnIterable) return;
                encode(value);
                if ($c38e2d25b6eee624$var$bundledStrings) $c38e2d25b6eee624$var$writeBundles(start, encode);
                encoder.offset = $c38e2d25b6eee624$var$position // update the offset so next serialization doesn't write over our buffer, but can continue writing to same buffer sequentially
                ;
                if (referenceMap && referenceMap.idsToInsert) {
                    $c38e2d25b6eee624$var$position += referenceMap.idsToInsert.length * 2;
                    if ($c38e2d25b6eee624$var$position > $c38e2d25b6eee624$var$safeEnd) makeRoom($c38e2d25b6eee624$var$position);
                    encoder.offset = $c38e2d25b6eee624$var$position;
                    let serialized = $c38e2d25b6eee624$var$insertIds($c38e2d25b6eee624$var$target.subarray(start, $c38e2d25b6eee624$var$position), referenceMap.idsToInsert);
                    referenceMap = null;
                    return serialized;
                }
                if (encodeOptions & $c38e2d25b6eee624$export$d41ac1453288b342) {
                    $c38e2d25b6eee624$var$target.start = start;
                    $c38e2d25b6eee624$var$target.end = $c38e2d25b6eee624$var$position;
                    return $c38e2d25b6eee624$var$target;
                }
                return $c38e2d25b6eee624$var$target.subarray(start, $c38e2d25b6eee624$var$position) // position can change if we call encode again in saveShared, so we get the buffer now
                ;
            } finally{
                if (sharedStructures) {
                    if (serializationsSinceTransitionRebuild < 10) serializationsSinceTransitionRebuild++;
                    if (sharedStructures.length > maxSharedStructures) sharedStructures.length = maxSharedStructures;
                    if (transitionsCount > 10000) {
                        // force a rebuild occasionally after a lot of transitions so it can get cleaned up
                        sharedStructures.transitions = null;
                        serializationsSinceTransitionRebuild = 0;
                        transitionsCount = 0;
                        if (recordIdsToRemove.length > 0) recordIdsToRemove = [];
                    } else if (recordIdsToRemove.length > 0 && !isSequential) {
                        for(let i = 0, l = recordIdsToRemove.length; i < l; i++)recordIdsToRemove[i][$c38e2d25b6eee624$var$RECORD_SYMBOL] = undefined;
                        recordIdsToRemove = [];
                    //sharedStructures.nextId = maxSharedStructures
                    }
                }
                if (hasSharedUpdate && encoder.saveShared) {
                    if (encoder.structures.length > maxSharedStructures) encoder.structures = encoder.structures.slice(0, maxSharedStructures);
                    // we can't rely on start/end with REUSE_BUFFER_MODE since they will (probably) change when we save
                    let returnBuffer = $c38e2d25b6eee624$var$target.subarray(start, $c38e2d25b6eee624$var$position);
                    if (encoder.updateSharedData() === false) return encoder.encode(value) // re-encode if it fails
                    ;
                    return returnBuffer;
                }
                if (encodeOptions & $c38e2d25b6eee624$export$5687accb6effa257) $c38e2d25b6eee624$var$position = start;
            }
        };
        this.findCommonStringsToPack = ()=>{
            samplingPackedValues = new Map();
            if (!sharedPackedObjectMap1) sharedPackedObjectMap1 = Object.create(null);
            return (options)=>{
                let threshold = options && options.threshold || 4;
                let position = this.pack ? options.maxPrivatePackedValues || 16 : 0;
                if (!sharedValues) sharedValues = this.sharedValues = [];
                for (let [key, status] of samplingPackedValues)if (status.count > threshold) {
                    sharedPackedObjectMap1[key] = position++;
                    sharedValues.push(key);
                    hasSharedUpdate = true;
                }
                while(this.saveShared && this.updateSharedData() === false);
                samplingPackedValues = null;
            };
        };
        const encode = (value)=>{
            if ($c38e2d25b6eee624$var$position > $c38e2d25b6eee624$var$safeEnd) $c38e2d25b6eee624$var$target = makeRoom($c38e2d25b6eee624$var$position);
            var type = typeof value;
            var length;
            if (type === 'string') {
                if (packedObjectMap1) {
                    let packedPosition = packedObjectMap1[value];
                    if (packedPosition >= 0) {
                        if (packedPosition < 16) $c38e2d25b6eee624$var$target[$c38e2d25b6eee624$var$position++] = packedPosition + 0xe0 // simple values, defined in https://www.potaroo.net/ietf/ids/draft-ietf-cbor-packed-03.txt
                        ;
                        else {
                            $c38e2d25b6eee624$var$target[$c38e2d25b6eee624$var$position++] = 0xc6 // tag 6 defined in https://www.potaroo.net/ietf/ids/draft-ietf-cbor-packed-03.txt
                            ;
                            if (packedPosition & 1) encode(15 - packedPosition >> 1);
                            else encode(packedPosition - 16 >> 1);
                        }
                        return;
                    /*						} else if (packedStatus.serializationId != serializationId) {
							packedStatus.serializationId = serializationId
							packedStatus.count = 1
							if (options.sharedPack) {
								let sharedCount = packedStatus.sharedCount = (packedStatus.sharedCount || 0) + 1
								if (shareCount > (options.sharedPack.threshold || 5)) {
									let sharedPosition = packedStatus.position = packedStatus.nextSharedPosition
									hasSharedUpdate = true
									if (sharedPosition < 16)
										target[position++] = sharedPosition + 0xc0

								}
							}
						} // else any in-doc incrementation?*/ } else if (samplingPackedValues && !options.pack) {
                        let status = samplingPackedValues.get(value);
                        if (status) status.count++;
                        else samplingPackedValues.set(value, {
                            count: 1
                        });
                    }
                }
                let strLength = value.length;
                if ($c38e2d25b6eee624$var$bundledStrings && strLength >= 4 && strLength < 0x400) {
                    if (($c38e2d25b6eee624$var$bundledStrings.size += strLength) > $c38e2d25b6eee624$var$MAX_BUNDLE_SIZE) {
                        let extStart;
                        let maxBytes = ($c38e2d25b6eee624$var$bundledStrings[0] ? $c38e2d25b6eee624$var$bundledStrings[0].length * 3 + $c38e2d25b6eee624$var$bundledStrings[1].length : 0) + 10;
                        if ($c38e2d25b6eee624$var$position + maxBytes > $c38e2d25b6eee624$var$safeEnd) $c38e2d25b6eee624$var$target = makeRoom($c38e2d25b6eee624$var$position + maxBytes);
                        $c38e2d25b6eee624$var$target[$c38e2d25b6eee624$var$position++] = 0xd9 // tag 16-bit
                        ;
                        $c38e2d25b6eee624$var$target[$c38e2d25b6eee624$var$position++] = 0xdf // tag 0xdff9
                        ;
                        $c38e2d25b6eee624$var$target[$c38e2d25b6eee624$var$position++] = 0xf9;
                        // TODO: If we only have one bundle with any string data, only write one string bundle
                        $c38e2d25b6eee624$var$target[$c38e2d25b6eee624$var$position++] = $c38e2d25b6eee624$var$bundledStrings.position ? 0x84 : 0x82 // array of 4 or 2 elements depending on if we write bundles
                        ;
                        $c38e2d25b6eee624$var$target[$c38e2d25b6eee624$var$position++] = 0x1a // 32-bit unsigned int
                        ;
                        extStart = $c38e2d25b6eee624$var$position - start;
                        $c38e2d25b6eee624$var$position += 4 // reserve for writing bundle reference
                        ;
                        if ($c38e2d25b6eee624$var$bundledStrings.position) $c38e2d25b6eee624$var$writeBundles(start, encode) // write the last bundles
                        ;
                        $c38e2d25b6eee624$var$bundledStrings = [
                            '',
                            ''
                        ] // create new ones
                        ;
                        $c38e2d25b6eee624$var$bundledStrings.size = 0;
                        $c38e2d25b6eee624$var$bundledStrings.position = extStart;
                    }
                    let twoByte = $c38e2d25b6eee624$var$hasNonLatin.test(value);
                    $c38e2d25b6eee624$var$bundledStrings[twoByte ? 0 : 1] += value;
                    $c38e2d25b6eee624$var$target[$c38e2d25b6eee624$var$position++] = twoByte ? 0xce : 0xcf;
                    encode(strLength);
                    return;
                }
                let headerSize;
                // first we estimate the header size, so we can write to the correct location
                if (strLength < 0x20) headerSize = 1;
                else if (strLength < 0x100) headerSize = 2;
                else if (strLength < 0x10000) headerSize = 3;
                else headerSize = 5;
                let maxBytes = strLength * 3;
                if ($c38e2d25b6eee624$var$position + maxBytes > $c38e2d25b6eee624$var$safeEnd) $c38e2d25b6eee624$var$target = makeRoom($c38e2d25b6eee624$var$position + maxBytes);
                if (strLength < 0x40 || !encodeUtf8) {
                    let i, c1, c2, strPosition = $c38e2d25b6eee624$var$position + headerSize;
                    for(i = 0; i < strLength; i++){
                        c1 = value.charCodeAt(i);
                        if (c1 < 0x80) $c38e2d25b6eee624$var$target[strPosition++] = c1;
                        else if (c1 < 0x800) {
                            $c38e2d25b6eee624$var$target[strPosition++] = c1 >> 6 | 0xc0;
                            $c38e2d25b6eee624$var$target[strPosition++] = c1 & 0x3f | 0x80;
                        } else if ((c1 & 0xfc00) === 0xd800 && ((c2 = value.charCodeAt(i + 1)) & 0xfc00) === 0xdc00) {
                            c1 = 0x10000 + ((c1 & 0x03ff) << 10) + (c2 & 0x03ff);
                            i++;
                            $c38e2d25b6eee624$var$target[strPosition++] = c1 >> 18 | 0xf0;
                            $c38e2d25b6eee624$var$target[strPosition++] = c1 >> 12 & 0x3f | 0x80;
                            $c38e2d25b6eee624$var$target[strPosition++] = c1 >> 6 & 0x3f | 0x80;
                            $c38e2d25b6eee624$var$target[strPosition++] = c1 & 0x3f | 0x80;
                        } else {
                            $c38e2d25b6eee624$var$target[strPosition++] = c1 >> 12 | 0xe0;
                            $c38e2d25b6eee624$var$target[strPosition++] = c1 >> 6 & 0x3f | 0x80;
                            $c38e2d25b6eee624$var$target[strPosition++] = c1 & 0x3f | 0x80;
                        }
                    }
                    length = strPosition - $c38e2d25b6eee624$var$position - headerSize;
                } else length = encodeUtf8(value, $c38e2d25b6eee624$var$position + headerSize, maxBytes);
                if (length < 0x18) $c38e2d25b6eee624$var$target[$c38e2d25b6eee624$var$position++] = 0x60 | length;
                else if (length < 0x100) {
                    if (headerSize < 2) $c38e2d25b6eee624$var$target.copyWithin($c38e2d25b6eee624$var$position + 2, $c38e2d25b6eee624$var$position + 1, $c38e2d25b6eee624$var$position + 1 + length);
                    $c38e2d25b6eee624$var$target[$c38e2d25b6eee624$var$position++] = 0x78;
                    $c38e2d25b6eee624$var$target[$c38e2d25b6eee624$var$position++] = length;
                } else if (length < 0x10000) {
                    if (headerSize < 3) $c38e2d25b6eee624$var$target.copyWithin($c38e2d25b6eee624$var$position + 3, $c38e2d25b6eee624$var$position + 2, $c38e2d25b6eee624$var$position + 2 + length);
                    $c38e2d25b6eee624$var$target[$c38e2d25b6eee624$var$position++] = 0x79;
                    $c38e2d25b6eee624$var$target[$c38e2d25b6eee624$var$position++] = length >> 8;
                    $c38e2d25b6eee624$var$target[$c38e2d25b6eee624$var$position++] = length & 0xff;
                } else {
                    if (headerSize < 5) $c38e2d25b6eee624$var$target.copyWithin($c38e2d25b6eee624$var$position + 5, $c38e2d25b6eee624$var$position + 3, $c38e2d25b6eee624$var$position + 3 + length);
                    $c38e2d25b6eee624$var$target[$c38e2d25b6eee624$var$position++] = 0x7a;
                    $c38e2d25b6eee624$var$targetView.setUint32($c38e2d25b6eee624$var$position, length);
                    $c38e2d25b6eee624$var$position += 4;
                }
                $c38e2d25b6eee624$var$position += length;
            } else if (type === 'number') {
                if (!this.alwaysUseFloat && value >>> 0 === value) {
                    // positive uint
                    if (value < 0x18) $c38e2d25b6eee624$var$target[$c38e2d25b6eee624$var$position++] = value;
                    else if (value < 0x100) {
                        $c38e2d25b6eee624$var$target[$c38e2d25b6eee624$var$position++] = 0x18;
                        $c38e2d25b6eee624$var$target[$c38e2d25b6eee624$var$position++] = value;
                    } else if (value < 0x10000) {
                        $c38e2d25b6eee624$var$target[$c38e2d25b6eee624$var$position++] = 0x19;
                        $c38e2d25b6eee624$var$target[$c38e2d25b6eee624$var$position++] = value >> 8;
                        $c38e2d25b6eee624$var$target[$c38e2d25b6eee624$var$position++] = value & 0xff;
                    } else {
                        $c38e2d25b6eee624$var$target[$c38e2d25b6eee624$var$position++] = 0x1a;
                        $c38e2d25b6eee624$var$targetView.setUint32($c38e2d25b6eee624$var$position, value);
                        $c38e2d25b6eee624$var$position += 4;
                    }
                } else if (!this.alwaysUseFloat && value >> 0 === value) {
                    if (value >= -24) $c38e2d25b6eee624$var$target[$c38e2d25b6eee624$var$position++] = 0x1f - value;
                    else if (value >= -256) {
                        $c38e2d25b6eee624$var$target[$c38e2d25b6eee624$var$position++] = 0x38;
                        $c38e2d25b6eee624$var$target[$c38e2d25b6eee624$var$position++] = ~value;
                    } else if (value >= -65536) {
                        $c38e2d25b6eee624$var$target[$c38e2d25b6eee624$var$position++] = 0x39;
                        $c38e2d25b6eee624$var$targetView.setUint16($c38e2d25b6eee624$var$position, ~value);
                        $c38e2d25b6eee624$var$position += 2;
                    } else {
                        $c38e2d25b6eee624$var$target[$c38e2d25b6eee624$var$position++] = 0x3a;
                        $c38e2d25b6eee624$var$targetView.setUint32($c38e2d25b6eee624$var$position, ~value);
                        $c38e2d25b6eee624$var$position += 4;
                    }
                } else if (!this.alwaysUseFloat && value < 0 && value >= -4294967296 && Math.floor(value) === value) {
                    // negative integer, 32-bit or less
                    $c38e2d25b6eee624$var$target[$c38e2d25b6eee624$var$position++] = 0x3a;
                    $c38e2d25b6eee624$var$targetView.setUint32($c38e2d25b6eee624$var$position, -1 - value);
                    $c38e2d25b6eee624$var$position += 4;
                } else {
                    let useFloat32;
                    if ((useFloat32 = this.useFloat32) > 0 && value < 0x100000000 && value >= -2147483648) {
                        $c38e2d25b6eee624$var$target[$c38e2d25b6eee624$var$position++] = 0xfa;
                        $c38e2d25b6eee624$var$targetView.setFloat32($c38e2d25b6eee624$var$position, value);
                        let xShifted;
                        if (useFloat32 < 4 || (xShifted = value * (0, $fec591ea5a7df9ff$export$c652a5bbb6be7a36)[($c38e2d25b6eee624$var$target[$c38e2d25b6eee624$var$position] & 0x7f) << 1 | $c38e2d25b6eee624$var$target[$c38e2d25b6eee624$var$position + 1] >> 7]) >> 0 === xShifted) {
                            $c38e2d25b6eee624$var$position += 4;
                            return;
                        } else $c38e2d25b6eee624$var$position-- // move back into position for writing a double
                        ;
                    }
                    $c38e2d25b6eee624$var$target[$c38e2d25b6eee624$var$position++] = 0xfb;
                    $c38e2d25b6eee624$var$targetView.setFloat64($c38e2d25b6eee624$var$position, value);
                    $c38e2d25b6eee624$var$position += 8;
                }
            } else if (type === 'object') {
                if (!value) $c38e2d25b6eee624$var$target[$c38e2d25b6eee624$var$position++] = 0xf6;
                else {
                    if (referenceMap) {
                        let referee = referenceMap.get(value);
                        if (referee) {
                            $c38e2d25b6eee624$var$target[$c38e2d25b6eee624$var$position++] = 0xd8;
                            $c38e2d25b6eee624$var$target[$c38e2d25b6eee624$var$position++] = 29 // http://cbor.schmorp.de/value-sharing
                            ;
                            $c38e2d25b6eee624$var$target[$c38e2d25b6eee624$var$position++] = 0x19 // 16-bit uint
                            ;
                            if (!referee.references) {
                                let idsToInsert = referenceMap.idsToInsert || (referenceMap.idsToInsert = []);
                                referee.references = [];
                                idsToInsert.push(referee);
                            }
                            referee.references.push($c38e2d25b6eee624$var$position - start);
                            $c38e2d25b6eee624$var$position += 2 // TODO: also support 32-bit
                            ;
                            return;
                        } else referenceMap.set(value, {
                            offset: $c38e2d25b6eee624$var$position - start
                        });
                    }
                    let constructor = value.constructor;
                    if (constructor === Object) {
                        if (this.skipFunction === true) value = Object.fromEntries([
                            ...Object.keys(value).filter((x)=>typeof value[x] !== "function").map((x)=>[
                                    x,
                                    value[x]
                                ])
                        ]);
                        writeObject(value);
                    } else if (constructor === Array) {
                        length = value.length;
                        if (length < 0x18) $c38e2d25b6eee624$var$target[$c38e2d25b6eee624$var$position++] = 0x80 | length;
                        else $c38e2d25b6eee624$var$writeArrayHeader(length);
                        for(let i = 0; i < length; i++)encode(value[i]);
                    } else if (constructor === Map) {
                        if (this.mapsAsObjects ? this.useTag259ForMaps !== false : this.useTag259ForMaps) {
                            // use Tag 259 (https://github.com/shanewholloway/js-cbor-codec/blob/master/docs/CBOR-259-spec--explicit-maps.md) for maps if the user wants it that way
                            $c38e2d25b6eee624$var$target[$c38e2d25b6eee624$var$position++] = 0xd9;
                            $c38e2d25b6eee624$var$target[$c38e2d25b6eee624$var$position++] = 1;
                            $c38e2d25b6eee624$var$target[$c38e2d25b6eee624$var$position++] = 3;
                        }
                        length = value.size;
                        if (length < 0x18) $c38e2d25b6eee624$var$target[$c38e2d25b6eee624$var$position++] = 0xa0 | length;
                        else if (length < 0x100) {
                            $c38e2d25b6eee624$var$target[$c38e2d25b6eee624$var$position++] = 0xb8;
                            $c38e2d25b6eee624$var$target[$c38e2d25b6eee624$var$position++] = length;
                        } else if (length < 0x10000) {
                            $c38e2d25b6eee624$var$target[$c38e2d25b6eee624$var$position++] = 0xb9;
                            $c38e2d25b6eee624$var$target[$c38e2d25b6eee624$var$position++] = length >> 8;
                            $c38e2d25b6eee624$var$target[$c38e2d25b6eee624$var$position++] = length & 0xff;
                        } else {
                            $c38e2d25b6eee624$var$target[$c38e2d25b6eee624$var$position++] = 0xba;
                            $c38e2d25b6eee624$var$targetView.setUint32($c38e2d25b6eee624$var$position, length);
                            $c38e2d25b6eee624$var$position += 4;
                        }
                        if (encoder.keyMap) for (let [key, entryValue] of value){
                            encode(encoder.encodeKey(key));
                            encode(entryValue);
                        }
                        else for (let [key, entryValue] of value){
                            encode(key);
                            encode(entryValue);
                        }
                    } else {
                        for(let i = 0, l = $c38e2d25b6eee624$var$extensions.length; i < l; i++){
                            let extensionClass = $c38e2d25b6eee624$var$extensionClasses[i];
                            if (value instanceof extensionClass) {
                                let extension = $c38e2d25b6eee624$var$extensions[i];
                                let tag = extension.tag;
                                if (tag == undefined) tag = extension.getTag && extension.getTag.call(this, value);
                                if (tag < 0x18) $c38e2d25b6eee624$var$target[$c38e2d25b6eee624$var$position++] = 0xc0 | tag;
                                else if (tag < 0x100) {
                                    $c38e2d25b6eee624$var$target[$c38e2d25b6eee624$var$position++] = 0xd8;
                                    $c38e2d25b6eee624$var$target[$c38e2d25b6eee624$var$position++] = tag;
                                } else if (tag < 0x10000) {
                                    $c38e2d25b6eee624$var$target[$c38e2d25b6eee624$var$position++] = 0xd9;
                                    $c38e2d25b6eee624$var$target[$c38e2d25b6eee624$var$position++] = tag >> 8;
                                    $c38e2d25b6eee624$var$target[$c38e2d25b6eee624$var$position++] = tag & 0xff;
                                } else if (tag > -1) {
                                    $c38e2d25b6eee624$var$target[$c38e2d25b6eee624$var$position++] = 0xda;
                                    $c38e2d25b6eee624$var$targetView.setUint32($c38e2d25b6eee624$var$position, tag);
                                    $c38e2d25b6eee624$var$position += 4;
                                } // else undefined, don't write tag
                                extension.encode.call(this, value, encode, makeRoom);
                                return;
                            }
                        }
                        if (value[Symbol.iterator]) {
                            if ($c38e2d25b6eee624$var$throwOnIterable) {
                                let error = new Error('Iterable should be serialized as iterator');
                                error.iteratorNotHandled = true;
                                throw error;
                            }
                            $c38e2d25b6eee624$var$target[$c38e2d25b6eee624$var$position++] = 0x9f // indefinite length array
                            ;
                            for (let entry of value)encode(entry);
                            $c38e2d25b6eee624$var$target[$c38e2d25b6eee624$var$position++] = 0xff // stop-code
                            ;
                            return;
                        }
                        if (value[Symbol.asyncIterator] || $c38e2d25b6eee624$var$isBlob(value)) {
                            let error = new Error('Iterable/blob should be serialized as iterator');
                            error.iteratorNotHandled = true;
                            throw error;
                        }
                        if (this.useToJSON && value.toJSON) {
                            const json = value.toJSON();
                            // if for some reason value.toJSON returns itself it'll loop forever
                            if (json !== value) return encode(json);
                        }
                        // no extension found, write as a plain object
                        writeObject(value);
                    }
                }
            } else if (type === 'boolean') $c38e2d25b6eee624$var$target[$c38e2d25b6eee624$var$position++] = value ? 0xf5 : 0xf4;
            else if (type === 'bigint') {
                if (value < BigInt(1) << BigInt(64) && value >= 0) {
                    // use an unsigned int as long as it fits
                    $c38e2d25b6eee624$var$target[$c38e2d25b6eee624$var$position++] = 0x1b;
                    $c38e2d25b6eee624$var$targetView.setBigUint64($c38e2d25b6eee624$var$position, value);
                } else if (value > -(BigInt(1) << BigInt(64)) && value < 0) {
                    // if we can fit an unsigned int, use that
                    $c38e2d25b6eee624$var$target[$c38e2d25b6eee624$var$position++] = 0x3b;
                    $c38e2d25b6eee624$var$targetView.setBigUint64($c38e2d25b6eee624$var$position, -value - BigInt(1));
                } else // overflow
                if (this.largeBigIntToFloat) {
                    $c38e2d25b6eee624$var$target[$c38e2d25b6eee624$var$position++] = 0xfb;
                    $c38e2d25b6eee624$var$targetView.setFloat64($c38e2d25b6eee624$var$position, Number(value));
                } else {
                    if (value >= BigInt(0)) $c38e2d25b6eee624$var$target[$c38e2d25b6eee624$var$position++] = 0xc2 // tag 2
                    ;
                    else {
                        $c38e2d25b6eee624$var$target[$c38e2d25b6eee624$var$position++] = 0xc3 // tag 2
                        ;
                        value = BigInt(-1) - value;
                    }
                    let bytes = [];
                    while(value){
                        bytes.push(Number(value & BigInt(0xff)));
                        value >>= BigInt(8);
                    }
                    $c38e2d25b6eee624$var$writeBuffer(new Uint8Array(bytes.reverse()), makeRoom);
                    return;
                }
                $c38e2d25b6eee624$var$position += 8;
            } else if (type === 'undefined') $c38e2d25b6eee624$var$target[$c38e2d25b6eee624$var$position++] = 0xf7;
            else throw new Error('Unknown type: ' + type);
        };
        const writeObject = this.useRecords === false ? this.variableMapSize ? (object)=>{
            // this method is slightly slower, but generates "preferred serialization" (optimally small for smaller objects)
            let keys = Object.keys(object);
            let vals = Object.values(object);
            let length = keys.length;
            if (length < 0x18) $c38e2d25b6eee624$var$target[$c38e2d25b6eee624$var$position++] = 0xa0 | length;
            else if (length < 0x100) {
                $c38e2d25b6eee624$var$target[$c38e2d25b6eee624$var$position++] = 0xb8;
                $c38e2d25b6eee624$var$target[$c38e2d25b6eee624$var$position++] = length;
            } else if (length < 0x10000) {
                $c38e2d25b6eee624$var$target[$c38e2d25b6eee624$var$position++] = 0xb9;
                $c38e2d25b6eee624$var$target[$c38e2d25b6eee624$var$position++] = length >> 8;
                $c38e2d25b6eee624$var$target[$c38e2d25b6eee624$var$position++] = length & 0xff;
            } else {
                $c38e2d25b6eee624$var$target[$c38e2d25b6eee624$var$position++] = 0xba;
                $c38e2d25b6eee624$var$targetView.setUint32($c38e2d25b6eee624$var$position, length);
                $c38e2d25b6eee624$var$position += 4;
            }
            let key;
            if (encoder.keyMap) for(let i = 0; i < length; i++){
                encode(encoder.encodeKey(keys[i]));
                encode(vals[i]);
            }
            else for(let i = 0; i < length; i++){
                encode(keys[i]);
                encode(vals[i]);
            }
        } : (object)=>{
            $c38e2d25b6eee624$var$target[$c38e2d25b6eee624$var$position++] = 0xb9 // always use map 16, so we can preallocate and set the length afterwards
            ;
            let objectOffset = $c38e2d25b6eee624$var$position - start;
            $c38e2d25b6eee624$var$position += 2;
            let size = 0;
            if (encoder.keyMap) {
                for(let key in object)if (typeof object.hasOwnProperty !== 'function' || object.hasOwnProperty(key)) {
                    encode(encoder.encodeKey(key));
                    encode(object[key]);
                    size++;
                }
            } else {
                for(let key in object)if (typeof object.hasOwnProperty !== 'function' || object.hasOwnProperty(key)) {
                    encode(key);
                    encode(object[key]);
                    size++;
                }
            }
            $c38e2d25b6eee624$var$target[objectOffset++ + start] = size >> 8;
            $c38e2d25b6eee624$var$target[objectOffset + start] = size & 0xff;
        } : (object, skipValues)=>{
            let nextTransition, transition = structures.transitions || (structures.transitions = Object.create(null));
            let newTransitions = 0;
            let length = 0;
            let parentRecordId;
            let keys;
            if (this.keyMap) {
                keys = Object.keys(object).map((k)=>this.encodeKey(k));
                length = keys.length;
                for(let i = 0; i < length; i++){
                    let key = keys[i];
                    nextTransition = transition[key];
                    if (!nextTransition) {
                        nextTransition = transition[key] = Object.create(null);
                        newTransitions++;
                    }
                    transition = nextTransition;
                }
            } else {
                for(let key in object)if (typeof object.hasOwnProperty !== 'function' || object.hasOwnProperty(key)) {
                    nextTransition = transition[key];
                    if (!nextTransition) {
                        if (transition[$c38e2d25b6eee624$var$RECORD_SYMBOL] & 0x100000) parentRecordId = transition[$c38e2d25b6eee624$var$RECORD_SYMBOL] & 0xffff;
                        nextTransition = transition[key] = Object.create(null);
                        newTransitions++;
                    }
                    transition = nextTransition;
                    length++;
                }
            }
            let recordId = transition[$c38e2d25b6eee624$var$RECORD_SYMBOL];
            if (recordId !== undefined) {
                recordId &= 0xffff;
                $c38e2d25b6eee624$var$target[$c38e2d25b6eee624$var$position++] = 0xd9;
                $c38e2d25b6eee624$var$target[$c38e2d25b6eee624$var$position++] = recordId >> 8 | 0xe0;
                $c38e2d25b6eee624$var$target[$c38e2d25b6eee624$var$position++] = recordId & 0xff;
            } else {
                if (!keys) keys = transition.__keys__ || (transition.__keys__ = Object.keys(object));
                if (parentRecordId === undefined) {
                    recordId = structures.nextId++;
                    if (!recordId) {
                        recordId = 0;
                        structures.nextId = 1;
                    }
                    if (recordId >= $c38e2d25b6eee624$var$MAX_STRUCTURES) structures.nextId = (recordId = maxSharedStructures) + 1;
                } else recordId = parentRecordId;
                structures[recordId] = keys;
                if (recordId < maxSharedStructures) {
                    $c38e2d25b6eee624$var$target[$c38e2d25b6eee624$var$position++] = 0xd9;
                    $c38e2d25b6eee624$var$target[$c38e2d25b6eee624$var$position++] = recordId >> 8 | 0xe0;
                    $c38e2d25b6eee624$var$target[$c38e2d25b6eee624$var$position++] = recordId & 0xff;
                    transition = structures.transitions;
                    for(let i = 0; i < length; i++){
                        if (transition[$c38e2d25b6eee624$var$RECORD_SYMBOL] === undefined || transition[$c38e2d25b6eee624$var$RECORD_SYMBOL] & 0x100000) transition[$c38e2d25b6eee624$var$RECORD_SYMBOL] = recordId;
                        transition = transition[keys[i]];
                    }
                    transition[$c38e2d25b6eee624$var$RECORD_SYMBOL] = recordId | 0x100000 // indicates it is a extendable terminal
                    ;
                    hasSharedUpdate = true;
                } else {
                    transition[$c38e2d25b6eee624$var$RECORD_SYMBOL] = recordId;
                    $c38e2d25b6eee624$var$targetView.setUint32($c38e2d25b6eee624$var$position, 0xd9dfff00) // tag two byte, then record definition id
                    ;
                    $c38e2d25b6eee624$var$position += 3;
                    if (newTransitions) transitionsCount += serializationsSinceTransitionRebuild * newTransitions;
                    // record the removal of the id, we can maintain our shared structure
                    if (recordIdsToRemove.length >= $c38e2d25b6eee624$var$MAX_STRUCTURES - maxSharedStructures) recordIdsToRemove.shift()[$c38e2d25b6eee624$var$RECORD_SYMBOL] = undefined // we are cycling back through, and have to remove old ones
                    ;
                    recordIdsToRemove.push(transition);
                    $c38e2d25b6eee624$var$writeArrayHeader(length + 2);
                    encode(0xe000 + recordId);
                    encode(keys);
                    if (skipValues) return; // special exit for iterator
                    for(let key in object)if (typeof object.hasOwnProperty !== 'function' || object.hasOwnProperty(key)) encode(object[key]);
                    return;
                }
            }
            if (length < 0x18) $c38e2d25b6eee624$var$target[$c38e2d25b6eee624$var$position++] = 0x80 | length;
            else $c38e2d25b6eee624$var$writeArrayHeader(length);
            if (skipValues) return; // special exit for iterator
            for(let key in object)if (typeof object.hasOwnProperty !== 'function' || object.hasOwnProperty(key)) encode(object[key]);
        };
        const makeRoom = (end)=>{
            let newSize;
            if (end > 0x1000000) {
                // special handling for really large buffers
                if (end - start > $c38e2d25b6eee624$var$MAX_BUFFER_SIZE) throw new Error('Encoded buffer would be larger than maximum buffer size');
                newSize = Math.min($c38e2d25b6eee624$var$MAX_BUFFER_SIZE, Math.round(Math.max((end - start) * (end > 0x4000000 ? 1.25 : 2), 0x400000) / 0x1000) * 0x1000);
            } else newSize = (Math.max(end - start << 2, $c38e2d25b6eee624$var$target.length - 1) >> 12) + 1 << 12;
            let newBuffer = new $c38e2d25b6eee624$var$ByteArrayAllocate(newSize);
            $c38e2d25b6eee624$var$targetView = new DataView(newBuffer.buffer, 0, newSize);
            if ($c38e2d25b6eee624$var$target.copy) $c38e2d25b6eee624$var$target.copy(newBuffer, 0, start, end);
            else newBuffer.set($c38e2d25b6eee624$var$target.slice(start, end));
            $c38e2d25b6eee624$var$position -= start;
            start = 0;
            $c38e2d25b6eee624$var$safeEnd = newBuffer.length - 10;
            return $c38e2d25b6eee624$var$target = newBuffer;
        };
        let chunkThreshold = 100;
        let continuedChunkThreshold = 1000;
        this.encodeAsIterable = function(value, options) {
            return startEncoding(value, options, encodeObjectAsIterable);
        };
        this.encodeAsAsyncIterable = function(value, options) {
            return startEncoding(value, options, encodeObjectAsAsyncIterable);
        };
        function* encodeObjectAsIterable(object, iterateProperties, finalIterable) {
            let constructor = object.constructor;
            if (constructor === Object) {
                let useRecords = encoder.useRecords !== false;
                if (useRecords) writeObject(object, true); // write the record identifier
                else $c38e2d25b6eee624$var$writeEntityLength(Object.keys(object).length, 0xa0);
                for(let key in object){
                    let value = object[key];
                    if (!useRecords) encode(key);
                    if (value && typeof value === 'object') {
                        if (iterateProperties[key]) yield* encodeObjectAsIterable(value, iterateProperties[key]);
                        else yield* tryEncode(value, iterateProperties, key);
                    } else encode(value);
                }
            } else if (constructor === Array) {
                let length = object.length;
                $c38e2d25b6eee624$var$writeArrayHeader(length);
                for(let i = 0; i < length; i++){
                    let value = object[i];
                    if (value && (typeof value === 'object' || $c38e2d25b6eee624$var$position - start > chunkThreshold)) {
                        if (iterateProperties.element) yield* encodeObjectAsIterable(value, iterateProperties.element);
                        else yield* tryEncode(value, iterateProperties, 'element');
                    } else encode(value);
                }
            } else if (object[Symbol.iterator] && !object.buffer) {
                $c38e2d25b6eee624$var$target[$c38e2d25b6eee624$var$position++] = 0x9f; // start indefinite array
                for (let value of object)if (value && (typeof value === 'object' || $c38e2d25b6eee624$var$position - start > chunkThreshold)) {
                    if (iterateProperties.element) yield* encodeObjectAsIterable(value, iterateProperties.element);
                    else yield* tryEncode(value, iterateProperties, 'element');
                } else encode(value);
                $c38e2d25b6eee624$var$target[$c38e2d25b6eee624$var$position++] = 0xff; // stop byte
            } else if ($c38e2d25b6eee624$var$isBlob(object)) {
                $c38e2d25b6eee624$var$writeEntityLength(object.size, 0x40); // encode as binary data
                yield $c38e2d25b6eee624$var$target.subarray(start, $c38e2d25b6eee624$var$position);
                yield object; // directly return blobs, they have to be encoded asynchronously
                restartEncoding();
            } else if (object[Symbol.asyncIterator]) {
                $c38e2d25b6eee624$var$target[$c38e2d25b6eee624$var$position++] = 0x9f; // start indefinite array
                yield $c38e2d25b6eee624$var$target.subarray(start, $c38e2d25b6eee624$var$position);
                yield object; // directly return async iterators, they have to be encoded asynchronously
                restartEncoding();
                $c38e2d25b6eee624$var$target[$c38e2d25b6eee624$var$position++] = 0xff; // stop byte
            } else encode(object);
            if (finalIterable && $c38e2d25b6eee624$var$position > start) yield $c38e2d25b6eee624$var$target.subarray(start, $c38e2d25b6eee624$var$position);
            else if ($c38e2d25b6eee624$var$position - start > chunkThreshold) {
                yield $c38e2d25b6eee624$var$target.subarray(start, $c38e2d25b6eee624$var$position);
                restartEncoding();
            }
        }
        function* tryEncode(value, iterateProperties, key) {
            let restart = $c38e2d25b6eee624$var$position - start;
            try {
                encode(value);
                if ($c38e2d25b6eee624$var$position - start > chunkThreshold) {
                    yield $c38e2d25b6eee624$var$target.subarray(start, $c38e2d25b6eee624$var$position);
                    restartEncoding();
                }
            } catch (error) {
                if (error.iteratorNotHandled) {
                    iterateProperties[key] = {};
                    $c38e2d25b6eee624$var$position = start + restart; // restart our position so we don't have partial data from last encode
                    yield* encodeObjectAsIterable.call(this, value, iterateProperties[key]);
                } else throw error;
            }
        }
        function restartEncoding() {
            chunkThreshold = continuedChunkThreshold;
            encoder.encode(null, $c38e2d25b6eee624$export$e724ae76933ea297); // restart encoding
        }
        function startEncoding(value, options, encodeIterable) {
            if (options && options.chunkThreshold) chunkThreshold = continuedChunkThreshold = options.chunkThreshold;
            else chunkThreshold = 100;
            if (value && typeof value === 'object') {
                encoder.encode(null, $c38e2d25b6eee624$export$e724ae76933ea297); // start encoding
                return encodeIterable(value, encoder.iterateProperties || (encoder.iterateProperties = {}), true);
            }
            return [
                encoder.encode(value)
            ];
        }
        async function* encodeObjectAsAsyncIterable(value, iterateProperties) {
            for (let encodedValue of encodeObjectAsIterable(value, iterateProperties, true)){
                let constructor = encodedValue.constructor;
                if (constructor === $c38e2d25b6eee624$var$ByteArray || constructor === Uint8Array) yield encodedValue;
                else if ($c38e2d25b6eee624$var$isBlob(encodedValue)) {
                    let reader = encodedValue.stream().getReader();
                    let next;
                    while(!(next = await reader.read()).done)yield next.value;
                } else if (encodedValue[Symbol.asyncIterator]) for await (let asyncValue of encodedValue){
                    restartEncoding();
                    if (asyncValue) yield* encodeObjectAsAsyncIterable(asyncValue, iterateProperties.async || (iterateProperties.async = {}));
                    else yield encoder.encode(asyncValue);
                }
                else yield encodedValue;
            }
        }
    }
    useBuffer(buffer) {
        // this means we are finished using our own buffer and we can write over it safely
        $c38e2d25b6eee624$var$target = buffer;
        $c38e2d25b6eee624$var$targetView = new DataView($c38e2d25b6eee624$var$target.buffer, $c38e2d25b6eee624$var$target.byteOffset, $c38e2d25b6eee624$var$target.byteLength);
        $c38e2d25b6eee624$var$position = 0;
    }
    clearSharedData() {
        if (this.structures) this.structures = [];
        if (this.sharedValues) this.sharedValues = undefined;
    }
    updateSharedData() {
        let lastVersion = this.sharedVersion || 0;
        this.sharedVersion = lastVersion + 1;
        let structuresCopy = this.structures.slice(0);
        let sharedData = new $c38e2d25b6eee624$var$SharedData(structuresCopy, this.sharedValues, this.sharedVersion);
        let saveResults = this.saveShared(sharedData, (existingShared)=>(existingShared && existingShared.version || 0) == lastVersion);
        if (saveResults === false) {
            // get updated structures and try again if the update failed
            sharedData = this.getShared() || {};
            this.structures = sharedData.structures || [];
            this.sharedValues = sharedData.packedValues;
            this.sharedVersion = sharedData.version;
            this.structures.nextId = this.structures.length;
        } else // restore structures
        structuresCopy.forEach((structure, i)=>this.structures[i] = structure);
        // saveShared may fail to write and reload, or may have reloaded to check compatibility and overwrite saved data, either way load the correct shared data
        return saveResults;
    }
}
function $c38e2d25b6eee624$var$writeEntityLength(length, majorValue) {
    if (length < 0x18) $c38e2d25b6eee624$var$target[$c38e2d25b6eee624$var$position++] = majorValue | length;
    else if (length < 0x100) {
        $c38e2d25b6eee624$var$target[$c38e2d25b6eee624$var$position++] = majorValue | 0x18;
        $c38e2d25b6eee624$var$target[$c38e2d25b6eee624$var$position++] = length;
    } else if (length < 0x10000) {
        $c38e2d25b6eee624$var$target[$c38e2d25b6eee624$var$position++] = majorValue | 0x19;
        $c38e2d25b6eee624$var$target[$c38e2d25b6eee624$var$position++] = length >> 8;
        $c38e2d25b6eee624$var$target[$c38e2d25b6eee624$var$position++] = length & 0xff;
    } else {
        $c38e2d25b6eee624$var$target[$c38e2d25b6eee624$var$position++] = majorValue | 0x1a;
        $c38e2d25b6eee624$var$targetView.setUint32($c38e2d25b6eee624$var$position, length);
        $c38e2d25b6eee624$var$position += 4;
    }
}
class $c38e2d25b6eee624$var$SharedData {
    constructor(structures, values, version){
        this.structures = structures;
        this.packedValues = values;
        this.version = version;
    }
}
function $c38e2d25b6eee624$var$writeArrayHeader(length) {
    if (length < 0x18) $c38e2d25b6eee624$var$target[$c38e2d25b6eee624$var$position++] = 0x80 | length;
    else if (length < 0x100) {
        $c38e2d25b6eee624$var$target[$c38e2d25b6eee624$var$position++] = 0x98;
        $c38e2d25b6eee624$var$target[$c38e2d25b6eee624$var$position++] = length;
    } else if (length < 0x10000) {
        $c38e2d25b6eee624$var$target[$c38e2d25b6eee624$var$position++] = 0x99;
        $c38e2d25b6eee624$var$target[$c38e2d25b6eee624$var$position++] = length >> 8;
        $c38e2d25b6eee624$var$target[$c38e2d25b6eee624$var$position++] = length & 0xff;
    } else {
        $c38e2d25b6eee624$var$target[$c38e2d25b6eee624$var$position++] = 0x9a;
        $c38e2d25b6eee624$var$targetView.setUint32($c38e2d25b6eee624$var$position, length);
        $c38e2d25b6eee624$var$position += 4;
    }
}
const $c38e2d25b6eee624$var$BlobConstructor = typeof Blob === 'undefined' ? function() {} : Blob;
function $c38e2d25b6eee624$var$isBlob(object) {
    if (object instanceof $c38e2d25b6eee624$var$BlobConstructor) return true;
    let tag = object[Symbol.toStringTag];
    return tag === 'Blob' || tag === 'File';
}
function $c38e2d25b6eee624$var$findRepetitiveStrings(value, packedValues) {
    switch(typeof value){
        case 'string':
            if (value.length > 3) {
                if (packedValues.objectMap[value] > -1 || packedValues.values.length >= packedValues.maxValues) return;
                let packedStatus = packedValues.get(value);
                if (packedStatus) {
                    if (++packedStatus.count == 2) packedValues.values.push(value);
                } else {
                    packedValues.set(value, {
                        count: 1
                    });
                    if (packedValues.samplingPackedValues) {
                        let status = packedValues.samplingPackedValues.get(value);
                        if (status) status.count++;
                        else packedValues.samplingPackedValues.set(value, {
                            count: 1
                        });
                    }
                }
            }
            break;
        case 'object':
            if (value) {
                if (value instanceof Array) for(let i = 0, l = value.length; i < l; i++)$c38e2d25b6eee624$var$findRepetitiveStrings(value[i], packedValues);
                else {
                    let includeKeys = !packedValues.encoder.useRecords;
                    for(var key in value)if (value.hasOwnProperty(key)) {
                        if (includeKeys) $c38e2d25b6eee624$var$findRepetitiveStrings(key, packedValues);
                        $c38e2d25b6eee624$var$findRepetitiveStrings(value[key], packedValues);
                    }
                }
            }
            break;
        case 'function':
            console.log(value);
    }
}
const $c38e2d25b6eee624$var$isLittleEndianMachine = new Uint8Array(new Uint16Array([
    1
]).buffer)[0] == 1;
$c38e2d25b6eee624$var$extensionClasses = [
    Date,
    Set,
    Error,
    RegExp,
    (0, $fec591ea5a7df9ff$export$3288d34c523a1192),
    ArrayBuffer,
    Uint8Array,
    Uint8ClampedArray,
    Uint16Array,
    Uint32Array,
    typeof BigUint64Array == 'undefined' ? function() {} : BigUint64Array,
    Int8Array,
    Int16Array,
    Int32Array,
    typeof BigInt64Array == 'undefined' ? function() {} : BigInt64Array,
    Float32Array,
    Float64Array,
    $c38e2d25b6eee624$var$SharedData
];
//Object.getPrototypeOf(Uint8Array.prototype).constructor /*TypedArray*/
$c38e2d25b6eee624$var$extensions = [
    {
        tag: 1,
        encode (date, encode) {
            let seconds = date.getTime() / 1000;
            if ((this.useTimestamp32 || date.getMilliseconds() === 0) && seconds >= 0 && seconds < 0x100000000) {
                // Timestamp 32
                $c38e2d25b6eee624$var$target[$c38e2d25b6eee624$var$position++] = 0x1a;
                $c38e2d25b6eee624$var$targetView.setUint32($c38e2d25b6eee624$var$position, seconds);
                $c38e2d25b6eee624$var$position += 4;
            } else {
                // Timestamp float64
                $c38e2d25b6eee624$var$target[$c38e2d25b6eee624$var$position++] = 0xfb;
                $c38e2d25b6eee624$var$targetView.setFloat64($c38e2d25b6eee624$var$position, seconds);
                $c38e2d25b6eee624$var$position += 8;
            }
        }
    },
    {
        tag: 258,
        encode (set, encode) {
            let array = Array.from(set);
            encode(array);
        }
    },
    {
        tag: 27,
        encode (error, encode) {
            encode([
                error.name,
                error.message
            ]);
        }
    },
    {
        tag: 27,
        encode (regex, encode) {
            encode([
                'RegExp',
                regex.source,
                regex.flags
            ]);
        }
    },
    {
        getTag (tag) {
            return tag.tag;
        },
        encode (tag, encode) {
            encode(tag.value);
        }
    },
    {
        encode (arrayBuffer, encode, makeRoom) {
            $c38e2d25b6eee624$var$writeBuffer(arrayBuffer, makeRoom);
        }
    },
    {
        getTag (typedArray) {
            if (typedArray.constructor === Uint8Array) {
                if (this.tagUint8Array || $c38e2d25b6eee624$var$hasNodeBuffer && this.tagUint8Array !== false) return 64;
            } // else no tag
        },
        encode (typedArray, encode, makeRoom) {
            $c38e2d25b6eee624$var$writeBuffer(typedArray, makeRoom);
        }
    },
    $c38e2d25b6eee624$var$typedArrayEncoder(68, 1),
    $c38e2d25b6eee624$var$typedArrayEncoder(69, 2),
    $c38e2d25b6eee624$var$typedArrayEncoder(70, 4),
    $c38e2d25b6eee624$var$typedArrayEncoder(71, 8),
    $c38e2d25b6eee624$var$typedArrayEncoder(72, 1),
    $c38e2d25b6eee624$var$typedArrayEncoder(77, 2),
    $c38e2d25b6eee624$var$typedArrayEncoder(78, 4),
    $c38e2d25b6eee624$var$typedArrayEncoder(79, 8),
    $c38e2d25b6eee624$var$typedArrayEncoder(85, 4),
    $c38e2d25b6eee624$var$typedArrayEncoder(86, 8),
    {
        encode (sharedData, encode) {
            let packedValues = sharedData.packedValues || [];
            let sharedStructures = sharedData.structures || [];
            if (packedValues.values.length > 0) {
                $c38e2d25b6eee624$var$target[$c38e2d25b6eee624$var$position++] = 0xd8 // one-byte tag
                ;
                $c38e2d25b6eee624$var$target[$c38e2d25b6eee624$var$position++] = 51 // tag 51 for packed shared structures https://www.potaroo.net/ietf/ids/draft-ietf-cbor-packed-03.txt
                ;
                $c38e2d25b6eee624$var$writeArrayHeader(4);
                let valuesArray = packedValues.values;
                encode(valuesArray);
                $c38e2d25b6eee624$var$writeArrayHeader(0) // prefixes
                ;
                $c38e2d25b6eee624$var$writeArrayHeader(0) // suffixes
                ;
                packedObjectMap = Object.create(sharedPackedObjectMap || null);
                for(let i = 0, l = valuesArray.length; i < l; i++)packedObjectMap[valuesArray[i]] = i;
            }
            if (sharedStructures) {
                $c38e2d25b6eee624$var$targetView.setUint32($c38e2d25b6eee624$var$position, 0xd9dffe00);
                $c38e2d25b6eee624$var$position += 3;
                let definitions = sharedStructures.slice(0);
                definitions.unshift(0xe000);
                definitions.push(new (0, $fec591ea5a7df9ff$export$3288d34c523a1192)(sharedData.version, 0x53687264));
                encode(definitions);
            } else encode(new (0, $fec591ea5a7df9ff$export$3288d34c523a1192)(sharedData.version, 0x53687264));
        }
    }
];
function $c38e2d25b6eee624$var$typedArrayEncoder(tag, size) {
    if (!$c38e2d25b6eee624$var$isLittleEndianMachine && size > 1) tag -= 4 // the big endian equivalents are 4 less
    ;
    return {
        tag: tag,
        encode: function writeExtBuffer(typedArray, encode) {
            let length = typedArray.byteLength;
            let offset = typedArray.byteOffset || 0;
            let buffer = typedArray.buffer || typedArray;
            encode($c38e2d25b6eee624$var$hasNodeBuffer ? $c38e2d25b6eee624$var$Buffer.from(buffer, offset, length) : new Uint8Array(buffer, offset, length));
        }
    };
}
function $c38e2d25b6eee624$var$writeBuffer(buffer, makeRoom) {
    let length = buffer.byteLength;
    if (length < 0x18) $c38e2d25b6eee624$var$target[$c38e2d25b6eee624$var$position++] = 0x40 + length;
    else if (length < 0x100) {
        $c38e2d25b6eee624$var$target[$c38e2d25b6eee624$var$position++] = 0x58;
        $c38e2d25b6eee624$var$target[$c38e2d25b6eee624$var$position++] = length;
    } else if (length < 0x10000) {
        $c38e2d25b6eee624$var$target[$c38e2d25b6eee624$var$position++] = 0x59;
        $c38e2d25b6eee624$var$target[$c38e2d25b6eee624$var$position++] = length >> 8;
        $c38e2d25b6eee624$var$target[$c38e2d25b6eee624$var$position++] = length & 0xff;
    } else {
        $c38e2d25b6eee624$var$target[$c38e2d25b6eee624$var$position++] = 0x5a;
        $c38e2d25b6eee624$var$targetView.setUint32($c38e2d25b6eee624$var$position, length);
        $c38e2d25b6eee624$var$position += 4;
    }
    if ($c38e2d25b6eee624$var$position + length >= $c38e2d25b6eee624$var$target.length) makeRoom($c38e2d25b6eee624$var$position + length);
    // if it is already a typed array (has an ArrayBuffer), use that, but if it is an ArrayBuffer itself,
    // must wrap it to set it.
    $c38e2d25b6eee624$var$target.set(buffer.buffer ? buffer : new Uint8Array(buffer), $c38e2d25b6eee624$var$position);
    $c38e2d25b6eee624$var$position += length;
}
function $c38e2d25b6eee624$var$insertIds(serialized, idsToInsert) {
    // insert the ids that need to be referenced for structured clones
    let nextId;
    let distanceToMove = idsToInsert.length * 2;
    let lastEnd = serialized.length - distanceToMove;
    idsToInsert.sort((a, b)=>a.offset > b.offset ? 1 : -1);
    for(let id = 0; id < idsToInsert.length; id++){
        let referee = idsToInsert[id];
        referee.id = id;
        for (let position of referee.references){
            serialized[position++] = id >> 8;
            serialized[position] = id & 0xff;
        }
    }
    while(nextId = idsToInsert.pop()){
        let offset = nextId.offset;
        serialized.copyWithin(offset + distanceToMove, offset, lastEnd);
        distanceToMove -= 2;
        let position = offset + distanceToMove;
        serialized[position++] = 0xd8;
        serialized[position++] = 28 // http://cbor.schmorp.de/value-sharing
        ;
        lastEnd = offset;
    }
    return serialized;
}
function $c38e2d25b6eee624$var$writeBundles(start, encode) {
    $c38e2d25b6eee624$var$targetView.setUint32($c38e2d25b6eee624$var$bundledStrings.position + start, $c38e2d25b6eee624$var$position - $c38e2d25b6eee624$var$bundledStrings.position - start + 1) // the offset to bundle
    ;
    let writeStrings = $c38e2d25b6eee624$var$bundledStrings;
    $c38e2d25b6eee624$var$bundledStrings = null;
    encode(writeStrings[0]);
    encode(writeStrings[1]);
}
function $c38e2d25b6eee624$export$4e11b2f4fcd6c82d(extension) {
    if (extension.Class) {
        if (!extension.encode) throw new Error('Extension has no encode function');
        $c38e2d25b6eee624$var$extensionClasses.unshift(extension.Class);
        $c38e2d25b6eee624$var$extensions.unshift(extension);
    }
    (0, $fec591ea5a7df9ff$export$4e11b2f4fcd6c82d)(extension);
}
let $c38e2d25b6eee624$var$defaultEncoder = new $c38e2d25b6eee624$export$a50aceb0e02a00aa({
    useRecords: false
});
const $c38e2d25b6eee624$export$c564cdbbe6da493 = $c38e2d25b6eee624$var$defaultEncoder.encode;
const $c38e2d25b6eee624$export$62a5d0ccbd8ba53e = $c38e2d25b6eee624$var$defaultEncoder.encodeAsIterable;
const $c38e2d25b6eee624$export$ba03bcdfc44f370a = $c38e2d25b6eee624$var$defaultEncoder.encodeAsAsyncIterable;
const { NEVER: $c38e2d25b6eee624$export$96c94437c95d7862, ALWAYS: $c38e2d25b6eee624$export$9252627518dcde93, DECIMAL_ROUND: $c38e2d25b6eee624$export$50de32e2440ab0bf, DECIMAL_FIT: $c38e2d25b6eee624$export$fa7c7714126eb380 } = (0, $fec591ea5a7df9ff$export$2239e49a3e351685);
const $c38e2d25b6eee624$export$d41ac1453288b342 = 512;
const $c38e2d25b6eee624$export$5687accb6effa257 = 1024;
const $c38e2d25b6eee624$export$e724ae76933ea297 = 2048;






var $b31a3889715d4145$require$Buffer = $51861dfc7ca9d588$export$a143d493d941bafc;
function $b31a3889715d4145$export$82db1b517a03d6f4(objectIterator, options = {}) {
    if (!objectIterator || typeof objectIterator !== 'object') throw new Error('first argument must be an Iterable, Async Iterable, or a Promise for an Async Iterable');
    else if (typeof objectIterator[Symbol.iterator] === 'function') return $b31a3889715d4145$var$encodeIterSync(objectIterator, options);
    else if (typeof objectIterator.then === 'function' || typeof objectIterator[Symbol.asyncIterator] === 'function') return $b31a3889715d4145$var$encodeIterAsync(objectIterator, options);
    else throw new Error('first argument must be an Iterable, Async Iterable, Iterator, Async Iterator, or a Promise');
}
function* $b31a3889715d4145$var$encodeIterSync(objectIterator, options) {
    const encoder = new (0, $c38e2d25b6eee624$export$a50aceb0e02a00aa)(options);
    for (const value of objectIterator)yield encoder.encode(value);
}
async function* $b31a3889715d4145$var$encodeIterAsync(objectIterator, options) {
    const encoder = new (0, $c38e2d25b6eee624$export$a50aceb0e02a00aa)(options);
    for await (const value of objectIterator)yield encoder.encode(value);
}
function $b31a3889715d4145$export$5201756020406471(bufferIterator, options = {}) {
    if (!bufferIterator || typeof bufferIterator !== 'object') throw new Error('first argument must be an Iterable, Async Iterable, Iterator, Async Iterator, or a promise');
    const decoder = new (0, $fec591ea5a7df9ff$export$f9de6ca0bc043724)(options);
    let incomplete;
    const parser = (chunk)=>{
        let yields;
        // if there's incomplete data from previous chunk, concatinate and try again
        if (incomplete) {
            chunk = $b31a3889715d4145$require$Buffer.concat([
                incomplete,
                chunk
            ]);
            incomplete = undefined;
        }
        try {
            yields = decoder.decodeMultiple(chunk);
        } catch (err) {
            if (err.incomplete) {
                incomplete = chunk.slice(err.lastPosition);
                yields = err.values;
            } else throw err;
        }
        return yields;
    };
    if (typeof bufferIterator[Symbol.iterator] === 'function') return function* iter() {
        for (const value of bufferIterator)yield* parser(value);
    }();
    else if (typeof bufferIterator[Symbol.asyncIterator] === 'function') return async function* iter() {
        for await (const value of bufferIterator)yield* parser(value);
    }();
}




function $801768f2dbeea819$export$c564cdbbe6da493(obj) {
    const encoder = new (0, $c38e2d25b6eee624$export$a50aceb0e02a00aa)({
        tagUint8Array: false,
        useRecords: false
    });
    return encoder.encode(obj);
}
function $801768f2dbeea819$export$2f872c0f2117be69(buf) {
    return (0, $fec591ea5a7df9ff$export$2f872c0f2117be69)(buf);
}


const $23cd2761638f0c26$export$1962463e0578ceb3 = (a, b)=>a.length === b.length && a.every((element, index)=>element === b[index]);


const $956570809efac935$export$f1581808060b6286 = (a, b)=>{
    return (0, $23cd2761638f0c26$export$1962463e0578ceb3)(a, b);
};


/* c8 ignore start */ /**
 * If `promise` is resolved before `t` ms elapse, the timeout is cleared and the result of the
 * promise is returned. If the timeout ends first, a `TimeoutError` is thrown.
 */ const $9ed6262ae2d58c93$export$e86e19342bc4850e = async (promise, t)=>{
    let timeoutId;
    const timeoutPromise = new Promise((_, reject)=>{
        timeoutId = setTimeout(()=>reject(new $9ed6262ae2d58c93$export$66d311bf29d5c89c(`withTimeout: timed out after ${t}ms`)), t);
    });
    try {
        return await Promise.race([
            promise,
            timeoutPromise
        ]);
    } finally{
        clearTimeout(timeoutId);
    }
};
class $9ed6262ae2d58c93$export$66d311bf29d5c89c extends Error {
    constructor(message){
        super(message);
        this.name = "TimeoutError";
    }
} /* c8 ignore end */ 


/**
 * An error thrown when an operation is aborted.
 *
 * @remarks
 * This error is thrown when an operation is aborted. It is a subclass of DOMException
 * with name "AbortError".
 *
 * @example
 * ```typescript
 * throw new AbortError()
 * ```
 */ class $5acd321f8117a579$export$18b052ffd8c84d7 extends DOMException {
    constructor(message){
        super(message ?? "Operation aborted", "AbortError");
    }
}
const $5acd321f8117a579$export$758b7261f3446d35 = (candidate)=>{
    return candidate instanceof $5acd321f8117a579$export$18b052ffd8c84d7 || (candidate instanceof Error || //In some JS environments, DOMException is not defined, and sometimes when defined, it does not extend Error; hence extra checks
    DOMException && candidate instanceof DOMException) && candidate.name === "AbortError";
};
function $5acd321f8117a579$export$930d1888c9e0cd90(p, signal) {
    let settled = false;
    return new Promise((resolve, reject)=>{
        signal?.addEventListener("abort", ()=>{
            if (!settled) reject(new $5acd321f8117a579$export$18b052ffd8c84d7());
        }, {
            once: true
        });
        p.then((result)=>{
            resolve(result);
        }).catch((error)=>{
            reject(error);
        }).finally(()=>{
            settled = true;
        });
    });
}




/**
 * Symbol used as discriminator for segments to avoid collision with user data.
 * Users might have objects with a 'kind' property in id patterns.
 */ const $a06f610e11c6dea9$export$79d3df7dce95d7c4 = "AUTOMERGE_REF_KIND";
const $a06f610e11c6dea9$export$c1d0705c3a028779 = "AUTOMERGE_REF_CURSOR_MARKER";




/**
 * # Path Segment Encoding Scheme
 *
 * | Type    | Format              | Example                    | Notes                           |
 * |---------|---------------------|----------------------------|---------------------------------|
 * | Key     | string              | `foo`, `my%2Fkey`          | Default, URL-encoded            |
 * | Index   | `@` + number        | `@0`, `@42`                | Array index                     |
 * | Match   | `{...}`             | `{"id":"alice"}`           | JSON object pattern (URL-encoded) |
 * | Cursors | `[start-end]`       | `[2@abc-5@def]`            | Cursor range                    |
 * | Cursors | `[cursor]`          | `[2@abc]`                  | Collapsed (start === end)       |
 *
 * ## Escape Rule
 * If a key starts with `@`, `{`, `[`, or `\`, prefix with `\` (URL-encoded as `%5C`):
 * - `\@at` → key "@at" (appears as `%5C%40at` in URL)
 * - `\{brace` → key "{brace" (appears as `%5C%7Bbrace` in URL)
 * - `\\backslash` → key "\backslash" (appears as `%5C%5Cbackslash` in URL)
 *
 * ## Parsing Priority (first match wins)
 * 1. Index: `@` + digits
 * 2. Match: `{...}` or URL-encoded `%7B...`
 * 3. Cursors: `[...]`
 * 4. Key: `\...` (escaped, URL-encoded as `%5C...`) or anything else
 */ const $0f558c6fd2f0e162$var$URL_PREFIX = "automerge:";
/** The escape character (backslash) */ const $0f558c6fd2f0e162$var$ESCAPE_CHAR = "\\";
/** URL-encoded form of the escape character for matching in URLs */ const $0f558c6fd2f0e162$var$ESCAPE_PREFIX = "%5C";
const $0f558c6fd2f0e162$var$INDEX_PREFIX = "@";
const $0f558c6fd2f0e162$var$CURSOR_OPEN = "[";
const $0f558c6fd2f0e162$var$CURSOR_CLOSE = "]";
const $0f558c6fd2f0e162$var$CURSOR_SEPARATOR = "-";
/** Characters that trigger escaping when at the start of a key */ const $0f558c6fd2f0e162$var$ESCAPE_TRIGGERS = [
    $0f558c6fd2f0e162$var$ESCAPE_CHAR,
    $0f558c6fd2f0e162$var$INDEX_PREFIX,
    "{",
    $0f558c6fd2f0e162$var$CURSOR_OPEN
];
const $0f558c6fd2f0e162$var$INDEX_PATTERN = /^@(\d+)$/;
const $0f558c6fd2f0e162$var$indexCodec = {
    kind: "index",
    match: (s)=>$0f558c6fd2f0e162$var$INDEX_PATTERN.test(s),
    parse: (s)=>{
        const m = s.match($0f558c6fd2f0e162$var$INDEX_PATTERN);
        if (!m) throw new Error(`Invalid index: ${s}`);
        return {
            [(0, $a06f610e11c6dea9$export$79d3df7dce95d7c4)]: "index",
            index: parseInt(m[1], 10)
        };
    },
    serialize: (seg)=>`${$0f558c6fd2f0e162$var$INDEX_PREFIX}${seg.index}`
};
const $0f558c6fd2f0e162$var$matchCodec = {
    kind: "match",
    // Match both raw JSON and URL-encoded JSON
    match: (s)=>s.startsWith("{") || s.startsWith("%7B"),
    parse: (s)=>{
        try {
            // Decode URL encoding first, then parse JSON
            // This handles both URL-encoded and raw JSON formats
            const decoded = decodeURIComponent(s);
            const parsed = JSON.parse(decoded);
            if (typeof parsed !== "object" || parsed === null || Array.isArray(parsed)) throw new Error("Match pattern must be a plain object");
            return {
                [(0, $a06f610e11c6dea9$export$79d3df7dce95d7c4)]: "match",
                match: parsed
            };
        } catch (e) {
            throw new Error(`Invalid match pattern: ${s}. ${e instanceof Error ? e.message : ""}`);
        }
    },
    // URL-encode the JSON to protect slashes and other special characters
    // from being interpreted as path separators
    serialize: (seg)=>encodeURIComponent(JSON.stringify(seg.match))
};
const $0f558c6fd2f0e162$var$cursorsCodec = {
    kind: "cursors",
    match: (s)=>s.startsWith($0f558c6fd2f0e162$var$CURSOR_OPEN) && s.endsWith($0f558c6fd2f0e162$var$CURSOR_CLOSE),
    parse: (s)=>{
        const inner = s.slice(1, -1);
        if (!inner) throw new Error("Invalid cursor range: empty brackets");
        const sepIndex = inner.indexOf($0f558c6fd2f0e162$var$CURSOR_SEPARATOR);
        if (sepIndex === -1) {
            const cursor = inner;
            return {
                [(0, $a06f610e11c6dea9$export$79d3df7dce95d7c4)]: "cursors",
                start: cursor,
                end: cursor
            };
        }
        const start = inner.slice(0, sepIndex);
        const end = inner.slice(sepIndex + 1);
        if (!start || !end) throw new Error(`Invalid cursor range: ${s}. Expected format: [cursor] or [start-end]`);
        return {
            [(0, $a06f610e11c6dea9$export$79d3df7dce95d7c4)]: "cursors",
            start: start,
            end: end
        };
    },
    serialize: (seg)=>{
        if (seg.start === seg.end) return `${$0f558c6fd2f0e162$var$CURSOR_OPEN}${seg.start}${$0f558c6fd2f0e162$var$CURSOR_CLOSE}`;
        return `${$0f558c6fd2f0e162$var$CURSOR_OPEN}${seg.start}${$0f558c6fd2f0e162$var$CURSOR_SEPARATOR}${seg.end}${$0f558c6fd2f0e162$var$CURSOR_CLOSE}`;
    }
};
const $0f558c6fd2f0e162$var$keyCodec = {
    kind: "key",
    match: (s)=>{
        // Escaped keys start with backslash (URL-encoded as %5C)
        if (s.startsWith($0f558c6fd2f0e162$var$ESCAPE_PREFIX) || s.startsWith($0f558c6fd2f0e162$var$ESCAPE_CHAR)) return true;
        // Regular keys don't start with special prefixes
        // We need to check both raw and URL-decoded forms
        const decoded = $0f558c6fd2f0e162$var$safeDecodeURIComponent(s);
        return !$0f558c6fd2f0e162$var$ESCAPE_TRIGGERS.some((p)=>s.startsWith(p) || decoded.startsWith(p));
    },
    parse: (s)=>{
        // Check for URL-encoded escape prefix (%5C) or literal backslash
        if (s.startsWith($0f558c6fd2f0e162$var$ESCAPE_PREFIX)) return {
            [(0, $a06f610e11c6dea9$export$79d3df7dce95d7c4)]: "key",
            key: decodeURIComponent(s.slice($0f558c6fd2f0e162$var$ESCAPE_PREFIX.length))
        };
        if (s.startsWith($0f558c6fd2f0e162$var$ESCAPE_CHAR)) return {
            [(0, $a06f610e11c6dea9$export$79d3df7dce95d7c4)]: "key",
            key: decodeURIComponent(s.slice($0f558c6fd2f0e162$var$ESCAPE_CHAR.length))
        };
        return {
            [(0, $a06f610e11c6dea9$export$79d3df7dce95d7c4)]: "key",
            key: decodeURIComponent(s)
        };
    },
    serialize: (seg)=>{
        // Check if key starts with any character that needs escaping
        const needsEscape = $0f558c6fd2f0e162$var$ESCAPE_TRIGGERS.some((p)=>seg.key.startsWith(p));
        const encoded = encodeURIComponent(seg.key);
        // Prefix with URL-encoded backslash (%5C) if escape needed
        return needsEscape ? `${$0f558c6fd2f0e162$var$ESCAPE_PREFIX}${encoded}` : encoded;
    }
};
/** Safely decode URI component, returning original string on error */ function $0f558c6fd2f0e162$var$safeDecodeURIComponent(s) {
    try {
        return decodeURIComponent(s);
    } catch  {
        return s;
    }
}
/**
 * Codecs in priority order. First matching codec wins for parsing.
 * Order: index → match → cursors → key (key is catch-all, must be last)
 */ const $0f558c6fd2f0e162$var$SEGMENT_CODECS = [
    $0f558c6fd2f0e162$var$indexCodec,
    $0f558c6fd2f0e162$var$matchCodec,
    $0f558c6fd2f0e162$var$cursorsCodec,
    $0f558c6fd2f0e162$var$keyCodec
];
function $0f558c6fd2f0e162$export$af89f897824e29a5(segment) {
    for (const codec of $0f558c6fd2f0e162$var$SEGMENT_CODECS){
        if (codec.match(segment)) return codec.parse(segment);
    }
    throw new Error(`Invalid segment: "${segment}"`);
}
function $0f558c6fd2f0e162$export$1e5a2416e28d1b7f(segment) {
    for (const codec of $0f558c6fd2f0e162$var$SEGMENT_CODECS){
        if (segment[0, $a06f610e11c6dea9$export$79d3df7dce95d7c4] === codec.kind) return codec.serialize(segment);
    }
    throw new Error(`No codec found for segment kind: ${segment[0, $a06f610e11c6dea9$export$79d3df7dce95d7c4]}`);
}
function $0f558c6fd2f0e162$export$8ccf933b0513f8d0(path) {
    if (!path) return [];
    const trimmed = path.replace(/^\/+|\/+$/g, "");
    if (!trimmed) throw new Error("Invalid path: path cannot be empty or consist only of slashes");
    if (trimmed.includes("//")) throw new Error("Invalid path: contains empty segment (double slash)");
    return trimmed.split("/").map($0f558c6fd2f0e162$export$af89f897824e29a5);
}
function $0f558c6fd2f0e162$export$2e1620420525139f(segments) {
    return segments.map($0f558c6fd2f0e162$export$1e5a2416e28d1b7f).join("/");
}
function $0f558c6fd2f0e162$export$344f7e040403495c(heads) {
    return heads ? heads.split("|") : undefined;
}
function $0f558c6fd2f0e162$export$e5d91f7f6fe5f096(heads) {
    return heads.length > 0 ? `#${heads.join("|")}` : "";
}
function $0f558c6fd2f0e162$export$1ccc49340267ee37(url) {
    const [baseUrl, headsSection, ...rest] = url.split("#");
    if (rest.length > 0) throw new Error("Invalid ref URL: contains multiple heads sections");
    const match = baseUrl.match(/^automerge:([^/]+)(?:\/(.*))?$/);
    if (!match) throw new Error(`Invalid ref URL: ${url}\n` + `Expected format: automerge:documentId/path/to/value#head1|head2`);
    const [, documentId, pathStr] = match;
    return {
        documentId: documentId,
        segments: pathStr ? $0f558c6fd2f0e162$export$8ccf933b0513f8d0(pathStr) : [],
        heads: $0f558c6fd2f0e162$export$344f7e040403495c(headsSection)
    };
}
function $0f558c6fd2f0e162$export$d0db8578b26f40fd(documentId, segments, heads) {
    const pathStr = $0f558c6fd2f0e162$export$2e1620420525139f(segments);
    const headsStr = heads ? $0f558c6fd2f0e162$export$e5d91f7f6fe5f096(heads) : "";
    return `${$0f558c6fd2f0e162$var$URL_PREFIX}${documentId}/${pathStr}${headsStr}`;
}


function $dccb15cc9d62971d$var$isObject(val) {
    return val !== null && typeof val === "object" && !Array.isArray(val);
}
function $dccb15cc9d62971d$export$54c78546e6f9aff(val) {
    return $dccb15cc9d62971d$var$isObject(val) && (0, $a06f610e11c6dea9$export$79d3df7dce95d7c4) in val;
}
function $dccb15cc9d62971d$export$5548536a65b0e92f(val) {
    return $dccb15cc9d62971d$var$isObject(val) && (0, $a06f610e11c6dea9$export$c1d0705c3a028779) in val;
}
function $dccb15cc9d62971d$export$41a28f5a000a9d0f(val) {
    return $dccb15cc9d62971d$var$isObject(val) && !$dccb15cc9d62971d$export$54c78546e6f9aff(val) && !$dccb15cc9d62971d$export$5548536a65b0e92f(val);
}
function $dccb15cc9d62971d$export$f21a847b360e13cd(str) {
    if (typeof str !== "string" || !str || !str.startsWith("automerge:")) return false;
    try {
        (0, $0f558c6fd2f0e162$export$1ccc49340267ee37)(str);
        return true;
    } catch  {
        return false;
    }
}






function $fcbad54e1dcba109$export$58734539bbfa41a2(start, end) {
    return {
        [(0, $a06f610e11c6dea9$export$c1d0705c3a028779)]: true,
        start: start,
        end: end ?? start
    };
}
function $fcbad54e1dcba109$export$bb788efb50077b39(handle, url) {
    const { documentId: documentId, segments: segments, heads: heads } = (0, $0f558c6fd2f0e162$export$1ccc49340267ee37)(url);
    if (documentId !== handle.documentId) throw new Error(`URL documentId "${documentId}" does not match handle's documentId "${handle.documentId}"`);
    // If URL has heads, get a time-traveled handle
    const targetHandle = heads ? handle.view((0, $73665c112ce7e927$export$5b2c9a3be6980e12)(heads)) : handle;
    return new (0, $9597508fb9559822$export$457d4d5cfb07df14)(targetHandle, segments);
}
function $fcbad54e1dcba109$export$75599ff8db233f33(docHandle, path) {
    const url = docHandle.url;
    const { segments: segments } = (0, $0f558c6fd2f0e162$export$1ccc49340267ee37)(`${url}/${path}`);
    return new (0, $9597508fb9559822$export$457d4d5cfb07df14)(docHandle, segments);
}
async function $fcbad54e1dcba109$export$c8b3cf89a301c078(repo, url) {
    const { documentId: documentId } = (0, $0f558c6fd2f0e162$export$1ccc49340267ee37)(url);
    const handle = await repo.find(documentId);
    await handle.whenReady();
    return $fcbad54e1dcba109$export$bb788efb50077b39(handle, url);
}
function $fcbad54e1dcba109$export$78e968efcca6b7ef(item, pattern) {
    return Object.entries(pattern).every(([key, value])=>item[key] === value);
}




function $2049b28c82b2b60a$export$6ea7326e800f2b0a(doc, propPath, value) {
    const mutations = {
        splice (index, deleteCount, insert) {
            $8a8016b162b6f8b4$export$869882364835d202(doc, propPath, index, deleteCount, insert);
        },
        updateText (newValue) {
            $8a8016b162b6f8b4$export$482314a40d8c0657(doc, propPath, newValue);
        }
    };
    return new Proxy(mutations, {
        get (target, prop) {
            // Automerge mutation methods
            if (prop in target) return target[prop];
            // Forward to underlying string
            const stringValue = value;
            const member = stringValue[prop];
            // Bind functions to the string value
            return typeof member === "function" ? member.bind(value) : member;
        },
        // Support iteration (for...of, spread)
        getPrototypeOf () {
            return String.prototype;
        }
    });
}


/**
 * FinalizationRegistry for automatic cleanup of Ref instances.
 * This ensures subscriptions are cleaned up when Refs are garbage collected,
 * even if dispose() is never called.
 */ const $9597508fb9559822$var$refCleanupRegistry = new FinalizationRegistry((cleanup)=>cleanup());
class $9597508fb9559822$export$457d4d5cfb07df14 {
    docHandle;
    path;
    range;
    #onChangeCallbacks = new Set();
    #updateHandler;
    constructor(docHandle, segments){
        this.docHandle = docHandle;
        const doc = docHandle.doc();
        const { path: path, range: range } = this.#normalizePath(doc, segments);
        this.path = path;
        this.range = range;
        this.#updateHandler = ()=>{
            const currentDoc = this.docHandle.doc();
            this.#updateProps(currentDoc);
        };
        this.docHandle.on("change", this.#updateHandler);
        // Register for automatic cleanup when this Ref is garbage collected
        $9597508fb9559822$var$refCleanupRegistry.register(this, ()=>this.#cleanup(), this);
    }
    #cleanup() {
        this.docHandle.off("change", this.#updateHandler);
        for (const callback of this.#onChangeCallbacks)this.docHandle.off("change", callback);
        this.#onChangeCallbacks.clear();
    }
    get rangePositions() {
        if (!this.range) return undefined;
        const propPath = this.#getPropPath();
        if (!propPath) return undefined;
        const doc = this.doc();
        return this.#getRangePositions(doc, propPath, this.range);
    }
    viewAt(heads) {
        const viewHandle = this.docHandle.view((0, $73665c112ce7e927$export$5b2c9a3be6980e12)(heads));
        return viewHandle.ref(...this.path);
    }
    value() {
        const doc = this.doc();
        const propPath = this.#getPropPath();
        if (!propPath) return undefined;
        const value = this.#getValueAt(doc, propPath);
        return this.range ? this.#extractRange(doc, propPath, value, this.range) : value;
    }
    doc() {
        return this.docHandle.doc();
    }
    change(fnOrValue) {
        if (this.docHandle.isReadOnly()) throw new Error("Cannot change a Ref on a read-only handle");
        // Convert direct value to function form
        const fn = typeof fnOrValue === "function" ? fnOrValue : ()=>fnOrValue;
        this.docHandle.change((doc)=>{
            if (this.path.length === 0 && !this.range) {
                fn(doc);
                return;
            }
            const propPath = this.#getPropPath();
            if (!propPath) throw new Error("Cannot resolve path");
            let current;
            if (this.range) {
                const parent = this.#getValueAt(doc, propPath);
                if (typeof parent !== "string") throw new Error("Range refs can only be used on string values");
                current = this.#extractRange(doc, propPath, parent, this.range);
            } else current = this.#getValueAt(doc, propPath);
            // If current is a string, wrap it in MutableText
            const valueToPass = typeof current === "string" ? (0, $2049b28c82b2b60a$export$6ea7326e800f2b0a)(doc, propPath, current) : current;
            const newValue = fn(valueToPass);
            if (newValue === undefined) return;
            // Warn if non-primitive value is returned (should mutate instead)
            if (!(newValue === null || typeof newValue === "string" || typeof newValue === "number" || typeof newValue === "boolean" || typeof newValue === "bigint")) console.warn("Ref.change() returned a non-primitive value. For objects and arrays, you should mutate them in place rather than returning a new instance. Returning new instances loses granular change tracking.");
            if (this.range) this.#spliceRange(doc, propPath, this.range, newValue);
            else this.#setValueAt(doc, propPath, newValue);
        });
    }
    remove() {
        if (this.docHandle.isReadOnly()) throw new Error("Cannot remove from a Ref on a read-only handle");
        if (this.path.length === 0 && !this.range) throw new Error("Cannot remove the root document");
        this.docHandle.change((doc)=>{
            const propPath = this.#getPropPath();
            if (!propPath || propPath.length === 0) throw new Error("Cannot resolve path for removal");
            // Handle range refs - delete the text within the range
            if (this.range) {
                this.#spliceRange(doc, propPath, this.range, "");
                return;
            }
            const parentPath = propPath.slice(0, -1);
            const key = propPath[propPath.length - 1];
            const parent = parentPath.length === 0 ? doc : this.#getValueAt(doc, parentPath);
            if (parent == null) throw new Error("Cannot remove: parent is null or undefined");
            if (Array.isArray(parent)) {
                if (typeof key !== "number") throw new Error("Cannot remove from array: key is not a number");
                parent.splice(key, 1);
            } else delete parent[key];
        });
    }
    onChange(callback) {
        const wrappedCallback = (payload)=>{
            if (this.#patchAffectsRef(payload.patches)) {
                const value = this.value();
                callback(value, payload);
            }
        };
        this.docHandle.on("change", wrappedCallback);
        // Track this callback so it can be cleaned up in dispose()
        this.#onChangeCallbacks.add(wrappedCallback);
        const unsubscribe = ()=>{
            this.docHandle.off("change", wrappedCallback);
            this.#onChangeCallbacks.delete(wrappedCallback);
        };
        return unsubscribe;
    }
    get url() {
        const allSegments = this.range ? [
            ...this.path,
            this.range
        ] : this.path;
        // Include heads in URL only for read-only (time-traveled) handles
        const heads = this.docHandle.isReadOnly() ? (0, $73665c112ce7e927$export$ebc2e4a21ab3cd04)(this.docHandle.heads()) : undefined;
        return (0, $0f558c6fd2f0e162$export$d0db8578b26f40fd)(this.docHandle.documentId, allSegments, heads);
    }
    equals(other) {
        return this.url === other.url;
    }
    contains(other) {
        // Must be same document
        if (this.docHandle.documentId !== other.docHandle.documentId) return false;
        // Must have same heads (compare handle URLs which include heads for read-only handles)
        if (this.docHandle.url !== other.docHandle.url) return false;
        // This path must be a prefix of other's path
        if (this.path.length >= other.path.length) return false;
        // Check if all segments match
        for(let i = 0; i < this.path.length; i++){
            if (!this.#segmentsEqual(this.path[i], other.path[i])) return false;
        }
        return true;
    }
    isChildOf(parent) {
        // Must be same document
        if (this.docHandle.documentId !== parent.docHandle.documentId) return false;
        // Must have same heads (compare handle URLs which include heads for read-only handles)
        if (this.docHandle.url !== parent.docHandle.url) return false;
        // Check if paths match up to parent's length
        if (this.path.length < parent.path.length) return false;
        // All of parent's path segments must match
        for(let i = 0; i < parent.path.length; i++){
            if (!this.#segmentsEqual(this.path[i], parent.path[i])) return false;
        }
        // Case 1: Same path length - only valid if this has a range and parent doesn't
        // (this is a range child of text)
        if (this.path.length === parent.path.length) return this.range !== undefined && parent.range === undefined;
        // Case 2: Path is exactly one segment longer (direct child)
        if (this.path.length === parent.path.length + 1) return true;
        // Case 3: Path is more than one segment longer (not a direct child)
        return false;
    }
    overlaps(other) {
        // Must be same document
        if (this.docHandle.documentId !== other.docHandle.documentId) return false;
        // Must have same heads (compare handle URLs which include heads for read-only handles)
        if (this.docHandle.url !== other.docHandle.url) return false;
        // Both must have ranges
        if (!this.range || !other.range) return false;
        // Paths must be identical (same parent location)
        if (this.path.length !== other.path.length) return false;
        for(let i = 0; i < this.path.length; i++){
            if (!this.#segmentsEqual(this.path[i], other.path[i])) return false;
        }
        // Check if ranges overlap
        // Get the numeric positions for both ranges
        const doc = this.doc();
        const propPath = this.#getPropPath();
        if (!propPath) return false;
        const thisPositions = this.#getRangePositions(doc, propPath, this.range);
        const otherPositions = this.#getRangePositions(doc, propPath, other.range);
        if (!thisPositions || !otherPositions) return false;
        const [thisStart, thisEnd] = thisPositions;
        const [otherStart, otherEnd] = otherPositions;
        // Ranges overlap if: thisStart < otherEnd && otherStart < thisEnd
        return thisStart < otherEnd && otherStart < thisEnd;
    }
    isEquivalent(other) {
        // Fast path: identity check
        if (this === other) return true;
        // Different documents can't be equivalent
        if (this.docHandle.documentId !== other.docHandle.documentId) return false;
        // Check heads equivalence
        // undefined heads means "current document state"
        // If one has undefined and other has explicit heads, check if they match current
        if (!this.#headsEquivalent(other)) return false;
        // Different path lengths can't be equivalent
        if (this.path.length !== other.path.length) return false;
        // Check range presence mismatch
        if (this.range === undefined !== (other.range === undefined)) return false;
        // Fast path: if segments are structurally equal, they're equivalent
        let segmentsEqual = true;
        for(let i = 0; i < this.path.length; i++)if (!this.#segmentsEqual(this.path[i], other.path[i])) {
            segmentsEqual = false;
            break;
        }
        if (segmentsEqual) {
            // Same path structure, now check ranges
            if (!this.range && !other.range) return true;
            // Both have ranges (checked above), compare them
            return this.range.start === other.range.start && this.range.end === other.range.end;
        }
        // Segments differ structurally - check if they resolve to the same prop path
        // Note: we access other.path[i].prop directly (public) instead of calling
        // private methods on other, since other may be from a different bundle
        for(let i = 0; i < this.path.length; i++){
            const thisProp = this.path[i].prop;
            const otherProp = other.path[i].prop;
            // If either can't be resolved, they're not equivalent
            if (thisProp === undefined || otherProp === undefined) return false;
            if (thisProp !== otherProp) return false;
        }
        // Prop paths match, now check ranges
        if (!this.range && !other.range) return true;
        // Both have ranges - compare cursor values
        return this.range.start === other.range.start && this.range.end === other.range.end;
    }
    valueOf() {
        return this.url;
    }
    toString() {
        return this.url;
    }
    /**
     * Check if this ref's heads are equivalent to another ref's heads.
     * A ref on a non-read-only handle represents "current document state",
     * so it's equivalent to a ref on a read-only handle with heads matching the current document.
     */ #headsEquivalent(other) {
        // If both handles have the same URL (including heads for read-only handles), they're equivalent
        if (this.docHandle.url === other.docHandle.url) return true;
        // Get effective heads for each - use handle's heads (which is current for non-read-only)
        const thisHeadsStr = this.docHandle.heads().join(",");
        const otherHeadsStr = other.docHandle.heads().join(",");
        return thisHeadsStr === otherHeadsStr;
    }
    /**
     * Normalize path inputs and extract stable IDs where possible.
     */ #normalizePath(doc, inputs) {
        const pathSegments = [];
        const propPath = [];
        let current = doc;
        let rangeSegment;
        for(let i = 0; i < inputs.length; i++){
            const input = inputs[i];
            // Handle cursor() marker - creates cursor-based range
            if ((0, $dccb15cc9d62971d$export$5548536a65b0e92f)(input)) {
                // cursor() must be the last segment
                if (i < inputs.length - 1) throw new Error("cursor() must be the last segment in a ref path. Segments after cursor() are not allowed.");
                rangeSegment = this.#createCursorRange(doc, propPath, current, input);
                break;
            }
            const segment = (0, $dccb15cc9d62971d$export$54c78546e6f9aff)(input) ? this.#ensureSegmentResolved(current, input) : this.#normalizeInput(current, input);
            if (segment[0, $a06f610e11c6dea9$export$79d3df7dce95d7c4] === "cursors") {
                // Cursor range from URL parsing - must also be last
                if (i < inputs.length - 1) throw new Error("Cursor range must be the last segment in a ref path. Segments after cursor range are not allowed.");
                rangeSegment = segment;
                break;
            }
            pathSegments.push(segment);
            if (segment.prop !== undefined && current !== undefined && current !== null) {
                propPath.push(segment.prop);
                current = current[segment.prop];
            }
        }
        return {
            path: pathSegments,
            range: rangeSegment
        };
    }
    /** Ensure a segment has its prop set */ #ensureSegmentResolved(container, segment) {
        const prop = this.#resolveSegmentProp(container, segment);
        return {
            ...segment,
            prop: prop
        };
    }
    /**
     * Resolve a path segment to its Automerge prop.
     * Returns undefined if the segment cannot be resolved.
     */ #resolveSegmentProp(container, segment) {
        if (container === undefined || container === null) return undefined;
        switch(segment[0, $a06f610e11c6dea9$export$79d3df7dce95d7c4]){
            case "key":
                return segment.key;
            case "index":
                return segment.index;
            case "match":
                {
                    if (!Array.isArray(container)) return undefined;
                    const matchIndex = container.findIndex((item)=>(0, $fcbad54e1dcba109$export$78e968efcca6b7ef)(item, segment.match));
                    return matchIndex !== -1 ? matchIndex : undefined;
                }
            case "cursors":
                return undefined;
            default:
                segment;
                return undefined;
        }
    }
    /** Update resolved props for all path segments based on current document state */ #updateProps(doc) {
        let current = doc;
        for (const segment of this.path){
            const prop = this.#resolveSegmentProp(current, segment);
            // Internal mutation: Update cached prop for efficient path resolution.
            // Safe because segments are owned by this Ref instance.
            segment.prop = prop;
            if (prop !== undefined && current !== undefined && current !== null) current = current[prop];
            else break;
        }
    }
    /**
     * Check if two PathSegments are equal.
     * Used by `contains` and `overlaps` methods.
     */ #segmentsEqual(a, b) {
        if (a[0, $a06f610e11c6dea9$export$79d3df7dce95d7c4] !== b[0, $a06f610e11c6dea9$export$79d3df7dce95d7c4]) return false;
        switch(a[0, $a06f610e11c6dea9$export$79d3df7dce95d7c4]){
            case "key":
                return a.key === b.key;
            case "index":
                return a.index === b.index;
            case "match":
                {
                    const aKeys = Object.keys(a.match);
                    const bKeys = Object.keys(b.match);
                    if (aKeys.length !== bKeys.length) return false;
                    return aKeys.every((key)=>a.match[key] === b.match[key]);
                }
            default:
                a;
                return false;
        }
    }
    #normalizeInput(container, input) {
        if (typeof input === "string") return {
            [(0, $a06f610e11c6dea9$export$79d3df7dce95d7c4)]: "key",
            key: input,
            prop: input
        };
        if (typeof input === "number") return {
            [(0, $a06f610e11c6dea9$export$79d3df7dce95d7c4)]: "index",
            index: input,
            prop: input
        };
        if ((0, $dccb15cc9d62971d$export$41a28f5a000a9d0f)(input)) {
            if (!Array.isArray(container)) return {
                [(0, $a06f610e11c6dea9$export$79d3df7dce95d7c4)]: "match",
                match: input,
                prop: undefined
            };
            const index = container.findIndex((obj)=>(0, $fcbad54e1dcba109$export$78e968efcca6b7ef)(obj, input));
            return {
                [(0, $a06f610e11c6dea9$export$79d3df7dce95d7c4)]: "match",
                match: input,
                prop: index !== -1 ? index : undefined
            };
        }
        throw new Error(`Unsupported path input type: ${typeof input}. ` + `Expected string, number, or plain object.`);
    }
    /** Create a cursor-based range from a CursorMarker */ #createCursorRange(doc, propPath, container, marker) {
        const { start: start, end: end } = marker;
        if (typeof container !== "string") throw new Error(`cursor() can only be used on string values, got ${typeof container}`);
        const startCursor = $8a8016b162b6f8b4$export$da3f040fb23d21f(doc, propPath, start);
        const endCursor = $8a8016b162b6f8b4$export$da3f040fb23d21f(doc, propPath, end);
        if (!startCursor || !endCursor) throw new Error(`Failed to create cursors at positions ${start}-${end}.`);
        return {
            [(0, $a06f610e11c6dea9$export$79d3df7dce95d7c4)]: "cursors",
            start: startCursor,
            end: endCursor
        };
    }
    /** Extract cached navigation path from segments */ #getPropPath() {
        const props = [];
        for (const segment of this.path){
            if (segment.prop === undefined) return undefined;
            props.push(segment.prop);
        }
        return props;
    }
    /** Navigate to a value by following a prop path */ #getValueAt(container, propPath) {
        let current = container;
        for (const prop of propPath){
            if (current == null) return undefined;
            current = current[prop];
        }
        return current;
    }
    /** Extract substring from a text value using a range */ #extractRange(doc, propPath, text, range) {
        const positions = this.#getRangePositions(doc, propPath, range);
        if (!positions) return undefined;
        return text.slice(positions[0], positions[1]);
    }
    /** Set a value at a prop path (change-only: mutates the doc proxy) */ #setValueAt(container, propPath, value) {
        if (propPath.length === 0) throw new Error("Internal error: #setValueAt called with empty path. Root document changes should be handled by the caller.");
        const parent = this.#getValueAt(container, propPath.slice(0, -1));
        if (parent == null) throw new Error("Cannot set value: parent is null or undefined");
        parent[propPath[propPath.length - 1]] = value;
    }
    /** Replace a substring at a range using Automerge.splice (change-only: mutates the doc proxy) */ #spliceRange(doc, propPath, range, newValue) {
        const positions = this.#getRangePositions(doc, propPath, range);
        if (!positions) throw new Error("Cannot resolve range positions");
        const [start, end] = positions;
        $8a8016b162b6f8b4$export$869882364835d202(doc, propPath, start, end - start, newValue);
    }
    /** Convert cursor positions to numeric [start, end] positions */ #getRangePositions(doc, propPath, range) {
        const start = $8a8016b162b6f8b4$export$47774cf7fb07bfc4(doc, propPath, range.start);
        const end = $8a8016b162b6f8b4$export$47774cf7fb07bfc4(doc, propPath, range.end);
        return start !== undefined && end !== undefined ? [
            start,
            end
        ] : undefined;
    }
    #patchAffectsRef(patches) {
        const refPropPath = [];
        for (const segment of this.path){
            if (segment.prop === undefined) break;
            refPropPath.push(segment.prop);
        }
        // If we couldn't resolve any part, ref was never valid - don't fire
        if (refPropPath.length === 0) return false;
        return patches.some((patch)=>this.#pathsOverlap(patch.path, refPropPath));
    }
    #pathsOverlap(patchPath, refPropPath) {
        const minLength = Math.min(patchPath.length, refPropPath.length);
        return patchPath.slice(0, minLength).every((prop, i)=>prop === refPropPath[i]);
    }
}


class $24957e09564e3864$export$adf9eb8d96703473 extends (0, (/*@__PURE__*/$parcel$interopDefault($28edd11f6c7e9f5f$exports))) {
    documentId;
    #log;
    /** The XState actor running our state machine.  */ #machine;
    /** If set, this handle will only show the document at these heads */ #fixedHeads;
    /** The last known state of our document. */ #prevDocState = (0, $8a8016b162b6f8b4$exports).init();
    /** How long to wait before giving up on a document. (Note that a document will be marked
     * unavailable much sooner if all known peers respond that they don't have it.) */ #timeoutDelay = 60000;
    /** A dictionary mapping each peer to the last known heads we have. */ #syncInfoByStorageId = {};
    /** Cache for view handles, keyed by the stringified heads */ #viewCache = new Map();
    /** Cache for ref instances, keyed by serialized path */ #refCache = new Map();
    /** @hidden */ constructor(documentId, options = {}){
        super();
        this.documentId = documentId;
        if ("timeoutDelay" in options && options.timeoutDelay) this.#timeoutDelay = options.timeoutDelay;
        if ("heads" in options) this.#fixedHeads = options.heads;
        const doc = (0, $8a8016b162b6f8b4$exports).init();
        this.#log = (0, (/*@__PURE__*/$parcel$interopDefault($1SXIy)))(`automerge-repo:dochandle:${this.documentId.slice(0, 5)}`);
        const delay = this.#timeoutDelay;
        const machine = (0, $21113145bdbb9065$export$de27182ff8187d6c)({
            types: {
                context: {},
                events: {}
            },
            actions: {
                /** Update the doc using the given callback and put the modified doc in context */ onUpdate: (0, $174145984b82c661$export$407448d2b89b1813)(({ context: context, event: event })=>{
                    const oldDoc = context.doc;
                    (0, $21113145bdbb9065$export$b3e112bfd3a4f448)(event, $24957e09564e3864$var$UPDATE);
                    const { callback: callback } = event.payload;
                    const doc = callback(oldDoc);
                    return {
                        doc: doc
                    };
                }),
                onDelete: (0, $174145984b82c661$export$407448d2b89b1813)(()=>{
                    this.emit("delete", {
                        handle: this
                    });
                    return {
                        doc: (0, $8a8016b162b6f8b4$exports).init()
                    };
                }),
                onUnavailable: (0, $174145984b82c661$export$407448d2b89b1813)(()=>{
                    return {
                        doc: (0, $8a8016b162b6f8b4$exports).init()
                    };
                }),
                onUnload: (0, $174145984b82c661$export$407448d2b89b1813)(()=>{
                    return {
                        doc: (0, $8a8016b162b6f8b4$exports).init()
                    };
                })
            }
        }).createMachine({
            /** @xstate-layout N4IgpgJg5mDOIC5QAoC2BDAxgCwJYDswBKAYgFUAFAEQEEAVAUQG0AGAXUVAAcB7WXAC64e+TiAAeiAOwAOAKwA6ACxSAzKqks1ATjlTdAGhABPRAFolAJksKN2y1KtKAbFLla5AX09G0WPISkVAwAMgyMrBxIILz8QiJikggAjCzOijKqLEqqybJyLizaRqYIFpbJtro5Uo7J2o5S3r4YOATECrgQADZgJADCAEoM9MzsYrGCwqLRSeoyCtra8pa5adquySXmDjY5ac7JljLJeepKzSB+bYGdPX0AYgCSAHJUkRN8UwmziM7HCgqyVcUnqcmScmcMm2ZV2yiyzkOx1OalUFx8V1aAQ63R46AgBCgJGGAEUyAwAMp0D7RSbxGagJKHFgKOSWJTJGRSCosCpKaEmRCqbQKU5yXINeTaer6LwY67YogKXH4wkkKgAeX6AH1hjQqABNGncL70xKIJQ5RY5BHOJag6wwpRyEWImQVeT1aWrVSXBXtJUqgn4Ik0ADqNCedG1L3CYY1gwA0saYqbpuaEG4pKLksKpFDgcsCjDhTnxTKpTLdH6sQGFOgAO7oKYhl5gAQNngAJwA1iRY3R40ndSNDSm6enfpm5BkWAVkvy7bpuTCKq7ndZnfVeSwuTX-HWu2AAI4AVzgQhD6q12rILxoADVIyEaAAhMLjtM-RmIE4LVSQi4nLLDIGzOCWwLKA0cgyLBoFWNy+43B0R5nheaqajqepjuMtJfgyEh-FoixqMCoKqOyhzgYKCDOq6UIeuCSxHOoSGKgop74OgABuzbdOgABGvTXlho5GrhJpxJOP4pLulT6KoMhpJY2hzsWNF0QobqMV6LG+pc+A8BAcBiP6gSfFJ36EQgKksksKxrHamwwmY7gLKB85QjBzoAWxdZdL0FnfARST8ooLC7qoTnWBU4pyC5ViVMKBQaHUDQuM4fm3EGhJBWaU7-CysEAUp3LpEpWw0WYRw2LmqzgqciIsCxWUdI2zaXlAbYdt2PZ5dJ1n5jY2iJY1ikOIcMJHCyUWHC62hRZkUVNPKta3Kh56wJ1-VWUyzhFc64JWJCtQNBBzhQW4cHwbsrVKpxPF8YJgV4ZZIWIKkiKiiNSkqZYWjzCWaQ5hFh0AcCuR3QoR74qUknBRmzholpv3OkpRQNNRpTzaKTWKbIWR5FDxm9AIkA7e9skUYCWayLILBZGoLkUSKbIyIdpxHPoyTeN4QA */ // You can use the XState extension for VS Code to visualize this machine.
            // Or, you can see this static visualization (last updated April 2024): https://stately.ai/registry/editor/d7af9b58-c518-44f1-9c36-92a238b04a7a?machineId=91c387e7-0f01-42c9-a21d-293e9bf95bb7
            initial: "idle",
            context: {
                documentId: documentId,
                doc: doc
            },
            on: {
                UPDATE: {
                    actions: "onUpdate"
                },
                UNLOAD: ".unloaded",
                DELETE: ".deleted"
            },
            states: {
                idle: {
                    on: {
                        BEGIN: "loading"
                    }
                },
                loading: {
                    on: {
                        REQUEST: "requesting",
                        DOC_READY: "ready"
                    },
                    after: {
                        [delay]: "unavailable"
                    }
                },
                requesting: {
                    on: {
                        DOC_UNAVAILABLE: "unavailable",
                        DOC_READY: "ready"
                    },
                    after: {
                        [delay]: "unavailable"
                    }
                },
                unavailable: {
                    entry: "onUnavailable",
                    on: {
                        DOC_READY: "ready"
                    }
                },
                ready: {},
                unloaded: {
                    entry: "onUnload",
                    on: {
                        RELOAD: "loading"
                    }
                },
                deleted: {
                    entry: "onDelete",
                    type: "final"
                }
            }
        });
        // Instantiate the state machine
        this.#machine = (0, $59def02d21be1ba1$export$db3b6bfb95261072)(machine);
        // Listen for state transitions
        this.#machine.subscribe((state)=>{
            const before = this.#prevDocState;
            const after = state.context.doc;
            this.#log(`\u{2192} ${state.value} %o`, after);
            // if the document has changed, emit a change event
            this.#checkForChanges(before, after);
        });
        // Start the machine, and send a create or find event to get things going
        this.#machine.start();
        this.begin();
    }
    // PRIVATE
    /** Returns the current document, regardless of state */ get #doc() {
        return this.#machine?.getSnapshot().context.doc;
    }
    /** Returns the docHandle's state (READY, etc.) */ get #state() {
        return this.#machine?.getSnapshot().value;
    }
    /**
     * Returns a promise that resolves when the docHandle is in one of the given states
     *
     * @param awaitStates - HandleState or HandleStates to wait for
     * @param signal - Optional AbortSignal to cancel the waiting operation
     */ #statePromise(awaitStates, options) {
        const awaitStatesArray = Array.isArray(awaitStates) ? awaitStates : [
            awaitStates
        ];
        return (0, $21113145bdbb9065$export$9bbfceb27f687c1b)(this.#machine, (s)=>awaitStatesArray.some((state)=>s.matches(state)), // use a longer delay here so as not to race with other delays
        {
            timeout: this.#timeoutDelay * 2,
            ...options
        });
    }
    /**
     * Update the document with whatever the result of callback is
     *
     * This is necessary instead of directly calling
     * `this.#machine.send({ type: UPDATE, payload: { callback } })` because we
     * want to catch any exceptions that the callback might throw, then rethrow
     * them after the state machine has processed the update.
     */ #sendUpdate(callback) {
        // This is kind of awkward. we have to pass the callback to xstate and wait for it to run it.
        // We're relying here on the fact that xstate runs everything synchronously, so by the time
        // `send` returns we know that the callback will have been run and so `thrownException`  will
        // be set if the callback threw an error.
        let thrownException = null;
        this.#machine.send({
            type: $24957e09564e3864$var$UPDATE,
            payload: {
                callback: (doc)=>{
                    try {
                        return callback(doc);
                    } catch (e) {
                        thrownException = e;
                        return doc;
                    }
                }
            }
        });
        if (thrownException) // If the callback threw an error, we throw it here so the caller can handle it
        throw thrownException;
    }
    /**
     * Called after state transitions. If the document has changed, emits a change event. If we just
     * received the document for the first time, signal that our request has been completed.
     */ #checkForChanges(before, after) {
        const beforeHeads = (0, $8a8016b162b6f8b4$exports).getHeads(before);
        const afterHeads = (0, $8a8016b162b6f8b4$exports).getHeads(after);
        const docChanged = !(0, $956570809efac935$export$f1581808060b6286)((0, $73665c112ce7e927$export$5b2c9a3be6980e12)(afterHeads), (0, $73665c112ce7e927$export$5b2c9a3be6980e12)(beforeHeads));
        if (docChanged) {
            this.emit("heads-changed", {
                handle: this,
                doc: after
            });
            const patches = (0, $8a8016b162b6f8b4$exports).diff(after, beforeHeads, afterHeads);
            if (patches.length > 0) this.emit("change", {
                handle: this,
                doc: after,
                patches: patches,
                // TODO: pass along the source (load/change/network)
                patchInfo: {
                    before: before,
                    after: after,
                    source: "change"
                }
            });
            // If we didn't have the document yet, signal that we now do
            if (!this.isReady()) this.#machine.send({
                type: $24957e09564e3864$var$DOC_READY
            });
        }
        this.#prevDocState = after;
    }
    // PUBLIC
    /** Our documentId in Automerge URL form.
     */ get url() {
        return (0, $73665c112ce7e927$export$6d38e899e24621e1)({
            documentId: this.documentId,
            heads: this.#fixedHeads
        });
    }
    /**
     * @returns true if the document is ready for accessing or changes.
     *
     * Note that for documents already stored locally this occurs before synchronization with any
     * peers. We do not currently have an equivalent `whenSynced()`.
     */ isReady = ()=>this.inState([
            "ready"
        ]);
    /**
     * @returns true if the document has been unloaded.
     *
     * Unloaded documents are freed from memory but not removed from local storage. It's not currently
     * possible at runtime to reload an unloaded document.
     */ isUnloaded = ()=>this.inState([
            "unloaded"
        ]);
    /**
     * @returns true if the document has been marked as deleted.
     *
     * Deleted documents are removed from local storage and the sync process. It's not currently
     * possible at runtime to undelete a document.
     */ isDeleted = ()=>this.inState([
            "deleted"
        ]);
    /**
     * @returns true if the document is currently unavailable.
     *
     * This will be the case if the document is not found in storage and no peers have shared it with us.
     */ isUnavailable = ()=>this.inState([
            "unavailable"
        ]);
    /**
     * @returns true if the handle is in one of the given states.
     */ inState = (states)=>states.some((s)=>this.#machine.getSnapshot().matches(s));
    /** @hidden */ get state() {
        return this.#machine.getSnapshot().value;
    }
    /**
     * Returns promise that resolves when document is in one of the given states (default is 'ready' state)
     *
     * Use this to block until the document handle has finished loading. The async equivalent to
     * checking `inState()`.
     *
     * @param awaitStates - HandleState or HandleStates to wait for
     * @param signal - Optional AbortSignal to cancel the waiting operation
     * @returns a promise that resolves when the document is in one of the given states (if no states
     * are passed, when the document is ready)
     */ async whenReady(awaitStates = [
        "ready"
    ], options) {
        try {
            await (0, $9ed6262ae2d58c93$export$e86e19342bc4850e)(this.#statePromise(awaitStates, options), this.#timeoutDelay);
        } catch (error) {
            if ((0, $5acd321f8117a579$export$758b7261f3446d35)(error)) throw new (0, $5acd321f8117a579$export$18b052ffd8c84d7)(); //throw new error for stack trace
            console.log(`error waiting for ${this.documentId} to be in one of states: ${awaitStates.join(", ")}`);
            throw error;
        }
    }
    /**
     * Returns the current state of the Automerge document this handle manages.
     *
     * @returns the current document
     * @throws on deleted and unavailable documents
     *
     */ doc() {
        if (!this.isReady()) throw new Error("DocHandle is not ready");
        if (this.#fixedHeads) return (0, $8a8016b162b6f8b4$exports).view(this.#doc, (0, $73665c112ce7e927$export$ebc2e4a21ab3cd04)(this.#fixedHeads));
        return this.#doc;
    }
    /**
     *
     * @deprecated */ docSync() {
        console.warn("docSync is deprecated. Use doc() instead. This function will be removed as part of the 2.0 release.");
        return this.doc();
    }
    /**
     * Returns the current "heads" of the document, akin to a git commit.
     * This precisely defines the state of a document.
     * @returns the current document's heads, or undefined if the document is not ready
     */ heads() {
        if (!this.isReady()) throw new Error("DocHandle is not ready");
        if (this.#fixedHeads) return this.#fixedHeads;
        return (0, $73665c112ce7e927$export$5b2c9a3be6980e12)((0, $8a8016b162b6f8b4$exports).getHeads(this.#doc));
    }
    begin() {
        this.#machine.send({
            type: $24957e09564e3864$var$BEGIN
        });
    }
    /**
     * Returns an array of all past "heads" for the document in topological order.
     *
     * @remarks
     * A point-in-time in an automerge document is an *array* of heads since there may be
     * concurrent edits. This API just returns a topologically sorted history of all edits
     * so every previous entry will be (in some sense) before later ones, but the set of all possible
     * history views would be quite large under concurrency (every thing in each branch against each other).
     * There might be a clever way to think about this, but we haven't found it yet, so for now at least
     * we present a single traversable view which excludes concurrency.
     * @returns UrlHeads[] - The individual heads for every change in the document. Each item is a tagged string[1].
     */ history() {
        if (!this.isReady()) return undefined;
        // This just returns all the heads as individual strings.
        return (0, $8a8016b162b6f8b4$exports).topoHistoryTraversal(this.#doc).map((h)=>(0, $73665c112ce7e927$export$5b2c9a3be6980e12)([
                h
            ]));
    }
    /**
     * Creates a fixed "view" of an automerge document at the given point in time represented
     * by the `heads` passed in. The return value is the same type as doc() and will return
     * undefined if the object hasn't finished loading.
     *
     * @remarks
     * Note that our Typescript types do not consider change over time and the current version
     * of Automerge doesn't check types at runtime, so if you go back to an old set of heads
     * that doesn't match the heads here, Typescript will not save you.
     *
     * @argument heads - The heads to view the document at. See history().
     * @returns DocHandle<T> at the time of `heads`
     */ view(heads) {
        if (!this.isReady()) throw new Error(`DocHandle#${this.documentId} is not ready. Check \`handle.isReady()\` before calling view().`);
        // Create a cache key from the heads
        const cacheKey = JSON.stringify(heads);
        // Check if we have a cached handle for these heads
        const cachedHandle = this.#viewCache.get(cacheKey);
        if (cachedHandle) return cachedHandle;
        // Create a new handle with the same documentId but fixed heads
        const handle = new $24957e09564e3864$export$adf9eb8d96703473(this.documentId, {
            heads: heads,
            timeoutDelay: this.#timeoutDelay
        });
        handle.update(()=>(0, $8a8016b162b6f8b4$exports).clone(this.#doc));
        handle.doneLoading();
        // Store in cache
        this.#viewCache.set(cacheKey, handle);
        return handle;
    }
    /**
     * Returns a set of Patch operations that will move a materialized document from one state to another
     * if applied.
     *
     * @remarks
     * We allow specifying either:
     * - Two sets of heads to compare directly
     * - A single set of heads to compare against our current heads
     * - Another DocHandle to compare against (which must share history with this document)
     *
     * @throws Error if the documents don't share history or if either document is not ready
     * @returns Automerge patches that go from one document state to the other
     */ diff(first, second) {
        if (!this.isReady()) throw new Error(`DocHandle#${this.documentId} is not ready. Check \`handle.isReady()\` before calling diff().`);
        const doc = this.#doc;
        if (!doc) throw new Error("Document not available");
        // If first argument is a DocHandle
        if (first instanceof $24957e09564e3864$export$adf9eb8d96703473) {
            if (!first.isReady()) throw new Error("Cannot diff against a handle that isn't ready");
            const otherHeads = first.heads();
            if (!otherHeads) throw new Error("Other document's heads not available");
            // Create a temporary merged doc to verify shared history and compute diff
            const mergedDoc = (0, $8a8016b162b6f8b4$exports).merge((0, $8a8016b162b6f8b4$exports).clone(doc), first.doc());
            // Use the merged doc to compute the diff
            return (0, $8a8016b162b6f8b4$exports).diff(mergedDoc, (0, $73665c112ce7e927$export$ebc2e4a21ab3cd04)(this.heads()), (0, $73665c112ce7e927$export$ebc2e4a21ab3cd04)(otherHeads));
        }
        // Otherwise treat as heads
        const from = second ? first : this.heads() || [];
        const to = second ? second : first;
        return (0, $8a8016b162b6f8b4$exports).diff(doc, (0, $73665c112ce7e927$export$ebc2e4a21ab3cd04)(from), (0, $73665c112ce7e927$export$ebc2e4a21ab3cd04)(to));
    }
    /**
     * `metadata(head?)` allows you to look at the metadata for a change
     * this can be used to build history graphs to find commit messages and edit times.
     * this interface.
     *
     * @remarks
     * I'm really not convinced this is the right way to surface this information so
     * I'm leaving this API "hidden".
     *
     * @hidden
     */ metadata(change) {
        if (!this.isReady()) return undefined;
        if (!change) change = this.heads()[0];
        // we return undefined instead of null by convention in this API
        return (0, $8a8016b162b6f8b4$exports).inspectChange(this.#doc, (0, $73665c112ce7e927$export$ebc2e4a21ab3cd04)([
            change
        ])[0]) || undefined;
    }
    /**
     * `update` is called any time we have a new document state; could be
     * from a local change, a remote change, or a new document from storage.
     * Does not cause state changes.
     * @hidden
     */ update(callback) {
        this.#sendUpdate(callback);
    }
    /**
     * `doneLoading` is called by the repo after it decides it has all the changes
     * it's going to get during setup. This might mean it was created locally,
     * or that it was loaded from storage, or that it was received from a peer.
     */ doneLoading() {
        this.#machine.send({
            type: $24957e09564e3864$var$DOC_READY
        });
    }
    /**
     * Called by the repo when a doc handle changes or we receive new remote heads.
     * @hidden
     */ setSyncInfo(storageId, syncInfo) {
        this.#syncInfoByStorageId[storageId] = syncInfo;
        this.emit("remote-heads", {
            storageId: storageId,
            heads: syncInfo.lastHeads,
            timestamp: syncInfo.lastSyncTimestamp
        });
    }
    /** Returns the heads of the storageId.
     *
     * @deprecated Use getSyncInfo instead.
     */ getRemoteHeads(storageId) {
        return this.#syncInfoByStorageId[storageId]?.lastHeads;
    }
    /** Returns the heads and the timestamp of the last update for the storageId. */ getSyncInfo(storageId) {
        return this.#syncInfoByStorageId[storageId];
    }
    /**
     * All changes to an Automerge document should be made through this method.
     * Inside the callback, the document should be treated as mutable: all edits will be recorded
     * using a Proxy and translated into operations as part of a single recorded "change".
     *
     * Note that assignment via ES6 spread operators will result in *replacing* the object
     * instead of mutating it which will prevent clean merges. This may be what you want, but
     * `doc.foo = { ...doc.foo, bar: "baz" }` is not equivalent to `doc.foo.bar = "baz"`.
     *
     * Local changes will be stored (by the StorageSubsystem) and synchronized (by the
     * DocSynchronizer) to any peers you are sharing it with.
     *
     * @param callback - A function that takes the current document and mutates it.
     *
     */ change(callback, options = {}) {
        if (!this.isReady()) throw new Error(`DocHandle#${this.documentId} is in ${this.state} and not ready. Check \`handle.isReady()\` before accessing the document.`);
        if (this.#fixedHeads) throw new Error(`DocHandle#${this.documentId} is in view-only mode at specific heads. Use clone() to create a new document from this state.`);
        this.#sendUpdate((doc)=>(0, $8a8016b162b6f8b4$exports).change(doc, options, callback));
    }
    /**
     * Makes a change as if the document were at `heads`.
     *
     * @returns A set of heads representing the concurrent change that was made.
     */ changeAt(heads, callback, options = {}) {
        if (!this.isReady()) throw new Error(`DocHandle#${this.documentId} is not ready. Check \`handle.isReady()\` before accessing the document.`);
        if (this.#fixedHeads) throw new Error(`DocHandle#${this.documentId} is in view-only mode at specific heads. Use clone() to create a new document from this state.`);
        let resultHeads = undefined;
        this.#sendUpdate((doc)=>{
            const result = (0, $8a8016b162b6f8b4$exports).changeAt(doc, (0, $73665c112ce7e927$export$ebc2e4a21ab3cd04)(heads), options, callback);
            resultHeads = result.newHeads ? (0, $73665c112ce7e927$export$5b2c9a3be6980e12)(result.newHeads) : undefined;
            return result.newDoc;
        });
        // the callback above will always run before we get here, so this should always contain the new heads
        return resultHeads;
    }
    /**
     * Check if the document can be change()ed. Currently, documents can be
     * edited unless we are viewing a particular point in time.
     *
     * @remarks It is technically possible to back-date changes using changeAt(),
     *          but we block it for usability reasons when viewing a particular point in time.
     *          To make changes in the past, use the primary document handle with no heads set.
     *
     * @returns boolean indicating whether changes are possible
     */ isReadOnly() {
        return !!this.#fixedHeads;
    }
    /**
     * Merges another document into this document. Any peers we are sharing changes with will be
     * notified of the changes resulting from the merge.
     *
     * @returns the merged document.
     *
     * @throws if either document is not ready or if `otherHandle` is unavailable.
     */ merge(/** the handle of the document to merge into this one */ otherHandle) {
        if (!this.isReady() || !otherHandle.isReady()) throw new Error("Both handles must be ready to merge");
        if (this.#fixedHeads) throw new Error(`DocHandle#${this.documentId} is in view-only mode at specific heads. Use clone() to create a new document from this state.`);
        const mergingDoc = otherHandle.doc();
        this.update((doc)=>{
            return (0, $8a8016b162b6f8b4$exports).merge(doc, mergingDoc);
        });
    }
    /**
     * Updates the internal state machine to mark the document unavailable.
     * @hidden
     */ unavailable() {
        this.#machine.send({
            type: $24957e09564e3864$var$DOC_UNAVAILABLE
        });
    }
    /**
     * Called by the repo either when the document is not found in storage.
     * @hidden
     * */ request() {
        if (this.#state === "loading") this.#machine.send({
            type: $24957e09564e3864$var$REQUEST
        });
    }
    /** Called by the repo to free memory used by the document. */ unload() {
        this.#machine.send({
            type: $24957e09564e3864$var$UNLOAD
        });
    }
    /** Called by the repo to reuse an unloaded handle. */ reload() {
        this.#machine.send({
            type: $24957e09564e3864$var$RELOAD
        });
    }
    /** Called by the repo when the document is deleted. */ delete() {
        this.#machine.send({
            type: $24957e09564e3864$var$DELETE
        });
    }
    /**
     * Sends an arbitrary ephemeral message out to all reachable peers who would receive sync messages
     * from you. It has no guarantee of delivery, and is not persisted to the underlying automerge doc
     * in any way. Messages will have a sending PeerId but this is *not* a useful user identifier (a
     * user could have multiple tabs open and would appear as multiple PeerIds). Every message source
     * must have a unique PeerId.
     */ broadcast(message) {
        this.emit("ephemeral-message-outbound", {
            handle: this,
            data: new Uint8Array((0, $801768f2dbeea819$export$c564cdbbe6da493)(message))
        });
    }
    metrics() {
        return (0, $8a8016b162b6f8b4$exports).stats(this.#doc);
    }
    /**
     * Create a ref to a location in this document.
     *
     * Returns the same ref instance for the same path, ensuring referential equality.
     *
     * @experimental This API is experimental and may change in future versions.
     *
     * @example
     * ```ts
     * const titleRef = handle.ref('todos', 0, 'title');
     * titleRef.value(); // string | undefined
     *
     * // Same ref instance is returned for same path
     * const sameRef = handle.ref('todos', 0, 'title');
     * titleRef === sameRef; // true
     * ```
     */ ref(...segments) {
        const cacheKey = this.#pathToCacheKey(segments);
        const existingRef = this.#refCache.get(cacheKey)?.deref();
        if (existingRef) return existingRef;
        // Create new ref and cache it
        const newRef = new (0, $9597508fb9559822$export$457d4d5cfb07df14)(this, segments);
        this.#refCache.set(cacheKey, new WeakRef(newRef));
        return newRef;
    }
    /**
     * Create a stable cache key from path segments.
     * Serializes the path to a string for comparison.
     */ #pathToCacheKey(segments) {
        return segments.map((seg)=>{
            if (typeof seg === "string") return `s:${seg}`;
            if (typeof seg === "number") return `n:${seg}`;
            if (typeof seg === "object" && seg !== null) // Pattern or CursorMarker
            return `o:${JSON.stringify(seg)}`;
            return `?:${String(seg)}`;
        }).join("/");
    }
}
const $24957e09564e3864$export$cc128a5510fe17b1 = {
    /** The handle has been created but not yet loaded or requested */ IDLE: "idle",
    /** We are waiting for storage to finish loading */ LOADING: "loading",
    /** We are waiting for someone in the network to respond to a sync request */ REQUESTING: "requesting",
    /** The document is available */ READY: "ready",
    /** The document has been unloaded from the handle, to free memory usage */ UNLOADED: "unloaded",
    /** The document has been deleted from the repo */ DELETED: "deleted",
    /** The document was not available in storage or from any connected peers */ UNAVAILABLE: "unavailable"
};
const { IDLE: $24957e09564e3864$export$49984ede44adf88d, LOADING: $24957e09564e3864$export$26d55645375ca9a, REQUESTING: $24957e09564e3864$export$1b7f27216269a67b, READY: $24957e09564e3864$export$4bf05b02be91f13a, UNLOADED: $24957e09564e3864$export$dcfeb5ccce46eb13, DELETED: $24957e09564e3864$export$1cc76b53f23597de, UNAVAILABLE: $24957e09564e3864$export$f2d101b977a134fd } = $24957e09564e3864$export$cc128a5510fe17b1;
const $24957e09564e3864$var$BEGIN = "BEGIN";
const $24957e09564e3864$var$REQUEST = "REQUEST";
const $24957e09564e3864$var$DOC_READY = "DOC_READY";
const $24957e09564e3864$var$UPDATE = "UPDATE";
const $24957e09564e3864$var$UNLOAD = "UNLOAD";
const $24957e09564e3864$var$RELOAD = "RELOAD";
const $24957e09564e3864$var$DELETE = "DELETE";
const $24957e09564e3864$var$TIMEOUT = "TIMEOUT";
const $24957e09564e3864$var$DOC_UNAVAILABLE = "DOC_UNAVAILABLE";





var $1SXIy = parcelRequire("1SXIy");





var $1SXIy = parcelRequire("1SXIy");
class $08b09118233ef298$export$d18166fc51e97dd extends (0, (/*@__PURE__*/$parcel$interopDefault($28edd11f6c7e9f5f$exports))) {
    // Last known heads and timestamp for each storageId that we know about
    #syncInfoByDocId = new Map();
    // Storage IDs we have subscribed to via Repo.subscribeToRemoteHeads
    #ourSubscriptions = new Set();
    // Storage IDs other peers have subscribed to by sending us a control message
    #theirSubscriptions = new Map();
    // Peers we will always share remote heads with even if they are not subscribed
    #generousPeers = new Set();
    // Documents each peer has open, we need this information so we only send remote heads of documents that the peer knows
    #subscribedDocsByPeer = new Map();
    #log = (0, (/*@__PURE__*/$parcel$interopDefault($1SXIy)))("automerge-repo:remote-heads-subscriptions");
    subscribeToRemotes(remotes) {
        this.#log("subscribeToRemotes", remotes);
        const remotesToAdd = [];
        for (const remote of remotes)if (!this.#ourSubscriptions.has(remote)) {
            this.#ourSubscriptions.add(remote);
            remotesToAdd.push(remote);
        }
        if (remotesToAdd.length > 0) this.emit("change-remote-subs", {
            add: remotesToAdd,
            peers: Array.from(this.#generousPeers)
        });
    }
    unsubscribeFromRemotes(remotes) {
        this.#log("subscribeToRemotes", remotes);
        const remotesToRemove = [];
        for (const remote of remotes)if (this.#ourSubscriptions.has(remote)) {
            this.#ourSubscriptions.delete(remote);
            if (!this.#theirSubscriptions.has(remote)) remotesToRemove.push(remote);
        }
        if (remotesToRemove.length > 0) this.emit("change-remote-subs", {
            remove: remotesToRemove,
            peers: Array.from(this.#generousPeers)
        });
    }
    handleControlMessage(control) {
        const remotesToAdd = [];
        const remotesToRemove = [];
        const addedRemotesWeKnow = [];
        this.#log("handleControlMessage", control);
        if (control.add) for (const remote of control.add){
            let theirSubs = this.#theirSubscriptions.get(remote);
            if (this.#ourSubscriptions.has(remote) || theirSubs) addedRemotesWeKnow.push(remote);
            if (!theirSubs) {
                theirSubs = new Set();
                this.#theirSubscriptions.set(remote, theirSubs);
                if (!this.#ourSubscriptions.has(remote)) remotesToAdd.push(remote);
            }
            theirSubs.add(control.senderId);
        }
        if (control.remove) for (const remote of control.remove){
            const theirSubs = this.#theirSubscriptions.get(remote);
            if (theirSubs) {
                theirSubs.delete(control.senderId);
                // if no one is subscribed anymore remove remote
                if (theirSubs.size == 0 && !this.#ourSubscriptions.has(remote)) remotesToRemove.push(remote);
            }
        }
        if (remotesToAdd.length > 0 || remotesToRemove.length > 0) this.emit("change-remote-subs", {
            peers: Array.from(this.#generousPeers),
            add: remotesToAdd,
            remove: remotesToRemove
        });
        // send all our stored heads of documents the peer knows for the remotes they've added
        for (const remote of addedRemotesWeKnow){
            const subscribedDocs = this.#subscribedDocsByPeer.get(control.senderId);
            if (subscribedDocs) for (const documentId of subscribedDocs){
                const syncInfo = this.#syncInfoByDocId.get(documentId);
                if (!syncInfo) continue;
                const syncInfoForRemote = syncInfo.get(remote);
                if (syncInfoForRemote) this.emit("notify-remote-heads", {
                    targetId: control.senderId,
                    documentId: documentId,
                    heads: syncInfoForRemote.lastHeads,
                    timestamp: syncInfoForRemote.lastSyncTimestamp,
                    storageId: remote
                });
            }
        }
    }
    /** A peer we are not directly connected to has changed their heads */ handleRemoteHeads(msg) {
        this.#log("handleRemoteHeads", msg);
        const changedHeads = this.#changedHeads(msg);
        // Emit a remote-heads-changed event to update local dochandles
        for (const event of changedHeads)if (this.#ourSubscriptions.has(event.storageId)) this.emit("remote-heads-changed", event);
        // Notify generous peers of these changes regardless of if they are subscribed to us
        for (const event of changedHeads)for (const peer of this.#generousPeers){
            // don't emit event to sender if sender is a generous peer
            if (peer === msg.senderId) continue;
            this.emit("notify-remote-heads", {
                targetId: peer,
                documentId: event.documentId,
                heads: event.remoteHeads,
                timestamp: event.timestamp,
                storageId: event.storageId
            });
        }
        // Notify subscribers of these changes
        for (const event of changedHeads){
            const theirSubs = this.#theirSubscriptions.get(event.storageId);
            if (theirSubs) {
                for (const peerId of theirSubs)if (this.#isPeerSubscribedToDoc(peerId, event.documentId)) this.emit("notify-remote-heads", {
                    targetId: peerId,
                    documentId: event.documentId,
                    heads: event.remoteHeads,
                    timestamp: event.timestamp,
                    storageId: event.storageId
                });
            }
        }
    }
    /** A peer we are directly connected to has updated their heads */ handleImmediateRemoteHeadsChanged(documentId, storageId, heads) {
        this.#log("handleLocalHeadsChanged", documentId, storageId, heads);
        const remote = this.#syncInfoByDocId.get(documentId);
        const timestamp = Date.now();
        if (!remote) this.#syncInfoByDocId.set(documentId, new Map([
            [
                storageId,
                {
                    lastSyncTimestamp: timestamp,
                    lastHeads: heads
                }
            ]
        ]));
        else {
            const docRemote = remote.get(storageId);
            if (!docRemote || docRemote.lastSyncTimestamp < Date.now()) remote.set(storageId, {
                lastSyncTimestamp: Date.now(),
                lastHeads: heads
            });
        }
        const theirSubs = this.#theirSubscriptions.get(storageId);
        if (theirSubs) {
            for (const peerId of theirSubs)if (this.#isPeerSubscribedToDoc(peerId, documentId)) this.emit("notify-remote-heads", {
                targetId: peerId,
                documentId: documentId,
                heads: heads,
                timestamp: timestamp,
                storageId: storageId
            });
        }
    }
    addGenerousPeer(peerId) {
        this.#log("addGenerousPeer", peerId);
        this.#generousPeers.add(peerId);
        if (this.#ourSubscriptions.size > 0) this.emit("change-remote-subs", {
            add: Array.from(this.#ourSubscriptions),
            peers: [
                peerId
            ]
        });
        for (const [documentId, remote] of this.#syncInfoByDocId)for (const [storageId, { lastHeads: lastHeads, lastSyncTimestamp: lastSyncTimestamp }] of remote)this.emit("notify-remote-heads", {
            targetId: peerId,
            documentId: documentId,
            heads: lastHeads,
            timestamp: lastSyncTimestamp,
            storageId: storageId
        });
    }
    removePeer(peerId) {
        this.#log("removePeer", peerId);
        const remotesToRemove = [];
        this.#generousPeers.delete(peerId);
        this.#subscribedDocsByPeer.delete(peerId);
        for (const [storageId, peerIds] of this.#theirSubscriptions)if (peerIds.has(peerId)) {
            peerIds.delete(peerId);
            if (peerIds.size == 0) {
                remotesToRemove.push(storageId);
                this.#theirSubscriptions.delete(storageId);
            }
        }
        if (remotesToRemove.length > 0) this.emit("change-remote-subs", {
            remove: remotesToRemove,
            peers: Array.from(this.#generousPeers)
        });
    }
    subscribePeerToDoc(peerId, documentId) {
        let subscribedDocs = this.#subscribedDocsByPeer.get(peerId);
        if (!subscribedDocs) {
            subscribedDocs = new Set();
            this.#subscribedDocsByPeer.set(peerId, subscribedDocs);
        }
        subscribedDocs.add(documentId);
        const remoteHeads = this.#syncInfoByDocId.get(documentId);
        if (remoteHeads) for (const [storageId, lastHeads] of remoteHeads){
            const subscribedPeers = this.#theirSubscriptions.get(storageId);
            if (subscribedPeers && subscribedPeers.has(peerId)) this.emit("notify-remote-heads", {
                targetId: peerId,
                documentId: documentId,
                heads: lastHeads.lastHeads,
                timestamp: lastHeads.lastSyncTimestamp,
                storageId: storageId
            });
        }
    }
    #isPeerSubscribedToDoc(peerId, documentId) {
        const subscribedDocs = this.#subscribedDocsByPeer.get(peerId);
        return subscribedDocs && subscribedDocs.has(documentId);
    }
    /** Returns the (document, storageId) pairs which have changed after processing msg */ #changedHeads(msg) {
        const changedHeads = [];
        const { documentId: documentId, newHeads: newHeads } = msg;
        for (const [storageId, { heads: heads, timestamp: timestamp }] of Object.entries(newHeads)){
            if (!this.#ourSubscriptions.has(storageId) && !this.#theirSubscriptions.has(storageId)) continue;
            let remote = this.#syncInfoByDocId.get(documentId);
            if (!remote) {
                remote = new Map();
                this.#syncInfoByDocId.set(documentId, remote);
            }
            const docRemote = remote.get(storageId);
            if (docRemote && docRemote.lastSyncTimestamp >= timestamp) continue;
            else {
                remote.set(storageId, {
                    lastSyncTimestamp: timestamp,
                    lastHeads: heads
                });
                changedHeads.push({
                    documentId: documentId,
                    storageId: storageId,
                    remoteHeads: heads,
                    timestamp: timestamp
                });
            }
        }
        return changedHeads;
    }
}



/** Throttle
 * Returns a function with a built in throttle timer that runs after `delay` ms.
 *
 * This function differs from a conventional `throttle` in that it ensures the final
 * call will also execute and delays sending the first one until `delay` ms to allow
 * additional work to accumulate.
 *
 * Here's a diagram:
 *
 * calls +----++++++-----++----
 * dlay  ^--v ^--v^--v   ^--v
 * execs ---+----+---+------+--
 *
 * The goal in this design is to create batches of changes without flooding
 * communication or storage systems while still feeling responsive.
 * (By default we communicate at 10hz / every 100ms.)
 *
 * Note that the args go inside the parameter and you should be careful not to
 * recreate the function on each usage. (In React, see useMemo().)
 *
 *
 * Example usage:
 * const callback = throttle((ev) => { doSomethingExpensiveOrOccasional() }, 100)
 * target.addEventListener('frequent-event', callback);
 *
 */ const $147c725b0c5cefa5$export$de363e709c412c8a = (fn, delay)=>{
    let lastCall = Date.now();
    let wait;
    let timeout;
    return function(...args) {
        wait = lastCall + delay - Date.now();
        clearTimeout(timeout);
        timeout = setTimeout(()=>{
            fn(...args);
            lastCall = Date.now();
        }, wait);
    };
};



var $1SXIy = parcelRequire("1SXIy");

// TYPE GUARDS
const $f7f9859bbb7f91eb$export$d1d1b29521a1a1d5 = (message)=>$f7f9859bbb7f91eb$export$215110dfa9a9f972(message) || $f7f9859bbb7f91eb$export$9d67bd6f3f072841(message) || $f7f9859bbb7f91eb$export$ba7103d54f1e2117(message) || $f7f9859bbb7f91eb$export$f3aaddbcfd12e0b5(message) || $f7f9859bbb7f91eb$export$fcd6c362350e189d(message) || $f7f9859bbb7f91eb$export$70db02413dda606b(message);
const $f7f9859bbb7f91eb$export$f3aaddbcfd12e0b5 = (msg)=>msg.type === "doc-unavailable";
const $f7f9859bbb7f91eb$export$ba7103d54f1e2117 = (msg)=>msg.type === "request";
const $f7f9859bbb7f91eb$export$215110dfa9a9f972 = (msg)=>msg.type === "sync";
const $f7f9859bbb7f91eb$export$9d67bd6f3f072841 = (msg)=>msg.type === "ephemeral";
const $f7f9859bbb7f91eb$export$fcd6c362350e189d = (msg)=>msg.type === "remote-subscription-change";
const $f7f9859bbb7f91eb$export$70db02413dda606b = (msg)=>msg.type === "remote-heads-changed";


const $cc58c014abe1974c$var$getEphemeralMessageSource = (message)=>`${message.senderId}:${message.sessionId}`;
class $cc58c014abe1974c$export$4b74e73b341d6846 extends (0, (/*@__PURE__*/$parcel$interopDefault($28edd11f6c7e9f5f$exports))) {
    peerId;
    peerMetadata;
    #log;
    #adaptersByPeer = {};
    #count = 0;
    #sessionId = Math.random().toString(36).slice(2);
    #ephemeralSessionCounts = {};
    adapters = [];
    constructor(adapters, peerId, peerMetadata){
        super();
        this.peerId = peerId;
        this.peerMetadata = peerMetadata;
        this.#log = (0, (/*@__PURE__*/$parcel$interopDefault($1SXIy)))(`automerge-repo:network:${this.peerId}`);
        adapters.forEach((a)=>this.addNetworkAdapter(a));
    }
    disconnect() {
        this.adapters.forEach((a)=>a.disconnect());
    }
    reconnect() {
        this.adapters.forEach((a)=>a.connect(this.peerId));
    }
    addNetworkAdapter(networkAdapter) {
        this.adapters.push(networkAdapter);
        networkAdapter.on("peer-candidate", ({ peerId: peerId, peerMetadata: peerMetadata })=>{
            this.#log(`peer candidate: ${peerId} `);
            // TODO: This is where authentication would happen
            // TODO: on reconnection, this would create problems!
            // the server would see a reconnection as a late-arriving channel
            // for an existing peer and decide to ignore it until the connection
            // times out: turns out my ICE/SIP emulation laziness did not pay off here
            if (!this.#adaptersByPeer[peerId]) // TODO: handle losing a server here
            this.#adaptersByPeer[peerId] = networkAdapter;
            this.emit("peer", {
                peerId: peerId,
                peerMetadata: peerMetadata
            });
        });
        networkAdapter.on("peer-disconnected", ({ peerId: peerId })=>{
            this.#log(`peer disconnected: ${peerId} `);
            delete this.#adaptersByPeer[peerId];
            this.emit("peer-disconnected", {
                peerId: peerId
            });
        });
        networkAdapter.on("message", (msg)=>{
            if (!(0, $f7f9859bbb7f91eb$export$d1d1b29521a1a1d5)(msg)) {
                this.#log(`invalid message: ${JSON.stringify(msg)}`);
                return;
            }
            this.#log(`message from ${msg.senderId}`);
            if ((0, $f7f9859bbb7f91eb$export$9d67bd6f3f072841)(msg)) {
                const source = $cc58c014abe1974c$var$getEphemeralMessageSource(msg);
                if (this.#ephemeralSessionCounts[source] === undefined || msg.count > this.#ephemeralSessionCounts[source]) {
                    this.#ephemeralSessionCounts[source] = msg.count;
                    this.emit("message", msg);
                }
                return;
            }
            this.emit("message", msg);
        });
        networkAdapter.on("close", ()=>{
            this.#log("adapter closed");
            Object.entries(this.#adaptersByPeer).forEach(([peerId, other])=>{
                if (other === networkAdapter) delete this.#adaptersByPeer[peerId];
            });
            this.adapters = this.adapters.filter((a)=>a !== networkAdapter);
        });
        this.peerMetadata.then((peerMetadata)=>{
            networkAdapter.connect(this.peerId, peerMetadata);
        }).catch((err)=>{
            this.#log("error connecting to network", err);
        });
    }
    // TODO: this probably introduces a race condition for the ready event
    // but I plan to refactor that as part of this branch in another patch
    removeNetworkAdapter(networkAdapter) {
        this.adapters = this.adapters.filter((a)=>a !== networkAdapter);
        networkAdapter.disconnect();
    }
    send(message) {
        const peer = this.#adaptersByPeer[message.targetId];
        if (!peer) {
            this.#log(`Tried to send message but peer not found: ${message.targetId}`);
            return;
        }
        /** Messages come in without a senderId and other required information; this is where we make
         * sure they have everything they need.
         */ const prepareMessage = (message)=>{
            if (message.type === "ephemeral") {
                if ("count" in message) // existing ephemeral message from another peer; pass on without changes
                return message;
                else // new ephemeral message from us; add our senderId as well as a counter and session id
                return {
                    ...message,
                    count: ++this.#count,
                    sessionId: this.#sessionId,
                    senderId: this.peerId
                };
            } else // other message type; just add our senderId
            return {
                ...message,
                senderId: this.peerId
            };
        };
        const outbound = prepareMessage(message);
        this.#log("sending message %o", outbound);
        peer.send(outbound);
    }
    isReady = ()=>{
        return this.adapters.every((a)=>a.isReady());
    };
    whenReady = async ()=>{
        return Promise.all(this.adapters.map((a)=>a.whenReady()));
    };
}




var $1SXIy = parcelRequire("1SXIy");

function $5a6d08ecd9c3c7d5$export$9826fe7ad3921016(myArrays) {
    // Get the total length of all arrays.
    let length = 0;
    myArrays.forEach((item)=>{
        length += item.length;
    });
    // Create a new array with total length and merge all source arrays.
    const mergedArray = new Uint8Array(length);
    let offset = 0;
    myArrays.forEach((item)=>{
        mergedArray.set(item, offset);
        offset += item.length;
    });
    return mergedArray;
}


var $8d1f4c1ea4bfa61d$exports = {};
(function(root, factory) {
    // Hack to make all exports of this module sha256 function object properties.
    var exports = {};
    factory(exports);
    var sha256 = exports["default"];
    for(var k in exports)sha256[k] = exports[k];
    if (typeof $8d1f4c1ea4bfa61d$exports === 'object') $8d1f4c1ea4bfa61d$exports = sha256;
    else if (typeof define === 'function' && define.amd) define(function() {
        return sha256;
    });
    else root.sha256 = sha256;
})($8d1f4c1ea4bfa61d$exports, function(exports) {
    "use strict";
    exports.__esModule = true;
    // SHA-256 (+ HMAC and PBKDF2) for JavaScript.
    //
    // Written in 2014-2016 by Dmitry Chestnykh.
    // Public domain, no warranty.
    //
    // Functions (accept and return Uint8Arrays):
    //
    //   sha256(message) -> hash
    //   sha256.hmac(key, message) -> mac
    //   sha256.pbkdf2(password, salt, rounds, dkLen) -> dk
    //
    //  Classes:
    //
    //   new sha256.Hash()
    //   new sha256.HMAC(key)
    //
    exports.digestLength = 32;
    exports.blockSize = 64;
    // SHA-256 constants
    var K = new Uint32Array([
        0x428a2f98,
        0x71374491,
        0xb5c0fbcf,
        0xe9b5dba5,
        0x3956c25b,
        0x59f111f1,
        0x923f82a4,
        0xab1c5ed5,
        0xd807aa98,
        0x12835b01,
        0x243185be,
        0x550c7dc3,
        0x72be5d74,
        0x80deb1fe,
        0x9bdc06a7,
        0xc19bf174,
        0xe49b69c1,
        0xefbe4786,
        0x0fc19dc6,
        0x240ca1cc,
        0x2de92c6f,
        0x4a7484aa,
        0x5cb0a9dc,
        0x76f988da,
        0x983e5152,
        0xa831c66d,
        0xb00327c8,
        0xbf597fc7,
        0xc6e00bf3,
        0xd5a79147,
        0x06ca6351,
        0x14292967,
        0x27b70a85,
        0x2e1b2138,
        0x4d2c6dfc,
        0x53380d13,
        0x650a7354,
        0x766a0abb,
        0x81c2c92e,
        0x92722c85,
        0xa2bfe8a1,
        0xa81a664b,
        0xc24b8b70,
        0xc76c51a3,
        0xd192e819,
        0xd6990624,
        0xf40e3585,
        0x106aa070,
        0x19a4c116,
        0x1e376c08,
        0x2748774c,
        0x34b0bcb5,
        0x391c0cb3,
        0x4ed8aa4a,
        0x5b9cca4f,
        0x682e6ff3,
        0x748f82ee,
        0x78a5636f,
        0x84c87814,
        0x8cc70208,
        0x90befffa,
        0xa4506ceb,
        0xbef9a3f7,
        0xc67178f2
    ]);
    function hashBlocks(w, v, p, pos, len) {
        var a, b, c, d, e, f, g, h, u, i, j, t1, t2;
        while(len >= 64){
            a = v[0];
            b = v[1];
            c = v[2];
            d = v[3];
            e = v[4];
            f = v[5];
            g = v[6];
            h = v[7];
            for(i = 0; i < 16; i++){
                j = pos + i * 4;
                w[i] = (p[j] & 0xff) << 24 | (p[j + 1] & 0xff) << 16 | (p[j + 2] & 0xff) << 8 | p[j + 3] & 0xff;
            }
            for(i = 16; i < 64; i++){
                u = w[i - 2];
                t1 = (u >>> 17 | u << 15) ^ (u >>> 19 | u << 13) ^ u >>> 10;
                u = w[i - 15];
                t2 = (u >>> 7 | u << 25) ^ (u >>> 18 | u << 14) ^ u >>> 3;
                w[i] = (t1 + w[i - 7] | 0) + (t2 + w[i - 16] | 0);
            }
            for(i = 0; i < 64; i++){
                t1 = (((e >>> 6 | e << 26) ^ (e >>> 11 | e << 21) ^ (e >>> 25 | e << 7)) + (e & f ^ ~e & g) | 0) + (h + (K[i] + w[i] | 0) | 0) | 0;
                t2 = ((a >>> 2 | a << 30) ^ (a >>> 13 | a << 19) ^ (a >>> 22 | a << 10)) + (a & b ^ a & c ^ b & c) | 0;
                h = g;
                g = f;
                f = e;
                e = d + t1 | 0;
                d = c;
                c = b;
                b = a;
                a = t1 + t2 | 0;
            }
            v[0] += a;
            v[1] += b;
            v[2] += c;
            v[3] += d;
            v[4] += e;
            v[5] += f;
            v[6] += g;
            v[7] += h;
            pos += 64;
            len -= 64;
        }
        return pos;
    }
    // Hash implements SHA256 hash algorithm.
    var Hash = /** @class */ function() {
        function Hash() {
            this.digestLength = exports.digestLength;
            this.blockSize = exports.blockSize;
            // Note: Int32Array is used instead of Uint32Array for performance reasons.
            this.state = new Int32Array(8); // hash state
            this.temp = new Int32Array(64); // temporary state
            this.buffer = new Uint8Array(128); // buffer for data to hash
            this.bufferLength = 0; // number of bytes in buffer
            this.bytesHashed = 0; // number of total bytes hashed
            this.finished = false; // indicates whether the hash was finalized
            this.reset();
        }
        // Resets hash state making it possible
        // to re-use this instance to hash other data.
        Hash.prototype.reset = function() {
            this.state[0] = 0x6a09e667;
            this.state[1] = 0xbb67ae85;
            this.state[2] = 0x3c6ef372;
            this.state[3] = 0xa54ff53a;
            this.state[4] = 0x510e527f;
            this.state[5] = 0x9b05688c;
            this.state[6] = 0x1f83d9ab;
            this.state[7] = 0x5be0cd19;
            this.bufferLength = 0;
            this.bytesHashed = 0;
            this.finished = false;
            return this;
        };
        // Cleans internal buffers and re-initializes hash state.
        Hash.prototype.clean = function() {
            for(var i = 0; i < this.buffer.length; i++)this.buffer[i] = 0;
            for(var i = 0; i < this.temp.length; i++)this.temp[i] = 0;
            this.reset();
        };
        // Updates hash state with the given data.
        //
        // Optionally, length of the data can be specified to hash
        // fewer bytes than data.length.
        //
        // Throws error when trying to update already finalized hash:
        // instance must be reset to use it again.
        Hash.prototype.update = function(data, dataLength) {
            if (dataLength === void 0) dataLength = data.length;
            if (this.finished) throw new Error("SHA256: can't update because hash was finished.");
            var dataPos = 0;
            this.bytesHashed += dataLength;
            if (this.bufferLength > 0) {
                while(this.bufferLength < 64 && dataLength > 0){
                    this.buffer[this.bufferLength++] = data[dataPos++];
                    dataLength--;
                }
                if (this.bufferLength === 64) {
                    hashBlocks(this.temp, this.state, this.buffer, 0, 64);
                    this.bufferLength = 0;
                }
            }
            if (dataLength >= 64) {
                dataPos = hashBlocks(this.temp, this.state, data, dataPos, dataLength);
                dataLength %= 64;
            }
            while(dataLength > 0){
                this.buffer[this.bufferLength++] = data[dataPos++];
                dataLength--;
            }
            return this;
        };
        // Finalizes hash state and puts hash into out.
        //
        // If hash was already finalized, puts the same value.
        Hash.prototype.finish = function(out) {
            if (!this.finished) {
                var bytesHashed = this.bytesHashed;
                var left = this.bufferLength;
                var bitLenHi = bytesHashed / 0x20000000 | 0;
                var bitLenLo = bytesHashed << 3;
                var padLength = bytesHashed % 64 < 56 ? 64 : 128;
                this.buffer[left] = 0x80;
                for(var i = left + 1; i < padLength - 8; i++)this.buffer[i] = 0;
                this.buffer[padLength - 8] = bitLenHi >>> 24 & 0xff;
                this.buffer[padLength - 7] = bitLenHi >>> 16 & 0xff;
                this.buffer[padLength - 6] = bitLenHi >>> 8 & 0xff;
                this.buffer[padLength - 5] = bitLenHi >>> 0 & 0xff;
                this.buffer[padLength - 4] = bitLenLo >>> 24 & 0xff;
                this.buffer[padLength - 3] = bitLenLo >>> 16 & 0xff;
                this.buffer[padLength - 2] = bitLenLo >>> 8 & 0xff;
                this.buffer[padLength - 1] = bitLenLo >>> 0 & 0xff;
                hashBlocks(this.temp, this.state, this.buffer, 0, padLength);
                this.finished = true;
            }
            for(var i = 0; i < 8; i++){
                out[i * 4 + 0] = this.state[i] >>> 24 & 0xff;
                out[i * 4 + 1] = this.state[i] >>> 16 & 0xff;
                out[i * 4 + 2] = this.state[i] >>> 8 & 0xff;
                out[i * 4 + 3] = this.state[i] >>> 0 & 0xff;
            }
            return this;
        };
        // Returns the final hash digest.
        Hash.prototype.digest = function() {
            var out = new Uint8Array(this.digestLength);
            this.finish(out);
            return out;
        };
        // Internal function for use in HMAC for optimization.
        Hash.prototype._saveState = function(out) {
            for(var i = 0; i < this.state.length; i++)out[i] = this.state[i];
        };
        // Internal function for use in HMAC for optimization.
        Hash.prototype._restoreState = function(from, bytesHashed) {
            for(var i = 0; i < this.state.length; i++)this.state[i] = from[i];
            this.bytesHashed = bytesHashed;
            this.finished = false;
            this.bufferLength = 0;
        };
        return Hash;
    }();
    exports.Hash = Hash;
    // HMAC implements HMAC-SHA256 message authentication algorithm.
    var HMAC = /** @class */ function() {
        function HMAC(key) {
            this.inner = new Hash();
            this.outer = new Hash();
            this.blockSize = this.inner.blockSize;
            this.digestLength = this.inner.digestLength;
            var pad = new Uint8Array(this.blockSize);
            if (key.length > this.blockSize) new Hash().update(key).finish(pad).clean();
            else for(var i = 0; i < key.length; i++)pad[i] = key[i];
            for(var i = 0; i < pad.length; i++)pad[i] ^= 0x36;
            this.inner.update(pad);
            for(var i = 0; i < pad.length; i++)pad[i] ^= 106;
            this.outer.update(pad);
            this.istate = new Uint32Array(8);
            this.ostate = new Uint32Array(8);
            this.inner._saveState(this.istate);
            this.outer._saveState(this.ostate);
            for(var i = 0; i < pad.length; i++)pad[i] = 0;
        }
        // Returns HMAC state to the state initialized with key
        // to make it possible to run HMAC over the other data with the same
        // key without creating a new instance.
        HMAC.prototype.reset = function() {
            this.inner._restoreState(this.istate, this.inner.blockSize);
            this.outer._restoreState(this.ostate, this.outer.blockSize);
            return this;
        };
        // Cleans HMAC state.
        HMAC.prototype.clean = function() {
            for(var i = 0; i < this.istate.length; i++)this.ostate[i] = this.istate[i] = 0;
            this.inner.clean();
            this.outer.clean();
        };
        // Updates state with provided data.
        HMAC.prototype.update = function(data) {
            this.inner.update(data);
            return this;
        };
        // Finalizes HMAC and puts the result in out.
        HMAC.prototype.finish = function(out) {
            if (this.outer.finished) this.outer.finish(out);
            else {
                this.inner.finish(out);
                this.outer.update(out, this.digestLength).finish(out);
            }
            return this;
        };
        // Returns message authentication code.
        HMAC.prototype.digest = function() {
            var out = new Uint8Array(this.digestLength);
            this.finish(out);
            return out;
        };
        return HMAC;
    }();
    exports.HMAC = HMAC;
    // Returns SHA256 hash of data.
    function hash(data) {
        var h = new Hash().update(data);
        var digest = h.digest();
        h.clean();
        return digest;
    }
    exports.hash = hash;
    // Function hash is both available as module.hash and as default export.
    exports["default"] = hash;
    // Returns HMAC-SHA256 of data under the key.
    function hmac(key, data) {
        var h = new HMAC(key).update(data);
        var digest = h.digest();
        h.clean();
        return digest;
    }
    exports.hmac = hmac;
    // Fills hkdf buffer like this:
    // T(1) = HMAC-Hash(PRK, T(0) | info | 0x01)
    function fillBuffer(buffer, hmac, info, counter) {
        // Counter is a byte value: check if it overflowed.
        var num = counter[0];
        if (num === 0) throw new Error("hkdf: cannot expand more");
        // Prepare HMAC instance for new data with old key.
        hmac.reset();
        // Hash in previous output if it was generated
        // (i.e. counter is greater than 1).
        if (num > 1) hmac.update(buffer);
        // Hash in info if it exists.
        if (info) hmac.update(info);
        // Hash in the counter.
        hmac.update(counter);
        // Output result to buffer and clean HMAC instance.
        hmac.finish(buffer);
        // Increment counter inside typed array, this works properly.
        counter[0]++;
    }
    var hkdfSalt = new Uint8Array(exports.digestLength); // Filled with zeroes.
    function hkdf(key, salt, info, length) {
        if (salt === void 0) salt = hkdfSalt;
        if (length === void 0) length = 32;
        var counter = new Uint8Array([
            1
        ]);
        // HKDF-Extract uses salt as HMAC key, and key as data.
        var okm = hmac(salt, key);
        // Initialize HMAC for expanding with extracted key.
        // Ensure no collisions with `hmac` function.
        var hmac_ = new HMAC(okm);
        // Allocate buffer.
        var buffer = new Uint8Array(hmac_.digestLength);
        var bufpos = buffer.length;
        var out = new Uint8Array(length);
        for(var i = 0; i < length; i++){
            if (bufpos === buffer.length) {
                fillBuffer(buffer, hmac_, info, counter);
                bufpos = 0;
            }
            out[i] = buffer[bufpos++];
        }
        hmac_.clean();
        buffer.fill(0);
        counter.fill(0);
        return out;
    }
    exports.hkdf = hkdf;
    // Derives a key from password and salt using PBKDF2-HMAC-SHA256
    // with the given number of iterations.
    //
    // The number of bytes returned is equal to dkLen.
    //
    // (For better security, avoid dkLen greater than hash length - 32 bytes).
    function pbkdf2(password, salt, iterations, dkLen) {
        var prf = new HMAC(password);
        var len = prf.digestLength;
        var ctr = new Uint8Array(4);
        var t = new Uint8Array(len);
        var u = new Uint8Array(len);
        var dk = new Uint8Array(dkLen);
        for(var i = 0; i * len < dkLen; i++){
            var c = i + 1;
            ctr[0] = c >>> 24 & 0xff;
            ctr[1] = c >>> 16 & 0xff;
            ctr[2] = c >>> 8 & 0xff;
            ctr[3] = c >>> 0 & 0xff;
            prf.reset();
            prf.update(salt);
            prf.update(ctr);
            prf.finish(u);
            for(var j = 0; j < len; j++)t[j] = u[j];
            for(var j = 2; j <= iterations; j++){
                prf.reset();
                prf.update(u).finish(u);
                for(var k = 0; k < len; k++)t[k] ^= u[k];
            }
            for(var j = 0; j < len && i * len + j < dkLen; j++)dk[i * len + j] = t[j];
        }
        for(var i = 0; i < len; i++)t[i] = u[i] = 0;
        for(var i = 0; i < 4; i++)ctr[i] = 0;
        prf.clean();
        return dk;
    }
    exports.pbkdf2 = pbkdf2;
});



function $7fb0ead237cd62ee$export$24d455de50bc442f(binary) {
    // calculate hash
    const hash = $8d1f4c1ea4bfa61d$exports.hash(binary);
    return $7fb0ead237cd62ee$var$bufferToHexString(hash);
}
function $7fb0ead237cd62ee$export$73b45893a2a04356(heads) {
    const encoder = new TextEncoder();
    const headsbinary = (0, $5a6d08ecd9c3c7d5$export$9826fe7ad3921016)(heads.map((h)=>encoder.encode(h)));
    return $7fb0ead237cd62ee$export$24d455de50bc442f(headsbinary);
}
function $7fb0ead237cd62ee$var$bufferToHexString(data) {
    return Array.from(data, (byte)=>byte.toString(16).padStart(2, "0")).join("");
}





class $d474326403a252bc$export$af46b7b95952eadf extends (0, (/*@__PURE__*/$parcel$interopDefault($28edd11f6c7e9f5f$exports))) {
    /** The storage adapter to use for saving and loading documents */ #storageAdapter;
    /** Record of the latest heads we've loaded or saved for each document  */ #storedHeads = new Map();
    /** Metadata on the chunks we've already loaded for each document */ #chunkInfos = new Map();
    /** Flag to avoid compacting when a compaction is already underway */ #compacting = false;
    #log = (0, (/*@__PURE__*/$parcel$interopDefault($1SXIy)))(`automerge-repo:storage-subsystem`);
    constructor(storageAdapter){
        super();
        this.#storageAdapter = storageAdapter;
    }
    async id() {
        const storedId = await this.#storageAdapter.load([
            "storage-adapter-id"
        ]);
        let id;
        if (storedId) id = new TextDecoder().decode(storedId);
        else {
            id = $3fa3ae484854b431$export$2e2bcd8739ae039();
            await this.#storageAdapter.save([
                "storage-adapter-id"
            ], new TextEncoder().encode(id));
        }
        return id;
    }
    // ARBITRARY KEY/VALUE STORAGE
    // The `load`, `save`, and `remove` methods are for generic key/value storage, as opposed to
    // Automerge documents. For example, they're used by the LocalFirstAuthProvider to persist the
    // encrypted team graph that encodes group membership and permissions.
    //
    // The namespace parameter is to prevent collisions with other users of the storage subsystem.
    // Typically this will be the name of the plug-in, adapter, or other system that is using it. For
    // example, the LocalFirstAuthProvider uses the namespace `LocalFirstAuthProvider`.
    /** Loads a value from storage. */ async load(/** Namespace to prevent collisions with other users of the storage subsystem. */ namespace, /** Key to load. Typically a UUID or other unique identifier, but could be any string. */ key) {
        const storageKey = [
            namespace,
            key
        ];
        return await this.#storageAdapter.load(storageKey);
    }
    /** Saves a value in storage. */ async save(/** Namespace to prevent collisions with other users of the storage subsystem. */ namespace, /** Key to load. Typically a UUID or other unique identifier, but could be any string. */ key, /** Data to save, as a binary blob. */ data) {
        const storageKey = [
            namespace,
            key
        ];
        await this.#storageAdapter.save(storageKey, data);
    }
    /** Removes a value from storage. */ async remove(/** Namespace to prevent collisions with other users of the storage subsystem. */ namespace, /** Key to remove. Typically a UUID or other unique identifier, but could be any string. */ key) {
        const storageKey = [
            namespace,
            key
        ];
        await this.#storageAdapter.remove(storageKey);
    }
    // AUTOMERGE DOCUMENT STORAGE
    /**
     * Loads and combines document chunks from storage, with snapshots first.
     */ async loadDocData(documentId) {
        // Load snapshots first
        const snapshotChunks = await this.#storageAdapter.loadRange([
            documentId,
            "snapshot"
        ]);
        const incrementalChunks = await this.#storageAdapter.loadRange([
            documentId,
            "incremental"
        ]);
        const binaries = [];
        const chunkInfos = [];
        // Process snapshots first
        for (const chunk of snapshotChunks){
            if (chunk.data === undefined) continue;
            chunkInfos.push({
                key: chunk.key,
                type: "snapshot",
                size: chunk.data.length
            });
            binaries.push(chunk.data);
        }
        // Then process incrementals
        for (const chunk of incrementalChunks){
            if (chunk.data === undefined) continue;
            chunkInfos.push({
                key: chunk.key,
                type: "incremental",
                size: chunk.data.length
            });
            binaries.push(chunk.data);
        }
        // Store chunk infos for future reference
        this.#chunkInfos.set(documentId, chunkInfos);
        // If no chunks were found, return null
        if (binaries.length === 0) return null;
        // Merge the chunks into a single binary
        return (0, $5a6d08ecd9c3c7d5$export$9826fe7ad3921016)(binaries);
    }
    /**
     * Loads the Automerge document with the given ID from storage.
     */ async loadDoc(documentId) {
        // Load and combine chunks
        const binary = await this.loadDocData(documentId);
        if (!binary) return null;
        // Load into an Automerge document
        const start = performance.now();
        const newDoc = (0, $8a8016b162b6f8b4$exports).loadIncremental((0, $8a8016b162b6f8b4$exports).init(), binary);
        const end = performance.now();
        this.emit("document-loaded", {
            documentId: documentId,
            durationMillis: end - start,
            ...(0, $8a8016b162b6f8b4$exports).stats(newDoc)
        });
        // Record the latest heads for the document
        this.#storedHeads.set(documentId, (0, $8a8016b162b6f8b4$exports).getHeads(newDoc));
        return newDoc;
    }
    /**
     * Saves the provided Automerge document to storage.
     *
     * @remarks
     * Under the hood this makes incremental saves until the incremental size is greater than the
     * snapshot size, at which point the document is compacted into a single snapshot.
     */ async saveDoc(documentId, doc) {
        // Don't bother saving if the document hasn't changed
        if (!this.#shouldSave(documentId, doc)) return;
        const sourceChunks = this.#chunkInfos.get(documentId) ?? [];
        if (this.#shouldCompact(sourceChunks)) await this.#saveTotal(documentId, doc, sourceChunks);
        else await this.#saveIncremental(documentId, doc);
        this.#storedHeads.set(documentId, (0, $8a8016b162b6f8b4$exports).getHeads(doc));
    }
    /**
     * Removes the Automerge document with the given ID from storage
     */ async removeDoc(documentId) {
        await this.#storageAdapter.removeRange([
            documentId,
            "snapshot"
        ]);
        await this.#storageAdapter.removeRange([
            documentId,
            "incremental"
        ]);
        await this.#storageAdapter.removeRange([
            documentId,
            "sync-state"
        ]);
    }
    /**
     * Saves just the incremental changes since the last save.
     */ async #saveIncremental(documentId, doc) {
        const sinceHeads = this.#storedHeads.get(documentId) ?? [];
        const start = performance.now();
        const binary = (0, $8a8016b162b6f8b4$exports).saveSince(doc, sinceHeads);
        const end = performance.now();
        this.emit("doc-saved", {
            documentId: documentId,
            durationMillis: end - start,
            sinceHeads: sinceHeads
        });
        if (binary && binary.length > 0) {
            const key = [
                documentId,
                "incremental",
                (0, $7fb0ead237cd62ee$export$24d455de50bc442f)(binary)
            ];
            this.#log(`Saving incremental ${key} for document ${documentId}`);
            await this.#storageAdapter.save(key, binary);
            if (!this.#chunkInfos.has(documentId)) this.#chunkInfos.set(documentId, []);
            this.#chunkInfos.get(documentId).push({
                key: key,
                type: "incremental",
                size: binary.length
            });
            this.#storedHeads.set(documentId, (0, $8a8016b162b6f8b4$exports).getHeads(doc));
        } else return Promise.resolve();
    }
    /**
     * Compacts the document storage into a single shapshot.
     */ async #saveTotal(documentId, doc, sourceChunks) {
        this.#compacting = true;
        const start = performance.now();
        const binary = (0, $8a8016b162b6f8b4$exports).save(doc);
        const end = performance.now();
        this.emit("doc-compacted", {
            documentId: documentId,
            durationMillis: end - start
        });
        const snapshotHash = (0, $7fb0ead237cd62ee$export$73b45893a2a04356)((0, $8a8016b162b6f8b4$exports).getHeads(doc));
        const key = [
            documentId,
            "snapshot",
            snapshotHash
        ];
        const oldKeys = new Set(sourceChunks.map((c)=>c.key).filter((k)=>k[2] !== snapshotHash));
        this.#log(`Saving snapshot ${key} for document ${documentId}`);
        this.#log(`deleting old chunks ${Array.from(oldKeys)}`);
        await this.#storageAdapter.save(key, binary);
        for (const key of oldKeys)await this.#storageAdapter.remove(key);
        const newChunkInfos = this.#chunkInfos.get(documentId)?.filter((c)=>!oldKeys.has(c.key)) ?? [];
        newChunkInfos.push({
            key: key,
            type: "snapshot",
            size: binary.length
        });
        this.#chunkInfos.set(documentId, newChunkInfos);
        this.#compacting = false;
    }
    async loadSyncState(documentId, storageId) {
        const key = [
            documentId,
            "sync-state",
            storageId
        ];
        try {
            const loaded = await this.#storageAdapter.load(key);
            return loaded ? (0, $8a8016b162b6f8b4$exports).decodeSyncState(loaded) : undefined;
        } catch (e) {
            this.#log(`Error loading sync state for ${documentId} from ${storageId}`);
            return undefined;
        }
    }
    async saveSyncState(documentId, storageId, syncState) {
        const key = [
            documentId,
            "sync-state",
            storageId
        ];
        await this.#storageAdapter.save(key, (0, $8a8016b162b6f8b4$exports).encodeSyncState(syncState));
    }
    /**
     * Returns true if the document has changed since the last time it was saved.
     */ #shouldSave(documentId, doc) {
        const oldHeads = this.#storedHeads.get(documentId);
        if (!oldHeads) // we haven't saved this document before
        return true;
        const newHeads = (0, $8a8016b162b6f8b4$exports).getHeads(doc);
        if ((0, $956570809efac935$export$f1581808060b6286)((0, $73665c112ce7e927$export$5b2c9a3be6980e12)(newHeads), (0, $73665c112ce7e927$export$5b2c9a3be6980e12)(oldHeads))) // the document hasn't changed
        return false;
        return true; // the document has changed
    }
    /**
     * We only compact if the incremental size is greater than the snapshot size.
     */ #shouldCompact(sourceChunks) {
        if (this.#compacting) return false;
        let snapshotSize = 0;
        let incrementalSize = 0;
        for (const chunk of sourceChunks)if (chunk.type === "snapshot") snapshotSize += chunk.size;
        else incrementalSize += chunk.size;
        // if the file is currently small, don't worry, just compact
        // this might seem a bit arbitrary (1k is arbitrary) but is designed to ensure compaction
        // for documents with only a single large change on top of an empty (or nearly empty) document
        // for example: imported NPM modules, images, etc.
        // if we have even more incrementals (so far) than the snapshot, compact
        return snapshotSize < 1024 || incrementalSize >= snapshotSize;
    }
}



var $1SXIy = parcelRequire("1SXIy");




var $1SXIy = parcelRequire("1SXIy");



class $76788055b214977f$export$77a2a2e4927ef3c2 extends (0, (/*@__PURE__*/$parcel$interopDefault($28edd11f6c7e9f5f$exports))) {
}



class $37b00b0a559f8ed6$export$606aaaba84cfbeb4 extends (0, $76788055b214977f$export$77a2a2e4927ef3c2) {
    #log;
    syncDebounceRate = 100;
    /** Active peers */ #peers = [];
    #pendingSyncStateCallbacks = {};
    #peerDocumentStatuses = {};
    /** Sync state for each peer we've communicated with (including inactive peers) */ #syncStates = {};
    #pendingSyncMessages = [];
    // We keep this around at least in part for debugging.
    // eslint-disable-next-line no-unused-private-class-members
    #peerId;
    #syncStarted = false;
    #handle;
    #onLoadSyncState;
    constructor({ handle: handle, peerId: peerId, onLoadSyncState: onLoadSyncState }){
        super();
        this.#peerId = peerId;
        this.#handle = handle;
        this.#onLoadSyncState = onLoadSyncState ?? (()=>Promise.resolve(undefined));
        const docId = handle.documentId.slice(0, 5);
        this.#log = (0, (/*@__PURE__*/$parcel$interopDefault($1SXIy)))(`automerge-repo:docsync:${docId}`);
        handle.on("change", (0, $147c725b0c5cefa5$export$de363e709c412c8a)(()=>this.#syncWithPeers(), this.syncDebounceRate));
        handle.on("ephemeral-message-outbound", (payload)=>this.#broadcastToPeers(payload));
        // Process pending sync messages immediately after the handle becomes ready.
        (async ()=>{
            this.#processAllPendingSyncMessages();
        })();
    }
    get peerStates() {
        return this.#peerDocumentStatuses;
    }
    get documentId() {
        return this.#handle.documentId;
    }
    /// PRIVATE
    async #syncWithPeers() {
        try {
            await this.#handle.whenReady();
            const doc = this.#handle.doc(); // XXX THIS ONE IS WEIRD
            this.#peers.forEach((peerId)=>this.#sendSyncMessage(peerId, doc));
        } catch (e) {
            console.log("sync with peers threw an exception");
        }
    }
    async #broadcastToPeers({ data: data }) {
        this.#log(`broadcastToPeers`, this.#peers);
        this.#peers.forEach((peerId)=>this.#sendEphemeralMessage(peerId, data));
    }
    #sendEphemeralMessage(peerId, data) {
        this.#log(`sendEphemeralMessage ->${peerId}`);
        const message = {
            type: "ephemeral",
            targetId: peerId,
            documentId: this.#handle.documentId,
            data: data
        };
        this.emit("message", message);
    }
    #withSyncState(peerId, callback) {
        this.#addPeer(peerId);
        if (!(peerId in this.#peerDocumentStatuses)) this.#peerDocumentStatuses[peerId] = "unknown";
        const syncState = this.#syncStates[peerId];
        if (syncState) {
            callback(syncState);
            return;
        }
        let pendingCallbacks = this.#pendingSyncStateCallbacks[peerId];
        if (!pendingCallbacks) {
            this.#onLoadSyncState(peerId).then((syncState)=>{
                this.#initSyncState(peerId, syncState ?? (0, $8a8016b162b6f8b4$exports).initSyncState());
            }).catch((err)=>{
                this.#log(`Error loading sync state for ${peerId}: ${err}`);
            });
            pendingCallbacks = this.#pendingSyncStateCallbacks[peerId] = [];
        }
        pendingCallbacks.push(callback);
    }
    #addPeer(peerId) {
        if (!this.#peers.includes(peerId)) {
            this.#peers.push(peerId);
            this.emit("open-doc", {
                documentId: this.documentId,
                peerId: peerId
            });
        }
    }
    #initSyncState(peerId, syncState) {
        const pendingCallbacks = this.#pendingSyncStateCallbacks[peerId];
        if (pendingCallbacks) for (const callback of pendingCallbacks)callback(syncState);
        delete this.#pendingSyncStateCallbacks[peerId];
        this.#syncStates[peerId] = syncState;
    }
    #setSyncState(peerId, syncState) {
        this.#syncStates[peerId] = syncState;
        this.emit("sync-state", {
            peerId: peerId,
            syncState: syncState,
            documentId: this.#handle.documentId
        });
    }
    #sendSyncMessage(peerId, doc) {
        this.#log(`sendSyncMessage ->${peerId}`);
        this.#withSyncState(peerId, (syncState)=>{
            const start = performance.now();
            const [newSyncState, message] = (0, $8a8016b162b6f8b4$exports).generateSyncMessage(doc, syncState);
            const end = performance.now();
            this.emit("metrics", {
                type: "generate-sync-message",
                documentId: this.#handle.documentId,
                durationMillis: end - start,
                forPeer: peerId
            });
            this.#setSyncState(peerId, newSyncState);
            if (message) {
                const isNew = (0, $8a8016b162b6f8b4$exports).getHeads(doc).length === 0;
                if (!this.#handle.isReady() && isNew && newSyncState.sharedHeads.length === 0 && !Object.values(this.#peerDocumentStatuses).includes("has") && this.#peerDocumentStatuses[peerId] === "unknown") // we don't have the document (or access to it), so we request it
                this.emit("message", {
                    type: "request",
                    targetId: peerId,
                    documentId: this.#handle.documentId,
                    data: message
                });
                else this.emit("message", {
                    type: "sync",
                    targetId: peerId,
                    data: message,
                    documentId: this.#handle.documentId
                });
                // if we have sent heads, then the peer now has or will have the document
                if (!isNew) this.#peerDocumentStatuses[peerId] = "has";
            }
        });
    }
    /// PUBLIC
    hasPeer(peerId) {
        return this.#peers.includes(peerId);
    }
    async beginSync(peerIds) {
        this.#handle.whenReady([
            (0, $24957e09564e3864$export$4bf05b02be91f13a),
            (0, $24957e09564e3864$export$1b7f27216269a67b),
            (0, $24957e09564e3864$export$f2d101b977a134fd)
        ]).then(()=>{
            this.#syncStarted = true;
            this.#checkDocUnavailable();
        }).catch((e)=>{
            console.log("caught whenready", e);
            this.#syncStarted = true;
            this.#checkDocUnavailable();
        });
        const peersWithDocument = this.#peers.some((peerId)=>{
            return this.#peerDocumentStatuses[peerId] == "has";
        });
        if (peersWithDocument) await this.#handle.whenReady();
        peerIds.forEach((peerId)=>{
            this.#withSyncState(peerId, (syncState)=>{
                // HACK: if we have a sync state already, we round-trip it through the encoding system to make
                // sure state is preserved. This prevents an infinite loop caused by failed attempts to send
                // messages during disconnection.
                // TODO: cover that case with a test and remove this hack
                const reparsedSyncState = (0, $8a8016b162b6f8b4$exports).decodeSyncState((0, $8a8016b162b6f8b4$exports).encodeSyncState(syncState));
                this.#setSyncState(peerId, reparsedSyncState);
                // At this point if we don't have anything in our storage, we need to use an empty doc to sync
                // with; but we don't want to surface that state to the front end
                this.#handle.whenReady([
                    (0, $24957e09564e3864$export$4bf05b02be91f13a),
                    (0, $24957e09564e3864$export$1b7f27216269a67b),
                    (0, $24957e09564e3864$export$f2d101b977a134fd)
                ]).then(()=>{
                    const doc = this.#handle.isReady() ? this.#handle.doc() : (0, $8a8016b162b6f8b4$exports).init();
                    const noPeersWithDocument = peerIds.every((peerId)=>this.#peerDocumentStatuses[peerId] in [
                            "unavailable",
                            "wants"
                        ]);
                    const wasUnavailable = doc === undefined;
                    if (wasUnavailable && noPeersWithDocument) return;
                    // If the doc is unavailable we still need a blank document to generate
                    // the sync message from
                    this.#sendSyncMessage(peerId, doc ?? (0, $8a8016b162b6f8b4$exports).init());
                }).catch((err)=>{
                    this.#log(`Error loading doc for ${peerId}: ${err}`);
                });
            });
        });
    }
    endSync(peerId) {
        this.#log(`removing peer ${peerId}`);
        this.#peers = this.#peers.filter((p)=>p !== peerId);
        delete this.#peerDocumentStatuses[peerId];
        this.#checkDocUnavailable();
    }
    receiveMessage(message) {
        switch(message.type){
            case "sync":
            case "request":
                this.receiveSyncMessage(message);
                break;
            case "ephemeral":
                this.receiveEphemeralMessage(message);
                break;
            case "doc-unavailable":
                this.#peerDocumentStatuses[message.senderId] = "unavailable";
                this.#checkDocUnavailable();
                break;
            default:
                throw new Error(`unknown message type: ${message}`);
        }
    }
    receiveEphemeralMessage(message) {
        if (message.documentId !== this.#handle.documentId) throw new Error(`channelId doesn't match documentId`);
        const { senderId: senderId, data: data } = message;
        const contents = (0, $fec591ea5a7df9ff$export$2f872c0f2117be69)(new Uint8Array(data));
        this.#handle.emit("ephemeral-message", {
            handle: this.#handle,
            senderId: senderId,
            message: contents
        });
        this.#peers.forEach((peerId)=>{
            if (peerId === senderId) return;
            this.emit("message", {
                ...message,
                targetId: peerId
            });
        });
    }
    receiveSyncMessage(message) {
        if (message.documentId !== this.#handle.documentId) throw new Error(`channelId doesn't match documentId`);
        // We need to block receiving the syncMessages until we've checked local storage
        if (!this.#handle.inState([
            (0, $24957e09564e3864$export$4bf05b02be91f13a),
            (0, $24957e09564e3864$export$1b7f27216269a67b),
            (0, $24957e09564e3864$export$f2d101b977a134fd)
        ])) {
            this.#pendingSyncMessages.push({
                message: message,
                received: new Date()
            });
            return;
        }
        this.#processAllPendingSyncMessages();
        this.#processSyncMessage(message);
    }
    #processSyncMessage(message) {
        if ((0, $f7f9859bbb7f91eb$export$ba7103d54f1e2117)(message)) this.#peerDocumentStatuses[message.senderId] = "wants";
        this.#checkDocUnavailable();
        // if the message has heads, then the peer has the document
        if ((0, $8a8016b162b6f8b4$exports).decodeSyncMessage(message.data).heads.length > 0) this.#peerDocumentStatuses[message.senderId] = "has";
        this.#withSyncState(message.senderId, (syncState)=>{
            this.#handle.update((doc)=>{
                const start = performance.now();
                const [newDoc, newSyncState] = (0, $8a8016b162b6f8b4$exports).receiveSyncMessage(doc, syncState, message.data);
                const end = performance.now();
                this.emit("metrics", {
                    type: "receive-sync-message",
                    documentId: this.#handle.documentId,
                    durationMillis: end - start,
                    fromPeer: message.senderId,
                    ...(0, $8a8016b162b6f8b4$exports).stats(doc)
                });
                this.#setSyncState(message.senderId, newSyncState);
                // respond to just this peer (as required)
                this.#sendSyncMessage(message.senderId, doc);
                return newDoc;
            });
            this.#checkDocUnavailable();
        });
    }
    #checkDocUnavailable() {
        // if we know none of the peers have the document, tell all our peers that we don't either
        if (this.#syncStarted && this.#handle.inState([
            (0, $24957e09564e3864$export$1b7f27216269a67b),
            (0, $24957e09564e3864$export$f2d101b977a134fd)
        ]) && this.#peers.every((peerId)=>this.#peerDocumentStatuses[peerId] === "unavailable" || this.#peerDocumentStatuses[peerId] === "wants")) {
            this.#peers.filter((peerId)=>this.#peerDocumentStatuses[peerId] === "wants").forEach((peerId)=>{
                // Transition the peer to unavailable so that we don't send it a doc-unavailable
                // message every time we run #checkDocUnavailable
                this.#peerDocumentStatuses[peerId] = "unavailable";
                const message = {
                    type: "doc-unavailable",
                    documentId: this.#handle.documentId,
                    targetId: peerId
                };
                this.emit("message", message);
            });
            this.#handle.unavailable();
        }
    }
    #processAllPendingSyncMessages() {
        for (const message of this.#pendingSyncMessages)this.#processSyncMessage(message.message);
        this.#pendingSyncMessages = [];
    }
    metrics() {
        return {
            peers: this.#peers,
            size: this.#handle.metrics()
        };
    }
}



const $0493b08b8598ec39$var$log = (0, (/*@__PURE__*/$parcel$interopDefault($1SXIy)))("automerge-repo:collectionsync");
class $0493b08b8598ec39$export$f725eb6eed148aab extends (0, $76788055b214977f$export$77a2a2e4927ef3c2) {
    repo;
    /** The set of peers we are connected with */ #peers = new Set();
    /** A map of documentIds to their synchronizers */ /** @hidden */ docSynchronizers = {};
    /** Used to determine if the document is know to the Collection and a synchronizer exists or is being set up */ #docSetUp = {};
    #denylist;
    #hasRequested = new Map();
    constructor(repo, denylist = []){
        super();
        this.repo = repo;
        this.#denylist = denylist.map((url)=>(0, $73665c112ce7e927$export$139eebd34d024bba)(url).documentId);
    }
    /** Returns a synchronizer for the given document, creating one if it doesn't already exist.  */ #fetchDocSynchronizer(handle) {
        if (!this.docSynchronizers[handle.documentId]) this.docSynchronizers[handle.documentId] = this.#initDocSynchronizer(handle);
        return this.docSynchronizers[handle.documentId];
    }
    /** Creates a new docSynchronizer and sets it up to propagate messages */ #initDocSynchronizer(handle) {
        const docSynchronizer = new (0, $37b00b0a559f8ed6$export$606aaaba84cfbeb4)({
            handle: handle,
            peerId: this.repo.networkSubsystem.peerId,
            onLoadSyncState: async (peerId)=>{
                if (!this.repo.storageSubsystem) return;
                const { storageId: storageId, isEphemeral: isEphemeral } = this.repo.peerMetadataByPeerId[peerId] || {};
                if (!storageId || isEphemeral) return;
                return this.repo.storageSubsystem.loadSyncState(handle.documentId, storageId);
            }
        });
        docSynchronizer.on("message", (event)=>this.emit("message", event));
        docSynchronizer.on("open-doc", (event)=>this.emit("open-doc", event));
        docSynchronizer.on("sync-state", (event)=>this.emit("sync-state", event));
        docSynchronizer.on("metrics", (event)=>this.emit("metrics", event));
        return docSynchronizer;
    }
    /** returns an array of peerIds that we share this document generously with */ async #documentGenerousPeers(documentId) {
        const peers = Array.from(this.#peers);
        const generousPeers = [];
        for (const peerId of peers){
            const okToShare = await this.#shouldShare(peerId, documentId);
            if (okToShare) generousPeers.push(peerId);
        }
        return generousPeers;
    }
    // PUBLIC
    /**
     * When we receive a sync message for a document we haven't got in memory, we
     * register it with the repo and start synchronizing
     */ async receiveMessage(message) {
        $0493b08b8598ec39$var$log(`onSyncMessage: ${message.senderId}, ${message.documentId}, ${"data" in message ? message.data.byteLength + "bytes" : ""}`);
        const documentId = message.documentId;
        if (!documentId) throw new Error("received a message with an invalid documentId");
        if (this.#denylist.includes(documentId)) {
            this.emit("metrics", {
                type: "doc-denied",
                documentId: documentId
            });
            this.emit("message", {
                type: "doc-unavailable",
                documentId: documentId,
                targetId: message.senderId
            });
            return;
        }
        // Record the request so that even if access is denied now, we know that the
        // peer requested the document so that if the share policy changes we know
        // to begin syncing with this peer
        if (message.type === "request" || message.type === "sync") {
            if (!this.#hasRequested.has(documentId)) this.#hasRequested.set(documentId, new Set());
            this.#hasRequested.get(documentId)?.add(message.senderId);
        }
        const hasAccess = await this.repo.shareConfig.access(message.senderId, documentId);
        if (!hasAccess) {
            $0493b08b8598ec39$var$log("access denied");
            this.emit("message", {
                type: "doc-unavailable",
                documentId: documentId,
                targetId: message.senderId
            });
            return;
        }
        this.#docSetUp[documentId] = true;
        const handle = await this.repo.find(documentId, {
            allowableStates: [
                "ready",
                "unavailable",
                "requesting"
            ]
        });
        const docSynchronizer = this.#fetchDocSynchronizer(handle);
        docSynchronizer.receiveMessage(message);
        // Initiate sync with any new peers
        const peers = await this.#documentGenerousPeers(documentId);
        docSynchronizer.beginSync(peers.filter((peerId)=>!docSynchronizer.hasPeer(peerId)));
    }
    /**
     * Starts synchronizing the given document with all peers that we share it generously with.
     */ addDocument(handle) {
        // HACK: this is a hack to prevent us from adding the same document twice
        if (this.#docSetUp[handle.documentId]) return;
        this.#docSetUp[handle.documentId] = true;
        const docSynchronizer = this.#fetchDocSynchronizer(handle);
        this.#documentGenerousPeers(handle.documentId).then((peers)=>{
            docSynchronizer.beginSync(peers);
        });
    }
    /** Removes a document and stops synchronizing them */ removeDocument(documentId) {
        $0493b08b8598ec39$var$log(`removing document ${documentId}`);
        const docSynchronizer = this.docSynchronizers[documentId];
        if (docSynchronizer !== undefined) this.peers.forEach((peerId)=>docSynchronizer.endSync(peerId));
        delete this.docSynchronizers[documentId];
        delete this.#docSetUp[documentId];
    }
    /** Adds a peer and maybe starts synchronizing with them */ addPeer(peerId) {
        $0493b08b8598ec39$var$log(`adding ${peerId} & synchronizing with them`);
        if (this.#peers.has(peerId)) return;
        this.#peers.add(peerId);
        for (const docSynchronizer of Object.values(this.docSynchronizers)){
            const { documentId: documentId } = docSynchronizer;
            this.#shouldShare(peerId, documentId).then((okToShare)=>{
                if (okToShare) docSynchronizer.beginSync([
                    peerId
                ]);
            });
        }
    }
    /** Removes a peer and stops synchronizing with them */ removePeer(peerId) {
        $0493b08b8598ec39$var$log(`removing peer ${peerId}`);
        this.#peers.delete(peerId);
        for (const requested of this.#hasRequested.values())requested.delete(peerId);
        for (const docSynchronizer of Object.values(this.docSynchronizers))docSynchronizer.endSync(peerId);
    }
    /** Returns a list of all connected peer ids */ get peers() {
        return Array.from(this.#peers);
    }
    /**
     * Re-evaluates share policy for a document and updates sync accordingly
     *
     * @remarks
     * This is called when the share policy for a document has changed. It re-evaluates
     * which peers should have access and starts/stops synchronization as needed.
     */ async reevaluateDocumentShare() {
        const peers = Array.from(this.#peers);
        const docPromises = [];
        for (const docSynchronizer of Object.values(this.docSynchronizers)){
            const documentId = docSynchronizer.documentId;
            docPromises.push((async ()=>{
                for (const peerId of peers){
                    const shouldShare = await this.#shouldShare(peerId, documentId);
                    const isAlreadySyncing = docSynchronizer.hasPeer(peerId);
                    $0493b08b8598ec39$var$log(`reevaluateDocumentShare: ${peerId} for ${documentId}, shouldShare: ${shouldShare}, isAlreadySyncing: ${isAlreadySyncing}`);
                    if (shouldShare && !isAlreadySyncing) {
                        $0493b08b8598ec39$var$log(`reevaluateDocumentShare: starting sync with ${peerId} for ${documentId}`);
                        docSynchronizer.beginSync([
                            peerId
                        ]);
                    } else if (!shouldShare && isAlreadySyncing) {
                        $0493b08b8598ec39$var$log(`reevaluateDocumentShare: stopping sync with ${peerId} for ${documentId}`);
                        docSynchronizer.endSync(peerId);
                    }
                }
            })().catch((e)=>{
                console.log(`error reevaluating document share for ${documentId}: ${e}`);
            }));
        }
        await Promise.allSettled(docPromises);
    }
    metrics() {
        return Object.fromEntries(Object.entries(this.docSynchronizers).map(([documentId, synchronizer])=>{
            return [
                documentId,
                synchronizer.metrics()
            ];
        }));
    }
    async #shouldShare(peerId, documentId) {
        const [announce, access] = await Promise.all([
            this.repo.shareConfig.announce(peerId, documentId),
            this.repo.shareConfig.access(peerId, documentId)
        ]);
        const hasRequested = this.#hasRequested.get(documentId)?.has(peerId) ?? false;
        return announce || access && hasRequested;
    }
}



function $3ae07bf46c75a7ba$var$randomPeerId() {
    return "peer-" + Math.random().toString(36).slice(4);
}
class $3ae07bf46c75a7ba$export$bb6a5047eb26f32d extends (0, (/*@__PURE__*/$parcel$interopDefault($28edd11f6c7e9f5f$exports))) {
    #log;
    /** @hidden */ networkSubsystem;
    /** @hidden */ storageSubsystem;
    /** @hidden */ #saveDebounceRate;
    /** @hidden */ #saveFn;
    #handleCache = {};
    /** @hidden */ synchronizer;
    #shareConfig = {
        announce: async ()=>true,
        access: async ()=>true
    };
    /** maps peer id to to persistence information (storageId, isEphemeral), access by collection synchronizer  */ /** @hidden */ peerMetadataByPeerId = {};
    #remoteHeadsSubscriptions = new (0, $08b09118233ef298$export$d18166fc51e97dd)();
    #remoteHeadsGossipingEnabled = false;
    #progressCache = {};
    #saveFns = {};
    #idFactory;
    constructor({ storage: storage, network: network = [], peerId: peerId = $3ae07bf46c75a7ba$var$randomPeerId(), sharePolicy: sharePolicy, shareConfig: shareConfig, isEphemeral: isEphemeral = storage === undefined, enableRemoteHeadsGossiping: enableRemoteHeadsGossiping = false, denylist: denylist = [], saveDebounceRate: saveDebounceRate = 100, idFactory: idFactory } = {}){
        super();
        this.#remoteHeadsGossipingEnabled = enableRemoteHeadsGossiping;
        this.#log = (0, (/*@__PURE__*/$parcel$interopDefault($1SXIy)))(`automerge-repo:repo`);
        this.#idFactory = idFactory || null;
        // Handle legacy sharePolicy
        if (sharePolicy != null && shareConfig != null) throw new Error("cannot provide both sharePolicy and shareConfig at once");
        if (sharePolicy) this.#shareConfig = {
            announce: sharePolicy,
            access: async ()=>true
        };
        if (shareConfig) this.#shareConfig = shareConfig;
        this.on("delete-document", ({ documentId: documentId })=>{
            this.synchronizer.removeDocument(documentId);
            if (storageSubsystem) storageSubsystem.removeDoc(documentId).catch((err)=>{
                this.#log("error deleting document", {
                    documentId: documentId,
                    err: err
                });
            });
        });
        // SYNCHRONIZER
        // The synchronizer uses the network subsystem to keep documents in sync with peers.
        this.synchronizer = new (0, $0493b08b8598ec39$export$f725eb6eed148aab)(this, denylist);
        // When the synchronizer emits messages, send them to peers
        this.synchronizer.on("message", (message)=>{
            this.#log(`sending ${message.type} message to ${message.targetId}`);
            networkSubsystem.send(message);
        });
        // Forward metrics from doc synchronizers
        this.synchronizer.on("metrics", (event)=>this.emit("doc-metrics", event));
        if (this.#remoteHeadsGossipingEnabled) this.synchronizer.on("open-doc", ({ peerId: peerId, documentId: documentId })=>{
            this.#remoteHeadsSubscriptions.subscribePeerToDoc(peerId, documentId);
        });
        // STORAGE
        // The storage subsystem has access to some form of persistence, and deals with save and loading documents.
        const storageSubsystem = storage ? new (0, $d474326403a252bc$export$af46b7b95952eadf)(storage) : undefined;
        if (storageSubsystem) {
            storageSubsystem.on("document-loaded", (event)=>this.emit("doc-metrics", {
                    type: "doc-loaded",
                    ...event
                }));
            storageSubsystem.on("doc-compacted", (event)=>this.emit("doc-metrics", {
                    type: "doc-compacted",
                    ...event
                }));
            storageSubsystem.on("doc-saved", (event)=>this.emit("doc-metrics", {
                    type: "doc-saved",
                    ...event
                }));
        }
        this.storageSubsystem = storageSubsystem;
        this.#saveDebounceRate = saveDebounceRate;
        if (this.storageSubsystem) // Save no more often than saveDebounceRate.
        this.#saveFn = ({ handle: handle, doc: doc })=>{
            let fn = this.#saveFns[handle.documentId];
            if (!fn) {
                fn = (0, $147c725b0c5cefa5$export$de363e709c412c8a)(({ doc: doc, handle: handle })=>{
                    this.storageSubsystem.saveDoc(handle.documentId, doc);
                }, this.#saveDebounceRate);
                this.#saveFns[handle.documentId] = fn;
            }
            fn({
                handle: handle,
                doc: doc
            });
        };
        else this.#saveFn = ()=>{};
        // NETWORK
        // The network subsystem deals with sending and receiving messages to and from peers.
        const myPeerMetadata = (async ()=>({
                storageId: await storageSubsystem?.id(),
                isEphemeral: isEphemeral
            }))();
        const networkSubsystem = new (0, $cc58c014abe1974c$export$4b74e73b341d6846)(network, peerId, myPeerMetadata);
        this.networkSubsystem = networkSubsystem;
        // When we get a new peer, register it with the synchronizer
        networkSubsystem.on("peer", async ({ peerId: peerId, peerMetadata: peerMetadata })=>{
            this.#log("peer connected", {
                peerId: peerId
            });
            if (peerMetadata) this.peerMetadataByPeerId[peerId] = {
                ...peerMetadata
            };
            this.#shareConfig.announce(peerId).then((shouldShare)=>{
                if (shouldShare && this.#remoteHeadsGossipingEnabled) this.#remoteHeadsSubscriptions.addGenerousPeer(peerId);
            }).catch((err)=>{
                console.log("error in share policy", {
                    err: err
                });
            });
            this.synchronizer.addPeer(peerId);
        });
        // When a peer disconnects, remove it from the synchronizer
        networkSubsystem.on("peer-disconnected", ({ peerId: peerId })=>{
            this.synchronizer.removePeer(peerId);
            this.#remoteHeadsSubscriptions.removePeer(peerId);
        });
        // Handle incoming messages
        networkSubsystem.on("message", async (msg)=>{
            this.#receiveMessage(msg);
        });
        this.synchronizer.on("sync-state", (message)=>{
            this.#saveSyncState(message);
            const handle = this.#handleCache[message.documentId];
            const { storageId: storageId } = this.peerMetadataByPeerId[message.peerId] || {};
            if (!storageId) return;
            const heads = handle.getSyncInfo(storageId)?.lastHeads;
            const haveHeadsChanged = message.syncState.theirHeads && (!heads || !(0, $956570809efac935$export$f1581808060b6286)(heads, (0, $73665c112ce7e927$export$5b2c9a3be6980e12)(message.syncState.theirHeads)));
            if (haveHeadsChanged && message.syncState.theirHeads) {
                handle.setSyncInfo(storageId, {
                    lastHeads: (0, $73665c112ce7e927$export$5b2c9a3be6980e12)(message.syncState.theirHeads),
                    lastSyncTimestamp: Date.now()
                });
                if (storageId && this.#remoteHeadsGossipingEnabled) this.#remoteHeadsSubscriptions.handleImmediateRemoteHeadsChanged(message.documentId, storageId, (0, $73665c112ce7e927$export$5b2c9a3be6980e12)(message.syncState.theirHeads));
            }
        });
        if (this.#remoteHeadsGossipingEnabled) {
            this.#remoteHeadsSubscriptions.on("notify-remote-heads", (message)=>{
                this.networkSubsystem.send({
                    type: "remote-heads-changed",
                    targetId: message.targetId,
                    documentId: message.documentId,
                    newHeads: {
                        [message.storageId]: {
                            heads: message.heads,
                            timestamp: message.timestamp
                        }
                    }
                });
            });
            this.#remoteHeadsSubscriptions.on("change-remote-subs", (message)=>{
                this.#log("change-remote-subs", message);
                for (const peer of message.peers)this.networkSubsystem.send({
                    type: "remote-subscription-change",
                    targetId: peer,
                    add: message.add,
                    remove: message.remove
                });
            });
            this.#remoteHeadsSubscriptions.on("remote-heads-changed", ({ documentId: documentId, storageId: storageId, remoteHeads: remoteHeads, timestamp: timestamp })=>{
                const handle = this.#handleCache[documentId];
                handle.setSyncInfo(storageId, {
                    lastHeads: remoteHeads,
                    lastSyncTimestamp: timestamp
                });
            });
        }
    }
    // The `document` event is fired by the DocCollection any time we create a new document or look
    // up a document by ID. We listen for it in order to wire up storage and network synchronization.
    #registerHandleWithSubsystems(handle) {
        if (this.storageSubsystem) {
            // Add save function as a listener if it's not already registered
            const existingListeners = handle.listeners("heads-changed");
            if (!existingListeners.some((listener)=>listener === this.#saveFn)) // Save when the document changes
            handle.on("heads-changed", this.#saveFn);
        }
        // Register the document with the synchronizer. This advertises our interest in the document.
        this.synchronizer.addDocument(handle);
    }
    #receiveMessage(message) {
        switch(message.type){
            case "remote-subscription-change":
                if (this.#remoteHeadsGossipingEnabled) this.#remoteHeadsSubscriptions.handleControlMessage(message);
                break;
            case "remote-heads-changed":
                if (this.#remoteHeadsGossipingEnabled) this.#remoteHeadsSubscriptions.handleRemoteHeads(message);
                break;
            case "sync":
            case "request":
            case "ephemeral":
            case "doc-unavailable":
                this.synchronizer.receiveMessage(message).catch((err)=>{
                    console.log("error receiving message", {
                        err: err,
                        message: message
                    });
                });
        }
    }
    #throttledSaveSyncStateHandlers = {};
    /** saves sync state throttled per storage id, if a peer doesn't have a storage id it's sync state is not persisted */ #saveSyncState(payload) {
        if (!this.storageSubsystem) return;
        const { storageId: storageId, isEphemeral: isEphemeral } = this.peerMetadataByPeerId[payload.peerId] || {};
        if (!storageId || isEphemeral) return;
        let handler = this.#throttledSaveSyncStateHandlers[storageId];
        if (!handler) handler = this.#throttledSaveSyncStateHandlers[storageId] = (0, $147c725b0c5cefa5$export$de363e709c412c8a)(({ documentId: documentId, syncState: syncState })=>{
            this.storageSubsystem.saveSyncState(documentId, storageId, syncState);
        }, this.#saveDebounceRate);
        handler(payload);
    }
    /** Returns an existing handle if we have it; creates one otherwise. */ #getHandle({ documentId: documentId }) {
        // If we have the handle cached, return it
        if (this.#handleCache[documentId]) return this.#handleCache[documentId];
        // If not, create a new handle, cache it, and return it
        if (!documentId) throw new Error(`Invalid documentId ${documentId}`);
        const handle = new (0, $24957e09564e3864$export$adf9eb8d96703473)(documentId);
        this.#handleCache[documentId] = handle;
        return handle;
    }
    /** Returns all the handles we have cached. */ get handles() {
        return this.#handleCache;
    }
    /** Returns a list of all connected peer ids */ get peers() {
        return this.synchronizer.peers;
    }
    get peerId() {
        return this.networkSubsystem.peerId;
    }
    /** @hidden */ get sharePolicy() {
        return this.#shareConfig.announce;
    }
    /** @hidden */ set sharePolicy(policy) {
        this.#shareConfig.announce = policy;
    }
    /** @hidden */ get shareConfig() {
        return this.#shareConfig;
    }
    /** @hidden */ set shareConfig(config) {
        this.#shareConfig = config;
    }
    getStorageIdOfPeer(peerId) {
        return this.peerMetadataByPeerId[peerId]?.storageId;
    }
    /**
     * Creates a new document and returns a handle to it. The initial value of the document is an
     * empty object `{}` unless an initial value is provided. Its documentId is generated by the
     * system. we emit a `document` event to advertise interest in the document.
     */ create(initialValue) {
        let initialDoc;
        if (initialValue) initialDoc = (0, $8a8016b162b6f8b4$exports).from(initialValue);
        else initialDoc = (0, $8a8016b162b6f8b4$exports).emptyChange((0, $8a8016b162b6f8b4$exports).init());
        // Generate a new UUID and store it in the buffer
        const { documentId: documentId } = (0, $73665c112ce7e927$export$139eebd34d024bba)((0, $73665c112ce7e927$export$a64c058c4a74ab18)());
        const handle = this.#getHandle({
            documentId: documentId
        });
        this.#registerHandleWithSubsystems(handle);
        handle.update(()=>{
            return initialDoc;
        });
        handle.doneLoading();
        return handle;
    }
    /**
     * Creates a new document and returns a handle to it. The initial value of the
     * document is an empty object `{}` unless an initial value is provided. The
     * main difference between this and Repo.create is that if an `idGenerator`
     * was provided at repo construction, that idGenerator will be used to
     * generate the document ID of the document returned by this method.
     *
     * This is a hidden, experimental API which is subject to change or removal without notice.
     * @hidden
     * @experimental
     */ async create2(initialValue) {
        // Note that the reason this method is hidden and experimental is because it is async,
        // and it is async because we want to be able to call the #idGenerator, which is async.
        // This is all really in service of wiring up keyhive and we probably need to find a
        // nicer way to achieve this.
        let initialDoc;
        if (initialValue) initialDoc = (0, $8a8016b162b6f8b4$exports).from(initialValue);
        else initialDoc = (0, $8a8016b162b6f8b4$exports).emptyChange((0, $8a8016b162b6f8b4$exports).init());
        let { documentId: documentId } = (0, $73665c112ce7e927$export$139eebd34d024bba)((0, $73665c112ce7e927$export$a64c058c4a74ab18)());
        if (this.#idFactory) {
            const rawDocId = await this.#idFactory((0, $8a8016b162b6f8b4$exports).getHeads(initialDoc));
            documentId = (0, $73665c112ce7e927$export$ba6379d23c8aa3cc)(rawDocId);
        }
        const handle = this.#getHandle({
            documentId: documentId
        });
        this.#registerHandleWithSubsystems(handle);
        handle.update(()=>{
            return initialDoc;
        });
        handle.doneLoading();
        return handle;
    }
    /** Create a new DocHandle by cloning the history of an existing DocHandle.
     *
     * @param clonedHandle - The handle to clone
     *
     * @remarks This is a wrapper around the `clone` function in the Automerge library.
     * The new `DocHandle` will have a new URL but will share history with the original,
     * which means that changes made to the cloned handle can be sensibly merged back
     * into the original.
     *
     * Any peers this `Repo` is connected to for whom `sharePolicy` returns `true` will
     * be notified of the newly created DocHandle.
     *
     */ clone(clonedHandle) {
        if (!clonedHandle.isReady()) throw new Error(`Cloned handle is not yet in ready state.
        (Try await handle.whenReady() first.)`);
        const sourceDoc = clonedHandle.doc();
        const handle = this.create();
        handle.update(()=>{
            // we replace the document with the new cloned one
            return (0, $8a8016b162b6f8b4$exports).clone(sourceDoc);
        });
        return handle;
    }
    findWithProgress(id, options = {}) {
        const { signal: signal } = options;
        const { documentId: documentId, heads: heads } = (0, $73665c112ce7e927$export$3d350e89349f36dd)(id) ? (0, $73665c112ce7e927$export$139eebd34d024bba)(id) : {
            documentId: (0, $73665c112ce7e927$export$c1f8c569cf258d73)(id),
            heads: undefined
        };
        // Check handle cache first - return plain FindStep for terminal states
        if (this.#handleCache[documentId]) {
            const handle = this.#handleCache[documentId];
            if (handle.state === (0, $24957e09564e3864$export$f2d101b977a134fd)) {
                const result = {
                    state: "unavailable",
                    error: new Error(`Document ${id} is unavailable`),
                    handle: handle
                };
                return result;
            }
            if (handle.state === (0, $24957e09564e3864$export$1cc76b53f23597de)) {
                const result = {
                    state: "failed",
                    error: new Error(`Document ${id} was deleted`),
                    handle: handle
                };
                return result;
            }
            if (handle.state === (0, $24957e09564e3864$export$4bf05b02be91f13a)) {
                const result = {
                    state: "ready",
                    handle: heads ? handle.view(heads) : handle
                };
                return result;
            }
        }
        // Check progress cache for any existing signal
        const cachedProgress = this.#progressCache[documentId];
        if (cachedProgress) {
            const handle = this.#handleCache[documentId];
            // Return cached progress if we have a handle and it's either in a terminal state or loading
            if (handle && (handle.state === (0, $24957e09564e3864$export$4bf05b02be91f13a) || handle.state === (0, $24957e09564e3864$export$f2d101b977a134fd) || handle.state === (0, $24957e09564e3864$export$1cc76b53f23597de) || handle.state === "loading")) return cachedProgress;
        }
        const handle = this.#getHandle({
            documentId: documentId
        });
        const initial = {
            state: "loading",
            progress: 0,
            handle: handle
        };
        // Create a new progress signal
        const progressSignal = {
            subscribers: new Set(),
            currentProgress: undefined,
            notify: (progress)=>{
                progressSignal.currentProgress = progress;
                progressSignal.subscribers.forEach((callback)=>callback(progress));
                // Cache all states, not just terminal ones
                this.#progressCache[documentId] = progress;
            },
            peek: ()=>progressSignal.currentProgress || initial,
            subscribe: (callback)=>{
                progressSignal.subscribers.add(callback);
                return ()=>progressSignal.subscribers.delete(callback);
            }
        };
        progressSignal.notify(initial);
        // Start the loading process
        this.#loadDocumentWithProgress(id, documentId, handle, progressSignal, signal ? (0, $5acd321f8117a579$export$930d1888c9e0cd90)(new Promise(()=>{}), signal) : new Promise(()=>{}));
        const result = {
            ...initial,
            peek: progressSignal.peek,
            subscribe: progressSignal.subscribe
        };
        this.#progressCache[documentId] = result;
        return result;
    }
    async #loadDocumentWithProgress(id, documentId, handle, progressSignal, abortPromise) {
        try {
            progressSignal.notify({
                state: "loading",
                progress: 25,
                handle: handle
            });
            const loadingPromise = await (this.storageSubsystem ? this.storageSubsystem.loadDoc(handle.documentId) : Promise.resolve(null));
            const loadedDoc = await Promise.race([
                loadingPromise,
                abortPromise
            ]);
            if (loadedDoc) {
                handle.update(()=>loadedDoc);
                handle.doneLoading();
                progressSignal.notify({
                    state: "loading",
                    progress: 50,
                    handle: handle
                });
            } else {
                await Promise.race([
                    this.networkSubsystem.whenReady(),
                    abortPromise
                ]);
                handle.request();
                progressSignal.notify({
                    state: "loading",
                    progress: 75,
                    handle: handle
                });
            }
            this.#registerHandleWithSubsystems(handle);
            await Promise.race([
                handle.whenReady([
                    (0, $24957e09564e3864$export$4bf05b02be91f13a),
                    (0, $24957e09564e3864$export$f2d101b977a134fd)
                ]),
                abortPromise
            ]);
            if (handle.state === (0, $24957e09564e3864$export$f2d101b977a134fd)) {
                const unavailableProgress = {
                    state: "unavailable",
                    handle: handle
                };
                progressSignal.notify(unavailableProgress);
                return;
            }
            if (handle.state === (0, $24957e09564e3864$export$1cc76b53f23597de)) throw new Error(`Document ${id} was deleted`);
            progressSignal.notify({
                state: "ready",
                handle: handle
            });
        } catch (error) {
            progressSignal.notify({
                state: "failed",
                error: // In most JS environments DOMException extends Error, but not always, in some environments it's a separate type.
                // Some Node.js DOM polyfills do not always extend the Error
                // Jsdom polyfill doesn't extend Error, whereas happy-dom does.
                error instanceof Error || error instanceof DOMException ? error : new Error(String(error)),
                handle: this.#getHandle({
                    documentId: documentId
                })
            });
        }
    }
    async find(id, options = {}) {
        const { allowableStates: allowableStates = [
            "ready"
        ], signal: signal } = options;
        // Check if already aborted
        if (signal?.aborted) throw new (0, $5acd321f8117a579$export$18b052ffd8c84d7)();
        const progress = this.findWithProgress(id, {
            signal: signal
        });
        if ("subscribe" in progress) {
            this.#registerHandleWithSubsystems(progress.handle);
            return new Promise((resolve, reject)=>{
                const unsubscribe = progress.subscribe((state)=>{
                    if (allowableStates.includes(state.handle.state)) {
                        unsubscribe();
                        resolve(state.handle);
                    } else if (state.state === "unavailable") {
                        unsubscribe();
                        reject(new Error(`Document ${id} is unavailable`));
                    } else if (state.state === "failed") {
                        unsubscribe();
                        reject(state.error);
                    }
                });
            });
        } else {
            if (progress.handle.state === (0, $24957e09564e3864$export$4bf05b02be91f13a)) return progress.handle;
            // If the handle isn't ready, wait for it and then return it
            await progress.handle.whenReady([
                (0, $24957e09564e3864$export$4bf05b02be91f13a),
                (0, $24957e09564e3864$export$f2d101b977a134fd)
            ]);
            if (progress.handle.state === "unavailable" && !allowableStates.includes((0, $24957e09564e3864$export$f2d101b977a134fd))) throw new Error(`Document ${id} is unavailable`);
            return progress.handle;
        }
    }
    /**
     * Loads a document without waiting for ready state
     */ async #loadDocument(documentId) {
        // If we have the handle cached, return it
        if (this.#handleCache[documentId]) return this.#handleCache[documentId];
        // If we don't already have the handle, make an empty one and try loading it
        const handle = this.#getHandle({
            documentId: documentId
        });
        const loadedDoc = await (this.storageSubsystem ? this.storageSubsystem.loadDoc(handle.documentId) : Promise.resolve(null));
        if (loadedDoc) {
            // We need to cast this to <T> because loadDoc operates in <unknowns>.
            // This is really where we ought to be validating the input matches <T>.
            handle.update(()=>loadedDoc);
            handle.doneLoading();
        } else {
            // Because the network subsystem might still be booting up, we wait
            // here so that we don't immediately give up loading because we're still
            // making our initial connection to a sync server.
            await this.networkSubsystem.whenReady();
            handle.request();
        }
        this.#registerHandleWithSubsystems(handle);
        return handle;
    }
    /**
     * Retrieves a document by id. It gets data from the local system, but also emits a `document`
     * event to advertise interest in the document.
     */ async findClassic(/** The url or documentId of the handle to retrieve */ id, options = {}) {
        const documentId = (0, $73665c112ce7e927$export$c1f8c569cf258d73)(id);
        const { allowableStates: allowableStates, signal: signal } = options;
        return (0, $5acd321f8117a579$export$930d1888c9e0cd90)((async ()=>{
            const handle = await this.#loadDocument(documentId);
            if (!allowableStates) {
                await handle.whenReady([
                    (0, $24957e09564e3864$export$4bf05b02be91f13a),
                    (0, $24957e09564e3864$export$f2d101b977a134fd)
                ]);
                if (handle.state === (0, $24957e09564e3864$export$f2d101b977a134fd) && !signal?.aborted) throw new Error(`Document ${id} is unavailable`);
            }
            return handle;
        })(), signal);
    }
    delete(/** The url or documentId of the handle to delete */ id) {
        const documentId = (0, $73665c112ce7e927$export$c1f8c569cf258d73)(id);
        const handle = this.#getHandle({
            documentId: documentId
        });
        handle.delete();
        delete this.#handleCache[documentId];
        delete this.#progressCache[documentId];
        delete this.#saveFns[documentId];
        this.emit("delete-document", {
            documentId: documentId
        });
    }
    /**
     * Exports a document to a binary format.
     * @param id - The url or documentId of the handle to export
     *
     * @returns Promise<Uint8Array | undefined> - A Promise containing the binary document,
     * or undefined if the document is unavailable.
     */ async export(id) {
        const documentId = (0, $73665c112ce7e927$export$c1f8c569cf258d73)(id);
        const handle = await this.find(documentId);
        const doc = handle.doc();
        return (0, $8a8016b162b6f8b4$exports).save(doc);
    }
    /**
     * Imports document binary into the repo.
     * @param binary - The binary to import
     * @param args - Optional argument specifying what document ID to import into,
     *              if at all possible avoid using this, see the remarks below
     *
     * @remarks
     * If no document ID is provided, a new document will be created. When
     * specifying the document ID it is important to ensure that two documents using
     * the same ID share the same history - i.e. don't create a document with the
     * same ID on unrelated processes that have never communicated with each
     * other. If you need to ship around a bunch of documents with their IDs
     * consider using the `automerge-repo-bundles` package which provides a
     * serialization format for documents and IDs and handles the boilerplate of
     * importing and exporting these bundles.
     */ import(binary, args) {
        const docId = args?.docId;
        if (docId != null) {
            const handle = this.#getHandle({
                documentId: docId
            });
            handle.update((doc)=>{
                return (0, $8a8016b162b6f8b4$exports).loadIncremental(doc, binary);
            });
            this.#registerHandleWithSubsystems(handle);
            return handle;
        } else {
            const doc = (0, $8a8016b162b6f8b4$exports).load(binary);
            const handle = this.create();
            handle.update(()=>{
                return (0, $8a8016b162b6f8b4$exports).clone(doc);
            });
            return handle;
        }
    }
    subscribeToRemotes = (remotes)=>{
        if (this.#remoteHeadsGossipingEnabled) {
            this.#log("subscribeToRemotes", {
                remotes: remotes
            });
            this.#remoteHeadsSubscriptions.subscribeToRemotes(remotes);
        } else this.#log("WARN: subscribeToRemotes called but remote heads gossiping is not enabled");
    };
    storageId = async ()=>{
        if (!this.storageSubsystem) return undefined;
        else return this.storageSubsystem.id();
    };
    /**
     * Writes Documents to a disk.
     * @hidden this API is experimental and may change.
     * @param documents - if provided, only writes the specified documents.
     * @returns Promise<void>
     */ async flush(documents) {
        if (!this.storageSubsystem) return;
        const handles = documents ? documents.map((id)=>this.#handleCache[id]) : Object.values(this.#handleCache);
        await Promise.all(handles.map(async (handle)=>{
            return this.storageSubsystem.saveDoc(handle.documentId, handle.doc());
        }));
    }
    /**
     * Removes a DocHandle from the handleCache.
     * @hidden this API is experimental and may change.
     * @param documentId - documentId of the DocHandle to remove from handleCache, if present in cache.
     * @returns Promise<void>
     */ async removeFromCache(documentId) {
        if (!this.#handleCache[documentId]) {
            this.#log(`WARN: removeFromCache called but handle not found in handleCache for documentId: ${documentId}`);
            return;
        }
        const handle = this.#getHandle({
            documentId: documentId
        });
        await handle.whenReady([
            (0, $24957e09564e3864$export$4bf05b02be91f13a),
            (0, $24957e09564e3864$export$dcfeb5ccce46eb13),
            (0, $24957e09564e3864$export$1cc76b53f23597de),
            (0, $24957e09564e3864$export$f2d101b977a134fd)
        ]);
        const doc = handle.doc();
        // because this is an internal-ish function, we'll be extra careful about undefined docs here
        if (doc) {
            if (handle.isReady()) handle.unload();
            else this.#log(`WARN: removeFromCache called but handle for documentId: ${documentId} in unexpected state: ${handle.state}`);
            delete this.#handleCache[documentId];
            delete this.#progressCache[documentId];
            delete this.#saveFns[documentId];
            this.synchronizer.removeDocument(documentId);
        } else this.#log(`WARN: removeFromCache called but doc undefined for documentId: ${documentId}`);
    }
    shutdown() {
        this.networkSubsystem.adapters.forEach((adapter)=>{
            adapter.disconnect();
        });
        return this.flush();
    }
    metrics() {
        return {
            documents: this.synchronizer.metrics()
        };
    }
    shareConfigChanged() {
        this.synchronizer.reevaluateDocumentShare();
    }
}



const $936d69da9439f4a1$export$6770df267fd1e2ab = 15000;
const $936d69da9439f4a1$export$31001ff29b83880e = 3 * $936d69da9439f4a1$export$6770df267fd1e2ab;
const $936d69da9439f4a1$export$b792c6c24aa2c2b = "__presence";


/**
 * A grouped view of peer states.
 */ class $f939254d7b229db1$export$dc9ee4bb6e022ed {
    value;
    constructor(value){
        this.value = value;
    }
    /**
     * Get the presence state of all peers. By default, each peer is its own
     * group, but presence activity can be aggregated by arbitrary criteria.
     *
     * @param opts
     * @returns presence state for all groups
     */ getStates(opts) {
        const groupingFn = opts?.groupingFn ?? $f939254d7b229db1$export$3e436401e21955d8;
        const summaryFn = opts?.summaryFn ?? $f939254d7b229db1$export$6f501c9b36c008a9;
        const statesByKey = Object.values(this.value).reduce((byKey, curr)=>{
            const key = groupingFn(curr);
            if (!(key in byKey)) byKey[key] = [];
            byKey[key].push(curr);
            return byKey;
        }, {});
        return Object.entries(statesByKey).reduce((result, [key, states])=>{
            result[key] = summaryFn(states);
            return result;
        }, {});
    }
}
function $f939254d7b229db1$export$3e436401e21955d8(peer) {
    return peer.peerId;
}
function $f939254d7b229db1$export$6f501c9b36c008a9(peers) {
    let freshestLastActiveAt;
    return peers.reduce((freshest, curr)=>{
        const lastActiveAt = curr.lastActiveAt;
        if (!lastActiveAt) return freshest;
        if (!freshest || lastActiveAt > freshestLastActiveAt) {
            freshestLastActiveAt = lastActiveAt;
            return curr;
        }
        return freshest;
    }, undefined);
}
function $f939254d7b229db1$export$e2d19ede0f88dcdc(peers) {
    let freshestLastSeenAt;
    return peers.reduce((freshest, curr)=>{
        const lastSeenAt = curr.lastSeenAt;
        if (!lastSeenAt) return freshest;
        if (!freshest || lastSeenAt > freshestLastSeenAt) {
            freshestLastSeenAt = lastSeenAt;
            return curr;
        }
        return freshest;
    }, undefined);
}


class $93a322aa9a3deb0e$export$d8c7ef3ab69057b8 {
    ttl;
    #peerStates = new (0, $f939254d7b229db1$export$dc9ee4bb6e022ed)({});
    /**
     * Build a new peer presence state.
     *
     * @param ttl in milliseconds - peers with no activity within this timeframe
     * are forgotten when {@link prune} is called.
     */ constructor(ttl){
        this.ttl = ttl;
    }
    has(peerId) {
        return peerId in this.#peerStates.value;
    }
    /**
     * Record that we've seen the given peer recently.
     *
     * @param peerId
     */ markSeen(peerId) {
        if (!(peerId in this.#peerStates.value)) // Ignore heartbeats from peers we have not seen before: they will send a snapshot
        return;
        this.#peerStates = new (0, $f939254d7b229db1$export$dc9ee4bb6e022ed)({
            ...this.#peerStates.value,
            [peerId]: {
                ...this.#peerStates.value[peerId],
                lastSeenAt: Date.now()
            }
        });
    }
    /**
     * Record a state update for the given peer. Note that existing state is not
     * overwritten.
     *
     * @param peerId
     * @param value
     */ update({ peerId: peerId, value: value }) {
        const peerState = this.#peerStates.value[peerId];
        const existingState = peerState?.value ?? {};
        const now = Date.now();
        this.#peerStates = new (0, $f939254d7b229db1$export$dc9ee4bb6e022ed)({
            ...this.#peerStates.value,
            [peerId]: {
                peerId: peerId,
                lastSeenAt: now,
                lastActiveAt: now,
                value: {
                    ...existingState,
                    ...value
                }
            }
        });
    }
    /**
     * Forget the given peer.
     *
     * @param peerId
     */ delete(peerId) {
        this.#peerStates = new (0, $f939254d7b229db1$export$dc9ee4bb6e022ed)(Object.fromEntries(Object.entries(this.#peerStates.value).filter(([existingId])=>{
            return existingId != peerId;
        })));
    }
    /**
     * Prune all peers that have not been seen since the configured ttl has
     * elapsed.
     */ prune() {
        const threshold = Date.now() - this.ttl;
        const pruned = [];
        this.#peerStates = new (0, $f939254d7b229db1$export$dc9ee4bb6e022ed)(Object.fromEntries(Object.entries(this.#peerStates.value).filter(([id, state])=>{
            const keep = state.lastSeenAt >= threshold;
            if (!keep) pruned.push(id);
            return keep;
        })));
        return pruned;
    }
    /**
     * Get a snapshot of the current peer states
     */ get states() {
        return this.#peerStates;
    }
}


class $93e26b5d1e13b6d6$export$99c2b779aa4e8b8b extends (0, (/*@__PURE__*/$parcel$interopDefault($28edd11f6c7e9f5f$exports))) {
    #handle;
    #peers;
    #localState;
    #heartbeatMs;
    #handleEphemeralMessage;
    #heartbeatInterval;
    #pruningInterval;
    #hellos = [];
    #running = false;
    /**
     * Create a new Presence to share ephemeral state with peers.
     *
     * @param config see {@link PresenceConfig}
     * @returns
     */ constructor({ handle: handle }){
        super();
        this.#handle = handle;
        this.#peers = new (0, $93a322aa9a3deb0e$export$d8c7ef3ab69057b8)((0, $936d69da9439f4a1$export$31001ff29b83880e));
        this.#localState = {};
    }
    /**
     * Start listening to ephemeral messages on the handle, broadcast initial
     * state to peers, and start sending heartbeats.
     */ start({ initialState: initialState, heartbeatMs: heartbeatMs, peerTtlMs: peerTtlMs }) {
        if (this.#running) return;
        this.#running = true;
        this.#heartbeatMs = heartbeatMs ?? (0, $936d69da9439f4a1$export$6770df267fd1e2ab);
        this.#peers = new (0, $93a322aa9a3deb0e$export$d8c7ef3ab69057b8)(peerTtlMs ?? (0, $936d69da9439f4a1$export$31001ff29b83880e));
        this.#localState = initialState;
        // N.B.: We can't use a regular member function here since member functions
        // of two distinct objects are identical, and we need to be able to stop
        // listening to the handle for just this Presence instance in stop()
        this.#handleEphemeralMessage = (e)=>{
            const peerId = e.senderId;
            const envelope = e.message;
            if (!((0, $936d69da9439f4a1$export$b792c6c24aa2c2b) in envelope)) return;
            const message = envelope[0, $936d69da9439f4a1$export$b792c6c24aa2c2b];
            if (!this.#peers.has(peerId)) this.announce();
            switch(message.type){
                case "heartbeat":
                    this.#peers.markSeen(peerId);
                    this.emit("heartbeat", {
                        type: "heartbeat",
                        peerId: peerId
                    });
                    break;
                case "goodbye":
                    this.#peers.delete(peerId);
                    this.emit("goodbye", {
                        type: "goodbye",
                        peerId: peerId
                    });
                    break;
                case "update":
                    this.#peers.update({
                        peerId: peerId,
                        value: {
                            [message.channel]: message.value
                        }
                    });
                    this.emit("update", {
                        type: "update",
                        peerId: peerId,
                        channel: message.channel,
                        value: message.value
                    });
                    break;
                case "snapshot":
                    this.#peers.update({
                        peerId: peerId,
                        value: message.state
                    });
                    this.emit("snapshot", {
                        type: "snapshot",
                        peerId: peerId,
                        state: message.state
                    });
                    break;
            }
        };
        this.#handle.on("ephemeral-message", this.#handleEphemeralMessage);
        this.broadcastLocalState(); // also starts heartbeats
        this.startPruningPeers();
    }
    /**
     * Return a view of current peer states.
     */ getPeerStates() {
        return this.#peers.states;
    }
    /**
     * Return a view of current local state.
     */ getLocalState() {
        return this.#localState;
    }
    /**
     * Update state for the specific channel, and broadcast new state to all
     * peers.
     *
     * @param channel
     * @param value
     */ broadcast(channel, value) {
        this.#localState = Object.assign({}, this.#localState, {
            [channel]: value
        });
        this.broadcastChannelState(channel);
    }
    /**
     * Whether this Presence is currently active. See
     * {@link start} and {@link stop}.
     */ get running() {
        return this.#running;
    }
    /**
     * Stop this Presence: broadcast a "goodbye" message (when received, other
     * peers will immediately forget the sender), stop sending heartbeats, and
     * stop listening to ephemeral-messages broadcast from peers.
     *
     * This can be used with browser events like
     * {@link https://developer.mozilla.org/en-US/docs/Web/API/Window/pagehide_event | "pagehide"}
     * or
     * {@link https://developer.mozilla.org/en-US/docs/Web/API/Document/visibilitychange_event | "visibilitychange"}
     * to stop sending and receiving updates when not active.
     */ stop() {
        if (!this.#running) return;
        this.#hellos.forEach((timeoutId)=>{
            clearTimeout(timeoutId);
        });
        this.#hellos = [];
        this.#handle.off("ephemeral-message", this.#handleEphemeralMessage);
        this.stopHeartbeats();
        this.stopPruningPeers();
        this.send({
            type: "goodbye"
        });
        this.#running = false;
    }
    announce() {
        // Broadcast our current state whenever we see new peers
        // TODO: We currently need to wait for the peer to be ready, but waiting
        // some arbitrary amount of time is brittle
        const helloId = setTimeout(()=>{
            this.broadcastLocalState();
            this.#hellos = this.#hellos.filter((id)=>id !== helloId);
        }, 500);
        this.#hellos.push(helloId);
    }
    broadcastLocalState() {
        this.doBroadcast("snapshot", {
            state: this.#localState
        });
        this.resetHeartbeats();
    }
    broadcastChannelState(channel) {
        const value = this.#localState[channel];
        this.doBroadcast("update", {
            channel: channel,
            value: value
        });
        this.resetHeartbeats();
    }
    resetHeartbeats() {
        // Reset heartbeats every time we broadcast a message to avoid sending
        // unnecessary heartbeats when there is plenty of actual update activity
        // happening.
        this.stopHeartbeats();
        this.startHeartbeats();
    }
    doBroadcast(type, extra) {
        this.send({
            type: type,
            ...extra
        });
    }
    send(message) {
        if (!this.#running) return;
        this.#handle.broadcast({
            [(0, $936d69da9439f4a1$export$b792c6c24aa2c2b)]: message
        });
    }
    startHeartbeats() {
        if (this.#heartbeatInterval !== undefined) return;
        this.#heartbeatInterval = setInterval(()=>{
            this.send({
                type: "heartbeat"
            });
        }, this.#heartbeatMs);
    }
    stopHeartbeats() {
        if (this.#heartbeatInterval === undefined) return;
        clearInterval(this.#heartbeatInterval);
        this.#heartbeatInterval = undefined;
    }
    startPruningPeers() {
        if (this.#pruningInterval !== undefined) return;
        // Pruning happens at the heartbeat frequency, not on a peer ttl frequency,
        // to minimize variance between peer expiration, since the heartbeat frequency
        // is expected to be several times higher.
        this.#pruningInterval = setInterval(()=>{
            const pruned = this.#peers.prune();
            if (pruned.length > 0) this.emit("pruning", {
                pruned: pruned
            });
        }, this.#heartbeatMs);
    }
    stopPruningPeers() {
        if (this.#pruningInterval === undefined) return;
        clearInterval(this.#pruningInterval);
        this.#pruningInterval = undefined;
    }
}



/* c8 ignore start */ 
class $dfba51f62e6f8b1e$export$63c7cc768ae2a3e2 extends (0, (/*@__PURE__*/$parcel$interopDefault($28edd11f6c7e9f5f$exports))) {
    peerId;
    peerMetadata;
}



/** A storage adapter represents some way of storing binary data for a {@link Repo}
 * @deprecated use {@link StorageAdapterInterface}
 *
 * @remarks
 * `StorageAdapter`s provide a key/value storage interface. The keys are arrays of strings
 * ({@link StorageKey}) and the values are binary blobs.
 */ class $89a26be7eb191bef$export$101f5cfbc14cf15e {
}







const $c24cfbf34a6b127c$export$1b74141c5fe63a28 = (0, $8a8016b162b6f8b4$exports).Counter;
const $c24cfbf34a6b127c$export$273a6633ac335954 = (0, $8a8016b162b6f8b4$exports).RawString;
const $c24cfbf34a6b127c$export$3e488ffad70f65de = (0, $8a8016b162b6f8b4$exports).RawString;
const $c24cfbf34a6b127c$export$db14845dcbb6e6df = (0, $8a8016b162b6f8b4$exports).getChanges;
const $c24cfbf34a6b127c$export$56552f518dc96f0f = (0, $8a8016b162b6f8b4$exports).getAllChanges;
const $c24cfbf34a6b127c$export$10db731c0a813ec1 = (0, $8a8016b162b6f8b4$exports).applyChanges;
const $c24cfbf34a6b127c$export$c4ddc81c7b2c8d7a = (0, $8a8016b162b6f8b4$exports).view;
const $c24cfbf34a6b127c$export$733bb30b9159fd88 = (0, $8a8016b162b6f8b4$exports).getConflicts;
const $c24cfbf34a6b127c$export$da3f040fb23d21f = (0, $8a8016b162b6f8b4$exports).getCursor;
const $c24cfbf34a6b127c$export$47774cf7fb07bfc4 = (0, $8a8016b162b6f8b4$exports).getCursorPosition;
const $c24cfbf34a6b127c$export$869882364835d202 = (0, $8a8016b162b6f8b4$exports).splice;
const $c24cfbf34a6b127c$export$482314a40d8c0657 = (0, $8a8016b162b6f8b4$exports).updateText;
const $c24cfbf34a6b127c$export$9f200c4466975173 = (0, $8a8016b162b6f8b4$exports).insertAt;
const $c24cfbf34a6b127c$export$90f9093465da3136 = (0, $8a8016b162b6f8b4$exports).deleteAt;
const $c24cfbf34a6b127c$export$bf7f2fce5c1cf636 = (0, $8a8016b162b6f8b4$exports).mark;
const $c24cfbf34a6b127c$export$3522532a010241a0 = (0, $8a8016b162b6f8b4$exports).unmark;
const $c24cfbf34a6b127c$export$eab0fb792e5f13ed = (0, $8a8016b162b6f8b4$exports).isRawString;
const $c24cfbf34a6b127c$export$c8182079cd36e71f = (0, $8a8016b162b6f8b4$exports).isRawString;
const $c24cfbf34a6b127c$export$fa986b91291934c7 = (0, $8a8016b162b6f8b4$exports).getObjectId;





/**
 * This module provides a storage adapter for IndexedDB.
 *
 * @packageDocumentation
 */ class $f62083d56bd93169$export$5e35002d9f13957e {
    database;
    store;
    dbPromise;
    /** Create a new {@link IndexedDBStorageAdapter}.
     * @param database - The name of the database to use. Defaults to "automerge".
     * @param store - The name of the object store to use. Defaults to "documents".
     */ constructor(database = "automerge", store = "documents"){
        this.database = database;
        this.store = store;
        this.dbPromise = this.createDatabasePromise();
    }
    createDatabasePromise() {
        return new Promise((resolve, reject)=>{
            const request = indexedDB.open(this.database, 1);
            request.onerror = ()=>{
                reject(request.error);
            };
            request.onupgradeneeded = (event)=>{
                const db = event.target.result;
                db.createObjectStore(this.store);
            };
            request.onsuccess = (event)=>{
                const db = event.target.result;
                resolve(db);
            };
        });
    }
    async load(keyArray) {
        const db = await this.dbPromise;
        const transaction = db.transaction(this.store);
        const objectStore = transaction.objectStore(this.store);
        const request = objectStore.get(keyArray);
        return new Promise((resolve, reject)=>{
            transaction.onerror = ()=>{
                reject(request.error);
            };
            request.onsuccess = (event)=>{
                const result = event.target.result;
                if (result && typeof result === "object" && "binary" in result) resolve(result.binary);
                else resolve(undefined);
            };
        });
    }
    async save(keyArray, binary) {
        const db = await this.dbPromise;
        const transaction = db.transaction(this.store, "readwrite");
        const objectStore = transaction.objectStore(this.store);
        objectStore.put({
            key: keyArray,
            binary: binary
        }, keyArray);
        return new Promise((resolve, reject)=>{
            transaction.onerror = ()=>{
                reject(transaction.error);
            };
            transaction.oncomplete = ()=>{
                resolve();
            };
        });
    }
    async remove(keyArray) {
        const db = await this.dbPromise;
        const transaction = db.transaction(this.store, "readwrite");
        const objectStore = transaction.objectStore(this.store);
        objectStore.delete(keyArray);
        return new Promise((resolve, reject)=>{
            transaction.onerror = ()=>{
                reject(transaction.error);
            };
            transaction.oncomplete = ()=>{
                resolve();
            };
        });
    }
    async loadRange(keyPrefix) {
        const db = await this.dbPromise;
        const lowerBound = keyPrefix;
        const upperBound = [
            ...keyPrefix,
            "\uffff"
        ];
        const range = IDBKeyRange.bound(lowerBound, upperBound);
        const transaction = db.transaction(this.store);
        const objectStore = transaction.objectStore(this.store);
        const request = objectStore.openCursor(range);
        const result = [];
        return new Promise((resolve, reject)=>{
            transaction.onerror = ()=>{
                reject(request.error);
            };
            request.onsuccess = (event)=>{
                const cursor = event.target.result;
                if (cursor) {
                    result.push({
                        data: cursor.value.binary,
                        key: cursor.key
                    });
                    cursor.continue();
                } else resolve(result);
            };
        });
    }
    async removeRange(keyPrefix) {
        const db = await this.dbPromise;
        const lowerBound = keyPrefix;
        const upperBound = [
            ...keyPrefix,
            "\uffff"
        ];
        const range = IDBKeyRange.bound(lowerBound, upperBound);
        const transaction = db.transaction(this.store, "readwrite");
        const objectStore = transaction.objectStore(this.store);
        objectStore.delete(range);
        return new Promise((resolve, reject)=>{
            transaction.onerror = ()=>{
                reject(transaction.error);
            };
            transaction.oncomplete = ()=>{
                resolve();
            };
        });
    }
}


/**
 * A `NetworkAdapter` which connects to a remote host via WebSockets
 *
 * The websocket protocol requires a server to be listening and a client to
 * connect to the server. To that end the {@link WebSocketServerAdapter} does not
 * make outbound connections and instead listens on the provided socket for
 * new connections whilst the {@link WebSocketClientAdapter} makes an
 * outbound connection to the provided socket.
 *
 * Note that the "browser" and "node" naming is a bit misleading, both
 * implementations work in both the browser and on node via `isomorphic-ws`.
 *
 * @module
 * */ 
// https://github.com/maxogden/websocket-stream/blob/48dc3ddf943e5ada668c31ccd94e9186f02fafbd/ws-fallback.js
var $600696615019689e$var$ws = null;
if (typeof WebSocket !== 'undefined') $600696615019689e$var$ws = WebSocket;
else if (typeof MozWebSocket !== 'undefined') $600696615019689e$var$ws = MozWebSocket;
else if (typeof $parcel$global !== 'undefined') $600696615019689e$var$ws = $parcel$global.WebSocket || $parcel$global.MozWebSocket;
else if (typeof window !== 'undefined') $600696615019689e$var$ws = window.WebSocket || window.MozWebSocket;
else if (typeof self !== 'undefined') $600696615019689e$var$ws = self.WebSocket || self.MozWebSocket;
var $600696615019689e$export$2e2bcd8739ae039 = $600696615019689e$var$ws;



var $1SXIy = parcelRequire("1SXIy");
// TYPE GUARDS
const $1edf922be16631fc$export$75ca4cf475463181 = (message)=>message.type === "join";
const $1edf922be16631fc$export$1ac9913070c11889 = (message)=>message.type === "peer";
const $1edf922be16631fc$export$1f58c1cb33987e0d = (message)=>message.type === "error";


const $3dcf81554608ea34$export$8599dfde47853686 = "1";


/* c8 ignore start */ function $e2d055ea5be47785$export$a7a9523472993e97(value, message = "Assertion failed") {
    if (value === false || value === null || value === undefined) {
        const error = new Error($e2d055ea5be47785$var$trimLines(message));
        error.stack = $e2d055ea5be47785$var$removeLine(error.stack, "assert.ts");
        throw error;
    }
}
const $e2d055ea5be47785$var$trimLines = (s)=>s.split("\n").map((s)=>s.trim()).join("\n");
const $e2d055ea5be47785$var$removeLine = (s = "", targetText)=>s.split("\n").filter((line)=>!line.includes(targetText)).join("\n"); /* c8 ignore end */ 


/**
 * This incantation deals with websocket sending the whole underlying buffer even if we just have a
 * uint8array view on it
 */ const $73fffdf743294fd6$export$8b22b05f429b130c = (bytes)=>{
    const { buffer: buffer, byteOffset: byteOffset, byteLength: byteLength } = bytes;
    return buffer.slice(byteOffset, byteOffset + byteLength);
};


class $0afb33f1ad125bfd$var$WebSocketNetworkAdapter extends (0, $dfba51f62e6f8b1e$export$63c7cc768ae2a3e2) {
    socket;
}
class $0afb33f1ad125bfd$export$d29687ed0c139dcf extends $0afb33f1ad125bfd$var$WebSocketNetworkAdapter {
    url;
    retryInterval;
    #ready = false;
    #readyResolver;
    #readyPromise = new Promise((resolve)=>{
        this.#readyResolver = resolve;
    });
    isReady() {
        return this.#ready;
    }
    whenReady() {
        return this.#readyPromise;
    }
    #forceReady() {
        if (!this.#ready) {
            this.#ready = true;
            this.#readyResolver?.();
        }
    }
    #retryIntervalId;
    #log = (0, (/*@__PURE__*/$parcel$interopDefault($1SXIy)))("automerge-repo:websocket:browser");
    remotePeerId;
    constructor(url, retryInterval = 5000){
        super();
        this.url = url;
        this.retryInterval = retryInterval;
        this.#log = this.#log.extend(url);
    }
    connect(peerId, peerMetadata) {
        if (!this.socket || !this.peerId) {
            // first time connecting
            this.#log("connecting");
            this.peerId = peerId;
            this.peerMetadata = peerMetadata ?? {};
        } else {
            this.#log("reconnecting");
            (0, $e2d055ea5be47785$export$a7a9523472993e97)(peerId === this.peerId);
            // Remove the old event listeners before creating a new connection.
            this.socket.removeEventListener("open", this.onOpen);
            this.socket.removeEventListener("close", this.onClose);
            this.socket.removeEventListener("message", this.onMessage);
            this.socket.removeEventListener("error", this.onError);
        }
        // Wire up retries
        if (!this.#retryIntervalId) this.#retryIntervalId = setInterval(()=>{
            this.connect(peerId, peerMetadata);
        }, this.retryInterval);
        this.socket = new (0, $600696615019689e$export$2e2bcd8739ae039)(this.url);
        this.socket.binaryType = "arraybuffer";
        this.socket.addEventListener("open", this.onOpen);
        this.socket.addEventListener("close", this.onClose);
        this.socket.addEventListener("message", this.onMessage);
        this.socket.addEventListener("error", this.onError);
        // Mark this adapter as ready if we haven't received an ack in 1 second.
        // We might hear back from the other end at some point but we shouldn't
        // hold up marking things as unavailable for any longer
        setTimeout(()=>this.#forceReady(), 1000);
        this.join();
    }
    onOpen = ()=>{
        this.#log("open");
        clearInterval(this.#retryIntervalId);
        this.#retryIntervalId = undefined;
        this.join();
    };
    // When a socket closes, or disconnects, remove it from the array.
    onClose = ()=>{
        this.#log("close");
        if (this.remotePeerId) this.emit("peer-disconnected", {
            peerId: this.remotePeerId
        });
        if (this.retryInterval > 0 && !this.#retryIntervalId) // try to reconnect
        setTimeout(()=>{
            (0, $e2d055ea5be47785$export$a7a9523472993e97)(this.peerId);
            return this.connect(this.peerId, this.peerMetadata);
        }, this.retryInterval);
    };
    onMessage = (event)=>{
        this.receiveMessage(event.data);
    };
    /** The websocket error handler signature is different on node and the browser.  */ onError = (event // node
    )=>{
        if ("error" in event) {
            // (node)
            if (event.error.code !== "ECONNREFUSED") /* c8 ignore next */ throw event.error;
        }
        this.#log("Connection failed, retrying...");
    };
    join() {
        (0, $e2d055ea5be47785$export$a7a9523472993e97)(this.peerId);
        (0, $e2d055ea5be47785$export$a7a9523472993e97)(this.socket);
        if (this.socket.readyState === (0, $600696615019689e$export$2e2bcd8739ae039).OPEN) this.send($0afb33f1ad125bfd$var$joinMessage(this.peerId, this.peerMetadata));
    }
    disconnect() {
        (0, $e2d055ea5be47785$export$a7a9523472993e97)(this.peerId);
        (0, $e2d055ea5be47785$export$a7a9523472993e97)(this.socket);
        const socket = this.socket;
        if (socket) {
            socket.removeEventListener("open", this.onOpen);
            socket.removeEventListener("close", this.onClose);
            socket.removeEventListener("message", this.onMessage);
            socket.removeEventListener("error", this.onError);
            socket.close();
        }
        clearInterval(this.#retryIntervalId);
        if (this.remotePeerId) this.emit("peer-disconnected", {
            peerId: this.remotePeerId
        });
        this.socket = undefined;
    }
    send(message) {
        if ("data" in message && message.data?.byteLength === 0) throw new Error("Tried to send a zero-length message");
        (0, $e2d055ea5be47785$export$a7a9523472993e97)(this.peerId);
        if (!this.socket) {
            this.#log("Tried to send on a disconnected socket.");
            return;
        }
        if (this.socket.readyState !== (0, $600696615019689e$export$2e2bcd8739ae039).OPEN) throw new Error(`Websocket not ready (${this.socket.readyState})`);
        const encoded = (0, $801768f2dbeea819$exports).encode(message);
        this.socket.send((0, $73fffdf743294fd6$export$8b22b05f429b130c)(encoded));
    }
    peerCandidate(remotePeerId, peerMetadata) {
        (0, $e2d055ea5be47785$export$a7a9523472993e97)(this.socket);
        this.#forceReady();
        this.remotePeerId = remotePeerId;
        this.emit("peer-candidate", {
            peerId: remotePeerId,
            peerMetadata: peerMetadata
        });
    }
    receiveMessage(messageBytes) {
        let message;
        try {
            message = (0, $801768f2dbeea819$exports).decode(new Uint8Array(messageBytes));
        } catch (e) {
            this.#log("error decoding message:", e);
            return;
        }
        (0, $e2d055ea5be47785$export$a7a9523472993e97)(this.socket);
        if (messageBytes.byteLength === 0) throw new Error("received a zero-length message");
        if ((0, $1edf922be16631fc$export$1ac9913070c11889)(message)) {
            const { peerMetadata: peerMetadata } = message;
            this.#log(`peer: ${message.senderId}`);
            this.peerCandidate(message.senderId, peerMetadata);
        } else if ((0, $1edf922be16631fc$export$1f58c1cb33987e0d)(message)) this.#log(`error: ${message.message}`);
        else this.emit("message", message);
    }
}
function $0afb33f1ad125bfd$var$joinMessage(senderId, peerMetadata) {
    return {
        type: "join",
        senderId: senderId,
        peerMetadata: peerMetadata,
        supportedProtocolVersions: [
            (0, $3dcf81554608ea34$export$8599dfde47853686)
        ]
    };
}




var $1SXIy = parcelRequire("1SXIy");





const $737d623262652b14$var$log = (0, (/*@__PURE__*/$parcel$interopDefault($1SXIy)))("WebsocketServer");
const { encode: $737d623262652b14$var$encode, decode: $737d623262652b14$var$decode } = (0, $801768f2dbeea819$exports);
class $737d623262652b14$export$c3b7395b74e5445c extends (0, $dfba51f62e6f8b1e$export$63c7cc768ae2a3e2) {
    server;
    keepAliveInterval;
    sockets = {};
    #ready = false;
    #readyResolver;
    #readyPromise = new Promise((resolve)=>{
        this.#readyResolver = resolve;
    });
    isReady() {
        return this.#ready;
    }
    whenReady() {
        return this.#readyPromise;
    }
    #forceReady() {
        if (!this.#ready) {
            this.#ready = true;
            this.#readyResolver?.();
        }
    }
    constructor(server, keepAliveInterval = 5000){
        super();
        this.server = server;
        this.keepAliveInterval = keepAliveInterval;
    }
    connect(peerId, peerMetadata) {
        this.peerId = peerId;
        this.peerMetadata = peerMetadata;
        this.server.on("close", ()=>{
            clearInterval(keepAliveId);
            this.disconnect();
        });
        this.server.on("connection", (socket)=>{
            // When a socket closes, or disconnects, remove it from our list
            socket.on("close", ()=>{
                this.#removeSocket(socket);
            });
            socket.on("message", (message)=>this.receiveMessage(message, socket));
            // Start out "alive", and every time we get a pong, reset that state.
            socket.isAlive = true;
            socket.on("pong", ()=>socket.isAlive = true);
            this.#forceReady();
        });
        const keepAliveId = setInterval(()=>{
            // Terminate connections to lost clients
            const clients = this.server.clients;
            clients.forEach((socket)=>{
                if (socket.isAlive) {
                    // Mark all clients as potentially dead until we hear from them
                    socket.isAlive = false;
                    socket.ping();
                } else this.#terminate(socket);
            });
        }, this.keepAliveInterval);
    }
    disconnect() {
        const clients = this.server.clients;
        clients.forEach((socket)=>{
            this.#terminate(socket);
            this.#removeSocket(socket);
        });
    }
    send(message) {
        (0, $e2d055ea5be47785$export$a7a9523472993e97)("targetId" in message && message.targetId !== undefined);
        if ("data" in message && message.data?.byteLength === 0) throw new Error("Tried to send a zero-length message");
        const senderId = this.peerId;
        (0, $e2d055ea5be47785$export$a7a9523472993e97)(senderId, "No peerId set for the websocket server network adapter.");
        const socket = this.sockets[message.targetId];
        if (!socket) {
            $737d623262652b14$var$log(`Tried to send to disconnected peer: ${message.targetId}`);
            return;
        }
        const encoded = $737d623262652b14$var$encode(message);
        const arrayBuf = (0, $73fffdf743294fd6$export$8b22b05f429b130c)(encoded);
        socket.send(arrayBuf);
    }
    receiveMessage(messageBytes, socket) {
        let message;
        try {
            message = $737d623262652b14$var$decode(messageBytes);
        } catch (e) {
            $737d623262652b14$var$log("invalid message received, closing connection");
            socket.close();
            return;
        }
        const { type: type, senderId: senderId } = message;
        const myPeerId = this.peerId;
        (0, $e2d055ea5be47785$export$a7a9523472993e97)(myPeerId);
        const documentId = "documentId" in message ? "@" + message.documentId : "";
        const { byteLength: byteLength } = messageBytes;
        $737d623262652b14$var$log(`[${senderId}->${myPeerId}${documentId}] ${type} | ${byteLength} bytes`);
        if ((0, $1edf922be16631fc$export$75ca4cf475463181)(message)) {
            const { peerMetadata: peerMetadata, supportedProtocolVersions: supportedProtocolVersions } = message;
            const existingSocket = this.sockets[senderId];
            if (existingSocket) {
                if (existingSocket.readyState === (0, $600696615019689e$export$2e2bcd8739ae039).OPEN) existingSocket.close();
                this.emit("peer-disconnected", {
                    peerId: senderId
                });
            }
            // Let the repo know that we have a new connection.
            this.emit("peer-candidate", {
                peerId: senderId,
                peerMetadata: peerMetadata
            });
            this.sockets[senderId] = socket;
            const selectedProtocolVersion = $737d623262652b14$var$selectProtocol(supportedProtocolVersions);
            if (selectedProtocolVersion === null) {
                this.send({
                    type: "error",
                    senderId: this.peerId,
                    message: "unsupported protocol version",
                    targetId: senderId
                });
                this.sockets[senderId].close();
                delete this.sockets[senderId];
            } else this.send({
                type: "peer",
                senderId: this.peerId,
                peerMetadata: this.peerMetadata,
                selectedProtocolVersion: (0, $3dcf81554608ea34$export$8599dfde47853686),
                targetId: senderId
            });
        } else this.emit("message", message);
    }
    #terminate(socket) {
        this.#removeSocket(socket);
        socket.terminate();
    }
    #removeSocket(socket) {
        const peerId = this.#peerIdBySocket(socket);
        if (!peerId) return;
        this.emit("peer-disconnected", {
            peerId: peerId
        });
        delete this.sockets[peerId];
    }
    #peerIdBySocket = (socket)=>{
        const isThisSocket = (peerId)=>this.sockets[peerId] === socket;
        const result = Object.keys(this.sockets).find(isThisSocket);
        return result ?? null;
    };
}
const $737d623262652b14$var$selectProtocol = (versions)=>{
    if (versions === undefined) return 0, $3dcf81554608ea34$export$8599dfde47853686;
    if (versions.includes((0, $3dcf81554608ea34$export$8599dfde47853686))) return 0, $3dcf81554608ea34$export$8599dfde47853686;
    return null;
};





// packages/alpinejs/src/scheduler.js
var $ceb1972acc1ecda9$var$flushPending = false;
var $ceb1972acc1ecda9$var$flushing = false;
var $ceb1972acc1ecda9$var$queue = [];
var $ceb1972acc1ecda9$var$lastFlushedIndex = -1;
var $ceb1972acc1ecda9$var$transactionActive = false;
function $ceb1972acc1ecda9$var$scheduler(callback) {
    $ceb1972acc1ecda9$var$queueJob(callback);
}
function $ceb1972acc1ecda9$var$startTransaction() {
    $ceb1972acc1ecda9$var$transactionActive = true;
}
function $ceb1972acc1ecda9$var$commitTransaction() {
    $ceb1972acc1ecda9$var$transactionActive = false;
    $ceb1972acc1ecda9$var$queueFlush();
}
function $ceb1972acc1ecda9$var$queueJob(job) {
    if (!$ceb1972acc1ecda9$var$queue.includes(job)) $ceb1972acc1ecda9$var$queue.push(job);
    $ceb1972acc1ecda9$var$queueFlush();
}
function $ceb1972acc1ecda9$var$dequeueJob(job) {
    let index = $ceb1972acc1ecda9$var$queue.indexOf(job);
    if (index !== -1 && index > $ceb1972acc1ecda9$var$lastFlushedIndex) $ceb1972acc1ecda9$var$queue.splice(index, 1);
}
function $ceb1972acc1ecda9$var$queueFlush() {
    if (!$ceb1972acc1ecda9$var$flushing && !$ceb1972acc1ecda9$var$flushPending) {
        if ($ceb1972acc1ecda9$var$transactionActive) return;
        $ceb1972acc1ecda9$var$flushPending = true;
        queueMicrotask($ceb1972acc1ecda9$var$flushJobs);
    }
}
function $ceb1972acc1ecda9$var$flushJobs() {
    $ceb1972acc1ecda9$var$flushPending = false;
    $ceb1972acc1ecda9$var$flushing = true;
    for(let i = 0; i < $ceb1972acc1ecda9$var$queue.length; i++){
        $ceb1972acc1ecda9$var$queue[i]();
        $ceb1972acc1ecda9$var$lastFlushedIndex = i;
    }
    $ceb1972acc1ecda9$var$queue.length = 0;
    $ceb1972acc1ecda9$var$lastFlushedIndex = -1;
    $ceb1972acc1ecda9$var$flushing = false;
}
// packages/alpinejs/src/reactivity.js
var $ceb1972acc1ecda9$var$reactive;
var $ceb1972acc1ecda9$var$effect;
var $ceb1972acc1ecda9$var$release;
var $ceb1972acc1ecda9$var$raw;
var $ceb1972acc1ecda9$var$shouldSchedule = true;
function $ceb1972acc1ecda9$var$disableEffectScheduling(callback) {
    $ceb1972acc1ecda9$var$shouldSchedule = false;
    callback();
    $ceb1972acc1ecda9$var$shouldSchedule = true;
}
function $ceb1972acc1ecda9$var$setReactivityEngine(engine) {
    $ceb1972acc1ecda9$var$reactive = engine.reactive;
    $ceb1972acc1ecda9$var$release = engine.release;
    $ceb1972acc1ecda9$var$effect = (callback)=>engine.effect(callback, {
            scheduler: (task)=>{
                if ($ceb1972acc1ecda9$var$shouldSchedule) $ceb1972acc1ecda9$var$scheduler(task);
                else task();
            }
        });
    $ceb1972acc1ecda9$var$raw = engine.raw;
}
function $ceb1972acc1ecda9$var$overrideEffect(override) {
    $ceb1972acc1ecda9$var$effect = override;
}
function $ceb1972acc1ecda9$var$elementBoundEffect(el) {
    let cleanup2 = ()=>{};
    let wrappedEffect = (callback)=>{
        let effectReference = $ceb1972acc1ecda9$var$effect(callback);
        if (!el._x_effects) {
            el._x_effects = /* @__PURE__ */ new Set();
            el._x_runEffects = ()=>{
                el._x_effects.forEach((i)=>i());
            };
        }
        el._x_effects.add(effectReference);
        cleanup2 = ()=>{
            if (effectReference === void 0) return;
            el._x_effects.delete(effectReference);
            $ceb1972acc1ecda9$var$release(effectReference);
        };
        return effectReference;
    };
    return [
        wrappedEffect,
        ()=>{
            cleanup2();
        }
    ];
}
function $ceb1972acc1ecda9$var$watch(getter, callback) {
    let firstTime = true;
    let oldValue;
    let effectReference = $ceb1972acc1ecda9$var$effect(()=>{
        let value = getter();
        JSON.stringify(value);
        if (!firstTime) {
            if (typeof value === "object" || value !== oldValue) {
                let previousValue = oldValue;
                queueMicrotask(()=>{
                    callback(value, previousValue);
                });
            }
        }
        oldValue = value;
        firstTime = false;
    });
    return ()=>$ceb1972acc1ecda9$var$release(effectReference);
}
async function $ceb1972acc1ecda9$var$transaction(callback) {
    $ceb1972acc1ecda9$var$startTransaction();
    try {
        await callback();
        await Promise.resolve();
    } finally{
        $ceb1972acc1ecda9$var$commitTransaction();
    }
}
// packages/alpinejs/src/mutation.js
var $ceb1972acc1ecda9$var$onAttributeAddeds = [];
var $ceb1972acc1ecda9$var$onElRemoveds = [];
var $ceb1972acc1ecda9$var$onElAddeds = [];
function $ceb1972acc1ecda9$var$onElAdded(callback) {
    $ceb1972acc1ecda9$var$onElAddeds.push(callback);
}
function $ceb1972acc1ecda9$var$onElRemoved(el, callback) {
    if (typeof callback === "function") {
        if (!el._x_cleanups) el._x_cleanups = [];
        el._x_cleanups.push(callback);
    } else {
        callback = el;
        $ceb1972acc1ecda9$var$onElRemoveds.push(callback);
    }
}
function $ceb1972acc1ecda9$var$onAttributesAdded(callback) {
    $ceb1972acc1ecda9$var$onAttributeAddeds.push(callback);
}
function $ceb1972acc1ecda9$var$onAttributeRemoved(el, name, callback) {
    if (!el._x_attributeCleanups) el._x_attributeCleanups = {};
    if (!el._x_attributeCleanups[name]) el._x_attributeCleanups[name] = [];
    el._x_attributeCleanups[name].push(callback);
}
function $ceb1972acc1ecda9$var$cleanupAttributes(el, names) {
    if (!el._x_attributeCleanups) return;
    Object.entries(el._x_attributeCleanups).forEach(([name, value])=>{
        if (names === void 0 || names.includes(name)) {
            value.forEach((i)=>i());
            delete el._x_attributeCleanups[name];
        }
    });
}
function $ceb1972acc1ecda9$var$cleanupElement(el) {
    el._x_effects?.forEach($ceb1972acc1ecda9$var$dequeueJob);
    while(el._x_cleanups?.length)el._x_cleanups.pop()();
}
var $ceb1972acc1ecda9$var$observer = new MutationObserver($ceb1972acc1ecda9$var$onMutate);
var $ceb1972acc1ecda9$var$currentlyObserving = false;
function $ceb1972acc1ecda9$var$startObservingMutations() {
    $ceb1972acc1ecda9$var$observer.observe(document, {
        subtree: true,
        childList: true,
        attributes: true,
        attributeOldValue: true
    });
    $ceb1972acc1ecda9$var$currentlyObserving = true;
}
function $ceb1972acc1ecda9$var$stopObservingMutations() {
    $ceb1972acc1ecda9$var$flushObserver();
    $ceb1972acc1ecda9$var$observer.disconnect();
    $ceb1972acc1ecda9$var$currentlyObserving = false;
}
var $ceb1972acc1ecda9$var$queuedMutations = [];
function $ceb1972acc1ecda9$var$flushObserver() {
    let records = $ceb1972acc1ecda9$var$observer.takeRecords();
    $ceb1972acc1ecda9$var$queuedMutations.push(()=>records.length > 0 && $ceb1972acc1ecda9$var$onMutate(records));
    let queueLengthWhenTriggered = $ceb1972acc1ecda9$var$queuedMutations.length;
    queueMicrotask(()=>{
        if ($ceb1972acc1ecda9$var$queuedMutations.length === queueLengthWhenTriggered) while($ceb1972acc1ecda9$var$queuedMutations.length > 0)$ceb1972acc1ecda9$var$queuedMutations.shift()();
    });
}
function $ceb1972acc1ecda9$var$mutateDom(callback) {
    if (!$ceb1972acc1ecda9$var$currentlyObserving) return callback();
    $ceb1972acc1ecda9$var$stopObservingMutations();
    let result = callback();
    $ceb1972acc1ecda9$var$startObservingMutations();
    return result;
}
var $ceb1972acc1ecda9$var$isCollecting = false;
var $ceb1972acc1ecda9$var$deferredMutations = [];
function $ceb1972acc1ecda9$var$deferMutations() {
    $ceb1972acc1ecda9$var$isCollecting = true;
}
function $ceb1972acc1ecda9$var$flushAndStopDeferringMutations() {
    $ceb1972acc1ecda9$var$isCollecting = false;
    $ceb1972acc1ecda9$var$onMutate($ceb1972acc1ecda9$var$deferredMutations);
    $ceb1972acc1ecda9$var$deferredMutations = [];
}
function $ceb1972acc1ecda9$var$onMutate(mutations) {
    if ($ceb1972acc1ecda9$var$isCollecting) {
        $ceb1972acc1ecda9$var$deferredMutations = $ceb1972acc1ecda9$var$deferredMutations.concat(mutations);
        return;
    }
    let addedNodes = [];
    let removedNodes = /* @__PURE__ */ new Set();
    let addedAttributes = /* @__PURE__ */ new Map();
    let removedAttributes = /* @__PURE__ */ new Map();
    for(let i = 0; i < mutations.length; i++){
        if (mutations[i].target._x_ignoreMutationObserver) continue;
        if (mutations[i].type === "childList") {
            mutations[i].removedNodes.forEach((node)=>{
                if (node.nodeType !== 1) return;
                if (!node._x_marker) return;
                removedNodes.add(node);
            });
            mutations[i].addedNodes.forEach((node)=>{
                if (node.nodeType !== 1) return;
                if (removedNodes.has(node)) {
                    removedNodes.delete(node);
                    return;
                }
                if (node._x_marker) return;
                addedNodes.push(node);
            });
        }
        if (mutations[i].type === "attributes") {
            let el = mutations[i].target;
            let name = mutations[i].attributeName;
            let oldValue = mutations[i].oldValue;
            let add2 = ()=>{
                if (!addedAttributes.has(el)) addedAttributes.set(el, []);
                addedAttributes.get(el).push({
                    name: name,
                    value: el.getAttribute(name)
                });
            };
            let remove = ()=>{
                if (!removedAttributes.has(el)) removedAttributes.set(el, []);
                removedAttributes.get(el).push(name);
            };
            if (el.hasAttribute(name) && oldValue === null) add2();
            else if (el.hasAttribute(name)) {
                remove();
                add2();
            } else remove();
        }
    }
    removedAttributes.forEach((attrs, el)=>{
        $ceb1972acc1ecda9$var$cleanupAttributes(el, attrs);
    });
    addedAttributes.forEach((attrs, el)=>{
        $ceb1972acc1ecda9$var$onAttributeAddeds.forEach((i)=>i(el, attrs));
    });
    for (let node of removedNodes){
        if (addedNodes.some((i)=>i.contains(node))) continue;
        $ceb1972acc1ecda9$var$onElRemoveds.forEach((i)=>i(node));
    }
    for (let node of addedNodes){
        if (!node.isConnected) continue;
        $ceb1972acc1ecda9$var$onElAddeds.forEach((i)=>i(node));
    }
    addedNodes = null;
    removedNodes = null;
    addedAttributes = null;
    removedAttributes = null;
}
// packages/alpinejs/src/scope.js
function $ceb1972acc1ecda9$var$scope(node) {
    return $ceb1972acc1ecda9$var$mergeProxies($ceb1972acc1ecda9$var$closestDataStack(node));
}
function $ceb1972acc1ecda9$var$addScopeToNode(node, data2, referenceNode) {
    node._x_dataStack = [
        data2,
        ...$ceb1972acc1ecda9$var$closestDataStack(referenceNode || node)
    ];
    return ()=>{
        node._x_dataStack = node._x_dataStack.filter((i)=>i !== data2);
    };
}
function $ceb1972acc1ecda9$var$closestDataStack(node) {
    if (node._x_dataStack) return node._x_dataStack;
    if (typeof ShadowRoot === "function" && node instanceof ShadowRoot) return $ceb1972acc1ecda9$var$closestDataStack(node.host);
    if (!node.parentNode) return [];
    return $ceb1972acc1ecda9$var$closestDataStack(node.parentNode);
}
function $ceb1972acc1ecda9$var$mergeProxies(objects) {
    return new Proxy({
        objects: objects
    }, $ceb1972acc1ecda9$var$mergeProxyTrap);
}
var $ceb1972acc1ecda9$var$mergeProxyTrap = {
    ownKeys ({ objects: objects }) {
        return Array.from(new Set(objects.flatMap((i)=>Object.keys(i))));
    },
    has ({ objects: objects }, name) {
        if (name == Symbol.unscopables) return false;
        return objects.some((obj)=>Object.prototype.hasOwnProperty.call(obj, name) || Reflect.has(obj, name));
    },
    get ({ objects: objects }, name, thisProxy) {
        if (name == "toJSON") return $ceb1972acc1ecda9$var$collapseProxies;
        return Reflect.get(objects.find((obj)=>Reflect.has(obj, name)) || {}, name, thisProxy);
    },
    set ({ objects: objects }, name, value, thisProxy) {
        const target = objects.find((obj)=>Object.prototype.hasOwnProperty.call(obj, name)) || objects[objects.length - 1];
        const descriptor = Object.getOwnPropertyDescriptor(target, name);
        if (descriptor?.set && descriptor?.get) return descriptor.set.call(thisProxy, value) || true;
        return Reflect.set(target, name, value);
    }
};
function $ceb1972acc1ecda9$var$collapseProxies() {
    let keys = Reflect.ownKeys(this);
    return keys.reduce((acc, key)=>{
        acc[key] = Reflect.get(this, key);
        return acc;
    }, {});
}
// packages/alpinejs/src/interceptor.js
function $ceb1972acc1ecda9$var$initInterceptors(data2) {
    let isObject2 = (val)=>typeof val === "object" && !Array.isArray(val) && val !== null;
    let recurse = (obj, basePath = "")=>{
        Object.entries(Object.getOwnPropertyDescriptors(obj)).forEach(([key, { value: value, enumerable: enumerable }])=>{
            if (enumerable === false || value === void 0) return;
            if (typeof value === "object" && value !== null && value.__v_skip) return;
            let path = basePath === "" ? key : `${basePath}.${key}`;
            if (typeof value === "object" && value !== null && value._x_interceptor) obj[key] = value.initialize(data2, path, key);
            else if (isObject2(value) && value !== obj && !(value instanceof Element)) recurse(value, path);
        });
    };
    return recurse(data2);
}
function $ceb1972acc1ecda9$var$interceptor(callback, mutateObj = ()=>{}) {
    let obj = {
        initialValue: void 0,
        _x_interceptor: true,
        initialize (data2, path, key) {
            return callback(this.initialValue, ()=>$ceb1972acc1ecda9$var$get(data2, path), (value)=>$ceb1972acc1ecda9$var$set(data2, path, value), path, key);
        }
    };
    mutateObj(obj);
    return (initialValue)=>{
        if (typeof initialValue === "object" && initialValue !== null && initialValue._x_interceptor) {
            let initialize = obj.initialize.bind(obj);
            obj.initialize = (data2, path, key)=>{
                let innerValue = initialValue.initialize(data2, path, key);
                obj.initialValue = innerValue;
                return initialize(data2, path, key);
            };
        } else obj.initialValue = initialValue;
        return obj;
    };
}
function $ceb1972acc1ecda9$var$get(obj, path) {
    return path.split(".").reduce((carry, segment)=>carry[segment], obj);
}
function $ceb1972acc1ecda9$var$set(obj, path, value) {
    if (typeof path === "string") path = path.split(".");
    if (path.length === 1) obj[path[0]] = value;
    else if (path.length === 0) throw error;
    else {
        if (obj[path[0]]) return $ceb1972acc1ecda9$var$set(obj[path[0]], path.slice(1), value);
        else {
            obj[path[0]] = {};
            return $ceb1972acc1ecda9$var$set(obj[path[0]], path.slice(1), value);
        }
    }
}
// packages/alpinejs/src/magics.js
var $ceb1972acc1ecda9$var$magics = {};
function $ceb1972acc1ecda9$var$magic(name, callback) {
    $ceb1972acc1ecda9$var$magics[name] = callback;
}
function $ceb1972acc1ecda9$var$injectMagics(obj, el) {
    let memoizedUtilities = $ceb1972acc1ecda9$var$getUtilities(el);
    Object.entries($ceb1972acc1ecda9$var$magics).forEach(([name, callback])=>{
        Object.defineProperty(obj, `$${name}`, {
            get () {
                return callback(el, memoizedUtilities);
            },
            enumerable: false
        });
    });
    return obj;
}
function $ceb1972acc1ecda9$var$getUtilities(el) {
    let [utilities, cleanup2] = $ceb1972acc1ecda9$var$getElementBoundUtilities(el);
    let utils = {
        interceptor: $ceb1972acc1ecda9$var$interceptor,
        ...utilities
    };
    $ceb1972acc1ecda9$var$onElRemoved(el, cleanup2);
    return utils;
}
// packages/alpinejs/src/utils/error.js
function $ceb1972acc1ecda9$var$tryCatch(el, expression, callback, ...args) {
    try {
        return callback(...args);
    } catch (e) {
        $ceb1972acc1ecda9$var$handleError(e, el, expression);
    }
}
function $ceb1972acc1ecda9$var$handleError(...args) {
    return $ceb1972acc1ecda9$var$errorHandler(...args);
}
var $ceb1972acc1ecda9$var$errorHandler = $ceb1972acc1ecda9$var$normalErrorHandler;
function $ceb1972acc1ecda9$var$setErrorHandler(handler4) {
    $ceb1972acc1ecda9$var$errorHandler = handler4;
}
function $ceb1972acc1ecda9$var$normalErrorHandler(error2, el, expression) {
    error2 = Object.assign(error2 ?? {
        message: "No error message given."
    }, {
        el: el,
        expression: expression
    });
    console.warn(`Alpine Expression Error: ${error2.message}

${expression ? 'Expression: "' + expression + '"\n\n' : ""}`, el);
    setTimeout(()=>{
        throw error2;
    }, 0);
}
// packages/alpinejs/src/evaluator.js
var $ceb1972acc1ecda9$var$shouldAutoEvaluateFunctions = true;
function $ceb1972acc1ecda9$var$dontAutoEvaluateFunctions(callback) {
    let cache = $ceb1972acc1ecda9$var$shouldAutoEvaluateFunctions;
    $ceb1972acc1ecda9$var$shouldAutoEvaluateFunctions = false;
    let result = callback();
    $ceb1972acc1ecda9$var$shouldAutoEvaluateFunctions = cache;
    return result;
}
function $ceb1972acc1ecda9$var$evaluate(el, expression, extras = {}) {
    let result;
    $ceb1972acc1ecda9$var$evaluateLater(el, expression)((value)=>result = value, extras);
    return result;
}
function $ceb1972acc1ecda9$var$evaluateLater(...args) {
    return $ceb1972acc1ecda9$var$theEvaluatorFunction(...args);
}
var $ceb1972acc1ecda9$var$theEvaluatorFunction = $ceb1972acc1ecda9$var$normalEvaluator;
function $ceb1972acc1ecda9$var$setEvaluator(newEvaluator) {
    $ceb1972acc1ecda9$var$theEvaluatorFunction = newEvaluator;
}
var $ceb1972acc1ecda9$var$theRawEvaluatorFunction;
function $ceb1972acc1ecda9$var$setRawEvaluator(newEvaluator) {
    $ceb1972acc1ecda9$var$theRawEvaluatorFunction = newEvaluator;
}
function $ceb1972acc1ecda9$var$normalEvaluator(el, expression) {
    let overriddenMagics = {};
    $ceb1972acc1ecda9$var$injectMagics(overriddenMagics, el);
    let dataStack = [
        overriddenMagics,
        ...$ceb1972acc1ecda9$var$closestDataStack(el)
    ];
    let evaluator = typeof expression === "function" ? $ceb1972acc1ecda9$var$generateEvaluatorFromFunction(dataStack, expression) : $ceb1972acc1ecda9$var$generateEvaluatorFromString(dataStack, expression, el);
    return $ceb1972acc1ecda9$var$tryCatch.bind(null, el, expression, evaluator);
}
function $ceb1972acc1ecda9$var$generateEvaluatorFromFunction(dataStack, func) {
    return (receiver = ()=>{}, { scope: scope2 = {}, params: params = [], context: context } = {})=>{
        if (!$ceb1972acc1ecda9$var$shouldAutoEvaluateFunctions) {
            $ceb1972acc1ecda9$var$runIfTypeOfFunction(receiver, func, $ceb1972acc1ecda9$var$mergeProxies([
                scope2,
                ...dataStack
            ]), params);
            return;
        }
        let result = func.apply($ceb1972acc1ecda9$var$mergeProxies([
            scope2,
            ...dataStack
        ]), params);
        $ceb1972acc1ecda9$var$runIfTypeOfFunction(receiver, result);
    };
}
var $ceb1972acc1ecda9$var$evaluatorMemo = {};
function $ceb1972acc1ecda9$var$generateFunctionFromString(expression, el) {
    if ($ceb1972acc1ecda9$var$evaluatorMemo[expression]) return $ceb1972acc1ecda9$var$evaluatorMemo[expression];
    let AsyncFunction = Object.getPrototypeOf(async function() {}).constructor;
    let rightSideSafeExpression = /^[\n\s]*if.*\(.*\)/.test(expression.trim()) || /^(let|const)\s/.test(expression.trim()) ? `(async()=>{ ${expression} })()` : expression;
    const safeAsyncFunction = ()=>{
        try {
            let func2 = new AsyncFunction([
                "__self",
                "scope"
            ], `with (scope) { __self.result = ${rightSideSafeExpression} }; __self.finished = true; return __self.result;`);
            Object.defineProperty(func2, "name", {
                value: `[Alpine] ${expression}`
            });
            return func2;
        } catch (error2) {
            $ceb1972acc1ecda9$var$handleError(error2, el, expression);
            return Promise.resolve();
        }
    };
    let func = safeAsyncFunction();
    $ceb1972acc1ecda9$var$evaluatorMemo[expression] = func;
    return func;
}
function $ceb1972acc1ecda9$var$generateEvaluatorFromString(dataStack, expression, el) {
    let func = $ceb1972acc1ecda9$var$generateFunctionFromString(expression, el);
    return (receiver = ()=>{}, { scope: scope2 = {}, params: params = [], context: context } = {})=>{
        func.result = void 0;
        func.finished = false;
        let completeScope = $ceb1972acc1ecda9$var$mergeProxies([
            scope2,
            ...dataStack
        ]);
        if (typeof func === "function") {
            let promise = func.call(context, func, completeScope).catch((error2)=>$ceb1972acc1ecda9$var$handleError(error2, el, expression));
            if (func.finished) {
                $ceb1972acc1ecda9$var$runIfTypeOfFunction(receiver, func.result, completeScope, params, el);
                func.result = void 0;
            } else promise.then((result)=>{
                $ceb1972acc1ecda9$var$runIfTypeOfFunction(receiver, result, completeScope, params, el);
            }).catch((error2)=>$ceb1972acc1ecda9$var$handleError(error2, el, expression)).finally(()=>func.result = void 0);
        }
    };
}
function $ceb1972acc1ecda9$var$runIfTypeOfFunction(receiver, value, scope2, params, el) {
    if ($ceb1972acc1ecda9$var$shouldAutoEvaluateFunctions && typeof value === "function") {
        let result = value.apply(scope2, params);
        if (result instanceof Promise) result.then((i)=>$ceb1972acc1ecda9$var$runIfTypeOfFunction(receiver, i, scope2, params)).catch((error2)=>$ceb1972acc1ecda9$var$handleError(error2, el, value));
        else receiver(result);
    } else if (typeof value === "object" && value instanceof Promise) value.then((i)=>receiver(i));
    else receiver(value);
}
function $ceb1972acc1ecda9$var$evaluateRaw(...args) {
    return $ceb1972acc1ecda9$var$theRawEvaluatorFunction(...args);
}
function $ceb1972acc1ecda9$var$normalRawEvaluator(el, expression, extras = {}) {
    let overriddenMagics = {};
    $ceb1972acc1ecda9$var$injectMagics(overriddenMagics, el);
    let dataStack = [
        overriddenMagics,
        ...$ceb1972acc1ecda9$var$closestDataStack(el)
    ];
    let scope2 = $ceb1972acc1ecda9$var$mergeProxies([
        extras.scope ?? {},
        ...dataStack
    ]);
    let params = extras.params ?? [];
    if (expression.includes("await")) {
        let AsyncFunction = Object.getPrototypeOf(async function() {}).constructor;
        let rightSideSafeExpression = /^[\n\s]*if.*\(.*\)/.test(expression.trim()) || /^(let|const)\s/.test(expression.trim()) ? `(async()=>{ ${expression} })()` : expression;
        let func = new AsyncFunction([
            "scope"
        ], `with (scope) { let __result = ${rightSideSafeExpression}; return __result }`);
        let result = func.call(extras.context, scope2);
        return result;
    } else {
        let rightSideSafeExpression = /^[\n\s]*if.*\(.*\)/.test(expression.trim()) || /^(let|const)\s/.test(expression.trim()) ? `(()=>{ ${expression} })()` : expression;
        let func = new Function([
            "scope"
        ], `with (scope) { let __result = ${rightSideSafeExpression}; return __result }`);
        let result = func.call(extras.context, scope2);
        if (typeof result === "function" && $ceb1972acc1ecda9$var$shouldAutoEvaluateFunctions) return result.apply(scope2, params);
        return result;
    }
}
// packages/alpinejs/src/directives.js
var $ceb1972acc1ecda9$var$prefixAsString = "x-";
function $ceb1972acc1ecda9$var$prefix(subject = "") {
    return $ceb1972acc1ecda9$var$prefixAsString + subject;
}
function $ceb1972acc1ecda9$var$setPrefix(newPrefix) {
    $ceb1972acc1ecda9$var$prefixAsString = newPrefix;
}
var $ceb1972acc1ecda9$var$directiveHandlers = {};
function $ceb1972acc1ecda9$var$directive(name, callback) {
    $ceb1972acc1ecda9$var$directiveHandlers[name] = callback;
    return {
        before (directive2) {
            if (!$ceb1972acc1ecda9$var$directiveHandlers[directive2]) {
                console.warn(String.raw`Cannot find directive \`${directive2}\`. \`${name}\` will use the default order of execution`);
                return;
            }
            const pos = $ceb1972acc1ecda9$var$directiveOrder.indexOf(directive2);
            $ceb1972acc1ecda9$var$directiveOrder.splice(pos >= 0 ? pos : $ceb1972acc1ecda9$var$directiveOrder.indexOf("DEFAULT"), 0, name);
        }
    };
}
function $ceb1972acc1ecda9$var$directiveExists(name) {
    return Object.keys($ceb1972acc1ecda9$var$directiveHandlers).includes(name);
}
function $ceb1972acc1ecda9$var$directives(el, attributes, originalAttributeOverride) {
    attributes = Array.from(attributes);
    if (el._x_virtualDirectives) {
        let vAttributes = Object.entries(el._x_virtualDirectives).map(([name, value])=>({
                name: name,
                value: value
            }));
        let staticAttributes = $ceb1972acc1ecda9$var$attributesOnly(vAttributes);
        vAttributes = vAttributes.map((attribute)=>{
            if (staticAttributes.find((attr)=>attr.name === attribute.name)) return {
                name: `x-bind:${attribute.name}`,
                value: `"${attribute.value}"`
            };
            return attribute;
        });
        attributes = attributes.concat(vAttributes);
    }
    let transformedAttributeMap = {};
    let directives2 = attributes.map($ceb1972acc1ecda9$var$toTransformedAttributes((newName, oldName)=>transformedAttributeMap[newName] = oldName)).filter($ceb1972acc1ecda9$var$outNonAlpineAttributes).map($ceb1972acc1ecda9$var$toParsedDirectives(transformedAttributeMap, originalAttributeOverride)).sort($ceb1972acc1ecda9$var$byPriority);
    return directives2.map((directive2)=>{
        return $ceb1972acc1ecda9$var$getDirectiveHandler(el, directive2);
    });
}
function $ceb1972acc1ecda9$var$attributesOnly(attributes) {
    return Array.from(attributes).map($ceb1972acc1ecda9$var$toTransformedAttributes()).filter((attr)=>!$ceb1972acc1ecda9$var$outNonAlpineAttributes(attr));
}
var $ceb1972acc1ecda9$var$isDeferringHandlers = false;
var $ceb1972acc1ecda9$var$directiveHandlerStacks = /* @__PURE__ */ new Map();
var $ceb1972acc1ecda9$var$currentHandlerStackKey = Symbol();
function $ceb1972acc1ecda9$var$deferHandlingDirectives(callback) {
    $ceb1972acc1ecda9$var$isDeferringHandlers = true;
    let key = Symbol();
    $ceb1972acc1ecda9$var$currentHandlerStackKey = key;
    $ceb1972acc1ecda9$var$directiveHandlerStacks.set(key, []);
    let flushHandlers = ()=>{
        while($ceb1972acc1ecda9$var$directiveHandlerStacks.get(key).length)$ceb1972acc1ecda9$var$directiveHandlerStacks.get(key).shift()();
        $ceb1972acc1ecda9$var$directiveHandlerStacks.delete(key);
    };
    let stopDeferring = ()=>{
        $ceb1972acc1ecda9$var$isDeferringHandlers = false;
        flushHandlers();
    };
    callback(flushHandlers);
    stopDeferring();
}
function $ceb1972acc1ecda9$var$getElementBoundUtilities(el) {
    let cleanups = [];
    let cleanup2 = (callback)=>cleanups.push(callback);
    let [effect3, cleanupEffect] = $ceb1972acc1ecda9$var$elementBoundEffect(el);
    cleanups.push(cleanupEffect);
    let utilities = {
        Alpine: $ceb1972acc1ecda9$var$alpine_default,
        effect: effect3,
        cleanup: cleanup2,
        evaluateLater: $ceb1972acc1ecda9$var$evaluateLater.bind($ceb1972acc1ecda9$var$evaluateLater, el),
        evaluate: $ceb1972acc1ecda9$var$evaluate.bind($ceb1972acc1ecda9$var$evaluate, el)
    };
    let doCleanup = ()=>cleanups.forEach((i)=>i());
    return [
        utilities,
        doCleanup
    ];
}
function $ceb1972acc1ecda9$var$getDirectiveHandler(el, directive2) {
    let noop = ()=>{};
    let handler4 = $ceb1972acc1ecda9$var$directiveHandlers[directive2.type] || noop;
    let [utilities, cleanup2] = $ceb1972acc1ecda9$var$getElementBoundUtilities(el);
    $ceb1972acc1ecda9$var$onAttributeRemoved(el, directive2.original, cleanup2);
    let fullHandler = ()=>{
        if (el._x_ignore || el._x_ignoreSelf) return;
        handler4.inline && handler4.inline(el, directive2, utilities);
        handler4 = handler4.bind(handler4, el, directive2, utilities);
        $ceb1972acc1ecda9$var$isDeferringHandlers ? $ceb1972acc1ecda9$var$directiveHandlerStacks.get($ceb1972acc1ecda9$var$currentHandlerStackKey).push(handler4) : handler4();
    };
    fullHandler.runCleanups = cleanup2;
    return fullHandler;
}
var $ceb1972acc1ecda9$var$startingWith = (subject, replacement)=>({ name: name, value: value })=>{
        if (name.startsWith(subject)) name = name.replace(subject, replacement);
        return {
            name: name,
            value: value
        };
    };
var $ceb1972acc1ecda9$var$into = (i)=>i;
function $ceb1972acc1ecda9$var$toTransformedAttributes(callback = ()=>{}) {
    return ({ name: name, value: value })=>{
        let { name: newName, value: newValue } = $ceb1972acc1ecda9$var$attributeTransformers.reduce((carry, transform)=>{
            return transform(carry);
        }, {
            name: name,
            value: value
        });
        if (newName !== name) callback(newName, name);
        return {
            name: newName,
            value: newValue
        };
    };
}
var $ceb1972acc1ecda9$var$attributeTransformers = [];
function $ceb1972acc1ecda9$var$mapAttributes(callback) {
    $ceb1972acc1ecda9$var$attributeTransformers.push(callback);
}
function $ceb1972acc1ecda9$var$outNonAlpineAttributes({ name: name }) {
    return $ceb1972acc1ecda9$var$alpineAttributeRegex().test(name);
}
var $ceb1972acc1ecda9$var$alpineAttributeRegex = ()=>new RegExp(`^${$ceb1972acc1ecda9$var$prefixAsString}([^:^.]+)\\b`);
function $ceb1972acc1ecda9$var$toParsedDirectives(transformedAttributeMap, originalAttributeOverride) {
    return ({ name: name, value: value })=>{
        if (name === value) value = "";
        let typeMatch = name.match($ceb1972acc1ecda9$var$alpineAttributeRegex());
        let valueMatch = name.match(/:([a-zA-Z0-9\-_:]+)/);
        let modifiers = name.match(/\.[^.\]]+(?=[^\]]*$)/g) || [];
        let original = originalAttributeOverride || transformedAttributeMap[name] || name;
        return {
            type: typeMatch ? typeMatch[1] : null,
            value: valueMatch ? valueMatch[1] : null,
            modifiers: modifiers.map((i)=>i.replace(".", "")),
            expression: value,
            original: original
        };
    };
}
var $ceb1972acc1ecda9$var$DEFAULT = "DEFAULT";
var $ceb1972acc1ecda9$var$directiveOrder = [
    "ignore",
    "ref",
    "data",
    "id",
    "anchor",
    "bind",
    "init",
    "for",
    "model",
    "modelable",
    "transition",
    "show",
    "if",
    $ceb1972acc1ecda9$var$DEFAULT,
    "teleport"
];
function $ceb1972acc1ecda9$var$byPriority(a, b) {
    let typeA = $ceb1972acc1ecda9$var$directiveOrder.indexOf(a.type) === -1 ? $ceb1972acc1ecda9$var$DEFAULT : a.type;
    let typeB = $ceb1972acc1ecda9$var$directiveOrder.indexOf(b.type) === -1 ? $ceb1972acc1ecda9$var$DEFAULT : b.type;
    return $ceb1972acc1ecda9$var$directiveOrder.indexOf(typeA) - $ceb1972acc1ecda9$var$directiveOrder.indexOf(typeB);
}
// packages/alpinejs/src/utils/dispatch.js
function $ceb1972acc1ecda9$var$dispatch(el, name, detail = {}) {
    el.dispatchEvent(new CustomEvent(name, {
        detail: detail,
        bubbles: true,
        // Allows events to pass the shadow DOM barrier.
        composed: true,
        cancelable: true
    }));
}
// packages/alpinejs/src/utils/walk.js
function $ceb1972acc1ecda9$var$walk(el, callback) {
    if (typeof ShadowRoot === "function" && el instanceof ShadowRoot) {
        Array.from(el.children).forEach((el2)=>$ceb1972acc1ecda9$var$walk(el2, callback));
        return;
    }
    let skip = false;
    callback(el, ()=>skip = true);
    if (skip) return;
    let node = el.firstElementChild;
    while(node){
        $ceb1972acc1ecda9$var$walk(node, callback, false);
        node = node.nextElementSibling;
    }
}
// packages/alpinejs/src/utils/warn.js
function $ceb1972acc1ecda9$var$warn(message, ...args) {
    console.warn(`Alpine Warning: ${message}`, ...args);
}
// packages/alpinejs/src/lifecycle.js
var $ceb1972acc1ecda9$var$started = false;
function $ceb1972acc1ecda9$var$start() {
    if ($ceb1972acc1ecda9$var$started) $ceb1972acc1ecda9$var$warn("Alpine has already been initialized on this page. Calling Alpine.start() more than once can cause problems.");
    $ceb1972acc1ecda9$var$started = true;
    if (!document.body) $ceb1972acc1ecda9$var$warn("Unable to initialize. Trying to load Alpine before `<body>` is available. Did you forget to add `defer` in Alpine's `<script>` tag?");
    $ceb1972acc1ecda9$var$dispatch(document, "alpine:init");
    $ceb1972acc1ecda9$var$dispatch(document, "alpine:initializing");
    $ceb1972acc1ecda9$var$startObservingMutations();
    $ceb1972acc1ecda9$var$onElAdded((el)=>$ceb1972acc1ecda9$var$initTree(el, $ceb1972acc1ecda9$var$walk));
    $ceb1972acc1ecda9$var$onElRemoved((el)=>$ceb1972acc1ecda9$var$destroyTree(el));
    $ceb1972acc1ecda9$var$onAttributesAdded((el, attrs)=>{
        $ceb1972acc1ecda9$var$directives(el, attrs).forEach((handle)=>handle());
    });
    let outNestedComponents = (el)=>!$ceb1972acc1ecda9$var$closestRoot(el.parentElement, true);
    Array.from(document.querySelectorAll($ceb1972acc1ecda9$var$allSelectors().join(","))).filter(outNestedComponents).forEach((el)=>{
        $ceb1972acc1ecda9$var$initTree(el);
    });
    $ceb1972acc1ecda9$var$dispatch(document, "alpine:initialized");
    setTimeout(()=>{
        $ceb1972acc1ecda9$var$warnAboutMissingPlugins();
    });
}
var $ceb1972acc1ecda9$var$rootSelectorCallbacks = [];
var $ceb1972acc1ecda9$var$initSelectorCallbacks = [];
function $ceb1972acc1ecda9$var$rootSelectors() {
    return $ceb1972acc1ecda9$var$rootSelectorCallbacks.map((fn)=>fn());
}
function $ceb1972acc1ecda9$var$allSelectors() {
    return $ceb1972acc1ecda9$var$rootSelectorCallbacks.concat($ceb1972acc1ecda9$var$initSelectorCallbacks).map((fn)=>fn());
}
function $ceb1972acc1ecda9$var$addRootSelector(selectorCallback) {
    $ceb1972acc1ecda9$var$rootSelectorCallbacks.push(selectorCallback);
}
function $ceb1972acc1ecda9$var$addInitSelector(selectorCallback) {
    $ceb1972acc1ecda9$var$initSelectorCallbacks.push(selectorCallback);
}
function $ceb1972acc1ecda9$var$closestRoot(el, includeInitSelectors = false) {
    return $ceb1972acc1ecda9$var$findClosest(el, (element)=>{
        const selectors = includeInitSelectors ? $ceb1972acc1ecda9$var$allSelectors() : $ceb1972acc1ecda9$var$rootSelectors();
        if (selectors.some((selector)=>element.matches(selector))) return true;
    });
}
function $ceb1972acc1ecda9$var$findClosest(el, callback) {
    if (!el) return;
    if (callback(el)) return el;
    if (el._x_teleportBack) el = el._x_teleportBack;
    if (el.parentNode instanceof ShadowRoot) return $ceb1972acc1ecda9$var$findClosest(el.parentNode.host, callback);
    if (!el.parentElement) return;
    return $ceb1972acc1ecda9$var$findClosest(el.parentElement, callback);
}
function $ceb1972acc1ecda9$var$isRoot(el) {
    return $ceb1972acc1ecda9$var$rootSelectors().some((selector)=>el.matches(selector));
}
var $ceb1972acc1ecda9$var$initInterceptors2 = [];
function $ceb1972acc1ecda9$var$interceptInit(callback) {
    $ceb1972acc1ecda9$var$initInterceptors2.push(callback);
}
var $ceb1972acc1ecda9$var$markerDispenser = 1;
function $ceb1972acc1ecda9$var$initTree(el, walker = $ceb1972acc1ecda9$var$walk, intercept = ()=>{}) {
    if ($ceb1972acc1ecda9$var$findClosest(el, (i)=>i._x_ignore)) return;
    $ceb1972acc1ecda9$var$deferHandlingDirectives(()=>{
        walker(el, (el2, skip)=>{
            if (el2._x_marker) return;
            intercept(el2, skip);
            $ceb1972acc1ecda9$var$initInterceptors2.forEach((i)=>i(el2, skip));
            $ceb1972acc1ecda9$var$directives(el2, el2.attributes).forEach((handle)=>handle());
            if (!el2._x_ignore) el2._x_marker = $ceb1972acc1ecda9$var$markerDispenser++;
            el2._x_ignore && skip();
        });
    });
}
function $ceb1972acc1ecda9$var$destroyTree(root, walker = $ceb1972acc1ecda9$var$walk) {
    walker(root, (el)=>{
        $ceb1972acc1ecda9$var$cleanupElement(el);
        $ceb1972acc1ecda9$var$cleanupAttributes(el);
        delete el._x_marker;
    });
}
function $ceb1972acc1ecda9$var$warnAboutMissingPlugins() {
    let pluginDirectives = [
        [
            "ui",
            "dialog",
            [
                "[x-dialog], [x-popover]"
            ]
        ],
        [
            "anchor",
            "anchor",
            [
                "[x-anchor]"
            ]
        ],
        [
            "sort",
            "sort",
            [
                "[x-sort]"
            ]
        ]
    ];
    pluginDirectives.forEach(([plugin2, directive2, selectors])=>{
        if ($ceb1972acc1ecda9$var$directiveExists(directive2)) return;
        selectors.some((selector)=>{
            if (document.querySelector(selector)) {
                $ceb1972acc1ecda9$var$warn(`found "${selector}", but missing ${plugin2} plugin`);
                return true;
            }
        });
    });
}
// packages/alpinejs/src/nextTick.js
var $ceb1972acc1ecda9$var$tickStack = [];
var $ceb1972acc1ecda9$var$isHolding = false;
function $ceb1972acc1ecda9$var$nextTick(callback = ()=>{}) {
    queueMicrotask(()=>{
        $ceb1972acc1ecda9$var$isHolding || setTimeout(()=>{
            $ceb1972acc1ecda9$var$releaseNextTicks();
        });
    });
    return new Promise((res)=>{
        $ceb1972acc1ecda9$var$tickStack.push(()=>{
            callback();
            res();
        });
    });
}
function $ceb1972acc1ecda9$var$releaseNextTicks() {
    $ceb1972acc1ecda9$var$isHolding = false;
    while($ceb1972acc1ecda9$var$tickStack.length)$ceb1972acc1ecda9$var$tickStack.shift()();
}
function $ceb1972acc1ecda9$var$holdNextTicks() {
    $ceb1972acc1ecda9$var$isHolding = true;
}
// packages/alpinejs/src/utils/classes.js
function $ceb1972acc1ecda9$var$setClasses(el, value) {
    if (Array.isArray(value)) return $ceb1972acc1ecda9$var$setClassesFromString(el, value.join(" "));
    else if (typeof value === "object" && value !== null) return $ceb1972acc1ecda9$var$setClassesFromObject(el, value);
    else if (typeof value === "function") return $ceb1972acc1ecda9$var$setClasses(el, value());
    return $ceb1972acc1ecda9$var$setClassesFromString(el, value);
}
function $ceb1972acc1ecda9$var$setClassesFromString(el, classString) {
    let split = (classString2)=>classString2.split(" ").filter(Boolean);
    let missingClasses = (classString2)=>classString2.split(" ").filter((i)=>!el.classList.contains(i)).filter(Boolean);
    let addClassesAndReturnUndo = (classes)=>{
        el.classList.add(...classes);
        return ()=>{
            el.classList.remove(...classes);
        };
    };
    classString = classString === true ? classString = "" : classString || "";
    return addClassesAndReturnUndo(missingClasses(classString));
}
function $ceb1972acc1ecda9$var$setClassesFromObject(el, classObject) {
    let split = (classString)=>classString.split(" ").filter(Boolean);
    let forAdd = Object.entries(classObject).flatMap(([classString, bool])=>bool ? split(classString) : false).filter(Boolean);
    let forRemove = Object.entries(classObject).flatMap(([classString, bool])=>!bool ? split(classString) : false).filter(Boolean);
    let added = [];
    let removed = [];
    forRemove.forEach((i)=>{
        if (el.classList.contains(i)) {
            el.classList.remove(i);
            removed.push(i);
        }
    });
    forAdd.forEach((i)=>{
        if (!el.classList.contains(i)) {
            el.classList.add(i);
            added.push(i);
        }
    });
    return ()=>{
        removed.forEach((i)=>el.classList.add(i));
        added.forEach((i)=>el.classList.remove(i));
    };
}
// packages/alpinejs/src/utils/styles.js
function $ceb1972acc1ecda9$var$setStyles(el, value) {
    if (typeof value === "object" && value !== null) return $ceb1972acc1ecda9$var$setStylesFromObject(el, value);
    return $ceb1972acc1ecda9$var$setStylesFromString(el, value);
}
function $ceb1972acc1ecda9$var$setStylesFromObject(el, value) {
    let previousStyles = {};
    Object.entries(value).forEach(([key, value2])=>{
        previousStyles[key] = el.style[key];
        if (!key.startsWith("--")) key = $ceb1972acc1ecda9$var$kebabCase(key);
        el.style.setProperty(key, value2);
    });
    setTimeout(()=>{
        if (el.style.length === 0) el.removeAttribute("style");
    });
    return ()=>{
        $ceb1972acc1ecda9$var$setStyles(el, previousStyles);
    };
}
function $ceb1972acc1ecda9$var$setStylesFromString(el, value) {
    let cache = el.getAttribute("style", value);
    el.setAttribute("style", value);
    return ()=>{
        el.setAttribute("style", cache || "");
    };
}
function $ceb1972acc1ecda9$var$kebabCase(subject) {
    return subject.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
}
// packages/alpinejs/src/utils/once.js
function $ceb1972acc1ecda9$var$once(callback, fallback = ()=>{}) {
    let called = false;
    return function() {
        if (!called) {
            called = true;
            callback.apply(this, arguments);
        } else fallback.apply(this, arguments);
    };
}
// packages/alpinejs/src/directives/x-transition.js
$ceb1972acc1ecda9$var$directive("transition", (el, { value: value, modifiers: modifiers, expression: expression }, { evaluate: evaluate2 })=>{
    if (typeof expression === "function") expression = evaluate2(expression);
    if (expression === false) return;
    if (!expression || typeof expression === "boolean") $ceb1972acc1ecda9$var$registerTransitionsFromHelper(el, modifiers, value);
    else $ceb1972acc1ecda9$var$registerTransitionsFromClassString(el, expression, value);
});
function $ceb1972acc1ecda9$var$registerTransitionsFromClassString(el, classString, stage) {
    $ceb1972acc1ecda9$var$registerTransitionObject(el, $ceb1972acc1ecda9$var$setClasses, "");
    let directiveStorageMap = {
        "enter": (classes)=>{
            el._x_transition.enter.during = classes;
        },
        "enter-start": (classes)=>{
            el._x_transition.enter.start = classes;
        },
        "enter-end": (classes)=>{
            el._x_transition.enter.end = classes;
        },
        "leave": (classes)=>{
            el._x_transition.leave.during = classes;
        },
        "leave-start": (classes)=>{
            el._x_transition.leave.start = classes;
        },
        "leave-end": (classes)=>{
            el._x_transition.leave.end = classes;
        }
    };
    directiveStorageMap[stage](classString);
}
function $ceb1972acc1ecda9$var$registerTransitionsFromHelper(el, modifiers, stage) {
    $ceb1972acc1ecda9$var$registerTransitionObject(el, $ceb1972acc1ecda9$var$setStyles);
    let doesntSpecify = !modifiers.includes("in") && !modifiers.includes("out") && !stage;
    let transitioningIn = doesntSpecify || modifiers.includes("in") || [
        "enter"
    ].includes(stage);
    let transitioningOut = doesntSpecify || modifiers.includes("out") || [
        "leave"
    ].includes(stage);
    if (modifiers.includes("in") && !doesntSpecify) modifiers = modifiers.filter((i, index)=>index < modifiers.indexOf("out"));
    if (modifiers.includes("out") && !doesntSpecify) modifiers = modifiers.filter((i, index)=>index > modifiers.indexOf("out"));
    let wantsAll = !modifiers.includes("opacity") && !modifiers.includes("scale");
    let wantsOpacity = wantsAll || modifiers.includes("opacity");
    let wantsScale = wantsAll || modifiers.includes("scale");
    let opacityValue = wantsOpacity ? 0 : 1;
    let scaleValue = wantsScale ? $ceb1972acc1ecda9$var$modifierValue(modifiers, "scale", 95) / 100 : 1;
    let delay = $ceb1972acc1ecda9$var$modifierValue(modifiers, "delay", 0) / 1e3;
    let origin = $ceb1972acc1ecda9$var$modifierValue(modifiers, "origin", "center");
    let property = "opacity, transform";
    let durationIn = $ceb1972acc1ecda9$var$modifierValue(modifiers, "duration", 150) / 1e3;
    let durationOut = $ceb1972acc1ecda9$var$modifierValue(modifiers, "duration", 75) / 1e3;
    let easing = `cubic-bezier(0.4, 0.0, 0.2, 1)`;
    if (transitioningIn) {
        el._x_transition.enter.during = {
            transformOrigin: origin,
            transitionDelay: `${delay}s`,
            transitionProperty: property,
            transitionDuration: `${durationIn}s`,
            transitionTimingFunction: easing
        };
        el._x_transition.enter.start = {
            opacity: opacityValue,
            transform: `scale(${scaleValue})`
        };
        el._x_transition.enter.end = {
            opacity: 1,
            transform: `scale(1)`
        };
    }
    if (transitioningOut) {
        el._x_transition.leave.during = {
            transformOrigin: origin,
            transitionDelay: `${delay}s`,
            transitionProperty: property,
            transitionDuration: `${durationOut}s`,
            transitionTimingFunction: easing
        };
        el._x_transition.leave.start = {
            opacity: 1,
            transform: `scale(1)`
        };
        el._x_transition.leave.end = {
            opacity: opacityValue,
            transform: `scale(${scaleValue})`
        };
    }
}
function $ceb1972acc1ecda9$var$registerTransitionObject(el, setFunction, defaultValue = {}) {
    if (!el._x_transition) el._x_transition = {
        enter: {
            during: defaultValue,
            start: defaultValue,
            end: defaultValue
        },
        leave: {
            during: defaultValue,
            start: defaultValue,
            end: defaultValue
        },
        in (before = ()=>{}, after = ()=>{}) {
            $ceb1972acc1ecda9$var$transition(el, setFunction, {
                during: this.enter.during,
                start: this.enter.start,
                end: this.enter.end
            }, before, after);
        },
        out (before = ()=>{}, after = ()=>{}) {
            $ceb1972acc1ecda9$var$transition(el, setFunction, {
                during: this.leave.during,
                start: this.leave.start,
                end: this.leave.end
            }, before, after);
        }
    };
}
window.Element.prototype._x_toggleAndCascadeWithTransitions = function(el, value, show, hide) {
    const nextTick2 = document.visibilityState === "visible" ? requestAnimationFrame : setTimeout;
    let clickAwayCompatibleShow = ()=>nextTick2(show);
    if (value) {
        if (el._x_transition && (el._x_transition.enter || el._x_transition.leave)) el._x_transition.enter && (Object.entries(el._x_transition.enter.during).length || Object.entries(el._x_transition.enter.start).length || Object.entries(el._x_transition.enter.end).length) ? el._x_transition.in(show) : clickAwayCompatibleShow();
        else el._x_transition ? el._x_transition.in(show) : clickAwayCompatibleShow();
        return;
    }
    el._x_hidePromise = el._x_transition ? new Promise((resolve, reject)=>{
        el._x_transition.out(()=>{}, ()=>resolve(hide));
        el._x_transitioning && el._x_transitioning.beforeCancel(()=>reject({
                isFromCancelledTransition: true
            }));
    }) : Promise.resolve(hide);
    queueMicrotask(()=>{
        let closest = $ceb1972acc1ecda9$var$closestHide(el);
        if (closest) {
            if (!closest._x_hideChildren) closest._x_hideChildren = [];
            closest._x_hideChildren.push(el);
        } else nextTick2(()=>{
            let hideAfterChildren = (el2)=>{
                let carry = Promise.all([
                    el2._x_hidePromise,
                    ...(el2._x_hideChildren || []).map(hideAfterChildren)
                ]).then(([i])=>i?.());
                delete el2._x_hidePromise;
                delete el2._x_hideChildren;
                return carry;
            };
            hideAfterChildren(el).catch((e)=>{
                if (!e.isFromCancelledTransition) throw e;
            });
        });
    });
};
function $ceb1972acc1ecda9$var$closestHide(el) {
    let parent = el.parentNode;
    if (!parent) return;
    return parent._x_hidePromise ? parent : $ceb1972acc1ecda9$var$closestHide(parent);
}
function $ceb1972acc1ecda9$var$transition(el, setFunction, { during: during, start: start2, end: end } = {}, before = ()=>{}, after = ()=>{}) {
    if (el._x_transitioning) el._x_transitioning.cancel();
    if (Object.keys(during).length === 0 && Object.keys(start2).length === 0 && Object.keys(end).length === 0) {
        before();
        after();
        return;
    }
    let undoStart, undoDuring, undoEnd;
    $ceb1972acc1ecda9$var$performTransition(el, {
        start () {
            undoStart = setFunction(el, start2);
        },
        during () {
            undoDuring = setFunction(el, during);
        },
        before: before,
        end () {
            undoStart();
            undoEnd = setFunction(el, end);
        },
        after: after,
        cleanup () {
            undoDuring();
            undoEnd();
        }
    });
}
function $ceb1972acc1ecda9$var$performTransition(el, stages) {
    let interrupted, reachedBefore, reachedEnd;
    let finish = $ceb1972acc1ecda9$var$once(()=>{
        $ceb1972acc1ecda9$var$mutateDom(()=>{
            interrupted = true;
            if (!reachedBefore) stages.before();
            if (!reachedEnd) {
                stages.end();
                $ceb1972acc1ecda9$var$releaseNextTicks();
            }
            stages.after();
            if (el.isConnected) stages.cleanup();
            delete el._x_transitioning;
        });
    });
    el._x_transitioning = {
        beforeCancels: [],
        beforeCancel (callback) {
            this.beforeCancels.push(callback);
        },
        cancel: $ceb1972acc1ecda9$var$once(function() {
            while(this.beforeCancels.length)this.beforeCancels.shift()();
            finish();
        }),
        finish: finish
    };
    $ceb1972acc1ecda9$var$mutateDom(()=>{
        stages.start();
        stages.during();
    });
    $ceb1972acc1ecda9$var$holdNextTicks();
    requestAnimationFrame(()=>{
        if (interrupted) return;
        let duration = Number(getComputedStyle(el).transitionDuration.replace(/,.*/, "").replace("s", "")) * 1e3;
        let delay = Number(getComputedStyle(el).transitionDelay.replace(/,.*/, "").replace("s", "")) * 1e3;
        if (duration === 0) duration = Number(getComputedStyle(el).animationDuration.replace("s", "")) * 1e3;
        $ceb1972acc1ecda9$var$mutateDom(()=>{
            stages.before();
        });
        reachedBefore = true;
        requestAnimationFrame(()=>{
            if (interrupted) return;
            $ceb1972acc1ecda9$var$mutateDom(()=>{
                stages.end();
            });
            $ceb1972acc1ecda9$var$releaseNextTicks();
            setTimeout(el._x_transitioning.finish, duration + delay);
            reachedEnd = true;
        });
    });
}
function $ceb1972acc1ecda9$var$modifierValue(modifiers, key, fallback) {
    if (modifiers.indexOf(key) === -1) return fallback;
    const rawValue = modifiers[modifiers.indexOf(key) + 1];
    if (!rawValue) return fallback;
    if (key === "scale") {
        if (isNaN(rawValue)) return fallback;
    }
    if (key === "duration" || key === "delay") {
        let match = rawValue.match(/([0-9]+)ms/);
        if (match) return match[1];
    }
    if (key === "origin") {
        if ([
            "top",
            "right",
            "left",
            "center",
            "bottom"
        ].includes(modifiers[modifiers.indexOf(key) + 2])) return [
            rawValue,
            modifiers[modifiers.indexOf(key) + 2]
        ].join(" ");
    }
    return rawValue;
}
// packages/alpinejs/src/clone.js
var $ceb1972acc1ecda9$var$isCloning = false;
function $ceb1972acc1ecda9$var$skipDuringClone(callback, fallback = ()=>{}) {
    return (...args)=>$ceb1972acc1ecda9$var$isCloning ? fallback(...args) : callback(...args);
}
function $ceb1972acc1ecda9$var$onlyDuringClone(callback) {
    return (...args)=>$ceb1972acc1ecda9$var$isCloning && callback(...args);
}
var $ceb1972acc1ecda9$var$interceptors = [];
function $ceb1972acc1ecda9$var$interceptClone(callback) {
    $ceb1972acc1ecda9$var$interceptors.push(callback);
}
function $ceb1972acc1ecda9$var$cloneNode(from, to) {
    $ceb1972acc1ecda9$var$interceptors.forEach((i)=>i(from, to));
    $ceb1972acc1ecda9$var$isCloning = true;
    $ceb1972acc1ecda9$var$dontRegisterReactiveSideEffects(()=>{
        $ceb1972acc1ecda9$var$initTree(to, (el, callback)=>{
            callback(el, ()=>{});
        });
    });
    $ceb1972acc1ecda9$var$isCloning = false;
}
var $ceb1972acc1ecda9$var$isCloningLegacy = false;
function $ceb1972acc1ecda9$var$clone(oldEl, newEl) {
    if (!newEl._x_dataStack) newEl._x_dataStack = oldEl._x_dataStack;
    $ceb1972acc1ecda9$var$isCloning = true;
    $ceb1972acc1ecda9$var$isCloningLegacy = true;
    $ceb1972acc1ecda9$var$dontRegisterReactiveSideEffects(()=>{
        $ceb1972acc1ecda9$var$cloneTree(newEl);
    });
    $ceb1972acc1ecda9$var$isCloning = false;
    $ceb1972acc1ecda9$var$isCloningLegacy = false;
}
function $ceb1972acc1ecda9$var$cloneTree(el) {
    let hasRunThroughFirstEl = false;
    let shallowWalker = (el2, callback)=>{
        $ceb1972acc1ecda9$var$walk(el2, (el3, skip)=>{
            if (hasRunThroughFirstEl && $ceb1972acc1ecda9$var$isRoot(el3)) return skip();
            hasRunThroughFirstEl = true;
            callback(el3, skip);
        });
    };
    $ceb1972acc1ecda9$var$initTree(el, shallowWalker);
}
function $ceb1972acc1ecda9$var$dontRegisterReactiveSideEffects(callback) {
    let cache = $ceb1972acc1ecda9$var$effect;
    $ceb1972acc1ecda9$var$overrideEffect((callback2, el)=>{
        let storedEffect = cache(callback2);
        $ceb1972acc1ecda9$var$release(storedEffect);
        return ()=>{};
    });
    callback();
    $ceb1972acc1ecda9$var$overrideEffect(cache);
}
// packages/alpinejs/src/utils/bind.js
function $ceb1972acc1ecda9$var$bind(el, name, value, modifiers = []) {
    if (!el._x_bindings) el._x_bindings = $ceb1972acc1ecda9$var$reactive({});
    el._x_bindings[name] = value;
    name = modifiers.includes("camel") ? $ceb1972acc1ecda9$var$camelCase(name) : name;
    switch(name){
        case "value":
            $ceb1972acc1ecda9$var$bindInputValue(el, value);
            break;
        case "style":
            $ceb1972acc1ecda9$var$bindStyles(el, value);
            break;
        case "class":
            $ceb1972acc1ecda9$var$bindClasses(el, value);
            break;
        case "selected":
        case "checked":
            $ceb1972acc1ecda9$var$bindAttributeAndProperty(el, name, value);
            break;
        default:
            $ceb1972acc1ecda9$var$bindAttribute(el, name, value);
            break;
    }
}
function $ceb1972acc1ecda9$var$bindInputValue(el, value) {
    if ($ceb1972acc1ecda9$var$isRadio(el)) {
        if (el.attributes.value === void 0) el.value = value;
        if (window.fromModel) {
            if (typeof value === "boolean") el.checked = $ceb1972acc1ecda9$var$safeParseBoolean(el.value) === value;
            else el.checked = $ceb1972acc1ecda9$var$checkedAttrLooseCompare(el.value, value);
        }
    } else if ($ceb1972acc1ecda9$var$isCheckbox(el)) {
        if (Number.isInteger(value)) el.value = value;
        else if (!Array.isArray(value) && typeof value !== "boolean" && ![
            null,
            void 0
        ].includes(value)) el.value = String(value);
        else if (Array.isArray(value)) el.checked = value.some((val)=>$ceb1972acc1ecda9$var$checkedAttrLooseCompare(val, el.value));
        else el.checked = !!value;
    } else if (el.tagName === "SELECT") $ceb1972acc1ecda9$var$updateSelect(el, value);
    else {
        if (el.value === value) return;
        el.value = value === void 0 ? "" : value;
    }
}
function $ceb1972acc1ecda9$var$bindClasses(el, value) {
    if (el._x_undoAddedClasses) el._x_undoAddedClasses();
    el._x_undoAddedClasses = $ceb1972acc1ecda9$var$setClasses(el, value);
}
function $ceb1972acc1ecda9$var$bindStyles(el, value) {
    if (el._x_undoAddedStyles) el._x_undoAddedStyles();
    el._x_undoAddedStyles = $ceb1972acc1ecda9$var$setStyles(el, value);
}
function $ceb1972acc1ecda9$var$bindAttributeAndProperty(el, name, value) {
    $ceb1972acc1ecda9$var$bindAttribute(el, name, value);
    $ceb1972acc1ecda9$var$setPropertyIfChanged(el, name, value);
}
function $ceb1972acc1ecda9$var$bindAttribute(el, name, value) {
    if ([
        null,
        void 0,
        false
    ].includes(value) && $ceb1972acc1ecda9$var$attributeShouldntBePreservedIfFalsy(name)) el.removeAttribute(name);
    else {
        if ($ceb1972acc1ecda9$var$isBooleanAttr(name)) value = name;
        $ceb1972acc1ecda9$var$setIfChanged(el, name, value);
    }
}
function $ceb1972acc1ecda9$var$setIfChanged(el, attrName, value) {
    if (el.getAttribute(attrName) != value) el.setAttribute(attrName, value);
}
function $ceb1972acc1ecda9$var$setPropertyIfChanged(el, propName, value) {
    if (el[propName] !== value) el[propName] = value;
}
function $ceb1972acc1ecda9$var$updateSelect(el, value) {
    const arrayWrappedValue = [].concat(value).map((value2)=>{
        return value2 + "";
    });
    Array.from(el.options).forEach((option)=>{
        option.selected = arrayWrappedValue.includes(option.value);
    });
}
function $ceb1972acc1ecda9$var$camelCase(subject) {
    return subject.toLowerCase().replace(/-(\w)/g, (match, char)=>char.toUpperCase());
}
function $ceb1972acc1ecda9$var$checkedAttrLooseCompare(valueA, valueB) {
    return valueA == valueB;
}
function $ceb1972acc1ecda9$var$safeParseBoolean(rawValue) {
    if ([
        1,
        "1",
        "true",
        "on",
        "yes",
        true
    ].includes(rawValue)) return true;
    if ([
        0,
        "0",
        "false",
        "off",
        "no",
        false
    ].includes(rawValue)) return false;
    return rawValue ? Boolean(rawValue) : null;
}
var $ceb1972acc1ecda9$var$booleanAttributes = /* @__PURE__ */ new Set([
    "allowfullscreen",
    "async",
    "autofocus",
    "autoplay",
    "checked",
    "controls",
    "default",
    "defer",
    "disabled",
    "formnovalidate",
    "inert",
    "ismap",
    "itemscope",
    "loop",
    "multiple",
    "muted",
    "nomodule",
    "novalidate",
    "open",
    "playsinline",
    "readonly",
    "required",
    "reversed",
    "selected",
    "shadowrootclonable",
    "shadowrootdelegatesfocus",
    "shadowrootserializable"
]);
function $ceb1972acc1ecda9$var$isBooleanAttr(attrName) {
    return $ceb1972acc1ecda9$var$booleanAttributes.has(attrName);
}
function $ceb1972acc1ecda9$var$attributeShouldntBePreservedIfFalsy(name) {
    return ![
        "aria-pressed",
        "aria-checked",
        "aria-expanded",
        "aria-selected"
    ].includes(name);
}
function $ceb1972acc1ecda9$var$getBinding(el, name, fallback) {
    if (el._x_bindings && el._x_bindings[name] !== void 0) return el._x_bindings[name];
    return $ceb1972acc1ecda9$var$getAttributeBinding(el, name, fallback);
}
function $ceb1972acc1ecda9$var$extractProp(el, name, fallback, extract = true) {
    if (el._x_bindings && el._x_bindings[name] !== void 0) return el._x_bindings[name];
    if (el._x_inlineBindings && el._x_inlineBindings[name] !== void 0) {
        let binding = el._x_inlineBindings[name];
        binding.extract = extract;
        return $ceb1972acc1ecda9$var$dontAutoEvaluateFunctions(()=>{
            return $ceb1972acc1ecda9$var$evaluate(el, binding.expression);
        });
    }
    return $ceb1972acc1ecda9$var$getAttributeBinding(el, name, fallback);
}
function $ceb1972acc1ecda9$var$getAttributeBinding(el, name, fallback) {
    let attr = el.getAttribute(name);
    if (attr === null) return typeof fallback === "function" ? fallback() : fallback;
    if (attr === "") return true;
    if ($ceb1972acc1ecda9$var$isBooleanAttr(name)) return !![
        name,
        "true"
    ].includes(attr);
    return attr;
}
function $ceb1972acc1ecda9$var$isCheckbox(el) {
    return el.type === "checkbox" || el.localName === "ui-checkbox" || el.localName === "ui-switch";
}
function $ceb1972acc1ecda9$var$isRadio(el) {
    return el.type === "radio" || el.localName === "ui-radio";
}
// packages/alpinejs/src/utils/debounce.js
function $ceb1972acc1ecda9$var$debounce(func, wait) {
    let timeout;
    return function() {
        const context = this, args = arguments;
        const later = function() {
            timeout = null;
            func.apply(context, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    };
}
// packages/alpinejs/src/utils/throttle.js
function $ceb1972acc1ecda9$var$throttle(func, limit) {
    let inThrottle;
    return function() {
        let context = this, args = arguments;
        if (!inThrottle) {
            func.apply(context, args);
            inThrottle = true;
            setTimeout(()=>inThrottle = false, limit);
        }
    };
}
// packages/alpinejs/src/entangle.js
function $ceb1972acc1ecda9$var$entangle({ get: outerGet, set: outerSet }, { get: innerGet, set: innerSet }) {
    let firstRun = true;
    let outerHash;
    let innerHash;
    let reference = $ceb1972acc1ecda9$var$effect(()=>{
        let outer = outerGet();
        let inner = innerGet();
        if (firstRun) {
            innerSet($ceb1972acc1ecda9$var$cloneIfObject(outer));
            firstRun = false;
        } else {
            let outerHashLatest = JSON.stringify(outer);
            let innerHashLatest = JSON.stringify(inner);
            if (outerHashLatest !== outerHash) innerSet($ceb1972acc1ecda9$var$cloneIfObject(outer));
            else if (outerHashLatest !== innerHashLatest) outerSet($ceb1972acc1ecda9$var$cloneIfObject(inner));
        }
        outerHash = JSON.stringify(outerGet());
        innerHash = JSON.stringify(innerGet());
    });
    return ()=>{
        $ceb1972acc1ecda9$var$release(reference);
    };
}
function $ceb1972acc1ecda9$var$cloneIfObject(value) {
    return typeof value === "object" ? JSON.parse(JSON.stringify(value)) : value;
}
// packages/alpinejs/src/plugin.js
function $ceb1972acc1ecda9$var$plugin(callback) {
    let callbacks = Array.isArray(callback) ? callback : [
        callback
    ];
    callbacks.forEach((i)=>i($ceb1972acc1ecda9$var$alpine_default));
}
// packages/alpinejs/src/store.js
var $ceb1972acc1ecda9$var$stores = {};
var $ceb1972acc1ecda9$var$isReactive = false;
function $ceb1972acc1ecda9$var$store(name, value) {
    if (!$ceb1972acc1ecda9$var$isReactive) {
        $ceb1972acc1ecda9$var$stores = $ceb1972acc1ecda9$var$reactive($ceb1972acc1ecda9$var$stores);
        $ceb1972acc1ecda9$var$isReactive = true;
    }
    if (value === void 0) return $ceb1972acc1ecda9$var$stores[name];
    $ceb1972acc1ecda9$var$stores[name] = value;
    $ceb1972acc1ecda9$var$initInterceptors($ceb1972acc1ecda9$var$stores[name]);
    if (typeof value === "object" && value !== null && value.hasOwnProperty("init") && typeof value.init === "function") $ceb1972acc1ecda9$var$stores[name].init();
}
function $ceb1972acc1ecda9$var$getStores() {
    return $ceb1972acc1ecda9$var$stores;
}
// packages/alpinejs/src/binds.js
var $ceb1972acc1ecda9$var$binds = {};
function $ceb1972acc1ecda9$var$bind2(name, bindings) {
    let getBindings = typeof bindings !== "function" ? ()=>bindings : bindings;
    if (name instanceof Element) return $ceb1972acc1ecda9$var$applyBindingsObject(name, getBindings());
    else $ceb1972acc1ecda9$var$binds[name] = getBindings;
    return ()=>{};
}
function $ceb1972acc1ecda9$var$injectBindingProviders(obj) {
    Object.entries($ceb1972acc1ecda9$var$binds).forEach(([name, callback])=>{
        Object.defineProperty(obj, name, {
            get () {
                return (...args)=>{
                    return callback(...args);
                };
            }
        });
    });
    return obj;
}
function $ceb1972acc1ecda9$var$applyBindingsObject(el, obj, original) {
    let cleanupRunners = [];
    while(cleanupRunners.length)cleanupRunners.pop()();
    let attributes = Object.entries(obj).map(([name, value])=>({
            name: name,
            value: value
        }));
    let staticAttributes = $ceb1972acc1ecda9$var$attributesOnly(attributes);
    attributes = attributes.map((attribute)=>{
        if (staticAttributes.find((attr)=>attr.name === attribute.name)) return {
            name: `x-bind:${attribute.name}`,
            value: `"${attribute.value}"`
        };
        return attribute;
    });
    $ceb1972acc1ecda9$var$directives(el, attributes, original).map((handle)=>{
        cleanupRunners.push(handle.runCleanups);
        handle();
    });
    return ()=>{
        while(cleanupRunners.length)cleanupRunners.pop()();
    };
}
// packages/alpinejs/src/datas.js
var $ceb1972acc1ecda9$var$datas = {};
function $ceb1972acc1ecda9$var$data(name, callback) {
    $ceb1972acc1ecda9$var$datas[name] = callback;
}
function $ceb1972acc1ecda9$var$injectDataProviders(obj, context) {
    Object.entries($ceb1972acc1ecda9$var$datas).forEach(([name, callback])=>{
        Object.defineProperty(obj, name, {
            get () {
                return (...args)=>{
                    return callback.bind(context)(...args);
                };
            },
            enumerable: false
        });
    });
    return obj;
}
// packages/alpinejs/src/alpine.js
var $ceb1972acc1ecda9$var$Alpine = {
    get reactive () {
        return $ceb1972acc1ecda9$var$reactive;
    },
    get release () {
        return $ceb1972acc1ecda9$var$release;
    },
    get effect () {
        return $ceb1972acc1ecda9$var$effect;
    },
    get raw () {
        return $ceb1972acc1ecda9$var$raw;
    },
    get transaction () {
        return $ceb1972acc1ecda9$var$transaction;
    },
    version: "3.15.8",
    flushAndStopDeferringMutations: $ceb1972acc1ecda9$var$flushAndStopDeferringMutations,
    dontAutoEvaluateFunctions: $ceb1972acc1ecda9$var$dontAutoEvaluateFunctions,
    disableEffectScheduling: $ceb1972acc1ecda9$var$disableEffectScheduling,
    startObservingMutations: $ceb1972acc1ecda9$var$startObservingMutations,
    stopObservingMutations: $ceb1972acc1ecda9$var$stopObservingMutations,
    setReactivityEngine: $ceb1972acc1ecda9$var$setReactivityEngine,
    onAttributeRemoved: $ceb1972acc1ecda9$var$onAttributeRemoved,
    onAttributesAdded: $ceb1972acc1ecda9$var$onAttributesAdded,
    closestDataStack: $ceb1972acc1ecda9$var$closestDataStack,
    skipDuringClone: $ceb1972acc1ecda9$var$skipDuringClone,
    onlyDuringClone: $ceb1972acc1ecda9$var$onlyDuringClone,
    addRootSelector: $ceb1972acc1ecda9$var$addRootSelector,
    addInitSelector: $ceb1972acc1ecda9$var$addInitSelector,
    setErrorHandler: $ceb1972acc1ecda9$var$setErrorHandler,
    interceptClone: $ceb1972acc1ecda9$var$interceptClone,
    addScopeToNode: $ceb1972acc1ecda9$var$addScopeToNode,
    deferMutations: $ceb1972acc1ecda9$var$deferMutations,
    mapAttributes: $ceb1972acc1ecda9$var$mapAttributes,
    evaluateLater: $ceb1972acc1ecda9$var$evaluateLater,
    interceptInit: $ceb1972acc1ecda9$var$interceptInit,
    initInterceptors: $ceb1972acc1ecda9$var$initInterceptors,
    injectMagics: $ceb1972acc1ecda9$var$injectMagics,
    setEvaluator: $ceb1972acc1ecda9$var$setEvaluator,
    setRawEvaluator: $ceb1972acc1ecda9$var$setRawEvaluator,
    mergeProxies: $ceb1972acc1ecda9$var$mergeProxies,
    extractProp: $ceb1972acc1ecda9$var$extractProp,
    findClosest: $ceb1972acc1ecda9$var$findClosest,
    onElRemoved: $ceb1972acc1ecda9$var$onElRemoved,
    closestRoot: $ceb1972acc1ecda9$var$closestRoot,
    destroyTree: $ceb1972acc1ecda9$var$destroyTree,
    interceptor: $ceb1972acc1ecda9$var$interceptor,
    transition: // INTERNAL: not public API and is subject to change without major release.
    $ceb1972acc1ecda9$var$transition,
    setStyles: // INTERNAL
    $ceb1972acc1ecda9$var$setStyles,
    mutateDom: // INTERNAL
    $ceb1972acc1ecda9$var$mutateDom,
    directive: $ceb1972acc1ecda9$var$directive,
    entangle: $ceb1972acc1ecda9$var$entangle,
    throttle: $ceb1972acc1ecda9$var$throttle,
    debounce: $ceb1972acc1ecda9$var$debounce,
    evaluate: $ceb1972acc1ecda9$var$evaluate,
    evaluateRaw: $ceb1972acc1ecda9$var$evaluateRaw,
    initTree: $ceb1972acc1ecda9$var$initTree,
    nextTick: $ceb1972acc1ecda9$var$nextTick,
    prefixed: $ceb1972acc1ecda9$var$prefix,
    prefix: $ceb1972acc1ecda9$var$setPrefix,
    plugin: $ceb1972acc1ecda9$var$plugin,
    magic: $ceb1972acc1ecda9$var$magic,
    store: $ceb1972acc1ecda9$var$store,
    start: $ceb1972acc1ecda9$var$start,
    clone: $ceb1972acc1ecda9$var$clone,
    cloneNode: // INTERNAL
    $ceb1972acc1ecda9$var$cloneNode,
    // INTERNAL
    bound: $ceb1972acc1ecda9$var$getBinding,
    $data: $ceb1972acc1ecda9$var$scope,
    watch: $ceb1972acc1ecda9$var$watch,
    walk: $ceb1972acc1ecda9$var$walk,
    data: $ceb1972acc1ecda9$var$data,
    bind: $ceb1972acc1ecda9$var$bind2
};
var $ceb1972acc1ecda9$var$alpine_default = $ceb1972acc1ecda9$var$Alpine;
// node_modules/@vue/shared/dist/shared.esm-bundler.js
function $ceb1972acc1ecda9$var$makeMap(str, expectsLowerCase) {
    const map = /* @__PURE__ */ Object.create(null);
    const list = str.split(",");
    for(let i = 0; i < list.length; i++)map[list[i]] = true;
    return expectsLowerCase ? (val)=>!!map[val.toLowerCase()] : (val)=>!!map[val];
}
var $ceb1972acc1ecda9$var$specialBooleanAttrs = `itemscope,allowfullscreen,formnovalidate,ismap,nomodule,novalidate,readonly`;
var $ceb1972acc1ecda9$var$isBooleanAttr2 = /* @__PURE__ */ $ceb1972acc1ecda9$var$makeMap($ceb1972acc1ecda9$var$specialBooleanAttrs + `,async,autofocus,autoplay,controls,default,defer,disabled,hidden,loop,open,required,reversed,scoped,seamless,checked,muted,multiple,selected`);
var $ceb1972acc1ecda9$var$EMPTY_OBJ = Object.freeze({});
var $ceb1972acc1ecda9$var$EMPTY_ARR = Object.freeze([]);
var $ceb1972acc1ecda9$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $ceb1972acc1ecda9$var$hasOwn = (val, key)=>$ceb1972acc1ecda9$var$hasOwnProperty.call(val, key);
var $ceb1972acc1ecda9$var$isArray = Array.isArray;
var $ceb1972acc1ecda9$var$isMap = (val)=>$ceb1972acc1ecda9$var$toTypeString(val) === "[object Map]";
var $ceb1972acc1ecda9$var$isString = (val)=>typeof val === "string";
var $ceb1972acc1ecda9$var$isSymbol = (val)=>typeof val === "symbol";
var $ceb1972acc1ecda9$var$isObject = (val)=>val !== null && typeof val === "object";
var $ceb1972acc1ecda9$var$objectToString = Object.prototype.toString;
var $ceb1972acc1ecda9$var$toTypeString = (value)=>$ceb1972acc1ecda9$var$objectToString.call(value);
var $ceb1972acc1ecda9$var$toRawType = (value)=>{
    return $ceb1972acc1ecda9$var$toTypeString(value).slice(8, -1);
};
var $ceb1972acc1ecda9$var$isIntegerKey = (key)=>$ceb1972acc1ecda9$var$isString(key) && key !== "NaN" && key[0] !== "-" && "" + parseInt(key, 10) === key;
var $ceb1972acc1ecda9$var$cacheStringFunction = (fn)=>{
    const cache = /* @__PURE__ */ Object.create(null);
    return (str)=>{
        const hit = cache[str];
        return hit || (cache[str] = fn(str));
    };
};
var $ceb1972acc1ecda9$var$camelizeRE = /-(\w)/g;
var $ceb1972acc1ecda9$var$camelize = $ceb1972acc1ecda9$var$cacheStringFunction((str)=>{
    return str.replace($ceb1972acc1ecda9$var$camelizeRE, (_, c)=>c ? c.toUpperCase() : "");
});
var $ceb1972acc1ecda9$var$hyphenateRE = /\B([A-Z])/g;
var $ceb1972acc1ecda9$var$hyphenate = $ceb1972acc1ecda9$var$cacheStringFunction((str)=>str.replace($ceb1972acc1ecda9$var$hyphenateRE, "-$1").toLowerCase());
var $ceb1972acc1ecda9$var$capitalize = $ceb1972acc1ecda9$var$cacheStringFunction((str)=>str.charAt(0).toUpperCase() + str.slice(1));
var $ceb1972acc1ecda9$var$toHandlerKey = $ceb1972acc1ecda9$var$cacheStringFunction((str)=>str ? `on${$ceb1972acc1ecda9$var$capitalize(str)}` : ``);
var $ceb1972acc1ecda9$var$hasChanged = (value, oldValue)=>value !== oldValue && (value === value || oldValue === oldValue);
// node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js
var $ceb1972acc1ecda9$var$targetMap = /* @__PURE__ */ new WeakMap();
var $ceb1972acc1ecda9$var$effectStack = [];
var $ceb1972acc1ecda9$var$activeEffect;
var $ceb1972acc1ecda9$var$ITERATE_KEY = Symbol("iterate");
var $ceb1972acc1ecda9$var$MAP_KEY_ITERATE_KEY = Symbol("Map key iterate");
function $ceb1972acc1ecda9$var$isEffect(fn) {
    return fn && fn._isEffect === true;
}
function $ceb1972acc1ecda9$var$effect2(fn, options = $ceb1972acc1ecda9$var$EMPTY_OBJ) {
    if ($ceb1972acc1ecda9$var$isEffect(fn)) fn = fn.raw;
    const effect3 = $ceb1972acc1ecda9$var$createReactiveEffect(fn, options);
    if (!options.lazy) effect3();
    return effect3;
}
function $ceb1972acc1ecda9$var$stop(effect3) {
    if (effect3.active) {
        $ceb1972acc1ecda9$var$cleanup(effect3);
        if (effect3.options.onStop) effect3.options.onStop();
        effect3.active = false;
    }
}
var $ceb1972acc1ecda9$var$uid = 0;
function $ceb1972acc1ecda9$var$createReactiveEffect(fn, options) {
    const effect3 = function reactiveEffect() {
        if (!effect3.active) return fn();
        if (!$ceb1972acc1ecda9$var$effectStack.includes(effect3)) {
            $ceb1972acc1ecda9$var$cleanup(effect3);
            try {
                $ceb1972acc1ecda9$var$enableTracking();
                $ceb1972acc1ecda9$var$effectStack.push(effect3);
                $ceb1972acc1ecda9$var$activeEffect = effect3;
                return fn();
            } finally{
                $ceb1972acc1ecda9$var$effectStack.pop();
                $ceb1972acc1ecda9$var$resetTracking();
                $ceb1972acc1ecda9$var$activeEffect = $ceb1972acc1ecda9$var$effectStack[$ceb1972acc1ecda9$var$effectStack.length - 1];
            }
        }
    };
    effect3.id = $ceb1972acc1ecda9$var$uid++;
    effect3.allowRecurse = !!options.allowRecurse;
    effect3._isEffect = true;
    effect3.active = true;
    effect3.raw = fn;
    effect3.deps = [];
    effect3.options = options;
    return effect3;
}
function $ceb1972acc1ecda9$var$cleanup(effect3) {
    const { deps: deps } = effect3;
    if (deps.length) {
        for(let i = 0; i < deps.length; i++)deps[i].delete(effect3);
        deps.length = 0;
    }
}
var $ceb1972acc1ecda9$var$shouldTrack = true;
var $ceb1972acc1ecda9$var$trackStack = [];
function $ceb1972acc1ecda9$var$pauseTracking() {
    $ceb1972acc1ecda9$var$trackStack.push($ceb1972acc1ecda9$var$shouldTrack);
    $ceb1972acc1ecda9$var$shouldTrack = false;
}
function $ceb1972acc1ecda9$var$enableTracking() {
    $ceb1972acc1ecda9$var$trackStack.push($ceb1972acc1ecda9$var$shouldTrack);
    $ceb1972acc1ecda9$var$shouldTrack = true;
}
function $ceb1972acc1ecda9$var$resetTracking() {
    const last = $ceb1972acc1ecda9$var$trackStack.pop();
    $ceb1972acc1ecda9$var$shouldTrack = last === void 0 ? true : last;
}
function $ceb1972acc1ecda9$var$track(target, type, key) {
    if (!$ceb1972acc1ecda9$var$shouldTrack || $ceb1972acc1ecda9$var$activeEffect === void 0) return;
    let depsMap = $ceb1972acc1ecda9$var$targetMap.get(target);
    if (!depsMap) $ceb1972acc1ecda9$var$targetMap.set(target, depsMap = /* @__PURE__ */ new Map());
    let dep = depsMap.get(key);
    if (!dep) depsMap.set(key, dep = /* @__PURE__ */ new Set());
    if (!dep.has($ceb1972acc1ecda9$var$activeEffect)) {
        dep.add($ceb1972acc1ecda9$var$activeEffect);
        $ceb1972acc1ecda9$var$activeEffect.deps.push(dep);
        if ($ceb1972acc1ecda9$var$activeEffect.options.onTrack) $ceb1972acc1ecda9$var$activeEffect.options.onTrack({
            effect: $ceb1972acc1ecda9$var$activeEffect,
            target: target,
            type: type,
            key: key
        });
    }
}
function $ceb1972acc1ecda9$var$trigger(target, type, key, newValue, oldValue, oldTarget) {
    const depsMap = $ceb1972acc1ecda9$var$targetMap.get(target);
    if (!depsMap) return;
    const effects = /* @__PURE__ */ new Set();
    const add2 = (effectsToAdd)=>{
        if (effectsToAdd) effectsToAdd.forEach((effect3)=>{
            if (effect3 !== $ceb1972acc1ecda9$var$activeEffect || effect3.allowRecurse) effects.add(effect3);
        });
    };
    if (type === "clear") depsMap.forEach(add2);
    else if (key === "length" && $ceb1972acc1ecda9$var$isArray(target)) depsMap.forEach((dep, key2)=>{
        if (key2 === "length" || key2 >= newValue) add2(dep);
    });
    else {
        if (key !== void 0) add2(depsMap.get(key));
        switch(type){
            case "add":
                if (!$ceb1972acc1ecda9$var$isArray(target)) {
                    add2(depsMap.get($ceb1972acc1ecda9$var$ITERATE_KEY));
                    if ($ceb1972acc1ecda9$var$isMap(target)) add2(depsMap.get($ceb1972acc1ecda9$var$MAP_KEY_ITERATE_KEY));
                } else if ($ceb1972acc1ecda9$var$isIntegerKey(key)) add2(depsMap.get("length"));
                break;
            case "delete":
                if (!$ceb1972acc1ecda9$var$isArray(target)) {
                    add2(depsMap.get($ceb1972acc1ecda9$var$ITERATE_KEY));
                    if ($ceb1972acc1ecda9$var$isMap(target)) add2(depsMap.get($ceb1972acc1ecda9$var$MAP_KEY_ITERATE_KEY));
                }
                break;
            case "set":
                if ($ceb1972acc1ecda9$var$isMap(target)) add2(depsMap.get($ceb1972acc1ecda9$var$ITERATE_KEY));
                break;
        }
    }
    const run = (effect3)=>{
        if (effect3.options.onTrigger) effect3.options.onTrigger({
            effect: effect3,
            target: target,
            key: key,
            type: type,
            newValue: newValue,
            oldValue: oldValue,
            oldTarget: oldTarget
        });
        if (effect3.options.scheduler) effect3.options.scheduler(effect3);
        else effect3();
    };
    effects.forEach(run);
}
var $ceb1972acc1ecda9$var$isNonTrackableKeys = /* @__PURE__ */ $ceb1972acc1ecda9$var$makeMap(`__proto__,__v_isRef,__isVue`);
var $ceb1972acc1ecda9$var$builtInSymbols = new Set(Object.getOwnPropertyNames(Symbol).map((key)=>Symbol[key]).filter($ceb1972acc1ecda9$var$isSymbol));
var $ceb1972acc1ecda9$var$get2 = /* @__PURE__ */ $ceb1972acc1ecda9$var$createGetter();
var $ceb1972acc1ecda9$var$readonlyGet = /* @__PURE__ */ $ceb1972acc1ecda9$var$createGetter(true);
var $ceb1972acc1ecda9$var$arrayInstrumentations = /* @__PURE__ */ $ceb1972acc1ecda9$var$createArrayInstrumentations();
function $ceb1972acc1ecda9$var$createArrayInstrumentations() {
    const instrumentations = {};
    [
        "includes",
        "indexOf",
        "lastIndexOf"
    ].forEach((key)=>{
        instrumentations[key] = function(...args) {
            const arr = $ceb1972acc1ecda9$var$toRaw(this);
            for(let i = 0, l = this.length; i < l; i++)$ceb1972acc1ecda9$var$track(arr, "get", i + "");
            const res = arr[key](...args);
            if (res === -1 || res === false) return arr[key](...args.map($ceb1972acc1ecda9$var$toRaw));
            else return res;
        };
    });
    [
        "push",
        "pop",
        "shift",
        "unshift",
        "splice"
    ].forEach((key)=>{
        instrumentations[key] = function(...args) {
            $ceb1972acc1ecda9$var$pauseTracking();
            const res = $ceb1972acc1ecda9$var$toRaw(this)[key].apply(this, args);
            $ceb1972acc1ecda9$var$resetTracking();
            return res;
        };
    });
    return instrumentations;
}
function $ceb1972acc1ecda9$var$createGetter(isReadonly = false, shallow = false) {
    return function get3(target, key, receiver) {
        if (key === "__v_isReactive") return !isReadonly;
        else if (key === "__v_isReadonly") return isReadonly;
        else if (key === "__v_raw" && receiver === (isReadonly ? shallow ? $ceb1972acc1ecda9$var$shallowReadonlyMap : $ceb1972acc1ecda9$var$readonlyMap : shallow ? $ceb1972acc1ecda9$var$shallowReactiveMap : $ceb1972acc1ecda9$var$reactiveMap).get(target)) return target;
        const targetIsArray = $ceb1972acc1ecda9$var$isArray(target);
        if (!isReadonly && targetIsArray && $ceb1972acc1ecda9$var$hasOwn($ceb1972acc1ecda9$var$arrayInstrumentations, key)) return Reflect.get($ceb1972acc1ecda9$var$arrayInstrumentations, key, receiver);
        const res = Reflect.get(target, key, receiver);
        if ($ceb1972acc1ecda9$var$isSymbol(key) ? $ceb1972acc1ecda9$var$builtInSymbols.has(key) : $ceb1972acc1ecda9$var$isNonTrackableKeys(key)) return res;
        if (!isReadonly) $ceb1972acc1ecda9$var$track(target, "get", key);
        if (shallow) return res;
        if ($ceb1972acc1ecda9$var$isRef(res)) {
            const shouldUnwrap = !targetIsArray || !$ceb1972acc1ecda9$var$isIntegerKey(key);
            return shouldUnwrap ? res.value : res;
        }
        if ($ceb1972acc1ecda9$var$isObject(res)) return isReadonly ? $ceb1972acc1ecda9$var$readonly(res) : $ceb1972acc1ecda9$var$reactive2(res);
        return res;
    };
}
var $ceb1972acc1ecda9$var$set2 = /* @__PURE__ */ $ceb1972acc1ecda9$var$createSetter();
function $ceb1972acc1ecda9$var$createSetter(shallow = false) {
    return function set3(target, key, value, receiver) {
        let oldValue = target[key];
        if (!shallow) {
            value = $ceb1972acc1ecda9$var$toRaw(value);
            oldValue = $ceb1972acc1ecda9$var$toRaw(oldValue);
            if (!$ceb1972acc1ecda9$var$isArray(target) && $ceb1972acc1ecda9$var$isRef(oldValue) && !$ceb1972acc1ecda9$var$isRef(value)) {
                oldValue.value = value;
                return true;
            }
        }
        const hadKey = $ceb1972acc1ecda9$var$isArray(target) && $ceb1972acc1ecda9$var$isIntegerKey(key) ? Number(key) < target.length : $ceb1972acc1ecda9$var$hasOwn(target, key);
        const result = Reflect.set(target, key, value, receiver);
        if (target === $ceb1972acc1ecda9$var$toRaw(receiver)) {
            if (!hadKey) $ceb1972acc1ecda9$var$trigger(target, "add", key, value);
            else if ($ceb1972acc1ecda9$var$hasChanged(value, oldValue)) $ceb1972acc1ecda9$var$trigger(target, "set", key, value, oldValue);
        }
        return result;
    };
}
function $ceb1972acc1ecda9$var$deleteProperty(target, key) {
    const hadKey = $ceb1972acc1ecda9$var$hasOwn(target, key);
    const oldValue = target[key];
    const result = Reflect.deleteProperty(target, key);
    if (result && hadKey) $ceb1972acc1ecda9$var$trigger(target, "delete", key, void 0, oldValue);
    return result;
}
function $ceb1972acc1ecda9$var$has(target, key) {
    const result = Reflect.has(target, key);
    if (!$ceb1972acc1ecda9$var$isSymbol(key) || !$ceb1972acc1ecda9$var$builtInSymbols.has(key)) $ceb1972acc1ecda9$var$track(target, "has", key);
    return result;
}
function $ceb1972acc1ecda9$var$ownKeys(target) {
    $ceb1972acc1ecda9$var$track(target, "iterate", $ceb1972acc1ecda9$var$isArray(target) ? "length" : $ceb1972acc1ecda9$var$ITERATE_KEY);
    return Reflect.ownKeys(target);
}
var $ceb1972acc1ecda9$var$mutableHandlers = {
    get: $ceb1972acc1ecda9$var$get2,
    set: $ceb1972acc1ecda9$var$set2,
    deleteProperty: $ceb1972acc1ecda9$var$deleteProperty,
    has: $ceb1972acc1ecda9$var$has,
    ownKeys: $ceb1972acc1ecda9$var$ownKeys
};
var $ceb1972acc1ecda9$var$readonlyHandlers = {
    get: $ceb1972acc1ecda9$var$readonlyGet,
    set (target, key) {
        console.warn(`Set operation on key "${String(key)}" failed: target is readonly.`, target);
        return true;
    },
    deleteProperty (target, key) {
        console.warn(`Delete operation on key "${String(key)}" failed: target is readonly.`, target);
        return true;
    }
};
var $ceb1972acc1ecda9$var$toReactive = (value)=>$ceb1972acc1ecda9$var$isObject(value) ? $ceb1972acc1ecda9$var$reactive2(value) : value;
var $ceb1972acc1ecda9$var$toReadonly = (value)=>$ceb1972acc1ecda9$var$isObject(value) ? $ceb1972acc1ecda9$var$readonly(value) : value;
var $ceb1972acc1ecda9$var$toShallow = (value)=>value;
var $ceb1972acc1ecda9$var$getProto = (v)=>Reflect.getPrototypeOf(v);
function $ceb1972acc1ecda9$var$get$1(target, key, isReadonly = false, isShallow = false) {
    target = target["__v_raw"];
    const rawTarget = $ceb1972acc1ecda9$var$toRaw(target);
    const rawKey = $ceb1972acc1ecda9$var$toRaw(key);
    if (key !== rawKey) !isReadonly && $ceb1972acc1ecda9$var$track(rawTarget, "get", key);
    !isReadonly && $ceb1972acc1ecda9$var$track(rawTarget, "get", rawKey);
    const { has: has2 } = $ceb1972acc1ecda9$var$getProto(rawTarget);
    const wrap = isShallow ? $ceb1972acc1ecda9$var$toShallow : isReadonly ? $ceb1972acc1ecda9$var$toReadonly : $ceb1972acc1ecda9$var$toReactive;
    if (has2.call(rawTarget, key)) return wrap(target.get(key));
    else if (has2.call(rawTarget, rawKey)) return wrap(target.get(rawKey));
    else if (target !== rawTarget) target.get(key);
}
function $ceb1972acc1ecda9$var$has$1(key, isReadonly = false) {
    const target = this["__v_raw"];
    const rawTarget = $ceb1972acc1ecda9$var$toRaw(target);
    const rawKey = $ceb1972acc1ecda9$var$toRaw(key);
    if (key !== rawKey) !isReadonly && $ceb1972acc1ecda9$var$track(rawTarget, "has", key);
    !isReadonly && $ceb1972acc1ecda9$var$track(rawTarget, "has", rawKey);
    return key === rawKey ? target.has(key) : target.has(key) || target.has(rawKey);
}
function $ceb1972acc1ecda9$var$size(target, isReadonly = false) {
    target = target["__v_raw"];
    !isReadonly && $ceb1972acc1ecda9$var$track($ceb1972acc1ecda9$var$toRaw(target), "iterate", $ceb1972acc1ecda9$var$ITERATE_KEY);
    return Reflect.get(target, "size", target);
}
function $ceb1972acc1ecda9$var$add(value) {
    value = $ceb1972acc1ecda9$var$toRaw(value);
    const target = $ceb1972acc1ecda9$var$toRaw(this);
    const proto = $ceb1972acc1ecda9$var$getProto(target);
    const hadKey = proto.has.call(target, value);
    if (!hadKey) {
        target.add(value);
        $ceb1972acc1ecda9$var$trigger(target, "add", value, value);
    }
    return this;
}
function $ceb1972acc1ecda9$var$set$1(key, value) {
    value = $ceb1972acc1ecda9$var$toRaw(value);
    const target = $ceb1972acc1ecda9$var$toRaw(this);
    const { has: has2, get: get3 } = $ceb1972acc1ecda9$var$getProto(target);
    let hadKey = has2.call(target, key);
    if (!hadKey) {
        key = $ceb1972acc1ecda9$var$toRaw(key);
        hadKey = has2.call(target, key);
    } else $ceb1972acc1ecda9$var$checkIdentityKeys(target, has2, key);
    const oldValue = get3.call(target, key);
    target.set(key, value);
    if (!hadKey) $ceb1972acc1ecda9$var$trigger(target, "add", key, value);
    else if ($ceb1972acc1ecda9$var$hasChanged(value, oldValue)) $ceb1972acc1ecda9$var$trigger(target, "set", key, value, oldValue);
    return this;
}
function $ceb1972acc1ecda9$var$deleteEntry(key) {
    const target = $ceb1972acc1ecda9$var$toRaw(this);
    const { has: has2, get: get3 } = $ceb1972acc1ecda9$var$getProto(target);
    let hadKey = has2.call(target, key);
    if (!hadKey) {
        key = $ceb1972acc1ecda9$var$toRaw(key);
        hadKey = has2.call(target, key);
    } else $ceb1972acc1ecda9$var$checkIdentityKeys(target, has2, key);
    const oldValue = get3 ? get3.call(target, key) : void 0;
    const result = target.delete(key);
    if (hadKey) $ceb1972acc1ecda9$var$trigger(target, "delete", key, void 0, oldValue);
    return result;
}
function $ceb1972acc1ecda9$var$clear() {
    const target = $ceb1972acc1ecda9$var$toRaw(this);
    const hadItems = target.size !== 0;
    const oldTarget = $ceb1972acc1ecda9$var$isMap(target) ? new Map(target) : new Set(target);
    const result = target.clear();
    if (hadItems) $ceb1972acc1ecda9$var$trigger(target, "clear", void 0, void 0, oldTarget);
    return result;
}
function $ceb1972acc1ecda9$var$createForEach(isReadonly, isShallow) {
    return function forEach(callback, thisArg) {
        const observed = this;
        const target = observed["__v_raw"];
        const rawTarget = $ceb1972acc1ecda9$var$toRaw(target);
        const wrap = isShallow ? $ceb1972acc1ecda9$var$toShallow : isReadonly ? $ceb1972acc1ecda9$var$toReadonly : $ceb1972acc1ecda9$var$toReactive;
        !isReadonly && $ceb1972acc1ecda9$var$track(rawTarget, "iterate", $ceb1972acc1ecda9$var$ITERATE_KEY);
        return target.forEach((value, key)=>{
            return callback.call(thisArg, wrap(value), wrap(key), observed);
        });
    };
}
function $ceb1972acc1ecda9$var$createIterableMethod(method, isReadonly, isShallow) {
    return function(...args) {
        const target = this["__v_raw"];
        const rawTarget = $ceb1972acc1ecda9$var$toRaw(target);
        const targetIsMap = $ceb1972acc1ecda9$var$isMap(rawTarget);
        const isPair = method === "entries" || method === Symbol.iterator && targetIsMap;
        const isKeyOnly = method === "keys" && targetIsMap;
        const innerIterator = target[method](...args);
        const wrap = isShallow ? $ceb1972acc1ecda9$var$toShallow : isReadonly ? $ceb1972acc1ecda9$var$toReadonly : $ceb1972acc1ecda9$var$toReactive;
        !isReadonly && $ceb1972acc1ecda9$var$track(rawTarget, "iterate", isKeyOnly ? $ceb1972acc1ecda9$var$MAP_KEY_ITERATE_KEY : $ceb1972acc1ecda9$var$ITERATE_KEY);
        return {
            // iterator protocol
            next () {
                const { value: value, done: done } = innerIterator.next();
                return done ? {
                    value: value,
                    done: done
                } : {
                    value: isPair ? [
                        wrap(value[0]),
                        wrap(value[1])
                    ] : wrap(value),
                    done: done
                };
            },
            // iterable protocol
            [Symbol.iterator] () {
                return this;
            }
        };
    };
}
function $ceb1972acc1ecda9$var$createReadonlyMethod(type) {
    return function(...args) {
        {
            const key = args[0] ? `on key "${args[0]}" ` : ``;
            console.warn(`${$ceb1972acc1ecda9$var$capitalize(type)} operation ${key}failed: target is readonly.`, $ceb1972acc1ecda9$var$toRaw(this));
        }
        return type === "delete" ? false : this;
    };
}
function $ceb1972acc1ecda9$var$createInstrumentations() {
    const mutableInstrumentations2 = {
        get (key) {
            return $ceb1972acc1ecda9$var$get$1(this, key);
        },
        get size () {
            return $ceb1972acc1ecda9$var$size(this);
        },
        has: $ceb1972acc1ecda9$var$has$1,
        add: $ceb1972acc1ecda9$var$add,
        set: $ceb1972acc1ecda9$var$set$1,
        delete: $ceb1972acc1ecda9$var$deleteEntry,
        clear: $ceb1972acc1ecda9$var$clear,
        forEach: $ceb1972acc1ecda9$var$createForEach(false, false)
    };
    const shallowInstrumentations2 = {
        get (key) {
            return $ceb1972acc1ecda9$var$get$1(this, key, false, true);
        },
        get size () {
            return $ceb1972acc1ecda9$var$size(this);
        },
        has: $ceb1972acc1ecda9$var$has$1,
        add: $ceb1972acc1ecda9$var$add,
        set: $ceb1972acc1ecda9$var$set$1,
        delete: $ceb1972acc1ecda9$var$deleteEntry,
        clear: $ceb1972acc1ecda9$var$clear,
        forEach: $ceb1972acc1ecda9$var$createForEach(false, true)
    };
    const readonlyInstrumentations2 = {
        get (key) {
            return $ceb1972acc1ecda9$var$get$1(this, key, true);
        },
        get size () {
            return $ceb1972acc1ecda9$var$size(this, true);
        },
        has (key) {
            return $ceb1972acc1ecda9$var$has$1.call(this, key, true);
        },
        add: $ceb1972acc1ecda9$var$createReadonlyMethod("add"),
        set: $ceb1972acc1ecda9$var$createReadonlyMethod("set"),
        delete: $ceb1972acc1ecda9$var$createReadonlyMethod("delete"),
        clear: $ceb1972acc1ecda9$var$createReadonlyMethod("clear"),
        forEach: $ceb1972acc1ecda9$var$createForEach(true, false)
    };
    const shallowReadonlyInstrumentations2 = {
        get (key) {
            return $ceb1972acc1ecda9$var$get$1(this, key, true, true);
        },
        get size () {
            return $ceb1972acc1ecda9$var$size(this, true);
        },
        has (key) {
            return $ceb1972acc1ecda9$var$has$1.call(this, key, true);
        },
        add: $ceb1972acc1ecda9$var$createReadonlyMethod("add"),
        set: $ceb1972acc1ecda9$var$createReadonlyMethod("set"),
        delete: $ceb1972acc1ecda9$var$createReadonlyMethod("delete"),
        clear: $ceb1972acc1ecda9$var$createReadonlyMethod("clear"),
        forEach: $ceb1972acc1ecda9$var$createForEach(true, true)
    };
    const iteratorMethods = [
        "keys",
        "values",
        "entries",
        Symbol.iterator
    ];
    iteratorMethods.forEach((method)=>{
        mutableInstrumentations2[method] = $ceb1972acc1ecda9$var$createIterableMethod(method, false, false);
        readonlyInstrumentations2[method] = $ceb1972acc1ecda9$var$createIterableMethod(method, true, false);
        shallowInstrumentations2[method] = $ceb1972acc1ecda9$var$createIterableMethod(method, false, true);
        shallowReadonlyInstrumentations2[method] = $ceb1972acc1ecda9$var$createIterableMethod(method, true, true);
    });
    return [
        mutableInstrumentations2,
        readonlyInstrumentations2,
        shallowInstrumentations2,
        shallowReadonlyInstrumentations2
    ];
}
var [$ceb1972acc1ecda9$var$mutableInstrumentations, $ceb1972acc1ecda9$var$readonlyInstrumentations, $ceb1972acc1ecda9$var$shallowInstrumentations, $ceb1972acc1ecda9$var$shallowReadonlyInstrumentations] = /* @__PURE__ */ $ceb1972acc1ecda9$var$createInstrumentations();
function $ceb1972acc1ecda9$var$createInstrumentationGetter(isReadonly, shallow) {
    const instrumentations = shallow ? isReadonly ? $ceb1972acc1ecda9$var$shallowReadonlyInstrumentations : $ceb1972acc1ecda9$var$shallowInstrumentations : isReadonly ? $ceb1972acc1ecda9$var$readonlyInstrumentations : $ceb1972acc1ecda9$var$mutableInstrumentations;
    return (target, key, receiver)=>{
        if (key === "__v_isReactive") return !isReadonly;
        else if (key === "__v_isReadonly") return isReadonly;
        else if (key === "__v_raw") return target;
        return Reflect.get($ceb1972acc1ecda9$var$hasOwn(instrumentations, key) && key in target ? instrumentations : target, key, receiver);
    };
}
var $ceb1972acc1ecda9$var$mutableCollectionHandlers = {
    get: /* @__PURE__ */ $ceb1972acc1ecda9$var$createInstrumentationGetter(false, false)
};
var $ceb1972acc1ecda9$var$readonlyCollectionHandlers = {
    get: /* @__PURE__ */ $ceb1972acc1ecda9$var$createInstrumentationGetter(true, false)
};
function $ceb1972acc1ecda9$var$checkIdentityKeys(target, has2, key) {
    const rawKey = $ceb1972acc1ecda9$var$toRaw(key);
    if (rawKey !== key && has2.call(target, rawKey)) {
        const type = $ceb1972acc1ecda9$var$toRawType(target);
        console.warn(`Reactive ${type} contains both the raw and reactive versions of the same object${type === `Map` ? ` as keys` : ``}, which can lead to inconsistencies. Avoid differentiating between the raw and reactive versions of an object and only use the reactive version if possible.`);
    }
}
var $ceb1972acc1ecda9$var$reactiveMap = /* @__PURE__ */ new WeakMap();
var $ceb1972acc1ecda9$var$shallowReactiveMap = /* @__PURE__ */ new WeakMap();
var $ceb1972acc1ecda9$var$readonlyMap = /* @__PURE__ */ new WeakMap();
var $ceb1972acc1ecda9$var$shallowReadonlyMap = /* @__PURE__ */ new WeakMap();
function $ceb1972acc1ecda9$var$targetTypeMap(rawType) {
    switch(rawType){
        case "Object":
        case "Array":
            return 1;
        case "Map":
        case "Set":
        case "WeakMap":
        case "WeakSet":
            return 2;
        default:
            return 0;
    }
}
function $ceb1972acc1ecda9$var$getTargetType(value) {
    return value["__v_skip"] || !Object.isExtensible(value) ? 0 : $ceb1972acc1ecda9$var$targetTypeMap($ceb1972acc1ecda9$var$toRawType(value));
}
function $ceb1972acc1ecda9$var$reactive2(target) {
    if (target && target["__v_isReadonly"]) return target;
    return $ceb1972acc1ecda9$var$createReactiveObject(target, false, $ceb1972acc1ecda9$var$mutableHandlers, $ceb1972acc1ecda9$var$mutableCollectionHandlers, $ceb1972acc1ecda9$var$reactiveMap);
}
function $ceb1972acc1ecda9$var$readonly(target) {
    return $ceb1972acc1ecda9$var$createReactiveObject(target, true, $ceb1972acc1ecda9$var$readonlyHandlers, $ceb1972acc1ecda9$var$readonlyCollectionHandlers, $ceb1972acc1ecda9$var$readonlyMap);
}
function $ceb1972acc1ecda9$var$createReactiveObject(target, isReadonly, baseHandlers, collectionHandlers, proxyMap) {
    if (!$ceb1972acc1ecda9$var$isObject(target)) {
        console.warn(`value cannot be made reactive: ${String(target)}`);
        return target;
    }
    if (target["__v_raw"] && !(isReadonly && target["__v_isReactive"])) return target;
    const existingProxy = proxyMap.get(target);
    if (existingProxy) return existingProxy;
    const targetType = $ceb1972acc1ecda9$var$getTargetType(target);
    if (targetType === 0) return target;
    const proxy = new Proxy(target, targetType === 2 ? collectionHandlers : baseHandlers);
    proxyMap.set(target, proxy);
    return proxy;
}
function $ceb1972acc1ecda9$var$toRaw(observed) {
    return observed && $ceb1972acc1ecda9$var$toRaw(observed["__v_raw"]) || observed;
}
function $ceb1972acc1ecda9$var$isRef(r) {
    return Boolean(r && r.__v_isRef === true);
}
// packages/alpinejs/src/magics/$nextTick.js
$ceb1972acc1ecda9$var$magic("nextTick", ()=>$ceb1972acc1ecda9$var$nextTick);
// packages/alpinejs/src/magics/$dispatch.js
$ceb1972acc1ecda9$var$magic("dispatch", (el)=>$ceb1972acc1ecda9$var$dispatch.bind($ceb1972acc1ecda9$var$dispatch, el));
// packages/alpinejs/src/magics/$watch.js
$ceb1972acc1ecda9$var$magic("watch", (el, { evaluateLater: evaluateLater2, cleanup: cleanup2 })=>(key, callback)=>{
        let evaluate2 = evaluateLater2(key);
        let getter = ()=>{
            let value;
            evaluate2((i)=>value = i);
            return value;
        };
        let unwatch = $ceb1972acc1ecda9$var$watch(getter, callback);
        cleanup2(unwatch);
    });
// packages/alpinejs/src/magics/$store.js
$ceb1972acc1ecda9$var$magic("store", $ceb1972acc1ecda9$var$getStores);
// packages/alpinejs/src/magics/$data.js
$ceb1972acc1ecda9$var$magic("data", (el)=>$ceb1972acc1ecda9$var$scope(el));
// packages/alpinejs/src/magics/$root.js
$ceb1972acc1ecda9$var$magic("root", (el)=>$ceb1972acc1ecda9$var$closestRoot(el));
// packages/alpinejs/src/magics/$refs.js
$ceb1972acc1ecda9$var$magic("refs", (el)=>{
    if (el._x_refs_proxy) return el._x_refs_proxy;
    el._x_refs_proxy = $ceb1972acc1ecda9$var$mergeProxies($ceb1972acc1ecda9$var$getArrayOfRefObject(el));
    return el._x_refs_proxy;
});
function $ceb1972acc1ecda9$var$getArrayOfRefObject(el) {
    let refObjects = [];
    $ceb1972acc1ecda9$var$findClosest(el, (i)=>{
        if (i._x_refs) refObjects.push(i._x_refs);
    });
    return refObjects;
}
// packages/alpinejs/src/ids.js
var $ceb1972acc1ecda9$var$globalIdMemo = {};
function $ceb1972acc1ecda9$var$findAndIncrementId(name) {
    if (!$ceb1972acc1ecda9$var$globalIdMemo[name]) $ceb1972acc1ecda9$var$globalIdMemo[name] = 0;
    return ++$ceb1972acc1ecda9$var$globalIdMemo[name];
}
function $ceb1972acc1ecda9$var$closestIdRoot(el, name) {
    return $ceb1972acc1ecda9$var$findClosest(el, (element)=>{
        if (element._x_ids && element._x_ids[name]) return true;
    });
}
function $ceb1972acc1ecda9$var$setIdRoot(el, name) {
    if (!el._x_ids) el._x_ids = {};
    if (!el._x_ids[name]) el._x_ids[name] = $ceb1972acc1ecda9$var$findAndIncrementId(name);
}
// packages/alpinejs/src/magics/$id.js
$ceb1972acc1ecda9$var$magic("id", (el, { cleanup: cleanup2 })=>(name, key = null)=>{
        let cacheKey = `${name}${key ? `-${key}` : ""}`;
        return $ceb1972acc1ecda9$var$cacheIdByNameOnElement(el, cacheKey, cleanup2, ()=>{
            let root = $ceb1972acc1ecda9$var$closestIdRoot(el, name);
            let id = root ? root._x_ids[name] : $ceb1972acc1ecda9$var$findAndIncrementId(name);
            return key ? `${name}-${id}-${key}` : `${name}-${id}`;
        });
    });
$ceb1972acc1ecda9$var$interceptClone((from, to)=>{
    if (from._x_id) to._x_id = from._x_id;
});
function $ceb1972acc1ecda9$var$cacheIdByNameOnElement(el, cacheKey, cleanup2, callback) {
    if (!el._x_id) el._x_id = {};
    if (el._x_id[cacheKey]) return el._x_id[cacheKey];
    let output = callback();
    el._x_id[cacheKey] = output;
    cleanup2(()=>{
        delete el._x_id[cacheKey];
    });
    return output;
}
// packages/alpinejs/src/magics/$el.js
$ceb1972acc1ecda9$var$magic("el", (el)=>el);
// packages/alpinejs/src/magics/index.js
$ceb1972acc1ecda9$var$warnMissingPluginMagic("Focus", "focus", "focus");
$ceb1972acc1ecda9$var$warnMissingPluginMagic("Persist", "persist", "persist");
function $ceb1972acc1ecda9$var$warnMissingPluginMagic(name, magicName, slug) {
    $ceb1972acc1ecda9$var$magic(magicName, (el)=>$ceb1972acc1ecda9$var$warn(`You can't use [$${magicName}] without first installing the "${name}" plugin here: https://alpinejs.dev/plugins/${slug}`, el));
}
// packages/alpinejs/src/directives/x-modelable.js
$ceb1972acc1ecda9$var$directive("modelable", (el, { expression: expression }, { effect: effect3, evaluateLater: evaluateLater2, cleanup: cleanup2 })=>{
    let func = evaluateLater2(expression);
    let innerGet = ()=>{
        let result;
        func((i)=>result = i);
        return result;
    };
    let evaluateInnerSet = evaluateLater2(`${expression} = __placeholder`);
    let innerSet = (val)=>evaluateInnerSet(()=>{}, {
            scope: {
                "__placeholder": val
            }
        });
    let initialValue = innerGet();
    innerSet(initialValue);
    queueMicrotask(()=>{
        if (!el._x_model) return;
        el._x_removeModelListeners["default"]();
        let outerGet = el._x_model.get;
        let outerSet = el._x_model.set;
        let releaseEntanglement = $ceb1972acc1ecda9$var$entangle({
            get () {
                return outerGet();
            },
            set (value) {
                outerSet(value);
            }
        }, {
            get () {
                return innerGet();
            },
            set (value) {
                innerSet(value);
            }
        });
        cleanup2(releaseEntanglement);
    });
});
// packages/alpinejs/src/directives/x-teleport.js
$ceb1972acc1ecda9$var$directive("teleport", (el, { modifiers: modifiers, expression: expression }, { cleanup: cleanup2 })=>{
    if (el.tagName.toLowerCase() !== "template") $ceb1972acc1ecda9$var$warn("x-teleport can only be used on a <template> tag", el);
    let target = $ceb1972acc1ecda9$var$getTarget(expression);
    let clone2 = el.content.cloneNode(true).firstElementChild;
    el._x_teleport = clone2;
    clone2._x_teleportBack = el;
    el.setAttribute("data-teleport-template", true);
    clone2.setAttribute("data-teleport-target", true);
    if (el._x_forwardEvents) el._x_forwardEvents.forEach((eventName)=>{
        clone2.addEventListener(eventName, (e)=>{
            e.stopPropagation();
            el.dispatchEvent(new e.constructor(e.type, e));
        });
    });
    $ceb1972acc1ecda9$var$addScopeToNode(clone2, {}, el);
    let placeInDom = (clone3, target2, modifiers2)=>{
        if (modifiers2.includes("prepend")) target2.parentNode.insertBefore(clone3, target2);
        else if (modifiers2.includes("append")) target2.parentNode.insertBefore(clone3, target2.nextSibling);
        else target2.appendChild(clone3);
    };
    $ceb1972acc1ecda9$var$mutateDom(()=>{
        placeInDom(clone2, target, modifiers);
        $ceb1972acc1ecda9$var$skipDuringClone(()=>{
            $ceb1972acc1ecda9$var$initTree(clone2);
        })();
    });
    el._x_teleportPutBack = ()=>{
        let target2 = $ceb1972acc1ecda9$var$getTarget(expression);
        $ceb1972acc1ecda9$var$mutateDom(()=>{
            placeInDom(el._x_teleport, target2, modifiers);
        });
    };
    cleanup2(()=>$ceb1972acc1ecda9$var$mutateDom(()=>{
            clone2.remove();
            $ceb1972acc1ecda9$var$destroyTree(clone2);
        }));
});
var $ceb1972acc1ecda9$var$teleportContainerDuringClone = document.createElement("div");
function $ceb1972acc1ecda9$var$getTarget(expression) {
    let target = $ceb1972acc1ecda9$var$skipDuringClone(()=>{
        return document.querySelector(expression);
    }, ()=>{
        return $ceb1972acc1ecda9$var$teleportContainerDuringClone;
    })();
    if (!target) $ceb1972acc1ecda9$var$warn(`Cannot find x-teleport element for selector: "${expression}"`);
    return target;
}
// packages/alpinejs/src/directives/x-ignore.js
var $ceb1972acc1ecda9$var$handler = ()=>{};
$ceb1972acc1ecda9$var$handler.inline = (el, { modifiers: modifiers }, { cleanup: cleanup2 })=>{
    modifiers.includes("self") ? el._x_ignoreSelf = true : el._x_ignore = true;
    cleanup2(()=>{
        modifiers.includes("self") ? delete el._x_ignoreSelf : delete el._x_ignore;
    });
};
$ceb1972acc1ecda9$var$directive("ignore", $ceb1972acc1ecda9$var$handler);
// packages/alpinejs/src/directives/x-effect.js
$ceb1972acc1ecda9$var$directive("effect", $ceb1972acc1ecda9$var$skipDuringClone((el, { expression: expression }, { effect: effect3 })=>{
    effect3($ceb1972acc1ecda9$var$evaluateLater(el, expression));
}));
// packages/alpinejs/src/utils/on.js
function $ceb1972acc1ecda9$var$on(el, event, modifiers, callback) {
    let listenerTarget = el;
    let handler4 = (e)=>callback(e);
    let options = {};
    let wrapHandler = (callback2, wrapper)=>(e)=>wrapper(callback2, e);
    if (modifiers.includes("dot")) event = $ceb1972acc1ecda9$var$dotSyntax(event);
    if (modifiers.includes("camel")) event = $ceb1972acc1ecda9$var$camelCase2(event);
    if (modifiers.includes("passive")) options.passive = true;
    if (modifiers.includes("capture")) options.capture = true;
    if (modifiers.includes("window")) listenerTarget = window;
    if (modifiers.includes("document")) listenerTarget = document;
    if (modifiers.includes("debounce")) {
        let nextModifier = modifiers[modifiers.indexOf("debounce") + 1] || "invalid-wait";
        let wait = $ceb1972acc1ecda9$var$isNumeric(nextModifier.split("ms")[0]) ? Number(nextModifier.split("ms")[0]) : 250;
        handler4 = $ceb1972acc1ecda9$var$debounce(handler4, wait);
    }
    if (modifiers.includes("throttle")) {
        let nextModifier = modifiers[modifiers.indexOf("throttle") + 1] || "invalid-wait";
        let wait = $ceb1972acc1ecda9$var$isNumeric(nextModifier.split("ms")[0]) ? Number(nextModifier.split("ms")[0]) : 250;
        handler4 = $ceb1972acc1ecda9$var$throttle(handler4, wait);
    }
    if (modifiers.includes("prevent")) handler4 = wrapHandler(handler4, (next, e)=>{
        e.preventDefault();
        next(e);
    });
    if (modifiers.includes("stop")) handler4 = wrapHandler(handler4, (next, e)=>{
        e.stopPropagation();
        next(e);
    });
    if (modifiers.includes("once")) handler4 = wrapHandler(handler4, (next, e)=>{
        next(e);
        listenerTarget.removeEventListener(event, handler4, options);
    });
    if (modifiers.includes("away") || modifiers.includes("outside")) {
        listenerTarget = document;
        handler4 = wrapHandler(handler4, (next, e)=>{
            if (el.contains(e.target)) return;
            if (e.target.isConnected === false) return;
            if (el.offsetWidth < 1 && el.offsetHeight < 1) return;
            if (el._x_isShown === false) return;
            next(e);
        });
    }
    if (modifiers.includes("self")) handler4 = wrapHandler(handler4, (next, e)=>{
        e.target === el && next(e);
    });
    if (event === "submit") handler4 = wrapHandler(handler4, (next, e)=>{
        if (e.target._x_pendingModelUpdates) e.target._x_pendingModelUpdates.forEach((fn)=>fn());
        next(e);
    });
    if ($ceb1972acc1ecda9$var$isKeyEvent(event) || $ceb1972acc1ecda9$var$isClickEvent(event)) handler4 = wrapHandler(handler4, (next, e)=>{
        if ($ceb1972acc1ecda9$var$isListeningForASpecificKeyThatHasntBeenPressed(e, modifiers)) return;
        next(e);
    });
    listenerTarget.addEventListener(event, handler4, options);
    return ()=>{
        listenerTarget.removeEventListener(event, handler4, options);
    };
}
function $ceb1972acc1ecda9$var$dotSyntax(subject) {
    return subject.replace(/-/g, ".");
}
function $ceb1972acc1ecda9$var$camelCase2(subject) {
    return subject.toLowerCase().replace(/-(\w)/g, (match, char)=>char.toUpperCase());
}
function $ceb1972acc1ecda9$var$isNumeric(subject) {
    return !Array.isArray(subject) && !isNaN(subject);
}
function $ceb1972acc1ecda9$var$kebabCase2(subject) {
    if ([
        " ",
        "_"
    ].includes(subject)) return subject;
    return subject.replace(/([a-z])([A-Z])/g, "$1-$2").replace(/[_\s]/, "-").toLowerCase();
}
function $ceb1972acc1ecda9$var$isKeyEvent(event) {
    return [
        "keydown",
        "keyup"
    ].includes(event);
}
function $ceb1972acc1ecda9$var$isClickEvent(event) {
    return [
        "contextmenu",
        "click",
        "mouse"
    ].some((i)=>event.includes(i));
}
function $ceb1972acc1ecda9$var$isListeningForASpecificKeyThatHasntBeenPressed(e, modifiers) {
    let keyModifiers = modifiers.filter((i)=>{
        return ![
            "window",
            "document",
            "prevent",
            "stop",
            "once",
            "capture",
            "self",
            "away",
            "outside",
            "passive",
            "preserve-scroll",
            "blur",
            "change",
            "lazy"
        ].includes(i);
    });
    if (keyModifiers.includes("debounce")) {
        let debounceIndex = keyModifiers.indexOf("debounce");
        keyModifiers.splice(debounceIndex, $ceb1972acc1ecda9$var$isNumeric((keyModifiers[debounceIndex + 1] || "invalid-wait").split("ms")[0]) ? 2 : 1);
    }
    if (keyModifiers.includes("throttle")) {
        let debounceIndex = keyModifiers.indexOf("throttle");
        keyModifiers.splice(debounceIndex, $ceb1972acc1ecda9$var$isNumeric((keyModifiers[debounceIndex + 1] || "invalid-wait").split("ms")[0]) ? 2 : 1);
    }
    if (keyModifiers.length === 0) return false;
    if (keyModifiers.length === 1 && $ceb1972acc1ecda9$var$keyToModifiers(e.key).includes(keyModifiers[0])) return false;
    const systemKeyModifiers = [
        "ctrl",
        "shift",
        "alt",
        "meta",
        "cmd",
        "super"
    ];
    const selectedSystemKeyModifiers = systemKeyModifiers.filter((modifier)=>keyModifiers.includes(modifier));
    keyModifiers = keyModifiers.filter((i)=>!selectedSystemKeyModifiers.includes(i));
    if (selectedSystemKeyModifiers.length > 0) {
        const activelyPressedKeyModifiers = selectedSystemKeyModifiers.filter((modifier)=>{
            if (modifier === "cmd" || modifier === "super") modifier = "meta";
            return e[`${modifier}Key`];
        });
        if (activelyPressedKeyModifiers.length === selectedSystemKeyModifiers.length) {
            if ($ceb1972acc1ecda9$var$isClickEvent(e.type)) return false;
            if ($ceb1972acc1ecda9$var$keyToModifiers(e.key).includes(keyModifiers[0])) return false;
        }
    }
    return true;
}
function $ceb1972acc1ecda9$var$keyToModifiers(key) {
    if (!key) return [];
    key = $ceb1972acc1ecda9$var$kebabCase2(key);
    let modifierToKeyMap = {
        "ctrl": "control",
        "slash": "/",
        "space": " ",
        "spacebar": " ",
        "cmd": "meta",
        "esc": "escape",
        "up": "arrow-up",
        "down": "arrow-down",
        "left": "arrow-left",
        "right": "arrow-right",
        "period": ".",
        "comma": ",",
        "equal": "=",
        "minus": "-",
        "underscore": "_"
    };
    modifierToKeyMap[key] = key;
    return Object.keys(modifierToKeyMap).map((modifier)=>{
        if (modifierToKeyMap[modifier] === key) return modifier;
    }).filter((modifier)=>modifier);
}
// packages/alpinejs/src/directives/x-model.js
$ceb1972acc1ecda9$var$directive("model", (el, { modifiers: modifiers, expression: expression }, { effect: effect3, cleanup: cleanup2 })=>{
    let scopeTarget = el;
    if (modifiers.includes("parent")) scopeTarget = el.parentNode;
    let evaluateGet = $ceb1972acc1ecda9$var$evaluateLater(scopeTarget, expression);
    let evaluateSet;
    if (typeof expression === "string") evaluateSet = $ceb1972acc1ecda9$var$evaluateLater(scopeTarget, `${expression} = __placeholder`);
    else if (typeof expression === "function" && typeof expression() === "string") evaluateSet = $ceb1972acc1ecda9$var$evaluateLater(scopeTarget, `${expression()} = __placeholder`);
    else evaluateSet = ()=>{};
    let getValue = ()=>{
        let result;
        evaluateGet((value)=>result = value);
        return $ceb1972acc1ecda9$var$isGetterSetter(result) ? result.get() : result;
    };
    let setValue = (value)=>{
        let result;
        evaluateGet((value2)=>result = value2);
        if ($ceb1972acc1ecda9$var$isGetterSetter(result)) result.set(value);
        else evaluateSet(()=>{}, {
            scope: {
                "__placeholder": value
            }
        });
    };
    if (typeof expression === "string" && el.type === "radio") $ceb1972acc1ecda9$var$mutateDom(()=>{
        if (!el.hasAttribute("name")) el.setAttribute("name", expression);
    });
    let hasChangeModifier = modifiers.includes("change") || modifiers.includes("lazy");
    let hasBlurModifier = modifiers.includes("blur");
    let hasEnterModifier = modifiers.includes("enter");
    let hasExplicitEventModifiers = hasChangeModifier || hasBlurModifier || hasEnterModifier;
    let removeListener;
    if ($ceb1972acc1ecda9$var$isCloning) removeListener = ()=>{};
    else if (hasExplicitEventModifiers) {
        let listeners = [];
        let syncValue = (e)=>setValue($ceb1972acc1ecda9$var$getInputValue(el, modifiers, e, getValue()));
        if (hasChangeModifier) listeners.push($ceb1972acc1ecda9$var$on(el, "change", modifiers, syncValue));
        if (hasBlurModifier) {
            listeners.push($ceb1972acc1ecda9$var$on(el, "blur", modifiers, syncValue));
            if (el.form) {
                let syncCallback = ()=>syncValue({
                        target: el
                    });
                if (!el.form._x_pendingModelUpdates) el.form._x_pendingModelUpdates = [];
                el.form._x_pendingModelUpdates.push(syncCallback);
                cleanup2(()=>el.form._x_pendingModelUpdates.splice(el.form._x_pendingModelUpdates.indexOf(syncCallback), 1));
            }
        }
        if (hasEnterModifier) listeners.push($ceb1972acc1ecda9$var$on(el, "keydown", modifiers, (e)=>{
            if (e.key === "Enter") syncValue(e);
        }));
        removeListener = ()=>listeners.forEach((remove)=>remove());
    } else {
        let event = el.tagName.toLowerCase() === "select" || [
            "checkbox",
            "radio"
        ].includes(el.type) ? "change" : "input";
        removeListener = $ceb1972acc1ecda9$var$on(el, event, modifiers, (e)=>{
            setValue($ceb1972acc1ecda9$var$getInputValue(el, modifiers, e, getValue()));
        });
    }
    if (modifiers.includes("fill")) {
        if ([
            void 0,
            null,
            ""
        ].includes(getValue()) || $ceb1972acc1ecda9$var$isCheckbox(el) && Array.isArray(getValue()) || el.tagName.toLowerCase() === "select" && el.multiple) setValue($ceb1972acc1ecda9$var$getInputValue(el, modifiers, {
            target: el
        }, getValue()));
    }
    if (!el._x_removeModelListeners) el._x_removeModelListeners = {};
    el._x_removeModelListeners["default"] = removeListener;
    cleanup2(()=>el._x_removeModelListeners["default"]());
    if (el.form) {
        let removeResetListener = $ceb1972acc1ecda9$var$on(el.form, "reset", [], (e)=>{
            $ceb1972acc1ecda9$var$nextTick(()=>el._x_model && el._x_model.set($ceb1972acc1ecda9$var$getInputValue(el, modifiers, {
                    target: el
                }, getValue())));
        });
        cleanup2(()=>removeResetListener());
    }
    el._x_model = {
        get () {
            return getValue();
        },
        set (value) {
            setValue(value);
        }
    };
    el._x_forceModelUpdate = (value)=>{
        if (value === void 0 && typeof expression === "string" && expression.match(/\./)) value = "";
        window.fromModel = true;
        $ceb1972acc1ecda9$var$mutateDom(()=>$ceb1972acc1ecda9$var$bind(el, "value", value));
        delete window.fromModel;
    };
    effect3(()=>{
        let value = getValue();
        if (modifiers.includes("unintrusive") && document.activeElement.isSameNode(el)) return;
        el._x_forceModelUpdate(value);
    });
});
function $ceb1972acc1ecda9$var$getInputValue(el, modifiers, event, currentValue) {
    return $ceb1972acc1ecda9$var$mutateDom(()=>{
        if (event instanceof CustomEvent && event.detail !== void 0) return event.detail !== null && event.detail !== void 0 ? event.detail : event.target.value;
        else if ($ceb1972acc1ecda9$var$isCheckbox(el)) {
            if (Array.isArray(currentValue)) {
                let newValue = null;
                if (modifiers.includes("number")) newValue = $ceb1972acc1ecda9$var$safeParseNumber(event.target.value);
                else if (modifiers.includes("boolean")) newValue = $ceb1972acc1ecda9$var$safeParseBoolean(event.target.value);
                else newValue = event.target.value;
                return event.target.checked ? currentValue.includes(newValue) ? currentValue : currentValue.concat([
                    newValue
                ]) : currentValue.filter((el2)=>!$ceb1972acc1ecda9$var$checkedAttrLooseCompare2(el2, newValue));
            } else return event.target.checked;
        } else if (el.tagName.toLowerCase() === "select" && el.multiple) {
            if (modifiers.includes("number")) return Array.from(event.target.selectedOptions).map((option)=>{
                let rawValue = option.value || option.text;
                return $ceb1972acc1ecda9$var$safeParseNumber(rawValue);
            });
            else if (modifiers.includes("boolean")) return Array.from(event.target.selectedOptions).map((option)=>{
                let rawValue = option.value || option.text;
                return $ceb1972acc1ecda9$var$safeParseBoolean(rawValue);
            });
            return Array.from(event.target.selectedOptions).map((option)=>{
                return option.value || option.text;
            });
        } else {
            let newValue;
            if ($ceb1972acc1ecda9$var$isRadio(el)) {
                if (event.target.checked) newValue = event.target.value;
                else newValue = currentValue;
            } else newValue = event.target.value;
            if (modifiers.includes("number")) return $ceb1972acc1ecda9$var$safeParseNumber(newValue);
            else if (modifiers.includes("boolean")) return $ceb1972acc1ecda9$var$safeParseBoolean(newValue);
            else if (modifiers.includes("trim")) return newValue.trim();
            else return newValue;
        }
    });
}
function $ceb1972acc1ecda9$var$safeParseNumber(rawValue) {
    let number = rawValue ? parseFloat(rawValue) : null;
    return $ceb1972acc1ecda9$var$isNumeric2(number) ? number : rawValue;
}
function $ceb1972acc1ecda9$var$checkedAttrLooseCompare2(valueA, valueB) {
    return valueA == valueB;
}
function $ceb1972acc1ecda9$var$isNumeric2(subject) {
    return !Array.isArray(subject) && !isNaN(subject);
}
function $ceb1972acc1ecda9$var$isGetterSetter(value) {
    return value !== null && typeof value === "object" && typeof value.get === "function" && typeof value.set === "function";
}
// packages/alpinejs/src/directives/x-cloak.js
$ceb1972acc1ecda9$var$directive("cloak", (el)=>queueMicrotask(()=>$ceb1972acc1ecda9$var$mutateDom(()=>el.removeAttribute($ceb1972acc1ecda9$var$prefix("cloak")))));
// packages/alpinejs/src/directives/x-init.js
$ceb1972acc1ecda9$var$addInitSelector(()=>`[${$ceb1972acc1ecda9$var$prefix("init")}]`);
$ceb1972acc1ecda9$var$directive("init", $ceb1972acc1ecda9$var$skipDuringClone((el, { expression: expression }, { evaluate: evaluate2 })=>{
    if (typeof expression === "string") return !!expression.trim() && evaluate2(expression, {}, false);
    return evaluate2(expression, {}, false);
}));
// packages/alpinejs/src/directives/x-text.js
$ceb1972acc1ecda9$var$directive("text", (el, { expression: expression }, { effect: effect3, evaluateLater: evaluateLater2 })=>{
    let evaluate2 = evaluateLater2(expression);
    effect3(()=>{
        evaluate2((value)=>{
            $ceb1972acc1ecda9$var$mutateDom(()=>{
                el.textContent = value;
            });
        });
    });
});
// packages/alpinejs/src/directives/x-html.js
$ceb1972acc1ecda9$var$directive("html", (el, { expression: expression }, { effect: effect3, evaluateLater: evaluateLater2 })=>{
    let evaluate2 = evaluateLater2(expression);
    effect3(()=>{
        evaluate2((value)=>{
            $ceb1972acc1ecda9$var$mutateDom(()=>{
                el.innerHTML = value;
                el._x_ignoreSelf = true;
                $ceb1972acc1ecda9$var$initTree(el);
                delete el._x_ignoreSelf;
            });
        });
    });
});
// packages/alpinejs/src/directives/x-bind.js
$ceb1972acc1ecda9$var$mapAttributes($ceb1972acc1ecda9$var$startingWith(":", $ceb1972acc1ecda9$var$into($ceb1972acc1ecda9$var$prefix("bind:"))));
var $ceb1972acc1ecda9$var$handler2 = (el, { value: value, modifiers: modifiers, expression: expression, original: original }, { effect: effect3, cleanup: cleanup2 })=>{
    if (!value) {
        let bindingProviders = {};
        $ceb1972acc1ecda9$var$injectBindingProviders(bindingProviders);
        let getBindings = $ceb1972acc1ecda9$var$evaluateLater(el, expression);
        getBindings((bindings)=>{
            $ceb1972acc1ecda9$var$applyBindingsObject(el, bindings, original);
        }, {
            scope: bindingProviders
        });
        return;
    }
    if (value === "key") return $ceb1972acc1ecda9$var$storeKeyForXFor(el, expression);
    if (el._x_inlineBindings && el._x_inlineBindings[value] && el._x_inlineBindings[value].extract) return;
    let evaluate2 = $ceb1972acc1ecda9$var$evaluateLater(el, expression);
    effect3(()=>evaluate2((result)=>{
            if (result === void 0 && typeof expression === "string" && expression.match(/\./)) result = "";
            $ceb1972acc1ecda9$var$mutateDom(()=>$ceb1972acc1ecda9$var$bind(el, value, result, modifiers));
        }));
    cleanup2(()=>{
        el._x_undoAddedClasses && el._x_undoAddedClasses();
        el._x_undoAddedStyles && el._x_undoAddedStyles();
    });
};
$ceb1972acc1ecda9$var$handler2.inline = (el, { value: value, modifiers: modifiers, expression: expression })=>{
    if (!value) return;
    if (!el._x_inlineBindings) el._x_inlineBindings = {};
    el._x_inlineBindings[value] = {
        expression: expression,
        extract: false
    };
};
$ceb1972acc1ecda9$var$directive("bind", $ceb1972acc1ecda9$var$handler2);
function $ceb1972acc1ecda9$var$storeKeyForXFor(el, expression) {
    el._x_keyExpression = expression;
}
// packages/alpinejs/src/directives/x-data.js
$ceb1972acc1ecda9$var$addRootSelector(()=>`[${$ceb1972acc1ecda9$var$prefix("data")}]`);
$ceb1972acc1ecda9$var$directive("data", (el, { expression: expression }, { cleanup: cleanup2 })=>{
    if ($ceb1972acc1ecda9$var$shouldSkipRegisteringDataDuringClone(el)) return;
    expression = expression === "" ? "{}" : expression;
    let magicContext = {};
    $ceb1972acc1ecda9$var$injectMagics(magicContext, el);
    let dataProviderContext = {};
    $ceb1972acc1ecda9$var$injectDataProviders(dataProviderContext, magicContext);
    let data2 = $ceb1972acc1ecda9$var$evaluate(el, expression, {
        scope: dataProviderContext
    });
    if (data2 === void 0 || data2 === true) data2 = {};
    $ceb1972acc1ecda9$var$injectMagics(data2, el);
    let reactiveData = $ceb1972acc1ecda9$var$reactive(data2);
    $ceb1972acc1ecda9$var$initInterceptors(reactiveData);
    let undo = $ceb1972acc1ecda9$var$addScopeToNode(el, reactiveData);
    reactiveData["init"] && $ceb1972acc1ecda9$var$evaluate(el, reactiveData["init"]);
    cleanup2(()=>{
        reactiveData["destroy"] && $ceb1972acc1ecda9$var$evaluate(el, reactiveData["destroy"]);
        undo();
    });
});
$ceb1972acc1ecda9$var$interceptClone((from, to)=>{
    if (from._x_dataStack) {
        to._x_dataStack = from._x_dataStack;
        to.setAttribute("data-has-alpine-state", true);
    }
});
function $ceb1972acc1ecda9$var$shouldSkipRegisteringDataDuringClone(el) {
    if (!$ceb1972acc1ecda9$var$isCloning) return false;
    if ($ceb1972acc1ecda9$var$isCloningLegacy) return true;
    return el.hasAttribute("data-has-alpine-state");
}
// packages/alpinejs/src/directives/x-show.js
$ceb1972acc1ecda9$var$directive("show", (el, { modifiers: modifiers, expression: expression }, { effect: effect3 })=>{
    let evaluate2 = $ceb1972acc1ecda9$var$evaluateLater(el, expression);
    if (!el._x_doHide) el._x_doHide = ()=>{
        $ceb1972acc1ecda9$var$mutateDom(()=>{
            el.style.setProperty("display", "none", modifiers.includes("important") ? "important" : void 0);
        });
    };
    if (!el._x_doShow) el._x_doShow = ()=>{
        $ceb1972acc1ecda9$var$mutateDom(()=>{
            if (el.style.length === 1 && el.style.display === "none") el.removeAttribute("style");
            else el.style.removeProperty("display");
        });
    };
    let hide = ()=>{
        el._x_doHide();
        el._x_isShown = false;
    };
    let show = ()=>{
        el._x_doShow();
        el._x_isShown = true;
    };
    let clickAwayCompatibleShow = ()=>setTimeout(show);
    let toggle = $ceb1972acc1ecda9$var$once((value)=>value ? show() : hide(), (value)=>{
        if (typeof el._x_toggleAndCascadeWithTransitions === "function") el._x_toggleAndCascadeWithTransitions(el, value, show, hide);
        else value ? clickAwayCompatibleShow() : hide();
    });
    let oldValue;
    let firstTime = true;
    effect3(()=>evaluate2((value)=>{
            if (!firstTime && value === oldValue) return;
            if (modifiers.includes("immediate")) value ? clickAwayCompatibleShow() : hide();
            toggle(value);
            oldValue = value;
            firstTime = false;
        }));
});
// packages/alpinejs/src/directives/x-for.js
$ceb1972acc1ecda9$var$directive("for", (el, { expression: expression }, { effect: effect3, cleanup: cleanup2 })=>{
    let iteratorNames = $ceb1972acc1ecda9$var$parseForExpression(expression);
    let evaluateItems = $ceb1972acc1ecda9$var$evaluateLater(el, iteratorNames.items);
    let evaluateKey = $ceb1972acc1ecda9$var$evaluateLater(el, // the x-bind:key expression is stored for our use instead of evaluated.
    el._x_keyExpression || "index");
    el._x_prevKeys = [];
    el._x_lookup = {};
    effect3(()=>$ceb1972acc1ecda9$var$loop(el, iteratorNames, evaluateItems, evaluateKey));
    cleanup2(()=>{
        Object.values(el._x_lookup).forEach((el2)=>$ceb1972acc1ecda9$var$mutateDom(()=>{
                $ceb1972acc1ecda9$var$destroyTree(el2);
                el2.remove();
            }));
        delete el._x_prevKeys;
        delete el._x_lookup;
    });
});
function $ceb1972acc1ecda9$var$loop(el, iteratorNames, evaluateItems, evaluateKey) {
    let isObject2 = (i)=>typeof i === "object" && !Array.isArray(i);
    let templateEl = el;
    evaluateItems((items)=>{
        if ($ceb1972acc1ecda9$var$isNumeric3(items) && items >= 0) items = Array.from(Array(items).keys(), (i)=>i + 1);
        if (items === void 0) items = [];
        let lookup = el._x_lookup;
        let prevKeys = el._x_prevKeys;
        let scopes = [];
        let keys = [];
        if (isObject2(items)) items = Object.entries(items).map(([key, value])=>{
            let scope2 = $ceb1972acc1ecda9$var$getIterationScopeVariables(iteratorNames, value, key, items);
            evaluateKey((value2)=>{
                if (keys.includes(value2)) $ceb1972acc1ecda9$var$warn("Duplicate key on x-for", el);
                keys.push(value2);
            }, {
                scope: {
                    index: key,
                    ...scope2
                }
            });
            scopes.push(scope2);
        });
        else for(let i = 0; i < items.length; i++){
            let scope2 = $ceb1972acc1ecda9$var$getIterationScopeVariables(iteratorNames, items[i], i, items);
            evaluateKey((value)=>{
                if (keys.includes(value)) $ceb1972acc1ecda9$var$warn("Duplicate key on x-for", el);
                keys.push(value);
            }, {
                scope: {
                    index: i,
                    ...scope2
                }
            });
            scopes.push(scope2);
        }
        let adds = [];
        let moves = [];
        let removes = [];
        let sames = [];
        for(let i = 0; i < prevKeys.length; i++){
            let key = prevKeys[i];
            if (keys.indexOf(key) === -1) removes.push(key);
        }
        prevKeys = prevKeys.filter((key)=>!removes.includes(key));
        let lastKey = "template";
        for(let i = 0; i < keys.length; i++){
            let key = keys[i];
            let prevIndex = prevKeys.indexOf(key);
            if (prevIndex === -1) {
                prevKeys.splice(i, 0, key);
                adds.push([
                    lastKey,
                    i
                ]);
            } else if (prevIndex !== i) {
                let keyInSpot = prevKeys.splice(i, 1)[0];
                let keyForSpot = prevKeys.splice(prevIndex - 1, 1)[0];
                prevKeys.splice(i, 0, keyForSpot);
                prevKeys.splice(prevIndex, 0, keyInSpot);
                moves.push([
                    keyInSpot,
                    keyForSpot
                ]);
            } else sames.push(key);
            lastKey = key;
        }
        for(let i = 0; i < removes.length; i++){
            let key = removes[i];
            if (!(key in lookup)) continue;
            $ceb1972acc1ecda9$var$mutateDom(()=>{
                $ceb1972acc1ecda9$var$destroyTree(lookup[key]);
                lookup[key].remove();
            });
            delete lookup[key];
        }
        for(let i = 0; i < moves.length; i++){
            let [keyInSpot, keyForSpot] = moves[i];
            let elInSpot = lookup[keyInSpot];
            let elForSpot = lookup[keyForSpot];
            let marker = document.createElement("div");
            $ceb1972acc1ecda9$var$mutateDom(()=>{
                if (!elForSpot) $ceb1972acc1ecda9$var$warn(`x-for ":key" is undefined or invalid`, templateEl, keyForSpot, lookup);
                elForSpot.after(marker);
                elInSpot.after(elForSpot);
                elForSpot._x_currentIfEl && elForSpot.after(elForSpot._x_currentIfEl);
                marker.before(elInSpot);
                elInSpot._x_currentIfEl && elInSpot.after(elInSpot._x_currentIfEl);
                marker.remove();
            });
            elForSpot._x_refreshXForScope(scopes[keys.indexOf(keyForSpot)]);
        }
        for(let i = 0; i < adds.length; i++){
            let [lastKey2, index] = adds[i];
            let lastEl = lastKey2 === "template" ? templateEl : lookup[lastKey2];
            if (lastEl._x_currentIfEl) lastEl = lastEl._x_currentIfEl;
            let scope2 = scopes[index];
            let key = keys[index];
            let clone2 = document.importNode(templateEl.content, true).firstElementChild;
            let reactiveScope = $ceb1972acc1ecda9$var$reactive(scope2);
            $ceb1972acc1ecda9$var$addScopeToNode(clone2, reactiveScope, templateEl);
            clone2._x_refreshXForScope = (newScope)=>{
                Object.entries(newScope).forEach(([key2, value])=>{
                    reactiveScope[key2] = value;
                });
            };
            $ceb1972acc1ecda9$var$mutateDom(()=>{
                lastEl.after(clone2);
                $ceb1972acc1ecda9$var$skipDuringClone(()=>$ceb1972acc1ecda9$var$initTree(clone2))();
            });
            if (typeof key === "object") $ceb1972acc1ecda9$var$warn("x-for key cannot be an object, it must be a string or an integer", templateEl);
            lookup[key] = clone2;
        }
        for(let i = 0; i < sames.length; i++)lookup[sames[i]]._x_refreshXForScope(scopes[keys.indexOf(sames[i])]);
        templateEl._x_prevKeys = keys;
    });
}
function $ceb1972acc1ecda9$var$parseForExpression(expression) {
    let forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
    let stripParensRE = /^\s*\(|\)\s*$/g;
    let forAliasRE = /([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/;
    let inMatch = expression.match(forAliasRE);
    if (!inMatch) return;
    let res = {};
    res.items = inMatch[2].trim();
    let item = inMatch[1].replace(stripParensRE, "").trim();
    let iteratorMatch = item.match(forIteratorRE);
    if (iteratorMatch) {
        res.item = item.replace(forIteratorRE, "").trim();
        res.index = iteratorMatch[1].trim();
        if (iteratorMatch[2]) res.collection = iteratorMatch[2].trim();
    } else res.item = item;
    return res;
}
function $ceb1972acc1ecda9$var$getIterationScopeVariables(iteratorNames, item, index, items) {
    let scopeVariables = {};
    if (/^\[.*\]$/.test(iteratorNames.item) && Array.isArray(item)) {
        let names = iteratorNames.item.replace("[", "").replace("]", "").split(",").map((i)=>i.trim());
        names.forEach((name, i)=>{
            scopeVariables[name] = item[i];
        });
    } else if (/^\{.*\}$/.test(iteratorNames.item) && !Array.isArray(item) && typeof item === "object") {
        let names = iteratorNames.item.replace("{", "").replace("}", "").split(",").map((i)=>i.trim());
        names.forEach((name)=>{
            scopeVariables[name] = item[name];
        });
    } else scopeVariables[iteratorNames.item] = item;
    if (iteratorNames.index) scopeVariables[iteratorNames.index] = index;
    if (iteratorNames.collection) scopeVariables[iteratorNames.collection] = items;
    return scopeVariables;
}
function $ceb1972acc1ecda9$var$isNumeric3(subject) {
    return !Array.isArray(subject) && !isNaN(subject);
}
// packages/alpinejs/src/directives/x-ref.js
function $ceb1972acc1ecda9$var$handler3() {}
$ceb1972acc1ecda9$var$handler3.inline = (el, { expression: expression }, { cleanup: cleanup2 })=>{
    let root = $ceb1972acc1ecda9$var$closestRoot(el);
    if (!root._x_refs) root._x_refs = {};
    root._x_refs[expression] = el;
    cleanup2(()=>delete root._x_refs[expression]);
};
$ceb1972acc1ecda9$var$directive("ref", $ceb1972acc1ecda9$var$handler3);
// packages/alpinejs/src/directives/x-if.js
$ceb1972acc1ecda9$var$directive("if", (el, { expression: expression }, { effect: effect3, cleanup: cleanup2 })=>{
    if (el.tagName.toLowerCase() !== "template") $ceb1972acc1ecda9$var$warn("x-if can only be used on a <template> tag", el);
    let evaluate2 = $ceb1972acc1ecda9$var$evaluateLater(el, expression);
    let show = ()=>{
        if (el._x_currentIfEl) return el._x_currentIfEl;
        let clone2 = el.content.cloneNode(true).firstElementChild;
        $ceb1972acc1ecda9$var$addScopeToNode(clone2, {}, el);
        $ceb1972acc1ecda9$var$mutateDom(()=>{
            el.after(clone2);
            $ceb1972acc1ecda9$var$skipDuringClone(()=>$ceb1972acc1ecda9$var$initTree(clone2))();
        });
        el._x_currentIfEl = clone2;
        el._x_undoIf = ()=>{
            $ceb1972acc1ecda9$var$mutateDom(()=>{
                $ceb1972acc1ecda9$var$destroyTree(clone2);
                clone2.remove();
            });
            delete el._x_currentIfEl;
        };
        return clone2;
    };
    let hide = ()=>{
        if (!el._x_undoIf) return;
        el._x_undoIf();
        delete el._x_undoIf;
    };
    effect3(()=>evaluate2((value)=>{
            value ? show() : hide();
        }));
    cleanup2(()=>el._x_undoIf && el._x_undoIf());
});
// packages/alpinejs/src/directives/x-id.js
$ceb1972acc1ecda9$var$directive("id", (el, { expression: expression }, { evaluate: evaluate2 })=>{
    let names = evaluate2(expression);
    names.forEach((name)=>$ceb1972acc1ecda9$var$setIdRoot(el, name));
});
$ceb1972acc1ecda9$var$interceptClone((from, to)=>{
    if (from._x_ids) to._x_ids = from._x_ids;
});
// packages/alpinejs/src/directives/x-on.js
$ceb1972acc1ecda9$var$mapAttributes($ceb1972acc1ecda9$var$startingWith("@", $ceb1972acc1ecda9$var$into($ceb1972acc1ecda9$var$prefix("on:"))));
$ceb1972acc1ecda9$var$directive("on", $ceb1972acc1ecda9$var$skipDuringClone((el, { value: value, modifiers: modifiers, expression: expression }, { cleanup: cleanup2 })=>{
    let evaluate2 = expression ? $ceb1972acc1ecda9$var$evaluateLater(el, expression) : ()=>{};
    if (el.tagName.toLowerCase() === "template") {
        if (!el._x_forwardEvents) el._x_forwardEvents = [];
        if (!el._x_forwardEvents.includes(value)) el._x_forwardEvents.push(value);
    }
    let removeListener = $ceb1972acc1ecda9$var$on(el, value, modifiers, (e)=>{
        evaluate2(()=>{}, {
            scope: {
                "$event": e
            },
            params: [
                e
            ]
        });
    });
    cleanup2(()=>removeListener());
}));
// packages/alpinejs/src/directives/index.js
$ceb1972acc1ecda9$var$warnMissingPluginDirective("Collapse", "collapse", "collapse");
$ceb1972acc1ecda9$var$warnMissingPluginDirective("Intersect", "intersect", "intersect");
$ceb1972acc1ecda9$var$warnMissingPluginDirective("Focus", "trap", "focus");
$ceb1972acc1ecda9$var$warnMissingPluginDirective("Mask", "mask", "mask");
function $ceb1972acc1ecda9$var$warnMissingPluginDirective(name, directiveName, slug) {
    $ceb1972acc1ecda9$var$directive(directiveName, (el)=>$ceb1972acc1ecda9$var$warn(`You can't use [x-${directiveName}] without first installing the "${name}" plugin here: https://alpinejs.dev/plugins/${slug}`, el));
}
// packages/alpinejs/src/index.js
$ceb1972acc1ecda9$var$alpine_default.setEvaluator($ceb1972acc1ecda9$var$normalEvaluator);
$ceb1972acc1ecda9$var$alpine_default.setRawEvaluator($ceb1972acc1ecda9$var$normalRawEvaluator);
$ceb1972acc1ecda9$var$alpine_default.setReactivityEngine({
    reactive: $ceb1972acc1ecda9$var$reactive2,
    effect: $ceb1972acc1ecda9$var$effect2,
    release: $ceb1972acc1ecda9$var$stop,
    raw: $ceb1972acc1ecda9$var$toRaw
});
var $ceb1972acc1ecda9$export$b7ee041e4ad2afec = $ceb1972acc1ecda9$var$alpine_default;
// packages/alpinejs/builds/module.js
var $ceb1972acc1ecda9$export$2e2bcd8739ae039 = $ceb1972acc1ecda9$export$b7ee041e4ad2afec;


// NOTE: Main function is needed because top-level await is not supported by Parcel
async function $e73bf42412feb220$var$main() {
    console.log('Initialize wasm');
    // await Automerge.initializeWasm("https://esm.sh/@automerge/automerge@3.2.4/dist/automerge.wasm");
    await $20f61774070fc636$export$f3ec8fcd2e9cfe3c("/automerge_wasm_bg.4f23e050.wasm");
    console.log('Create Repo');
    const repo = new $3ae07bf46c75a7ba$export$bb6a5047eb26f32d({
        network: [
            new (0, $0afb33f1ad125bfd$export$d29687ed0c139dcf)("wss://sync.automerge.org")
        ],
        storage: new (0, $f62083d56bd93169$export$5e35002d9f13957e)()
    });
    /* Check the location hash for a Automerge document URL */ console.log('Check location hash for Automerge document URL');
    const rootDocUrl = `${document.location.hash.substring(1)}`;
    let handle;
    if ($73665c112ce7e927$export$3d350e89349f36dd(rootDocUrl)) {
        console.log('Automerge document found');
        handle = await repo.find(rootDocUrl);
    } else {
        console.log('Create new document');
        handle = repo.create({
            count: 0
        });
        document.location.hash = handle.url;
    }
    console.log('Initialize Alpine data');
    (0, $ceb1972acc1ecda9$export$2e2bcd8739ae039).data('counter', ()=>{
        return {
            count: 0,
            doc: handle.doc(),
            async init () {
                this.count = this.doc.count;
                this.$watch('count', (value)=>{
                    handle.change((d)=>d.count = value);
                });
            }
        };
    });
    window.Alpine = (0, $ceb1972acc1ecda9$export$2e2bcd8739ae039);
    (0, $ceb1972acc1ecda9$export$2e2bcd8739ae039).start();
}
$e73bf42412feb220$var$main();


//# sourceMappingURL=woodpecker.02037ac9.js.map
